(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("morningstar"), require("d3"), require("moment"), require("handlebars/runtime"));
	else if(typeof define === 'function' && define.amd)
		define("markets-components-svgchart", ["morningstar", "d3", "moment", "handlebars.runtime"], factory);
	else if(typeof exports === 'object')
		exports["markets-components-svgchart"] = factory(require("morningstar"), require("d3"), require("moment"), require("handlebars/runtime"));
	else
		root["markets-components-svgchart"] = factory(root["morningstar"], root["d3"], root["moment"], root["Handlebars"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_19__, __WEBPACK_EXTERNAL_MODULE_24__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(morningstar) {
	    'use strict';
	    var QSAPI = morningstar.components["markets-components-core"];
	    return QSAPI.components.register('svgchart', __webpack_require__(2));
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(5), __webpack_require__(55)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, chartComponent, config) {
	    "use strict";
	    var $ = core.$;
	    var clone = core.Util.clone;
	
	    function parseSettings(allSettings) {
	        if (!allSettings) {
	            return;
	        }
	        var storeSettings = allSettings.storeSettings;
	        if ($.isArray(storeSettings)) {
	            storeSettings = storeSettings.join("");
	        }
	        if (typeof(storeSettings) === "string") {
	            storeSettings = storeSettings.replace(/\r/g, "");
	            storeSettings = storeSettings.replace(/\n/g, "");
	            try {
	                storeSettings = JSON.parse(storeSettings);
	            } catch (e) {
	                storeSettings = null;
	            }
	        }
	        return storeSettings;
	    }
	
	    function init(container, component, actionHandler) {
	        var configuration = component.configuration || {};
	        if (configuration.investment) {
	            configuration.mainTicker = configuration.investment;
	        }
	        configuration.container = container;
	        configuration.actionHandler = actionHandler;
	        $.extend(configuration, component.callbacks);
	        $.extend(configuration, {
	            callbacks: component.callbacks
	        });
	        var instance = chartComponent();
	        instance.isInited = false;
	        // Used to control the init step, we can rebuild configuration before component init.
	        // will be used in the API component
	        if (!configuration.skipInit) {
	            this.isInited = true;
	            instance.init(configuration);
	        }
	        instance.setInvestment = function(investment) {
	            instance.changeMainTicker(clone(investment));
	        };
	        // only for DWM to restore settings
	        instance.setSettings = function(value) {
	            if (!this.isInited) {
	                // DWM store setting is string array and 250 length restriction. So we restrore with join.
	                var savedConfig = parseSettings(value);
	                this.isInited = true;
	                configuration.savedConfig = savedConfig;
	                instance.init(configuration);
	            }
	        };
	        return instance;
	    }
	
	    return {
	        init: init,
	        properties: {
	            needTrack: true,
	            setter: {
	                'parentSize': 'changeSize',
	                'investment': 'setInvestment',
	                'growthBaseValue': 'changeGrowthBaseValue',
	                'compareTickers': 'updateCompareTickers',
	                'skin': 'changeSkin',
	                'settings': 'setSettings', //only for DWM to restore settings
	                'refresh': 'refreshChart'
	            },
	            getter: {
	                'configuration': 'getSaveConfig'
	            },
	            events: {
	                'load': 'onLoad',
	                'mainTickerDrawEnd': 'onMainTickerDrawEnd',
	                'close': 'onClose',
	                'click': 'triggerClickCallback',
	                'addCompareTickers': 'onAddCompareTickers',
	                'removeCompareTickers': 'onRemoveCompareTickers',
	                'heightChange': 'onHeightChange',
	                'tickerRemoveBtnClicked': 'onTickerRemoveBtnClicked',
	                'configChange': 'onConfigChange',
	                'fullyRendered': 'onFullyRendered',
	                'complete':'onComplete',
	                'error': 'onError',
	                'beforeZoomIn': 'onbeforeZoomIn',
	                'dateRangeChange': 'onDateRangeChange',
	                'frequencyChange': 'onChangeFrequency'
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, d3) {
	    'use strict';
	    /**
	    * Define the component name for namespace.
	    */
	    var marketscore = 'markets-components-core';
	    /**
	    * Registar the global namespace name for the whole component
	    */
	    var QSAPI = morningstar.components[marketscore];
	
	    QSAPI.d3 = d3;
	
	    return QSAPI;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(54), __webpack_require__(60), __webpack_require__(67)], __WEBPACK_AMD_DEFINE_RESULT__ = function(layoutManagerModel, chartConfigManagerModel, dataAdapterModel, eventManagerModel) {
	    'use strict';
	    return function() {
	        var managers = {};
	        managers.eventManager = eventManagerModel(managers);
	        managers.dataAdapter = dataAdapterModel(managers);
	        managers.chartConfigManager = chartConfigManagerModel(managers);
	        managers.layoutManager = layoutManagerModel(managers);
	        var chartConfigManager = managers.chartConfigManager;
	        var layoutManager = managers.layoutManager;
	        return {
	            init: function(extendConfig, callbacks) {
	                chartConfigManager.initConfig(extendConfig, layoutManager.createView);
	            },
	            getSaveConfig: chartConfigManager.getSaveConfig,
	            changeInterval: chartConfigManager.changeInterval,
	            destroy: chartConfigManager.destroyChart,
	            changeMainTicker: chartConfigManager.changeMainTicker,
	            addCompareTickers: chartConfigManager.addCompareTickers,
	            removeCompareTickers: chartConfigManager.removeCompareTickers,
	            changeSize: layoutManager.changeSize,
	            hidePopover: layoutManager.hidePopover,
	            changeGrowthBaseValue: chartConfigManager.changeGrowthBaseValue,
	            updateCompareTickers: chartConfigManager.updateCompareTickers,
	            changeSkin: layoutManager.changeSkin,
	            refreshChart: chartConfigManager.processChartDataUpdate
	        };
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(21), __webpack_require__(45), __webpack_require__(22),
	        __webpack_require__(30), __webpack_require__(3), __webpack_require__(17), __webpack_require__(42), __webpack_require__(7),
	        __webpack_require__(51), __webpack_require__(52), __webpack_require__(53), __webpack_require__(33), __webpack_require__(41), __webpack_require__(1)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(errorHandler, crosshairsModel, MenuBarModel, MenuBarInterval, core, util, mainChartModel, volumeChartModel, sliderChartModel, indicatorChartModel, fundamentalChartModel, AutoCompleteModel, PopoverModel, morningstar) {
	        "use strict";
	
	        var $ = core.$;
	
	        /**
	         * Layout manage Model
	         *
	         */
	        function layoutManager(managers) {
	            var CCM = managers.chartConfigManager;
	            var eventManager = managers.eventManager;
	            var MenuBar = MenuBarModel(managers);
	            var menuBar = null;
	            var crosshairs = crosshairsModel(managers);
	            var ChartNameConstructorMapping = {
	                mainChart: mainChartModel(managers),
	                volumeChart: volumeChartModel(managers),
	                sliderChart: sliderChartModel(managers),
	                fundamentalChart: fundamentalChartModel(managers),
	                indicatorChart: indicatorChartModel(managers)
	            };
	
	            var config;
	            var viewMappings = {};
	            var $container, $scrollEl, $innerContainer, $el, $menubarContainer, $subChartContainer;
	            var $indicatorFoundmentalContainer;
	            var $loadingElem;
	            var callLoadingCount = 0;
	            var componentName = "markets-components-svgchart";
	            var heightChangeTimer;
	            var lastCallbackHeight, viewLoaded = false;
	            var cursorTypeChanged, frequencyChanged;
	            var containerIsBody;
	            var scrollBarInfo;
	            var scrollbarStatus;
	            var hideLoadingTimer;
	            var breakpointArr, breakpointLength, breakpointStatus, printSizeConfig = {},
	                printStyleClass;
	            /**
	             * Render the whole chart view
	             *
	             * @param {config} the configuration of the chart view layout
	             */
	            function createView() {
	                breakpointStatus = Infinity;
	                cursorTypeChanged = false;
	                frequencyChanged = false;
	                $loadingElem = null;
	                config = CCM.getConfig();
	
	                var breakpointConfig = core.getBreakpointConfig(config.theme);
	                if (config.customBreakPoint) {
	                    breakpointConfig.breakPoint = config.customBreakPoint;
	                }
	                breakpointArr = (breakpointConfig.breakPoint || []).sort(function(a, b) {
	                    return a - b;
	                });
	
	                breakpointLength = breakpointArr.length;
	                if (scrollbarStatus) {
	                    config.width += (scrollBarInfo = getScrollBarInfo(scrollBarInfo)).width;
	                }
	
	                scrollbarStatus = false;
	                $container = $(config.container);
	                $innerContainer = $('<div class="mkts-cmpt-svgcht-chart-wrap"></div>').appendTo($container);
	                $scrollEl = $(config.template({
	                    skin: config.skin
	                })).addClass(config.securityTypeClass).appendTo($innerContainer);
	                if (config.showPadding) {
	                    $scrollEl.addClass('mkts-cmpt-svgcht-chart-container--padding');
	                }
	                $el = $scrollEl.find(".mkts-cmpt-svgcht-chart");
	                config.$componentContainer = $el;
	                config.$container = $container;
	                config.$scrollEl = $scrollEl;
	                config.$innerContainer = $innerContainer;
	                containerIsBody = $container.is(document.body);
	                if (containerIsBody) {
	                    if (config.fixHeight) {
	                        $container.css('overflow', 'hidden');
	                    } else {
	                        $container.css('overflowX', 'hidden');
	                    }
	                }
	
	                $subChartContainer = $el.find(".chart-subcharts");
	                $indicatorFoundmentalContainer = $el.find(".chart-indicator-fundamental");
	                bindEvents();
	
	                if (config.MenubarModel && typeof config.MenubarModel === 'function') {
	                    MenuBar = config.MenubarModel(managers, core, util, AutoCompleteModel, PopoverModel);
	                }
	                /*render menubar firstly, then we can get the height*/
	                renderMenuBarView();
	
	                /*calculate size*/
	                var width, height;
	                if (config.width > 0) {
	                    width = config.width;
	                } else {
	                    width = getContainerWidth();
	                }
	                if (config.height > 0) {
	                    height = config.height;
	                } else {
	                    height = getContainerHeight();
	                }
	
	                width = caculateContentWidth(width, false);
	                height = caculateContentHeight(height, false);
	                addOrRemoveBreakPointStyle(width);
	                var newConfig = {
	                    width: width,
	                    height: height,
	                    paddingTopBottom: padTopBottom(),
	                    paddingLeftRight: padLeftRight()
	                };
	
	                CCM.setConfig(newConfig, newConfig.width !== config.width || newConfig.height !== config.height);
	
	                widthRelatedProcess();
	                renderSubCharts();
	                config.charts.mainChart.height = caculateMainChartHeight(newConfig.width, newConfig.height - newConfig.paddingTopBottom).height;
	                renderMainCharts();
	                var style = {};
	                if (config.fixHeight) {
	                    style.overflowY = "auto";
	                    style.height = newConfig.height;
	                } else {
	                    style.overflow = "hidden";
	                }
	
	                //if (containerIsBody) {
	                //    style.width = caculateContentWidth(width);
	                //}
	
	                /*var marginConfig = config.margin;
	                style.margin = marginConfig.top + "px " + marginConfig.right + "px " +
	                    marginConfig.bottom + "px " + marginConfig.left + "px";*/
	                $scrollEl.css(style);
	
	                renderCrossHairs();
	
	                $scrollEl.show();
	                errorHandler(managers);
	                eventManager.trigger("layout-rendered");
	                addPrintListener();
	            }
	
	            function addPrintListener() {
	                // support chrome for listen print function
	                var currentWidth = 0,
	                    _FixHeight;
	                window.matchMedia("print").addListener(function(mql) {
	                    if (mql.matches) {
	                        caculatePrintWidth(_FixHeight);
	                    }
	                });
	                //support IE & firefox for listen print function
	                window.addEventListener("beforeprint", function(e) {
	                    var userArge = navigator.userAgent;
	                    currentWidth = getContainerWidth();
	                    if (/Firefox/ig.test(userArge) || /(msie\s|Trident.*rv:)([\w.]+)/g.test(userArge)) {
	                        caculatePrintWidth(_FixHeight);
	                    }
	                });
	                window.addEventListener("afterprint", function(e) {
	                    config.fixHeight = _FixHeight;
	                    changeSize(currentWidth);
	                    config.$componentContainer.find(".chart-body").removeClass(printStyleClass);
	                });
	            }
	
	            // caculate print screen width and resize svgchart container
	            function caculatePrintWidth(_FixHeight) {
	                config.$componentContainer.find(".chart-body").removeClass(printStyleClass);
	                config.fixHeight = [false, _FixHeight = config.fixHeight][0];
	                var styles = config.$container.attr("style"),
	                    hasWidthStyle = false;
	                if (styles && styles.indexOf("width") > -1) {
	                    hasWidthStyle = true;
	                }
	                var prefix = "mkts-cmpt-svgcht-less",
	                    suffix = "printStyle",
	                    sizeArry = [1155, 834, 634, 600],
	                    resizewidth,
	                    screenWidth = window.screen.width;
	
	                if (!hasWidthStyle) {
	                    var _breakpointArr = [].concat(breakpointArr).sort(function(a, b) {
	                        return b - a;
	                    });
	                    for (var printPoint = 0; printPoint < _breakpointArr.length; printPoint++) {
	                        if (printSizeConfig.width <= _breakpointArr[printPoint]) {
	                            resizewidth = sizeArry[printPoint + 1];
	                            printStyleClass = prefix + _breakpointArr[printPoint] + suffix;
	                        } else if (printSizeConfig.width > 1000) {
	                            resizewidth = sizeArry[0];
	                            printStyleClass = screenWidth === printSizeConfig.width && containerIsBody ? "mkts-cmpt-svgcht-nobody-style" : "mkts-cmpt-svgcht-more1000printStyle";
	
	                        }
	                    }
	                    if (screenWidth !== printSizeConfig.width || !containerIsBody) {
	                        changeSize(resizewidth);
	                    }
	                    config.$componentContainer.find(".chart-body").addClass(printStyleClass);
	                } else {
	                    //svgchart container has width style
	                    resizewidth = getContainerWidth();
	                    changeSize(resizewidth);
	                }
	
	            }
	
	            function getScrollBarInfo(scrollBarInfo) {
	                if (scrollBarInfo) return scrollBarInfo;
	                var scrollBarHelper = document.createElement("div");
	                scrollBarHelper.style.cssText = "overflow:scroll;width:100px;height:100px;";
	                document.body.appendChild(scrollBarHelper);
	                var __scrollBarInfo = {};
	                if (scrollBarHelper) {
	                    __scrollBarInfo = {
	                        height: scrollBarHelper.offsetHeight - scrollBarHelper.clientHeight,
	                        width: scrollBarHelper.offsetWidth - scrollBarHelper.clientWidth
	                    };
	                }
	
	                document.body.removeChild(scrollBarHelper);
	                return __scrollBarInfo;
	            }
	
	            function checkIsSupportDateTypeElment() {
	                var div = document.createElement("input");
	                div.setAttribute("type", "date");
	                if (div.type == "text") {
	                    return false
	                }
	                return true;
	            }
	
	            function caculateContentWidth(width, needMinusPadding) {
	                needMinusPadding = needMinusPadding === false ? false : true;
	                var _width = width - (needMinusPadding ? padLeftRight() : 0);
	                _width = Math.max(config.minWidth, _width);
	                _width = Math.min(config.maxWidth, _width);
	                return _width;
	            }
	
	            function caculateContentHeight(height, needMinusPadding) {
	                needMinusPadding = needMinusPadding === false ? false : true;
	                return height - (needMinusPadding ? padTopBottom() : 0);
	            }
	
	            function padTopBottom() {
	                return parseInt($scrollEl.css('padding-top'), 10) + parseInt($scrollEl.css('padding-bottom'), 10);
	            }
	
	            function padLeftRight() {
	                return parseInt($scrollEl.css('padding-left'), 10) + parseInt($scrollEl.css('padding-right'), 10);
	            }
	
	            function caculateMainChartHeight(width, height) {
	                var needScrollBar = false,
	                    menuHeight = $menubarContainer.is(':hidden') ? 0 : $menubarContainer.outerHeight(true),
	                    volumeSliderHeight = $subChartContainer.outerHeight(true),
	                    volumeSliderWidtht = $subChartContainer.outerWidth(true),
	                    indicatorFoundmentalHeight = $indicatorFoundmentalContainer.outerHeight(true),
	                    mainHeight = height - menuHeight - volumeSliderHeight,
	                    minHeight = config.charts.mainChart.minHeight;
	                if (config.fixHeight) {
	                    if (indicatorFoundmentalHeight > 0) {
	                        needScrollBar = true;
	                    }
	                } else {
	                    mainHeight -= indicatorFoundmentalHeight;
	                }
	
	                if (mainHeight < minHeight) {
	                    needScrollBar = true;
	                    mainHeight = minHeight;
	                }
	
	                return {
	                    height: mainHeight,
	                    needScrollBar: needScrollBar
	                };
	            }
	
	            function bindEvents() {
	                var eventTypes = eventManager.EventTypes;
	                eventManager.bind(eventTypes.StartLoading, startLoading);
	                eventManager.bind(eventTypes.EndLoading, endLoading);
	                eventManager.bind(eventTypes.HeightChanged, heightChanged);
	                eventManager.bind(eventTypes.CallBackHeightChanged, callBackHeightChanged);
	                eventManager.bind(eventTypes.DestroyChart, processDestroyChart);
	                eventManager.bind(eventTypes.OnMainTickerDrawEnd, onMainTickerDrawEnd);
	            }
	
	            function heightChanged() {
	                if (config.fixHeight) {
	                    changeSize();
	                    if (!viewLoaded) {
	                        callBackHeightChanged();
	                    }
	                } else {
	                    callBackHeightChanged();
	                }
	            }
	
	
	            function processDestroyChart() {
	                $container.removeData('morningstar-markets-container-event-data');
	                $innerContainer.hide().remove();
	                viewMappings = {};
	                $el = null;
	            }
	
	            function createLoadingElem() {
	                $loadingElem = $('<div class="mkts-cmpt-svgcht-loading-overlay"></div>')
	                    .append($('<div class="mkts-cmpt-svgcht-loading-spinner"></div>'))
	                    .appendTo($el);
	            }
	
	            function startLoading() {
	                if (!$loadingElem) {
	                    createLoadingElem();
	                }
	                callLoadingCount++;
	                //console.log("startLoading callLoadingCount:" + callLoadingCount);
	                //console.trace();
	                $loadingElem.addClass("showing").show();
	                clearTimeout(hideLoadingTimer);
	                hideLoadingTimer = setTimeout(hideLoading, 10000);
	            }
	
	            function endLoading() {
	                callLoadingCount--;
	                //console.log("endLoading callLoadingCount:" + callLoadingCount);
	                //console.trace();
	                if (callLoadingCount <= 0) {
	                    hideLoading();
	                }
	            }
	
	            function changeSkin(theme) {
	                var str = 'mkts-cmpt-svgcht-chart-container--';
	                var themeClass = str + config.skin;
	                var $el = $container.find('.mkts-cmpt-svgcht-chart-container');
	                if ($el.hasClass(themeClass)) {
	                    $el.removeClass(themeClass);
	                }
	                themeClass = str + theme;
	                config.skin = theme;
	                $el.addClass(themeClass);
	            };
	
	            function hideLoading() {
	                callLoadingCount = 0;
	                $loadingElem && $loadingElem.hide().removeClass("showing");
	                clearTimeout(hideLoadingTimer);
	            }
	
	            function changeSize(width, height) {
	                // before init config, may be change browser size.
	                if (config && util.isExistedInDom(config.$container)) {
	                    eventManager.trigger(eventManager.EventTypes.ToggleCrossharis);
	                    width = width || (config.width + (scrollbarStatus ? (scrollBarInfo = getScrollBarInfo(scrollBarInfo)).width : 0)) || getContainerWidth();
	
	                    var newConfig = {
	                        width: width
	                    };
	                    width = caculateContentWidth(width, false);
	                    var style = {};
	                    var mainHeightChanged = false;
	                    if (!config.fixHeight) {
	                        height = null;
	                    } else {
	                        height = height || config.height || getContainerHeight();
	                        newConfig.height = height;
	                        height = caculateContentHeight(height);
	                        style.height = newConfig.height;
	
	                        var chartInfo = caculateMainChartHeight(width, height);
	                        if (mainHeightChanged = (config.charts.mainChart.height != chartInfo.height)) {
	                            config.charts.mainChart.height = chartInfo.height;
	                        }
	
	                        scrollbarStatus = chartInfo.needScrollBar;
	                        if (scrollbarStatus) {
	                            scrollBarInfo = getScrollBarInfo(scrollBarInfo);
	                            width -= scrollBarInfo.width || 0;
	                        }
	                    }
	
	                    $scrollEl.css(style);
	                    widthRelatedProcess(width);
	                    var widthChanged = (width !== config.width);
	                    newConfig.width = width;
	                    if ((newConfig.height && config.height !== newConfig.height) || widthChanged) {
	                        CCM.setConfig(newConfig); //just update config, not update view.
	                    }
	
	                    addOrRemoveBreakPointStyle(width);
	
	                    newConfig.paddingLeftRight = padLeftRight();
	                    newConfig.paddingTopBottom = padTopBottom();
	                    var paddingChanged = (newConfig.paddingLeftRight !== config.paddingLeftRight) || (newConfig.paddingTopBottom !== config.paddingTopBottom);
	                    if (paddingChanged) {
	                        CCM.setConfig(newConfig);
	                    }
	                    $.extend(true, printSizeConfig, newConfig);
	                    if (widthChanged || paddingChanged) {
	                        eventManager.trigger(eventManager.EventTypes.LayoutChange);
	                    } else if (mainHeightChanged) {
	                        eventManager.trigger(eventManager.EventTypes.ChangeMainChartLayout);
	                    }
	                }
	            }
	
	            function addOrRemoveBreakPointStyle(width) {
	                var prefix = "mkts-cmpt-svgcht-less";
	                var suffix = "style";
	                if (CCM.getConfig().customBreakPoint) {
	                    suffix += "-custom";
	                }
	                var lastStatus = breakpointStatus;
	                for (var i = breakpointLength; i > 0; i--) {
	                    if (width > breakpointArr[i - 1]) {
	                        break;
	                    }
	                };
	                breakpointStatus = i;
	                if (lastStatus > breakpointStatus) {
	                    for (var k = breakpointStatus; k < lastStatus && k < breakpointLength; k++) {
	                        $scrollEl.addClass(prefix + breakpointArr[k] + suffix);
	                    }
	                } else if (lastStatus < breakpointStatus) {
	                    for (var k = lastStatus; k < breakpointStatus && k < breakpointLength; k++) {
	                        $scrollEl.removeClass(prefix + breakpointArr[k] + suffix);
	                    }
	                }
	                eventManager.trigger(eventManager.EventTypes.DeployIntervalBreakPoint, width);
	            }
	
	            function widthRelatedProcess() {
	                var crossType;
	                if (!cursorTypeChanged && config.hideCross && (config.cursorType === CCM.CursorType.Crosshair) && (getContainerWidth() < 800)) {
	                    crossType = CCM.CursorType.Trackball;
	                    cursorTypeChanged = true;
	
	                } else if (cursorTypeChanged && (getContainerWidth() > 800)) {
	                    cursorTypeChanged = false;
	                    crossType = CCM.CursorType.Crosshair;
	                }
	
	                if (crossType) {
	                    eventManager.trigger(eventManager.EventTypes.ChangeChartCursor, crossType);
	                    eventManager.trigger(eventManager.EventTypes.ToggleCrossharis);
	                }
	
	                if (!frequencyChanged && getContainerWidth() < 1000) {
	                    eventManager.trigger(eventManager.EventTypes.ChangeOneDayFrequency, true);
	                    frequencyChanged = true;
	                } else if (frequencyChanged && getContainerWidth() > 1000) {
	                    eventManager.trigger(eventManager.EventTypes.ChangeOneDayFrequency, false);
	                    frequencyChanged = false;
	                }
	            }
	
	            function callBackHeightChanged() {
	                clearTimeout(heightChangeTimer);
	
	                //Why use setTimeout?
	                //Because main chart, volume chart, indicator chart use same data and data manager have
	
	                heightChangeTimer = setTimeout(function() {
	                    var height = $scrollEl.outerHeight(true),
	                        width = $scrollEl.outerWidth(true);
	                    if (!viewLoaded) {
	                        lastCallbackHeight = height;
	                        if (typeof config.onLoad == 'function') {
	                            viewLoaded = true;
	                            config.onLoad({
	                                component: componentName,
	                                width: width,
	                                height: height
	                            });
	                        }
	                    } else if (lastCallbackHeight !== height) {
	                        lastCallbackHeight = height;
	                        if (typeof config.onHeightChange == 'function') {
	                            config.onHeightChange({
	                                height: height,
	                                component: componentName
	                            });
	                        }
	                    }
	                    var eventTypes = eventManager.EventTypes;
	                    eventManager.trigger(eventTypes.FetchPreloadRelatedAndIndexData, null, false);
	                }, 10);
	            }
	
	            function createSelfContainer(height) {
	                return $("<div/>").addClass("chart-container").css("height", height);
	            }
	
	            function getContainer(className) {
	                var chartContainer = $el.find("." + className)[0];
	                if (!chartContainer) {
	                    chartContainer = $("<div>").addClass(className).appendTo($el);
	                }
	                return chartContainer;
	            }
	
	            function renderSubCharts() {
	                var chartTypes = CCM.ChartTypes;
	                var chartName, chartConfig, chartConstructor;
	                for (var key in chartTypes) {
	                    chartName = chartTypes[key];
	                    if (chartName === chartTypes.MainChart) {
	                        continue;
	                    }
	                    chartConfig = CCM.getChartConfig(chartName);
	                    chartConstructor = ChartNameConstructorMapping[chartName];
	                    //fund chart does not need init volume chart
	
	                    if ((chartConfig.show || chartName === chartTypes.VolumeChart) && chartConstructor) {
	                        if (chartName === chartTypes.VolumeChart) {
	                            if (!chartConfig.needInit) continue;
	                        }
	                        chartConfig.container = getContainer(chartConfig.chartClass);
	                        viewMappings[chartName] = new chartConstructor(chartConfig);
	                    }
	                }
	            }
	
	            function renderMainCharts() {
	                var chartName, chartConfig, chartConstructor;
	                chartName = CCM.ChartTypes.MainChart;
	                chartConfig = CCM.getChartConfig(chartName);
	                chartConstructor = ChartNameConstructorMapping[chartName];
	                if (chartConfig.show && chartConstructor) {
	                    chartConfig.container = getContainer(chartConfig.chartClass);
	                    viewMappings[chartName] = new chartConstructor(chartConfig);
	                }
	            }
	
	            function renderMenuBarView() {
	                $menubarContainer = $el.find('.mkts-cmpt-svgcht-menubar');
	
	                menuBar = new MenuBar({
	                    container: $menubarContainer
	                });
	
	                if (config.hideAllMenuBar) {
	                    $menubarContainer.hide();
	                } else {
	                    if (config.hideMenu) {
	                        $menubarContainer.find('.mkts-cmpt-svgcht-menubar-top, .mkts-cmpt-svgcht-hr').hide();
	                    }
	
	                    if (config.hideTab) {
	                        $menubarContainer.find('.mkts-cmpt-svgcht-menubar-tab, .mkts-cmpt-svgcht-hr').hide();
	                    }
	                    if (config.hideMenuBottom) {
	                        $menubarContainer.find('.mkts-cmpt-svgcht-menubar-bottom').hide();
	                    }
	                    if (config.hideSearch) {
	                        $menubarContainer.find('.mkts-cmpt-svgcht-menubar-top').addClass('mkts-cmpt-svgcht-hide-search');
	                    }
	                    if (config.hideIndicator) {
	                        $menubarContainer.find(".mkts-cmpt-svgcht-menubtn--events-indicators").hide();
	                    }
	                    if (config.hideFundamental) {
	                        $menubarContainer.find(".mkts-cmpt-svgcht-menubtn--fundamental").hide();
	                    }
	                    if (config.hideDrawing) {
	                        $menubarContainer.find(".mkts-cmpt-svgcht-menubtn--drawing").hide();
	                    }
	                    if (config.hideDisplay) {
	                        $menubarContainer.find(".mkts-cmpt-svgcht-menubtn--display").hide();
	                    }
	
	                    if (config.hideDateRange) {
	                        $menubarContainer.find('.mkts-cmpt-svgcht-menuicn--label,.mkts-cmpt-svgcht-date-range').hide();
	                    }
	                    if (config.hideCalendar) {
	                        $menubarContainer.find('.mkts-cmpt-svgcht-calendar-pickers').hide();
	                    }
	                    if (config.hideFrequency) {
	                        $menubarContainer.find('.mkts-cmpt-svgcht-menuicn--label,.mkts-cmpt-svgcht-frequency-picker').hide();
	                    }
	                }
	            }
	
	            function renderCrossHairs() {
	                new crosshairs($innerContainer, {
	                    menuHeight: config.hideAllMenuBar ? 0 : menuBar.getHeight()
	                });
	            }
	
	            function getContainerWidth() {
	                return containerIsBody ? document.documentElement.clientWidth : $container.width();
	            }
	
	            function getContainerHeight() {
	                return containerIsBody ? document.documentElement.clientHeight : $container.height();
	            }
	
	            function hidePopover() {
	                menuBar.hidePopover();
	            }
	
	            function onMainTickerDrawEnd(date) {
	                if (config && typeof config.onMainTickerDrawEnd == "function") {
	                    config.onMainTickerDrawEnd(date);
	                }
	            }
	            return {
	                createView: createView,
	                changeSize: changeSize,
	                hidePopover: hidePopover,
	                changeSkin: changeSkin
	            };
	        }
	
	        return layoutManager;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(9), __webpack_require__(3), __webpack_require__(15), __webpack_require__(17),
	        __webpack_require__(10), __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(commonPlotter, graphTypes, core, baseChartModel, util, barSeries, request) {
	        "use strict";
	        var $ = core.$;
	        var d3 = core.d3;
	
	        /**
	         * Volume chart Model
	         *
	         */
	        var model = function(managers) {
	            var eventManager = managers.eventManager;
	            var chartConfigManager = managers.chartConfigManager;
	            var baseChart = baseChartModel(managers);
	            var dataAdapter = managers.dataAdapter;
	            var rootConfig;
	
	            var volumeChartExtend = {
	                _init: function(config) {
	                    this._innerClass = innerClass;
	                    rootConfig = chartConfigManager.getConfig();
	                    this.langData = chartConfigManager.getLabels('markets-components-svgchart', config.lang);
	                    this._chartTypes = chartConfigManager.VolumeChartTypes;
	                    this._bindEvents();
	                    this._renderDomFrame();
	                    this._decideMinMaxAttrbute();
	                    this._updateViewData();
	                    if (this.config.show === false) {
	                        this._changeVolumeChart();
	                    }
	                },
	                _reviseData: function(data) {
	                    data.forEach(function(d) {
	                        d.x = d.index;
	                        d.y = d.volume;
	                    });
	                    return data;
	                },
	                _bindEvents: function() {
	                    var eventTypes = eventManager.EventTypes;
	                    eventManager.bind(eventTypes.UpdateConfig, this._updateConfig, this);
	                    eventManager.bind(eventTypes.ChangeChartType, this._changeChartType, this);
	                    eventManager.bind(eventTypes.ChangeXAxisDomain, this._changeXAxisScaleDomain, this);
	                    eventManager.bind(eventTypes.ChangeIntervalFrequency, this._changDataRange, this);
	                    eventManager.bind(eventTypes.ChangeIndicators, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeFundamental, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.FetchPreloadData, this._fetchPreloadData, this);
	                    eventManager.bind(eventTypes.LayoutChange, this._changeLayout, this);
	                    eventManager.bind(eventTypes.ChangeYAxis, this._changeYaxis, this);
	                    eventManager.bind(eventTypes.ChangeEvents, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.UpdateCompareTickers, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ToggleTrackballVolume, this._toggleTrackball, this);
	                    eventManager.bind(eventTypes.ChangeVolumeChart, this._changeVolumeChart, this);
	                    eventManager.bind(eventTypes.DrawNewData, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.DestroyChart, this._processDestroyChart, this);
	                    eventManager.bind(eventTypes.MouseOutChart, this._hideCursorValue, this);
	                    eventManager.bind(eventTypes.ShowTrackball, this._showTrackball, this);
	                    eventManager.bind(eventTypes.ChangeStartDate, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeChartType, this._decideMinMaxAttrbute, this);
	                },
	                _processDestroyChart: function() {
	                    this._svg && this._svg.on('.volumechart', null);
	                },
	                _changeYaxis: function(position) {
	                    if (this.config.yAxis.position == "outer") {
	                        this._caculateValidSize();
	                        this._createScale();
	                        this._createCommonPlotter();
	                        var translate = this._getGElemTranslate();
	                        this._outerGElem && this._outerGElem.attr("transform", translate);
	                    }
	                    this._chartConfigChanged();
	                },
	                _hideCursorValue: function() {
	                    rootConfig.$componentContainer.find('.' + chartConfigManager.getConfig().cursorValueClass).text('');
	                },
	                _changeVolumeChart: function() {
	                    var volumeChartElement = rootConfig.$componentContainer.find('.' + chartConfigManager.getConfig().volumeChartClass);
	                    if (this.config.show) {
	                        if (volumeChartElement) {
	                            volumeChartElement.css('display', 'block');
	                        }
	                        this._chartConfigChanged(this.config.chartType);
	                    } else {
	                        if (volumeChartElement) {
	                            volumeChartElement.css('display', 'none');
	                        }
	                        this._clearView();
	                    }
	                    eventManager.trigger(eventManager.EventTypes.HeightChanged);
	                },
	                _toggleTrackball: function(trackballData) {
	                    var cfg = this.config;
	                    var rootCfg = chartConfigManager.getConfig();
	                    for (var chartType in trackballData) {
	                        if (trackballData.hasOwnProperty(chartType)) {
	                            switch (chartType) {
	                                case 'main':
	                                    var volumeFormat = isNaN(rootCfg.frequency) ? ".3s" : ",";
	                                    var volumeToDisplay = !trackballData[chartType].data || isNaN(trackballData[chartType].data.volume) ? this.langData['crosshairsPopoverNoData'] : d3.format(volumeFormat)(trackballData[chartType].data.volume);
	                                    var mainValueLable = rootConfig.$componentContainer.find('.' + innerClass.mainValue);
	                                    if (mainValueLable) {
	                                        mainValueLable.css('color', trackballData[chartType].color);
	                                        mainValueLable.text(': ' + volumeToDisplay);
	                                    }
	                                    break;
	                                case 'indicators':
	                                    var runningIndex = 0,
	                                        chartTypeName = '';
	                                    trackballData[chartType].forEach(function(d) {
	                                        var newChartTypeName = d.name;
	                                        newChartTypeName = newChartTypeName.replace(' ', '');
	                                        if (chartTypeName !== newChartTypeName) {
	                                            runningIndex = 0;
	                                            chartTypeName = newChartTypeName;
	                                        }
	                                        var tickerValueElement = rootConfig.$componentContainer.find('.' + innerClass[chartType + "Value"] + chartTypeName + runningIndex);
	                                        if (tickerValueElement) {
	                                            tickerValueElement.css('color', d.color);
	                                            tickerValueElement.text((d.data && !isNaN(d.data.y)) ? d.data.y.toFixed(2) : '--');
	                                        }
	                                        runningIndex += 1;
	                                    });
	                                    break;
	                                default:
	                                    break;
	                            }
	                        }
	                    };
	                },
	                _showDataNotAvailable: function() {
	                    if (!this._svg) {
	                        return;
	                    }
	
	                    if (this._outerGElem) {
	                        this._outerGElem.selectAll("g").remove();
	                    }
	                    if (this.config && this.config.container) {
	                        $(this.config.container).hide();
	                    }
	                },
	                _hideDataNotAvailable: function() {
	                    if (this.config.show) {
	                        $(this.config.container).show();
	                    }
	                },
	                _updateConfig: function() {
	                    this.config = chartConfigManager.getChartConfig(chartConfigManager.ChartTypes.VolumeChart);
	                },
	                _changeChartType: function(chartType) {
	                    if (this["_draw_" + chartType]) {
	                        this.config.chartType = this._currentChartType = chartType;
	                        //TODO: Not every chart type need reload data. We need change this in future.
	                        this._chartConfigChanged();
	                    }
	                },
	                _chartConfigChanged: function(chartType) {
	                    this._updateViewData();
	                },
	                _clearView: function(chartType) {
	                    if (this._outerGElem) {
	                        this._outerGElem.selectAll("." + innerClass.indicators).remove();
	                        this._outerGElem.selectAll(".gridBlock").remove();
	                    }
	
	                    this._clearTrackball();
	                },
	                _displayViewAfterChangeDomain: function() {
	                    this._caculateValidSize();
	                    this._clearView();
	                    this._renderContainedViews();
	                    this._appendHeaderForIndicators();
	                },
	                _createScale: function() {
	                    var view = this;
	                    this._xScale = d3.scale.linear()
	                        .range([0, this._validWidth])
	                        .domain(this._getAjustedDomain([0, this._data.length - 1]));
	
	                    this._yScale = d3.scale.linear().range([this._validHeight, 0]);
	                    this._setYScaleDomain();
	                },
	                _setYScaleDomain: function() {
	                    var minYValueArr = [d3.min(this._data, function(d) {
	                        return d.y;
	                    })];
	                    var maxYValueArr = [d3.max(this._data, function(d) {
	                        return d.y;
	                    })];
	                    var yScaleData = this._calculateYScaleDomainTickValues(d3.min(minYValueArr), d3.max(maxYValueArr));
	                    this._yTickValues = yScaleData.tickValues;
	                    if (yScaleData.domain) {
	                        this._yScale.domain(yScaleData.domain);
	                    }
	                },
	                _changeLayout: function() {
	                    d3.select(this.config.container).selectAll("div").remove();
	                    this._renderDomFrame();
	                    if (this._data && (this._data.length > 0)) {
	                        this._renderView();
	                    } else {
	                        this._showDataNotAvailable();
	                        this._viewInited = false;
	                    }
	                },
	                _caculateValidSize: function() {
	                    var cfg = this.config;
	                    if (cfg.yAxis.position == "outer") {
	                        this._validWidth = cfg.width - cfg.margin.left - cfg.margin.right - cfg.yAxis.width - cfg.yAxisMargin;
	                    } else {
	                        this._validWidth = cfg.width - cfg.margin.left - cfg.margin.right;
	                    }
	                    this._validHeight = cfg.height - cfg.margin.top - cfg.margin.bottom - this._headerHeight;
	                },
	                _renderDomFrame: function() {
	                    this._renderHeader();
	                    this._caculateValidSize();
	                    this._createSvgWrapper();
	                    this._renderFooter();
	                    this._appendHeaderForIndicators();
	                    //eventManager.trigger(eventManager.EventTypes.HeightChanged, this);
	                },
	                _createSvgWrapper: function() {
	                    var cfg = this.config;
	                    var svg = this._svg = d3.select(cfg.container).append('div').classed(innerClass.chartBody, true)
	                        .style("width", cfg.width + cfg.margin.left + cfg.margin.right + "px").style("height", this._validHeight + "px")
	                        .append("svg").attr("width", cfg.width).attr("height", this._validHeight);
	                    this._outerGElem = svg.append("g")
	                        .attr("transform", this._getGElemTranslate());
	                    this._yAxisOuterGElem = svg.append("g").attr("class", innerClass.yAxis);
	                },
	                _renderView: function() {
	                    var view = this;
	                    this._containerOffset = 0;
	                    this._createScale();
	                    this._createCommonPlotter();
	                    this._renderContainedViews();
	                    //when mouse move in the mainchart, we will show crosshairs
	                    this._svg.on('mousemove.volumechart', function() {
	                        view._containerOffset = view._containerOffset ? view._containerOffset : $(view.config.container).offset();
	                        view._mousemove(d3.event, d3.mouse(this), view._headerHeight);
	                    });
	                    this._viewInited = true;
	                },
	                _renderContainedViews: function() {
	                    if (!this._data || this._data.length === 0) {
	                        this._showDataNotAvailable();
	                        return;
	                    } else {
	                        this._hideDataNotAvailable();
	                    }
	                    this._decimalPlaces = this._getDecimalPlaces();
	                    this._drawXAxis();
	                    this._drawYAxis();
	                    this._drawGridLines();
	                    this._draw_Indicators();
	                    this._drawChartGraph();
	
	                },
	                _createCommonPlotter: function() {
	                    var view = this;
	                    var graphConfig = this._defaultGraphConfig = {
	                        yAttributeName: "volume",
	                        containerGElem: this._outerGElem,
	                        data: this._data,
	                        xScale: this._xScale,
	                        yScale: this._yScale,
	                        graphType: graphTypes.Histogram,
	                        width: this._validWidth,
	                        height: this._validHeight,
	                        tickSize: this.config.volumeBarWidth,
	                        yAxisContainerGElem: this._yAxisOuterGElem,
	                        getElementsMapping: function(elementsMapping) {
	                            var mapping = view._elementsMapping || [];
	                            mapping.push(elementsMapping);
	                            view._elementsMapping = mapping;
	                        }
	                    };
	                    this._getDefaultGraphConfig = function() {
	                        this._defaultGraphConfig.data = this._data;
	                        return this._defaultGraphConfig;
	                    };
	                    this._commonPlotter = new commonPlotter(graphConfig);
	                },
	                _renderHeader: function() {
	                    var cfg = this.config,
	                        margin = this.config.margin;
	                    var tickerInfoContainer = this._headerContainer = d3.select(cfg.container)
	                        .append("div").classed(innerClass.chartHeader, true);
	                    if (cfg.showLegend) {
	                        tickerInfoContainer.append("span").classed(innerClass.chartLegend, true)
	                            .style("background", "#2F4880");
	                    }
	                    tickerInfoContainer.append("span")
	                        .style("margin-left", margin.left + "px")
	                        .style("width", (this.config.width - margin.left - margin.right) + "px")
	                        .classed(innerClass.chartLegendText, true)
	                        .text(this.langData[cfg.chartLegendText] || cfg.chartLegendText)
	                        .append("span")
	                        .classed(chartConfigManager.getConfig().cursorValueClass, true)
	                        .classed(innerClass.mainValue, true);
	                    this._headerContainer.append("span").classed(innerClass.indicators, true);
	                    this._headerHeight = $(tickerInfoContainer[0]).outerHeight(true);
	                },
	                _renderFooter: function() {
	                    var cfg = this.config,
	                        margin = this.config.margin;
	                    d3.select(cfg.container)
	                        .append("div").classed(innerClass.chartFooter, true)
	                        .style("margin-left", margin.left + "px")
	                        .style("width", (this.config.width - margin.left - margin.right) + "px")
	                },
	                _drawChartGraph: function() {
	                    var chartType = this._currentChartType = this.config.chartType;
	                    this["_draw_" + chartType](chartType);
	                },
	                _draw_volumeChart: function(chartType) {
	                    var graphConfig = {
	                        graphCss: innerClass.volumeChart
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	                },
	                _draw_volumePlusChart: function(chartType) {
	                    var graphConfig = {
	                        graphCss: innerClass.volumeChart, //we should use volumePlusChart, I change it for performance.
	                        distinguish: true
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	                }
	            };
	
	            return util.extendClass(baseChart, volumeChartExtend);
	        };
	
	        var innerClass = {
	            gridLines: "volumeChart-gridLines",
	            volumeChart: "chart-volume",
	            volumePlusChart: "chart-volumePlus",
	            chartHeader: "volumeChart-header",
	            chartLegend: "volumeChart-legend",
	            chartLegendText: "volumeChart-legend-text",
	            chartBody: 'volumeChart-body',
	            chartFooter: "volumeChart-footer",
	            xAxis: "volumeChart-xAxis",
	            yAxis: "volumeChart-yAxis",
	            indicators: "indicators",
	            indicatorsLegend: "indicators-legend",
	            indicatorsLegendText: "indicators-legend-text",
	            mainValue: "volumeChart-volumeValue",
	            indicatorsValue: "volumeChart-indicatorsValue-",
	            closeButton: "icon chart close-button"
	        };
	
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(9), __webpack_require__(10), __webpack_require__(11), __webpack_require__(12), __webpack_require__(13), __webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, GraphTypes, barSeries, volumeByPrice, candlestickSeries, gridLines, ohlcSeries) {
	        "use strict";
	        var $ = core.$;
	        var d3 = core.d3;
	        var minTickSize = 1,
	            maxTickSize = 30;
	
	        var commonPlotter = function(config) {
	            var plotter = this;
	            this.defaultConfig = {
	                containerGElem: "",
	                componentContainer: "",
	                data: [],
	                yAxisContainerGElem: "",
	                graphCss: "",
	                insertBeforeCss: "",
	                graphType: GraphTypes.Line,
	                xScale: null,
	                yScale: null,
	                xAttributeName: "",
	                yAttributeName: "close",
	                xFunc: function(d) {
	                    return plotter.config.xScale(d[plotter.config.xAttributeName]);
	                },
	                yFunc: function(d) {
	                    return plotter.config.yScale(d[plotter.config.yAttributeName]);
	                },
	                definedFunc: function(d) {
	                    return !isNaN(d[plotter.config.yAttributeName]);
	                },
	                y0Value: 0
	            };
	            this._init(config);
	        };
	
	        commonPlotter.prototype = {
	            _init: function(config) {
	                this.setConfig(config);
	            },
	            setConfig: function(config) {
	                this.config = $.extend(true, {}, this.defaultConfig);
	                this.config = $.extend(this.config, config);
	            },
	            extendConfig: function(config) {
	                $.extend(this.config, config);
	            },
	            draw: function() {
	                var plotter = this;
	                if (!this.config.xAttributeName) {
	                    this.config.xFunc = function(d, i) {
	                        return plotter.config.xScale(i);
	                    };
	                }
	                return this._showElem(this["_draw_" + this.config.graphType]());
	            },
	            drawTrackball: function(config) {
	                config.graphCss && (config.graphCss = config.graphCss + ' trackball');
	                var graphElem = this._hideElem(this["_draw_track_" + config.trackType](config).classed("track-ball", true));
	                config.globalGraphClass && graphElem.classed(config.globalGraphClass, true);
	                return graphElem
	            },
	            _draw_track_circle: function(config) {
	                var elem = config.trackContainer.append("circle")
	                    .attr("r", config.circleRadius || 4)
	                    .attr("cx", -100)
	                    .attr("cy", -100);
	
	                config.graphCss && elem.classed(config.graphCss, true);
	                config.color && elem.style("stroke", config.color);
	                return elem;
	            },
	            _draw_track_OHLC: function() {
	
	            },
	            _draw_track_candlestick: function() {
	
	            },
	            _caculateTickSize: function() {
	                var width = this.config.width;
	                var tickSize;
	                if (width) {
	                    tickSize = width / this.config.data.length - 1;
	                    tickSize = Math.min(tickSize, maxTickSize);
	                    tickSize = Math.max(tickSize, minTickSize);
	                }
	                return tickSize;
	            },
	            _commonDrawOuterElement: function() {
	                var cfg = this.config;
	                var newGElem;
	                if (cfg.graphCss) {
	                    newGElem = cfg.containerGElem.select("." + cfg.graphCss);
	                }
	
	                if (!newGElem || newGElem.empty()) {
	                    if (cfg.insertBeforeCss) {
	                        newGElem = cfg.containerGElem.insert("g", "." + cfg.insertBeforeCss);
	                    } else {
	                        newGElem = cfg.containerGElem.append("g");
	                    }
	
	                    newGElem.classed(cfg.graphCss, true);
	                    cfg.globalGraphClass && newGElem.classed(cfg.globalGraphClass, true);
	                }
	                return this._hideElem(newGElem);
	            },
	            _commonDrawOHLC: function() {
	                var cfg = this.config;
	                var ohlcFunc = ohlcSeries().xScale(cfg.xScale)
	                    .yScale(cfg.yScale).getElementsMapping(cfg.getElementsMapping)
	                    .tickSize(this._caculateTickSize()).type(cfg.graphType);
	
	                var dataInDomain = this._commonGetDataInDomain(cfg.data, cfg.xScale);
	                var outerElem = this._commonDrawOuterElement();
	                outerElem.datum(dataInDomain).call(ohlcFunc);
	
	                return outerElem;
	            },
	            _commonGetDataInDomain: function(data, scale) {
	                var domain = scale.domain();
	                return data.slice(domain[0], domain[1] + 1);
	            },
	            _hideElem: function(elem) {
	                elem.style("display", "none");
	                return elem
	            },
	            _showElem: function(elem) {
	                elem.style("display", "");
	                return elem
	            },
	            _draw_line: function() {
	                var cfg = this.config;
	                //console.log(cfg.data[cfg.data.length-1].date);
	                var lineFunc = d3.svg.line()
	                    .x(cfg.xFunc)
	                    .y(cfg.yFunc)
	                    .defined(cfg.definedFunc);
	
	                var outerElem = this._commonDrawOuterElement();
	
	                var line = outerElem.append("path")
	                    .datum(this._processData(cfg.data, cfg.definedFunc, cfg.xAttributeName))
	                    .attr("d", lineFunc);
	
	                cfg.color && line.style("stroke", cfg.color);
	                return outerElem;
	            },
	            _draw_area: function() {
	                var cfg = this.config;
	                var area = d3.svg.area()
	                    .x(cfg.xFunc)
	                    .y0(cfg.y0Value)
	                    .y1(cfg.yFunc)
	                    .defined(cfg.definedFunc);
	
	                var outerElem = this._commonDrawOuterElement();
	
	                var graph = outerElem.append("path")
	                    .datum(this._processData(cfg.data, cfg.definedFunc, cfg.xAttributeName))
	                    .attr("d", area);
	
	                cfg.color && graph.style("fill", cfg.color);
	                return outerElem;
	            },
	            _draw_dot: function() {
	                var cfg = this.config;
	                var outerElem = this._commonDrawOuterElement();
	                var dataInDomain = this._commonGetDataInDomain(cfg.data, cfg.xScale);
	                var dataIndex = 0;
	
	                if (!cfg.xAttributeName) {
	                    cfg.xFunc = function() {
	                        return cfg.xScale(dataIndex);
	                    };
	                }
	
	                dataInDomain.forEach(function(d) {
	                    if (!isNaN(d[cfg.yAttributeName])) {
	                        var elem = outerElem.append("circle")
	                            .attr("r", cfg.dotRadius)
	                            .attr("cx", cfg.xFunc(d))
	                            .attr("cy", cfg.yFunc(d));
	
	                        cfg.color && elem.style('fill', cfg.color);
	                    }
	                    dataIndex++;
	                });
	
	                return outerElem;
	            },
	            _getTickTextSize: function(textArray, cls, font) {
	                var width = 0,
	                    height = 0,
	                    temp,
	                    css = {
	                        display: 'inline-block'
	                    };
	                if (font) {
	                    css['font'] = font;
	                }
	                var span = $('<span></span>').appendTo(this.config.componentContainer).css(css).addClass(cls);
	                textArray.forEach(function(text) {
	                    span.html(text);
	                    var tempW, tempH;
	                    tempW = span.width();
	                    tempH = span.height();
	                    if (tempW > width) {
	                        width = tempW;
	                    }
	                    if (tempH > height) {
	                        height = tempH;
	                    }
	                })
	                span.remove();
	                return {
	                    width: width,
	                    height: height
	                };
	            },
	            _draw_lineLegend: function() {
	                var cfg = this.config;
	                var outerElem = this._commonDrawOuterElement();
	
	                var downArrow = [{
	                    x: 0,
	                    y: 0
	                }, {
	                    x: cfg.arrowWidth,
	                    y: 0
	                }, {
	                    x: cfg.arrowWidth,
	                    y: cfg.arrowHeight
	                }];
	
	                var tagArrow = outerElem.append('polygon')
	                    .attr('class', cfg.graphCss);
	                var tagRectangle = outerElem.append('rect')
	                    .attr('class', cfg.graphCss)
	                    .style('stroke', cfg.fillColor);
	                var tagText = outerElem.append('text')
	                    .attr("x", cfg.xPosition + cfg.sideMargin + cfg.arrowWidth)
	                    .text(cfg.tagText)
	                    .attr('class', cfg.graphCssText);
	                if (tagText[0][0]) {
	                    var legendTextSize = this._getTickTextSize([cfg.tagText], cfg.graphCssText);
	                    var legendTextWidth = legendTextSize.width;
	                    var legendTextHeight = legendTextSize.height;
	                    var tagWidth = legendTextWidth + cfg.sideMargin * 2 + cfg.arrowWidth;
	
	                    tagRectangle.attr("x", cfg.xPosition)
	                        .attr("y", cfg.yPosition - cfg.arrowHeight - legendTextHeight)
	                        .style('fill', cfg.fillColor)
	                        .style('stroke', cfg.fillColor)
	                        .attr("width", legendTextWidth + cfg.sideMargin * 2)
	                        .attr("height", legendTextHeight);
	
	                    var legendRectHeight = parseFloat(tagRectangle[0][0].attributes.height.value);
	                    if (legendRectHeight == 0) {
	                        legendRectHeight = 20;
	                    }
	
	                    tagText.attr("y", cfg.yPosition - legendRectHeight + cfg.textTopMargin);
	                    tagText.attr("x", cfg.xPosition + cfg.sideMargin - tagWidth);
	
	                    tagRectangle.attr("x", cfg.xPosition - tagWidth);
	
	                    downArrow.forEach(function(l) {
	                        l.x += cfg.xPosition - 2 * cfg.arrowWidth + 1;
	                        l.y += cfg.yPosition - cfg.arrowHeight;
	                    });
	
	                    tagArrow.style('fill', cfg.fillColor)
	                        .attr("points", downArrow.map(function(a) {
	                            return a.x + ',' + a.y;
	                        }).join(' '));
	                }
	
	                return outerElem;
	
	            },
	            _draw_tag: function() {
	                var cfg = this.config;
	                var outerElem = this._commonDrawOuterElement();
	                var tagArrow = outerElem.append('polygon')
	                    .attr('class', cfg.graphCss);
	
	                var tagRectangle = outerElem.append('rect')
	                    .attr('class', cfg.graphCss)
	                    .style('stroke', cfg.fillColor);
	
	                var sideMargin;
	                var tagText = outerElem.append('text')
	                    .text(cfg.tagText)
	                    .attr('class', cfg.graphCssText);
	                if (tagText[0][0]) {
	                    //Hardcoded width and height for FF and IE
	                    var legendTextSize = this._getTickTextSize([cfg.tagText], cfg.graphCssText);
	                    var legendTextWidth = legendTextSize.width;
	                    var legendTextHeight = legendTextSize.height;
	
	                    var tagRectWidth, sideMargin;
	                    if (cfg.tagWidth && cfg.tagWidth > legendTextWidth) {
	                        tagRectWidth = cfg.tagWidth;
	                        sideMargin = (tagRectWidth - legendTextWidth) / 2;
	                    } else {
	                        tagRectWidth = legendTextWidth + cfg.sideMargin * 2;
	                        sideMargin = cfg.sideMargin;
	                    }
	                    tagText.attr("x", cfg.xPosition + cfg.sideMargin + cfg.arrowWidth);
	                    var tagWidth = tagRectWidth + cfg.arrowWidth;
	                    var rightArrow, leftArrow;
	                    var rectangleYPos = cfg.yPosition;
	                    var rectangleHeight = cfg.tagHeight || legendTextHeight;
	                    var yVerticalMargin = cfg.yVerticalMargin || 3;
	                    var yPosAjust = 0;
	                    if (cfg.upward) {
	                        rectangleYPos -= rectangleHeight;
	                        if (rectangleYPos < yVerticalMargin) {
	                            yPosAjust = yVerticalMargin - rectangleYPos;
	                        }
	
	                        rectangleYPos += yPosAjust;
	                        rightArrow = [{
	                            x: 0,
	                            y: 0
	                        }, {
	                            x: cfg.arrowWidth,
	                            y: 0
	                        }, {
	                            x: 0,
	                            y: -cfg.arrowHeight
	                        }];
	                        leftArrow = [{
	                            x: 0,
	                            y: 0
	                        }, {
	                            x: cfg.arrowWidth,
	                            y: 0
	                        }, {
	                            x: cfg.arrowWidth,
	                            y: -cfg.arrowHeight
	                        }];
	                    } else {
	                        var rectangleBottomPos = (rectangleYPos + rectangleHeight + yVerticalMargin);
	                        if (rectangleBottomPos > cfg.height) {
	                            yPosAjust = rectangleBottomPos - cfg.height;
	                        }
	
	                        rectangleYPos -= yPosAjust;
	                        rightArrow = [{
	                            x: 0,
	                            y: 0
	                        }, {
	                            x: cfg.arrowWidth,
	                            y: 0
	                        }, {
	                            x: 0,
	                            y: cfg.arrowHeight
	                        }];
	                        leftArrow = [{
	                            x: 0,
	                            y: 0
	                        }, {
	                            x: cfg.arrowWidth,
	                            y: 0
	                        }, {
	                            x: cfg.arrowWidth,
	                            y: cfg.arrowHeight
	                        }];
	                    }
	
	                    tagRectangle.attr("x", cfg.xPosition + cfg.arrowWidth)
	                        .attr("y", rectangleYPos)
	                        .style('fill', cfg.fillColor)
	                        .style('stroke', cfg.fillColor)
	                        .attr("width", tagRectWidth)
	                        .attr("height", cfg.tagHeight || legendTextHeight);
	
	                    var legendRectHeight = parseFloat(tagRectangle[0][0].attributes.height.value);
	                    if (legendRectHeight == 0) {
	                        legendRectHeight = 20;
	                    }
	
	                    tagText.attr("y", rectangleYPos + legendRectHeight - cfg.textTopMargin + 3);
	                    if (tagWidth >= cfg.spaceOnRight) {
	                        tagText.attr("x", cfg.xPosition + sideMargin - tagWidth);
	                        tagRectangle.attr("x", cfg.xPosition - tagWidth);
	                        rightArrow.forEach(function(l) {
	                            l.x += cfg.xPosition - cfg.arrowWidth;
	                            l.y += cfg.yPosition;
	                        });
	
	                        tagArrow.style('fill', cfg.fillColor)
	                            .attr("points", rightArrow.map(function(a) {
	                                return a.x + ',' + a.y;
	                            }).join(' '));
	                    } else {
	                        leftArrow.forEach(function(l) {
	                            l.x += cfg.xPosition;
	                            l.y += cfg.yPosition;
	                        });
	
	                        tagArrow.style('fill', cfg.fillColor)
	                            .attr("points", leftArrow.map(function(a) {
	                                return a.x + ',' + a.y;
	                            }).join(' '));
	                    }
	                }
	                return outerElem;
	            },
	            _draw_event: function() {
	                var cfg = this.config;
	                var outerElem = this._commonDrawOuterElement();
	                if (cfg.data && cfg.data.length > 0) {
	                    cfg.data.forEach(function(d) {
	                        if (d.x >= 0) {
	                            var xPosition = cfg.xScale(d.x);
	
	                            outerElem
	                                .append("ellipse")
	                                .attr("cx", xPosition)
	                                .attr("cy", cfg.y0Value)
	                                .attr("rx", cfg.xRadious)
	                                .attr("ry", cfg.yRadious)
	                                .style('fill', d.upFlag === 0 ? cfg.downColor : cfg.color)
	                                .attr("class", cfg.graphCss);
	
	                            outerElem
	                                .append('text')
	                                .attr("x", xPosition)
	                                .attr("y", cfg.y0Value)
	                                .text(cfg.innerText)
	                                .attr('dy', cfg.dy)
	                                .attr('text-anchor', cfg.textAnchor)
	                                .style('fill', cfg.textColor)
	                                .attr("class", cfg.textClass);
	                        }
	                    });
	                }
	                return outerElem;
	            },
	            _draw_aboveBelow: function() {
	                var cfg = this.config;
	                var yClipValue = cfg.yScale(cfg.referValue);
	                var areaFunc = d3.svg.area()
	                    .x(cfg.xFunc)
	                    .y1(cfg.yFunc)
	                    .defined(cfg.definedFunc);
	
	                var outerElem = this._commonDrawOuterElement();
	                var datumData = this._processData(cfg.data, cfg.definedFunc, cfg.xAttributeName);
	
	                //Create above area
	                if (yClipValue >= 0) {
	                    if (yClipValue <= cfg.height) {
	                        outerElem.insert("clipPath", "path." + cfg.aboveAreaCss)
	                            .attr("id", cfg.aboveClipID)
	                            .append('rect')
	                            .attr('x', 0)
	                            .attr('y', 0)
	                            .attr('width', cfg.width)
	                            .attr('height', yClipValue);
	                    }
	                    outerElem.append("path").datum(datumData)
	                        .attr("class", cfg.aboveAreaCss)
	                        .style({
	                            stroke: "#" + cfg.ASColor,
	                            fill: "#" + cfg.AFColor
	                        })
	                        .attr("clip-path", "url(#" + cfg.aboveClipID + ")")
	                        .attr("d", areaFunc.y0(cfg.height));
	                }
	                //Create below area
	                if (yClipValue <= cfg.height) {
	                    outerElem.append("path").datum(datumData)
	                        .attr("class", cfg.belowAreaCss)
	                        .style({
	                            stroke: "#" + cfg.BSColor,
	                            fill: "#" + cfg.BFColor
	                        })
	                        .attr("clip-path", "url(#" + cfg.belowClipID + ")")
	                        .attr("d", areaFunc.y0(0));
	                        if (cfg.height - yClipValue >= 0 && yClipValue >= 0) {
	                            outerElem.insert("clipPath", "path." + cfg.belowAreaCss)
	                                .attr("id", cfg.belowClipID)
	                                .append('rect')
	                                .attr('x', 0)
	                                .attr('y', yClipValue)
	                                .attr('width', cfg.width)
	                                .attr('height', cfg.height - yClipValue);
	                        }
	                }
	
	                return outerElem;
	            },
	            _draw_ohlc: function() {
	                return this._commonDrawOHLC();
	            },
	            _draw_hlc: function() {
	                return this._commonDrawOHLC();
	            },
	            _draw_candlestick: function() {
	                var cfg = this.config;
	                var dataInDomain = this._commonGetDataInDomain(cfg.data, cfg.xScale);
	
	                var candlestickFunc = candlestickSeries().xScale(cfg.xScale).decimal(cfg.decimal)
	                    .yScale(cfg.yScale).getElementsMapping(cfg.getElementsMapping)
	                    .tickSize(this._caculateTickSize());
	
	                var outerElem = this._commonDrawOuterElement();
	                outerElem.datum(dataInDomain).call(candlestickFunc);
	
	                return outerElem;
	            },
	            _draw_gridLines: function() {
	                var cfg = this.config;
	                var grid = gridLines().setShowGridBlocks(cfg.showGridBlocks).setShowSolidGridLines(cfg.showSolidGridLines).xScale(cfg.xScale).yScale(cfg.yScale).yTicks(cfg.yTicks).xTicks(cfg.xTicks);
	                var outerElem = this._commonDrawOuterElement();
	                outerElem.call(grid);
	                return outerElem;
	            },
	            _draw_zoomDrag: function() {
	                var cfg = this.config;
	                var zoom = d3.behavior.zoom()
	                    .center([cfg.width, 0])
	                    .x(cfg.xScale)
	                    .on("zoomstart", function() {
	                        cfg.panStartCallback && cfg.panStartCallback(zoom);
	                    })
	                    .on("zoom", function() {
	                        cfg.panCallback && cfg.panCallback(zoom);
	                    })
	                    .on("zoomend", function() {
	                        cfg.panEndCallback && cfg.panEndCallback(zoom);
	                    });
	
	                var maxScale = cfg.data.length / 3;
	                var minScale = 0.5;
	                zoom.scaleExtent([minScale, maxScale]);
	
	                var outerElem = this._commonDrawOuterElement();
	
	                outerElem.append("rect")
	                    .attr("transform", "translate(" + (cfg.translateLeft || cfg.margin.left) + "," + cfg.margin.top + ")")
	                    .attr("class", cfg.zoomDragMaskCss)
	                    .attr("width", cfg.width)
	                    .attr("height", cfg.height)
	                    .call(zoom);
	
	                return outerElem;
	            },
	            _draw_histogram: function() {
	                var cfg = this.config;
	                var dataInDomain = this._commonGetDataInDomain(cfg.data, cfg.xScale);
	                var bars = barSeries().xScale(cfg.xScale)
	                    .yScale(cfg.yScale).width(cfg.width).height(cfg.height)
	                    .tickSize(this._caculateTickSize());
	
	                $.isNumeric(cfg.baseValue) && bars.baseValue(cfg.baseValue);
	                cfg.color && bars.color(cfg.color);
	                cfg.xAttributeName && bars.xAttributeName(cfg.xAttributeName);
	                cfg.yAttributeName && bars.yAttributeName(cfg.yAttributeName);
	                cfg.distinguish && bars.distinguish(cfg.distinguish);
	                cfg.getElementsMapping && bars.getElementsMapping(cfg.getElementsMapping);
	                var outerElem = this._commonDrawOuterElement();
	                outerElem.datum(dataInDomain).call(bars);
	                if (outerElem.selectAll("rect") &&
	                    outerElem.selectAll("rect")[0] &&
	                    outerElem.selectAll("rect")[0][0] &&
	                    $(outerElem.selectAll("rect")[0][0]).attr('x') < 0) {
	                    var xvalue = parseFloat($(outerElem.selectAll("rect")[0][0]).attr('x'));
	                    var width = parseFloat($(outerElem.selectAll("rect")[0][0]).attr('width'));
	                    $(outerElem.selectAll("rect")[0][0]).attr('x', 0).attr('width', width + xvalue);
	                }
	                return outerElem;
	            },
	            _draw_brush: function() {
	                var cfg = this.config;
	
	                var brushFunc = d3.svg.brush().x(cfg.xScale)
	                    .on("brushstart", brushStart).on("brush", onBrush).on("brushend", brushEnd);
	
	                cfg.setBrushFunc && cfg.setBrushFunc(brushFunc, this);
	
	                function brushStart() {
	                    cfg.brushStartResponseFunc && cfg.brushStartResponseFunc(brushFunc);
	                };
	
	                function onBrush() {
	                    cfg.brushResponseFunc && cfg.brushResponseFunc(brushFunc, this);
	                }
	
	                function brushEnd() {
	                    cfg.brushEndResponseFunc && cfg.brushEndResponseFunc(brushFunc);
	                };
	
	                var outerElem = this._commonDrawOuterElement();
	
	                outerElem.classed("x brush", true)
	                    .call(brushFunc);
	
	                outerElem.selectAll("rect")
	                    .attr("y", cfg.yValue)
	                    .attr("height", cfg.height);
	
	                function changeBrushExtent(newDomainValue, sender) {
	                    if (sender !== this) {
	                        outerElem.call(brushFunc.extent(newDomainValue));
	                        //.call(brushFunc.event);
	                    }
	                };
	
	                var brushImages = cfg.brushImages;
	                if (brushImages) {
	                    var brushImageIDPrefix = new Date().getTime();
	                    var resizeElems = outerElem.selectAll(".resize");
	
	                    resizeElems.append("image")
	                        .attr("id", function(d, i) {
	                            return brushImageIDPrefix + "-" + i;
	                        }).attr({
	                            "width": cfg.brushImagesWidth,
	                            "height": cfg.height,
	                            "x": cfg.brushImagesXAdjust,
	                            "y": 0,
	                            "xlink:href": function(d, i) {
	                                return brushImages[i];
	                            }
	                        });
	
	                    cfg.setExtentFunc && cfg.setExtentFunc(changeBrushExtent);
	                }
	
	                return outerElem;
	            },
	          _draw_axis: function () {
	            var cfg = this.config;
	
	            var axisFunc = d3.svg.axis().scale(cfg.scale).orient(cfg.orient);
	            cfg.tickSize && axisFunc.tickSize(cfg.tickSize);
	            cfg.ticks && axisFunc.ticks(cfg.ticks);
	            cfg.tickPadding && axisFunc.tickPadding(cfg.tickPadding);
	            cfg.tickValues && axisFunc.tickValues(cfg.tickValues);
	            cfg.tickFormatFunc && axisFunc.tickFormat(cfg.tickFormatFunc);
	
	            var outerElem = this._commonDrawOuterElement();
	            var translateValues;
	
	            function extendTickClass(ticks) {
	              ticks.each(function (d, i) {
	                var d3_this = d3.select(this);
	                if (i === 0) {
	                  d3_this.classed('tick-first', true);
	                } else if (i === ticks[0].length - 1) {
	                  d3_this.classed('tick-last', true);
	                } else {
	                  d3_this.classed('tick-middle', true);
	                }
	              });
	            }
	
	            function leftStyleFunc(elem) {
	              if (cfg.tick.line.show) {
	                elem.selectAll("line")
	                  .attr("x1", 0)
	                  .attr("x2", cfg.yAxisWidth)
	                  .style(cfg.tick.line.style);
	              } else {
	                elem.selectAll("line").style("display", "none");
	              }
	              extendTickClass(elem.selectAll(".tick"));
	
	              elem.selectAll("text").style("text-anchor", "start")
	                .attr("x", 0).attr("dy", "1em");
	              return elem;
	            };
	
	            function topStyleFunc(elem) {
	              extendTickClass(elem.selectAll(".tick"));
	              elem.selectAll("text").attr("x", 1).attr("y", -6);
	              elem.call(xAxisStyleFunc);
	              return elem;
	            };
	
	            function rightStyleFunc(elem) {
	              if (cfg.tick.line.show) {
	                elem.selectAll("line")
	                  .attr("x1", -cfg.yAxisWidth)
	                  .attr("x2", 0)
	                  .style(cfg.tick.line.style);
	              } else {
	                elem.selectAll("line").style("display", "none");
	              }
	              extendTickClass(elem.selectAll(".tick"));
	              elem.selectAll("text").style("text-anchor", "end")
	                .attr("x", 0).attr("dy", "1em");
	
	              return elem;
	            };
	
	            function bottomStyleFunc(elem) {
	              extendTickClass(elem.selectAll(".tick"));
	              elem.selectAll("text").attr("x", 1).attr("y", 1);
	              elem.call(xAxisStyleFunc);
	              return elem;
	            };
	
	            function xAxisStyleFunc(elem) {
	              var textEl = elem.selectAll("text");
	              if (cfg.xTickInfos && cfg.xTickInfos.tickLabels) {
	                var count = 0;
	                for (var x in cfg.xTickInfos.tickLabels) {
	                  d3.select(textEl[0][count]).style("text-anchor", cfg.xTickInfos.tickLabels[x].textAnchor);
	                  count++;
	                }
	              }
	              return elem;
	            }
	
	            var defaultStyleFunc;
	            var yAxisMargin = (isNaN(cfg.yAxisWidth) || !cfg.yAxisMargin) ? 0 : cfg.yAxisMargin;
	            var yAxisWidth = (isNaN(cfg.yAxisWidth) || !cfg.yAxisWidth) ? 0 : cfg.yAxisWidth;
	            yAxisMargin = parseInt(yAxisMargin, 10);
	
	            switch (cfg.orient) {
	              case "left":
	                if (cfg.position == "outer") {
	                  translateValues = [0, 0];
	                } else {
	                  translateValues = [0 + yAxisMargin, 0];
	                }
	                defaultStyleFunc = leftStyleFunc;
	                outerElem = cfg.yAxisContainerGElem || outerElem;
	                break;
	              case "top":
	                translateValues = [0, 0];
	                defaultStyleFunc = topStyleFunc;
	                break;
	              case "right":
	                if (cfg.position == "outer") {
	                  translateValues = [cfg.width + yAxisWidth + yAxisMargin, 0]
	                } else {
	                  translateValues = [cfg.width - yAxisMargin, 0];
	                }
	                defaultStyleFunc = rightStyleFunc;
	                outerElem = cfg.yAxisContainerGElem || outerElem;
	                break;
	              case "bottom":
	                translateValues = [0, cfg.height];
	                defaultStyleFunc = bottomStyleFunc;
	                break;
	            }
	
	            outerElem.classed("axis", true)
	              .attr("transform", "translate(" + translateValues[0] + "," + translateValues[1] + ")");
	
	            outerElem.style("display", "none");
	            outerElem.call(axisFunc).call(defaultStyleFunc);
	            if (cfg.orient == "right" || cfg.orient == "left") {
	              var ticksElems = outerElem.selectAll(".tick")[0];
	              if (ticksElems.length > 0) {
	                var $firstTickText = $(ticksElems[0]).find("text");
	                var textHeight = this._getTickTextSize([$firstTickText.text()], null, $firstTickText.css('font')).height;
	                $firstTickText.attr("y", -textHeight);
	                if (ticksElems.length > 1) {
	                  // If draw GrowthBaseValue label  we need sort the ticksElems.
	                  if (cfg.drawGrowthBaseValueLabel) {
	                    ticksElems.sort(function (pre, next) {
	                      return parseFloat(pre['textContent'].replace(/,/g, '')) - parseFloat(next['textContent'].replace(/,/g, ''));
	                    });
	                  }
	                  var $secondTick = $(ticksElems[1]);
	                  var firstTickY = d3.transform(d3.select(ticksElems[0]).attr("transform")).translate[1];
	                  var secondTickY = d3.transform(d3.select(ticksElems[1]).attr("transform")).translate[1];
	                  if (firstTickY - secondTickY < textHeight * 2) {
	                    $secondTick.find("text").attr("y", -textHeight);
	                  }
	                  // If draw GrowthBaseValue label  we need resort zero and  GrowthBaseValue label location.
	                  if (cfg.drawGrowthBaseValueLabel) {
	                    this._resortGrowthBaseValueLocation(ticksElems, textHeight);
	                  }
	                }
	              }
	            }
	            outerElem.style("display", "block");
	            if (cfg.graphCss === 'sliderChart-xAxis') {
	              var temp = outerElem.selectAll(".tick")[0], x, y;
	              temp.forEach(function (element) {
	                x = d3.transform(d3.select(element).attr("transform")).translate[0];
	                y = d3.transform(d3.select(element).attr("transform")).translate[1] + 3; //move text down 3 pixels so it doesn't touch the line above.
	                element.setAttribute('transform', 'translate(' + x + ',' + y + ')');
	              });
	            }
	            return outerElem;
	          },
	          /**
	           * Resort GrowthBaseValue label and zero YAxis label location.
	           * @param tickElements - The tick elements.
	           * @param textHeight - The text height.
	           * @private
	           */
	          _resortGrowthBaseValueLocation: function (tickElements, textHeight) {
	            if (!$.isArray(tickElements) || tickElements.length <= 0) {
	              throw new Error("The ticks elements should be array and the length must greater than 1.");
	            }
	            var zeroTickElement = d3.select(tickElements[0]);
	            var zeroTickY = d3.transform(zeroTickElement.attr("transform")).translate[1];
	            var secondTickY = d3.transform(d3.select(tickElements[1]).attr("transform")).translate[1];
	            if (zeroTickY - secondTickY < textHeight * 2) {
	              zeroTickElement.select("text").attr("y", 0);
	            }
	          },
	
	            _draw_volumeByPrice: function() {
	                var cfg = this.config;
	                var bars = volumeByPrice().yScale(cfg.yScale)
	                    .width(cfg.width).height(cfg.height)
	                    .totalVolume(cfg.totalVolume)
	                    .downColor(cfg.downColor)
	                    .upColor(cfg.upColor)
	                    .$container(cfg.$container);
	
	                cfg.langData && bars.langData(cfg.langData);
	                cfg.yAttributeName && bars.yAttributeName(cfg.yAttributeName);
	                var outerElem = this._commonDrawOuterElement();
	                outerElem.datum(cfg.data).call(bars);
	                cfg.setDrawObj && cfg.setDrawObj(bars);
	                return outerElem;
	            },
	            _processData: function(data, defined, xAttributeName) {
	                var ret = [];
	                var validDataPoint = {};
	                var l = data.length;
	                var maxValidIndex = l;
	                for (var i = l - 1; i >= 0; i--) {
	                    if (defined(data[i])) {
	                        maxValidIndex = i;
	                        break;
	                    }
	                }
	                for (var j = 0, d; j < l; j++) {
	                    d = data[j];
	                    if (defined(d)) {
	                        validDataPoint = d;
	                        ret.push(d);
	                    } else if (defined(validDataPoint) && j <= maxValidIndex) {
	                        var extDataPoint = {};
	                        extDataPoint[xAttributeName] = j;
	                        ret.push($.extend({}, validDataPoint, extDataPoint));
	                    } else {
	                        ret.push(d);
	                    }
	                }
	                return ret;
	            }
	        };
	
	        return commonPlotter;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        'use strict';
	
	        var GraphTypes = {
	            Line: "line",
	            Area: "area",
	            Dot: "dot",
	            AboveBelow: "aboveBelow",
	            OHLC: "ohlc",
	            HLC: "hlc",
	            Candlestick: "candlestick",
	            DividendEffect: "dividendEffect",
	            Growth: "growth",
	            TenKGrowth: "tenKGrowth",
	            GridLines: "gridLines",
	            GridBlocks: "gridBlocks",
	            ZoomDrag: "zoomDrag",
	            Histogram: "histogram",
	            Brush: "brush",
	            Axis: "axis",
	            Event: "event",
	            VBP: "volumeByPrice",
	            Tag: "tag",
	            LineLegend: "lineLegend"
	        };
	
	        return GraphTypes;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (core) {
	    "use strict";
	    var $ = core.$;
	    var d3 = core.d3;
	    function barSeries() {
	        var xScale, yScale;
	        var tickSize = 5;
	        var width, viewHeight, halfViewHeight;
	        var baseValue;
	        var xValueFunc, yValueFunc, heightFunc;
	        var isUp, isDown;
	        var xAttributeName, yAttributeName = "volume";
	        var dataIndex = 0;
	        var barColor;
	        var distinguish = false;
	        var getElementsMapping;
	
	        var drawRectangle = function (bar) {
	            var rect = bar.select("rect");
	            if (rect.empty()) {
	                rect = bar.append('rect');
	            }
	
	            rect.attr("x", xValueFunc)
	                .attr("y", yValueFunc)
	                .attr("width", tickSize)
	                .attr("height", heightFunc);
	        };
	
	        /*var zoom = d3.behavior.zoom()
	            .x(xScale)
	            .scaleExtent([1, 50])
	            .on('zoom', zoomed)
	            .on('zoomend', zoomend);*/
	
	        var bar = function (selection) {
	            var series, bar;
	            xValueFunc = function (d) {
	                return xScale(d[xAttributeName]) - tickSize / 2;
	            };
	
	            if ($.isNumeric(baseValue)) {
	                isUp = function (d) {
	                    return d[yAttributeName] > baseValue;
	                };
	
	                isDown = function (d) {
	                    return !isUp(d);
	                };
	
	                var baseY = yScale(baseValue);
	                yValueFunc = function (d) {
	                    var yValue;
	                    if (isUp(d)) {
	                        yValue = yScale(d[yAttributeName]);
	                    }
	                    else {
	                        yValue = baseY;
	                    }
	
	                    return yValue;
	                };
	
	                heightFunc = function (d) {
	                    var height;
	                    if (isUp(d)) {
	                        height = baseY - yScale(d[yAttributeName]);
	                    }
	                    else {
	                        height = yScale(d[yAttributeName]) - baseY;
	                    }
	
	                    return height;
	                };
	            }
	            else {
	                isUp = function (d) {
	                    return d.upFlag;
	                };
	
	                isDown = function (d) {
	                    return d.upFlag;
	                };
	
	                yValueFunc = function (d) {
	                    return yScale(d[yAttributeName]);
	                };
	
	                heightFunc = function (d) {
	                    return viewHeight - yScale(d[yAttributeName]);
	                };
	            }
	
	            var isDown = function (d) {
	                return !isUp(d);
	            };
	
	            selection.each(function (dataArr) {
	                if (!xAttributeName) {
	                    xAttributeName = "_x";
	                    dataArr.forEach(function (dataItem, index) {
	                        dataItem[xAttributeName] = index;
	                    });
	                }
	
	                var d3_this = d3.select(this);
	                var outerElem = d3_this.select(".bar-series");
	                if (outerElem.empty()) {
	                    outerElem = d3_this.append("g").classed("bar-series", true);
	                }
	
	                var barGraphs = outerElem.selectAll(".bar")[0];
	                var graphIndex = 0;
	                var indexElementsMapping = {};
	                dataArr.forEach(function (dataItem, dataIndex) {
	                    if (!isNaN(dataItem[yAttributeName]) && (dataItem[yAttributeName] !== 0)) {
	                        bar = barGraphs[graphIndex++];
	                        if (bar) {
	                            bar = d3.select(bar);
	                        } else {
	                            bar = outerElem.append("g").classed("bar", true);
	                        }
	
	                        bar.data([dataItem]);
	                        if (distinguish || $.isNumeric(baseValue)) {
	                            bar.classed({ "up": isUp, "down": isDown });
	                        } else {
	                            bar.classed({ "up": false, "down": false });
	                        }
	
	                        drawRectangle(bar);
	                        indexElementsMapping[dataIndex] = bar;
	                    }
	                });
	
	                barGraphs = outerElem.selectAll(".bar")[0];
	                if (barGraphs.length > graphIndex) {
	                    var nativeParentDom = outerElem[0][0];
	                    for (var i = graphIndex; i < barGraphs.length; i++) {
	                        nativeParentDom.removeChild(barGraphs[i]);
	                    }
	                }
	
	                getElementsMapping && getElementsMapping(indexElementsMapping);
	            });
	
	            barColor && selection.selectAll("rect").style({ 'fill': barColor });
	        };
	
	        //bar.zoom = function (selection) {
	        //    var xDomain = xScale.domain();
	        //    var xRange = xScale.range();
	        //    var translate = zoom.translate()[0];
	        //}
	
	        bar.xScale = function (value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return bar;
	        };
	
	        bar.yScale = function (value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return bar;
	        };
	
	        bar.tickSize = function (value) {
	            if (!arguments.length) {
	                return tickSize;
	            }
	            tickSize = value;
	            return bar;
	        };
	
	        bar.width = function (value) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = value;
	            return bar;
	        };
	
	        bar.height = function (value) {
	            if (!arguments.length) {
	                return viewHeight;
	            }
	            viewHeight = value;
	            halfViewHeight = viewHeight / 2;
	            return bar;
	        };
	
	        bar.baseValue = function (value) {
	            if (!arguments.length) {
	                return baseValue;
	            }
	            baseValue = +value;
	            return bar;
	        };
	
	        bar.color = function (value) {
	            if (!arguments.length) {
	                return barColor;
	            }
	            barColor = value;
	            return bar;
	        };
	
	        bar.xAttributeName = function (value) {
	            if (!arguments.length) {
	                return xAttributeName;
	            }
	            xAttributeName = value;
	            return bar;
	        };
	
	        bar.yAttributeName = function (value) {
	            if (!arguments.length) {
	                return yAttributeName;
	            }
	            yAttributeName = value;
	            return bar;
	        };
	
	        bar.distinguish = function (value) {
	            if (!arguments.length) {
	                return distinguish;
	            }
	            distinguish = value;
	            return bar;
	        };
	
	        bar.getElementsMapping = function (value) {
	            if (!arguments.length) {
	                return getElementsMapping;
	            }
	            getElementsMapping = value;
	            return bar;
	        };
	
	        return bar;
	    }
	    return barSeries;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (core) {
	    "use strict";
	    function barSeries() {
	        var $ = core.$;
	        var d3 = core.d3;
	        var xScale, yScale;
	        var margeValue = 1;
	        var width, volumeByPriceScale = 0.4;
	        var totalVolume;
	        var xValueFunc, yValueFunc, heightFunc;
	        var yAttributeName = "volume";
	        var dataIndex = 0;
	        var downColor, upColor;
	        var data, $tipElement, $tipContent, tipHeight = 20;
	        var langData, $container;
	
	        var drawRectangle = function (barGraph) {
	            var rect = barGraph.append('rect')
	                .classed("up", true)
	                .attr("x", 0)
	                .attr("y", function (d) {
	                    return yScale(d.range[1]) - margeValue;
	                })
	                .attr("width", function (d) {
	                    return xScale(d.upVolume);
	                })
	                .attr("height", function (d) {
	                    return yScale(d.range[0]) - yScale(d.range[1]) - 2 * margeValue;
	                });
	
	            var rect = barGraph.append('rect')
	                .classed("down", true)
	                .attr("x", function (d) {
	                    return xScale(d.upVolume);
	                })
	                .attr("y", function (d) {
	                    return yScale(d.range[1]) - margeValue;
	                })
	                .attr("width", function (d) {
	                    return xScale(d.downVolume);
	                })
	                .attr("height", function (d) {
	                    return yScale(d.range[0]) - yScale(d.range[1]) - 2 * margeValue;
	                });
	        };
	
	        var createTipElement = function () {
	            $tipElement = $container.find(".chart-vbp-tip");
	            if ($tipElement.length === 0) {
	                $tipElement = $('<div class="chart-vbp-tip"><div class="chart-vbp-content"></div></div>').appendTo($container);
	            }
	
	            $tipContent = $tipElement.find(".chart-vbp-content").css("height", tipHeight);
	        }
	
	        var displayTip = function (dataItem, offsetTop, offsetLeft) {
	            $tipElement || createTipElement();
	            var priceRange = dataItem.range
	            var tipViticalCenter = yScale((priceRange[1] - priceRange[0]) / 2 + priceRange[0]);
	            $tipElement.css("top", (tipViticalCenter - tipHeight / 2 + offsetTop));
	            var totalVolume = dataItem.totalVolume;
	            $tipElement.css("left", (xScale(totalVolume) + 2 + offsetLeft));
	
	
	            $tipContent.text(langData['volume'] + ": " + totalVolume + " | " + langData['range'] + ": " + priceRange[0].toFixed(2) + " - " + priceRange[1].toFixed(2));
	            $tipElement.show();
	        }
	
	        var bar = function (selection) {
	            data = selection.datum();
	            xScale = d3.scale.linear()
	                    .range([0, width * volumeByPriceScale])
	                    .domain([0, totalVolume]);
	
	            var barGraph;
	            selection.each(function (dataArr) {
	                var outerElem = d3.select(this).append("g").classed("bar-series", true);
	
	                dataArr.forEach(function (dataItem) {
	                    barGraph = outerElem.append("g").data([dataItem])
	                        .classed("bar", true);
	
	                    drawRectangle(barGraph);
	                });
	            });
	
	            downColor && selection.selectAll("rect.down").style({ 'fill': downColor });
	            upColor && selection.selectAll("rect.up").style({ 'fill': upColor });
	        };
	
	        bar.hideTipElement = function () {
	            $tipElement && $tipElement.hide();
	        };
	
	        bar.tipProcess = function (position, offsetTop, offsetLeft) {
	            offsetLeft = offsetLeft || 0;
	            var x = position[0] - (offsetLeft || 0 ) ;
	            if (x > (width * volumeByPriceScale + 3)) {
	                bar.hideTipElement();
	                return;
	            }
	
	            var mousePrice = yScale.invert(position[1]);
	            var dataItem, priceRange;
	            for (var i = 0, len = data.length; i < len; i++) {
	                priceRange = data[i].range;
	                if (mousePrice > priceRange[0] && mousePrice < priceRange[1]) {
	                    dataItem = data[i];
	                    break;
	                }
	            }
	
	            if (dataItem && (xScale.invert(x) < dataItem.totalVolume)) {
	                displayTip(dataItem, offsetTop, offsetLeft);
	            }
	            else {
	                bar.hideTipElement();
	            }
	        };
	
	        bar.yScale = function (value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return bar;
	        };
	
	        bar.width = function (value) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = value;
	            return bar;
	        };
	
	        bar.height = function (value) {
	            return bar;
	        };
	
	        bar.downColor = function (value) {
	            if (!arguments.length) {
	                return downColor;
	            }
	            downColor = value;
	            return bar;
	        };
	
	        bar.upColor = function (value) {
	            if (!arguments.length) {
	                return upColor;
	            }
	            upColor = value;
	            return bar;
	        };
	
	        bar.yAttributeName = function (value) {
	            if (!arguments.length) {
	                return yAttributeName;
	            }
	            yAttributeName = value;
	            return bar;
	        };
	
	        bar.totalVolume = function (value) {
	            if (!arguments.length) {
	                return totalVolume;
	            }
	            totalVolume = value;
	            return bar;
	        };
	
	        bar.langData = function (value) {
	            if (!arguments.length) {
	                return langData;
	            }
	            langData = value;
	            return bar;
	        };
	
	        bar.$container = function (value) {
	            if (!arguments.length) {
	                return $container;
	            }
	            $container = value;
	            return bar;
	        };
	
	        return bar;
	    }
	    return barSeries;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (core) {
	    "use strict";
	    var d3 = core.d3;
	
	    function candlestickSeries() {
	        var xScale, yScale;
	        var cacheData, cacheScale;
	        var tickSize = 5;
	        var width;
	        var decimal;
	        var xAttributeName, yAttributeName = "close";
	        var getElementsMapping;
	        var toFormatVal = function (d) {
	            return +Number(d).toFixed(decimal);
	        };
	        var isUpDay = function (d) {
	            return toFormatVal(d.close) > toFormatVal(d.open);
	        };
	
	        var isDownDay = function (d) {
	            return !isUpDay(d);
	        };
	        
	        var  comparePreclose = function (d) {
	            return toFormatVal(d.close) >= toFormatVal(d.previousColse);
	        }
	
	        var isDownFill = function (d) {
	            return !comparePreclose(d) && isDownDay(d);
	        }
	
	        var isDownEmpty = function (d) {
	            return !comparePreclose(d) && isUpDay(d);
	        }
	        var isUpEmpty = function (d) {
	            return comparePreclose(d) && isUpDay(d);
	        }
	        var isUpFill = function (d) {
	            return comparePreclose(d) && isDownDay(d);
	        }
	
	        var line = d3.svg.line()
	            .x(function (d) {
	                return d.x;
	            })
	            .y(function (d) {
	                return d.y;
	            });
	
	        var highLowLines = function (bar) {
	            var paths = bar.append("path")
	                .classed({ "high-low-line": true })
	                .attr("d", function (d) {
	                    var x = xScale(d[xAttributeName]);
	                    return line([
	                        { x: x, y: yScale(d.high) },
	                        { x: x, y: yScale(d.low) }
	                    ]);
	                });
	        };
	
	        var rectangles = function (bar) {
	            var rect = bar.append('rect')
	                .attr("x", function (d) { return xScale(d[xAttributeName]) - tickSize / 2; })
	                .attr("y", function (d) { return isUpDay(d) ? yScale(d.close) : yScale(d.open); })
	                .attr("width", tickSize)
	                .attr("height", function (d) {
	                    return Math.max(0.5, isUpDay(d) ? (yScale(toFormatVal(d.open)) - yScale(toFormatVal(d.close))) : (yScale(toFormatVal(d.close)) - yScale(toFormatVal(d.open))));
	                });
	        };
	
	        /*var zoom = d3.behavior.zoom()
	            .x(xScale)
	            .scaleExtent([1, 50])
	            .on('zoom', zoomed)
	            .on('zoomend', zoomend);*/
	
	        var candlestick = function (selection) {
	            var outerElem, bar;
	
	            selection.each(function (dataArr) {
	                //cacheData = data;  ??
	                //cacheScale = yScale.copy();
	                if (!xAttributeName) {
	                    xAttributeName = "_x";
	                    dataArr.forEach(function (dataItem, index) {
	                        dataItem[xAttributeName] = index;
	                    });
	                }
	
	                outerElem = d3.select(this).append("g").classed("candlestick-series", true);
	                var indexElementsMapping = {};
	                dataArr.forEach(function (dataItem, dataIndex) {
	                    if (!isNaN(dataItem[yAttributeName])) {
	                        var bar = outerElem.append("g").data([dataItem])
	                            .classed({
	                                "bar": true,
	                                "up": isUpEmpty,
	                                "down": isDownFill,
	                                "down-empty": isDownEmpty,
	                                "up-fill": isUpFill,
	                            });
	
	                        highLowLines(bar);
	                        rectangles(bar);
	                        indexElementsMapping[dataIndex] = bar;
	                    }
	                });
	
	                getElementsMapping && getElementsMapping(indexElementsMapping);
	            });
	        };
	
	        //candlestick.zoom = function (selection) {
	        //    var xDomain = xScale.domain();
	        //    var xRange = xScale.range();
	        //    var translate = zoom.translate()[0];
	        //}
	
	        candlestick.xScale = function (value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return candlestick;
	        };
	
	        candlestick.decimal = function(value){
	            if (!arguments.length) {
	                return decimal;
	            }
	            decimal = value;
	            return candlestick;
	        };
	        candlestick.yScale = function (value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return candlestick;
	        };
	
	        candlestick.tickSize = function (value) {
	            if (!arguments.length) {
	                return tickSize;
	            }
	            tickSize = value;
	            return candlestick;
	        };
	
	        candlestick.width = function (value) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = value;
	            return candlestick;
	        };
	
	
	        candlestick.xAttributeName = function (value) {
	            if (!arguments.length) {
	                return xAttributeName;
	            }
	            xAttributeName = value;
	            return candlestick;
	        };
	
	        candlestick.yAttributeName = function (value) {
	            if (!arguments.length) {
	                return yAttributeName;
	            }
	            yAttributeName = value;
	            return candlestick;
	        };
	
	        candlestick.getElementsMapping = function (value) {
	            if (!arguments.length) {
	                return getElementsMapping;
	            }
	            getElementsMapping = value;
	            return candlestick;
	        };
	
	        return candlestick;
	    }
	
	    return candlestickSeries;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (core) {
	    "use strict";
	    var d3 = core.d3;
	
	    return function () {
	        var xScale, yScale, xTicks, yTicks;
	        var showGridBlocks = false;
	        var showSolidGridLines = false;
	        var blockXArray = [], blockYArray=[];
	
	        var drawRectangle = function (bar, x, width, height) {
	            var rect = bar.select("rect");
	            if (rect.empty()) {
	                rect = bar.append('rect');
	            }
	            rect.attr("x", x)
	                .attr("y", 0)
	                .attr("width", width)
	                .attr("height", height);
	        };
	
	        var drawBackgroudByxTickData = function(scope, xTickData, yTickData){
	            var outerElem, bar;
	
	            for (var i = 0; i < xTickData.length; i++) {
	                outerElem = d3.select(scope);
	                bar = outerElem.append("g").data(xTickData)
	                    .classed({
	                        "gridBlock": true,
	                    });
	
	                var x = blockXArray[i];
	                var width = (blockXArray[i+1]?blockXArray[i+1]:10000) - blockXArray[i];
	                var height = blockYArray[i];
	                drawRectangle(bar, x, width, height);
	            };
	        };
	
	
	        var xLines = function (data, grid) {
	            var xlines = grid.selectAll(".grid-x").data(data);
	            xlines.enter().append("line");
	            xlines.attr({
	                "class": "grid-x",
	                "x1": function (d) {
	                    var xValue = xScale(d);
	                    blockXArray.push(xValue);
	                    return xValue;
	                },
	                "x2": function (d) {
	                    return xScale(d);
	                },
	                "y1": function(){
	                    var yValue = yScale.range()[0];
	                    blockYArray.push(yValue);
	                    return yValue;
	                },
	                "y2": yScale.range()[1]
	            });
	
	            xlines.exit().remove();
	        };
	
	        var yLines = function (data, grid) {
	            var ylines = grid.selectAll('.grid-y').data(data);
	
	            ylines.enter()
	                .append('line')
	                .attr({
	                    'class': 'grid-y',
	                    'x1': xScale.range()[0],
	                    'x2': xScale.range()[1],
	                    'y1': function (d) {
	                        return yScale(d);
	                    },
	                    'y2': function (d) {
	                        return yScale(d);
	                    }
	                });
	        };
	
	        var gridlines = function (selection) {
	            var grid, xTickData, yTickData;
	            selection.each(function () {
	                xTickData = xTicks ? (Array.isArray(xTicks) ? xTicks : xScale.ticks(xTicks)) : xScale.ticks();
	                yTickData = yTicks ? (Array.isArray(yTicks) ? yTicks : yScale.ticks(yTicks)) : yScale.ticks();
	                grid = d3.select(this).selectAll('.gridlines').data([[xTickData, yTickData]]);
	                grid.enter().append('g').classed('gridlines', true);
	                xLines(xTickData, grid);
	                yLines(yTickData, grid);
	                if( showGridBlocks ){
	                    grid.classed('hideXGrids', true);
	                    if( xTickData.length >3) {
	                        drawBackgroudByxTickData(this, xTickData, yTickData);
	                    }
	                } else {
	                    grid.classed('gridlines', true);
	                }
	                if(showSolidGridLines){
	                    grid.classed('solidGridLines', true);
	                }
	            });
	            
	        };
	
	        gridlines.xScale = function (value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return gridlines;
	        };
	
	        gridlines.yScale = function (value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return gridlines;
	        };
	
	        gridlines.xTicks = function (value) {
	            if (!arguments.length) {
	                return xTicks;
	            }
	            xTicks = value;
	            return gridlines;
	        };
	
	        gridlines.yTicks = function (value) {
	            if (!arguments.length) {
	                return yTicks;
	            }
	            yTicks = value;
	            return gridlines;
	        };
	
	        gridlines.setShowGridBlocks = function (value) {
	            if (!arguments.length) {
	                return showGridBlocks;
	            }
	            showGridBlocks = value;
	            return gridlines;
	        };
	
	        gridlines.setShowSolidGridLines = function (value) {
	            if (!arguments.length) {
	                return showSolidGridLines;
	            }
	            showSolidGridLines = value;
	            return gridlines;
	        };
	
	        return gridlines;
	    }
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = function (core, graphTypes) {
	    "use strict";
	    var d3 = core.d3;
	
	    return function () {
	        var xScale, yScale;
	        var tickSize = 5;
	        var barType;
	        var isHLC = false;
	        var xAttributeName, yAttributeName = "close";
	        var getElementsMapping;
	        var isUpDay = function (d) {
	            return d.close > d.open;
	        };
	
	        var isDownDay = function (d) {
	            return !isUpDay(d);
	        };
	
	        var line = d3.svg.line()
	            .x(function (d) { return d.x; })
	            .y(function (d) { return d.y; });
	
	        var highLowLines = function (bar) {
	            bar.append("path")
	                .classed("high-low-line", true)
	                .attr("d", function (d) {
	                    var x = xScale(d[xAttributeName]);
	                    return line([
	                        { x: x, y: yScale(d.high) },
	                        { x: x, y: yScale(d.low) }
	                    ]);
	                });
	        };
	
	        var openTicks = function (bar) {
	            bar.append("path").classed("open-tick", true)
	                .attr("d", function (d) {
	                    var x = xScale(d[xAttributeName]);
	                    var x1, x2;
	                    x1 = x - tickSize;
	                    x2 = x;
	                    var y = yScale(d.open);
	                    return line([
	                        { x: x1, y: y },
	                        { x: x2, y: y }
	                    ]);
	                });
	        };
	
	        var closeTicks = function (bar) {
	            var close = bar.append("path").classed("close-tick", true)
	                .attr("d", function (d) {
	                    var x = xScale(d[xAttributeName]);
	                    var x1, x2;
	                    x1 = x;
	                    x2 = x + tickSize;
	                    var y = yScale(d.close);
	                    return line([
	                        { x: x1, y: y },
	                        { x: x2, y: y }
	                    ]);
	                });
	        }
	
	        var ohlc = function (selection) {
	            var series, bar;
	
	            selection.each(function (dataArr) {
	                if (!xAttributeName) {
	                    xAttributeName = "_x";
	                    dataArr.forEach(function (dataItem,index) {
	                        dataItem[xAttributeName] = index;
	                    });
	                }
	                var outerElem = d3.select(this).append("g").classed("ohlc-series", true);
	                var indexElementsMapping = {};
	                dataArr.forEach(function (dataItem, dataIndex) {
	                    if (!isNaN(dataItem[yAttributeName])) {
	                        bar = outerElem.append("g").data([dataItem])
	                            .classed({
	                                "bar": true,
	                                "up-day": isUpDay,
	                                "down-day": isDownDay
	                            });
	
	                        highLowLines(bar);
	
	                        if (barType === graphTypes.OHLC) {
	                            openTicks(bar);
	                        }
	                        closeTicks(bar);
	                        indexElementsMapping[dataIndex] = bar;
	                    }
	                });
	
	                getElementsMapping && getElementsMapping(indexElementsMapping);
	            });
	        };
	
	        ohlc.xScale = function (value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return ohlc;
	        };
	
	        ohlc.yScale = function (value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return ohlc;
	        };
	
	        ohlc.tickSize = function (value) {
	            if (!arguments.length) {
	                return tickSize;
	            }
	            tickSize = value/2;
	            return ohlc;
	        };
	
	        ohlc.type = function (value) {
	            if (!arguments.length) {
	                return barType;
	            }
	            barType = value;
	            return ohlc;
	        };
	
	        ohlc.xAttributeName = function (value) {
	            if (!arguments.length) {
	                return xAttributeName;
	            }
	            xAttributeName = value;
	            return ohlc;
	        };
	
	        ohlc.yAttributeName = function (value) {
	            if (!arguments.length) {
	                return yAttributeName;
	            }
	            yAttributeName = value;
	            return ohlc;
	        };
	
	        ohlc.getElementsMapping = function (value) {
	            if (!arguments.length) {
	                return getElementsMapping;
	            }
	            getElementsMapping = value;
	            return ohlc;
	        };
	
	        return ohlc;
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(9), __webpack_require__(8), __webpack_require__(3),
	        __webpack_require__(16), __webpack_require__(17), __webpack_require__(13), __webpack_require__(18), __webpack_require__(19)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(graphTypes, commonPlotter, core, baseView, util, gridLines, exportService, moment) {
	        "use strict";
	        var $ = core.$;
	        var d3 = core.d3;
	        var coreUtil = core.Util;
	        var dateUtil = core.Widget.Chart.Util;
	        var model = function(managers) {
	            var eventManager = managers.eventManager;
	            var chartConfigManager = managers.chartConfigManager;
	            var IntervalTypes = chartConfigManager.IntervalTypes;
	            var CursorType = chartConfigManager.CursorType;
	            var FrequencyTypes = chartConfigManager.FrequencyTypes;
	            var VerticalScaleTypes = chartConfigManager.VerticalScaleTypes;
	            var MainChartTypes = chartConfigManager.MainChartTypes;
	            var MainDataTypes = chartConfigManager.MainDataTypes;
	            var dataAdapter = managers.dataAdapter;
	            var SelectionModes = chartConfigManager.SelectionModes;
	            var StartDateTypes = chartConfigManager.StartDateTypes;
	            var isMobile = util.deviceType.mobile();
	            var getDateFormat = function() {
	                var format;
	                var rootConfig = chartConfigManager.getConfig();
	                if (chartConfigManager.isIntraday()) {
	                    format = rootConfig.intradayDateFormater;
	                } else {
	                    format = rootConfig.dailyDateFormatter;
	                }
	                return format;
	            };
	            /**
	             *   Base chart Model
	             *   It extended from baseView.
	             */
	            var baseChartExtend = {
	                _init: function() {
	                    this._bindEvents();
	                    this.decimalPlaces = this._getDecimalPlaces();
	                },
	                _generateRowArray: function(tickerObject, dataPoints, priceData, indicatorsData, fundamentalsData, eventsData) {
	                    var header = this._getExportColumnHeaders(dataPoints, tickerObject);
	                    var rowArray = [header];
	                    var rootConfig = chartConfigManager.getConfig();
	                    for (var i = 0; i < this._data.length; i++) {
	                        var row = '';
	                        for (var j = 0; j < dataPoints.length; j++) {
	                            var dp = dataPoints[j];
	                            var value = '';
	                            if (priceData[i]) {
	                                switch (dp.toLowerCase()) {
	                                    case 'close':
	                                        value = priceData[i].close;
	                                        break;
	                                    case 'open':
	                                        value = priceData[i].open;
	                                        break;
	                                    case 'high':
	                                        value = priceData[i].high;
	                                        break;
	                                    case 'low':
	                                        value = priceData[i].low;
	                                        break;
	                                    case 'volume':
	                                        value = priceData[i].volume;
	                                        break;
	                                    case 'growth':
	                                    case 'price':
	                                    case 'nav':
	                                        value = priceData[i][this.yAttr];
	                                        break;
	                                    case '10kgrowth':
	                                        value = priceData[i].value || priceData[i].close;
	                                        break;
	                                    case 'originalprice':
	                                        value = priceData[i].originalPrice || priceData[i].close;
	                                        break;
	                                    default: {
	                                        break;
	                                    }
	                                }
	                            }
	                            if (/^indicator/.test(dp)) {
	                                var indicatorName = dp.split(':')[1];
	                                var parameter = dp.match(/(\S*)_(\S*):(\S*)/) && dp.match(/(\S*)_(\S*):(\S*)/)[2];
	                                var indicatorData;
	                                if (!parameter) {
	                                    indicatorData = indicatorsData[indicatorName][0].data;
	                                } else {
	                                    $.each(indicatorsData[indicatorName], function(index, dataObj) {
	                                        if (parameter == dataObj.parameter) {
	                                            indicatorData = dataObj.data;
	                                        }
	                                    });
	                                }
	                                value = indicatorData[i] && indicatorData[i].value;
	                            } else if (/^fundamental/.test(dp)) {
	                                var fundamentalName = dp.split(':')[1];
	                                if (fundamentalsData && fundamentalsData[fundamentalName]) {
	                                    value = fundamentalsData[fundamentalName].data && fundamentalsData[fundamentalName].data[i] && fundamentalsData[fundamentalName].data[i].value;
	                                }
	                            }
	                            value = isNaN(value) ? '' : util.numberFormatter(this.config.lang, value, this._decimalPlaces, " ", false, rootConfig.isFormat, true);
	                            if (dp === 'time') {
	                                value = moment(this._data[i].date).format(getDateFormat());
	                            } else if (dp === 'name') {
	                                value = tickerObject['customTickerName'] || tickerObject['Name'] || '';
	                            }
	                            if (value.indexOf(',') > -1 || value.indexOf('\n') > -1 || value.indexOf('\r') > -1) {
	                                value = '"' + value + '"';
	                            }
	                            row += value + rootConfig.columnDelimiter;
	                        }
	                        rowArray.push(row);
	                    }
	                    return rowArray;
	                },
	                _exportDataToExcel: function() {
	                    var dataPoints = this._getExportDataPoints()
	                    var priceData = [],
	                        indicatorsData = [],
	                        fundamentalsData = [],
	                        eventsData = [],
	                        rowData = [];
	                    var mainDataPoints = dataPoints[this._getUniqueKey(this.mainTickerObject)];
	                    priceData = this._data;
	                    indicatorsData = this._indicatorsData;
	                    fundamentalsData = this._fundamentalsData;
	                    eventsData = this._eventsData;
	                    rowData.push(this._generateRowArray(this.mainTickerObject, mainDataPoints, priceData, indicatorsData, fundamentalsData, eventsData));
	                    if (this._compareData && chartConfigManager.getConfig().growthType !== 'priceGrowth' && chartConfigManager.getConfig().growthType !== 'performancesGrowth') {
	                        for (var i = 0; i < this._compareData.length; i++) {
	                            var compareData = this._compareData[i];
	                            var compareDataPoints = dataPoints[this._getUniqueKey(compareData.tickerObject)];
	                            priceData = this._compareData[i].Price.data;
	                            indicatorsData = this._compareData[i].Indicators;
	                            fundamentalsData = this._compareData[i].Fundamentals;
	                            eventsData = this._compareData[i].eventsData;
	                            rowData.push(this._generateRowArray(compareData.tickerObject, compareDataPoints, priceData, indicatorsData, fundamentalsData, eventsData));
	                        }
	                    }
	                    exportService.createFile(this.config.container, {
	                        rowData: rowData,
	                        fileName: this._getLegendText(this.mainTickerObject),
	                        delimiter: chartConfigManager.getConfig().columnDelimiter
	                    });
	                },
	                _getExportDataPoints: function() {
	                    var exportDPMap = {
	                        'price': ['time', 'name', 'close', 'high', 'low', 'open'],
	                        'nav': ['time', 'name', 'nav'],
	                        'return': ['time', 'name', 'growth'],
	                        'return_k': ['time', 'name', '10KGrowth']
	                    };
	                    var dataPoints = {};
	                    var tickerCollection = chartConfigManager.getTickerCollection();
	                    var type = parseInt(this.mainTickerObject.type, 10);
	                    var mType = this.mainTickerObject.mType;
	                    var priceType = chartConfigManager.getPriceType(tickerCollection);
	                    var mainDps = exportDPMap[priceType] || [];
	                    var config = chartConfigManager.getConfig();
	                    if (config.showCrosshairOriginalData && !(chartConfigManager.isITFund(this.mainTickerObject) && priceType === 'return') || config.growthType == "performancesGrowth" || config.growthType === 'priceGrowth') {
	                        mainDps = ['time', 'name', 'originalPrice'];
	                    }
	                    if (type !== 20 && !chartConfigManager.isMutualFund(this.mainTickerObject)) {
	                        mainDps.push('volume');
	                    }
	                    for (var indic in this._indicatorsData) {
	                        var indicData = this._indicatorsData[indic] || [];
	                        switch (indic) {
	                            case 'RSI':
	                            case 'PChannel':
	                            case 'DMI':
	                                indicData = indicData.slice(0, 1);
	                                break;
	                            case 'SStochastic':
	                            case 'FStochastic':
	                                indicData = indicData.slice(0, 2);
	                                break;
	                        }
	                        for (var p = 0; p < indicData.length; p++) {
	                            var para = indicData[p].parameter;
	                            if (para) {
	                                mainDps.push('indicator_' + indicData[p].parameter + ':' + indic);
	                            } else {
	                                mainDps.push('indicator:' + indic);
	                            }
	                        }
	                    }
	                    for (var fundamental in this._fundamentalsData) {
	                        mainDps.push('fundamental:' + fundamental);
	                    }
	                    dataPoints[this._getUniqueKey(this.mainTickerObject)] = mainDps;
	                    if (this._compareData) {
	                        for (var i = 0; i < this._compareData.length; i++) {
	                            var compareDps = ['name'];
	                            var uniqueKey = this._getUniqueKey(this._compareData[i].tickerObject);
	                            if (dataPoints[uniqueKey]) {
	                                continue;
	                            }
	                            if (config.showCrosshairOriginalData && !(chartConfigManager.getConfig().useEUTimeSeriesData && priceType === 'return')) {
	                                compareDps.push('originalPrice');
	                            } else {
	                                compareDps.push('growth');
	                            }
	                            for (var fundamentalName in (this._compareData[i].Fundamentals || {})) {
	                                if (chartConfigManager.isMutualFund(this._compareData[i].tickerObject)) {
	                                    if (this.config.fundamentalProperties.hasOwnProperty(fundamentalName) && this.config.fundamentalProperties[fundamentalName].showWithCompare) {
	                                        compareDps.push('fundamental:' + fundamentalName);
	                                    }
	                                }
	                            }
	                            for (var indicatorName in (this._compareData[i].Indicators || {})) {
	                                if (this.config.indicatorProperties.hasOwnProperty(indicatorName) && this.config.indicatorProperties[indicatorName].showWithCompare) {
	                                    var indicData = this._indicatorsData[indic] || [];
	                                    for (var p = 0; p < indicData.length; p++) {
	                                        var para = indicData[p].parameter;
	                                        if (para) {
	                                            compareDps.push('indicator_' + indicData[p].parameter + ':' + indicatorName);
	                                        } else {
	                                            compareDps.push('indicator:' + indicatorName);
	                                        }
	                                    }
	                                }
	                            }
	                            dataPoints[uniqueKey] = compareDps;
	                        }
	                    }
	                    return dataPoints;
	                },
	                _getUniqueKey: function(tickerObject) {
	                    if (tickerObject) {
	                        return [tickerObject.gkey, tickerObject.secId, tickerObject.performanceId].join(',').replace(/[_:]/g, '');
	                    }
	                    return null;
	                },
	                _getDataByUniqueKey: function(key) {
	                    if (this._getUniqueKey(this.mainTickerObject) === key) {
	                        return this._data;
	                    } else {
	                        for (var i = 0; i < this._compareData.length; i++) {
	                            if (this._getUniqueKey(this._compareData[i].tickerObject) === key) {
	                                return this._compareData[i].Price.data;
	                            }
	                        }
	                    }
	                    return [];
	                },
	                _getTickerObjectByUniqueKey: function(key) {
	                    var tickerObjects = chartConfigManager.getTickerCollection();
	                    for (var i = 0; i < tickerObjects.length; i++) {
	                        var tickerObject = tickerObjects[i];
	                        var uniqueKey = this._getUniqueKey(tickerObject);
	                        if (uniqueKey === key) {
	                            return tickerObject;
	                        }
	                    }
	                    return null;
	                },
	                _getExportColumnHeaders: function(keys, tickerObject) {
	                    var headers = [];
	                    var config = chartConfigManager.getConfig();
	                    for (var i = 0, l = keys.length, key, lkey; i < l; i++) {
	                        key = lkey = keys[i];
	                        var parameter = '';
	                        if (key === 'time') {
	                            lkey = isNaN(config.frequency) ? 'date' : key;
	                        } else {
	                            if (key === 'originalPrice') {
	                                lkey = chartConfigManager.isMutualFund(tickerObject) ? 'nav' : 'price';
	                                if (tickerObject.mType === 'XI') {
	                                    lkey = 'price';
	                                }
	                                if (config.growthType == "performancesGrowth" || config.growthType === 'priceGrowth') {
	                                    lkey = 'value'
	                                }
	                            } else if (key.indexOf(':') > -1) {
	                                lkey = key.split(':')[1];
	                                lkey = lkey.replace(/\b(\w)|\s(\w)/g, function(m) {
	                                    return m.toLowerCase();
	                                });
	                                if (key.indexOf('_') > -1) {
	                                    parameter = key.match(/(\S*)_(\S*):(\S*)/)[2];
	                                }
	                            }
	                        }
	                        var header = this.langData[lkey] || lkey.replace(/\b(\w)|\s(\w)/g, function(m) {
	                            return m.toUpperCase();
	                        });
	                        if (parameter !== '') {
	                            header += parameter;
	                        }
	                        headers.push(header);
	                    }
	                    return headers.join(config.columnDelimiter);
	                },
	                _createCommonPlotter: function() {
	                    this._defaultGraphConfig = {};
	
	                    this._getDefaultGraphConfig = function() {
	                        return this._defaultGraphConfig;
	                    };
	                    this._commonPlotter = new commonPlotter(this._defaultGraphConfig);
	                },
	                _caculateValidSize: function() {
	                    var cfg = this.config;
	                    if (cfg.yAxis.position == "outer") {
	                        this._validWidth = cfg.width - cfg.margin.left - cfg.margin.right - (cfg.yAxis.width + cfg.yAxisMargin || 0);
	                    } else {
	                        this._validWidth = cfg.width - cfg.margin.left - cfg.margin.right;
	                    }
	
	                    this._validHeight = cfg.height - cfg.margin.top - cfg.margin.bottom;
	                },
	                _updateViewAfterDataChanged: function(preloadInfo, offsetDomain, res) {
	                    if (this._changeScaleDomain()) {
	                        this._displayViewAfterChangeDomain();
	                    }
	                },
	                _getCompareData: function(dataArr) {
	                    var compareItem, compareDataArr = [];
	                    for (var i = 1, len = dataArr.length; i < len; i++) {
	                        compareItem = dataArr[i];
	                        compareItem && compareItem.Price && dataArr[i].Price.data && compareDataArr.push(dataArr[i]);
	                    }
	                    this._compareData = (compareDataArr.length > 0) ? compareDataArr : null;
	                },
	                _reviseData: function(data) {
	                    this._decideMinMaxAttrbute();
	                    var yAttr = this.yAttr || 'close';
	                    data.forEach(function(d) {
	                        d.x = d.index;
	                        d.y = d[yAttr];
	                    });
	                    return data;
	                },
	                _reviseDividendEffectData: function(data) {
	                    var revisedData = data.slice();
	                    revisedData.forEach(function(d) {
	                        d.x = d.index;
	                        d.y = d.value;
	                        d.value = d.value;
	                    });
	                    return revisedData;
	                },
	                _reviseMainDividendEffectData: function(data) {
	                    var revisedData = data.slice();
	                    revisedData.forEach(function(d) {
	                        d.x = d.index;
	                        d.y = d.close;
	                        d.value = d.close;
	                    });
	                    return revisedData;
	                },
	                _cancelNotRunedPreload: function() {
	                    clearTimeout(this._timer);
	                },
	                _preloadData: function(domainStart, domainEnd, loadedData) {
	                    domainStart = domainStart || this._xScale.domain()[0];
	                    domainEnd = domainEnd || this._xScale.domain()[1];
	                    var view = this;
	                    var dataLen = (loadedData || []).length;
	                    var needLoad = false;
	                    if (domainStart <= 0 || this._preloadInfo.intervalType === IntervalTypes.Max || this._loadingData) {
	                        needLoad = true;
	                    } else if ((domainEnd - domainStart) * 0.25 > dataLen || domainEnd > dataLen) {
	                        needLoad = true;
	                    }
	                    if (needLoad) {
	                        clearTimeout(view._timer);
	                        if (!this._loadingData) {
	                            view._preloading = true;
	                            view._loadingData = true;
	                            view._showLoading();
	                            eventManager.trigger(eventManager.EventTypes.FetchPreloadData);
	                        }
	                    }
	                },
	                _fetchPreloadData: function() {
	                    if (!this._xScale) {
	                        return;
	                    }
	                    var view = this;
	                    this._loadingData = true;
	                    chartConfigManager.preloadMainTickerData(this._preloadInfo,
	                        function(res, preloadInfo) {
	                            if (res && res.status().errorCode === "0") {
	                                var resDataArr = res.data();
	                                var mainTickerData = resDataArr[0];
	                                var newData = mainTickerData.Price.data;
	                                var newDataLength = newData.length;
	                                if (newDataLength > 0) {
	                                    newData = view._reviseData(newData);
	                                    var renderedData = preloadInfo.loadedData || view._data;
	                                    var offsetDomain = 0; //preloadInfo.offsetDomain || 0;
	                                    var renderedDateLength = renderedData.length;
	                                    if (renderedDateLength === 0) {
	                                        return;
	                                    }
	
	                                    var newDataLastDateTime = newData[newDataLength - 1].date.getTime();
	                                    if (renderedData[renderedDateLength - 1].date.getTime() === newDataLastDateTime) {
	                                        offsetDomain += newDataLength - renderedDateLength;
	                                    } else {
	                                        var renderedDate = renderedData[0].date.getTime();
	                                        if (renderedDate > newDataLastDateTime) {
	                                            offsetDomain += newDataLength;
	                                        } else if (renderedDate === newDataLastDateTime) {
	                                            newData.pop();
	                                            offsetDomain += newDataLength - 1;
	                                        } else if (renderedDate < newDataLastDateTime) {
	                                            for (var i = 0; i < renderedData.length; i++) {
	                                                if (renderedData[i].date.getTime() > newDataLastDateTime) {
	                                                    break;
	                                                }
	                                            }
	                                            offsetDomain += newDataLength - i;
	                                            renderedData = renderedData.slice(i);
	                                        } else {
	                                            alert("Error!");
	                                        }
	
	                                        renderedData.forEach(function(d) {
	                                            d.x = d.x + offsetDomain;
	                                        });
	
	                                        newData = newData.concat(renderedData);
	                                    }
	
	                                    preloadInfo.offsetDomain = preloadInfo.offsetDomain || 0;
	                                    preloadInfo.offsetDomain += offsetDomain;
	
	                                    //Why put it on preloadInfo?
	                                    //Because preloadInfo can reset all those parameters when change date range or indicator.
	                                    view._loadedData = preloadInfo.loadedData = newData;
	                                    view._preloadInfo = preloadInfo;
	                                }
	                            }
	
	                            view._hideLoading();
	                            view._loadingData = false;
	                        });
	                },
	                _decideMinMaxAttrbute: function() {
	                    var comConfig = chartConfigManager.getConfig();
	                    if (/\w+\-(mainchart)/ig.test(this.$el[0].className) && comConfig.chartGenre === chartConfigManager.ChartGenre.FundChart && chartConfigManager.getMainDataType() === chartConfigManager.MainDataTypes.PriceWithDividendGrowth) {
	                        this.minAttr = "growthWithNav";
	                        this.maxAttr = "growthWithNav";
	                        this.yAttr = "growthWithNav";
	                    } else if (comConfig.chartGenre === chartConfigManager.ChartGenre.FundChart && !chartConfigManager.isCompareOrPercentChart() && !comConfig.useDataApiTimeseriesData) {
	                        this.minAttr = "value";
	                        this.maxAttr = "value";
	                        this.yAttr = "value";
	                        this._convertToPrice = this._convertToFundPrice; // This avoid judge chartGenre
	                    } else if ($.inArray(comConfig.charts.mainChart.chartType, [MainChartTypes.OHLCChart, MainChartTypes.HLCChart, MainChartTypes.CandlestickChart]) > -1) {
	                        this.minAttr = "low";
	                        this.maxAttr = "high";
	                        this.yAttr = "close";
	                    } else {
	                        this.minAttr = "close";
	                        this.maxAttr = "close";
	                        this.yAttr = "close";
	                    }
	                },
	                _createScale: function() {
	                    var view = this;
	                    this._xScale = d3.scale.linear()
	                        .range([0, this._validWidth])
	                        .domain(this._getAjustedDomain([0, this._data.length - 1]));
	
	                    this._yScale = this._createYScale().range([this._validHeight, 0]);
	                    this._setYScaleDomain();
	                },
	                _getAjustedDomain: function(xScaleDomain) {
	                    var domain = xScaleDomain[1] - xScaleDomain[0];
	                    if (domain === 0) {
	                        var data = this._data[0];
	                        var dataArr = []; // Avoid affect original data.
	                        var data1 = {};
	                        var data2 = {};
	                        data1.date = data2.date = data.date;
	                        data1.dateIndex = data2.dateIndex = data.dateIndex;
	                        dataArr.push(data1);
	                        data.x = 1;
	                        dataArr.push(data);
	                        dataArr.push(data2);
	                        domain = 2;
	                        this._data = dataArr;
	                        this._needAjustLine = true;
	                    } else {
	                        this._needAjustLine = false;
	                    }
	
	                    return [0, domain];
	                },
	                _setYScaleDomain: function() {
	                    var view = this;
	                    //d3.min/max can work on NaN, but Math.min/max can't.
	                    var minYValueArr = [d3.min(this._data, function(d) {
	                        return d[view.minAttr];
	                    })];
	                    var maxYValueArr = [d3.max(this._data, function(d) {
	                        return d[view.maxAttr];
	                    })];
	                    for (var indicatorName in this._indicatorsData) {
	                        if (this.config.indicatorProperties.hasOwnProperty(indicatorName) && indicatorName !== dataAdapter.IndicatorName.VBP) {
	                            if (indicatorName === dataAdapter.IndicatorName.PrevClose &&
	                                (this.config.intervalType !== IntervalTypes.OneDay || chartConfigManager.isCompareOrPercentChart())) {
	                                continue;
	                            }
	
	                            this._indicatorsData[indicatorName].forEach(function(s) {
	                                minYValueArr.push(d3.min(s.data, function(d) {
	                                    return d.value;
	                                }));
	                                maxYValueArr.push(d3.max(s.data, function(d) {
	                                    return d.value;
	                                }));
	                            });
	                        }
	                    }
	
	                    if (this._compareData && !this._needHideBenchmark()) {
	                        this._compareData.forEach(function(d) {
	                            minYValueArr.push(d3.min(d.Price.data, function(d) {
	                                return d[view.minAttr];
	                            }));
	                            maxYValueArr.push(d3.max(d.Price.data, function(d) {
	                                return d[view.maxAttr];
	                            }));
	                        });
	                    }
	
	                    var isPriceChart = this._checkIfPriceChart();
	                    if (this._fundamentalsData && isPriceChart) {
	                        for (var fundamentalName in this._fundamentalsData) {
	                            if (this.config.fundamentalProperties.hasOwnProperty(fundamentalName) && !this.config.fundamentalProperties[fundamentalName].skipDrawGraph) {
	                                var filteredFundamentals = view._fundamentalsData[fundamentalName].data;
	                                if (filteredFundamentals && filteredFundamentals.length > 0) {
	                                    minYValueArr.push(d3.min(filteredFundamentals, function(d) {
	                                        return d.value;
	                                    }));
	                                    maxYValueArr.push(d3.max(filteredFundamentals, function(d) {
	                                        return d.value;
	                                    }));
	                                }
	                            }
	                        }
	                    }
	
	                    if (this._dividendEffectData && this._dividendEffectData.length > 0) {
	                        minYValueArr.push(d3.min(this._dividendEffectData, function(d) {
	                            return d.value;
	                        }));
	                        maxYValueArr.push(d3.max(this._dividendEffectData, function(d) {
	                            return d.value;
	                        }));
	                    }
	                    var yScaleData = this._calculateYScaleDomainTickValues(d3.min(minYValueArr), d3.max(maxYValueArr));
	                    this._yTickValues = yScaleData.tickValues;
	                    if (yScaleData.domain) {
	                        this._yScale.domain(yScaleData.domain);
	                    }
	                },
	                _calculateYScaleDomainTickValues: function(minYValue, maxYValue) {
	                    var maxTickCount = this._caculateMaxTickCount();
	                    return this._ajustDomainByAlgorithm([minYValue, maxYValue], maxTickCount);
	                },
	                _caculateMaxTickCount: function() {
	                    var height = this._validHeight;
	                    var textHeight = this._getTextWidthHeight("1").height;
	                    var space = 8;
	                    var maxTickCount = parseInt(height / (textHeight * 2 + space), 10) + 1;
	                    if (maxTickCount <= 1) {
	                        maxTickCount = 2; //at least 2 ticks
	                    }
	                    if (this.config.yAxis.maxTickCount && this.config.yAxis.maxTickCount < maxTickCount) {
	                        maxTickCount = this.config.yAxis.maxTickCount;
	                    }
	                    return maxTickCount;
	                },
	                _ajustDomainByAlgorithm: function(domain, maxTickCount) {
	                    var _factors = [0.01, 0.015, 0.02, 0.025, 0.03, 0.04, 0.05, 0.075];
	                    var min = domain[0];
	                    var max = domain[1];
	                    var range = util.Math.subtract(max, min);
	                    var adjustedMax, adjustedMin;
	                    var maxExponent = 20;
	                    var tickCount;
	                    if (range == 0) {
	                        //max==min==factor
	                        factor = max = min;
	                        tickCount = (maxTickCount % 2) ? maxTickCount : (maxTickCount - 1);
	                        var multiplyFactor = Math.floor(tickCount / 2) * factor;
	                        adjustedMax = util.Math.add(max, multiplyFactor);
	                        adjustedMin = util.Math.subtract(min, multiplyFactor);
	                        domain[0] = adjustedMin;
	                        domain[1] = adjustedMax;
	                        return {
	                            domain: domain,
	                            tickValues: this._generateYTickValues(domain, tickCount, factor)
	                        };
	                    } else if (range <= 0.01) {
	                        var temp = 10;
	                        maxExponent = 3;
	                        for (var i = maxExponent; i > 0; i--) {
	                            for (var f in _factors) {
	                                var factor = util.Math.multiply(_factors[f], Math.pow(10, -i));
	                                if (util.Math.multiply((maxTickCount - 1), factor) > range) {
	                                    var offset = util.Math.subtract(factor, Math.abs(util.Math.mod(max, factor)));
	                                    adjustedMax = util.Math.add(max, offset);
	                                    tickCount = parseInt(util.Math.divide(util.Math.subtract(adjustedMax, min), factor) + 1, 10);
	                                    tickCount += util.Math.mod(util.Math.subtract(adjustedMax, min), factor) === 0 ? 0 : 1;
	                                    adjustedMin = util.Math.subtract(adjustedMax, (tickCount - 1) * factor);
	                                    if (tickCount < maxTickCount) {
	                                        domain[0] = adjustedMin;
	                                        domain[1] = adjustedMax;
	                                        return {
	                                            domain: domain,
	                                            tickValues: this._generateYTickValues(domain, tickCount, factor)
	                                        };
	                                    }
	                                }
	                            }
	                        }
	                    } else {
	                        for (var i = 0; i < maxExponent; i++) {
	                            for (var f in _factors) {
	                                var factor = util.Math.multiply(_factors[f], Math.pow(10, i));
	                                if (util.Math.subtract((maxTickCount - 1) * factor, range) > util.Math.multiply(0.01, range)) {
	                                    var offset = util.Math.subtract(factor, Math.abs(util.Math.mod(max, factor)));
	                                    adjustedMax = util.Math.add(max, offset);
	                                    tickCount = parseInt(util.Math.divide(util.Math.subtract(adjustedMax, min), factor) + 1, 10);
	                                    tickCount += util.Math.mod(util.Math.subtract(adjustedMax, min), factor) === 0 ? 0 : 1;
	                                    adjustedMin = util.Math.subtract(adjustedMax, (tickCount - 1) * factor);
	                                    if (tickCount <= maxTickCount) {
	                                        domain[0] = adjustedMin;
	                                        domain[1] = adjustedMax;
	                                        return {
	                                            domain: domain,
	                                            tickValues: this._generateYTickValues(domain, tickCount, factor)
	                                        };
	                                    }
	                                }
	                            }
	                        }
	                    }
	                },
	                _generateYTickValues: function(domain, tickCount, factor) {
	                    var tickValues = [];
	                    this._yAxisDecimal = this._getYAxisDecimalPlaces(domain, tickCount, factor);
	                    if (this._getCurrentScaleType() == VerticalScaleTypes.Logarithmic) {
	                        if (domain[0] < 1) {
	                            var adjustOffset = 1 - domain[0];
	                            domain[0] = 1;
	                            domain[1] = util.Math.add(domain[1], adjustOffset);
	                        }
	                    }
	                    for (var i = 0; i < tickCount; i++) {
	                        tickValues.push(domain[0] + factor * i);
	                    }
	                    // this._yTickValues = tickValues;
	                    return tickValues;
	                },
	                _createYScale: function() {
	                    var yScale;
	                    var scaleType = this._getCurrentScaleType();
	                    switch (scaleType) {
	                        case VerticalScaleTypes.Logarithmic:
	                            yScale = d3.scale.log();
	                            break;
	                        case VerticalScaleTypes.Linear:
	                        default:
	                            yScale = d3.scale.linear();
	                            break;
	                    }
	
	                    return yScale;
	                },
	                _getCurrentScaleType: function() {
	                    return VerticalScaleTypes.Linear;
	                },
	                _fetchDateRangeData: function(dateRange) {
	                    var view = this;
	                    chartConfigManager.fetchDisplayData(dateRange, view._preloadInfo.frequency, function(res) {
	                        view._clearAllData();
	                        if (res.status().errorCode === "0") {
	                            var resDataArr = res.data();
	                            var mainTickerData = resDataArr[0];
	                            var data = mainTickerData.Price.data;
	                            if (data.length > 0) {
	                                data = view._reviseData(data);
	                                view._data = data;
	                                view._lastClosePrice = mainTickerData.Price.spos;
	                                view._lastOpenPrice = mainTickerData.Price.epos;
	                                view._fundamentalsData = mainTickerData.Fundamentals;
	                                view._eventsData = mainTickerData.Events;
	                                var mainDataType = chartConfigManager.getMainDataType();
	                                if (mainDataType === MainDataTypes.DividendEffect) {
	                                    var fundamentalType = dataAdapter.Fundamental.MReturnIndex;
	                                    if (mainTickerData.Fundamentals && mainTickerData.Fundamentals[fundamentalType] &&
	                                        mainTickerData.Fundamentals[fundamentalType].data) {
	                                        view._dividendEffectData = view._reviseDividendEffectData(mainTickerData.Fundamentals[fundamentalType].data);
	                                    }
	                                } else {
	                                    view._getCompareData(res.data());
	                                    view._indicatorsData = mainTickerData.Indicators;
	                                    view._createDummyData(view._compareData);
	                                }
	
	                                var startIndex = view._getDataIndexByDate(dateRange[0], null, null, view._data);
	                                var endIndex = view._getDataIndexByDate(dateRange[1], null, null, view._data);
	                                var xScaleDomain = [startIndex, endIndex];
	                                view._getDisplayData(xScaleDomain);
	                                view._setScaleDomain(xScaleDomain);
	                            }
	                        }
	                        view._displayViewAfterChangeDomain();
	
	                    });
	                },
	                _changeScaleDomain: function(xScaleDomain, isZoomIn) {
	                    if (!this._xScale) {
	                        return;
	                    }
	                    if (xScaleDomain) {
	                        if (isZoomIn) {
	                            this._getDisplayData(xScaleDomain);
	                        } else {
	                            var loadedData = this._loadedData || this._data;
	                            if (loadedData && loadedData[xScaleDomain[0]]) {
	                                var startDate = loadedData[xScaleDomain[0]].date;
	                                var endIndex = (xScaleDomain[1] < loadedData.length) ? xScaleDomain[1] : (loadedData.length - 1);
	                                var endDate = loadedData[endIndex].date;
	                                this._fetchDateRangeData([startDate, endDate]);
	                            }
	                            return;
	                        }
	                    } else {
	                        var lastDateRange = this._lastDateRange;
	                        if (lastDateRange) {
	                            var data = this._data;
	                            var start = this._getDataIndexByDate(lastDateRange[0], null, null, data);
	                            var end = this._getDataIndexByDate(lastDateRange[1], null, null, data);
	                            if (!start || !end) {
	                                this._fetchDateRangeData(lastDateRange);
	                                return;
	                            } else {
	                                xScaleDomain = [start, end];
	                                this._getDisplayData(xScaleDomain);
	                            }
	                        } else {
	                            xScaleDomain = [0, this._data.length - 1];
	                        }
	                    }
	                    this._setScaleDomain(xScaleDomain);
	                    return true;
	                },
	                _displayViewAfterChangeDomain: function() {
	                    this._clearView();
	                    this._renderContainedViews();
	                },
	                _setScaleDomain: function(xScaleDomain) {
	                    this._xScale.domain(this._getAjustedDomain(xScaleDomain));
	                    this._setYScaleDomain();
	                },
	                _checkIfPriceChart: function() {
	                    var mainDataType = chartConfigManager.getMainDataType();
	                    var isPriceChart = mainDataType !== MainDataTypes.Growth &&
	                        mainDataType !== MainDataTypes.DividendEffect &&
	                        (!this._compareData || this._compareData.length == 0);
	                    var rootCfg = chartConfigManager.getConfig();
	                    if (mainDataType === MainDataTypes.Growth && chartConfigManager.getConfig().useEUTimeSeriesData && chartConfigManager.getConfig().growthType == "priceGrowth" || rootCfg.drawNavAndPriceChart) {
	                        isPriceChart = true;
	                    }
	                    return isPriceChart;
	                },
	                _getDataIndexByDate: function(dateTime, startIndex, endIndex, data) {
	                    var data = data || this._data;
	                    var result;
	                    if (data) {
	                        startIndex = startIndex || 0;
	                        endIndex = endIndex || data.length - 1;
	                        if (dateTime < data[startIndex].date || dateTime > data[endIndex].date) {
	                            result = null;
	                        } else if (dateTime.getTime() === data[startIndex].date.getTime()) {
	                            result = startIndex;
	                        } else if (dateTime.getTime() === data[endIndex].date.getTime()) {
	                            result = endIndex;
	                        } else {
	                            while (true) {
	                                if ((endIndex - startIndex) >= 2) {
	                                    var middleIndex = Math.floor((startIndex + endIndex) / 2);
	                                    var middleIndexDate = data[middleIndex].date;
	                                    if (dateTime < middleIndexDate) {
	                                        endIndex = middleIndex;
	                                    } else if (dateTime > middleIndexDate) {
	                                        startIndex = middleIndex;
	                                    } else {
	                                        result = middleIndex;
	                                        break;
	                                    }
	                                } else {
	                                    var millisecond;
	                                    var startDate, endDate;
	                                    startDate = data[startIndex].date;
	                                    if (endIndex === data.length) {
	                                        millisecond = data[endIndex - 1].date - data[endIndex - 2].date;
	                                    } else {
	                                        endDate = data[endIndex].date;
	                                        millisecond = endDate - startDate
	                                    }
	                                    result = startIndex + (dateTime - startDate) / millisecond;
	                                    break;
	                                }
	                            }
	                        }
	                    }
	
	                    return result;
	                },
	                _changDataRange: function(adjustedDateRange) {
	                    this._lastDateRange = null;
	                    this._updateViewData(adjustedDateRange);
	                },
	                _getDisplayPriceData: function(xScaleDomain) {
	                    var data = this._data;
	                    this._data = data.slice(xScaleDomain[0], xScaleDomain[1] + 1);
	                },
	                _getDisplayDividendEffectData: function(xScaleDomain) {
	                    var dividendData = this._dividendEffectData;
	
	                    this._dividendEffectData = dividendData && dividendData.slice(xScaleDomain[0], xScaleDomain[1] + 1);
	                },
	                _getDisplayCompareData: function(xScaleDomain) {
	                    var loadedCompareData = this._loadedCompareData;
	                    var renderedCompareData = this._compareData;
	                    var compareData = renderedCompareData;
	                    if (renderedCompareData && compareData && compareData.length > 0) {
	                        for (var i = 0, len = compareData.length; i < len; i++) {
	                            renderedCompareData[i].Price.data = compareData[i].Price.data.slice(xScaleDomain[0], xScaleDomain[1] + 1);
	                        }
	
	                        this._compareData = renderedCompareData;
	                    }
	                },
	                _getDisplayIndicatorsData: function(xScaleDomain) {
	                    var loadedIndicatorsData = this._loadedIndicatorsData;
	                    var renderedIndicatorsData = this._indicatorsData;
	                    var indecatorsData = renderedIndicatorsData;
	                    var indicatorsItem, renderedIndicatorItem;
	                    if (indecatorsData) {
	                        for (var indicatorName in indecatorsData) {
	                            indicatorsItem = indecatorsData[indicatorName];
	                            renderedIndicatorItem = renderedIndicatorsData[indicatorName];
	                            for (var i = 0, len = indicatorsItem.length; i < len; i++) {
	                                renderedIndicatorItem[i].data = indicatorsItem[i].data.slice(xScaleDomain[0], xScaleDomain[1] + 1);
	                            }
	                        }
	                    }
	
	                    this._indicatorsData = renderedIndicatorsData;
	                },
	                _getDisplayData: function(xScaleDomain) {
	                    this._getDisplayPriceData(xScaleDomain);
	                    this._getDisplayIndicatorsData(xScaleDomain);
	                    this._getDisplayCompareData(xScaleDomain);
	                    this._getDisplayDividendEffectData(xScaleDomain);
	                },
	                _formatXAxisLabels: function(dataIndex, tickIndex) {
	                    var tickLabel = this._xTickInfos.tickLabels[dataIndex];
	                    if ($.isFunction(tickLabel.format)) {
	                        return tickLabel.format(tickLabel.date);
	                    } else {
	                        return "";
	                    }
	                },
	                _getOneDayTickInfos: function() {
	                    var tickValues = [],
	                        tickLabels = {};
	                    var currentXScaleDomain = this._xScale.domain();
	                    var tickSpan;
	                    var intervalType = IntervalTypes.OneDay;
	                    var frequency = chartConfigManager.getConfig().frequency || chartConfigManager.getDefaultfrequencyByIntervalType(intervalType);
	                    switch (frequency) {
	                        case FrequencyTypes.OneMinute:
	                            tickSpan = this._validWidth <= 600 ? 120 : 60; //exception:x-small should have 2hrs tick (QS-7776)
	                            break;
	                        case FrequencyTypes.FiveMinute:
	                            tickSpan = 12;
	                            break;
	                        case FrequencyTypes.TenMinute:
	                            tickSpan = 6;
	                            break;
	                        case FrequencyTypes.FifteenMinute:
	                            tickSpan = 4;
	                            break;
	                        case FrequencyTypes.ThirtyMinute:
	                            tickSpan = 2;
	                            break;
	                    }
	
	                    var lang = this.config.lang;
	                    var data = this._data;
	                    var d3Locale = chartConfigManager.getD3Locale();
	                    var xLabelDateTimeFormat = d3Locale.XLabelDateTimeFormat;
	                    var d3TimeFormat = d3Locale.timeFormat;
	                    var xLabelFormatter;
	                    var start = data[0].date;
	                    var d;
	                    for (var i = currentXScaleDomain[0]; i < currentXScaleDomain[1]; i = (i + tickSpan)) {
	                        d = data[i].date;
	                        tickValues.push(i);
	                        if (start.getFullYear() != d.getFullYear()) {
	                            xLabelFormatter = d3TimeFormat(xLabelDateTimeFormat.YearMonthDay);
	                        } else if (start.getMonth() != d.getMonth() || start.getDate() != d.getDate()) {
	                            xLabelFormatter = d3TimeFormat(xLabelDateTimeFormat.MonthDay);
	                        } else {
	                            xLabelFormatter = d3TimeFormat(xLabelDateTimeFormat.HourMinutes);
	                        }
	                        start = d;
	                        tickLabels[i] = {
	                            format: xLabelFormatter,
	                            date: d,
	                            x: this._xScale(i)
	                        };
	                    }
	
	                    return {
	                        tickValues: tickValues,
	                        tickLabels: tickLabels
	                    };
	                },
	                _createXAxisTickInfos: function() {
	                    var tickValues = [];
	                    var tickLabels = {};
	                    var data = this._data;
	                    var dlen = data.length;
	                    if (!dlen) {
	                        return;
	                    }
	                    var start = data[0]['date'],
	                        end = data[dlen - 1]['date'];
	                    var diff = (end.getTime() - start.getTime()) / chartConfigManager.Constants.DAY_IN_MILLISECONDS;
	                    if (this.config.intervalType === IntervalTypes.OneDay || diff < 1 && chartConfigManager.getConfig().chartGenre !== chartConfigManager.ChartGenre.FundChart) {
	                        var tickInfos = this._getOneDayTickInfos();
	                        tickValues = tickInfos.tickValues;
	                        tickLabels = tickInfos.tickLabels;
	                    } else {
	                        var d3Locale = chartConfigManager.getD3Locale();
	                        var xLabelDateTimeFormat = d3Locale.XLabelDateTimeFormat;
	                        var d3TimeFormat = d3Locale.timeFormat;
	                        var formatMD = d3TimeFormat(xLabelDateTimeFormat.MonthDay),
	                            formatM = d3TimeFormat(xLabelDateTimeFormat.Month),
	                            formatY = d3TimeFormat(xLabelDateTimeFormat.Year),
	                            formatYM = d3TimeFormat(xLabelDateTimeFormat.YearMonth),
	                            formatYMD = d3TimeFormat(xLabelDateTimeFormat.YearMonthDay);
	                        var ty = 'd';
	                        var format;
	                        if (diff < 8) {
	                            ty = 'd';
	                            format = formatMD;
	                        } else if (diff <= 31) {
	                            ty = 'avg';
	                            format = formatMD;
	                        } else if (diff <= 61) {
	                            ty = 'w';
	                            format = formatMD;
	                        } else if (diff <= 240) {
	                            ty = 'm';
	                            format = start.getMonth() === 0 ? formatYM : formatM;
	                        } else if (diff <= 730) {
	                            ty = 'q';
	                            format = start.getMonth() === 0 ? formatYM : formatM;
	                        } else if (diff <= 2920) {
	                            ty = 'y';
	                            format = formatY;
	                        } else {
	                            ty = '5y';
	                            format = formatY;
	                        }
	
	                        tickValues.push(0);
	                        tickLabels[0] = {
	                            format: format,
	                            date: start,
	                            x: this._xScale(0)
	                        }
	
	                        for (var i = 1, d, flag, temp = start; i < dlen; i++) {
	                            d = data[i]['date'];
	                            flag = false;
	                            if (ty === 'd' || ty === 'avg') {
	                                flag = temp.getDate() !== d.getDate();
	                                flag && (format = formatMD);
	                            } else if (ty === 'w') {
	                                flag = temp.getDate() !== d.getDate();
	                                flag && (format = formatMD);
	                            } else if (ty === 'm') {
	                                flag = temp.getMonth() !== d.getMonth();
	                                flag && (format = d.getMonth() === 0 ? formatYM : formatM);
	                            } else if (ty === 'q') {
	                                flag = (d.getMonth() + 1) % 3 === 1 && temp.getMonth() !== d.getMonth();
	                                flag && (format = d.getMonth() === 0 ? formatYM : formatM);
	                            } else if (ty === 'y') {
	                                flag = temp.getFullYear() !== d.getFullYear();
	                                flag && (format = formatY);
	                            } else {
	                                flag = temp.getFullYear() !== d.getFullYear() && d.getFullYear() % 5 === 0;
	                                flag && (format = formatY);
	                            }
	
	                            if (flag) {
	                                temp = d;
	                                tickValues.push(i);
	                                tickLabels[i] = {
	                                    format: format,
	                                    date: d,
	                                    x: this._xScale(i)
	                                };
	                            }
	                        }
	                    }
	                    var maxTickCount = this._validWidth / 70;
	                    var tempTickValues, prevDate, currDate;
	                    while (tickValues.length > maxTickCount) {
	                        tempTickValues = [];
	                        for (var i = 0, x; i < tickValues.length; i++) {
	                            x = tickValues[i];
	                            if (i % 2 === 0) {
	                                tempTickValues.push(tickValues[i]);
	                                if (prevDate) {
	                                    currDate = tickLabels[x].date;
	                                    if (prevDate.getFullYear() !== currDate.getFullYear()) {
	                                        if (tickLabels[x].format === formatM) {
	                                            tickLabels[x].format = formatYM;
	                                        } else if (tickLabels[x].format === formatMD) {
	                                            tickLabels[x].format = formatYMD;
	                                        }
	                                    }
	                                }
	                                prevDate = tickLabels[x].date;
	                            }
	                        }
	                        tickValues = tempTickValues;
	                    }
	
	                    var newTickValues = [];
	                    var newTickLabels = {};
	                    for (var j = 0, jl = tickValues.length, tickValue, tickLabel, tickWidth, lastTickWidth, nextX, lastX, formerX; j < jl; j++) {
	                        tickValue = tickValues[j];
	                        tickLabel = tickLabels[tickValue];
	                        nextX = j === jl - 1 ? this._validWidth : tickLabels[tickValues[j + 1]].x;
	                        formerX = j === 0 ? 0 : tickLabels[tickValues[j - 1]].x;
	                        tickWidth = this._getTickWidth(tickLabel.format(tickLabel.date), this._innerClass.xAxis);
	                        if (tickWidth <= nextX - tickLabel.x) {
	                            tickLabel.textAnchor = 'start';
	                        } else if ((tickLabel.x + tickWidth) > nextX) {
	                            tickLabel.format = "";
	                            tickLabel.textAnchor = 'start';
	                        } else if (tickWidth <= tickLabel.x - formerX) {
	                            if (lastTickWidth && (tickWidth + lastTickWidth) >= (tickLabel.x - formerX)) {
	                                tickLabel.format = "";
	                            }
	                            tickLabel.textAnchor = 'end';
	                        }
	                        newTickValues.push(tickValue);
	                        newTickLabels[tickValue] = tickLabel;
	                        lastTickWidth = tickWidth;
	                    }
	                    this._xTickInfos = {
	                        tickValues: newTickValues,
	                        tickLabels: newTickLabels
	                    };
	                },
	                _drawXAxis: function() {
	                    this._createXAxisTickInfos();
	                    var view = this;
	                    if (this.config.xAxis.show) {
	                        var config = {
	                            tickSize: this.config.xAxis.tickSize || 0,
	                            tickPadding: 5,
	                            tickValues: this._xTickInfos.tickValues,
	                            orient: this.config.xAxis.orient,
	                            graphCss: this._innerClass.xAxis,
	                            graphType: graphTypes.Axis,
	                            scale: this._xScale,
	                            width: this._validWidth,
	                            height: this._validHeight,
	                            xTickInfos: this._xTickInfos,
	                            tickFormatFunc: function() {
	                                return view._formatXAxisLabels.apply(view, arguments);
	                            }
	                        };
	                        this._commonDraw(config);
	                    }
	                },
	                _setYAxisStyle: function(selection) {
	                    selection.select(".domain").remove(),
	                        selection.selectAll("text").attr("dy", "1em");
	                },
	                _formatYAxisLabels: function() {
	
	                },
	                _getTickWidth: function(textArray, cls) {
	                    var width = 0,
	                        text,
	                        temp;
	                    var $textSpan = $('<span style="display:inline-block;"></span>').appendTo(this.config.container);
	                    if (cls) {
	                        $textSpan.addClass(cls);
	                    }
	                    if (!$.isArray(textArray)) {
	                        textArray = [textArray];
	                    }
	                    textArray.forEach(function(text) {
	                        temp = $textSpan.html(text).outerWidth(true);
	                        if (temp > width) {
	                            width = temp;
	                        }
	                    });
	                    $textSpan.remove();
	                    return width;
	                },
	                _changeYaxis: function() {},
	                _drawYAxis: function() {
	                    var view = this;
	                    var formatValue;
	                    var yAxisConfig = this.config.yAxis;
	                    formatValue = function(d) {
	                        return util.numberFormatter(view.config.lang, d, view._yAxisDecimal, " ", yAxisConfig.withUnit, false);
	                    }
	                    if (yAxisConfig.show) {
	                        var comConfig = chartConfigManager.getConfig();
	                        var yAxisTickValues = this._yTickValues;
	                        var config = {
	                            containerGElem: view._yAxisOuterGElem,
	                            tickSize: yAxisConfig.tickSize || 0,
	                            tickPadding: 5,
	                            tickValues: yAxisTickValues,
	                            orient: yAxisConfig.orient,
	                            position: yAxisConfig.position,
	                            yAxisWidth: yAxisConfig.width,
	                            ticks: yAxisConfig.ticks,
	                            graphCss: this._innerClass.yAxis,
	                            setAxisStyleFunc: this._setYAxisStyle,
	                            graphType: graphTypes.Axis,
	                            scale: this._yScale,
	                            width: this._validWidth,
	                            height: this._validHeight,
	                            tick: yAxisConfig.tick,
	                            tickFormatFunc: function(d) {
	                                return formatValue(d)
	                            },
	                            componentContainer: comConfig.$componentContainer,
	                        };
	
	                        if (comConfig.yAxisMargin) {
	                            config.yAxisMargin = comConfig.yAxisMargin;
	                        }
	                        this._commonDraw(config);
	                        //var yElem = this._commonDraw(config);
	                        //var scaleType = this._getCurrentScaleType();
	                        //this._processTicks(yElem);
	                    }
	                },
	                _getGElemTranslate: function(type) {
	                    var cfg = this.config;
	                    var translate = {
	                        x: cfg.margin.left,
	                        y: cfg.margin.top
	                    }
	                    if (cfg.yAxis.show && cfg.yAxis.position == "outer") {
	                        if (cfg.yAxis.orient == "left") {
	                            translate.x = parseInt(cfg.margin.left + cfg.yAxis.width + cfg.yAxisMargin);
	                            translate.y = parseInt(cfg.margin.top);
	                        }
	                    }
	                    return "translate(" + translate.x + "," + translate.y + ")";
	                },
	                _processTicks: function(yElem) {
	                    var lastTick = yElem.select(".tick");
	                    if (lastTick.size()) {
	                        var lastTickTransform = lastTick.attr("transform");
	                        //TODO: use regex.
	                        var transformValues = lastTickTransform.replace("translate(", "").replace(")", "");
	                        if (transformValues.indexOf(",") > 0) {
	                            transformValues = transformValues.split(",");
	                        } else {
	                            transformValues = transformValues.split(" ");
	                        }
	
	                        var lastTickYPosition = parseInt(transformValues[1], 10);
	                        var marginValue = 17;
	                        if ((this._validHeight - lastTickYPosition) < marginValue && this.config.yAxis.position == "inner") {
	                            lastTick.remove();
	                        }
	                    }
	                },
	                _createDummyData: function(dataToCheck) {
	                    var view = this;
	                    if (dataToCheck) {
	                        dataToCheck.forEach(function(d) {
	                            if (d && d.Price.data.length === 0 && view._data && view._data.length > 0) {
	                                var dummyData = [];
	                                view._data.forEach(function(dum) {
	                                    dummyData.push({
	                                        close: NaN,
	                                        index: dum.index,
	                                        x: dum.x,
	                                        open: NaN,
	                                        high: NaN,
	                                        low: NaN,
	                                        volume: NaN
	                                    });
	                                });
	                                d.Price.data = dummyData;
	                            }
	                        });
	                    }
	                },
	                _commonDraw: function(config) {
	                    this._commonPlotter.setConfig(this._getDefaultGraphConfig());
	                    this._commonPlotter.extendConfig(config);
	                    return this._commonPlotter.draw();
	                },
	                _commonDrawTrackball: function(config) {
	                    !config.trackType && (config.trackType = 'circle');
	                    !config.data && (config.data = this._data);
	                    !config.trackContainer && (config.trackContainer = this._getDefaultGraphConfig().containerGElem);
	                    config.elem = this._commonPlotter.drawTrackball(config);
	                    (this._trackBalls || (this._trackBalls = [])).push(config);
	                },
	                _showTrackball: function(dataIndex) {
	                    var view = this,
	                        yValue, elem;
	                    this._elementsMapping && this._elementsMapping.forEach(function(mapping) {
	                        elem = mapping[dataIndex];
	                        mapping.lastTrackElem && mapping.lastTrackElem.classed('track-high-light', false);
	                        elem && elem.classed('track-high-light', true);
	                        mapping.lastTrackElem = elem;
	                    });
	
	                    this._trackBalls && this._trackBalls.forEach(function(trackballInfo) {
	                        if (trackballInfo.data) {
	                            if (trackballInfo.data[dataIndex] && !isNaN(yValue = trackballInfo.data[dataIndex].y)) {
	                                if (trackballInfo.showFunc) {
	                                    trackballInfo.showFunc(trackballInfo, dataIndex);
	                                } else {
	                                    var elem = trackballInfo.elem;
	                                    elem.attr('cx', view._xScale(dataIndex))
	                                    elem.attr('cy', (trackballInfo.yScale || view._yScale)(yValue))
	                                    elem.style("display", "");
	                                }
	                            } else {
	                                trackballInfo.elem.style("display", "none");
	                            }
	                        }
	                    });
	                },
	                _clearTrackball: function() {
	                    if (!this._needTrackball) {
	                        this._hideTrackball();
	                        this._elementsMapping = undefined;
	                        this._trackBalls = undefined;
	                    }
	                },
	                _hideTrackball: function() {
	                    this._elementsMapping && this._elementsMapping.forEach(function(mapping) {
	                        mapping.lastTrackElem && mapping.lastTrackElem.classed('track-high-light', false);
	                        mapping.lastTrackElem = undefined;
	                    });
	
	                    this._trackBalls && this._trackBalls.forEach(function(trackballInfo) {
	                        trackballInfo.elem.style("display", "none");
	                    });
	                },
	                _drawGridLines: function() {
	                    if (this.config.showGridLines) {
	                        var graphConfig = {
	                            graphCss: this._innerClass.gridLines,
	                            graphType: graphTypes.GridLines,
	                            xTicks: this._xTickInfos && this._xTickInfos.tickValues,
	                            yTicks: this._yTickValues,
	                            showGridBlocks: this.config.showGridBlocks,
	                            showSolidGridLines: this.config.showSolidGridLines
	                        };
	
	                        this._commonDraw(graphConfig);
	                    }
	                },
	                _changeXAxisScaleDomain: function(newXDomainValue, lastDateRange, isZoomIn) {
	                    this._lastDateRange = lastDateRange;
	                    if (this._changeScaleDomain(newXDomainValue, isZoomIn)) {
	                        this._displayViewAfterChangeDomain();
	                    }
	                },
	                _changeChartType: function(chartType) {
	                    var processFunc = this["_draw_" + chartType];
	                    if (processFunc) {
	                        this._clearChartGraphs();
	                        processFunc.call(this, chartType);
	                    }
	                },
	                _createSvgWrapper: function(elemFlag) {
	                    var cfg = this.config;
	                    var svg = this._svg = d3.select(cfg.container).append('div')
	                        .classed(this._innerClass.chartBody, true)
	                        .classed(elemFlag + '-class', true)
	                        .style("width", cfg.width + "px").style("height", cfg.height + "px")
	                        .append("svg").attr("width", cfg.width).attr("height", cfg.height);
	                    this._yAxisOuterGElem = svg.append("g").attr("class", this._innerClass.yAxis);
	                    this._outerGElem = svg.append("g")
	                        .attr("transform", this._getGElemTranslate()).attr("class", "chart-gelm");
	                    this._containerOffset = $(cfg.container).offset();
	                },
	                _clearChartGraphs: function() {
	                    for (var key in MainChartTypes) {
	                        var elem = this["_elem_" + chartTypes[key]];
	                        elem && elem.remove();
	                    }
	                },
	                _clearView: function(chartType) {
	                    if (this._svg) {
	                        this._svg.selectAll("g").remove();
	                    }
	
	                    this._clearTrackball();
	                },
	                _showLoading: function() {
	                    eventManager.trigger(eventManager.EventTypes.StartLoading);
	                },
	                _hideLoading: function() {
	                    eventManager.trigger(eventManager.EventTypes.EndLoading);
	                },
	                _removeIndicators: function(event) {
	                    eventManager.trigger(eventManager.EventTypes.ChangeIndicators, true, event.data.toRemove, event.data.indicatorParameters, event.data.removeAll, event.data.isFromCloseBtn);
	                },
	                _rebaseFundamentalData: function() {
	                    var view = this;
	                    if (!view._fundamentalsData || view._fundamentalsData.length <= 0) {
	                        return;
	                    }
	
	                    var mainTickerXLength = view._data ? view._data.length : 0;
	                    for (var fundamental in view._fundamentalsData) {
	                        if (view._fundamentalsData.hasOwnProperty(fundamental)) {
	                            if (view._fundamentalsData[fundamental].data && view._fundamentalsData[fundamental].data.length > 0) {
	                                var fundaData = view._fundamentalsData[fundamental].data;
	                                if (fundaData.length !== mainTickerXLength) {
	                                    fundaData = view._baselineXCordinates(fundaData, view._data);
	                                }
	                                fundaData.forEach(function(d) {
	                                    d.x = d.index;
	                                    d.value = d.value;
	                                    d.y = d.value;
	                                });
	                                view._fundamentalsData[fundamental].data = fundaData;
	                            }
	                        }
	                    }
	                },
	                _rebaseCompareData: function() {
	                    var view = this;
	                    var mainTickerData = view._data;
	                    if (!mainTickerData || mainTickerData.length === 0) {
	                        return;
	                    }
	                    var mainTickerXLength = view._data ? view._data.length : 0;
	                    var rootConfig = chartConfigManager.getConfig();
	                    var startDate = mainTickerData[0].date;
	                    var startIndex = dateUtil.toDateIndex(startDate);
	                    var endDate = mainTickerData[mainTickerXLength - 1].date;
	                    var endIndex = dateUtil.toDateIndex(endDate);
	                    var changeDateRange = false;
	                    var rootCfg = chartConfigManager.getConfig();
	                    var baseData = view._data; //line with the oldest history data 
	                    var newestData = view._data; //line with the latest update data
	                    var baseDataChanged = false;
	                    view._rebaseCompareTime = view._rebaseCompareTime || 0;
	                    view._compareData && view._compareData.forEach(function(c, cIndex) {
	                        if (c.Price.data.length > 0) {
	                            var compareData = c.Price.data,
	                                compareDataLength = compareData.length,
	                                cStartIndex = dateUtil.toDateIndex(compareData[0].date),
	                                cEndIndex = dateUtil.toDateIndex(compareData[compareDataLength - 1].date);
	                            var startDateCfg = rootCfg.startDate;
	                            if (rootConfig.AlignToCompare && chartConfigManager.getMainDataType() === MainDataTypes.Growth10K && chartConfigManager.isITFund()) {
	                                startDateCfg = StartDateTypes.Common;
	                            }
	                            if (compareData[0].date) {
	                                if (startDateCfg === StartDateTypes.Common) {
	                                    if (cStartIndex !== startIndex) {
	                                        startIndex = Math.max(cStartIndex, startIndex);
	                                        startDate = dateUtil.toDateFromIndex(startIndex);
	                                        baseData = compareData;
	                                        baseDataChanged = true;
	                                        changeDateRange = true;
	                                    }
	                                    if (cEndIndex !== endIndex) {
	                                        endIndex = Math.min(cEndIndex, endIndex);
	                                        endDate = dateUtil.toDateFromIndex(endIndex);
	                                        baseData = compareData;
	                                        baseDataChanged = true;
	                                        changeDateRange = true;
	                                    }
	                                } else if (startDateCfg === StartDateTypes.Earliest) {
	                                    if (cStartIndex < startIndex) {
	                                        startIndex = cStartIndex;
	                                        baseData = compareData;
	                                        baseDataChanged = true;
	                                    }
	                                    if (cEndIndex.dateIndex > endIndex) {
	                                        endIndex = cEndIndex;
	                                        newestData = compareData;
	                                        // baseDataChanged = true;
	                                    }
	                                } else { // "mainTicker"
	                                    if (cStartIndex < startIndex || cEndIndex > endIndex) {
	                                        changeDateRange = true;
	                                    }
	                                }
	                            }
	                        }
	                    });
	                    if (changeDateRange && view._rebaseCompareTime <= 2) {
	                        view._rebaseCompareTime++;
	                        var dataRange = [startDate, endDate];
	                        view._updateViewData(dataRange);
	                    } else {
	                        view._rebaseCompareTime > 0 && view._rebaseCompareTime--;
	                        changeDateRange = false;
	                        var toBeBasedData = view._compareData || [];
	                        for (var i = 0; i < toBeBasedData.length; i++) {
	                            var basedData = view._baselineXCordinates(toBeBasedData[i].Price.data, baseData, newestData);
	                            basedData.forEach(function(d) {
	                                d.x = d.index;
	                                d.y = d[view.yAttr];
	                            });
	                            toBeBasedData[i].Price.data = basedData;
	                        }
	                        view._compareData = toBeBasedData;
	                        if (baseDataChanged) {
	                            view._data = view._baselineXCordinates(view._data, baseData, newestData);
	                        }
	                    }
	
	                    return changeDateRange; //Abort current draw graph thread
	                },
	                _getWeekInYear: function(date) {
	                    var date2 = new Date(date.getFullYear(), 0, 1);
	                    var day1 = date.getDay();
	                    var day2 = date2.getDay();
	                    var d = Math.round((date.getTime() - date2.getTime() + (day2 - day1) * (24 * 60 * 60 * 1000)) / 86400000);
	                    return Math.ceil(d / 7) + 1;
	                },
	
	                _baselineXCordinates: function(toBaseline, baseData, newestData) {
	                    var baseLen = baseData.length;
	                    var baseDataPos = 0; //because data is sorted by date. we can optimize it.
	                    var toBaseLen = toBaseline.length;
	                    var rootCfg = chartConfigManager.getConfig();
	                    var mainDateIndex;
	                    var basedResult = [];
	                    var lastValidY = NaN;
	                    if (newestData && newestData[newestData.length - 1].dateIndex > baseData[baseLen - 1].dateIndex) {
	                        for (var i = 0; i < newestData.length; i++) {
	                            if (newestData[i].dateIndex > baseData[baseLen - 1].dateIndex) {
	                                baseData.push({
	                                    'dateIndex': newestData[i].dateIndex,
	                                    'date': newestData[i].date,
	                                    'index': i,
	                                    'close': NaN,
	                                    'y': NaN,
	                                    'value': NaN,
	                                    'lastValidY': baseData[baseLen - 1][this.yAttr]
	                                });
	                            }
	                        }
	                        baseLen = baseData.length;
	                    }
	                    if (toBaseLen > 0) {
	                        for (var i = 0, mainItem, baseItem; i < baseLen; i++) {
	                            mainItem = baseData[i];
	                            for (var j = baseDataPos; j < toBaseLen; j++) {
	                                baseItem = toBaseline[j];
	                                mainDateIndex = mainItem.dateIndex;
	                                var match = false;
	                                if (this.frequency === 'w' && baseItem.date && mainItem.date) {
	                                    if (('' + baseItem.date.getFullYear() + this._getWeekInYear(baseItem.date)) === ('' + mainItem.date.getFullYear() + this._getWeekInYear(mainItem.date))) {
	                                        match = true;
	                                    }
	                                } else if (baseItem.dateIndex === mainDateIndex) {
	                                    match = true;
	                                }
	                                if (match) {
	                                    baseItem.index = i; //Not use baseData[w].index.
	                                    basedResult.push(baseItem);
	                                    lastValidY = baseItem[this.yAttr];
	                                    baseDataPos++;
	                                    break;
	                                } else if (baseItem.dateIndex > mainDateIndex) {
	                                    basedResult.push({
	                                        'dateIndex': mainDateIndex,
	                                        'date': mainItem.date,
	                                        'index': i,
	                                        'close': NaN,
	                                        'y': NaN,
	                                        'value': NaN,
	                                        'lastValidY': lastValidY
	                                    });
	                                    break;
	                                }
	                            }
	                        }
	                    }
	
	                    return basedResult;
	                },
	                _appendHeaderForIndicators: function(currentIndicatorName) {
	                    if (!this._headerContainer) {
	                        return;
	                    }
	
	                    var cfg = this.config;
	                    var view = this;
	                    var $headerContainer = $(this._headerContainer[0]);
	                    var parentSpan = $headerContainer.find("." + this._innerClass.indicators);
	                    if (parentSpan) {
	                        parentSpan.empty();
	                    }
	
	                    if (!view._indicatorsData) {
	                        return;
	                    }
	
	                    chartConfigManager.getConfig().indicators.forEach(function(indicatorObj) {
	                        if (cfg.indicatorProperties.hasOwnProperty(indicatorObj.name)) {
	                            view._constructIndicatorLegend(parentSpan, indicatorObj, currentIndicatorName);
	                        }
	                    });
	                    var _headerHeight = $headerContainer.outerHeight(true);
	                    if (this._headerHeight !== _headerHeight) {
	                        this._headerHeight = _headerHeight;
	                    }
	                },
	                _createLegendSpan: function(parentSpan, indicatorName, indicatorLabel, pIndex, globalGraphClass, parameter) {
	                    var cfg = this.config;
	                    var view = this;
	                    var legendClass = "legend" + indicatorName + pIndex;
	                    var legendSpan = parentSpan.find("." + legendClass);
	
	                    var $closeElem;
	                    if (legendSpan.length === 0) {
	                        var legendCon = $("<span class='indicator-legend-" + pIndex + "'>");
	                        globalGraphClass && legendCon.addClass(globalGraphClass);
	                        if (cfg.showLegends) {
	                            legendCon.append("<span class='" + this._innerClass.indicatorsLegend + "'>");
	                        }
	
	                        legendCon.append("<span class='" + legendClass + "'>");
	                        legendCon.append("<span class='" + chartConfigManager.getConfig().cursorValueClass + ' ' + this._innerClass.indicatorsValue + legendClass.replace('legend', '') + "'>");
	                        if (cfg.showIndicatorCloseButton && indicatorLabel) {
	                            $closeElem = $("<span class='" + this._innerClass.closeButton + "'>&#215</span>").appendTo(legendCon);
	                        }
	
	                        legendCon.appendTo(parentSpan);
	                    }
	
	                    legendSpan = parentSpan.find("." + legendClass);
	                    if (legendSpan && indicatorLabel) {
	                        legendSpan.addClass(this._innerClass.indicatorsLegendText)
	                            .css("color", cfg.indicatorProperties[indicatorName].color[pIndex])
	                            .text(indicatorLabel);
	                        if (cfg.showLegends) {
	                            legendSpan.prev().css("background", cfg.indicatorProperties[indicatorName].color[pIndex]);
	                        }
	                        if (cfg.showIndicatorCloseButton) {
	                            $closeElem && $closeElem.bind('click', {
	                                toRemove: indicatorName,
	                                indicatorParameters: parameter,
	                                removeAll: cfg.indicatorProperties[indicatorName].removeAll === true,
	                                isFromCloseBtn: true
	                            }, view._removeIndicators);
	                        }
	                    }
	                },
	                /**
	                 * @function Create indicator legend
	                 * @param parentSpan    Indicatoe legend parent dom
	                 * @param indicatorObj  A object contains name/parameters
	                 * @param currentIndicatorName Identified current indicator in loop
	                 * 
	                 * @return void
	                 */
	                _constructIndicatorLegend: function(parentSpan, indicatorObj, currentIndicatorName, globalGraphClassList) {
	                    var cfg = this.config;
	                    var view = this;
	                    var indicatorName = indicatorObj.name;
	                    var parameters = indicatorObj.parameters;
	                    if (cfg.indicatorProperties.hasOwnProperty(indicatorName)) {
	                        if ((typeof(currentIndicatorName) === 'undefined' || currentIndicatorName === indicatorName) &&
	                            (view._indicatorsData[indicatorName])) {
	
	                            var indicatorLabelArr = view._getIndicatorLabelsArr(indicatorObj);
	                            if ($.isArray(indicatorLabelArr)) {
	                                indicatorLabelArr.forEach(function(indicatorLabel, pIndex) {
	                                    if (globalGraphClassList && globalGraphClassList.length > 0) {
	                                        view._createLegendSpan(parentSpan, indicatorName, indicatorLabel, pIndex, globalGraphClassList[pIndex], parameters[pIndex]);
	                                    } else {
	                                        var globalGraphClass = view._getGlobalClass();
	                                        view._createLegendSpan(parentSpan, indicatorName, indicatorLabel, pIndex, globalGraphClass, parameters[pIndex]);
	                                    }
	                                });
	                            }
	                        }
	                    }
	                },
	                /**
	                 * @function Get indicator labels array, which are define in languageConfig.js
	                 * @param indicatorObj  A object contains name/parameters
	                 * 
	                 * @return lableTextArr
	                 */
	                _getIndicatorLabelsArr: function(indicatorObj, mainIndicatorProperties) {
	                    if ($.isEmptyObject(indicatorObj)) {
	                        return null;
	                    }
	                    mainIndicatorProperties = mainIndicatorProperties || chartConfigManager.getConfig().charts.mainChart.indicatorProperties;
	                    var cfg = this.config;
	                    var lableTextArr = [];
	
	                    var indicatorName = indicatorObj.name;
	                    var parameters = indicatorObj.parameters;
	                    var indicatorLabels = this.langData[indicatorName];
	                    indicatorLabels = $.isArray(indicatorLabels) ? indicatorLabels : [indicatorLabels];
	
	                    // Legend parse function are defined in config.js
	                    // if has not, return label in array directly
	                    var getLegendArrParse = null;
	                    if (cfg.indicatorProperties && cfg.indicatorProperties[indicatorName] && cfg.indicatorProperties[indicatorName].legend) {
	                        getLegendArrParse = cfg.indicatorProperties[indicatorName].legend;
	                    } else if (mainIndicatorProperties[indicatorName] && mainIndicatorProperties[indicatorName].legend) {
	                        getLegendArrParse = mainIndicatorProperties[indicatorName].legend;
	                    }
	
	                    if ($.isFunction(getLegendArrParse)) {
	                        lableTextArr = getLegendArrParse(indicatorLabels, parameters);
	                    } else {
	                        lableTextArr = indicatorLabels;
	                    }
	
	                    return lableTextArr;
	                },
	                _clearAllData: function() {
	                    this._indicatorsData = null;
	                    this._compareData = null;
	                    this._dividendEffectData = null;
	                    this._eventsData = null;
	                    this._data = null;
	                },
	                _getCurrency: function(tickerObject, currencyField) {
	                    if (currencyField === 'currency') { //for cbnca, QS-12844
	                        return coreUtil.assignCurrency(tickerObject, chartConfigManager.getConfig());
	                    } else {
	                        return tickerObject[currencyField];
	                    }
	                },
	                _updateViewData: function(adjustedDateRange) {
	                    var view = this;
	                    var cfg = this.config;
	                    var chartconfig = chartConfigManager.getConfig();
	                    var $chartContainer = chartconfig.$container;
	                    view._showLoading();
	                    view._loading = true;
	                    view._hideDataNotAvailable();
	                    view._cancelNotRunedPreload();
	                    view._decideMinMaxAttrbute();
	                    chartConfigManager.fetchMainTickerData(function(res, preloadInfo) {
	                        view._clearAllData();
	                        view._clearView();
	                        if (res.status().errorCode === "0") {
	                            view._preloadInfo = preloadInfo;
	                            var resData = res.data()[0];
	                            var data = resData.Price.data;
	                            view.frequency = res.req().frequency();
	                            view.mainTickerObject = resData.tickerObject;
	                            if (resData.mifidExcludedPeriod) {
	                                view.mifidExcludedPeriod = resData.mifidExcludedPeriod;
	                            }
	                            if (data.length > 0) {
	                                data = view._reviseData(data);
	                                preloadInfo.dateRange = [data[0].date, data[data.length - 1].date];
	                                preloadInfo.loadedData = view._data = data;
	                                view._lastClosePrice = resData.Price.spos;
	                                view._lastOpenPrice = resData.Price.epos;
	                                view._lastTradeTime = resData.Price.lastTradeTime;
	                                view._priceCurrency = view._getCurrency(resData.tickerObject, resData.Price.currencyField);
	                                view._fundamentalsData = resData.Fundamentals;
	                                view._eventsData = resData.Events;
	                                if (chartConfigManager.getMainDataType() === MainDataTypes.DividendEffect) {
	                                    var fundamentalType = dataAdapter.Fundamental.MReturnIndex;
	                                    if (resData.Fundamentals && resData.Fundamentals[fundamentalType] &&
	                                        resData.Fundamentals[fundamentalType].data) {
	                                        view._dividendEffectData = view._reviseDividendEffectData(resData.Fundamentals[fundamentalType].data);
	                                    }
	                                } else {
	                                    view._getCompareData(res.data());
	                                    preloadInfo.loadedIndicatorsData = view._indicatorsData = resData.Indicators;
	                                    view._createDummyData(view._compareData);
	                                    preloadInfo.loadedCompareData = view._compareData;
	                                }
	
	                                var changeDateRange = view._rebaseCompareData();
	                                if (changeDateRange) {
	                                    view._hideLoading();
	                                    return;
	                                }
	
	                                view._rebaseFundamentalData();
	                                if (!view._viewInited) {
	                                    view._renderView();
	                                } else {
	                                    view._updateViewAfterDataChanged();
	                                }
	                                view._loadedData = view._data.slice(); //This because preload may no data, otherwise chart can't pan.
	                                view._createSelectionMode && view._createSelectionMode();
	
	                                if (preloadInfo.intervalType !== IntervalTypes.Max && !chartconfig.useEUTimeSeriesData && chartconfig.preload) {
	                                    view._timer = setTimeout(function() {
	                                        view._preloading = true;
	                                        view._loadingData = true;
	                                        view._fetchPreloadData();
	                                    }, view.config.preloadDelay);
	                                }
	                            }
	                        }
	
	                        //this logic just suit main and volume chart.
	                        if (!view._data || view._data.length === 0) {
	                            view.dataNotAvailable = true;
	                            view._showDataNotAvailable();
	                        } else {
	                            view.dataNotAvailable = false;
	                        }
	                        view._hideLoading();
	                        view._loading = false;
	                        chartconfig = chartConfigManager.getConfig();
	                        if (chartconfig.isFullyRendered && !chartconfig.triggeredFullyRendered) {
	                            clearTimeout(view._callbackTimer);
	                            view._callbackTimer = setTimeout(function() {
	                                chartConfigManager.setConfig({
	                                    triggeredFullyRendered: true
	                                });
	                                var _params = {
	                                    component: 'markets-components-svgchart',
	                                    width: $chartContainer.width(),
	                                    height: $chartContainer.height()
	                                };
	                                chartconfig.onFullyRendered(_params);
	                                chartconfig.onComplete(_params);
	                            }, 0);
	                        }
	                    }, adjustedDateRange);
	                },
	                _draw_Indicators: function() {
	                    var indicatorsData = this._indicatorsData;
	                    if (!indicatorsData) {
	                        return;
	                    }
	                    var view = this;
	                    var cfg = this.config;
	                    this._needTrackball = false;
	                    for (var indicatorName in indicatorsData) {
	                        if (cfg.indicatorProperties.hasOwnProperty(indicatorName)) {
	                            var indicatorData = indicatorsData[indicatorName];
	                            if (indicatorName === dataAdapter.IndicatorName.PrevClose &&
	                                (cfg.intervalType !== IntervalTypes.OneDay || chartConfigManager.isCompareOrPercentChart())) {
	                                continue;
	                            }
	
	                            if (!$.isArray(indicatorData)) {
	                                indicatorData = [indicatorData];
	                            }
	
	                            indicatorData.forEach(function(s, chartIndex) {
	                                view._draw_Indicators_graph(s, chartIndex, indicatorName);
	                            });
	                        }
	                    }
	                },
	                _draw_Indicators_graph: function(s, chartIndex, indicatorName, globalGraphClass) {
	                    var cfg = this.config;
	                    var index = 0;
	                    s.data.forEach(function(d) {
	                        d.x = index++;
	                        d.y = d.value;
	                    });
	                    var graphTypes = cfg.indicatorProperties[indicatorName].chartTypes;
	                    if (graphTypes) {
	                        var typeOfChart;
	                        if ($.isArray(graphTypes)) {
	                            typeOfChart = graphTypes[chartIndex];
	                        } else {
	                            typeOfChart = graphTypes;
	                        }
	
	                        this["_draw_" + typeOfChart + "_Indicators"](s.data, indicatorName, typeOfChart, chartIndex, globalGraphClass, s);
	                    } else {
	                        this._draw_lineChart_Indicators(s.data, indicatorName, 'lineChart', chartIndex, globalGraphClass);
	                    }
	
	                    this._needTrackball = true;
	                    if (this.config.indicatorProperties[indicatorName].showLegend === true) {
	                        var legendLineProperties = this.config.indicatorProperties[indicatorName];
	                        var legendPostText = ' | ';
	                        if ($.isFunction(legendLineProperties.legend)) {
	                            legendPostText += legendLineProperties.legend([this.langData[indicatorName]]);
	                        } else {
	                            legendPostText += legendLineProperties.legend;
	                        }
	                        this._draw_LineLegend(s.data, 'lineChart', legendLineProperties.color[0], legendPostText);
	                    }
	                },
	                _draw_dotChart_Indicators: function(data, indicatorName, chartType, chartIndex, globalGraphClass) {
	                    var cfg = this.config;
	                    var colorValue = this.config.indicatorProperties[indicatorName].color[chartIndex];
	                    var graphCss = this._innerClass[chartType + "-indicators"] + " " + indicatorName + "-" + chartIndex + "-class";
	                    var graphConfig = {
	                        data: data,
	                        color: colorValue,
	                        graphCss: graphCss,
	                        insertBeforeCss: this._innerClass.xAxis,
	                        graphType: graphTypes.Dot,
	                        yAttributeName: "value",
	                        dotRadius: cfg.dotChartRadius,
	                        globalGraphClass: globalGraphClass
	
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	
	                    var trackballConfig = {
	                        graphCss: graphCss,
	                        color: colorValue,
	                        data: data,
	                        globalGraphClass: globalGraphClass
	                    };
	
	                    this._commonDrawTrackball(trackballConfig);
	
	                },
	                _draw_LineLegend: function(data, graphType, legendColor, postText) {
	                    var cfg = this.config;
	                    var graphConfig = {
	                        xPosition: this._xScale(data.length * 0.95),
	                        yPosition: this._yScale(data[0].y),
	                        tagText: data[0].y + postText,
	                        graphCssText: this._innerClass.lineLegendTextClass,
	                        graphCss: this._innerClass.lineLegendClass,
	                        fillColor: legendColor,
	                        arrowWidth: cfg.tagProperties.arrowWidth,
	                        arrowHeight: cfg.tagProperties.arrowHeight,
	                        sideMargin: cfg.tagProperties.sideMargin,
	                        textTopMargin: cfg.tagProperties.textTopMargin,
	                        graphType: graphTypes.LineLegend,
	                        componentContainer: chartConfigManager.getConfig().$componentContainer,
	                    };
	
	                    this["_elem_" + graphType] = this._commonDraw(graphConfig);
	                },
	                _draw_lineChart_Indicators: function(data, indicatorName, graphType, chartIndex, globalGraphClass) {
	                    var colorValue = this.config.indicatorProperties[indicatorName].color[chartIndex];
	                    var graphCss = this._innerClass.indicators + " " + indicatorName + "-" + chartIndex + "-class";
	                    var graphConfig = {
	                        data: data,
	                        color: colorValue,
	                        graphCss: graphCss,
	                        insertBeforeCss: this._innerClass.xAxis,
	                        yAttributeName: "value",
	                        graphType: graphTypes.Line,
	                        globalGraphClass: globalGraphClass
	                    };
	
	                    this["_elem_" + graphType] = this._commonDraw(graphConfig);
	
	                    var trackballConfig = {
	                        graphCss: graphCss,
	                        color: colorValue,
	                        data: data,
	                        yScale: this._yScale,
	                        globalGraphClass: globalGraphClass
	                    };
	
	                    this._commonDrawTrackball(trackballConfig);
	                },
	                _mouseDown: function(e, position, headerHeight) {
	                    //d3.event.preventDefault();
	                    var view = this;
	                    var translateLeft = 0;
	                    if (this.config.yAxis.orient == "left" && this.config.yAxis.position == "outer") {
	                        translateLeft = this.config.margin.left + this.config.yAxis.width + this.config.yAxisMargin;
	                    }
	                    var item = this._findNearItem([position[0] - translateLeft, position[1]]);
	                    if (item) {
	                        this.drawObj.drawType(this._drawingType);
	                        this.drawObj.start(item, function(drawType) {
	                            view._changeDrawing(drawType);
	                        });
	                    }
	                    this._mousemove(e, position, headerHeight);
	                },
	                _getDecimalPlaces: function() {
	                    var decimal;
	                    var rootCfg = chartConfigManager.getConfig();
	                    if ($.isNumeric(this.config.decimalPlaces)) {
	                        decimal = this.config.decimalPlaces;
	                    } else if ($.isNumeric(rootCfg.decimalPlaces)) {
	                        decimal = rootCfg.decimalPlaces;
	                    } else {
	                        decimal = rootCfg.defaultDecimal;
	                    }
	                    return decimal;
	                },
	                _getYAxisDecimalPlaces: function(domain, tickCount, factor) {
	                    var decimal;
	                    var yAxisCfg = this.config.yAxis,
	                        rootCfg = chartConfigManager.getConfig();
	                    if ($.isNumeric(yAxisCfg.decimalPlaces)) {
	                        decimal = yAxisCfg.decimalPlaces;
	                    } else if ($.isNumeric(rootCfg.yAxisDecimal)) {
	                        decimal = rootCfg.yAxisDecimal;
	                    } else {
	                        decimal = rootCfg.defaultDecimal;
	                    }
	                    var factorDecimal = factor.toString().split(".")[1] && factor.toString().split(".")[1].length;
	                    if (factorDecimal > decimal) {
	                        decimal = factorDecimal;
	                    }
	                    return decimal;
	                },
	                _mouseUp: function() {
	                    //d3.event.preventDefault();
	                    if (this._drawingType) {
	                        this.drawObj.end(this._data.length);
	                    }
	                    this._changeDrawing();
	                },
	                _toApplyPercentage: function() {
	                    var rootCfg = chartConfigManager.getConfig();
	                    var isCompare = rootCfg.compareTickers.length > 0 &&
	                        chartConfigManager.getMainDataType() !== MainDataTypes.PerformancesGrowth &&
	                        chartConfigManager.getMainDataType() !== MainDataTypes.Growth10K && !rootCfg.drawNavAndPriceChart;
	
	                    var isPrice = this._checkIfPriceChart();
	                    return isCompare && isPrice;
	                },
	                _getLegendText: function(tickerObj) {
	                    var text = tickerObj['customTickerName'];
	                    if (!text) {
	                        var defalutField = 'clientTicker';
	                        var legendInfoLabel = chartConfigManager.getConfig().legendInfoLabel || defalutField;
	                        text = this.getTickerLabelByLegendInfoModel(legendInfoLabel, tickerObj, defalutField) || tickerObj['clientTicker'] || tickerObj['ticker'] || tickerObj['symbol'];
	                    }
	
	                    return text;
	                },
	                /**
	                 * @param "clientTikcer", "ticker", "{clientTicker}({MIC-CODE})"
	                 * @param tickerObj 
	                 * if some one no match, return defalutField,just like clientTicker
	                 */
	                getTickerLabelByLegendInfoModel: function(fields, tickerObj, defalutField) {
	                    var pattern = (/\{[\s\S]+?\}/g);
	                    var isAllFieldsExist = true;
	                    if (!pattern.test(fields)) {
	                        return tickerObj[fields]
	                    }
	                    var text = fields.replace(pattern, function(word) {
	                        name = word.substring(1, word.length - 1);
	                        if (tickerObj[name] && tickerObj[name] !== '') {
	                            return tickerObj[name];
	                        } else {
	                            isAllFieldsExist = false;
	                        }
	
	                    })
	                    return isAllFieldsExist ? text : tickerObj[defalutField];
	                },
	                _mousemove: function(e, position, offsetTop) {
	                    //d3.event.preventDefault();
	                    if (!this.mainTickerObject || this._panning || this._zooming) {
	                        return;
	                    }
	                    offsetTop = offsetTop || 0;
	                    var rootCfg = chartConfigManager.getConfig();
	                    var cursorType = rootCfg.cursorType;
	                    if (rootCfg.cursorType === 'off' && !this._drawingType) {
	                        return;
	                    }
	                    var yAxisCfg = this.config.yAxis;
	                    var indexPosition = [];
	                    for (var i = 0; i < position.length; i++) {
	                        indexPosition[i] = position[i];
	                    }
	                    if (yAxisCfg.position == "outer" && yAxisCfg.show && yAxisCfg.orient == "left") {
	                        if (position[0] - this.config.yAxisMargin - yAxisCfg.width < 0) {
	                            if (cursorType === CursorType.Crosshair) {
	                                eventManager.trigger(eventManager.EventTypes.ToggleCrossharis);
	                            }
	                            return;
	                        }
	                        indexPosition[0] = position[0] - this.config.yAxisMargin - yAxisCfg.width;
	                    }
	                    if (rootCfg.hightLightHoveredLine && this._compareData && this._compareData.length > 0 && chartConfigManager.getConfig().growthType !== "priceGrowth") {
	                        if ($.isFunction(this._hightLightHoveredLine)) {
	                            this._hightLightHoveredLine(indexPosition);
	                        };
	                    }
	                    var dataIndex = this._currentDataIndex = this._findNearIndex(indexPosition)
	                    var item = this._findNearItem(indexPosition);
	                    var isPrice = this._checkIfPriceChart();
	
	                    var popoverType = isPrice ? chartConfigManager.PopoverTypes.OHLCV : chartConfigManager.PopoverTypes.Growth;
	                    var mainDataType = chartConfigManager.getMainDataType();
	                    if (mainDataType === MainDataTypes.Growth10K) {
	                        popoverType = chartConfigManager.PopoverTypes.TenKGrowth;
	                    }
	                    if (rootCfg.crosshairMode === 's') {
	                        if (rootCfg.chartGenre === chartConfigManager.ChartGenre.FundChart || !isPrice || mainDataType === MainDataTypes.Growth10K) {
	                            popoverType = chartConfigManager.PopoverTypes.Simple;
	                        }
	                    }
	                    this._crossGlobalIndex = -1;
	                    var isPercent = this._toApplyPercentage();
	                    var nearest = this._findNearestData(item, isPercent, this._lastClosePrice); //this._findNearest(xMouse, isPercent, this._lastClosePrice);
	                    if (nearest !== null) {
	                        if (this._drawingType) {
	                            this.drawObj && this.drawObj.move(item);
	                        } else if (rootCfg.cursorType !== 'off') {
	                            var offset = rootCfg.$innerContainer.offset(),
	                                left,
	                                pageY,
	                                pageX;
	                            left = position[0] + $(this._svg[0]).offset().left - offset.left;
	                            pageY = e.touches && e.touches.length ? e.touches[0].pageY : e.pageY;
	                            pageX = e.touches && e.touches.length ? e.touches[0].pageX : e.pageX;
	                            var args = {
	                                'position': {
	                                    'top': pageY,
	                                    'left': left,
	                                    'pageX': pageX
	                                },
	                                'data': {
	                                    'main': {
	                                        'ticker': this._getLegendText(this.mainTickerObject), //.name || this.mainTickerObject.clientTicker,
	                                        'globalClass': this._getGlobalClass(this.mainTickerObject, '_crossGlobalIndex'),
	                                        'color': this.mainTickerObject['customTickerColor'] || rootCfg.mainTickerColor,
	                                        'data': nearest,
	                                        'tickerObject': this.mainTickerObject,
	                                        'currency': this._priceCurrency || this.mainTickerObject.customCurrency || this.mainTickerObject.currency,
	                                        'frequency': chartConfigManager.getConfig().frequency
	                                    },
	                                    'compare': [],
	                                    'indicators': [],
	                                    'fundamentals': [],
	                                    'events': [],
	                                },
	                                'popoverType': popoverType
	                            };
	                            if (offsetTop > 0) {
	                                args['offsetTop'] = offsetTop;
	                            }
	                            //hideBenchmark from user
	                            if (this._compareData &&
	                                this._compareData.length &&
	                                !(chartConfigManager.getMainDataType() === MainDataTypes.Growth && chartConfigManager.isITFund() && rootCfg.hideBenchmark)) {
	
	                                args.data.compare.push.apply(args.data.compare, this._getCompareArray(position, isPercent));
	                            }
	                            if (this._indicatorsData) {
	                                args.data.indicators.push.apply(args.data.indicators, this._getIndicatorsArray(position, isPercent));
	                            }
	                            if (mainDataType === MainDataTypes.DividendEffect) {
	                                args.data.compare.push.apply(args.data.compare, this._getDividendEffectArray(position, isPercent));
	                            }
	                            if (this._fundamentalsData) {
	                                args.data.fundamentals.push.apply(args.data.fundamentals, this._getFundamentalsArray(position, isPercent));
	                            }
	                            if (this._eventsData) {
	                                args.data.events.push.apply(args.data.events, this._getEventsArray(position, isPercent));
	                            }
	
	                            if (cursorType === CursorType.Crosshair) {
	                                eventManager.trigger(eventManager.EventTypes.ToggleCrossharis, args);
	                            } else if (cursorType === CursorType.Trackball) {
	                                eventManager.trigger(eventManager.EventTypes.ToggleTrackball, args);
	                            }
	
	                            eventManager.trigger(eventManager.EventTypes.ShowTrackball, dataIndex);
	                            var volumeCharts = {
	                                'main': args.data.main,
	                                indicators: []
	                            };
	                            var indicatorsOnVolumeChart = this._getIndicatorsArray(position, isPercent, rootCfg.charts.volumeChart);
	                            if (indicatorsOnVolumeChart) {
	                                volumeCharts.indicators = indicatorsOnVolumeChart;
	                            }
	                            eventManager.trigger(eventManager.EventTypes.ToggleTrackballVolume, volumeCharts);
	
	                            if (this._indicatorsData) {
	                                var indicatorsOnIndicatorChart = this._getIndicatorsArray(position, isPercent, rootCfg.charts.indicatorChart);
	                                if (indicatorsOnIndicatorChart) {
	                                    eventManager.trigger(eventManager.EventTypes.ToggleTrackballIndicators, indicatorsOnIndicatorChart);
	                                }
	                            }
	
	                            if (this._fundamentalsData) {
	                                var fundamentalsChart = this._getFundamentalsArray(position, isPercent, rootCfg.charts.fundamentalChart);
	                                if (fundamentalsChart) {
	                                    eventManager.trigger(eventManager.EventTypes.ToggleTrackballFundamentals, fundamentalsChart);
	                                }
	                            }
	
	
	                            if (this.drawObj && item && (this.drawObj.isEnter(item.mPosition) || this.drawObj.isCloseButton(item.mPosition))) {
	                                this._disablePan && this._disablePan();
	                                this._disableZoomIn && this._disableZoomIn();
	                            } else {
	                                if (this.config.selectionMode === SelectionModes.Pan) {
	                                    if (!isMobile) {
	                                        this._enablePan();
	                                    }
	                                } else if (this.config.selectionMode === SelectionModes.ZoomIn) {
	                                    this._enableZoomIn();
	                                }
	                            }
	
	                            this._VBPTipProcess && this._VBPTipProcess(position, offsetTop);
	                        }
	                    }
	                    this._currentDataIndex = null;
	                },
	                _validData: function(xMouse) {
	                    var yAttr = this.yAttr;
	                    var allData = [this._data];
	                    var compareLen = this._compareData && this._compareData.length;
	                    for (var i = 0; i < compareLen; i++) {
	                        if (this._compareData[i].Price && this._compareData[i].Price.data) {
	                            allData.push(this._compareData[i].Price.data);
	                        }
	                    }
	                    for (var i = 0; i < allData.length; i++) {
	                        var d = allData[i] && allData[i][xMouse] && allData[i][xMouse][yAttr];
	                        if (!isNaN(d)) {
	                            return true;
	                        }
	                    }
	                    return false;
	                },
	                _findNearIndex: function(position) {
	                    var dataList = this._data;
	                    var allData = [this._data].concat(this._compareData || []);
	                    if (!dataList || dataList.length === 0) {
	                        return;
	                    }
	                    var dataLen = dataList.length;
	                    var view = this;
	                    var oriXMouse = this._xScale.invert(position[0]);
	                    var xMouse = Math.round((oriXMouse - this._xScale.domain()[0]));
	                    if (xMouse < 0) {
	                        xMouse = 0;
	                    }
	                    if (xMouse >= dataLen) {
	                        xMouse = dataLen - 1;
	                    }
	                    if (!this._validData(xMouse)) {
	                        var factor;
	                        if (oriXMouse >= xMouse) {
	                            factor = -1;
	                        } else {
	                            factor = 1;
	                        }
	                        var loop = 1;
	                        var leftSearched = false,
	                            rightSearched = false;
	                        do {
	                            factor *= -1;
	                            xMouse = xMouse + factor * (loop++);
	                            if (xMouse < 0) {
	                                leftSearched = true;
	                                continue;
	                            } else if (xMouse >= dataLen) {
	                                rightSearched = true;
	                                continue;
	                            }
	                        } while (!this._validData(xMouse) && (!leftSearched || !rightSearched));
	                    }
	
	                    return xMouse;
	                },
	                _findNearItem: function(position, targetDataList, forceFind) {
	                    forceFind = forceFind === true ? true : false; //it is used by drawings
	                    targetDataList = targetDataList || this._data;
	                    if (targetDataList) {
	                        var dataIndex = this._currentDataIndex;
	                        (forceFind || isNaN(dataIndex) || dataIndex === null) && (dataIndex = this._findNearIndex(position));
	                        var dataItem = targetDataList[dataIndex];
	                        var mPosition = dataIndex > -1 ? [this._xScale(dataIndex), position[1]] : position;
	                        return {
	                            datapoint: dataItem,
	                            mPosition: mPosition
	                        };
	                    }
	                },
	                _convertToPrice: function(item, spos) {
	                    if (item && item.datapoint) {
	                        var datapoint = item.datapoint;
	                        return {
	                            open: spos * (1 + datapoint.open / 100),
	                            close: spos * (1 + datapoint.close / 100),
	                            high: spos * (1 + datapoint.high / 100),
	                            low: spos * (1 + datapoint.low / 100),
	                            y: spos * (1 + datapoint.y / 100),
	                            x: datapoint.x,
	                            date: datapoint.date,
	                            volume: datapoint.volume
	                        };
	                    }
	                },
	                _convertToFundPrice: function(item, spos) {
	                    if (item && item.datapoint) {
	                        var datapoint = item.datapoint;
	                        return {
	                            value: spos * (1 + datapoint.value / 100),
	                            x: datapoint.x,
	                            date: datapoint.date,
	                        };
	                    }
	                },
	                _convertPercentageToPrice: function(valueToConvert, baseValue) {
	                    return baseValue * (1 + valueToConvert / 100);
	                },
	                _getGlobalClass: function(tickerObj, globalIndexAttr, globalIndex) {
	                    var globalClass = '';
	                    globalIndexAttr = globalIndexAttr || '_globalGraphIndex';
	                    var index;
	                    if ($.isNumeric(globalIndex)) {
	                        index = globalIndex;
	                    } else if ($.isNumeric(this[globalIndexAttr])) {
	                        index = this[globalIndexAttr]++;
	                    }
	                    if ($.isNumeric(index)) {
	                        if (!tickerObj || !tickerObj['customTickerColor']) {
	                            globalClass = " globalIndex-" + index;
	                        }
	                    }
	                    return globalClass;
	                },
	                _getCompareArray: function(position, isPercent) {
	                    var compareColors = chartConfigManager.getConfig().compareColors;
	                    var compareArray = []
	                    var view = this;
	                    this._compareData.forEach(function(compare, cIndex) {
	                        var legendColorIndex = (cIndex >= compareColors.length) ? cIndex % compareColors.length : cIndex;
	                        var legendColor = compare.tickerObject['customTickerColor'] || compareColors[legendColorIndex];
	                        var compareItem = {
	                            ticker: view._getLegendText(compare.tickerObject),
	                            data: view._findNearestData(view._findNearItem(position, compare.Price.data), isPercent, compare.Price.spos),
	                            color: legendColor,
	                            currency: compare.tickerObject.customCurrency || compare.tickerObject.currency,
	                            tickerObject: compare.tickerObject,
	                            globalClass: view._getGlobalClass(compare.tickerObject, '_crossGlobalIndex'),
	                        };
	                        var fundamentalsData = {};
	                        for (var fundamentalName in compare.Fundamentals) {
	                            if (view.config.fundamentalProperties && view.config.fundamentalProperties[fundamentalName] && view.config.fundamentalProperties[fundamentalName].showWithCompare) {
	                                fundamentalsData[fundamentalName] = compare.Fundamentals[fundamentalName];
	                            }
	                        }
	                        if (!$.isEmptyObject(fundamentalsData)) {
	                            compareItem.fundamentals = view._getFundamentalsArray(position, isPercent, null, fundamentalsData);
	                        }
	                        compareArray.push(compareItem);
	                    });
	                    return compareArray;
	                },
	                _getDividendEffectArray: function(position, isPercent) {
	                    var cfg = this.config;
	                    var rootCfg = chartConfigManager.getConfig();
	                    var dividendEffectArray = []
	                    var view = this;
	                    var dividendEffectData = view._dividendEffectData ? view._dividendEffectData : view._reviseMainDividendEffectData(view._data);
	                    dividendEffectArray.push({
	                        ticker: view.mainTickerObject.ticker + this.langData['mainChartHeaderDividendEffectLabel'],
	                        data: view._findNearestData(view._findNearItem(position, dividendEffectData), isPercent, view._lastClosePrice),
	                        color: rootCfg.charts.mainChart.dividendEffectProperties.color
	                    });
	                    return dividendEffectArray;
	                },
	                _normalizeEventsData: function(eventsData) {
	                    if (eventsData && eventsData.length > 0 && this._data && this._data.length > 0) {
	                        var baseData = this._data;
	                        var baseDataLength = baseData.length;
	                        var baseDateIndex;
	                        eventsData.forEach(function(item) {
	                            item.x = -100; //will not draw it.
	                            for (var i = 0; i < baseDataLength; i++) {
	                                baseDateIndex = baseData[i].dateIndex;
	                                if (item.dateIndex === baseDateIndex) {
	                                    item.x = i;
	                                    break;
	                                } else if (item.dateIndex < baseDateIndex) {
	                                    if (i === 0) {
	                                        item.x = -100;
	                                        break;
	                                    } else {
	                                        item.x = i;
	                                        break;
	                                    }
	                                }
	                            }
	
	                            item.y = item.value;
	                        });
	                    }
	                },
	                _getEventsArray: function(position, isPercent) {
	                    var mainChartConfig = chartConfigManager.getConfig().charts.mainChart;
	                    var limitSpan = isNaN(mainChartConfig.eventProperties.xRadious) ? 5 : mainChartConfig.eventProperties.xRadious;
	                    var xMouse = this._xScale.invert(position[0]);
	                    var eventsArray = [];
	                    var view = this;
	                    for (var eventName in this._eventsData) {
	                        var eventPropertyName = Object.keys(dataAdapter.Events).filter(function(e) {
	                            return dataAdapter.Events[e] === eventName
	                        })[0];
	                        var eventsCopy = view._eventsData[eventName].data.slice();
	                        view._normalizeEventsData(eventsCopy);
	                        if (mainChartConfig.eventProperties.hasOwnProperty(eventPropertyName)) {
	                            if (eventName === dataAdapter.Events.Dividend && !mainChartConfig.showDividend) {
	                                continue;
	                            }
	                            var eventProperty = mainChartConfig.eventProperties[eventPropertyName];
	                            var eventLabel = eventProperty.labels || '';
	                            var nearestEventItem = view._findNearestEvent(position, eventsCopy, limitSpan);
	                            if (eventLabel && nearestEventItem) {
	                                var eventData = {
	                                    name: this.langData[eventLabel],
	                                    data: {
	                                        yDate: nearestEventItem.date,
	                                        yValue: nearestEventItem.y,
	                                        x: nearestEventItem.x
	                                    },
	                                    color: nearestEventItem.upFlag === 0 ? eventProperty.downColor : eventProperty.color,
	                                }
	                                if (eventName === dataAdapter.Events.Earnings) {
	                                    eventData.data.yFrequency = this.langData[nearestEventItem.frequency];
	                                }
	                                eventsArray.push(eventData);
	                            }
	                        }
	                    }
	                    return eventsArray;
	                },
	                _findNearestEvent: function(position, eventsData, limitSpan) {
	                    var view = this;
	                    var nearestEvent = null;
	                    if (!eventsData || eventsData.length === 0 || !position || !limitSpan) {
	                        return null;
	                    }
	                    var nearestEvents = eventsData.filter(function(e) {
	                        var xDataPoint = view._xScale(e.x);
	                        if (view.config.yAxis && view.config.yAxis.position == 'outer' && view.config.yAxis.orient == 'left') {
	                            var offset = isNaN(view.config.yAxis.width + (view.config.yAxisMargin || 0)) ? 0 : (view.config.yAxis.width + (view.config.yAxisMargin || 0));
	                            xDataPoint += offset;
	                        }
	                        return position[0] >= (xDataPoint - limitSpan) && position[0] <= (xDataPoint + limitSpan);
	                    });
	                    if (nearestEvents && nearestEvents.length > 0) {
	                        nearestEvent = nearestEvents[0];
	                    }
	                    return nearestEvent;
	                },
	                _getFundamentalsArray: function(position, isPercent, chartConfigToUse, fundamentalsData) {
	                    var chartCfg = chartConfigToUse ? chartConfigToUse : chartConfigManager.getConfig().charts.mainChart;
	                    var fundamentalsArray = [];
	                    var view = this;
	                    fundamentalsData = fundamentalsData || this._fundamentalsData;
	                    for (var fundamentalName in fundamentalsData) {
	                        if (chartCfg.fundamentalProperties.hasOwnProperty(fundamentalName)) {
	                            var fundamentalConfig = chartConfigManager.getConfig().fundamentals.filter(function(f) {
	                                return f === fundamentalName;
	                            });
	                            var fundamentalLabel = view.langData[util.lowerFirstChar(fundamentalName)] || fundamentalName;
	                            if (fundamentalLabel) {
	                                var fundamentalData = fundamentalsData[fundamentalName].data;
	                                fundamentalData.forEach(function(d, i) {
	                                    d.y = d.value;
	                                });
	                                fundamentalsArray.push({
	                                    decimalPlaces: chartCfg.fundamentalProperties[fundamentalName].decimalPlaces,
	                                    ticker: fundamentalLabel,
	                                    name: fundamentalName,
	                                    showLegend: chartCfg.fundamentalProperties[fundamentalName].showLegend,
	                                    data: view._findNearestData(view._findNearItem(position, fundamentalData), false, fundamentalsData[fundamentalName].spos),
	                                    color: chartCfg.fundamentalProperties[fundamentalName].color,
	                                    globalClass: !chartCfg.fundamentalProperties[fundamentalName].skipDrawGraph && view._getGlobalClass(null, '_crossGlobalIndex')
	                                });
	                            }
	                        }
	                    }
	                    return fundamentalsArray;
	                },
	
	                _getIndicatorsArray: function(position, isPercent, chartConfigToUse) {
	                    var mainChartConfig = chartConfigManager.getConfig().charts.mainChart;
	                    var chartCfg = chartConfigToUse ? chartConfigToUse : mainChartConfig;
	                    var indicatorsArray = [];
	                    var view = this;
	                    for (var indicatorName in this._indicatorsData) {
	                        if (chartCfg.indicatorProperties.hasOwnProperty(indicatorName)) {
	                            var indicatorConfig = chartConfigManager.getConfig().indicators.filter(function(i) {
	                                return i.name === indicatorName;
	                            });
	
	                            // code for drawing legend, and fill data
	                            var indicatorObj = indicatorConfig.length > 0 ? indicatorConfig[0] : {};
	                            var indicatorLabelArr = view._getIndicatorLabelsArr(indicatorObj, chartCfg.indicatorProperties);
	                            if ($.isArray(indicatorLabelArr)) {
	                                indicatorLabelArr.forEach(function(indicatorLabel, pIndex) {
	                                    view._prepareIndicatorsArray(indicatorsArray, indicatorName, pIndex, indicatorLabel, position, isPercent, chartCfg);
	                                });
	                            }
	                        }
	                    }
	                    return indicatorsArray;
	                },
	                _prepareIndicatorsArray: function(indicatorsArray, indicatorName, chartIndex, indicatorLabel, position, isPercent, chartCfg) {
	                    if (indicatorName === dataAdapter.IndicatorName.VBP) {
	                        return;
	                    }
	                    var view = this;
	                    var indicatorData = view._indicatorsData[indicatorName][chartIndex].data;
	                    indicatorData.forEach(function(d, i) {
	                        d.y = d.value;
	                    });
	                    indicatorsArray.push({
	                        ticker: indicatorLabel,
	                        name: indicatorName,
	                        data: view._findNearestData(view._findNearItem(position, indicatorData), isPercent, view._indicatorsData[indicatorName][chartIndex].spos),
	                        color: chartCfg.indicatorProperties[indicatorName].color[chartIndex],
	                        globalClass: view._getGlobalClass(null, '_crossGlobalIndex') //' globalIndex-' + ($.isNumeric(this._crossGlobalIndex) ? this._crossGlobalIndex++ : '')
	                    });
	                },
	                _findNearestData: function(item, isPercentValue, spos) {
	                    if (item) {
	                        return isPercentValue ? this._convertToPrice(item, spos) : item.datapoint;
	                    }
	                },
	                _showDataNotAvailable: function(type) {
	                    if (!this._svg) {
	                        return;
	                    }
	                    this._clearView();
	                    var elem = this._svg.append('g').append('text').attr("transform", "translate(" + this._validWidth / 2 + "," + this.config.height / 2 + ")");
	                    var message = this.langData['datanotavailable'];
	                    if (type == "changeToDailyFreq") {
	                        message = this.langData['changetodailyfrequency'];
	                    }
	                    var textWidth = this._getTextWidthHeight(message).width;
	                    //text need to be wraped when too long
	                    if (textWidth > (this._validWidth - 20)) {
	                        var mesArr = message.split('|');
	                        for (var i in mesArr) {
	                            elem.append('tspan')
	                                .attr('class', 'dataNotAvailable')
	                                .attr('dy', i * 1.5 + 'em')
	                                .attr('x', '0')
	                                .text(mesArr[i]);
	                        }
	                    } else {
	                        message = message.replace('|', '');
	                        elem.append('tspan')
	                            .attr('class', 'dataNotAvailable')
	                            .text(message);
	                    }
	                    this._$DataNotAvailableElem = elem;
	                },
	                _getTextWidthHeight: function(text) {
	                    var $textSpan = $('<span style="display:inline-block;">' + text + '</span>').appendTo(this.config.container);
	                    var width = $textSpan.outerWidth(true);
	                    var height = $textSpan.outerHeight(true);
	                    $textSpan.remove();
	                    return {
	                        width: width,
	                        height: height
	                    };
	                },
	                _hideDataNotAvailable: function() {
	                    this._$DataNotAvailableElem && this._$DataNotAvailableElem.remove();
	                },
	                _draw_Fundamentals: function(renderView, fundamentalStartIndex) {
	                    var fundamentalsData = this._fundamentalsData;
	                    var view = this;
	                    var cfg = this.config;
	                    this._needTrackball = false;
	                    chartConfigManager.getConfig().fundamentals.forEach(function(fundamentalName, chartIndex) {
	                        if (cfg.fundamentalProperties.hasOwnProperty(fundamentalName) && !cfg.fundamentalProperties[fundamentalName].skipDrawGraph) {
	                            if (renderView) {
	                                view._renderView(fundamentalName);
	                            }
	
	                            var fundamental = fundamentalsData && fundamentalsData[fundamentalName];
	                            if (fundamental && !fundamental.DailyDataPoint) {
	                                var fundamental = fundamentalsData[fundamentalName];
	                                if (fundamental && fundamental.data && fundamental.data.length > 0) {
	                                    var index = 0;
	                                    fundamental.data.forEach(function(d) {
	                                        d.x = index++;
	                                        d.y = d.value;
	                                    });
	                                    view._draw_lineChart_Fundamentals(fundamental.data, fundamentalName, 'lineChart', chartIndex, fundamentalStartIndex++);
	                                    view._needTrackball = true;
	                                }
	                            } else {
	                                eventManager.trigger(eventManager.EventTypes.FundamentalNotAvailable, true);
	                                if (view._isFundamentalChart) {
	                                    if (fundamental && fundamental.DailyDataPoint) {
	                                        view._showDataNotAvailable('changeToDailyFreq');
	                                    } else {
	                                        view._showDataNotAvailable();
	                                    }
	                                }
	                            }
	                        }
	                    });
	                },
	                _draw_lineChart_Fundamentals: function(data, fundamentalName, chartType, chartIndex, globalIndex) {
	                    var graphCss = this._innerClass.fundamentals + " " + fundamentalName +
	                        "-" + chartIndex + "-class" + " globalIndex-" + globalIndex;
	
	                    var graphConfig = {
	                        data: data,
	                        color: this.config.fundamentalProperties[fundamentalName].color,
	                        graphCss: graphCss,
	                        insertBeforeCss: this._innerClass.xAxis,
	                        xAttributeName: "x",
	                        yAttributeName: "y",
	                        graphType: graphTypes.Line,
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	
	                    var trackballConfig = {
	                        graphCss: graphCss,
	                        color: this.config.fundamentalProperties[fundamentalName].color,
	                        data: data,
	                        yScale: this._yScale
	                    };
	
	                    this._commonDrawTrackball(trackballConfig);
	                },
	                _appendHeaderForFundamentals: function(fundamentalName) {
	                    if (!this._headerContainer) {
	                        return;
	                    }
	
	                    var cfg = this.config;
	                    var view = this;
	                    var $headerContainer = $(this._headerContainer[0]);
	                    var parentSpan = $headerContainer.find("." + this._innerClass.fundamentals);
	                    if (parentSpan) {
	                        parentSpan.empty();
	                    }
	
	                    chartConfigManager.getConfig().fundamentals.forEach(function(f) {
	                        if (cfg.fundamentalProperties.hasOwnProperty(f)) {
	                            if (fundamentalName) { // drawing fundmental chart header legend
	                                view._constructFundamentalLegend(parentSpan, fundamentalName);
	                            } else if (view._fundamentalsData && view._fundamentalsData[f] && view._fundamentalsData[f].data && view._fundamentalsData[f].data.length) { //drawing main chart header legend when fundamental data is available
	                                view._constructFundamentalLegend(parentSpan, f);
	                            }
	                        }
	                    });
	                    var _headerHeight = $headerContainer.outerHeight(true);
	                    if (this._headerHeight !== _headerHeight) {
	                        this._headerHeight = _headerHeight;
	                    }
	                },
	                _constructFundamentalLegend: function(parentSpan, fundamentalName) {
	                    var cfg = this.config;
	                    var view = this;
	                    if (parentSpan && fundamentalName && !cfg.fundamentalProperties[fundamentalName].skipDrawGraph) {
	                        var legendClass = "legend" + fundamentalName;
	                        var legendSpan = parentSpan.find("." + legendClass);
	                        var fundamentalLable = this.langData[fundamentalName];
	                        if (legendSpan.length === 0) {
	                            var $legendCon;
	                            if ($.isNumeric(view._globalGraphIndex)) {
	                                $legendCon = $("<span class='globalIndex-" + (view._globalGraphIndex++) + "'>").appendTo(parentSpan);
	                            } else {
	                                $legendCon = parentSpan;
	                            }
	
	                            if (cfg.showLegends) {
	                                $legendCon.append("<span class='" + view._innerClass.fundamentalsLegend + "'>");
	                            }
	                            $legendCon.append("<span class='" + legendClass + "'>");
	                            $legendCon.append("<span class='" + chartConfigManager.getConfig().cursorValueClass + ' ' + view._innerClass.fundamentalsValue + legendClass.replace('legend', '') + "'>");
	                            if (cfg.showFundamentalCloseButton && fundamentalLable) {
	                                $legendCon.append("<span class='" + view._innerClass.closeButton + "'>&#215</span>");
	                            }
	                        }
	
	                        legendSpan = parentSpan.find("." + legendClass);
	                        if (legendSpan && fundamentalLable) {
	                            legendSpan.addClass(view._innerClass.fundamentalsLegendText)
	                                .css("color", cfg.fundamentalProperties[fundamentalName].color)
	                                .text(fundamentalLable);
	                            if (cfg.showLegends) {
	                                legendSpan.prev().css("background", cfg.fundamentalProperties[fundamentalName].color);
	                            }
	                            if (cfg.showFundamentalCloseButton) {
	                                legendSpan.next().next().bind('click', {
	                                    toRemove: fundamentalName
	                                }, view._removeFundamentals);
	                            }
	                        }
	                    }
	                },
	                _removeFundamentals: function(event) {
	                    eventManager.trigger(eventManager.EventTypes.ChangeFundamental, event.data.toRemove, true);
	                }
	            };
	
	            return util.extendClass(baseView, baseChartExtend);
	        }
	
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core) {
	    "use strict";
	    var $ = core.$;
	
	    /**
	     * Base View Model
	     *
	     * It's the base of all view of the components.
	     * It defines common interface that all views should have.
	     *
	     * @constructor
	     */
	    var baseView = function(config) {
	        this.config = config;
	        this.$el = $(this.config.container);
	        this._init(config);
	    }
	
	    baseView.prototype = {
	        _init: function(config) {
	            $.extend(true, this.config, config);
	            this._renderView();
	        },
	        _renderView: function() {},
	        show: function() {
	            this.$el.show();
	            return this;
	        },
	        hide: function() {
	            this.$el.hide();
	            return this;
	        },
	        remove: function() {
	            this.$el.remove();
	        }
	    };
	
	    return baseView;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core) {
	    "use strict";
	
	    var $ = core.$;
	    var dateFmt, numFmt;
	
	    /**
	     *   Make sure console log/debug won't cause errors in unsupported browsers
	     */
	    if (typeof console !== 'object') {
	        window.console = {};
	    }
	
	    if (typeof console.log !== 'function' && typeof console.log !== 'object') {
	        console.log = function() {};
	    }
	    if (typeof console.debug !== 'function' && typeof console.debug !== 'object') {
	        console.debug = console.log;
	    }
	
	    /**
	     *   Helper function to correctly set up the prototype chain, for subclasses.
	     *   Similar to `goog.inherits`, but uses a hash of prototype properties and
	     *   class properties to be extended.
	     */
	    function extendClass(parentClass, protoProps, staticProps) {
	        var child;
	
	        // The constructor function for the new subclass is either defined by you
	        // (the "constructor" property in your `extend` definition), or defaulted
	        // by us to simply call the parent's constructor.
	        if (protoProps && protoProps.hasOwnProperty('constructor')) {
	            child = protoProps.constructor;
	        } else {
	            child = function() {
	                return parentClass.apply(this, arguments);
	            };
	        }
	
	        // Add static properties to the constructor function, if supplied.
	        $.extend(true, child, parentClass, staticProps);
	
	        // Set the prototype chain to inherit from `parent`, without calling
	        // `parent`'s constructor function.
	        var surrogate = function() {
	            this.constructor = child;
	        };
	        surrogate.prototype = parentClass.prototype;
	        child.prototype = new surrogate;
	
	        // Add prototype properties (instance properties) to the subclass,
	        // if supplied.
	        if (protoProps) $.extend(true, child.prototype, protoProps);
	
	        return child;
	    }
	
	    function isTouchCapable() {
	        var ret = false;
	        var test1 = 'ontouchstart' in window;
	        var test2 = 'onmsgesturechange' in window;
	
	        if (test1 || test2) {
	            ret = true;
	        }
	        return ret;
	    }
	
	    function dashesToCamel(str) {
	        return str.replace(/-([a-z])/g, function(g) {
	            return g[1].toUpperCase();
	        });
	    }
	
	    function camelToDashes(str) {
	        //return str.replace(/([a-z][A-Z])/g, function (g) { return g[0] + '-' + g[1]; }).toLowerCase();
	        return str.replace(/([A-Z])/g, "-$1").replace(/^-/, "").toLowerCase();
	    }
	
	    function capFirstChar(str) {
	        return str.charAt(0).toUpperCase() + str.slice(1);
	    }
	
	    function lowerFirstChar(str) {
	        return str.charAt(0).toLowerCase() + str.slice(1);
	    }
	
	    var isStaticDate = function(str) {
	        return /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(str);
	    };
	
	    function boldSearch(input, search, needHighLight) {
	        if (!needHighLight) {
	            return input;
	        }
	
	        var specialChar = new RegExp("([\$|\!|\+|\-|\/|\\|\*|\.])", "i");
	        search = search.replace(specialChar, "\\" + "$1");
	        var rgx = new RegExp(search, "i");
	        var tmatch = input.match(rgx);
	        if (tmatch != null) {
	            input = input.replace(rgx, "<em>" + tmatch[0] + "</em>");
	        }
	
	        return input;
	    }
	
	    function contains(f, c) {
	        if (!f) {
	            return false;
	        }
	        var bCB2F = false;
	        if (f.contains) {
	            bCB2F = f.contains(c);
	        } else {
	            bCB2F = (typeof f.compareDocumentPosition == "function" && f.compareDocumentPosition(c) == 20) ? true : false;
	        }
	        return bCB2F;
	    }
	
	    function arrConcat(obj, arr) {
	        if ($.isArray(obj))
	            obj = obj.concat(arr);
	        else
	            obj = arr;
	
	        return obj;
	    }
	
	    /**
	     * Class to handle user agent matching
	     */
	    function DeviceType() {
	        var useragent = navigator.userAgent,
	            device;
	
	        if (useragent.match(/Android/i)) {
	            device = 'android';
	        } else if (useragent.match(/webOS/i)) {
	            device = 'webos';
	        } else if (useragent.match(/iPhone/i)) {
	            device = 'iphone';
	        } else if (useragent.match(/iPod/i)) {
	            device = 'ipod';
	        } else if (useragent.match(/iPad/i)) {
	            device = 'ipad';
	        } else if (useragent.match(/Windows Phone/i)) {
	            device = 'windows phone';
	        } else if (useragent.match(/windows ce/i)) {
	            device = "windows ce";
	        } else if (useragent.match(/SymbianOS/i)) {
	            device = 'symbian';
	        } else if (useragent.match(/BlackBerry|RIM|BB\d{2}/)) {
	            device = 'blackberry';
	        } else {
	            device = undefined;
	        }
	
	        /** wrapper for device matching
	         * @param String - a list of device strings
	         * @return Function - the function that will run for the device method
	         **/
	        function isDevice() {
	            var args = Array.prototype.slice.call(arguments);
	            var matchDevice = function(obj) {
	                return obj === device
	            };
	
	            return function() {
	                return args.some(matchDevice);
	            }
	        }
	
	        this.android = isDevice('android');
	        this.iPhone = isDevice('iphone');
	        this.iPad = isDevice('ipad');
	        this.blackberry = isDevice('blackberry');
	        this.windowsPhone = isDevice('windows phone');
	        this.windowsCe = isDevice('windows ce');
	        this.iOS = isDevice('iphone', 'ipad', 'ipod');
	        this.mobile = function() {
	            return device !== undefined;
	        }
	    }
	
	    function numberFormatter(locale, n, f, sep, needmark, isFormat, showOriginalDecimal) {
	        var MSize = [1e+12, 1e+9, 1e+6, 1e+3];
	        var Mark = ['T', 'bil', 'mil', 'k'];
	        var zs = ['000', '00', '0'];
	        var sep = (sep != undefined) ? sep : " ";
	        var ds = ".";
	        var gs = ",";
	        var lang = locale.split('-')[0];
	        if (showOriginalDecimal) {
	            var strn = n + '';
	            f = strn.indexOf('.') === -1 ? 0 : (strn.length - strn.indexOf('.') - 1);
	        }
	        if ($.inArray(lang, ['fr', 'it', 'es', 'de', 'pt']) > -1) {
	            Mark = ['T', 'G', 'M', 'K'];
	            ds = ",";
	            gs = ".";
	        }
	        var ne = 0;
	        if (n == Infinity || isNaN(n)) {
	            return '--';
	        }
	        if (needmark === false && isFormat === false) {
	            return (f != undefined) ? parseFloat(n).toFixed(f < 0 ? 2 : f) : n;
	        }
	        if (f != undefined) {
	            n = +parseFloat(n).toFixed(f < 0 ? 2 : f);
	        }
	        if (n < 0) {
	            ne = 1;
	            n = -n;
	        }
	        try {
	            var t = n;
	            var m = '';
	            var ret = '';
	            if (needmark !== false) {
	                if (n >= MSize[MSize.length - 1]) { //divide the million , billion or thousand
	                    for (var i = 0, size = MSize.length; i < size; i++) {
	                        if (n >= MSize[i]) {
	                            t = n / MSize[i];
	                            m = sep + Mark[i];
	                            break;
	                        }
	                    }
	                }
	            }
	            if (f < 0) { // if f is invalid,it will be used the default value.
	                f = m == '' ? 1 : 2;
	            }
	            if (isFormat === false) {
	                ret = t.toFixed(f) + m;
	                // ne is a negative flag, unit abbreviations format logic lack this flag
	                if (ne == 1) {
	                    ret = '-' + ret;
	                }
	                return ret;
	            }
	            var p1 = Math.floor(t);
	            //integer
	            var p2 = t - p1;
	            var ar = [];
	            var st;
	            //toFixed
	            if ((f < 0 && p2 != 0) || f > 0) {
	                var k = new Number(p2);
	                k = k.toFixed(f);
	                if (k == 1)
	                    p1++;
	                m = ds + k.substr(2) + m;
	            }
	
	            //format
	            do {
	                t = p1 % 1000;
	                p1 = Math.floor(p1 / 1000);
	                st = '' + t;
	                if (p1 > 0 && st.length < 3) {
	                    st = zs[st.length] + st
	                }
	                ar.unshift(st);
	            } while (p1 > 0);
	            ret = ar.join(gs) + m;
	        } catch (e) {
	            ret = '' + n;
	        }
	        if (ne == 1) {
	            ret = '-' + ret;
	        }
	        return ret;
	    }
	
	    function calculateDecimal(ticks, min, max) {
	        var scale = 0,
	            decimal = 2;
	        if (min == max) {
	            min = min / 2.0;
	            max = min + max;
	        }
	
	        scale = (max - min) / ticks;
	        if (scale > 0.25) {
	            decimal = 2;
	        } else if (scale > 0.0001) {
	            decimal = 4;
	        } else if (scale > 0.00001) {
	            decimal = 5;
	        } else {
	            decimal = 6;
	        }
	
	        return decimal;
	    }
	
	    // Taken from underscore.js
	    // Returns a function, that, as long as it continues to be invoked, will not
	    // be triggered. The function will be called after it stops being called for
	    // N milliseconds. If `immediate` is passed, trigger the function on the
	    // leading edge, instead of the trailing.
	    function debounce(func, wait, immediate) {
	        var timeout;
	        return function() {
	            var context = this,
	                args = arguments;
	            var later = function() {
	                timeout = null;
	                if (!immediate) func.apply(context, args);
	            };
	            var callNow = immediate && !timeout;
	            clearTimeout(timeout);
	            timeout = setTimeout(later, wait);
	            if (callNow) func.apply(context, args);
	        };
	    }
	
	    function isFund(tickerObj) {
	        var tenforeCode = tickerObj.getField("tenforeCode"),
	            tenforeType = tickerObj.getField("type"),
	            mType = tickerObj.getField("mType")
	        if (tenforeType == 8) {
	            if (mType && mType != "FO") {
	                return false;
	            } else {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function getKeyByValueInObj(obj, value) {
	        var returnKey = '';
	        for (var key in obj) {
	            if (obj[key] === value) {
	                returnKey = key;
	                break;
	            }
	        }
	        return returnKey;
	    }
	
	    //format number until find the effect number
	    function formatNotZeroNum(count, decimal) {
	        // judge count is 0/0.00/0.0..00
	        if (parseFloat(count, 10) === 0) {
	            return;
	        }
	        if (/^0(\.(0)+)?$/.test(count.toFixed(decimal))) {
	            decimal++;
	            return formatNotZeroNum(count, decimal);
	        } else {
	            return count.toFixed(decimal);
	        }
	    }
	
	    function endwith(str, char) {
	        var pos = str.lastIndexOf(char);
	        if (pos === -1) {
	            return false;
	        } else {
	            return pos + 1 === str.length;
	        }
	    }
	
	    function isInteger(num) {
	        return Math.floor(num) === num;
	    }
	
	    function toInteger(num) {
	        if (isInteger(num)) {
	            return {
	                times: 1,
	                intNum: num
	            };
	        }
	        var numString = num + '';
	        var precision = numString.replace(/^-?\d+.(\d)/, '$1').length;
	        var times = Math.pow(10, precision);
	        return {
	            times: times,
	            intNum: parseInt(numString.replace('.', ''), 10)
	        };
	    }
	
	    function operation(a, b, op) {
	        var ret,
	            integerA = toInteger(a),
	            integerB = toInteger(b),
	            intNumA = integerA.intNum,
	            intNumB = integerB.intNum,
	            maxTimes = Math.max(integerA.times, integerB.times);
	
	        switch (op) {
	            case '+':
	                if (integerA.times > integerB.times) {
	                    intNumB = intNumB * integerA.times / integerB.times;
	                } else if (integerA.times < integerB.times) {
	                    intNumA = intNumA * integerB.times / integerA.times;
	                }
	                ret = (intNumA + intNumB) / maxTimes;
	                break;
	            case '*':
	                ret = (intNumA * intNumB) / (integerA.times * integerB.times);
	                break;
	            case '/':
	                ret = (intNumA / intNumB) * (integerB.times / integerA.times);
	                break;
	            case '%':
	                if (integerA.times > integerB.times) {
	                    intNumB = intNumB * integerA.times / integerB.times;
	                } else if (integerA.times < integerB.times) {
	                    intNumA = intNumA * integerB.times / integerA.times;
	                }
	                ret = (intNumA % intNumB) / maxTimes;
	                break;
	        }
	        return ret;
	    }
	
	    function add(a, b) {
	        if (isInteger(a) || isInteger(b)) {
	            return a + b;
	        }
	        return operation(a, b, '+');
	    }
	
	    function subtract(a, b) {
	        if (isInteger(b)) {
	            return a - b;
	        }
	        return operation(a, -b, '+');
	    }
	
	    function multiply(a, b) {
	        if (isInteger(a) && isInteger(b)) {
	            return a * b;
	        }
	        return operation(a, b, '*');
	    }
	
	    function divide(a, b) {
	        if (isInteger(a) || isInteger(b)) {
	            return a / b;
	        }
	        return operation(a, b, '/');
	    }
	
	    function mod(a, b) {
	        return operation(a, b, '%');
	    }
	
	    function isExistedInDom($element) {
	        return $element && ($.contains(document.body, $element[0]) || $element.is(document.body) || $.isWindow($element));
	    }
	
	    function splitStringToArray(str, len) {
	        var array = [];
	        var l = str.length;
	        if (l < len) {
	            array.push(str);
	        } else {
	            for (var i = 0; i < l; i += len) {
	                array.push(str.substr(i, len));
	            }
	        }
	        return array;
	    }
	
	    function guid() {
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	            var r = (Math.random() * 16) | 0;
	            var v = c === 'x' ? r : (r & 0x3) | 0x8;
	            return v.toString(16);
	        });
	    }
	    return {
	        debounce: debounce,
	        boldSearch: boldSearch,
	        extendClass: extendClass,
	        dashesToCamel: dashesToCamel,
	        camelToDashes: camelToDashes,
	        capFirstChar: capFirstChar,
	        lowerFirstChar: lowerFirstChar,
	        isStaticDate: isStaticDate,
	        contains: contains,
	        isTouchCapable: isTouchCapable,
	        arrConcat: arrConcat,
	        deviceType: new DeviceType(),
	        numberFormatter: numberFormatter,
	        calculateDecimal: calculateDecimal,
	        isFund: isFund,
	        getKeyByValueInObj: getKeyByValueInObj,
	        formatNotZeroNum: formatNotZeroNum,
	        endwith: endwith,
	        isExistedInDom: isExistedInDom,
	        splitStringToArray: splitStringToArray,
	        guid: guid,
	        Math: {
	            add: add,
	            subtract: subtract,
	            multiply: multiply,
	            divide: divide,
	            mod: mod
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(17)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, util) {
	    'use strict';
	    var isSafari = (function() {
	        var ua = navigator.userAgent.toLowerCase();
	        var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
	            /(webkit)[ \/]([\w.]+)/.exec(ua) ||
	            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
	            /(msie) ([\w.]+)/.exec(ua) ||
	            ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
	        return match[1] === 'webkit';
	    })();
	
	    var download = function(container, fileName, url) {
	        var $container = container.jquery ? container : $(container);
	        var $downloadLink = $('<a></a>').appendTo($container);
	        $downloadLink.attr('href', url);
	        $downloadLink.attr('download', fileName);
	        $downloadLink.attr('target', '_blank');
	        setTimeout(function() {
	            $downloadLink[0].click();
	            $downloadLink.remove();
	        }, 0);
	    };
	
	    // var downloadForSafari = function(content) {
	    //     var rowData = content.rowData;
	    //     var params = {
	    //         url: core.getQSPath() + 'ra/export',
	    //         ept: 'CSV',
	    //         fileName: content.fileName,
	    //         delimiter: ';',
	    //         content: JSON.stringify({
	    //             sheets: [{
	    //                 sheetName: content.fileName,
	    //                 headers: ['date'],
	    //                 datas: [
	    //                     ['aaa']
	    //                 ]
	    //             }]
	    //         })
	    //     };
	    //     core.Util.openWindowWithPost(params);
	    // };
	
	    var convertCSVData = function(content) {
	        var dataLength = 0,
	            csvString = '',
	            rowData = content.rowData;
	        for (var i = 0; i < rowData.length; i++) {
	            dataLength = rowData[i].length > dataLength ? rowData[i].length : dataLength;
	        }
	        for (var i = 0; i < dataLength; i++) {
	            var rowString = '';
	            for (var r = 0; r < rowData.length; r++) {
	                var tempStr = rowData[r][i];
	                if (util.endwith(tempStr, content.delimiter)) {
	                    if (r !== rowData.length - 1) {
	                        tempStr += content.delimiter;
	                    }
	                } else if (r !== rowData.length - 1) {
	                    tempStr += (content.delimiter + content.delimiter);
	                }
	                rowString += tempStr;
	            }
	            rowString += '\r\n';
	            csvString += rowString;
	        }
	        return csvString;
	    };
	
	    var createFile = function(container, content) {
	        var result = convertCSVData(content);
	        if (!Blob) {
	            throw (new Error('Blob is not supported by your browser'));
	        }
	        result = '\ufeff' + result;
	
	        var blob = new Blob([result], {
	            type: 'text/csv;charset=utf-8;'
	        });
	
	        var fileName = content.fileName + '.csv';
	
	        if (window.navigator.msSaveOrOpenBlob) {
	            // for IE
	            window.navigator.msSaveBlob(blob, fileName);
	        } else {
	            if (isSafari) {
	                var reader = new window.FileReader();
	                reader.onloadend = function() {
	                    var dataUrl = reader.result.replace(/^data:[^;]*;/, 'data:attachment;');
	                    download(container, fileName, dataUrl);
	                };
	                reader.readAsDataURL(blob);
	            } else {
	                // for other browser
	                download(container, fileName, window.URL.createObjectURL(blob));
	            }
	        }
	    };
	    return {
	        createFile: createFile
	    }
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_19__;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	
	    function Request() {
	        var id;
	        var priceType, chartType;
	        var isPreAfter = false;
	        var frequency;
	        var dpType;
	        var tickerObjects;
	        var dateRange = [null, null];
	        var days = -1;
	        //var dataPoints;
	        var events;
	        var indicators;
	        var fundamentals;
	        var keyword;
	        var category = ['Equities', 'ETF', 'Closed-End Fund', 'Mutual Fund', 'Index', 'Forex', 'Futures', 'Options', 'Debenture', 'Government Bonds', 'Strategies & Spreads', 'Unspecified Bonds', 'Unspecified Funds & Certificates', 'Warrents'];
	        var headers;
	        var keepDateRange = false;
	        var nonFilterCategory = [];
	        var alignMainTicker = true;
	        //growthBaseValue
	        var growthBaseValue;
	
	        this.id = function(value) {
	            if (!arguments.length) {
	                return id;
	            }
	            id = value;
	            return this;
	        };
	
	        this.priceType = function(value) {
	            if (!arguments.length) {
	                return priceType;
	            }
	            priceType = value;
	            return this;
	        };
	
	        this.dpType = function(value) {
	            if (!arguments.length) {
	                return dpType;
	            }
	            dpType = value;
	            return this;
	        };
	        this.chartType = function(value) {
	            if (!arguments.length) {
	                return chartType;
	            }
	            chartType = value;
	            return this;
	        };
	
	        this.isPreAfter = function(value) {
	            if (!arguments.length) {
	                return isPreAfter;
	            }
	            isPreAfter = typeof value === 'boolean' ? value : true;
	            return this;
	        };
	
	        this.frequency = function(value) {
	            if (!arguments.length) {
	                return frequency;
	            }
	            if (!isNaN(value)) {
	                value = parseInt(value, 10);
	            }
	            frequency = value;
	            return this;
	        };
	
	        this.tickerObjects = function(value) {
	            if (!arguments.length) {
	                return tickerObjects;
	            }
	            tickerObjects = value;
	            return this;
	        };
	
	        this.dateRange = function(value) {
	            if (!arguments.length) {
	                return dateRange;
	            }
	            dateRange = value;
	            return this;
	        };
	
	        this.alignMainTicker = function(value) {
	            if (!arguments.length) {
	                return alignMainTicker;
	            }
	            alignMainTicker = value;
	            return this;
	        }
	
	        this.days = function(value) {
	            if (!arguments.length) {
	                return days;
	            }
	            days = value;
	            return this;
	        };
	
	        /*this.dataPoints = function (value) {
	            if (!arguments.length) {
	                return dataPoints;
	            }
	            dataPoints = value;
	            return this;
	        };*/
	        this.events = function(value) {
	            if (!arguments.length) {
	                return events;
	            }
	            events = value;
	            return this;
	        };
	
	        this.indicators = function(value) {
	            if (!arguments.length) {
	                return indicators;
	            }
	            indicators = value;
	            return this;
	        };
	
	        this.fundamentals = function(value) {
	            if (!arguments.length) {
	                return fundamentals;
	            }
	            fundamentals = value;
	            return this;
	        };
	
	        this.keyword = function(value) {
	            if (!arguments.length) {
	                return keyword;
	            }
	            keyword = value;
	            return this;
	        };
	
	        this.category = function(value) {
	            if (!arguments.length) {
	                return category;
	            }
	            category = value;
	            return this;
	        };
	
	        this.headers = function(value) {
	            if (!arguments.length) {
	                return headers;
	            }
	            headers = value;
	            return this;
	        };
	
	        this.keepDateRange = function(value) {
	            if (!arguments.length) {
	                return keepDateRange;
	            }
	            keepDateRange = value === true ? true : false;
	            return this;
	        };
	
	        this.nonFilterCategory = function(value) {
	            if (!arguments.length) {
	                return nonFilterCategory;
	            }
	            nonFilterCategory = value;
	            return this;
	        };
	
	        // default 10000
	        this.growthBaseValue = function(value) {
	            if (!arguments.length) {
	                return growthBaseValue;
	            }
	            growthBaseValue = value;
	            return this;
	        };
	    }
	
	    return Request;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(17)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, util) {
	        "use strict";
	
	        function handler(managers) {
	            var chartConfigManager = managers.chartConfigManager,
	                eventManager = managers.eventManager,
	                eventTypes = eventManager.EventTypes,
	                errorContainer, config, baseConfig;
	
	            function hideErrorMessage() {
	                setTimeout(function() {
	                    errorContainer.fadeOut(250, function() {
	                        errorContainer.empty().removeClass('alert error');
	                        eventManager.trigger([eventTypes.ErrorHidden, eventTypes.HeightChanged], this);
	                    });
	                }, config.errorTimeout);
	            }
	
	            function showErrorMessage(content, type, hide) {
	                type = type || 'alert';
	                errorContainer.html(content).addClass(type);
	                errorContainer.fadeIn(250, function() {
	                    if (hide) { hideErrorMessage() }
	                    eventManager.trigger([eventTypes.ErrorShown, eventTypes.HeightChanged], this);
	                });
	            }
	
	            var ErrorHandler = function() {
	                baseConfig = chartConfigManager.getConfig();
	
	                // bind all error events after inititialization is complete
	                this.bindCollection.forEach(function(arr, i) {
	                    eventManager.bind(arr[0], this[arr[1]], this);
	                }, this);
	            };
	
	            ErrorHandler.prototype.bindCollection = [];
	
	            /**
	             * Adds an error to the factory
	             * @param {string} name
	             * @param {string} eventName - name of the event to watch for
	             * @param {function} handler - callback function to fire for event
	             */
	            function addError(name, eventName, handler) {
	                ErrorHandler.prototype[name] = handler
	
	                ErrorHandler.prototype.bindCollection.push([eventName, name])
	            }
	
	            addError("blackberryWarningMessage", 'layout-rendered', function() {
	                if (util.deviceType.blackberry()) {
	                    showErrorMessage.call(this, config.langData['errorsMsg'], 'alert', false)
	                }
	            });
	
	            addError("tooManyTickers", "error:ticker-limit-reached", function() {
	                var errorSpan = baseConfig.$componentContainer.find('.error-message');
	                if (errorSpan) {
	                    errorSpan.show();
	                    setTimeout(function() {
	                        errorSpan.hide();
	                    }, config.errorTimeout);
	                }
	            });
	
	            // initialize after the layout is rendered and configuration is done
	            eventManager.bind(eventTypes.LayoutRendered, function init() {
	                errorContainer = baseConfig.$componentContainer.find('.mkts-cmpt-svgcht-errors');
	                config = {
	                    errorTimeout: baseConfig.compareChartsMaxAllowedErrorMessageTimeout,
	                    langData: chartConfigManager.getLabels('markets-components-svgchart', baseConfig.lang)
	                };
	            }, this);
	
	            return new ErrorHandler();
	        }
	
	        return handler;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(23),
	        __webpack_require__(29),
	        __webpack_require__(25),
	        __webpack_require__(26),
	        __webpack_require__(27),
	        __webpack_require__(28),
	        __webpack_require__(3),
	        __webpack_require__(17),
	        __webpack_require__(30),
	        __webpack_require__(33),
	        __webpack_require__(41)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(menuBarTemplate,
	        popoverEventsIndicatorsTemplate,
	        popoverFundamentalTemplate,
	        popoverDrwaingTemplate,
	        popoverDisplayTemplate,
	        settingsTemplate,
	        core,
	        util,
	        MenuBarIntervalModel,
	        AutoCompleteModel,
	        PopoverModel) {
	        "use strict";
	
	        /**
	         * Menubar for main chart type view
	         *
	         * @constructor
	         */
	
	        var $ = core.$;
	        var Util = core.Util;
	        var invalidClass = 'mkts-cmpt-svgcht-invalid';
	
	        function model(managers) {
	            var eventManager = managers.eventManager;
	            var CCM = managers.chartConfigManager;
	            var MenuBarInterval = MenuBarIntervalModel(managers);
	            var Popover = PopoverModel();
	            var AutoComplete = AutoCompleteModel(managers, Popover);
	            var $menuBarTemplate;
	            var langObj;
	            var appConfig;
	
	            var MenuBar = function(config) {
	                this.config = {
	                    container: '',
	                    popObj: {},
	                    popConfig: '',
	                    popName: '',
	                };
	                this._init(config);
	            };
	
	            MenuBar.prototype = {
	                /* test-code */
	                __private: {
	                    CCM: CCM,
	                    eventManager: eventManager
	                },
	                /* end-test-code */
	                _init: function(config) {
	                    function makePopOvers() {
	                        var templates = {
	                            eventsIndicators: popoverEventsIndicatorsTemplate, //eventsIndicatorsTemplate,
	                            fundamentals: popoverFundamentalTemplate, //fundamentalTemplate,
	                            drawings: popoverDrwaingTemplate, //drawingTemplate,
	                            display: popoverDisplayTemplate, //displayTemplate
	                        };
	                        var popovers = {};
	                        var buttons = $menuBarTemplate.find('.mkts-cmpt-svgcht-menubtn');
	                        var buttonLen = buttons.length;
	                        var name, button, tempFun, markupStr, i;
	
	                        for (i = 0; i < buttonLen; i++) {
	                            button = buttons[i];
	                            name = button.getAttribute('data-menuid');
	                            name = util.dashesToCamel(name);
	                            button.popName = name;
	                            tempFun = templates[name];
	                            var tempData = langObj;
	                            if (name === 'display') {
	                                tempData.showStartDate = CCM.getConfig().showStartDate;
	                                tempData.showPriceWithDividendGrowth = CCM.getConfig().showPriceWithDividendGrowth;
	                            }
	                            markupStr = tempFun(tempData);
	                            var $markupStr = $(markupStr);
	                            if (name === 'drawings') {
	                                button.resetOnOpen = true;
	                            } else if (name === 'display') {
	                                var configArr = [
	                                    (function(mainChart) {
	                                        var MainChartTypes = CCM.MainChartTypes;
	                                        var MainDataTypes = CCM.MainDataTypes;
	                                        var dataType = mainChart.dataType;
	                                        if (dataType === MainDataTypes.Growth) {
	                                            return MainChartTypes.pGrowthChart;
	                                        } else if (dataType === MainDataTypes.Growth10K) {
	                                            return MainChartTypes.TenKGrowthChart;
	                                        } else if (dataType === MainDataTypes.DividendEffect) {
	                                            return MainChartTypes.DividendEffectChart;
	                                        } else if (dataType === MainDataTypes.PostTax) {
	                                            return MainChartTypes.PostTaxChart;
	                                        } else if (dataType === MainDataTypes.PriceWithDividendGrowth) {
	                                            return MainDataTypes.PriceWithDividendGrowth;
	                                        } else {
	                                            return mainChart.chartType;
	                                        }
	                                    })(appConfig.charts.mainChart),
	                                    appConfig.cursorType,
	                                    appConfig.verticalScaleType,
	                                    appConfig.charts.mainChart.selectionMode,
	                                    appConfig.charts.mainChart.yAxis.orient,
	                                    appConfig.charts.volumeChart.chartType,
	                                    appConfig.startDate
	                                ];
	                                if (appConfig.showPreAfter) {
	                                    configArr.push("extendedMarketHour");
	                                }
	
	                                configArr.forEach(function(item) {
	                                    setOptionsStatus(item, $markupStr)
	                                });
	                            } else if (name === 'eventsIndicators' || name === 'fundamentals') {
	                                $markupStr.find(".mkts-cmpt-svgcht-toggle--off,.mkts-cmpt-svgcht-toggle--on").each(function() {
	                                    if ($(this).find("div").length === 0) {
	                                        var wraper = '<div class="mkts-cmpt-svgcht-indicator-name" title="' + $(this).text() + '"></div>';
	                                        $(this).wrapInner(wraper);
	                                    }
	                                    var onoffBtn = '<div class="mkts-cmpt-svgcht-onoff-btn"> <span class="onoff-left"></span><span class="onoff-right"></span></div>';
	                                    $(this).append(onoffBtn);
	                                });
	                                var defaultOptions = {};
	                                if (name === 'eventsIndicators') {
	                                    defaultOptions["events"] = appConfig.events || [];
	                                    defaultOptions["indicators"] = appConfig.indicators || [];
	                                    //handle if the volume is active
	                                    if (appConfig.charts.volumeChart.show === false) {
	                                        $markupStr.find(".volume-chart").removeClass("mkts-cmpt-svgcht-toggle--on").addClass("mkts-cmpt-svgcht-toggle--off");
	                                    }
	                                } else if (name === 'fundamentals') {
	                                    defaultOptions["fundamentals"] = appConfig.fundamentals ? appConfig.fundamentals.slice() : [];
	                                    appConfig.indicators.forEach(function(indicator) {
	                                        if (CCM.isIndicatorsFundamentals(indicator.name)) {
	                                            defaultOptions["fundamentals"].push(indicator.name);
	                                        }
	                                    });
	                                }
	                                setDefaultIndictFundm(defaultOptions, $markupStr);
	                            }
	                            popovers[name] = $markupStr;
	                        }
	
	                        return popovers;
	                    }
	
	                    function setOptionsStatus(optionValue, $markupStr) {
	                        if (!optionValue) return;
	                        var eid = util.camelToDashes(optionValue);
	                        var elem = $markupStr.find("." + eid);
	                        if (optionValue !== appConfig.charts.volumeChart.chartType && optionValue !== "extendedMarketHour") {
	                            elem.addClass('active');
	                        } else {
	                            elem.removeClass('mkts-cmpt-svgcht-toggle--off').addClass('mkts-cmpt-svgcht-toggle--on');
	                        }
	                    }
	
	                    function setDefaultIndictFundm(defaultOptions, $markupStr) {
	                        var items = [];
	                        var eid;
	                        var events = defaultOptions.events ? defaultOptions.events : [];
	                        for (var i = 0, eventsLength = events.length; i < eventsLength; i++) {
	                            eid = events[i];
	                            if (appConfig.charts.mainChart.showDividend === false && eid === 'eventDividend') {
	                                continue;
	                            }
	
	                            $markupStr.find("." + eid).removeClass("mkts-cmpt-svgcht-toggle--off").addClass("mkts-cmpt-svgcht-toggle--on");
	                            self.activeIndicators[events[i]] = {
	                                el: $markupStr.find("." + eid)[0]
	                            }
	                        }
	
	                        var indicators = defaultOptions.indicators ? defaultOptions.indicators : [];
	                        var fundamentals = defaultOptions.fundamentals ? defaultOptions.fundamentals : [];
	                        for (var i = 0, indicatorsLength = indicators.length, indicator; i < indicatorsLength; i++) {
	                            indicator = indicators[i];
	                            if (CCM.isIndicatorsFundamentals(indicator.name)) {
	                                fundamentals.push(indicator.name);
	                                continue;
	                            }
	                            eid = util.camelToDashes(indicator.name);
	                            var $elm = $markupStr.find("." + eid).removeClass("mkts-cmpt-svgcht-toggle--off").addClass("mkts-cmpt-svgcht-toggle--on");
	                            var $drawer = $markupStr.find("." + eid).next('.mkts-cmpt-svgcht-drawer, .mkts-cmpt-svgcht-drawer--expand');
	                            $drawer.removeClass('mkts-cmpt-svgcht-drawer').addClass('mkts-cmpt-svgcht-drawer--expand');
	                            var $input = $drawer.find('.mkts-cmpt-svgcht-dropdown input');
	                            if (indicator.parameters) {
	                                indicator.parameters.forEach(function(item, idx) {
	                                    $input.eq(idx).val(item);
	                                });
	                            }
	                            $elm[0].toRemove = false;
	                            self.activeIndicators[indicators[i].name] = {
	                                el: $elm[0],
	                                options: indicators[i].parameters
	                            }
	                        }
	
	                        for (var i = 0, fundamentalsLength = fundamentals.length; i < fundamentalsLength; i++) {
	                            eid = util.camelToDashes(fundamentals[i]);
	                            $markupStr.find("." + eid).removeClass("mkts-cmpt-svgcht-toggle--off").addClass("mkts-cmpt-svgcht-toggle--on");
	                            self.activeFundamentals[fundamentals[i]] = {
	                                el: $markupStr.find("." + eid)[0],
	                            }
	                        }
	                    }
	                    var self = this;
	
	                    /* test-code */
	                    self.__private._init = {
	                        makePopOvers: makePopOvers
	                    };
	                    /* end-test-code */
	
	                    appConfig = CCM.getConfig();
	                    var locale = appConfig.lang || 'en-US';
	                    var isAutoCompleteActMainTicker = appConfig.autoComplete.action === 'main' ? true : false;
	
	                    langObj = CCM.getLabels('markets-components-svgchart', locale);
	                    langObj.autoCompleteChangeMainTicker = isAutoCompleteActMainTicker;
	                    langObj.hideGear = appConfig.hideIndicator && appConfig.hideFundamental && appConfig.hideDrawing && appConfig.hideDisplay;
	                    langObj.showExportMenuTab = appConfig.hideExport === false;
	                    $.extend(true, self.config, config);
	
	                    $menuBarTemplate = $(menuBarTemplate(langObj));
	
	                    if (appConfig.enterTipsLabelID) {
	                        var placeholder = isAutoCompleteActMainTicker ? langObj['changeTicker'] : langObj['searchAssets'];
	                        $menuBarTemplate.find(".mkts-cmpt-svgcht-search-input").attr("placeholder", placeholder);
	                    }
	
	
	                    self._conditionalLoad();
	                    self.activeIndicators = {};
	                    self.activeFundamentals = {};
	                    self.popovers = makePopOvers();
	                    /* test-code */
	                    self.__private.activeIndicators = self.activeIndicators;
	                    self.__private.activeFundamentals = self.activeFundamentals;
	                    /* end-test-code */
	
	                    self._renderView();
	                    self._hideMenuItemsAndSetPremium();
	                    self._hideMenuIcons();
	                    self._hideMenuButtons();
	                    self._bindEvents();
	                },
	                hidePopover: function() {
	                    Popover.hide();
	                },
	                getHeight: function() {
	                    return this.$el.outerHeight(true);
	                },
	                _conditionalLoad: function() {
	                    var testDiv = document.createElement('div');
	
	                    //conditionally load overrides for browsers without flexbox (ie9)
	                    $('body').append(testDiv);
	                    if (testDiv.style.flexDirection === undefined && testDiv.style.webkitFlexDirection === undefined && testDiv.style.msFlexDirection === undefined) {
	                        CCM.getConfig().$componentContainer.find(".mkts-cmpt-svgcht-menubar").addClass("mkts-cmpt-svgcht-noFlex");
	                    }
	                    $(testDiv).remove();
	
	                },
	                _hideMenuItemsAndSetPremium: function() {
	                    function hideElements() {
	                        var key = 'hide' + util.capFirstChar(curPop);
	                        var hides = menubarCfg[key];
	                        var i, l;
	
	                        if (hides && $.isArray(hides)) {
	                            l = hides.length;
	                            for (i = 0; i < l; i++) {
	                                $el.find('.' + hides[i]).hide();
	                                //hide Title if all subItem is hidden
	                                var $pEl = $el.find('.' + hides[i]).parent();
	                                if ($pEl.prev().hasClass('mkts-cmpt-svgcht-popover-sub-title')) {
	                                    var allHidden = true;
	                                    $.each($pEl.children(".mkts-cmpt-svgcht-popover-body"), function(o, e) {
	                                        if ($(e).css('display') !== 'none') {
	                                            allHidden = false;
	                                            return false;
	                                        }
	                                    });
	                                }
	                                if (allHidden) {
	                                    $pEl.prev().hide();
	                                }
	                            }
	                        }
	                    }
	
	                    function findPremium() {
	                        function disablePremium(el) {
	                            var $parEl = $(el.parentNode);
	
	                            $parEl.removeClass('mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off')
	                                .addClass('mkts-cmpt-svgcht-popover-body-disabled')
	                                .attr('data-linkbinding', 'history-fairvalue');
	                        }
	
	                        function hidePremiumMark(el) {
	                            var $el = $(el);
	                            $el.css({
	                                'background': 'none',
	                                'padding-left': '0px'
	                            });
	                        }
	
	                        var premItms = $el.find('.mkts-cmpt-svgcht-premium-chic');
	                        var premLen = premItms.length;
	                        var i;
	
	                        if (!appConfig.premiumUser) {
	                            for (i = 0; i < premLen; i++) {
	                                disablePremium(premItms[i]);
	                            }
	                        } else {
	                            for (i = 0; i < premLen; i++) {
	                                hidePremiumMark(premItms[i]);
	                            }
	                        }
	
	                    }
	                    var self = this;
	                    var menubarCfg = appConfig.menubar;
	                    var popovers = self.popovers;
	                    var curPop, $el;
	
	
	                    //conditionally hide items for listed in config
	                    for (curPop in popovers) {
	                        if (popovers.hasOwnProperty(curPop)) {
	                            $el = self.popovers[curPop];
	                            hideElements();
	                            findPremium();
	                        }
	                    }
	
	                    //hide interval items
	                    curPop = 'Interval';
	                    $el = $menuBarTemplate;
	                    hideElements();
	
	                    if (appConfig.showCloseBtn) {
	                        $menuBarTemplate.find('.mkts-cmpt-svgcht-menuicn--remove').show();
	                    }
	                },
	                _hideMenuIcons: function() {
	                    var resetFlag = appConfig.hideResetIcon;
	                    var hideExport = appConfig.hideExport;
	                    var hidePrint = appConfig.hidePrint;
	                    if (resetFlag) {
	                        $menuBarTemplate.find('.mkts-cmpt-svgcht-menuicn--reset').hide();
	                    }
	                    if (hideExport) {
	                        $menuBarTemplate.find('.mkts-cmpt-svgcht-menuicn--export').hide();
	                    }
	                    if (hidePrint) {
	                        $menuBarTemplate.find('.mkts-cmpt-svgcht-menuicn--print').hide();
	                    }
	                },
	                _hideMenuButtons: function() {
	                    var buttons = appConfig.menubar.hideButtons;
	                    var l, i;
	
	                    if ($.isArray(buttons) && buttons.length > 0) {
	                        l = buttons.length;
	                        for (i = 0; i < l; i++) {
	                            $menuBarTemplate.find('.' + buttons[i]).hide();
	                        }
	                    }
	                },
	                _renderView: function(defaultRange) {
	                    var intervalInst;
	                    this.$el = this.config.container;
	                    $menuBarTemplate.appendTo(this.$el);
	                    intervalInst = new MenuBarInterval({
	                        container: this.$el.find('.mkts-cmpt-svgcht-menubar-bottom')
	                    });
	
	                    this.intervalInst = intervalInst;
	                    /* test-code */
	                    this.__private.menuIntervalInst = intervalInst;
	                    /* test-code */
	
	                    new AutoComplete({
	                        $menuBarContainer: this.$el
	                    });
	                },
	                _bindEvents: function() {
	                    var self = this;
	                    var popObj = this.config.popObj;
	                    var popConfig = this.config.popConfig;
	                    var popName = this.config.popName;
	                    var timer;
	
	                    function onMenuButtonClick(e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	
	                        if (Util.isString(this.popName)) {
	
	                            popName = this.popName;
	                            popObj.$el = self.popovers[this.popName];
	                            if (this.resetOnOpen) {
	                                popObj.$el.find('.mkts-cmpt-svgcht-popover-body').removeClass('active');
	                            }
	                            var rootConfig = CCM.getConfig();
	                            var containerWidth = rootConfig.width;
	                            popConfig = {
	                                containerWidth: containerWidth,
	                                containerHeight: rootConfig.height,
	                                $componentContainer: rootConfig.$componentContainer,
	                                $target: $(this),
	                                styleClass: 'mkts-cmpt-svgcht-popover--' + this.popName,
	                                $menuBarContainer: self.$el,
	                                sync: containerWidth < 601 //todo: need to find the unify process to check mobile size
	                            };
	                            Popover.show(popObj, popConfig);
	
	                            /*
	                             * popName is eventsIndicators|fundamental|drawing|display
	                             */
	                            eventManager.trigger(eventManager.EventTypes.triggerClickCallback, {
	                                name: popName
	                            });
	                        }
	                    }
	
	                    function changeLayout() {
	                        if (popObj != null && popConfig != "") {
	                            if (Util.isString(popName)) {
	                                popConfig = {
	                                    $container: self.$el,
	                                    $target: $(this),
	                                    styleClass: 'mkts-cmpt-svgcht-popover--' + popName
	                                };
	                                if (popConfig.$container.find('.' + popConfig.styleClass).length > 0) {
	                                    Popover.adjustPosition();
	                                }
	                            }
	                        }
	                    }
	
	                    function onLayoutChange() {
	                        clearTimeout(timer);
	                        timer = setTimeout(changeLayout, 100);
	                    }
	
	                    function onSettingsButtonClick(e) {
	                        var name = this.getAttribute('data-menuid');
	                        var target = self.$el.find('.mkts-cmpt-svgcht-menuicn--gear');
	
	                        if (target.length > 0) {
	                            name = util.dashesToCamel(name);
	                            target.popName = name;
	                            onMenuButtonClick.call(target, e);
	                        }
	                        /*
	                         * popName is eventsIndicators|fundamental|drawing|display
	                         */
	                        eventManager.trigger(eventManager.EventTypes.triggerClickCallback, {
	                            name: popName
	                        });
	                    }
	
	                    function onSettingsClick(e) {
	                        var popObj = {};
	                        var popConfig;
	
	                        e.preventDefault();
	                        e.stopPropagation();
	
	                        $.extend(langObj, {
	                            hideIndicatorInGear: appConfig.hideIndicator,
	                            hideFundamentalInGear: appConfig.hideFundamental,
	                            hideDrawingInGear: appConfig.hideDrawing,
	                            hideDisplayInGear: appConfig.hideDisplay
	                        });
	
	                        popObj.$el = $(settingsTemplate(langObj));
	                        var rootConfig = CCM.getConfig();
	                        popConfig = {
	                            containerWidth: rootConfig.width,
	                            containerHeight: rootConfig.height,
	                            $componentContainer: rootConfig.$componentContainer,
	                            $target: $(this),
	                            styleClass: 'mkts-cmpt-svgcht-popover--settings',
	                            $menuBarContainer: self.$el,
	                            sync: false
	                        };
	                        Popover.show(popObj, popConfig);
	                        eventManager.trigger(eventManager.EventTypes.triggerClickCallback, {
	                            name: 'gear'
	                        });
	                    }
	
	                    function makeArrayFromInputs(el) {
	                        var ar = [];
	                        var inpts, inptLen, i;
	
	                        if (Util.isObj(el) && el.length > 0) {
	                            inpts = $(el).find('input');
	                            inptLen = inpts.length;
	                            for (i = 0; i < inptLen; i++) {
	                                if (Util.isString(inpts[i].value) && inpts[i].value !== '') {
	                                    var numValue = parseFloat(inpts[i].value, 10);
	                                    if (!isNaN(numValue)) {
	                                        ar.push(parseFloat(numValue));
	                                    }
	                                } else {
	                                    ar.push(null);
	                                }
	                            }
	                        }
	
	                        return ar;
	                    }
	
	                    function toggleDrawer(el) {
	                        var drawer = $(el).next('.mkts-cmpt-svgcht-drawer, .mkts-cmpt-svgcht-drawer--expand');
	
	                        if (el.toRemove === undefined || el.toRemove) {
	                            el.toRemove = false;
	                        } else {
	                            el.toRemove = true;
	                        }
	
	                        $(el).toggleClass('mkts-cmpt-svgcht-toggle--on mkts-cmpt-svgcht-toggle--off');
	                        $(drawer).toggleClass('mkts-cmpt-svgcht-drawer mkts-cmpt-svgcht-drawer--expand');
	                        if (drawer.length > 0) {
	                            if (el.className.indexOf('on') > 0) {
	                                $(el).addClass('noBorder');
	                            } else {
	                                $(el).removeClass('noBorder');
	                            }
	                        }
	                    }
	
	                    function onMenuItemClick(e) {
	                        function manageVolumeState() {
	                            var popovers = self.popovers;
	                            var toggleString = 'mkts-cmpt-svgcht-toggle--on mkts-cmpt-svgcht-toggle--off';
	                            var $vol = popovers.eventsIndicators.find('.volume-chart');
	                            var $volPlus = popovers.display.find('.volume-plus-chart');
	
	                            if (eventType === 'ChangeChartVolume') {
	                                if ($vol.hasClass('mkts-cmpt-svgcht-toggle--off') && $volPlus.hasClass('mkts-cmpt-svgcht-toggle--on')) {
	                                    $volPlus.toggleClass(toggleString);
	                                    eventManager.trigger(eventManager.EventTypes.ChangeChartVolumePlus, false);
	                                    console.debug(eventManager.EventTypes.ChangeChartVolumePlus, false);
	                                }
	                            } else if (eventType === 'ChangeChartVolumePlus') {
	                                if ($volPlus.hasClass('mkts-cmpt-svgcht-toggle--on') && $vol.hasClass('mkts-cmpt-svgcht-toggle--off')) {
	                                    $vol.toggleClass(toggleString);
	                                    eventManager.trigger(eventManager.EventTypes.ChangeChartVolume, true);
	                                    console.debug(eventManager.EventTypes.ChangeChartVolume, true);
	                                }
	                            }
	                        }
	
	                        function manageVolumeValue() {
	                            eventVal = false;
	                            if (el.className.indexOf('--on') > 0) {
	                                eventVal = true;
	                            }
	                        }
	
	                        function processElement() {
	                            if ($(el).attr("id") === "reset") {
	                                return;
	                            }
	
	                            var items = $(parent).find('.mkts-cmpt-svgcht-popover-body');
	                            if (toggle) {
	                                toggleDrawer(el);
	                            } else {
	                                $(items).removeClass('active');
	                                $(el).addClass('active');
	                            }
	                        }
	
	                        function assignActiveIndicators() {
	                            inputContainer = $(el).next('.mkts-cmpt-svgcht-drawer, .mkts-cmpt-svgcht-drawer--expand');
	                            if (el.toRemove === false) {
	                                indicatorArgs = makeArrayFromInputs(inputContainer);
	                                self.activeIndicators[eventVal] = {
	                                    el: el,
	                                    options: indicatorArgs
	                                };
	                            }
	                        }
	
	                        function assingActiveFundamentals() {
	                            if (el.toRemove === false) {
	                                self.activeFundamentals[eventVal] = {
	                                    el: el
	                                };
	                            }
	                        }
	
	                        function fireNormalEvent(flag) {
	                            if (window._satellite) {
	                                try {
	                                    _satellite.setVar('CategoryName', eventManager.EventTypes[eventType]);
	                                    _satellite.setVar('EventVal', eventVal);
	                                    _satellite.track('DropDown');
	                                } catch (e) {}
	                            }
	                            eventManager.trigger(eventManager.EventTypes[eventType], eventVal);
	                            console.debug(eventManager.EventTypes[eventType], eventVal);
	                            eventVal = flag ? el.getAttribute('data-menuid').replace(/-chart/, '').replace(/-(\w)/g, function($0, $1) {
	                                return $1.toUpperCase()
	                            }) : eventVal;
	                            eventManager.trigger(eventManager.EventTypes.triggerClickCallback, {
	                                name: popName,
	                                value: eventVal
	                            });
	                        }
	
	                        function fireParameteredEvent() {
	                            inputContainer = $(el).next('.mkts-cmpt-svgcht-drawer, .mkts-cmpt-svgcht-drawer--expand');
	                            if (el.toRemove === false) {
	                                indicatorArgs = makeArrayFromInputs(inputContainer);
	                                self.activeIndicators[eventVal] = {
	                                    el: el,
	                                    options: indicatorArgs
	                                };
	                            }
	                            if (window._satellite) {
	                                try {
	                                    _satellite.setVar('CategoryName', eventManager.EventTypes.ChangeIndicators);
	                                    _satellite.setVar('EventVal', eventVal);
	                                    _satellite.track('DropDown');
	                                } catch (e) {}
	                            }
	                            eventManager.trigger(eventManager.EventTypes.ChangeIndicators, el.toRemove, eventVal, indicatorArgs);
	                            console.debug(eventManager.EventTypes.ChangeIndicators, el.toRemove, eventVal, indicatorArgs);
	
	                            eventManager.trigger(eventManager.EventTypes.triggerClickCallback, {
	                                name: popName,
	                                value: eventVal,
	                                params: indicatorArgs
	                            });
	                        }
	
	                        function hidePopoverAfterSelect() {
	                            if (appConfig.isHidePopoverAfterSelect) {
	                                self.hidePopover();
	                            }
	                        }
	
	                        function processEventType() {
	                            switch (eventType) {
	                                case 'ChangeFundamental':
	                                    eventVal = util.capFirstChar(eventVal);
	                                    assingActiveFundamentals();
	                                    fireNormalEvent();
	                                    hidePopoverAfterSelect();
	                                    break;
	                                case 'ChangeIndicators':
	                                    eventVal = util.capFirstChar(eventVal);
	                                    assignActiveIndicators();
	                                    fireParameteredEvent();
	                                    hidePopoverAfterSelect();
	                                    break;
	                                case 'ChangeChartVolumePlus':
	                                    //intentional fall through, both event types should be handled the same
	                                case 'ChangeChartVolume':
	                                    manageVolumeState();
	                                    manageVolumeValue();
	                                    hidePopoverAfterSelect();
	                                    fireNormalEvent(true);
	                                    break;
	                                default:
	                                    fireNormalEvent();
	                                    hidePopoverAfterSelect();
	                            }
	                        }
	                        var el = this;
	                        var parent = el.parentNode;
	                        var eventType;
	                        var eventVal;
	                        var inputContainer;
	                        var toggle = el.className.indexOf('mkts-cmpt-svgcht-toggle') > 0;
	                        var indicatorArgs = [];
	
	                        e.preventDefault();
	                        e.stopPropagation();
	
	                        if (Util.isString(el.getAttribute('data-menuid')) && Util.isObj(parent) && Util.isString(parent.getAttribute('data-menuid'))) {
	                            eventType = util.dashesToCamel(parent.getAttribute('data-menuid'));
	                            eventType = util.capFirstChar(eventType);
	                            eventVal = util.dashesToCamel(el.getAttribute('data-menuid'));
	                            processElement();
	                            processEventType();
	                        }
	                    }
	
	                    function onIndicatorChagne(remove, indicator, options, removeAll, isFromCloseBtn) {
	                        function allNull(array) {
	                            var isNull = true;
	                            var len = array.length || 0;
	                            var i;
	
	                            for (i = 0; i < len; i++) {
	                                if (array[i] !== null) {
	                                    isNull = false;
	                                    break;
	                                }
	                            }
	
	                            return isNull;
	                        }
	
	                        function updateActiveIndicators() {
	                            indicatorArray.splice(index, 1);
	                            if (indicatorArray.length === 0 || allNull(indicatorArray) || removeAll) {
	                                toggleDrawer(indicatorEl);
	                            }
	                        }
	
	                        function removeValue() {
	                            if (Util.isObj(self.activeIndicators[indicator])) {
	                                indicatorArray = self.activeIndicators[indicator].options;
	                                indicatorEl = self.activeIndicators[indicator].el;
	                                if (isFromCloseBtn && $.isNumeric(options)) {
	                                    index = indicatorArray.indexOf(options);
	                                    if (index > -1) {
	                                        //if clearing individual fields as they're cleared from the chart is requested, this is where that function should be called
	                                        //get an array of the input fields, and find the field from this index, then set it to ''
	                                        updateActiveIndicators();
	                                    }
	                                } else if (isFromCloseBtn) {
	                                    updateActiveIndicators();
	                                }
	                            }
	                        }
	                        var indicatorArray, indicatorEl, index;
	                        if (remove) {
	                            removeValue();
	                        };
	                    }
	
	                    function onFundamentalChagne(fun, remove) {
	                        var funEl;
	
	                        if (remove === true) {
	                            if (Util.isObj(self.activeFundamentals[fun])) {
	                                funEl = self.activeFundamentals[fun].el;
	                                toggleDrawer(funEl);
	                            }
	                        }
	                    }
	
	                    function onUpdateIndicator() {
	                        var inputContainer = $(this).closest('.mkts-cmpt-svgcht-drawer--expand');
	                        var el = inputContainer.prev('.mkts-cmpt-svgcht-popover-body')[0];
	                        var parent = el.parentNode;
	                        var eventType;
	                        var eventVal;
	                        var indicatorArgs;
	                        var $invalidInputs = inputContainer.find('.' + invalidClass);
	                        if ($invalidInputs.length > 0) {
	                            $invalidInputs.animate({
	                                borderWidth: '5px'
	                            }, 'fast').animate({
	                                borderWidth: '1px'
	                            }, 'fast').focus();
	                        } else if (Util.isString(el.getAttribute('data-menuid')) &&
	                            Util.isObj(parent) &&
	                            Util.isString(parent.getAttribute('data-menuid'))) {
	                            eventType = util.dashesToCamel(parent.getAttribute('data-menuid'));
	                            eventType = util.capFirstChar(eventType);
	                            eventVal = util.dashesToCamel(el.getAttribute('data-menuid'));
	                            eventVal = util.capFirstChar(eventVal);
	                            indicatorArgs = makeArrayFromInputs(inputContainer);
	                            self.activeIndicators[eventVal] = {
	                                el: el,
	                                options: indicatorArgs
	                            };
	
	                            eventManager.trigger(eventManager.EventTypes.ChangeIndicators, false, eventVal, indicatorArgs);
	                            console.debug(eventManager.EventTypes.ChangeIndicators, false, eventVal, indicatorArgs);
	                        }
	                    }
	
	                    function onInputKeyPress(event) {
	                        return;
	                        /*var $target = $(event.currentTarget);
	                        var inputType = $target.attr('data-inputtype');
	                        var inputValid = false;
	                        var inputValue = $target.val();
	                        switch (inputType) {
	                            case CCM.indicatorInputTypes.NecessaryPositiveInteger:
	                                inputValid = /^[0-9]*[1-9][0-9]*$/.test(inputValue);
	                                break;
	                            default:
	                                inputValid = (inputValue === '' || /^[0-9]*[1-9][0-9]*$/.test(inputValue));
	                                break;
	                        }
	
	                        var invalidLabel = $target.parent().next('div.' + invalidLabelClass);
	                        if (inputValid) {
	                            $target.removeClass(invalidClass);
	                            invalidLabel.remove();
	                        } else {
	                            $target.addClass(invalidClass);
	                            if (invalidLabel.length === 0) {
	                                $('<div>').addClass(invalidLabelClass)
	                                    .html(langObj['invalid-input-' + (inputType || 'default')])
	                                    .insertAfter($target.parent());
	                            }
	                        }*/
	                    }
	
	                    function onAutoCompleteClear() {
	                        self.$el.find('.mkts-cmpt-svgcht-search-input').val('');
	                        self.$el.find('.mkts-cmpt-svgcht-popover--search').remove();
	                    }
	
	                    function onMenuIconClick() {
	                        if (Util.isString(this.getAttribute('data-menuid'))) {
	                            var eventType = util.capFirstChar(this.getAttribute('data-menuid').replace('mkts-cmpt-svgcht-menuicn--', ''));
	
	                            if (eventManager.EventTypes[eventType]) {
	
	                                eventManager.trigger(eventManager.EventTypes[eventType]);
	
	                                eventManager.trigger(eventManager.EventTypes.triggerClickCallback, {
	                                    name: eventType
	                                });
	                            }
	                        }
	                    }
	
	                    function onCloseButton() {
	                        eventManager.trigger(eventManager.EventTypes.DestroyChart);
	                        if ($.isFunction(appConfig.onClose)) {
	                            appConfig.onClose({
	                                component: 'markets-components-svgchart'
	                            });
	                        }
	                    }
	
	                    function destroyMenubar() {
	                        appConfig.$componentContainer.off('.mkts-cmpt-svgcht-menu');
	                    }
	
	                    function onGrowthTypeClick(e) {
	                        var el = this;
	                        var $el = $(el);
	                        var eventType;
	                        var eventVal;
	
	                        e.preventDefault();
	                        e.stopPropagation();
	
	                        if ($el.hasClass("active")) {
	                            return;
	                        }
	
	                        var et = el.attributes['data-eventtype'].value;
	                        eventType = util.dashesToCamel(et);
	                        eventType = util.capFirstChar(eventType);
	                        var ev = el.attributes['data-eventvalue'].value;
	                        eventVal = util.dashesToCamel(ev);
	                        if (eventVal !== eventManager.EventTypes.Export) {
	                            $el.siblings().removeClass('active');
	                            $el.addClass('active');
	                        }
	                        eventManager.trigger(eventManager.EventTypes[eventType], eventVal);
	                        console.debug(eventManager.EventTypes[eventType], eventVal);
	                    }
	
	                    function print() {
	                        window.print();
	                    }
	
	                    function onResetRoomIn(e) {
	                        e.preventDefault();
	                        e.stopPropagation();
	                        eventManager.trigger(eventManager.EventTypes.ResetZoomIn);
	                    }
	
	                    eventManager.bind(eventManager.EventTypes.ChangeIndicators, onIndicatorChagne);
	                    eventManager.bind(eventManager.EventTypes.ChangeFundamental, onFundamentalChagne);
	                    eventManager.bind(eventManager.EventTypes.LayoutChange, onLayoutChange);
	                    eventManager.bind(eventManager.EventTypes.DestroyChart, destroyMenubar);
	                    eventManager.bind(eventManager.EventTypes.Print, print);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-menubtn', onMenuButtonClick);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-menuicn--gear', onSettingsClick);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-popover-menubtn', onSettingsButtonClick);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-menuicn--remove', onAutoCompleteClear);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-popover-body', onMenuItemClick);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-popover-text.zoom-in-reset', onResetRoomIn);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-menutab', onGrowthTypeClick);
	                    appConfig.$componentContainer.on('keyup.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-text-box', onInputKeyPress);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-btn-update', onUpdateIndicator);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-menuicn', onMenuIconClick);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-menuicn--remove', onCloseButton);
	                }
	            };
	
	            return MenuBar;
	        }
	
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "    <button data-eventtype=\"export\"  data-eventvalue=\"export\" class=\"mkts-cmpt-svgcht-menutab\" title=\""
	    + alias4(((helper = (helper = helpers["export"] || (depth0 != null ? depth0["export"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"export","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers["export"] || (depth0 != null ? depth0["export"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"export","hash":{},"data":data}) : helper)))
	    + "</button>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "    <span class=\"mkts-cmpt-svgcht-menuicn--label\">"
	    + container.escapeExpression(((helper = (helper = helpers.labelChange || (depth0 != null ? depth0.labelChange : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"labelChange","hash":{},"data":data}) : helper)))
	    + "</span> ";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n    <span class=\"mkts-cmpt-svgcht-menuicn--label\">"
	    + container.escapeExpression(((helper = (helper = helpers.labelSearch || (depth0 != null ? depth0.labelSearch : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"labelSearch","hash":{},"data":data}) : helper)))
	    + "</span>";
	},"7":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "        <span class=\"mkts-cmpt-svgcht-menuicn--label\">"
	    + container.escapeExpression(((helper = (helper = helpers.labelChange || (depth0 != null ? depth0.labelChange : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"labelChange","hash":{},"data":data}) : helper)))
	    + "</span> ";
	},"9":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n    <span class=\"mkts-cmpt-svgcht-menuicn--label\">"
	    + container.escapeExpression(((helper = (helper = helpers.labelSearch || (depth0 != null ? depth0.labelSearch : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"labelSearch","hash":{},"data":data}) : helper)))
	    + "</span> ";
	},"11":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "        <input data-menuid=\"mkts-cmpt-svgcht-search-input\" type=\"text\" class=\"mkts-cmpt-svgcht-search-input\" placeholder=\""
	    + container.escapeExpression(((helper = (helper = helpers.changeTicker || (depth0 != null ? depth0.changeTicker : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"changeTicker","hash":{},"data":data}) : helper)))
	    + "\"> ";
	},"13":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n        <input data-menuid=\"mkts-cmpt-svgcht-search-input\" type=\"text\" class=\"mkts-cmpt-svgcht-search-input\" placeholder=\""
	    + container.escapeExpression(((helper = (helper = helpers.addComparison || (depth0 != null ? depth0.addComparison : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"addComparison","hash":{},"data":data}) : helper)))
	    + "\"> ";
	},"15":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "\n    <span data-menuid=\"mkts-cmpt-svgcht-menuicn--gear\" class=\"mkts-cmpt-svgcht-menuicn mkts-cmpt-svgcht-menuicn--gear\" title=\""
	    + alias4(((helper = (helper = helpers.settings || (depth0 != null ? depth0.settings : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"settings","hash":{},"data":data}) : helper)))
	    + "\">\n		<button class=\"mkts-cmpt-svgcht-settingText\" title=\""
	    + alias4(((helper = (helper = helpers.optionsBtnText || (depth0 != null ? depth0.optionsBtnText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"optionsBtnText","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.options || (depth0 != null ? depth0.options : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"options","hash":{},"data":data}) : helper)))
	    + "</button>\n	</span> ";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"mkts-cmpt-svgcht-menubar-tab\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showExportMenuTab : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    <button data-eventtype=\"change-growth-type\" data-eventvalue=\"price-growth\" class=\"mkts-cmpt-svgcht-menutab\" title=\""
	    + alias4(((helper = (helper = helpers.pricesGrowthChart || (depth0 != null ? depth0.pricesGrowthChart : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pricesGrowthChart","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.pricesGrowthChart || (depth0 != null ? depth0.pricesGrowthChart : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pricesGrowthChart","hash":{},"data":data}) : helper)))
	    + "</button>\n    <button data-eventtype=\"change-growth-type\" data-eventvalue=\"performances-growth\" class=\"mkts-cmpt-svgcht-menutab mkts-cmpt-svgcht-menutab-performance active\" title=\""
	    + alias4(((helper = (helper = helpers.performanceGrowthChart || (depth0 != null ? depth0.performanceGrowthChart : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"performanceGrowthChart","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.performanceGrowthChart || (depth0 != null ? depth0.performanceGrowthChart : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"performanceGrowthChart","hash":{},"data":data}) : helper)))
	    + "</button>\n    <button data-eventtype=\"change-growth-type\" data-eventvalue=\"performances-growth\" class=\"mkts-cmpt-svgcht-menutab mkts-cmpt-svgcht-menutab-performance-mobile active\" title=\""
	    + alias4(((helper = (helper = helpers.performanceGrowthChart || (depth0 != null ? depth0.performanceGrowthChart : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"performanceGrowthChart","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.performanceGrowthChartance || (depth0 != null ? depth0.performanceGrowthChartance : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"performanceGrowthChartance","hash":{},"data":data}) : helper)))
	    + "</button>\n</div>\n<hr class=\"mkts-cmpt-svgcht-hr\">\n<div class=\"mkts-cmpt-svgcht-menubar-top\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.autoCompleteChangeMainTicker : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n    <span data-menuid=\"mkts-cmpt-svgcht-menuicn--search\" class=\"mkts-cmpt-svgcht-menuicn mkts-cmpt-svgcht-menuicn--search\" title=\""
	    + alias4(((helper = (helper = helpers.addComparison || (depth0 != null ? depth0.addComparison : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"addComparison","hash":{},"data":data}) : helper)))
	    + "\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.autoCompleteChangeMainTicker : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n    </span>\n    <div class=\"mkts-cmpt-svgcht-search\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.autoCompleteChangeMainTicker : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.program(13, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n\n        <span class=\"mkts-cmpt-svgcht-search-clear\">&#215;</span>\n    </div>\n    <button class=\"mkts-cmpt-svgcht-menubtn mkts-cmpt-svgcht-menubtn--events-indicators\" data-menuid=\"events-indicators\" title=\""
	    + alias4(((helper = (helper = helpers.eventsIndicators || (depth0 != null ? depth0.eventsIndicators : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"eventsIndicators","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.eventsIndicators || (depth0 != null ? depth0.eventsIndicators : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"eventsIndicators","hash":{},"data":data}) : helper)))
	    + "</button>\n    <button class=\"mkts-cmpt-svgcht-menubtn mkts-cmpt-svgcht-menubtn--fundamental\" data-menuid=\"fundamentals\" title=\""
	    + alias4(((helper = (helper = helpers.fundamentals || (depth0 != null ? depth0.fundamentals : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fundamentals","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.fundamentals || (depth0 != null ? depth0.fundamentals : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fundamentals","hash":{},"data":data}) : helper)))
	    + "</button>\n    <button class=\"mkts-cmpt-svgcht-menubtn mkts-cmpt-svgcht-menubtn--drawing\" data-menuid=\"drawings\" title=\""
	    + alias4(((helper = (helper = helpers.drawings || (depth0 != null ? depth0.drawings : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"drawings","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.drawings || (depth0 != null ? depth0.drawings : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"drawings","hash":{},"data":data}) : helper)))
	    + "</button>\n    <button class=\"mkts-cmpt-svgcht-menubtn mkts-cmpt-svgcht-menubtn--display\" data-menuid=\"display\" title=\""
	    + alias4(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"display","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"display","hash":{},"data":data}) : helper)))
	    + "</button> "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideGear : depth0),{"name":"unless","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n    <span data-menuid=\"mkts-cmpt-svgcht-menuicn--reset\" class=\"mkts-cmpt-svgcht-menuicn mkts-cmpt-svgcht-menuTextIcon mkts-cmpt-svgcht-menuicn--reset\" title=\""
	    + alias4(((helper = (helper = helpers.reset || (depth0 != null ? depth0.reset : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reset","hash":{},"data":data}) : helper)))
	    + "\">\n            <button class=\"mkts-cmpt-svgcht-menuText\" title=\""
	    + alias4(((helper = (helper = helpers.reset || (depth0 != null ? depth0.reset : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reset","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.reset || (depth0 != null ? depth0.reset : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reset","hash":{},"data":data}) : helper)))
	    + "</button>\n        </span>\n    <span data-menuid=\"mkts-cmpt-svgcht-menuicn--export\" class=\"mkts-cmpt-svgcht-menuicn mkts-cmpt-svgcht-menuTextIcon mkts-cmpt-svgcht-menuicn--export\" title=\""
	    + alias4(((helper = (helper = helpers["export"] || (depth0 != null ? depth0["export"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"export","hash":{},"data":data}) : helper)))
	    + "\">\n            <button class=\"mkts-cmpt-svgcht-menuText\" title=\""
	    + alias4(((helper = (helper = helpers["export"] || (depth0 != null ? depth0["export"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"export","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers["export"] || (depth0 != null ? depth0["export"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"export","hash":{},"data":data}) : helper)))
	    + "</button>\n        </span>\n    <span data-menuid=\"mkts-cmpt-svgcht-menuicn--print\" class=\"mkts-cmpt-svgcht-menuicn mkts-cmpt-svgcht-menuTextIcon mkts-cmpt-svgcht-menuicn--print\" title=\""
	    + alias4(((helper = (helper = helpers.print || (depth0 != null ? depth0.print : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"print","hash":{},"data":data}) : helper)))
	    + "\">\n            <button class=\"mkts-cmpt-svgcht-menuText\" title=\""
	    + alias4(((helper = (helper = helpers.print || (depth0 != null ? depth0.print : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"print","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.print || (depth0 != null ? depth0.print : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"print","hash":{},"data":data}) : helper)))
	    + "</button> \n         </span>\n    <span data-menuid=\"mkts-cmpt-svgcht-menuicn--remove\" class=\"mkts-cmpt-svgcht-menuicn mkts-cmpt-svgcht-menuicn--remove\" title=\""
	    + alias4(((helper = (helper = helpers.closeBtnText || (depth0 != null ? depth0.closeBtnText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"closeBtnText","hash":{},"data":data}) : helper)))
	    + "\"></span>\n</div>\n<hr class=\"mkts-cmpt-svgcht-hr\">\n<div class=\"mkts-cmpt-svgcht-menubar-bottom\">\n</div>";
	},"useData":true});

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div>\n    <div class=\"mkts-cmpt-svgcht-popover-title\">"
	    + alias4(((helper = (helper = helpers.fundamentals || (depth0 != null ? depth0.fundamentals : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fundamentals","hash":{},"data":data}) : helper)))
	    + "<span class=\"mkts-cmpt-svgcht-popover-close\"></span></div>\n    <div class=\"mkts-cmpt-svgcht-popover-content change-fundamental\" data-menuid=\"change-fundamental\">\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off p-e\" data-menuid=\"p-e\">"
	    + alias4(((helper = (helper = helpers.priceEarnings || (depth0 != null ? depth0.priceEarnings : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"priceEarnings","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off p-s\" data-menuid=\"p-s\">"
	    + alias4(((helper = (helper = helpers.priceSales || (depth0 != null ? depth0.priceSales : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"priceSales","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off p-b\" data-menuid=\"p-b\">"
	    + alias4(((helper = (helper = helpers.priceBook || (depth0 != null ? depth0.priceBook : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"priceBook","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off p-c\" data-menuid=\"p-c\">"
	    + alias4(((helper = (helper = helpers.priceCash || (depth0 != null ? depth0.priceCash : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"priceCash","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off fair-value\" data-menuid=\"fair-value\">\n            <div class=\"mkts-cmpt-svgcht-premium-chic\">"
	    + alias4(((helper = (helper = helpers.fairValue || (depth0 != null ? depth0.fairValue : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fairValue","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off quantitative-fair-value\" data-menuid=\"quantitative-fair-value\">\n            <div class=\"mkts-cmpt-svgcht-premium-chic\">"
	    + alias4(((helper = (helper = helpers.fairValue || (depth0 != null ? depth0.fairValue : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fairValue","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off r-dividend\" data-menuid=\"r-dividend\">"
	    + alias4(((helper = (helper = helpers.rollingDividend || (depth0 != null ? depth0.rollingDividend : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"rollingDividend","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off d-yield\" data-menuid=\"d-yield\">"
	    + alias4(((helper = (helper = helpers.dividendYield || (depth0 != null ? depth0.dividendYield : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dividendYield","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off r-e-p-s\" data-menuid=\"r-e-p-s\">"
	    + alias4(((helper = (helper = helpers.rollingEPS || (depth0 != null ? depth0.rollingEPS : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"rollingEPS","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off discount-cum-fair\" data-menuid=\"discount-cum-fair\">"
	    + alias4(((helper = (helper = helpers.priceEarnings0 || (depth0 != null ? depth0.priceEarnings0 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"priceEarnings0","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off daily-cum-fair-nav\" data-menuid=\"daily-cum-fair-nav\">"
	    + alias4(((helper = (helper = helpers.priceEarnings1 || (depth0 != null ? depth0.priceEarnings1 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"priceEarnings1","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off premium-discount\" data-menuid=\"premium-discount\">"
	    + alias4(((helper = (helper = helpers.priceEarnings2 || (depth0 != null ? depth0.priceEarnings2 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"priceEarnings2","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-popover-body-last mkts-cmpt-svgcht-toggle--off s-interest\" data-menuid=\"s-interest\">"
	    + alias4(((helper = (helper = helpers.shortInt || (depth0 != null ? depth0.shortInt : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"shortInt","hash":{},"data":data}) : helper)))
	    + "</div>\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div>\n    <div class=\"mkts-cmpt-svgcht-popover-title\">"
	    + alias4(((helper = (helper = helpers.drawings || (depth0 != null ? depth0.drawings : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"drawings","hash":{},"data":data}) : helper)))
	    + "<span class=\"mkts-cmpt-svgcht-popover-close\"></span></div>\n    <div class=\"mkts-cmpt-svgcht-popover-content change-drawing\" data-menuid=\"change-drawing\">\n        <div class=\"mkts-cmpt-svgcht-popover-body trend-line\" data-menuid=\"trend-line\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.trendLine || (depth0 != null ? depth0.trendLine : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"trendLine","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body rectangle\" data-menuid=\"rectangle\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.rectangle || (depth0 != null ? depth0.rectangle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"rectangle","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body ellipse\" data-menuid=\"ellipse\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.ellipse || (depth0 != null ? depth0.ellipse : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ellipse","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body level-line\" data-menuid=\"level-line\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.levelLine || (depth0 != null ? depth0.levelLine : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"levelLine","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body fibonacci-retracement-levels\" data-menuid=\"fibonacci-retracement-levels\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.fibonacciRL || (depth0 != null ? depth0.fibonacciRL : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fibonacciRL","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body fibonacci-fans\" data-menuid=\"fibonacci-fans\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.fibonacciFans || (depth0 != null ? depth0.fibonacciFans : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fibonacciFans","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body fibonacci-time-zones\" data-menuid=\"fibonacci-time-zones\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.fibonacciTZ || (depth0 != null ? depth0.fibonacciTZ : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fibonacciTZ","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-popover-body-last fibonacci-arcs\" data-menuid=\"fibonacci-arcs\">\n            <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.fibonacciArcs || (depth0 != null ? depth0.fibonacciArcs : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fibonacciArcs","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                <div class=\"mkts-cmpt-svgcht-popover-body price-with-dividend-growth\" data-menuid=\"price-with-dividend-growth\">\n                    <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + container.escapeExpression(((helper = (helper = helpers.priceWithDividendGrowth || (depth0 != null ? depth0.priceWithDividendGrowth : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"priceWithDividendGrowth","hash":{},"data":data}) : helper)))
	    + "</div>\n                </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"mkts-cmpt-svgcht-popover-sub-title title-start-date\">"
	    + alias4(((helper = (helper = helpers.startDate || (depth0 != null ? depth0.startDate : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"startDate","hash":{},"data":data}) : helper)))
	    + " <span class=\"title-start-date-illustrate\" title=\""
	    + alias4(((helper = (helper = helpers.startDateIllustrate || (depth0 != null ? depth0.startDateIllustrate : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"startDateIllustrate","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.startDateIllustrate || (depth0 != null ? depth0.startDateIllustrate : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"startDateIllustrate","hash":{},"data":data}) : helper)))
	    + "</span></div>\n\n            <div class=\"change-start-date\" data-menuid=\"change-start-date\">\n                <div class=\"mkts-cmpt-svgcht-popover-body earliest\" data-menuid=\"earliest\">\n                    <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.earliest || (depth0 != null ? depth0.earliest : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"earliest","hash":{},"data":data}) : helper)))
	    + "</div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-popover-body common\" data-menuid=\"common\">\n                    <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.common || (depth0 != null ? depth0.common : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"common","hash":{},"data":data}) : helper)))
	    + "</div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-popover-body main\" data-menuid=\"main\">\n                    <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.mainTicker || (depth0 != null ? depth0.mainTicker : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"mainTicker","hash":{},"data":data}) : helper)))
	    + "</div>\n                </div>\n            </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div>\n    <div class=\"mkts-cmpt-svgcht-popover-title\">"
	    + alias4(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"display","hash":{},"data":data}) : helper)))
	    + "<span class=\"mkts-cmpt-svgcht-popover-close\"></span></div>\n    <div class=\"mkts-cmpt-svgcht-popover-content\">\n        <div class=\"mkts-cmpt-svgcht-popover-sub-title chart-cursor-sub-title\">"
	    + alias4(((helper = (helper = helpers.cursorType || (depth0 != null ? depth0.cursorType : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"cursorType","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-chart-cursor\" data-menuid=\"change-chart-cursor\">\n            <div class=\"mkts-cmpt-svgcht-popover-body crosshair\" data-menuid=\"crosshair\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.crosshair || (depth0 != null ? depth0.crosshair : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"crosshair","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body trackball\" data-menuid=\"trackball\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.trackBall || (depth0 != null ? depth0.trackBall : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"trackBall","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body off\" data-menuid=\"off\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.off || (depth0 != null ? depth0.off : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"off","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-sub-title\">"
	    + alias4(((helper = (helper = helpers.chartType || (depth0 != null ? depth0.chartType : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"chartType","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-chart-type\" data-menuid=\"change-chart-type\">\n            <div class=\"mkts-cmpt-svgcht-popover-body mountain-chart\" data-menuid=\"mountain-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.mountain || (depth0 != null ? depth0.mountain : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"mountain","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body line-chart\" data-menuid=\"line-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.line || (depth0 != null ? depth0.line : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"line","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body dot-chart\" data-menuid=\"dot-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.dot || (depth0 != null ? depth0.dot : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dot","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body ab-chart\" data-menuid=\"ab-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.aboveBelow || (depth0 != null ? depth0.aboveBelow : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"aboveBelow","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body ohlc-chart\" data-menuid=\"ohlc-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.OHLC || (depth0 != null ? depth0.OHLC : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"OHLC","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body candlestick-chart\" data-menuid=\"candlestick-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.candlestick || (depth0 != null ? depth0.candlestick : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"candlestick","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body p-growth-chart\" data-menuid=\"p-growth-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.growth || (depth0 != null ? depth0.growth : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"growth","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body ten-k-growth-chart\" data-menuid=\"ten-k-growth-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers["10KGrowth"] || (depth0 != null ? depth0["10KGrowth"] : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"10KGrowth","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showPriceWithDividendGrowth : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            <div class=\"mkts-cmpt-svgcht-popover-body dividend-effect-chart\" data-menuid=\"dividend-effect-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.dividendEffect || (depth0 != null ? depth0.dividendEffect : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dividendEffect","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body post-tax-return-chart\" data-menuid=\"post-tax-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.postTax || (depth0 != null ? depth0.postTax : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"postTax","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-sub-title\">"
	    + alias4(((helper = (helper = helpers.yAxis || (depth0 != null ? depth0.yAxis : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"yAxis","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-y-axis\" data-menuid=\"change-y-axis\">\n            <div class=\"mkts-cmpt-svgcht-popover-body left\" data-menuid=\"left\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.left || (depth0 != null ? depth0.left : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"left","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body right\" data-menuid=\"right\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.right || (depth0 != null ? depth0.right : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"right","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-sub-title\">"
	    + alias4(((helper = (helper = helpers.verticalScale || (depth0 != null ? depth0.verticalScale : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"verticalScale","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-vertical-scale\" data-menuid=\"change-vertical-scale\">\n            <div class=\"mkts-cmpt-svgcht-popover-body linear\" data-menuid=\"linear\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.linear || (depth0 != null ? depth0.linear : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"linear","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body logarithmic\" data-menuid=\"logarithmic\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.logarithmic || (depth0 != null ? depth0.logarithmic : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"logarithmic","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-sub-title title-selection-mode\">"
	    + alias4(((helper = (helper = helpers.selectionMode || (depth0 != null ? depth0.selectionMode : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"selectionMode","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-selection-mode\" data-menuid=\"change-selection-mode\">\n            <div class=\"mkts-cmpt-svgcht-popover-body pan\" data-menuid=\"pan\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.pan || (depth0 != null ? depth0.pan : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"pan","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body zoom-in\" data-menuid=\"zoom-in\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.zoomIn || (depth0 != null ? depth0.zoomIn : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"zoomIn","hash":{},"data":data}) : helper)))
	    + "\n                    <span class=\"mkts-cmpt-svgcht-popover-text zoom-in-reset\" data-menuid=\"reset\">"
	    + alias4(((helper = (helper = helpers.reset || (depth0 != null ? depth0.reset : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"reset","hash":{},"data":data}) : helper)))
	    + "</span>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body off\" data-menuid=\"off\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.off || (depth0 != null ? depth0.off : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"off","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n        </div>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showStartDate : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        <div class=\"mkts-cmpt-svgcht-popover-sub-title title-other\">"
	    + alias4(((helper = (helper = helpers.other || (depth0 != null ? depth0.other : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"other","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-extended-market-hour\" data-menuid=\"change-extended-market-hour\">\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off extended-market-hour\" data-menuid=\"extended-market-hour\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.extendedMarketHour || (depth0 != null ? depth0.extendedMarketHour : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"extendedMarketHour","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n        </div>\n        <div class=\"change-chart-volume-plus\" data-menuid=\"change-chart-volume-plus\">\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-popover-body-last mkts-cmpt-svgcht-toggle--off volume-plus-chart\" data-menuid=\"volume-plus-chart\">\n                <div class=\"mkts-cmpt-svgcht-popover-text\">"
	    + alias4(((helper = (helper = helpers.volumePlus || (depth0 != null ? depth0.volumePlus : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"volumePlus","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n        </div>\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "    <div class=\"mkts-cmpt-svgcht-popover-menubtn mkts-cmpt-svgcht-popover-menubtn--events-indicators\" data-menuid=\"events-indicators\">\n        <div>"
	    + container.escapeExpression(((helper = (helper = helpers.eventsIndicators || (depth0 != null ? depth0.eventsIndicators : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"eventsIndicators","hash":{},"data":data}) : helper)))
	    + "</div>\n    </div>\n    ";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n    <div class=\"mkts-cmpt-svgcht-popover-menubtn mkts-cmpt-svgcht-popover-menubtn--fundamental\" data-menuid=\"fundamentals\">\n        <div>"
	    + container.escapeExpression(((helper = (helper = helpers.fundamentals || (depth0 != null ? depth0.fundamentals : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"fundamentals","hash":{},"data":data}) : helper)))
	    + "</div>\n    </div>\n    ";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n    <div class=\"mkts-cmpt-svgcht-popover-menubtn mkts-cmpt-svgcht-popover-menubtn--drawing\" data-menuid=\"drawings\">\n        <div>"
	    + container.escapeExpression(((helper = (helper = helpers.drawings || (depth0 != null ? depth0.drawings : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"drawings","hash":{},"data":data}) : helper)))
	    + "</div>\n    </div>\n    ";
	},"7":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n    <div class=\"mkts-cmpt-svgcht-popover-menubtn mkts-cmpt-svgcht-popover-menubtn-last mkts-cmpt-svgcht-popover-menubtn--display\" data-menuid=\"display\">\n        <div>"
	    + container.escapeExpression(((helper = (helper = helpers.display || (depth0 != null ? depth0.display : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"display","hash":{},"data":data}) : helper)))
	    + "</div>\n    </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<div>\n    <div class=\"mkts-cmpt-svgcht-popover-title\">"
	    + container.escapeExpression(((helper = (helper = helpers.settings || (depth0 != null ? depth0.settings : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"settings","hash":{},"data":data}) : helper)))
	    + "<span class=\"mkts-cmpt-svgcht-popover-close\"></span></div>\n"
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideIndicatorInGear : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideFundamentalInGear : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideDrawingInGear : depth0),{"name":"unless","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.hideDisplayInGear : depth0),{"name":"unless","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>";
	},"useData":true});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div>\n    <div class=\"mkts-cmpt-svgcht-popover-title\">"
	    + alias4(((helper = (helper = helpers.eventsIndicators || (depth0 != null ? depth0.eventsIndicators : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"eventsIndicators","hash":{},"data":data}) : helper)))
	    + "<span class=\"mkts-cmpt-svgcht-popover-close\"></span></div>\n    <div class=\"mkts-cmpt-svgcht-popover-content\">\n        <div class=\"mkts-cmpt-svgcht-popover-sub-title mkts-cmpt-svgcht-popover1-subtitle1\" data-menuid=\"mkts-cmpt-svgcht-popover1-subtitle1\">"
	    + alias4(((helper = (helper = helpers.events || (depth0 != null ? depth0.events : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"events","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-events\" data-menuid=\"change-events\">\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off dividend\" data-menuid=\"dividend\">"
	    + alias4(((helper = (helper = helpers.eventsDividende || (depth0 != null ? depth0.eventsDividende : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"eventsDividende","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off split\" data-menuid=\"split\">"
	    + alias4(((helper = (helper = helpers.eventsSplits || (depth0 != null ? depth0.eventsSplits : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"eventsSplits","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off earnings\" data-menuid=\"earnings\">"
	    + alias4(((helper = (helper = helpers.eventsEarnings || (depth0 != null ? depth0.eventsEarnings : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"eventsEarnings","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-popover-sub-title mkts-cmpt-svgcht-popover1-subtitle2\" data-menuid=\"mkts-cmpt-svgcht-popover1-subtitle2\">"
	    + alias4(((helper = (helper = helpers.indicators || (depth0 != null ? depth0.indicators : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicators","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"change-indicators\" data-menuid=\"change-indicators\">\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off s-m-a\" data-menuid=\"s-m-a\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMA || (depth0 != null ? depth0.indicatorsSMA : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMA","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAlabel1 || (depth0 != null ? depth0.indicatorsSMAlabel1 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAlabel1","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"10\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAlabel2 || (depth0 != null ? depth0.indicatorsSMAlabel2 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAlabel2","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"50\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAlabel3 || (depth0 != null ? depth0.indicatorsSMAlabel3 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAlabel3","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off e-m-a\" data-menuid=\"e-m-a\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMA || (depth0 != null ? depth0.indicatorsEMA : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMA","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAlabel1 || (depth0 != null ? depth0.indicatorsEMAlabel1 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAlabel1","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"10\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAlabel2 || (depth0 != null ? depth0.indicatorsEMAlabel2 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAlabel2","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAlabel3 || (depth0 != null ? depth0.indicatorsEMAlabel3 : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAlabel3","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"change-chart-volume\" data-menuid=\"change-chart-volume\">\n                <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--on volume-chart\" data-menuid=\"volume-chart\">"
	    + alias4(((helper = (helper = helpers.indicatorsVolume || (depth0 != null ? depth0.indicatorsVolume : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsVolume","hash":{},"data":data}) : helper)))
	    + "</div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off s-m-a-v\" data-menuid=\"s-m-a-v\">"
	    + alias4(((helper = (helper = helpers.indicatorsVolumeSMA || (depth0 != null ? depth0.indicatorsVolumeSMA : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsVolumeSMA","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsPeriod || (depth0 != null ? depth0.indicatorsPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"50\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off b-bands\" data-menuid=\"b-bands\">"
	    + alias4(((helper = (helper = helpers.indicatorsBBands || (depth0 != null ? depth0.indicatorsBBands : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsBBands","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsBBandsPeriod || (depth0 != null ? depth0.indicatorsBBandsPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsBBandsPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" data-inputtype=\"npi\" value=\"20\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsBBandsDeviation || (depth0 != null ? depth0.indicatorsBBandsDeviation : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsBBandsDeviation","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" data-inputtype=\"npi\" value=\"2\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off p-s-a-r\" data-menuid=\"p-s-a-r\">"
	    + alias4(((helper = (helper = helpers.indicatorsPSAR || (depth0 != null ? depth0.indicatorsPSAR : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsPSAR","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsPSARStep || (depth0 != null ? depth0.indicatorsPSARStep : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsPSARStep","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"0.02\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsPSARMaxStep || (depth0 != null ? depth0.indicatorsPSARMaxStep : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsPSARMaxStep","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"0.2\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off m-a-c-d\" data-menuid=\"m-a-c-d\">"
	    + alias4(((helper = (helper = helpers.indicatorsMACD || (depth0 != null ? depth0.indicatorsMACD : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsMACD","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsMACDSlow || (depth0 != null ? depth0.indicatorsMACDSlow : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsMACDSlow","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"26\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsMACDFast || (depth0 != null ? depth0.indicatorsMACDFast : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsMACDFast","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"12\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsMACDSignal || (depth0 != null ? depth0.indicatorsMACDSignal : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsMACDSignal","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"9\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off r-s-i\" data-menuid=\"r-s-i\">"
	    + alias4(((helper = (helper = helpers.indicatorsRSI || (depth0 != null ? depth0.indicatorsRSI : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsRSI","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsRSIPeriod || (depth0 != null ? depth0.indicatorsRSIPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsRSIPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off r-o-c\" data-menuid=\"r-o-c\">"
	    + alias4(((helper = (helper = helpers.indicatorsROC || (depth0 != null ? depth0.indicatorsROC : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsROC","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsROCPeriod || (depth0 != null ? depth0.indicatorsROCPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsROCPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"12\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n			<div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off c-c-i\" data-menuid=\"c-c-i\">"
	    + alias4(((helper = (helper = helpers.indicatorsCCI || (depth0 != null ? depth0.indicatorsCCI : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsCCI","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsCCIPeriod || (depth0 != null ? depth0.indicatorsCCIPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsCCIPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"20\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off will-r\" data-menuid=\"will-r\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAR || (depth0 != null ? depth0.indicatorsSMAR : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAR","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAPeriod || (depth0 != null ? depth0.indicatorsSMAPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off s-stochastic\" data-menuid=\"s-stochastic\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMASlow || (depth0 != null ? depth0.indicatorsSMASlow : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMASlow","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAK || (depth0 != null ? depth0.indicatorsSMAK : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAK","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAD || (depth0 != null ? depth0.indicatorsSMAD : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAD","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"3\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off f-stochastic\" data-menuid=\"f-stochastic\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAFast || (depth0 != null ? depth0.indicatorsSMAFast : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAFast","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAFastK || (depth0 != null ? depth0.indicatorsSMAFastK : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAFastK","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAFastD || (depth0 != null ? depth0.indicatorsSMAFastD : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAFastD","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"3\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off p-channel\" data-menuid=\"p-channel\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAPrice || (depth0 != null ? depth0.indicatorsSMAPrice : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAPrice","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAPriceChannel || (depth0 != null ? depth0.indicatorsSMAPriceChannel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAPriceChannel","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off m-a-e\" data-menuid=\"m-a-e\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAMA || (depth0 != null ? depth0.indicatorsSMAMA : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAMA","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAMAPeriod || (depth0 != null ? depth0.indicatorsSMAMAPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAMAPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAMABand || (depth0 != null ? depth0.indicatorsSMAMABand : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAMABand","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"2\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off momentum\" data-menuid=\"momentum\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAMomentum || (depth0 != null ? depth0.indicatorsSMAMomentum : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAMomentum","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAMomentumPeriod || (depth0 != null ? depth0.indicatorsSMAMomentumPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAMomentumPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"2\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off u-l-t\" data-menuid=\"u-l-t\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAULT || (depth0 != null ? depth0.indicatorsSMAULT : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAULT","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off d-m-i\" data-menuid=\"d-m-i\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMADMI || (depth0 != null ? depth0.indicatorsSMADMI : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMADMI","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMADMIPeriod || (depth0 != null ? depth0.indicatorsSMADMIPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMADMIPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off m-f-i\" data-menuid=\"m-f-i\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAMoney || (depth0 != null ? depth0.indicatorsSMAMoney : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAMoney","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAMoneyPeriod || (depth0 != null ? depth0.indicatorsSMAMoneyPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAMoneyPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"14\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off o-b-v\" data-menuid=\"o-b-v\">"
	    + alias4(((helper = (helper = helpers.indicatorsSMAOBV || (depth0 != null ? depth0.indicatorsSMAOBV : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsSMAOBV","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off v-acc\" data-menuid=\"v-acc\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAVol || (depth0 != null ? depth0.indicatorsEMAVol : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAVol","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off u-d-ratio\" data-menuid=\"u-d-ratio\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMADirect || (depth0 != null ? depth0.indicatorsEMADirect : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMADirect","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMADirectPeriodo || (depth0 != null ? depth0.indicatorsEMADirectPeriodo : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMADirectPeriodo","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"7\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMADirectSmoothing || (depth0 != null ? depth0.indicatorsEMADirectSmoothing : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMADirectSmoothing","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"5\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off v-b-p\" data-menuid=\"v-b-p\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAVolume || (depth0 != null ? depth0.indicatorsEMAVolume : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAVolume","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off f-volatility\" data-menuid=\"f-volatility\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAFast || (depth0 != null ? depth0.indicatorsEMAFast : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAFast","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off w-m-a\" data-menuid=\"w-m-a\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAWeight || (depth0 != null ? depth0.indicatorsEMAWeight : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAWeight","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAWeightPeriodo || (depth0 != null ? depth0.indicatorsEMAWeightPeriodo : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAWeightPeriodo","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"15\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off acc-dis\" data-menuid=\"acc-dis\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAAD || (depth0 != null ? depth0.indicatorsEMAAD : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAAD","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off mass\" data-menuid=\"mass\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAMass || (depth0 != null ? depth0.indicatorsEMAMass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAMass","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off volatility\" data-menuid=\"volatility\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAVolat || (depth0 != null ? depth0.indicatorsEMAVolat : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAVolat","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAVolatPeriod || (depth0 != null ? depth0.indicatorsEMAVolatPeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAVolatPeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"10\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAVolatPeriodA || (depth0 != null ? depth0.indicatorsEMAVolatPeriodA : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAVolatPeriodA","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"10\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off force-index\" data-menuid=\"force-index\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAForce || (depth0 != null ? depth0.indicatorsEMAForce : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAForce","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMAForcePeriod || (depth0 != null ? depth0.indicatorsEMAForcePeriod : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMAForcePeriod","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" value=\"13\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off a-t-r\" data-menuid=\"a-t-r\">"
	    + alias4(((helper = (helper = helpers.indicatorsEMARange || (depth0 != null ? depth0.indicatorsEMARange : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsEMARange","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-toggle--off keltner\" data-menuid=\"keltner\">"
	    + alias4(((helper = (helper = helpers.indicatorsVolumeKeltner || (depth0 != null ? depth0.indicatorsVolumeKeltner : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsVolumeKeltner","hash":{},"data":data}) : helper)))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-drawer\">\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsVolumeKeltnerEMA || (depth0 != null ? depth0.indicatorsVolumeKeltnerEMA : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsVolumeKeltnerEMA","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" data-inputtype=\"npi\" value=\"20\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsVolumeKeltnerTimes || (depth0 != null ? depth0.indicatorsVolumeKeltnerTimes : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsVolumeKeltnerTimes","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" data-inputtype=\"npi\" value=\"2\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.indicatorsVolumeKeltnerATR || (depth0 != null ? depth0.indicatorsVolumeKeltnerATR : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsVolumeKeltnerATR","hash":{},"data":data}) : helper)))
	    + "</label>\n                    <div class=\"mkts-cmpt-svgcht-dropdown\">\n                        <input class=\"mkts-cmpt-svgcht-text-box\" data-inputtype=\"npi\" value=\"10\" />\n                    </div>\n                </div>\n                <div class=\"mkts-cmpt-svgcht-drawer-row\">\n                    <button class=\"mkts-cmpt-svgcht-btn-update\">"
	    + alias4(((helper = (helper = helpers.update || (depth0 != null ? depth0.update : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"update","hash":{},"data":data}) : helper)))
	    + "</button>\n                </div>\n            </div>\n            <div class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-popover-body-last mkts-cmpt-svgcht-toggle--off prev-close\" data-menuid=\"prev-close\">"
	    + alias4(((helper = (helper = helpers.indicatorsVolumePrevious || (depth0 != null ? depth0.indicatorsVolumePrevious : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"indicatorsVolumePrevious","hash":{},"data":data}) : helper)))
	    + "</div>\n        </div>\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(31),
	        __webpack_require__(32),
	        __webpack_require__(3),
	        __webpack_require__(17),
	        __webpack_require__(1),
	        __webpack_require__(19)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(intervalTemplate,
	        intervalSelectOption,
	        core,
	        util,
	        morningstar,
	        moment) {
	        "use strict";
	
	        /**
	         * Menubar for main chart type view
	         *
	         * @constructor
	         */
	        var $ = core.$;
	        var Util = core.Util;
	        var isMobile = util.deviceType.mobile();
	        var intervalsMapping = {
	            '1D': ".one-day",
	            '5D': ".five-day",
	            '15D': ".fifteen-day",
	            '1M': ".one-month",
	            '3M': ".three-month",
	            '6M': ".six-month",
	            'YTD': ".y-t-d",
	            '1Y': ".one-year",
	            '3Y': ".three-year",
	            '5Y': ".five-year",
	            '10Y': ".ten-year",
	            'MAX': ".max"
	        };
	
	        var model = function myfunction(managers) {
	            var eventManager = managers.eventManager;
	            var CCM = managers.chartConfigManager;
	            var $intervalTemplate;
	            var freqConfig = CCM.frequencyConfig;
	            var freqTypes = CCM.FrequencyTypes;
	            var IntervalTypes = CCM.IntervalTypes;
	            var datePickerFixativeFormater = 'YYYY-MM-DD';
	            var $startInput, $endInput;
	            var appConfig, isFundChart;
	            var datePicker;
	
	            var Interval = function(config) {
	                this.LastIntervalType; //remain last interval type to change the frequency of "Max"
	                this.config = {
	                    container: ''
	                };
	                this._init(config);
	            };
	
	            Interval.prototype = {
	                /* test-code */
	                __private: {
	                    CCM: CCM,
	                    eventManager: eventManager
	                },
	                /* end-test-code */
	                _init: function(config) {
	                    this.setupCalendars = function() {
	                        $startInput = $intervalTemplate.find('.mkts-cmpt-svgcht-start-input');
	                        $endInput = $intervalTemplate.find('.mkts-cmpt-svgcht-end-input');
	                        if (!isMobile) {
	                            var datePickerConfig = $.extend(true, {}, appConfig.datePicker, {
	                                needTrack: false,
	                                dataFields: [$startInput[0], $endInput[0]],
	                                startDate: self.startMoment.toDate(),
	                                endDate: self.endMoment.toDate(),
	                                lang: appConfig.lang,
	                                format: this.displayFomater,
	                                triggerClass: 'mkts-cmpt-svgcht-cal-picker',
	                                labels: CCM.getD3Locale()
	                            });
	                            var params = {
	                                element: appConfig.$componentContainer,
	                                initialConfiguration: {
	                                    component: {
	                                        configuration: datePickerConfig,
	
	                                    }
	                                }
	                            };
	                            datePicker = morningstar.components['markets-components-datepicker'].createComponent(params);
	                        }
	                    }
	                    this.displayFomater = function(date) {
	                        if ($.isFunction(appConfig.datePicker.format)) {
	                            return appConfig.datePicker.format(date);
	                        }
	                        var formater = appConfig.dailyDateFormatter;
	                        if (moment.isDate(date)) {
	                            date = moment(date);
	                        }
	                        return date.format(formater || datePickerFixativeFormater);
	                    };
	
	                    function setDefaultRange() {
	                        if (isFundChart || appConfig.drawNavAndPriceChart) {
	                            $intervalTemplate.find('.one-day, .five-day, .fifteen-day').remove();
	                        }
	                        self.rangePreset = appConfig.intervalType;
	                        if (self.rangePreset) {
	                            $intervalTemplate.find('.' + util.camelToDashes(self.rangePreset)).addClass('active');
	                        }
	                        self._updateFreq(self.rangePreset || CCM.getFrequencyByDateRange(appConfig.dateRange, true));
	                    }
	
	                    var self = this;
	                    appConfig = CCM.getConfig();
	                    isFundChart = appConfig.chartGenre === CCM.ChartGenre.FundChart;
	                    var locale = appConfig.lang || 'en-US';
	                    var langObj = CCM.getLabels('markets-components-svgchart', locale);
	
	                    self._clearRange = function() {
	                        self.rangePreset = null;
	                        this.$container.find('.mkts-cmpt-svgcht-segment-option').removeClass('active');
	                    };
	
	
	
	                    self._emitIntervalFreq = function() {
	                        var freq = self.intervalFreq;
	                        var interval, dateRange;
	
	                        if (Util.isString(self.rangePreset)) {
	                            interval = self.rangePreset;
	                        } else {
	                            dateRange = [self.startMoment.toDate(), self.endMoment.toDate()];
	                        }
	
	                        eventManager.trigger(eventManager.EventTypes.ChangeIDFConfig, interval, dateRange, freq);
	                    };
	                    self._freqFromDates = function(start, end, isBrush) {
	                        // add date change callback
	                        var freqByDate = CCM.getFrequencyByDateRange([start, end], true);
	
	                        //update frequency
	                        self._clearRange();
	                        self._updateFreq(freqByDate);
	                        !isBrush && eventManager.trigger(eventManager.EventTypes.onDateRangeChange, {
	                            name: 'calendarDateRange',
	                            value: {
	                                startDate: moment(start).format(appConfig.intradayDateFormater),
	                                endDate: moment(end).format(appConfig.intradayDateFormater)
	                            }
	                        })
	                    };
	                    self._updateFreq = function(interval, innerCall, isDateRange) {
	                        function makeOptions(config) {
	                            var options = [];
	                            var option;
	                            var conLen = config.length;
	                            var i;
	                            for (i = 0; i < conLen; i++) {
	                                var templateCfg = {
	                                    isMobile: isMobile,
	                                    fc: {
	                                        text: langObj[config[i].text] || config[i].text,
	                                        value: config[i].value
	                                    }
	                                }
	                                option = intervalSelectOption(templateCfg);
	                                options.push(option);
	                            }
	
	                            return options.join('');
	                        }
	                        var $freqSelect = $intervalTemplate.find('.mkts-cmpt-svgcht-freq-input');
	                        var fc = freqConfig[interval].fc;
	                        var def = freqConfig[interval].def;
	                        var options;
	                        var $defOpt;
	                        var nfc = [];
	                        var validFre = [];
	                        for (var i = 0, l = fc.length, c; i < l; i++) {
	                            c = fc[i];
	                            if (isFundChart) {
	                                if (isNaN(c.value)) {
	                                    nfc.push(c);
	                                    validFre.push(c.value);
	                                }
	                            } else {
	                                nfc.push(c);
	                                validFre.push(c.value);
	                            }
	                        }
	                        var idx = -1,
	                            reRender = false,
	                            appFreIndex;
	                        if (appConfig.frequencyPriority === "manually") {
	                            idx = $.inArray(appConfig.frequency + "", validFre);
	                        }
	                        if (appConfig.defaultFrequency || appConfig.lastFrequency) {
	                            idx = $.inArray((appConfig.defaultFrequency || appConfig.lastFrequency) + "", validFre);
	                            appConfig.lastFrequency = null;
	                        }
	                        var defIndex = idx >= 0 ? idx : $.inArray(def + "", validFre);
	
	                        /** when chose custom date and the frequency in the frequency list
	                         *  then the frequency do not change,Otherwise the change
	                         */
	                        appFreIndex = $.inArray(appConfig.frequency + "", validFre);
	
	                        if (appFreIndex > -1) {
	                            if (!isDateRange && defIndex >= 0) {
	                                defIndex = appFreIndex;
	                                reRender = true;
	                            }
	                        }
	
	                        if (self.interval !== interval || reRender) {
	                            self.interval = interval;
	                            options = makeOptions(nfc);
	                            if (isMobile) {
	                                $freqSelect.empty().append(options);
	                                $defOpt = $freqSelect.find('option').eq(defIndex);
	                                $defOpt.attr('selected', 'selected');
	                            } else {
	                                var $ulFreq = $intervalTemplate.find(".ul-freq-dropdown-list");
	                                $ulFreq.empty().append(options);
	                                var $selectli = $ulFreq.find('li').eq(defIndex);
	                                $freqSelect.text($selectli.find('span').text()).data("value", $selectli.data("value"));
	                                $selectli.attr('data-selected', 'selected');
	                            }
	                        }
	
	                        self.onChangeFrequency(null, innerCall); //innerCall
	                    };
	                    self.datesHaveChanged = function(start, end) {
	                        var _startMoment = start,
	                            _endMoment = end,
	                            _flag = false;
	                        if (_startMoment) {
	                            if (moment.isDate(_startMoment)) {
	                                _startMoment = moment(_startMoment).hours(0).minutes(0).seconds(0);
	                            }
	                            if (!_startMoment.isSame(self.startMoment)) {
	                                self.startMoment = _startMoment;
	                                _flag = true;
	                            }
	                        }
	                        if (_endMoment) {
	                            if (moment.isDate(_endMoment)) {
	                                _endMoment = moment(_endMoment).hours(0).minutes(0).seconds(0);
	                            }
	                            if (!_endMoment.isSame(self.endMoment)) {
	                                self.endMoment = _endMoment;
	                                _flag = true;
	                            }
	                        }
	
	                        if (self.startMoment.isAfter(self.endMoment)) { //switch start end if start < end
	                            var temp = self.endMoment;
	                            self.endMoment = self.startMoment;
	                            self.startMoment = temp;
	                            if (isMobile) {
	                                $startInput.val(self.startMoment.format(datePickerFixativeFormater));
	                                $endInput.val(self.endMoment.format(datePickerFixativeFormater));
	                            } else {
	                                datePicker.setProperty("date", {
	                                    date: self.startMoment.toDate(),
	                                    which: 'start'
	                                });
	                                datePicker.setProperty("date", {
	                                    date: self.endMoment.toDate(),
	                                    which: 'end'
	                                });
	                            }
	
	                        }
	
	                        return _flag;
	                    };
	                    langObj.isMobile = isMobile;
	                    $intervalTemplate = $(intervalTemplate(langObj));
	
	                    $.extend(true, self.config, config);
	                    var dateRange = appConfig.dateRange;
	                    if (dateRange && dateRange.length === 2) {
	                        self.startMoment = moment(dateRange[0]);
	                        self.lastMoment = self.endMoment = moment(dateRange[1]);
	                    } else {
	                        self.lastMoment = self.startMoment = self.endMoment = moment().hours(0).minutes(0).seconds(0);
	                    }
	                    self._bindEvents();
	                    setDefaultRange();
	                    self.setupCalendars();
	                    self._renderView();
	                },
	
	                _renderView: function() {
	                    this.$el = this.config.container;
	                    $intervalTemplate.appendTo(this.$el);
	                    this.$container = this.$el.parent();
	                },
	                _bindEvents: function() {
	                    var self = this;
	
	                    function momentFromEvent(e) {
	                        var target;
	                        var _momentObj;
	                        if (Util.isObj(e.originalEvent) && Util.isObj(e.originalEvent.target) && Util.isString(e.originalEvent.target.value) && e.originalEvent.target.value !== '') {
	                            target = e.originalEvent.target;
	                        } else if (Util.isObj(e.currentTarget) && Util.isString(e.currentTarget.value) && e.currentTarget.value !== '') {
	                            target = e.currentTarget;
	                        }
	                        if (target) {
	                            $(target).parent().removeClass('open'); //easiest way to clear down arrow when an option is selected
	                            $(target).blur();
	                            var dateVal = isMobile ? target.value : target.dateValue;
	                            _momentObj = moment(dateVal).hours(0).minutes(0).seconds(0);
	                            if (_momentObj.isAfter(self.lastMoment)) {
	                                _momentObj = self.lastMoment;
	                            }
	                        }
	                        return _momentObj;
	                    }
	
	                    function changeStartEnd(start, end) {
	                        if (self.datesHaveChanged(start, end)) {
	                            self._freqFromDates(self.startMoment.toDate(), self.endMoment.toDate());
	                        }
	                    }
	
	                    function onChangeStartDate(e) {
	                        changeStartEnd(momentFromEvent(e));
	                    }
	
	                    function onChangeEndDate(e) {
	                        changeStartEnd(undefined, momentFromEvent(e));
	                    }
	
	                    function onChangeFrequency(e, innerCall) {
	                        var value, $target, $container = self.$container || $intervalTemplate;
	                        if (e) {
	                            $target = $(e.currentTarget);
	                        } else {
	                            if (isMobile) {
	                                $target = $container.find('.mkts-cmpt-svgcht-freq-input').eq(0);
	                            } else {
	                                $target = $container.find("li[data-selected='selected']");
	                            }
	                        }
	
	                        if (!isMobile) {
	                            $container.find(".ul-freq-dropdown-list").hide();
	                            if ($target && $target.find("span")) {
	                                var targetText = $target.find("span").text();
	                                $container.find('.mkts-cmpt-svgcht-freq-input')
	                                    .data("value", targetText)
	                                    .text(targetText);
	                            }
	                            value = $target.data("value") || '';
	                        } else {
	                            value = $target.val() || '';
	                            $target.parent().removeClass('open'); //easiest way to clear down arrow when an option is selected
	                            $target.blur();
	                        }
	
	                        if (typeof(value) !== "object" && value !== '') {
	                            if (!innerCall && self.rangePreset === IntervalTypes.OneDay) {
	                                self.oneDayCanAdjust = false;
	                            }
	                            self.intervalFreq = value;
	                            self._emitIntervalFreq();
	                            e && eventManager.trigger(eventManager.EventTypes.triggerClickCallback, {
	                                name: 'frequency',
	                                value: value
	                            });
	                        }
	                    }
	
	                    function hideFrequencyList() {
	                        self.$container.find(".ul-freq-dropdown-list").hide();
	                        self.$container.find(".mkts-cmpt-svgcht-freq").removeClass('open');
	                    }
	
	                    function onClickFrequency(e) {
	                        var $dropdownList = self.$container.find(".ul-freq-dropdown-list");
	                        var $target = $(e.target || e.srcElement);
	                        var $pEl = $target;
	                        if ($dropdownList.css("display") == "none") {
	                            var $freqDiv = self.$container.find(".mkts-cmpt-svgcht-freq");
	                            var postion = $freqDiv.position();
	                            var top = postion.top + $freqDiv.height();
	                            var left = postion.left;
	                            var width = self.$container.find(".mkts-cmpt-svgcht-freq-container").width();
	                            $dropdownList.css({
	                                "top": top,
	                                "left": left,
	                                "width": width
	                            }).show();
	                        } else {
	                            $dropdownList.hide();
	                        }
	                        CCM.triggerClickCallback({
	                            name: 'frequency'
	                        });
	                    }
	
	                    function filterRenderEvents(dates) {
	                        updateDatesFromMainChart(dates, true);
	                    }
	
	                    function updateDatesFromMainChart(dates, suppressClearRange) {
	                        if (self.datesHaveChanged(dates[0], dates[1])) {
	                            if (isMobile) {
	                                $startInput.val(self.startMoment.format(datePickerFixativeFormater));
	                                $endInput.val(self.endMoment.format(datePickerFixativeFormater));
	                            } else {
	                                datePicker.setProperty("date", {
	                                    date: self.startMoment.toDate(),
	                                    which: 'start'
	                                });
	                                datePicker.setProperty("date", {
	                                    date: self.endMoment.toDate(),
	                                    which: 'end'
	                                });
	                            }
	                            if (!suppressClearRange) {
	                                self._clearRange();
	                            }
	                        }
	                        updateChartTitle();
	                    }
	
	                    function updateChartTitle(startDate, endDate) {
	                        startDate = startDate ? startDate : self.displayFomater(self.startMoment.toDate());
	                        endDate = endDate ? endDate : self.displayFomater(self.endMoment.toDate());
	                        if (!appConfig.actionHandler) return;
	                        var value = {};
	                        var mainTickerObject = appConfig.mainTickerObject;
	                        var name = mainTickerObject.Name !== "" ? mainTickerObject.Name : mainTickerObject.performanceId;
	                        var MainDataTypes = CCM.MainDataTypes;
	                        var dataType = CCM.getMainDataType();
	                        dataType = dataType === MainDataTypes.Growth10K ? "Wealth" : dataType === MainDataTypes.Growth ? "Return" : "NAV";
	                        value = {
	                            name: name,
	                            startDate: startDate,
	                            endDate: endDate,
	                            dataType: dataType,
	                            timePeriod: appConfig.intervalType
	                        };
	                        var actionHandler = appConfig.actionHandler;
	                        if (appConfig.setMarketValueTitle) {
	                            actionHandler.send("setTitle", "Market Value " + value.startDate + "-" + value.endDate + "-" + value.name);
	                        } else if (appConfig.setReturnChartTitle) {
	                            actionHandler.send("setTitle", dataType + " over " + value.timePeriod);
	                        }
	                    }
	
	                    function updateFreqAndMainChart(dates, isBrush) {
	                        self._freqFromDates(dates[0], dates[1], isBrush);
	                    }
	
	                    function onDateIntervalClick(innerCall) {
	                        function clearActive() {
	                            self.$container.find('.mkts-cmpt-svgcht-segment-option').removeClass('active');
	                        }
	                        var id, eventVal;
	                        if (Util.isObj(this) && Util.isString(this.getAttribute('data-menuid'))) {
	                            id = this.getAttribute('data-menuid');
	                            eventVal = util.dashesToCamel(id);
	                            eventVal = util.capFirstChar(eventVal);
	                            if (eventVal === self.rangePreset) {
	                                return;
	                            }
	                            if (Util.isObj(freqConfig[eventVal])) {
	                                if (!innerCall && eventVal === IntervalTypes.OneDay) {
	                                    self.oneDayCanAdjust = true;
	                                }
	                                self.rangePreset = eventVal;
	                                self.LastIntervalType = eventVal;
	                                self._updateFreq(eventVal, true, true);
	                            }
	                            clearActive();
	                            $(this).addClass('active');
	
	                            CCM.triggerClickCallback({
	                                name: 'date range',
	                                value: eventVal
	                            });
	                        }
	                        $(this).blur();
	                    }
	
	                    function onDdUnfocus(e) {
	                        var $dd = self.$container.find('.mkts-cmpt-svgcht-dropdown');
	                        var ddLen = $dd.length;
	                        var tar = e.target;
	                        var contained = false;
	                        var i;
	                        for (i = 0; i < ddLen; i++) {
	                            if ($dd[i] === tar || $.contains($dd[i], tar)) {
	                                contained = true;
	                                $($dd[i]).toggleClass('open');
	                            } else {
	                                $($dd[i]).removeClass('open');
	                            }
	                        }
	                    }
	
	                    function changeOneDayFrequency(isChange) {
	                        //if user have manuly change frequency, we can't change again.
	                        if (self.oneDayCanAdjust !== false) {
	                            if (isChange) {
	                                freqConfig.OneDay.def = 1;
	                                changeView(1);
	                            } else {
	                                freqConfig.OneDay.def = 0;
	                                changeView(5);
	                            }
	                        }
	                    }
	
	                    /*
	                     *   @freqValue: the frequency value before change.
	                     */
	                    function changeView(freqValue) {
	                        if (self.rangePreset === IntervalTypes.OneDay && (!self.intervalFreq || self.intervalFreq === freqValue)) {
	                            self.interval = null; //otherwise, it don't update the view.
	                            var target = self.$container.find(".one-day")[0];
	                            onDateIntervalClick.call(target, true); //innerCall 
	                        }
	                    }
	
	                    function changeInterval(interval) {
	                        var intervalMap = CCM.intervalTypesMapping;
	                        if (self.rangePreset === intervalMap[interval]) {
	                            return;
	                        }
	                        var target = intervalsMapping[interval] && self.$container.find(intervalsMapping[interval])[0];
	                        if (target)
	                            onDateIntervalClick.call(target, true);
	                    }
	
	                    function deployIntervalBreakPoint(width) {
	                        var intervalArr;
	                        var breakPointArr = Object.keys(appConfig.intervalBreakPointMap).sort();
	                        for (var b in breakPointArr) {
	                            var breakpoint = breakPointArr[b];
	                            if (breakpoint >= width || breakpoint === "default") {
	                                if (breakpoint === self.intervalBreakPoint) {
	                                    return;
	                                } else {
	                                    if (!self.intervalBreakPoint) self.intervalBreakPoint = "default";
	                                    // preIntervalArr = appConfig.intervalBreakPointMap[self.intervalBreakPoint];
	                                    intervalArr = appConfig.intervalBreakPointMap[breakpoint];
	                                    self.intervalBreakPoint = breakpoint;
	                                    var showSelector = [],
	                                        needChangeDefaultInterval = true;
	                                    for (var i = 0; i < intervalArr.length; i++) {
	                                        var interval = intervalArr[i];
	                                        showSelector.push(intervalsMapping[interval]);
	                                        if (CCM.intervalTypesMapping[interval] === self.rangePreset || !self.rangePreset) {
	                                            needChangeDefaultInterval = false;
	                                        }
	                                    }
	                                    if (needChangeDefaultInterval) {
	                                        eventManager.trigger(eventManager.EventTypes.ChangeInterval, intervalArr[0]);
	                                    }
	                                    if (showSelector) {
	                                        var showSelector = showSelector.join(','),
	                                            showEle = $intervalTemplate.find(showSelector);
	                                        showEle.show().removeClass('mkts-cmpt-svgcht-interval-last mkts-cmpt-svgcht-interval-first');
	                                        showEle.eq(0).addClass('mkts-cmpt-svgcht-interval-first');
	                                        showEle.eq(showEle.length - 1).addClass('mkts-cmpt-svgcht-interval-last');
	                                        $intervalTemplate.find('.mkts-cmpt-svgcht-segment-option').not(showSelector).hide();
	                                    }
	                                }
	                                return;
	                            }
	                        }
	                    }
	                    self.onChangeFrequency = onChangeFrequency;
	
	                    if (!isMobile) {
	                        eventManager.bind(eventManager.EventTypes.LayoutChange, hideFrequencyList);
	                    }
	
	                    eventManager.bind(eventManager.EventTypes.ChangeOneDayFrequency, changeOneDayFrequency, self);
	                    eventManager.bind(eventManager.EventTypes.UpdateMenuInterval, updateDatesFromMainChart);
	                    eventManager.bind(eventManager.EventTypes.UpdateMenuIntervalForRender, filterRenderEvents);
	                    eventManager.bind(eventManager.EventTypes.RequestFrequencyFromMenu, updateFreqAndMainChart);
	                    eventManager.bind(eventManager.EventTypes.ChangeInterval, changeInterval);
	                    eventManager.bind(eventManager.EventTypes.DeployIntervalBreakPoint, deployIntervalBreakPoint);
	
	                    appConfig.$componentContainer.on('change.mkts-cmpt-svgcht-menu', 'input.mkts-cmpt-svgcht-start-input', onChangeStartDate);
	                    appConfig.$componentContainer.on('change.mkts-cmpt-svgcht-menu', 'input.mkts-cmpt-svgcht-end-input', onChangeEndDate);
	                    appConfig.$componentContainer.on('change.mkts-cmpt-svgcht-menu', 'select.mkts-cmpt-svgcht-freq-input', onChangeFrequency);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.change-time-range .mkts-cmpt-svgcht-segment-option', onDateIntervalClick);
	                    appConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', onDdUnfocus); //clearing the open state from morningstar style dropdowns is unfortunately complicated
	                    appConfig.$componentContainer.on("click.mkts-cmpt-svgcht-menu", ".ul-freq-dropdown-list li", onChangeFrequency);
	                    appConfig.$componentContainer.on("click.mkts-cmpt-svgcht-menu", ".mkts-cmpt-svgcht-freq", onClickFrequency);
	                    appConfig.$componentContainer.on('mouseleave.mkts-cmpt-svgcht-menu', ".ul-freq-dropdown-list", hideFrequencyList);
	                }
	            };
	
	            return Interval;
	        }
	
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return " type=\"date\"";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "                <select data-menuid=\"mkts-cmpt-svgcht-freq-input\" class=\"mkts-cmpt-svgcht-select-box mkts-cmpt-svgcht-freq-input\"></select> ";
	},"5":function(container,depth0,helpers,partials,data) {
	    return "\n                <div data-menuid=\"mkts-cmpt-svgcht-freq-input\" class=\"mkts-cmpt-svgcht-select-box mkts-cmpt-svgcht-freq-input divoption\"></div>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    return " ";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "\n        <ul class=\"ul-freq-dropdown-list\"></ul>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<span class=\"mkts-cmpt-svgcht-menuicn--label\">"
	    + alias4(((helper = (helper = helpers.dataRange || (depth0 != null ? depth0.dataRange : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"dataRange","hash":{},"data":data}) : helper)))
	    + "</span>\n<section class=\"mkts-cmpt-svgcht-date-range\">\n    <div class=\"mkts-cmpt-svgcht-segment-control mkts-cmpt-svgcht-date-range change-time-range\" data-menuid=\"change-time-range\">\n        <button class=\"mkts-cmpt-svgcht-segment-option one-day\" data-menuid=\"one-day\">"
	    + alias4(((helper = (helper = helpers.oneDay || (depth0 != null ? depth0.oneDay : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"oneDay","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option five-day\" data-menuid=\"five-day\">"
	    + alias4(((helper = (helper = helpers.fiveDay || (depth0 != null ? depth0.fiveDay : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fiveDay","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option fifteen-day\" data-menuid=\"fifteen-day\">"
	    + alias4(((helper = (helper = helpers.fifteenDay || (depth0 != null ? depth0.fifteenDay : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fifteenDay","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option one-month\" data-menuid=\"one-month\">"
	    + alias4(((helper = (helper = helpers.oneMonth || (depth0 != null ? depth0.oneMonth : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"oneMonth","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option three-month\" data-menuid=\"three-month\">"
	    + alias4(((helper = (helper = helpers.threeMonth || (depth0 != null ? depth0.threeMonth : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"threeMonth","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option six-month\" data-menuid=\"six-month\">"
	    + alias4(((helper = (helper = helpers.sixMonth || (depth0 != null ? depth0.sixMonth : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"sixMonth","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option y-t-d\" data-menuid=\"y-t-d\">"
	    + alias4(((helper = (helper = helpers.YTD || (depth0 != null ? depth0.YTD : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"YTD","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option one-year\" data-menuid=\"one-year\">"
	    + alias4(((helper = (helper = helpers.oneYear || (depth0 != null ? depth0.oneYear : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"oneYear","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option three-year\" data-menuid=\"three-year\">"
	    + alias4(((helper = (helper = helpers.threeYear || (depth0 != null ? depth0.threeYear : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"threeYear","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option five-year\" data-menuid=\"five-year\">"
	    + alias4(((helper = (helper = helpers.fiveYear || (depth0 != null ? depth0.fiveYear : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"fiveYear","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option ten-year\" data-menuid=\"ten-year\">"
	    + alias4(((helper = (helper = helpers.tenYear || (depth0 != null ? depth0.tenYear : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"tenYear","hash":{},"data":data}) : helper)))
	    + "</button>\n        <button class=\"mkts-cmpt-svgcht-segment-option max\" data-menuid=\"max\">"
	    + alias4(((helper = (helper = helpers.max || (depth0 != null ? depth0.max : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"max","hash":{},"data":data}) : helper)))
	    + "</button>\n    </div>\n</section>\n<section class=\"mkts-cmpt-svgcht-calendar-range\">\n    <section data-menuid=\"mkts-cmpt-svgcht-calendar-pickers\" class=\"mkts-cmpt-svgcht-calendar-pickers\">\n        <div data-menuid=\"mkts-cmpt-svgcht-start-date\" class=\"mkts-cmpt-svgcht-dropdown mkts-cmpt-svgcht-cal-picker mkts-cmpt-svgcht-start-date\">\n            <div><input "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " data-menuid=\"mkts-cmpt-svgcht-start-input\" class=\"mkts-cmpt-svgcht-date-box mkts-cmpt-svgcht-start-input\" required=\"required\"></div>\n        </div>\n        <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.to || (depth0 != null ? depth0.to : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"to","hash":{},"data":data}) : helper)))
	    + "</label>\n        <div data-menuid=\"mkts-cmpt-svgcht-end-date\" class=\"mkts-cmpt-svgcht-dropdown mkts-cmpt-svgcht-cal-picker mkts-cmpt-svgcht-end-date mkts-cmpt-svgcht-end-date\">\n            <div><input "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " data-menuid=\"mkts-cmpt-svgcht-end-input\" class=\"mkts-cmpt-svgcht-date-box mkts-cmpt-svgcht-end-input\" required=\"required\"></div>\n        </div>\n    </section>\n    <span class=\"mkts-cmpt-svgcht-menuicn--label\">"
	    + alias4(((helper = (helper = helpers.frequency || (depth0 != null ? depth0.frequency : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"frequency","hash":{},"data":data}) : helper)))
	    + "</span>\n    <section data-menuid=\"mkts-cmpt-svgcht-frequency-picker\" class=\"mkts-cmpt-svgcht-frequency-picker\">\n        <label class=\"mkts-cmpt-svgcht-label\">"
	    + alias4(((helper = (helper = helpers.frequency || (depth0 != null ? depth0.frequency : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"frequency","hash":{},"data":data}) : helper)))
	    + "</label>\n        <div data-menuid=\"mkts-cmpt-svgcht-freq\" class=\"mkts-cmpt-svgcht-dropdown mkts-cmpt-svgcht-freq\">\n            <div class=\"mkts-cmpt-svgcht-freq-container\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
	    + "            </div>\n        </div>\n        "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(9, data, 0),"data":data})) != null ? stack1 : "")
	    + "    </section>\n</section>";
	},"useData":true});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "<option value=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.value : stack1), depth0))
	    + "\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.text : stack1), depth0))
	    + "</option>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "<li data-value=\""
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.value : stack1), depth0))
	    + "\"><span>"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.text : stack1), depth0))
	    + "</span></li>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3),
	        __webpack_require__(20),
	        __webpack_require__(35),
	        __webpack_require__(36),
	        __webpack_require__(37),
	        __webpack_require__(34),
	        __webpack_require__(38),
	        __webpack_require__(39),
	        __webpack_require__(40),
	        __webpack_require__(17)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(
	        core,
	        Request,
	        autocompleteContainer,
	        autocompleteContainerFullScreen,
	        autocompleteCategory,
	        autocompleteCategoryFullScreen,
	        autoCompleteCatHeaderFullScreen,
	        autocompleteRow,
	        autocompleteNoresults,
	        util) {
	        "use strict";
	
	        /**
	         *   AutoComplete Model
	         *
	         */
	        var $ = core.$;
	        var Util = core.Util;
	
	        var model = function(managers, Popover) {
	            var eventManager = managers.eventManager;
	            var CCM = managers.chartConfigManager;
	            var dataAdapter = managers.dataAdapter;
	            var rootConfig;
	            var $clearButton;
	            var $menuBarContainer;
	            var AutoComplete = function(config) {
	                this.config = {};
	                rootConfig = CCM.getConfig();
	                this._init(config);
	            };
	
	            AutoComplete.prototype = {
	                /* test-code */
	                __private: {
	                    CCM: CCM,
	                    dataAdapter: dataAdapter,
	                    eventManager: eventManager,
	                },
	                /* end-test-code */
	                _init: function(config) {
	                    $.extend(true, this.config, config);
	                    $menuBarContainer = this.config.$menuBarContainer;
	                    var obj = {
	                        'autoCompleteChangeMainTicker': rootConfig.autoComplete.action === 'main' ? true : false,
	                        'add-comparison': CCM.getLabel('addComparison'),
	                        'change-ticker': CCM.getLabel('changeTicker')
	                    }
	                    this.$mobileSearch = $(autocompleteContainerFullScreen(obj));
	                    this._bindEvents();
	
	                },
	                _bindEvents: function() {
	                    var self = this;
	
	                    function onMobileSearchIcon(event) {
	                        var $mobileSearch = self.$mobileSearch;
	                        var el = self.$mobileSearch;
	                        var popObj = {
	                            $el: el
	                        };
	                        var popConfig = {
	                            containerHeight: CCM.getConfig().height,
	                            containerWidth: CCM.getConfig().width,
	                            $componentContainer: rootConfig.$componentContainer,
	                            $target: $menuBarContainer.find('.mkts-cmpt-svgcht-menuicn--search'),
	                            toggle: false,
	                            styleClass: 'mkts-cmpt-svgcht-popover--search-mobile',
	                            $menuBarContainer: $menuBarContainer,
	                            sync: false
	                        };
	                        $mobileSearch.find('.mkts-cmpt-svgcht-search-input--mobile').val('').focus();
	                        $mobileSearch.find('.mkts-cmpt-svgcht-search-results-container').empty();
	                        Popover.show(popObj, popConfig);
	                        event.stopPropagation();
	                    }
	
	                    function makeAutocompleteMarkup(d, ss, isMobile) {
	                        function makeCat(catData) {
	                            function makeEachExchangeHeader() {
	                                var rowObj = {
	                                    name: catObj.catName,
	                                    ticker: "Identifier",
	                                    exchange: "exchange",
	                                    type: "Type",
	                                    isShowRelateTickerAndMajorIndex: true,
	                                    headerClassName: "mkts-cmpt-svgcht-search-header"
	                                }
	                                var rowStr = autocompleteRow(rowObj);
	                                var row = $(rowStr);
	                                return row;
	                            };
	
	                            function makeRow(rowData) {
	                                var needBoldReplace = rootConfig.autoComplete.highlight;
	                                var tickerPriority = rootConfig.autoComplete.tickerPriority ? rootConfig.autoComplete.tickerPriority.split(',') : ['ticker'];
	                                var rowObj = {
	                                    name: util.boldSearch(rowData.name, ss, needBoldReplace),
	                                    exchange: rowData.exch,
	                                    type: rowData.type,
	                                    cols: {}
	                                };
	
	                                if (rootConfig.autoComplete.removeExch !== true) {
	                                    rowObj.cols.exchange = true;
	                                }
	
	                                tickerPriority.forEach(function(element) {
	                                    if (!rowObj.ticker && rowData[element]) {
	                                        rowObj.ticker = util.boldSearch(rowData[element], ss, needBoldReplace);
	                                    }
	                                });
	
	                                if (rootConfig.isShowRelateTickerAndMajorIndex) {
	                                    rowObj.isShowRelateTickerAndMajorIndex = true;
	                                } else {
	                                    rowObj.cols.cnpjTicker = rootConfig.autoComplete.cnpjTicker;
	                                    if (!rowObj.cols.cnpjTicker && !rowObj.cols.exchange) {
	                                        $el.addClass('mkts-cmpt-svgcht-popover--search-narrow');
	                                    }
	                                }
	
	                                var rowStr = autocompleteRow(rowObj);
	                                var row = $(rowStr);
	                                var li = row[0];
	
	                                li.ticker = rowData.ticker; // this should be used to display in the UI
	                                li.identifier = rowData.identifier; // this should be used to transfer in each modules like dataAdapter, chart and so on.
	                                li.name = rowData.name;
	                                li.secId = rowData.secId;
	                                li.currency = rowData.currency;
	                                return row;
	                            };
	                            var catObj = {
	                                showHCategory: rootConfig.autoComplete.categoryLayout !== 'vertical',
	                                catName: CCM.getLabel(formatCategory(catData.catName)) || catData.catName
	                            };
	                            var $td = $('<td>');
	                            var rows = catData.results;
	                            var rowLen = rows.length || 0;
	                            var catStr, $cat, i, $table, header;
	
	                            /* test-code */
	                            self.__private._bindEvents.makeAutocompleteMarkup.makeCat.makeRow = makeRow;
	                            /* end-test-code */
	
	                            if (isMobile) {
	                                catStr = autocompleteCategoryFullScreen();
	                                header = autoCompleteCatHeaderFullScreen(catObj);
	                            } else {
	                                catObj.isShowRelateTickerAndMajorIndex = rootConfig.isShowRelateTickerAndMajorIndex;
	                                catStr = autocompleteCategory(catObj);
	                            }
	
	                            $cat = $(catStr);
	
	                            for (i = 0; i < rowLen; i++) {
	                                $td.append(makeRow(rows[i]));
	                            }
	                            if (!catObj.showHCategory) {
	                                var colspan = $el.hasClass('mkts-cmpt-svgcht-popover--search-narrow') ? 1 : 3;
	                                $td.prepend('<tr class="mkts-cmpt-svgcht-search-result-title"><td class="mkts-cmpt-svgcht-search-cat-name" colspan="' + colspan + '">' + catObj.catName + '</td></tr>');
	                            }
	
	                            if (rootConfig.isShowRelateTickerAndMajorIndex) {
	                                $td.prepend(makeEachExchangeHeader());
	                            }
	
	                            $cat.append($td);
	                            if (isMobile) {
	                                $table = $('<table>');
	                                $table.append(header);
	                                $table.append($cat);
	                                return $table;
	                            }
	
	                            return $cat;
	                        }
	
	                        function formatCategory(str) {
	                            if (str) {
	                                return str.replace(/\s+\&\s+|\-|(\b\s+\b)/g, "").replace(/\b\w/g, function($0) {
	                                    return $0.toLocaleLowerCase();
	                                });
	                            }
	                            return str;
	                        }
	
	                        function loopData() {
	                            var len = results.length;
	                            var i;
	                            var tableInEl = $el.find('.mkts-cmpt-svgcht-search-table');
	                            var appendElement = tableInEl.length > 0 ? tableInEl : $el;
	
	                            if (len > 0) {
	                                for (i = 0; i < len; i++) {
	                                    if (results[i].results.length) {
	                                        appendElement.append(makeCat(results[i]));
	                                    }
	                                }
	                            } else {
	                                appendElement.append(autocompleteNoresults());
	                            }
	                        }
	                        var results = d.data() || [];
	                        var req = d.req();
	                        var reqKey = req.keyword();
	                        var $el = null;
	
	                        /* test-code */
	                        self.__private._bindEvents.makeAutocompleteMarkup.makeCat = makeCat;
	                        self.__private._bindEvents.makeAutocompleteMarkup.loopData = loopData;
	                        /* end-test-code */
	
	                        if (Util.isString(reqKey) && reqKey === self.autoCompleteKeyword) {
	                            var _obj = {};
	                            if (rootConfig.isShowRelateTickerAndMajorIndex) {
	                                _obj.isShowRelateTickerAndMajorIndex = true;
	                            }
	                            $el = $(autocompleteContainer(_obj));
	                            loopData();
	                        }
	
	                        return $el;
	                    }
	
	                    function search(searchStr, target, isMobile) {
	                        function displayResults(data) {
	                            var $el = makeAutocompleteMarkup(data, searchStr, isMobile);
	
	                            if ($el) {
	                                if (Util.isObj(target)) {
	                                    $(target).empty().append($el);
	                                }
	                                showAutocompletePopup($el);
	                            }
	                        }
	                        var request = new Request();
	                        var cats = rootConfig.autocompleteCategories;
	
	                        self.autoCompleteKeyword = searchStr;
	                        request.keyword(searchStr);
	
	                        request.category(cats);
	                        request.nonFilterCategory(rootConfig.autoComplete.nonFilterCategory);
	                        dataAdapter.fetchAutocompleteData(request, displayResults);
	                    }
	
	                    function showAutocompletePopup(el) {
	                        var popObj = {
	                            $el: el
	                        };
	                        rootConfig = CCM.getConfig();
	                        var popConfig = {
	                            containerWidth: rootConfig.width,
	                            containerHeight: rootConfig.height,
	                            $target: $menuBarContainer.find('.mkts-cmpt-svgcht-search'),
	                            toggle: false,
	                            styleClass: 'mkts-cmpt-svgcht-popover--search',
	                            $componentContainer: rootConfig.$componentContainer,
	                            $menuBarContainer: $menuBarContainer
	                        };
	
	                        if (rootConfig.width <= 600) {
	                            popObj = {
	                                $el: $menuBarContainer.find('.mkts-cmpt-svgcht-popover--search-mobile')
	                            };
	                            popConfig.styleClass = 'mkts-cmpt-svgcht-popover--search-mobile';
	                            popConfig.sync = true;
	                        }
	
	                        $menuBarContainer.find('.mkts-cmpt-svgcht-popover--search, mkts-cmpt-svgcht-popover--search-mobile').remove();
	                        Popover.show(popObj, popConfig);
	                    }
	
	                    function onMainSearchKey(e) {
	
	                        if (isActionKey(e)) {
	                            onActionKey(e.keyCode);
	                        } else {
	                            var ss,
	                                __$this = $(e.target),
	                                __isMobile = __$this.hasClass('mkts-cmpt-svgcht-search-input--mobile'),
	                                __$target = !__isMobile ? undefined : $menuBarContainer.find('.mkts-cmpt-svgcht-search-results-container');
	                            if (Util.isObj(e) && Util.isObj(e.target) && Util.isString(e.target.value) && e.target.value !== '') {
	                                ss = e.target.value; //make closure for boldSearch function
	                                clearButtonShow(true);
	                                if (CCM.getConfig().autoComplete.dataSource && CCM.getConfig().autoComplete.dataSource.toLocaleLowerCase() === 'eu' && $.trim(ss).length < 2) {
	                                    $menuBarContainer.find('.mkts-cmpt-svgcht-popover--search').remove();
	                                    return;
	                                }
	                                search(ss, __$target, __isMobile);
	                            } else {
	                                $menuBarContainer.find('.mkts-cmpt-svgcht-popover--search').remove();
	                                clearButtonShow(false);
	                            }
	                        }
	
	                    }
	
	                    function isActionKey(e) {
	                        var keyList = [13, 27, 37, 38, 39, 40];
	                        var keyCode;
	
	                        if (Util.isObj(e) && $.isNumeric(e.keyCode)) {
	                            keyCode = e.keyCode;
	                        }
	
	                        return keyList.indexOf(keyCode) > -1;
	                    }
	
	                    function onActionKey(key) {
	                        function clearActive() {
	                            $results.removeClass('active');
	                        }
	                        var action = {
	                            close: function() {
	                                $menuBarContainer.find('.mkts-cmpt-svgcht-popover--search').remove();
	                                $menuBarContainer.find('.mkts-cmpt-svgcht-search-results-container').empty();
	                            },
	                            select: function() {
	                                if ($target) {
	                                    $target.click();
	                                }
	                            },
	                            prev: function() {
	                                if ($target && targetIndex !== 0) {
	                                    $target = $($results[targetIndex - 1]);
	                                    clearActive();
	                                    $target.addClass('active');
	                                } else {
	                                    $target = $($results[lastIndex]);
	                                    clearActive();
	                                    $target.addClass('active');
	                                }
	                                $container.scrollTop($target.position().top);
	                            },
	                            next: function() {
	                                if ($target && targetIndex !== lastIndex) {
	                                    $target = $($results[targetIndex + 1]);
	                                    clearActive();
	                                    $target.addClass('active');
	                                } else {
	                                    $target = $($results[0]);
	                                    clearActive();
	                                    $target.addClass('active');
	                                }
	                                $container.scrollTop($target.position().top);
	                            }
	                        };
	                        var $container = $menuBarContainer.find('.mkts-cmpt-svgcht-search-table');
	                        var $results = $menuBarContainer.find('.mkts-cmpt-svgcht-search-result');
	                        var $active = $results.filter('.active');
	                        var $target, targetIndex, lastIndex;
	
	                        if ($.isNumeric(key)) {
	                            key = key.toString();
	                            key = key.replace('27', 'close').replace('13', 'select').replace('37', 'prev').replace('38', 'prev').replace('39', 'next').replace('40', 'next');
	
	                            if ($.isFunction(action[key])) {
	                                if ($results.length > 0) {
	                                    if ($active.length > 0) {
	                                        $target = $($active[0]);
	                                        targetIndex = $results.index($active[0]);
	                                        lastIndex = $results.length - 1;
	                                    }
	                                }
	                                action[key]();
	                            }
	                        }
	                    }
	
	                    function onResultClick() {
	                        var autoCompleteAction = rootConfig.autoComplete.action;
	
	                        if (Util.isObj(this) && Util.isString(this.ticker)) {
	                            $menuBarContainer.find('.mkts-cmpt-svgcht-search-input').val('').blur();
	                            clearButtonShow(false);
	                            if (autoCompleteAction === 'main') {
	                                if (rootConfig.autoComplete.changeTicker) {
	                                    eventManager.trigger(eventManager.EventTypes.ChangeTicker, this.identifier);
	                                    console.debug(eventManager.EventTypes.ChangeTicker, this.identifier);
	                                }
	                                if ($.isFunction(rootConfig.onAutoCompleteClick)) {
	                                    rootConfig.onAutoCompleteClick(this.identifier);
	                                }
	                            } else {
	                                var compareTicker = this.identifier;
	                                if (rootConfig.autoComplete.dataSource === 'EU' && rootConfig.useEUTimeSeriesData) {
	                                    compareTicker = {
	                                        id: rootConfig.useEUSecurityData ? this.secId : this.identifier,
	                                        securityToken: this.secId + ']',
	                                        name: this.name,
	                                        currency: this.currency
	                                    };
	                                } else if (rootConfig.useEUSecurityData) {
	                                    compareTicker = this.secId;
	                                }
	                                eventManager.trigger(eventManager.EventTypes.CompareTicker, compareTicker);
	                                console.debug(eventManager.EventTypes.CompareTicker, this.identifier);
	                            }
	
	                            /*
	                             * this.identifier is like 126.1.IBM
	                             */
	                            CCM.triggerClickCallback({
	                                name: 'autoComplete',
	                                value: autoCompleteAction === 'main' ? 'changeMainTicker' : 'addComparison'
	                            });
	
	                            $(this).parents('.mkts-cmpt-svgcht-popover--search').remove();
	                            $(this).parents('.mkts-cmpt-svgcht-popover--search-mobile').remove();
	                        }
	                    }
	
	                    function onSearchClick(event, isShowPopover) {
	                        // hide date range
	                        eventManager.trigger(eventManager.EventTypes.HideDateRange);
	
	                        if (event) {
	                            event.stopPropagation();
	                        }
	
	                        function displayResults(data) {
	                            var $el = makeAutocompleteMarkup(data, searchStr, isMobile);
	
	                            if ($el) {
	                                if (Util.isObj(target)) {
	                                    $(target).empty()
	                                        .append($el);
	                                } else {
	                                    if (isShowPopover) {
	                                        showAutocompletePopup($el);
	                                    }
	                                }
	                            }
	                        }
	
	                        // trigger click event first
	                        CCM.triggerClickCallback({
	                            name: 'autoComplete'
	                        });
	
	                        if (!rootConfig.isShowRelateTickerAndMajorIndex) {
	                            return;
	                        }
	                        var isShowPopover = isShowPopover == false ? false : true;
	                        var target;
	                        var ifInputBlack = $menuBarContainer.find('.mkts-cmpt-svgcht-search-input').val();
	                        if (ifInputBlack !== '') {
	                            return;
	                        }
	
	                        var searchStr = "relateTickerAndMajorIndex";
	                        var isMobile = false;
	
	                        self.autoCompleteKeyword = searchStr;
	
	                        var request = new Request();
	                        request.tickerObjects([rootConfig.mainTickerObject]);
	                        var cats = rootConfig.autocompleteCategories;
	                        request.keyword(searchStr);
	                        request.category(cats);
	                        request.nonFilterCategory(rootConfig.autoComplete.nonFilterCategory);
	
	                        dataAdapter.fetchRelatedTickersAndMajorIndexData(request, displayResults);
	                    }
	
	                    function onSearchClear() {
	                        $menuBarContainer.find('.mkts-cmpt-svgcht-search-input').val('').focus();
	                        clearButtonShow(false);
	                    }
	                    //true or false
	                    function clearButtonShow(show) {
	                        $clearButton = $clearButton || $menuBarContainer.find('.mkts-cmpt-svgcht-search-clear');
	                        $clearButton[show ? 'show' : 'hide']();
	                    }
	
	                    function onMobileSearchClear() {
	                        $menuBarContainer.find('.mkts-cmpt-svgcht-search-input--mobile').val('').focus();
	                        $menuBarContainer.find('.mkts-cmpt-svgcht-search-results-container').empty();
	                        clearButtonShow(false);
	                    }
	
	                    var self = this;
	
	                    function onMouseOver(event) {
	                        $(event.currentTarget).addClass("active");
	                    }
	
	                    function onMouseLeave(event) {
	                        $(event.currentTarget).removeClass("active");
	                    }
	
	                    /* test-code */
	                    self.__private._bindEvents = {
	                        self: self,
	                        onMobileSearchIcon: onMobileSearchIcon,
	                        makeAutocompleteMarkup: makeAutocompleteMarkup,
	                        search: search,
	                        showAutocompletePopup: showAutocompletePopup,
	                        onMainSearchKey: onMainSearchKey,
	                        onMouseOver: onMouseOver,
	                        onMouseLeave: onMouseLeave,
	                        isActionKey: isActionKey,
	                        onActionKey: onActionKey,
	                        onResultClick: onResultClick
	
	                    };
	                    /* end-test-code */
	
	                    if (rootConfig.isShowRelateTickerAndMajorIndex) {
	                        eventManager.bind(eventManager.EventTypes.FetchPreloadRelatedAndIndexData, onSearchClick);
	                    }
	
	                    rootConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-menuicn--search', onMobileSearchIcon);
	                    rootConfig.$componentContainer.on('keyup.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-search-input', onMainSearchKey);
	                    rootConfig.$componentContainer.on('mouseover.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-search-result', onMouseOver);
	                    rootConfig.$componentContainer.on('mouseleave.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-search-result', onMouseLeave);
	
	                    rootConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-search-input', onSearchClick);
	                    rootConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-search-input--mobile', onSearchClick);
	
	                    rootConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-search-clear', onSearchClear);
	                    rootConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-popover--search-mobile .mkts-cmpt-svgcht-search-clear', onMobileSearchClear);
	
	                    rootConfig.$componentContainer.on('click.mkts-cmpt-svgcht-menu', '.mkts-cmpt-svgcht-search-result', onResultClick);
	
	                }
	            };
	
	            return AutoComplete;
	        }
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<tbody>\n    <tr class=\"mkts-cmpt-svgcht-search-category\">\n    </tr>\n</tbody>\n";
	},"useData":true});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"popover bottom show mkts-cmpt-svgcht-popover\">\n    <div class=\"mkts-cmpt-svgcht-popover-arrow arrow\"></div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "</div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isShowRelateTickerAndMajorIndex : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    <table class=\"mkts-cmpt-svgcht-search-table\">\n    </table>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isShowRelateTickerAndMajorIndex : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "            <input data-menuid=\"mkts-cmpt-svgcht-search-input--mobile\" type=\"text\" class=\"mkts-cmpt-svgcht-search-input mkts-cmpt-svgcht-search-input--mobile\" placeholder=\""
	    + container.escapeExpression(((helper = (helper = helpers.changeTicker || (depth0 != null ? depth0.changeTicker : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"changeTicker","hash":{},"data":data}) : helper)))
	    + "\">";
	},"3":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "\n            <input data-menuid=\"mkts-cmpt-svgcht-search-input--mobile\" type=\"text\" class=\"mkts-cmpt-svgcht-search-input mkts-cmpt-svgcht-search-input--mobile\" placeholder=\""
	    + container.escapeExpression(((helper = (helper = helpers.addComparison || (depth0 != null ? depth0.addComparison : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"addComparison","hash":{},"data":data}) : helper)))
	    + "\">";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<div>\n    <div class=\"mkts-cmpt-svgcht-mobile-top\">\n        <div class=\"mkts-cmpt-svgcht-search\">\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.autoCompleteChangeMainTicker : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
	    + "\n            <span class=\"mkts-cmpt-svgcht-search-clear\">&#215;</span>\n        </div>\n        <span class=\"mkts-cmpt-svgcht-popover-close\"></span>\n    </div>\n    <div data-menuid=\"mkts-cmpt-svgcht-search-results-container\" class=\"mkts-cmpt-svgcht-search-results-container mkts-cmpt-svgcht-search-results-container\">\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    return "";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.showHCategory : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "            <td class=\"mkts-cmpt-svgcht-search-cat-name\">"
	    + container.escapeExpression(((helper = (helper = helpers.catName || (depth0 != null ? depth0.catName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"catName","hash":{},"data":data}) : helper)))
	    + "</td>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "<tr class=\"mkts-cmpt-svgcht-search-category\">\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isShowRelateTickerAndMajorIndex : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
	    + "</tr>";
	},"useData":true});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<thead><tr><th colspan=\"3\" class=\"mkts-cmpt-svgcht-search-cat-name--header\">"
	    + container.escapeExpression(((helper = (helper = helpers.catName || (depth0 != null ? depth0.catName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"catName","hash":{},"data":data}) : helper)))
	    + "</th></tr></thead>\n";
	},"useData":true});

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<tr class=\"mkts-cmpt-svgcht-popover-body mkts-cmpt-svgcht-search-result "
	    + alias4(((helper = (helper = helpers.headerClassName || (depth0 != null ? depth0.headerClassName : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"headerClassName","hash":{},"data":data}) : helper)))
	    + "\">\n    <td class=\"mkts-cmpt-svgcht-search-company\">"
	    + ((stack1 = ((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</td>\n    <td class=\"mkts-cmpt-svgcht-search-market\">"
	    + ((stack1 = ((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ticker","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</td>\n    <td class=\"mkts-cmpt-svgcht-search-exchange\">"
	    + alias4(((helper = (helper = helpers.type || (depth0 != null ? depth0.type : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"type","hash":{},"data":data}) : helper)))
	    + "</td>\n</tr>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "<tr class=\"mkts-cmpt-svgcht-search-result\">\n    <td class=\"mkts-cmpt-svgcht-search-company\">"
	    + ((stack1 = ((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</td>\n"
	    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.cols : depth0)) != null ? stack1.cnpjTicker : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.cols : depth0)) != null ? stack1.exchange : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</tr>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, helper;
	
	  return "    <td class=\"mkts-cmpt-svgcht-search-market\">"
	    + ((stack1 = ((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticker","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</td>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "    <td class=\"mkts-cmpt-svgcht-search-exchange\">"
	    + container.escapeExpression(((helper = (helper = helpers.exchange || (depth0 != null ? depth0.exchange : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"exchange","hash":{},"data":data}) : helper)))
	    + "</td>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isShowRelateTickerAndMajorIndex : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
	},"useData":true});

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<tr>\n    <td class=\"mkts-cmpt-svgcht-no-results\">No Results</td>\n</tr>\n";
	},"useData":true});

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core) {
	    "use strict";
	    var $ = core.$;
	
	    function popover() {
	        var $el, option, shown;
	
	        function show(view, config) {
	            $el = view.$el;
	            var $menuBarContainer;
	            var defaults = {
	                $componentContainer: config.$componentContainer,
	                $menuBarContainer: config.$menuBarContainer,
	                $target: null,
	                toggle: true, // hide the popover when hitting the same target twice
	                styleClass: "", // custom style class
	                sizeForMobile: true,
	                center: false,
	                autohide: true,
	                blurhide: true,
	                sync: true
	            };
	
	            option = $.extend(defaults, config);
	            $menuBarContainer = option.$menuBarContainer;
	
	            var $popElem = $menuBarContainer.find('.' + option.styleClass);
	            if ($popElem.length < 1) {
	                $menuBarContainer.find('.mkts-cmpt-svgcht-popover').remove(); //if a different popover is shown, remove it
	                $el.addClass('mkts-cmpt-svgcht-popover').addClass(option.styleClass);
	                $menuBarContainer.append($el);
	                adjustPosition();
	            } else if (option.sync) {
	                adjustPosition();
	            } else {
	                if (shown) {
	                    if (option.toggle) {
	                        $popElem.remove();
	                        hide(); //will call $(document).off('.popover') to remove click events.
	                        return false;
	                    }
	                }
	            }
	
	            // If popover should auto hide on blur
	            if (option.blurhide === true) {
	                addBlurListener();
	            }
	            $el.on('click.popover', '.mkts-cmpt-svgcht-popover-close', function() {
	                hide();
	            });
	
	            shown = true;
	        };
	
	        function hide() {
	            if ($el) {
	                $el.remove();
	                $(document).off('.popover');
	                $($el).off('.popover');
	                option.$menuBarContainer.find('.mkts-cmpt-svgcht-menubtn').each(function() {
	                    $(this).removeClass('active');
	                });
	                shown = false;
	            }
	        };
	
	        function adjustPosition() {
	            function setHeightAndTop($el, $target) {
	                var position = $target.position();
	                var popTop = position.top + $target.outerHeight();
	                var heightPlusPosition = popTop + $el.outerHeight();
	
	                $el.css({
	                    top: popTop
	                });
	                if (heightPlusPosition > componentHeight) {
	                    $el.height(componentHeight - popTop - 10);
	                }
	            }
	
	            function setLeft($el, $target) {
	                var position = $target.position();
	                var popLeft = position.left;
	
	                if (option.center) { //center if config'd
	                    popLeft = (popLeft + ($target.outerWidth() / 2) - ($el.outerWidth() / 2));
	                }
	                if ((popLeft + $el.outerWidth()) > componentWidth) { //scootch if no room
	                    popLeft = componentWidth - $el.outerWidth();
	                }
	
	                $el.css({
	                    left: popLeft
	                });
	            }
	
	            function setArrowPostion($el, $target) {
	                var $arrow = $el.find('.mkts-cmpt-svgcht-popover-arrow');
	                if ($arrow.length < 1) {
	                    return;
	                }
	                var _left = $target.position().left - $el.position().left;
	                _left += 30;
	                $arrow.css("left", _left);
	            }
	            var componentWidth = option.$componentContainer.outerWidth();
	            var componentHeight = option.$componentContainer.outerHeight();
	            var $target = option.$target;
	
	            $el.css({
	                visibility: 'hidden'
	            });
	            if (option.sizeForMobile === true && option.containerWidth < 601) {
	                $el.height('auto');
	                var style = {
	                    'top': 0,
	                    'left': 0,
	                    'width': '100%',
	                    'max-width': '100%',
	                    'height': height,
	                    'overflow': 'hidden'
	                };
	                if (option.sync) {
	                    var height = $el.outerHeight(true);
	                    if (componentHeight < height) {
	                        height = componentHeight;
	                    }
	                    style.height = height + 'px';
	                }
	                $el.css(style);
	            } else {
	                $el.css({
	                    'width': '330px', //when it display on mobil, it will limited by max-width.
	                    'height': 'auto',
	                    'max-height': '100%'
	                });
	                setHeightAndTop($el, $target);
	                setLeft($el, $target);
	                setArrowPostion($el, $target);
	            }
	            $el.css({
	                visibility: 'visible'
	            });
	        };
	
	        function addBlurListener() {
	            $(document).on('click.popover', function(e) {
	                var el = $el[0];
	                var tar = e.target;
	                var autohide = option.autohide;
	                var contained = $.contains(el, tar);
	
	                if (autohide === false || (autohide === true && !contained)) {
	                    hide();
	                }
	            });
	        }
	
	        return {
	            show: show,
	            adjustPosition: adjustPosition,
	            hide: hide
	        }
	    }
	    return popover;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(3), __webpack_require__(15), __webpack_require__(17), __webpack_require__(9), __webpack_require__(43), __webpack_require__(19), __webpack_require__(44)], __WEBPACK_AMD_DEFINE_RESULT__ = function(commonPlotter, core, baseChartModel, util, graphTypes, drawings, moment, chartLegendHtml) {
	        "use strict";
	        var $ = core.$;
	        var d3 = core.d3;
	
	        /**
	         * Main chart Model
	         *
	         */
	        var model = function(managers) {
	            var eventManager = managers.eventManager;
	            var chartConfigManager = managers.chartConfigManager;
	            var dataAdapter = managers.dataAdapter;
	            var baseChart = baseChartModel(managers);
	            var IntervalTypes = chartConfigManager.IntervalTypes;
	            var SelectionModes = chartConfigManager.SelectionModes;
	            var MainChartTypes = chartConfigManager.MainChartTypes;
	            var MainDataTypes = chartConfigManager.MainDataTypes;
	            var CurrencyMapping = chartConfigManager.CurrencyMapping;
	            var rootConfig;
	            var isFundChart = false;
	            var needMergeHeaderIndicators = ['MAE', 'BBands', 'PChannel', "Keltner"];
	            var isMobile = util.deviceType.mobile();
	            var mainChartExtend = {
	                _init: function(config) {
	                    this._innerClass = innerClass;
	                    rootConfig = chartConfigManager.getConfig();
	                    isFundChart = (rootConfig.chartGenre === chartConfigManager.ChartGenre.FundChart);
	                    this.langData = chartConfigManager.getLabels('markets-components-svgchart', config.lang);
	                    this._decimalPlaces = this.config.crossHairDecimal = this.config.drawingsDecimal = this._getDecimalPlaces();
	                    this._bindEvents();
	                    this._decideMinMaxAttrbute();
	                    this._updateViewData();
	                    this._panResponseCount = 0;
	                },
	                _createCommonPlotter: function() {
	                    var view = this;
	                    var graphConfig = this._defaultGraphConfig = {
	                        containerGElem: this._outerGElem,
	                        data: this._data,
	                        xScale: this._xScale,
	                        yScale: this._yScale,
	                        width: this._validWidth,
	                        yAttributeName: this.yAttr,
	                        yAxisContainerGElem: this._yAxisOuterGElem,
	                        getElementsMapping: function(elementsMapping) {
	                            var mapping = view._elementsMapping || [];
	                            mapping.push(elementsMapping);
	                            view._elementsMapping = mapping;
	                        }
	                    };
	                    this._getDefaultGraphConfig = function() {
	                        this._defaultGraphConfig.data = this._data;
	                        return this._defaultGraphConfig;
	                    };
	                    this._commonPlotter = new commonPlotter(graphConfig);
	                },
	                _bindEvents: function() {
	                    var eventTypes = eventManager.EventTypes;
	                    eventManager.bind(eventTypes.ExportData, this._exportDataToExcel, this);
	                    eventManager.bind(eventTypes.UpdateConfig, this._updateConfig, this);
	                    eventManager.bind(eventTypes.ChangeChartType, this._changeChartType, this);
	                    eventManager.bind(eventTypes.ChangeIntervalFrequency, this._changDataRange, this);
	                    eventManager.bind(eventTypes.UpdateCompareTickers, this._compareTicker, this);
	                    eventManager.bind(eventTypes.GetMainChartDateRange, this._setSliderDateRange, this);
	                    eventManager.bind(eventTypes.ChangeXAxisDomain, this._changeXAxisScaleDomain, this);
	                    eventManager.bind(eventTypes.ChangeIndicators, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeFundamental, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeEvents, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeYAxis, this._changeYaxis, this);
	                    eventManager.bind(eventTypes.FetchPreloadData, this._fetchPreloadData, this);
	                    eventManager.bind([eventTypes.LayoutChange, eventTypes.ChangeMainChartLayout], this._changeLayout, this);
	                    eventManager.bind(eventTypes.ChangeSelectionMode, this._changeSelectionMode, this);
	                    eventManager.bind(eventTypes.ChangeDrawing, this._changeDrawing, this);
	                    eventManager.bind(eventTypes.ChangeVerticalScale, this._changeVerticalScale, this);
	                    eventManager.bind(eventTypes.ToggleTrackball, this._toggleTrackball, this);
	                    eventManager.bind(eventTypes.DrawNewData, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.DestroyChart, this._processDestroyChart, this);
	                    eventManager.bind(eventTypes.ShowTrackball, this._showTrackball, this);
	                    eventManager.bind(eventTypes.ResetZoomIn, this._resetZoomIn, this);
	                },
	                _changeYaxis: function() {
	                    if (this.config.yAxis.position == "outer") {
	                        var translate = this._getGElemTranslate();
	                        this._xAxisOuterGElem && this._xAxisOuterGElem.attr("transform", translate);
	                        this._outerGElem && this._outerGElem.attr("transform", translate);
	                        this._drawingsGElem && this._drawingsGElem.attr("transform", translate);
	                    }
	                    this._chartConfigChanged();
	                },
	                /**
	                 * Draw YAxis.
	                 */
	                _drawYAxis: function() {
	                    var view = this;
	                    var formatValue;
	                    var yAxisConfig = this.config.yAxis;
	                    // This function will help us generate yAxis text.
	                    formatValue = function(d) {
	                        return util.numberFormatter(view.config.lang, d, view._yAxisDecimal, " ", yAxisConfig.withUnit, true);
	                    };
	                    // Whether draw GrowthBaseValue label. You can find more details in https://msjira.morningstar.com/browse/RTCOMP-13750.
	                    var drawGrowthBaseValueLabel = false;
	                    if (yAxisConfig.show) {
	                        if (yAxisConfig.position == "outer") {
	                            var rootConfig = chartConfigManager.getConfig();
	
	                            // Whether need add GrowthBaseValue value.
	                            drawGrowthBaseValueLabel = this._needAddGrowthBaseValueLabel(rootConfig, this._yTickValues);
	                            if (drawGrowthBaseValueLabel) {
	                                this._addGrowthBaseValue(rootConfig.growthBaseValue, this._yTickValues);
	                            }
	
	                            var yAxisTickText = [];
	                            $.each(this._yTickValues, function(key, val) {
	                                yAxisTickText.push(formatValue(val));
	                            });
	                            // Calculate yAxis text width.
	                            var tickWidth = this._getTickWidth(yAxisTickText, this._innerClass.yAxis) + 2;
	                            tickWidth = (tickWidth < rootConfig.yAxisWidth) ? rootConfig.yAxisWidth : tickWidth;
	                            // If the setting's width different with calculated width, we use setting's width.
	                            // And we need reset the chat setting same time we need trigger YAxis changed event.
	                            if (tickWidth != yAxisConfig.width) {
	                                yAxisConfig.width = tickWidth;
	                                var newConfig = rootConfig;
	                                newConfig.charts.mainChart.yAxis.width = yAxisConfig.width;
	                                newConfig.charts.volumeChart.yAxis.width = yAxisConfig.width;
	                                newConfig.charts.sliderChart.yAxis.width = yAxisConfig.width;
	                                newConfig.charts.indicatorChart.yAxis.width = yAxisConfig.width;
	                                newConfig.charts.fundamentalChart.yAxis.width = yAxisConfig.width;
	                                chartConfigManager.setConfig(newConfig);
	                                eventManager.trigger(eventManager.EventTypes.ChangeYAxis);
	                                return false;
	                            }
	                        }
	                        // The config maybe update at above. So we need get the config again here.
	                        var comConfig = chartConfigManager.getConfig();
	                        var config = {
	                            containerGElem: view._yAxisOuterGElem,
	                            tickSize: yAxisConfig.tickSize || 0,
	                            tickPadding: 5,
	                            tickValues: this._yTickValues,
	                            orient: yAxisConfig.orient,
	                            position: yAxisConfig.position,
	                            yAxisWidth: yAxisConfig.width,
	                            ticks: yAxisConfig.ticks,
	                            graphCss: this._innerClass.yAxis,
	                            setAxisStyleFunc: this._setYAxisStyle,
	                            graphType: graphTypes.Axis,
	                            scale: this._yScale,
	                            width: this._validWidth,
	                            height: this._validHeight,
	                            tick: yAxisConfig.tick,
	                            tickFormatFunc: function(d) {
	                                return formatValue(d);
	                            },
	                            componentContainer: comConfig.$componentContainer,
	                            /**
	                             * If we need extra draw GrowthBaseValue label, we need this parameter in _draw_axis function of commonPlotter.js.
	                             * Why we need this, because we need process special location in _draw_axis.
	                             * You can find more details in _resortYAxisLabelLocation function of commonPlotter.js.
	                             */
	                            drawGrowthBaseValueLabel: drawGrowthBaseValueLabel
	                        };
	                        if (comConfig.yAxisMargin) {
	                            config.yAxisMargin = comConfig.yAxisMargin;
	                        }
	                        // Draw the yAxis.
	                        this._commonDraw(config);
	                        // var yElem = this._commonDraw(config);
	                        // var scaleType = this._getCurrentScaleType();
	                        // this._processTicks(yElem);
	
	                        // We need remove GrowthBaseValue.
	                        // If you don't remove it, chart will draw a grid line for this value.
	                        if (drawGrowthBaseValueLabel) {
	                            this._removeGrowthBaseValue(comConfig.growthBaseValue, this._yTickValues);
	                        }
	                        return true;
	                    }
	                },
	                /**
	                 * Judgement whether need add GrowthBaseValue label.
	                 * @param rootConfig - The chart config.
	                 * @param yAxisTickValues - The yAxis values.
	                 * @returns {boolean} - Whether need add GrowthBaseValue label.
	                 * @private
	                 */
	                _needAddGrowthBaseValueLabel: function(rootConfig, yAxisTickValues) {
	                    if (!rootConfig.charts.mainChart.hasOwnProperty('dataType') || !rootConfig.hasOwnProperty('showGrowthBaseValueLabel') || !Array.isArray(yAxisTickValues)) {
	                        return false;
	                    }
	                    // If chart type is ten k growth and growth base value not in yAxisTickValues, we need add growthBaseValue into yAxisTickValues.
	                    return rootConfig.showGrowthBaseValueLabel &&
	                        rootConfig.charts.mainChart.dataType === MainDataTypes.Growth10K &&
	                        $.inArray(rootConfig.growthBaseValue, yAxisTickValues) === -1;
	                },
	
	                /**
	                 * Add GrowthBaseValue label value.
	                 * @param growthBaseValue - The growthBaseValue.
	                 * @param yAxisTickValues - The yAxis values.
	                 * @returns {number[]} - Added yAxisTickValues.
	                 * @private
	                 */
	                _addGrowthBaseValue: function(growthBaseValue, yAxisTickValues) {
	                    return yAxisTickValues.push(growthBaseValue);
	                },
	
	                /**
	                 * Remove growthBaseValue value form yAxisTickValues.
	                 * If we don't remove it, chart will draw a grid line for this value.
	                 * @param growthBaseValue - The growthBaseValue.
	                 * @param yAxisTickValues - The yAxis values array.
	                 * @private
	                 */
	                _removeGrowthBaseValue: function(growthBaseValue, yAxisTickValues) {
	                    if (Array.isArray(yAxisTickValues)) {
	                        var postion = $.inArray(growthBaseValue, yAxisTickValues);
	                        yAxisTickValues.splice(postion, 1);
	                    }
	                },
	
	                _processDestroyChart: function() {
	                    this._svg && this._svg.on('.mainchart', null);
	                },
	
	                _compareTicker: function() {
	                    var eventTypes = eventManager.EventTypes;
	                    // @todo remove duplication in chartConfigManager
	                    if (rootConfig.compareTickers && rootConfig.compareTickers.length > rootConfig.compareChartsMaxAllowed) {
	                        var toRemove = rootConfig.compareTickers.pop();
	                        eventManager.trigger(eventTypes.TickerLimitReached);
	                    } else {
	                        this._chartConfigChanged();
	                    }
	                },
	                _toggleTrackball: function(trackballData) {
	                    var cfg = this.config;
	                    var view = this;
	                    for (var chartType in trackballData.data) {
	                        if (trackballData.data.hasOwnProperty(chartType)) {
	                            switch (chartType) {
	                                case 'main':
	                                    var mainValueLable = this.$el.find('.' + innerClass.mainValue);
	                                    mainValueLable.css('color', trackballData.data[chartType].color);
	                                    mainValueLable.text(this._constructMainTickerValues(trackballData.data[chartType].data));
	                                    break;
	                                case 'events':
	                                    break;
	                                case 'fundamentals':
	                                    trackballData.data[chartType].forEach(function(d) {
	                                        var tickerValueElement = view.$el.find('.' + innerClass[chartType + "Value"] + d.name);
	                                        tickerValueElement.css('color', d.color);
	                                        tickerValueElement.text((d.data && !isNaN(d.data.y)) ? d.data.y.toFixed(view._decimalPlaces) : '--');
	                                    });
	                                    break;
	                                default:
	                                    var runningIndex = 0,
	                                        chartTypeName = '';
	                                    trackballData.data[chartType].forEach(function(d) {
	                                        var newChartTypeName = d.ticker.indexOf('(') > -1 ? d.ticker.substr(0, d.ticker.indexOf('(')) : d.ticker
	                                        newChartTypeName = newChartTypeName.replace(' ', '');
	                                        if (chartTypeName !== newChartTypeName) {
	                                            runningIndex = 0;
	                                            chartTypeName = newChartTypeName;
	                                        }
	
	                                        chartTypeName = chartTypeName.replace(/[^\d\w]/g, '');
	                                        var tickerValueElement = view.$el.find('.' + innerClass[chartType + "Value"] + chartTypeName + runningIndex);
	                                        tickerValueElement.css('color', d.color);
	                                        var textValue = d.data && !isNaN(d.data.y) ? d.data.y.toFixed(view._decimalPlaces) : '--';
	                                        if (chartType != "compare") {
	                                            tickerValueElement.text(' ' + textValue);
	                                        }
	                                        runningIndex += 1;
	                                    });
	                                    break;
	                            }
	                        }
	                    };
	                },
	                _constructMainTickerValues: function(tickerData) {
	                    var tickerValues = ''
	                    if (tickerData) {
	                        if (isFundChart) {
	                            tickerValues = (!isNaN(tickerData[this.yAttr]) ? util.numberFormatter(this.config.lang, tickerData[this.yAttr], this._decimalPlaces, " ", false, true) : '') + ' ';
	                        } else {
	                            tickerValues += 'O:' + (!isNaN(tickerData.open) ? util.numberFormatter(this.config.lang, tickerData.open, this._decimalPlaces, " ", false, true) : '') + ' ';
	                            tickerValues += 'H:' + (!isNaN(tickerData.high) ? util.numberFormatter(this.config.lang, tickerData.high, this._decimalPlaces, " ", false, true) : '') + ' ';
	                            tickerValues += 'L:' + (!isNaN(tickerData.low) ? util.numberFormatter(this.config.lang, tickerData.low, this._decimalPlaces, " ", false, true) : '') + ' ';
	                            tickerValues += 'C:' + (!isNaN(tickerData.close) ? util.numberFormatter(this.config.lang, tickerData.close, this._decimalPlaces, " ", false, true) : '') + ' ';
	                            tickerValues += 'Volume:' + tickerData.volume + ' ';
	                        }
	                    }
	                    return tickerValues;
	                },
	                _changeDrawing: function(drawingType) {
	                    if (drawingType) {
	                        this._disablePan();
	                        this._disableZoomIn();
	                        eventManager.trigger(eventManager.EventTypes.ToggleCrossharis);
	                        this._drawingType = drawingType.toLowerCase();
	                    } else {
	                        if (this.config.selectionMode === SelectionModes.Pan) {
	                            if (!isMobile) {
	                                this._enablePan();
	                            }
	                        } else if (this.config.selectionMode === SelectionModes.ZoomIn) {
	                            this._enableZoomIn();
	                        }
	                        this._drawingType = null;
	                    }
	                },
	                _changeVerticalScale: function() {
	                    this._changeYScale();
	                    this._setYScaleDomain();
	                    this._displayViewAfterChangeDomain();
	                    this._createSelectionMode();
	                },
	                _setScaleDomain: function(xScaleDomain) {
	                    var view = this;
	                    this._xScale.domain(this._getAjustedDomain(xScaleDomain));
	                    this._yScale = this._createYScale().range([this._validHeight, 0]);
	                    this._decideMinMaxAttrbute();
	                    this._setYScaleDomain();
	                },
	                _getCurrentScaleType: function() {
	                    var mainDataType = chartConfigManager.getMainDataType();
	                    var currentScaleType;
	                    if ((this.config.verticalScaleType === chartConfigManager.VerticalScaleTypes.Logarithmic) &&
	                        (this._compareData && this._compareData.length > 0 ||
	                            mainDataType === MainDataTypes.Growth ||
	                            mainDataType === MainDataTypes.DividendEffect)) {
	
	                        currentScaleType = chartConfigManager.VerticalScaleTypes.Linear;
	                    } else {
	                        currentScaleType = this.config.verticalScaleType || chartConfigManager.VerticalScaleTypes.Linear;
	                    }
	                    return currentScaleType;
	                },
	                _changeYScale: function() {
	                    var yScaleDomain = this._yScale.domain();
	                    this._yScale = this._createYScale().range([this._validHeight, 0]).domain(yScaleDomain);
	                },
	                _changeSelectionMode: function() {
	                    if (this._lastSelectionMode && this._lastSelectionMode === this.config.selectionMode) {
	                        return;
	                    }
	                    var selectionMode = this.config.selectionMode;
	                    switch (selectionMode) {
	                        case SelectionModes.Pan:
	                            this._disableZoomIn();
	                            this._createPan();
	                            if (isMobile) {
	                                this._disablePan();
	                            }
	                            var loadedData = this._loadedData || this._data;
	                            if (loadedData) {
	                                var offsetDomain = this._preloadInfo.offsetDomain || 0;
	                                var start = this._getDataIndexByDate(this._data[0].date, null, null, loadedData);
	                                start && (this._preloadInfo.offsetDomain = start);
	                            }
	
	                            this._lastSelectionMode = selectionMode;
	                            break;
	                        case SelectionModes.ZoomIn:
	                            this._disablePan();
	                            this._createZoomIn();
	                            this._lastSelectionMode = selectionMode;
	                            break;
	                        case SelectionModes.Off:
	                            this._disablePan();
	                            this._disableZoomIn();
	                            this._lastSelectionMode = selectionMode;
	                            break;
	                    }
	                },
	                _updateConfig: function() {
	                    this.config = chartConfigManager.getChartConfig(chartConfigManager.ChartTypes.MainChart);
	                },
	                _setSliderDateRange: function() {
	                    var dateRange = this.config.dateRange;
	                    // TODO: why _xScale is null sometimes?
	                    if (this._xScale && this._data && (!dateRange || dateRange.length !== 2)) {
	                        var crurrentDomain = this._xScale.domain();
	                        var startIndex, endIndex;
	                        if (crurrentDomain[0] < 0) { //no preload data.
	                            startIndex = 0;
	                        } else {
	                            startIndex = Math.floor(crurrentDomain[0]);
	                        }
	
	                        if (crurrentDomain[1] >= this._data.length) {
	                            endIndex = this._data.length - 1;
	                        } else {
	                            endIndex = Math.floor(crurrentDomain[1] - 1);
	                        }
	
	                        if (endIndex < 0) {
	                            endIndex = 0;
	                        }
	
	                        dateRange = [this._data[startIndex].date, this._data[endIndex].date];
	                    }
	
	                    dateRange && eventManager.trigger(eventManager.EventTypes.ChangeSliderDateRange, dateRange);
	                    return dateRange;
	                },
	                _chartConfigChanged: function() {
	                    //TODO: Calls are made twice one for main chart and again for volume
	                    //Need to work on making sure that the call is made only once
	                    this._updateViewData();
	                },
	
	                _changeChartType: function(chartType) {
	                    if (chartType === MainChartTypes.TenKGrowthChart) {
	                        chartConfigManager.setConfig({
	                            growthBaseValue: 10000,
	                            chartType: chartType,
	                            dataType: chartConfigManager.getMainDataType()
	                        });
	                    } else {
	                        chartConfigManager.setConfig({
	                            growthBaseValue: rootConfig.rootGrowthBaseValue,
	                            chartType: chartType,
	                            dataType: chartConfigManager.getMainDataType()
	                        });
	                    }
	                    if (chartType === MainChartTypes.pGrowthChart || chartType === MainChartTypes.TenKGrowthChart || chartType === MainChartTypes.DividendEffectChart || chartType === MainChartTypes.PostTaxChart || chartType === MainChartTypes.PriceWithDividendGrowth) {
	                        chartType = MainChartTypes.MountainChart;
	                    }
	                    this._decideMinMaxAttrbute();
	                    if (this["_draw_" + chartType]) {
	                        this._chartConfigChanged();
	                    }
	                },
	                _hightLightHoveredLine: function(indexPosition) {
	                    var hightLightIndex = this._findHoveredLineIndex(indexPosition);
	                    var hightLightLine;
	                    var d3Container = d3.select(this.config.container);
	                    if (hightLightIndex == 0) {
	                        hightLightLine = d3Container.select('.mkts-cmpt-svgcht-chart-lines.chart-line');
	                        this._drawMainTag(true);
	                    } else if (!isNaN(hightLightIndex)) {
	                        var cIndex = hightLightIndex - 1;
	                        var compareData = this._compareData[cIndex];
	                        var lineSelector = '.mkts-cmpt-svgcht-chart-lines.compare-' + cIndex + '-class';
	                        var tagSelector = '.compare-tag-' + cIndex;
	                        var colorsLength = chartConfigManager.getConfig().compareColors.length;
	                        hightLightLine = d3Container.select(lineSelector);
	                        var colorIndex = (cIndex >= colorsLength && colorsLength) ? cIndex % colorsLength : cIndex;
	                        var colorValue = compareData.tickerObject['customTickerColor'] || chartConfigManager.getConfig().compareColors[colorIndex];
	                        var globalGraphClass = this._getGlobalClass(compareData.tickerObject, null, cIndex);
	                        var upward = this._firstCompareTagUpward;
	                        this._drawTag(compareData.Price.data, this.yAttr, colorValue, "compare-tag-" + colorIndex + globalGraphClass, upward, true);
	                    }
	                    d3Container.selectAll(".mkts-cmpt-svgcht-chart-lines").classed('mkts-cmpt-svgcht-hightlight-line', false);
	                    hightLightLine && hightLightLine.classed('mkts-cmpt-svgcht-hightlight-line', true);
	                },
	                _isAcuteAngle: function(p1, p2, p3) { //p1 is the vertex,
	                    var angel = 0,
	                        radian;
	                    var P12 = Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
	                    var P13 = Math.sqrt(Math.pow(p1.x - p3.x, 2) + Math.pow(p1.y - p3.y, 2));
	                    var P23 = Math.sqrt(Math.pow(p2.x - p3.x, 2) + Math.pow(p2.y - p3.y, 2));
	                    if (P12 == 0 || P23 == 0 || P13 == 0) {
	                        radian = 0;
	                    } else {
	                        var cosV = (Math.pow(P12, 2) + Math.pow(P13, 2) - Math.pow(P23, 2)) / (2 * P12 * P13);
	                        if (cosV > 1) {
	                            cosV = 1;
	                        } else if (cosV < -1) {
	                            cosV = -1;
	                        }
	                        radian = Math.acos(cosV);
	                    }
	                    var angle = Math.floor(180 / (Math.PI / radian));
	                    return angle < 90;
	                },
	                _findHoveredLineIndex: function(position) {
	                    var dataList = [],
	                        disArray = [],
	                        yAttr = this.yAttr;
	                    var highlightDist = rootConfig.highlightDist;
	                    dataList.push(this._data);
	                    if (this._compareData) {
	                        for (var i = 0; i < this._compareData.length; i++) {
	                            dataList.push(this._compareData[i]['Price']['data']);
	                        }
	                    }
	                    for (var i = 0; i < dataList.length; i++) {
	                        var data = dataList[i],
	                            dataLen = data.length;
	                        var p0 = {
	                                x: 0,
	                                y: 0
	                            },
	                            p1 = {
	                                x: 0,
	                                y: 0
	                            },
	                            p = {
	                                x: 0,
	                                y: 0
	                            };
	                        var oriXMouse = this._xScale.invert(position[0]);
	                        var oriXMouse1 = Math.floor(this._xScale.invert(position[0] - highlightDist) - this._xScale.domain()[0]);
	                        var oriXMouse2 = Math.ceil(this._xScale.invert(position[0] + highlightDist));
	                        oriXMouse2 = oriXMouse2 > (data.length - 1) ? (data.length - 1) : oriXMouse2;
	                        oriXMouse1 = oriXMouse1 < 0 ? 0 : oriXMouse1;
	                        var dpGroupArray = []; // all possible line segments between oriXMouse1 and oriXMouse2
	                        for (var n = oriXMouse1; n < oriXMouse2; n++) {
	                            var dpGroup = [n, n + 1]
	                            dpGroupArray.push(dpGroup);
	                        }
	                        p.x = position[0];
	                        p.y = position[1];
	                        for (var g = 0; g < dpGroupArray.length; g++) { // caculate the distance of 'p to segments'
	                            var xMouseArray = dpGroupArray[g]; // two datapoints of segment
	                            for (var x = 0; x < xMouseArray.length; x++) {
	                                var xMouse = xMouseArray[x];
	                                if (xMouse < 0) {
	                                    xMouse = 0;
	                                }
	                                if (xMouse >= dataLen) {
	                                    xMouse = dataLen - 1;
	                                }
	                                var d = data[xMouse];
	                                if (isNaN(d[yAttr]) && isNaN(d['lastValidY'])) { // find the nearest valid dataPoint for xMouse
	                                    var factor = (x == 0) ? -1 : 1;
	                                    do {
	                                        xMouse = xMouse + factor;
	                                        if (xMouse <= 0 && x == 0 || xMouse >= dataLen - 1 && x == 1) {
	                                            break;
	                                        }
	                                        d = data[xMouse];
	                                    } while (isNaN(d[yAttr]) && isNaN(d['lastValidY']));
	                                }
	                                if (isNaN(d[yAttr]) && isNaN(d['lastValidY'])) {
	                                    break;
	                                }
	                                var validY = isNaN(d[yAttr]) ? d['lastValidY'] : d[yAttr];
	                                if (x == 0) {
	                                    p0.x = this._xScale(xMouse);
	                                    p0.y = this._yScale(validY);
	                                } else if (x == 1) {
	                                    p1.x = this._xScale(xMouse);
	                                    p1.y = this._yScale(validY);
	                                }
	                            }
	                            var dis;
	                            if (p1.x == p0.x) { // p1 and p0 is the same points, caculate distance of 'point to point'
	                                dis = Math.sqrt(Math.pow(p1.x - p.x, 2) + Math.pow(p1.y - p.y, 2));
	                            } else {
	                                if (this._isAcuteAngle(p0, p, p1) && this._isAcuteAngle(p1, p, p0)) {
	                                    //if ∠pp0p1 and ∠pp1p0 are both acute angle, caculate the distance of 'point to line'
	                                    var k = ((p0.y - p1.y) / (p0.x - p1.x));
	                                    var b = (p0.y * p1.x - p1.y * p0.x) / (p1.x - p0.x);
	                                    dis = Math.abs(k * p.x - 1 * p.y + b) / Math.sqrt(1 + k * k);
	                                } else {
	                                    //else caculate the min distance of 'pp0' and 'pp1'
	                                    dis = Math.min(Math.sqrt(Math.pow(p1.x - p.x, 2) + Math.pow(p1.y - p.y, 2)), Math.sqrt(Math.pow(p0.x - p.x, 2) + Math.pow(p0.y - p.y, 2)));
	                                }
	                            }
	                            disArray.push({
	                                distance: dis,
	                                index: i
	                            });
	                        }
	                    }
	                    var minIndex = 0,
	                        minDis;
	                    if (disArray.length > 0) {
	                        minDis = disArray[0].distance;
	                        for (var i = 0; i < disArray.length; i++) {
	                            if (disArray[i].distance < minDis) {
	                                minDis = disArray[i].distance;
	                                minIndex = disArray[i].index;
	                            }
	                        }
	                    }
	                    if (minDis < highlightDist) {
	                        return minIndex;
	                    }
	                },
	                _draw_compareCharts: function() {
	                    var view = this;
	                    if (!(this._compareData && this._compareData.length > 0)) {
	                        return;
	                    }
	
	                    var compareChartsData = this._compareData;
	                    var upward = false;
	                    compareChartsData && compareChartsData.forEach(function(c, cIndex) {
	                        var compareData = c.Price.data;
	                        var mainTickerXLength = view._data ? view._data.length : 0;
	                        if (compareData.length !== mainTickerXLength) {
	                            compareData = view._baselineXCordinates(compareData, view._data);
	                        }
	                        var index = 0;
	                        compareData.forEach(function(d) {
	                            d.x = d.index = index++;
	                            d.y = d[view.yAttr];
	                        });
	                        c.Price.data = compareData;
	                        var colorValue = c.colorValue;
	                        var globalGraphClass = c.globalGraphClass;
	                        var colorIndex = c.colorIndex;
	                        var graphCss = innerClass.compare + " compare" + "-" + colorIndex + "-class" + globalGraphClass + " " + innerClass.chartlines;
	                        var graphConfig = {
	                            data: compareData,
	                            color: colorValue,
	                            graphCss: graphCss,
	                            graphType: graphTypes.Line
	                        };
	                        if (c.Price.data.length > 0) {
	                            view._commonDraw(graphConfig);
	                            //Just when cIndex = 0, check tag position if need ajust.
	                            if (cIndex === 0) {
	                                upward = view._firstCompareTagUpward;
	                            }
	                            view._drawTag(compareData, view.yAttr, colorValue,
	                                "compare-tag-" + colorIndex + globalGraphClass, upward);
	
	                            var trackballConfig = {
	                                graphCss: graphCss,
	                                color: colorValue,
	                                data: compareData,
	                                globalGraphClass: globalGraphClass
	                            };
	
	                            view._commonDrawTrackball(trackballConfig);
	                        }
	                    });
	
	                },
	                _needHideBenchmark: function() {
	                    return chartConfigManager.getMainDataType() === MainDataTypes.Growth && chartConfigManager.isITFund() && rootConfig.hideBenchmark;
	                },
	                _removeCompare: function(index) {
	                    var tickerCollection = chartConfigManager.getTickerCollection();
	                    if (tickerCollection[index]) {
	                        eventManager.trigger(eventManager.EventTypes.CompareTicker, tickerCollection[index], true, true);
	                    }
	                },
	                _removeMainTicker: function() {
	                    var tickerCollection = chartConfigManager.getTickerCollection();
	                    if (tickerCollection.length > 1) {
	                        eventManager.trigger(eventManager.EventTypes.ChangeTicker, {
	                            ticker: tickerCollection[1]
	                        }, true);
	                    }
	                },
	                // exchange MainTicker and rebuild compare ticker
	                _exchangeMainTicker: function(index) {
	                    var tickerCollection = chartConfigManager.getTickerCollection();
	                    var toMove = tickerCollection[index];
	                    var rootConfig = chartConfigManager.getConfig();
	                    var compareTickers = $.extend(true, [], rootConfig.compareTickers);
	                    if (index && tickerCollection[index]) {
	                        tickerCollection.splice(0, 1, toMove);
	                        tickerCollection.splice(index, 1, this.mainTickerObject)
	                        chartConfigManager.setTickerCollection(tickerCollection);
	                        var main = this.mainTickerObject.symbol || this.mainTickerObject.performanceId;
	                        if (rootConfig.useEUTimeSeriesData) {
	                            main = {
	                                id: this.mainTickerObject.secId,
	                                securityToken: this.mainTickerObject.securityToken,
	                                name: this.mainTickerObject.Name,
	                                currency: this.mainTickerObject.customCurrency
	                            };
	                        }
	                        compareTickers.splice(index - 1, 1, main);
	                        chartConfigManager.setConfig({
	                            compareTickers: compareTickers
	                        });
	                        eventManager.trigger(eventManager.EventTypes.ChangeTicker, {
	                            ticker: toMove
	                        }, true);
	                    }
	                },
	                _constructTickerPriceChangeLabel: function(tickerData) {
	                    var legendLabel = '';
	                    var lastPriceChange = Number.MIN_VALUE;
	                    var priceChange = Number.MIN_VALUE;
	                    var percentageChange = Number.MIN_VALUE;
	
	                    var isPercentChart = chartConfigManager.isPercentChart();
	
	                    var dataToRefer = (tickerData ? tickerData.Price.data : this._data) || []; // Why use .slice()
	                    var lastClosePrice = tickerData ? tickerData.Price.spos : this._lastClosePrice;
	                    var yValue;
	                    for (var len = dataToRefer.length, i = len - 1; i >= 0; i--) {
	                        yValue = dataToRefer[i][this.yAttr];
	                        if (!isNaN(yValue)) {
	                            lastPriceChange = yValue;
	                            break;
	                        }
	                    }
	                    var config = chartConfigManager.getConfig();
	                    var growthBaseValue = config.rootGrowthBaseValue;
	
	                    if (isPercentChart) {
	                        if (rootConfig.useEUTimeSeriesData) {
	                            priceChange = lastPriceChange;
	                            percentageChange = lastPriceChange;
	                        } else if (lastPriceChange !== Number.MIN_VALUE && !isNaN(lastClosePrice)) {
	                            priceChange = lastClosePrice * (lastPriceChange / 100);
	                            percentageChange = lastPriceChange;
	                        }
	                    } else {
	                        var mainDataType = chartConfigManager.getMainDataType();
	                        var MainDataTypes = chartConfigManager.MainDataTypes;
	                        if (growthBaseValue || mainDataType === MainDataTypes.Growth10K) {
	                            lastClosePrice = growthBaseValue || 10000;
	                        }
	                        if (config.chartGenre === chartConfigManager.ChartGenre.FundChart &&
	                            (mainDataType === MainDataTypes.PriceWithDividendGrowth || mainDataType === MainDataTypes.PostTax) &&
	                            dataToRefer.length > 0) {
	                            lastClosePrice = dataToRefer[0][this.yAttr];
	                        }
	                        if (lastPriceChange !== Number.MIN_VALUE && !isNaN(lastClosePrice)) {
	                            if ((tickerData || (this._compareData && this._compareData.length)) && !growthBaseValue && !rootConfig.drawNavAndPriceChart) {
	                                priceChange = (lastPriceChange / 100) * lastClosePrice;
	                                percentageChange = lastPriceChange;
	                            } else {
	                                priceChange = lastPriceChange - lastClosePrice;
	                                percentageChange = (priceChange / lastClosePrice) * 100;
	                            }
	                        }
	                    }
	                    if (priceChange != Number.MIN_VALUE && percentageChange != Number.MIN_VALUE) {
	                        var legendSpanColor = this._updatePriceChangeColor(priceChange.toFixed(this._decimalPlaces));
	                        var _chgPDecimal = (rootConfig.chgPDecimal != undefined && rootConfig.chgPDecimal != null) ? rootConfig.chgPDecimal : rootConfig.defaultDecimal;
	                        while (Math.abs(percentageChange) * Math.pow(10, _chgPDecimal) < 0.5 && percentageChange !== 0) {
	                            _chgPDecimal++;
	                        }
	                        var changePositive = false;
	                        if (percentageChange > 0) {
	                            changePositive = true;
	                        }
	                        var _chg = util.numberFormatter(this.config.lang, priceChange, this._decimalPlaces, " ", false, true);
	                        var _chgp = util.numberFormatter(this.config.lang, percentageChange, _chgPDecimal, " ", false, true);
	                        if (rootConfig.showPricePlusSign && changePositive) {
	                            _chg = '+' + _chg;
	                            _chgp = '+' + _chgp;
	                        }
	                        // define two parameters to control chg || chgp
	                        var _showChg = !!rootConfig.showLegendNetChange;
	                        var _showChgp = !!rootConfig.showLegendPercentChange;
	                        if (isPercentChart && rootConfig.useEUTimeSeriesData) {
	                            _showChg = false;
	                        }
	
	                        if (_showChg && _showChgp) {
	                            legendLabel += _chg + ' | ' + _chgp + '% ';
	                        } else {
	                            legendLabel = _showChg ? _chg : _showChgp ? _chgp + '% ' : '';
	                        }
	                    }
	
	                    return {
	                        label: legendLabel,
	                        legendSpanColor: legendSpanColor
	                    };
	                },
	                _updatePriceChangeColor: function(pricechange) {
	                    var legendSpanColor;
	                    if (pricechange > 0) {
	                        legendSpanColor = innerClass.upPriceChangeColor;
	                    } else if (pricechange < 0) {
	                        legendSpanColor = innerClass.downPriceChangeColor;
	                    } else {
	                        legendSpanColor = innerClass.zeroPriceChangeColor;
	                    }
	
	                    return legendSpanColor;
	                },
	                _dividendEffectHeaderProcess: function() {
	                    if (!this._headerContainer || !this.mainTickerObject) {
	                        return;
	                    }
	
	                    var cfg = this.config;
	                    var parentSpan = $(this._headerContainer[0]).find("." + innerClass.compare);
	                    var mainDataType = chartConfigManager.getMainDataType();
	                    if (mainDataType === MainDataTypes.DividendEffect) {
	                        if (cfg.showLegend) {
	                            $("<span class='" + innerClass.dividendEffectLegend + "'>")
	                                .css("background", cfg.dividendEffectProperties.color).appendTo(parentSpan);
	                        }
	
	                        var divEffectSpan = $("<span class='" + innerClass.dividendEffectLegendText + "'>").appendTo(parentSpan);
	                        divEffectSpan.css("color", cfg.dividendEffectProperties.color)
	                            .text(this.mainTickerObject.ticker + this.langData['mainChartHeaderDividendEffectLabel']);
	                    }
	                },
	                _showDataNotAvailable: function() {
	                    if (this.showDataNotAvaible || !this.dataNotAvailable) {
	                        return;
	                    }
	                    this.showDataNotAvaible = true;
	                    var message = this.langData['datanotavailable'];
	                    if (this.mifidExcludedPeriod) {
	                        message = this.langData['mifidRuleMessage'].replace('{0}', this.mifidExcludedPeriod);
	                    }
	                    this._renderDomFrame();
	                    this._outerGElem && this._outerGElem.selectAll("g").remove();
	                    this._svg.select(".mainChart-zoomDrag").remove();
	                    this._xAxisOuterGElem && this._xAxisOuterGElem.select("g").remove();
	                    innerClass["xAxisSvg"] && this.$el.find("." + innerClass["xAxisSvg"]).hide();
	                    innerClass["yAxis"] && this.$el.find("." + innerClass["yAxis"]).hide();
	                    innerClass["chartHeader"] && this.$el.find("." + innerClass["chartHeader"]).hide();
	                    innerClass["mainSvg"] && this.$el.find("." + innerClass["mainSvg"]).css("border-bottom", "none").css("height", this.config.minHeight);
	                    innerClass["chartBody"] && this.$el.find("." + innerClass["chartBody"]).css("height", this.config.minHeight);
	                    var elem = this._svg.append('g');
	                    elem.append('text').attr('class', 'dataNotAvailable')
	                        .text(message)
	                        .attr("transform", "translate(" + this._validWidth / 2 + ",40)");
	                    this._$DataNotAvailableElem = elem;
	                    eventManager.trigger(eventManager.EventTypes.HeightChanged);
	                    chartConfigManager.setConfig({
	                        isFullyRendered: true
	                    });
	                },
	
	                _hideDataNotAvailable: function() {
	                    innerClass["mainSvg"] && this.$el.find("." + innerClass["mainSvg"]).css({
	                        "border-bottom": "none",
	                        "height": this._validHeight
	                    });
	                    this._$DataNotAvailableElem && this._$DataNotAvailableElem.remove();
	                    innerClass["xAxisSvg"] && this.$el.find("." + innerClass["xAxisSvg"]).show();
	                    innerClass["yAxis"] && this.$el.find("." + innerClass["yAxis"]).show();
	                    innerClass["chartHeader"] && this.$el.find("." + innerClass["chartHeader"]).show();
	                    innerClass["chartBody"] && this.$el.find("." + innerClass["chartBody"]).css("height", this._validHeight + this.config.xAxisHeight);
	                    if (!this.showDataNotAvaible) {
	                        return;
	                    }
	                    this.showDataNotAvaible = false;
	                    eventManager.trigger(eventManager.EventTypes.HeightChanged);
	
	                },
	
	                _clearView: function(chartType) {
	                    if (this._outerGElem) {
	                        this._outerGElem.selectAll("g").remove();
	                        this._outerGElem.selectAll(".track-ball").remove();
	                        this._clearTrackball();
	                    }
	                    if (this._yAxisOuterGElem) {
	                        this._yAxisOuterGElem.selectAll("g").remove();
	                    }
	                    if (this._xAxisOuterGElem) {
	                        this._xAxisOuterGElem.selectAll("g").remove();
	                    }
	                    this._hideDataNotAvailable();
	                },
	                _changeLayout: function() {
	                    this._clearView();
	                    if (this._data && (this._data.length > 0)) {
	                        this._renderView();
	                        this._createSelectionMode();
	                    } else {
	                        this._showDataNotAvailable();
	                        this._viewInited = false;
	                    }
	                },
	                _getDrawingGContainer: function() {},
	                _createSvgWrapper: function() {
	                    var cfg = this.config;
	                    var view = this;
	                    var d3_container = d3.select(cfg.container);
	                    var mainDiv = d3_container.select("." + innerClass.chartBody);
	                    if (mainDiv.empty()) {
	                        mainDiv = d3_container.append('div').classed(innerClass.chartBody, true)
	                        var svg = this._svg = mainDiv.append('svg').classed(innerClass.mainSvg, true)
	                        var yAxisGElem = d3_container.select('.' + innerClass.yAxis);
	                        if (!this._yAxisOuterGElem || (this._yAxisOuterGElem && this._yAxisOuterGElem.empty())) {
	                            yAxisGElem = d3_container.select('.' + innerClass.mainSvg)
	                                .append("g").classed(innerClass.yAxis, true)
	                                .style("width", cfg.yAxis.width + "px");
	
	                            this._yAxisOuterGElem = yAxisGElem;
	                        }
	                        this._outerGElem = svg.append("g");
	                        this._drawingsGElem = svg.append("g");
	                        //when mouse move in the mainchart, we will show crosshairs
	                        this._svg.on('mousedown.mainchart', function() {
	                            d3.event.preventDefault();
	                            view._mouseDown(d3.event, d3.mouse(this), view._headerHeight);
	                        }).on("touchstart.mainchart", function() {
	                            view._mouseDown(d3.event, d3.mouse(this), view._headerHeight);
	                        }).on('mousemove.mainchart', function() {
	                            view._mousemove(d3.event, d3.mouse(this), view._headerHeight);
	                        }).on('mouseleave.mainchart', function() {
	                            view._mouseleave(d3.mouse(this));
	                        }).on("touchmove.mainchart", function() {
	                            view._mousemove(d3.event, d3.mouse(this), view._headerHeight);
	                        }).on('mouseup.mainchart', function(e) {
	                            view._mouseUp(d3.mouse(this));
	                        }).on('touchend.mainchart', function() {
	                            view._mouseUp(d3.mouse(this));
	                        });
	                    }
	                    var mainWidth;
	                    if (cfg.yAxis.position == "outer") {
	                        mainWidth = this._validWidth + cfg.margin.left + cfg.margin.right + cfg.yAxis.width + cfg.yAxisMargin + "px";
	                    } else {
	                        mainWidth = this._validWidth + cfg.margin.left + cfg.margin.right + "px";
	                    }
	
	                    mainDiv.style({
	                        "width": mainWidth,
	                        "height": this._validHeight + cfg.xAxisHeight + "px"
	                    });
	
	                    this._svg.style({
	                        "width": mainWidth,
	                        "height": (this._validHeight + 1) + "px"
	                    });
	
	                    this._outerGElem.attr("transform", this._getGElemTranslate());
	                    this._drawingsGElem.attr("transform", this._getGElemTranslate());
	                    this._containerOffset = $(cfg.container).offset();
	                    var xAxisSvg = d3_container.select('.' + innerClass.xAxisSvg);
	
	                    if (!this._xAxisOuterGElem || (this._xAxisOuterGElem && this._xAxisOuterGElem.empty())) {
	                        xAxisSvg = d3_container.select('.' + innerClass.chartBody)
	                            .append("svg").classed(innerClass.xAxisSvg, true)
	                            .style("height", cfg.xAxisHeight + "px");
	                        this._xAxisOuterGElem = xAxisSvg.append("g");
	                        if (cfg.yAxis.position == "outer") {
	                            this._xAxisOuterGElem.attr("transform", this._getGElemTranslate());
	                        }
	                    }
	                    if (cfg.yAxis.position == "outer") {
	                        xAxisSvg.style("width", this._validWidth + cfg.yAxis.width + cfg.yAxisMargin + "px");
	                    } else {
	                        xAxisSvg.style("width", this._validWidth + "px");
	                    }
	
	                },
	                _mouseleave: function(e) {
	                    d3.select(this.config.container).selectAll(".mkts-cmpt-svgcht-chart-lines").classed('mkts-cmpt-svgcht-hightlight-line', false);
	                    if (this._drawingType && this.drawObj) {
	                        this.drawObj.end(this._data.length);
	                        this._changeDrawing();
	                    }
	                },
	                _caculateValidSize: function() {
	                    var cfg = this.config;
	                    if (cfg.yAxis.position == "outer") {
	                        this._validWidth = cfg.width - cfg.margin.left - cfg.margin.right - (cfg.yAxis.width + cfg.yAxisMargin);
	                    } else {
	                        this._validWidth = cfg.width - cfg.margin.left - cfg.margin.right;
	                    }
	                    this._validHeight = cfg.height - cfg.margin.top - cfg.margin.bottom - cfg.xAxisHeight - this.$el.find("." + innerClass.chartHeader).outerHeight(true);
	                    if (this._yScale) {
	                        this._changeYScale();
	                    }
	                },
	                _drawXAxis: function() {
	                    var cfg = this.config;
	                    this._createXAxisTickInfos();
	                    var view = this;
	                    if (cfg.xAxis.show) {
	                        this._xAxisOuterGElem.select("g").remove();
	                        var config = {
	                            containerGElem: this._xAxisOuterGElem,
	                            tickSize: cfg.xAxis.tickSize || 0,
	                            tickPadding: 5,
	                            tickValues: this._xTickInfos.tickValues,
	                            orient: cfg.xAxis.orient,
	                            graphCss: innerClass.xAxis,
	                            graphType: graphTypes.Axis,
	                            scale: this._xScale,
	                            width: this._validWidth,
	                            height: 0,
	                            xTickInfos: this._xTickInfos,
	                            tickFormatFunc: function() {
	                                return view._formatXAxisLabels.apply(view, arguments);
	                            }
	                        };
	                        this._commonDraw(config);
	                    }
	                },
	                _renderDomFrame: function() {
	                    if (!rootConfig.hideSymbol) {
	                        this._renderHeader();
	                    }
	                    this._caculateValidSize();
	                    this._createSvgWrapper();
	                },
	                _renderView: function() {
	                    var view = this;
	                    this._renderDomFrame();
	                    this._createScale();
	                    if (!this.drawObj) {
	                        this.drawObj = drawings(chartConfigManager, eventManager)
	                            .target(this._drawingsGElem)
	                            .findByPosition(function(position) {
	                                return view._findNearItem(position, null, true);
	                            });
	                    }
	                    this._renderContainedViews();
	                    this._viewInited = true;
	                    eventManager.trigger(eventManager.EventTypes.HeightChanged);
	                },
	                _VBPTipProcess: function(position, offsetTop) {
	                    if ($.isArray(rootConfig.indicators)) {
	                        for (var i = 0, len = rootConfig.indicators.length; i < len; i++) {
	                            if (rootConfig.indicators[i].name === dataAdapter.IndicatorName.VBP) {
	                                var offsetLeft = 0;
	                                if (this.config.yAxis.position == "outer") {
	                                    offsetLeft = this.config.yAxis.width + this.config.yAxisMargin;
	                                }
	                                this._VBPDrawObj.tipProcess(position, offsetTop, offsetLeft);
	                                break;
	                            }
	                        }
	                    }
	                },
	                _displayViewAfterChangeDomain: function() {
	                    this._clearView();
	                    this._renderContainedViews();
	                },
	                _renderContainedViews: function() {
	                    this._renderHeader();
	                    this._caculateValidSize();
	                    if (!this._data || this._data.length === 0) {
	                        this._showDataNotAvailable();
	                        return;
	                    } else {
	                        var formater = rootConfig.momentDateTime;
	                        if (!$.isNumeric(rootConfig.frequency)) {
	                            formater = rootConfig.momentDate;
	                        }
	                        var self = this;
	                        self.mainTickerLastDateObj = {
	                            date: moment(self._lastTradeTime).format(formater),
	                            frequency: rootConfig.frequency,
	                            rtTicker: this.mainTickerObject.gkey
	                        }
	                        eventManager.trigger(eventManager.EventTypes.OnMainTickerDrawEnd, self.mainTickerLastDateObj);
	                        this._hideDataNotAvailable();
	                    }
	
	                    // Update calendar date value and frequency according returned data.
	                    eventManager.trigger(eventManager.EventTypes.UpdateMenuIntervalForRender, [this._data[0].date, this._data[this._data.length - 1].date]);
	                    this._createCommonPlotter();
	                    this._drawXAxis();
	                    if (!this._drawYAxis()) {
	                        return;
	                    }
	                    this._xScale.range([0, this._validWidth]);
	                    if (this.drawObj) {
	                        this.drawObj.width(this._validWidth)
	                            .height(this._validHeight)
	                            .xScale(this._xScale)
	                            .yScale(this._yScale);
	                    }
	                    this._setTagUpward();
	                    this._drawGridLines();
	                    this._drawMainGraph();
	                    //hideBenchmark from user
	                    if (!this._needHideBenchmark()) {
	                        this._draw_compareCharts();
	                    }
	                    this._draw_Indicators();
	                    this._dividendEffectHeaderProcess();
	                    var mainDataType = chartConfigManager.getMainDataType();
	                    var isGrowthType = (mainDataType === MainDataTypes.Growth10K ||
	                        mainDataType === MainDataTypes.Growth ||
	                        mainDataType === MainDataTypes.DividendEffect)
	                    if (!((this._compareData && this._compareData.length > 0) || isGrowthType)) {
	                        var tempGlobalIndex = this._globalGraphIndex;
	                        this._draw_Fundamentals(false, tempGlobalIndex);
	                        this._appendHeaderForFundamentals();
	                    } else {
	                        this._clearHeaderForFundamentals();
	                    }
	
	                    this._drawEvents();
	                    this._drawMainTag();
	                    this._setSliderDateRange();
	                    var savedDrawings = chartConfigManager.getConfig().savedDrawings;
	                    if (savedDrawings) {
	                        this.drawObj && this.drawObj.applySavedDrawings(savedDrawings);
	                        chartConfigManager.setConfig({
	                            savedDrawings: null
	                        });
	                    }
	                    this.drawObj && this.drawObj.redraw(this._data);
	                    chartConfigManager.setConfig({
	                        isFullyRendered: true,
	                        migrateFromSdk: false
	                    });
	                    delete rootConfig.resetAction;
	                },
	                _draw_Indicators: function() {
	                    var view = this;
	                    var cfg = this.config;
	                    var parentSpan, $headerContainer;
	
	                    if (this._headerContainer) {
	                        $headerContainer = $(this._headerContainer[0]);
	                        parentSpan = $headerContainer.find("." + innerClass.indicators).empty();
	                    }
	                    var indicatorsData = this._indicatorsData;
	                    if (!indicatorsData) {
	                        return;
	                    }
	
	                    for (var indicatorName in indicatorsData) {
	                        if (cfg.indicatorProperties.hasOwnProperty(indicatorName)) {
	                            var indiData = indicatorsData[indicatorName];
	                            if (indicatorName === dataAdapter.IndicatorName.PrevClose &&
	                                (cfg.intervalType !== IntervalTypes.OneDay || chartConfigManager.isCompareOrPercentChart())) {
	                                continue;
	                            }
	
	                            if (!$.isArray(indiData)) {
	                                indiData = [indiData];
	                            }
	
	                            var globalGraphClass;
	                            var globalGraphClassList = [];
	                            var needMergeHeader = (needMergeHeaderIndicators.indexOf(indicatorName) >= 0);
	                            // code for drawing chart, no change
	                            indiData.forEach(function(graphData, chartIndex) {
	                                if (!needMergeHeader || (needMergeHeader && chartIndex === 0)) {
	                                    globalGraphClass = view._getGlobalClass();
	                                }
	                                globalGraphClassList.push(globalGraphClass);
	
	                                view._draw_Indicators_graph(graphData, chartIndex, indicatorName, globalGraphClass);
	                            });
	
	                            // code for drawing legend
	                            var indicatorConfig = chartConfigManager.getConfig().indicators.filter(function(i) {
	                                return i.name === indicatorName;
	                            });
	                            var indicatorObj = indicatorConfig.length > 0 ? indicatorConfig[0] : [];
	                            view._constructIndicatorLegend(parentSpan, indicatorObj, indicatorName, globalGraphClassList);
	                        }
	                    }
	
	                    var _headerHeight = $headerContainer.outerHeight(true);
	                    if (this._headerHeight !== _headerHeight) {
	                        this._headerHeight = _headerHeight;
	                    }
	                },
	                _drawEvents: function() {
	                    var view = this;
	                    if (this._eventsData) {
	                        for (var eventData in this._eventsData) {
	                            if (eventData === dataAdapter.Events.Dividend && !view.config.showDividend) {
	                                continue;
	                            }
	                            view._drawEvent(eventData, view._eventsData[eventData]);
	                        }
	                    }
	                },
	                _clearHeaderForFundamentals: function() {
	                    if (!this._headerContainer) {
	                        return;
	                    }
	
	                    var cfg = this.config;
	                    var $headerContainer = $(this._headerContainer[0]);
	                    var parentSpan = $headerContainer.find("." + innerClass.fundamentals);
	                    if (parentSpan) {
	                        parentSpan.empty();
	                    }
	                },
	                _getCompareLegendData: function() {
	                    var compareChartsData = this._compareData;
	                    var view = this;
	                    var compareLegendData = [];
	                    compareChartsData && compareChartsData.forEach(function(c, cIndex) {
	                        var colorsLength = rootConfig.compareColors.length;
	                        var colorIndex = (cIndex >= colorsLength && colorsLength) ? cIndex % colorsLength : cIndex;
	                        var colorValue = c.tickerObject['customTickerColor'] || rootConfig.compareColors[colorIndex];
	                        var globalGraphClass = view._getGlobalClass(c.tickerObject);
	                        var legendText = view._getLegendText(c.tickerObject);
	                        if (rootConfig.legendDot) {
	                            legendText = "●" + legendText
	                        }
	                        var legendData = {
	                            compareClass: "compare-legend-" + cIndex + (globalGraphClass || ' globalIndex-'),
	                            closeable: rootConfig.compareClose,
	                            legendText: legendText,
	                            color: colorValue,
	                            tickerIndex: cIndex + 1,
	                            legendChange: rootConfig.legendChange,
	                        };
	
	                        if (rootConfig.legendChange !== false) {
	                            var legendLabelInfo = view._constructTickerPriceChangeLabel(c);
	                            legendData.changeValue = legendLabelInfo.label;
	                            legendData.updown = legendLabelInfo.legendSpanColor;
	                        }
	                        compareLegendData.push(legendData);
	                        c.colorValue = colorValue;
	                        c.globalGraphClass = globalGraphClass;
	                        c.colorIndex = colorIndex;
	                    });
	                    return compareLegendData;
	                },
	                _renderHeader: function() {
	                    if (!this.mainTickerObject) {
	                        return;
	                    }
	                    this._globalGraphIndex = 0;
	                    var cfg = this.config;
	                    var currency, legendText;
	                    var tickerCollection = chartConfigManager.getTickerCollection();
	                    if (this._headerContainer) {
	                        this._headerContainer.remove();
	                    }
	                    currency = rootConfig.currencyAliases[this._priceCurrency] || this._priceCurrency || this.mainTickerObject.currency;
	                    if (chartConfigManager.isPercentChart()) {
	                        currency = cfg.yAxisDimensionForPercentage;
	                    }
	                    if (rootConfig.showCurrencyOptions && rootConfig.useEUTimeSeriesData) {
	                        currency = rootConfig.baseCurrency || this.mainTickerObject.customCurrency || this.mainTickerObject.currency;
	                    }
	                    legendText = this._getLegendText(this.mainTickerObject);
	                    if (rootConfig.legendDot) {
	                        legendText = "●" + legendText;
	                    }
	                    var legendData = {
	                        showCurrency: !rootConfig.hideCurrency,
	                        showLegend: cfg.hideLegend !== true,
	                        errorMsg: this.langData[rootConfig.compareChartsMaxAllowedErrorLabel],
	                        needLegendBackground: !!cfg.needLegendBackground,
	                        marginLeft: cfg.margin.left,
	                        main: {
	                            show: !rootConfig.hideMainLegend,
	                            color: this.mainTickerObject["customTickerColor"] || rootConfig.mainTickerColor,
	                            globalClass: this._getGlobalClass(this.mainTickerObject, null, -1),
	                            tickerIndex: 0,
	                            currency: currency,
	                            legendText: legendText,
	                            closeable: rootConfig.showMTickerRemoveBtn && tickerCollection.length > 1
	                        },
	                        compare: {
	                            show: !this._needHideBenchmark() && !rootConfig.hideCompareLegend
	                        },
	                    };
	                    var view = this;
	                    if (rootConfig.solutionKey && rootConfig.showCurrencyOptions) {
	                        var currencyList = []
	                        for (var key in CurrencyMapping) {
	                            currencyList.push({
	                                value: key,
	                                text: CurrencyMapping[key]
	                            })
	                        }
	                        legendData.isIwtSource = true;
	                        legendData.isMobile = !isMobile;
	                        legendData.currencyList = currencyList;
	                        $(document).on('click', function(e) {
	                            var tar = e.target;
	                            if (!$(tar).hasClass('mkts-cmpt-svgcht-currency-text')) {
	                                view._hideCurrencyPopover();
	                            }
	                        });
	                    }
	                    if (rootConfig.legendChange !== false) {
	                        var priceLabelInfo = this._constructTickerPriceChangeLabel();
	                        legendData.main.changeValue = priceLabelInfo.label;
	                        legendData.main.updown = priceLabelInfo.legendSpanColor;
	                    }
	                    legendData.compare.data = this._getCompareLegendData();
	                    $(chartLegendHtml(legendData)).prependTo(cfg.container);
	                    this._headerContainer = $(cfg.container).find(".mainChart-header");
	                    this._headerHeight = this._headerContainer.outerHeight(true);
	                    this._headerContainer.find(".error-message-close-button").bind("click", function(e) {
	                        var $target = $(e.target || e.srcElement);
	                        $target.parent().hide();
	                    }).css("margin-left", cfg.margin.left + "px");
	                    if (rootConfig.exchangeMainTickerByLegend) {
	                        this._headerContainer.find(".compare-legend-text").bind("click", function(e) {
	                            var $target = $(e.target || e.srcElement);
	                            view._exchangeMainTicker($target.data("index"));
	                        });
	                    }
	                    this._headerContainer.find(".close-button").bind("click", function(e) {
	                        var $target = $(e.target || e.srcElement);
	                        var index = +$target.data("index");
	                        if (index === 0) {
	                            view._removeMainTicker();
	                        } else {
	                            view._removeCompare(index);
	                        }
	                    });
	                    this._headerContainer.find('.mkts-cmpt-svgcht-currency-text').bind("click", function(e) {
	                        var $target = $(e.target || e.srcElement);
	                        $target.toggleClass('open');
	                        var $dropdownList = $target.parent().find('.mkts-cmpt-currency-dropdown-list');
	                        $dropdownList.toggle();
	                        if ($dropdownList.is(':visible')) {
	                            $dropdownList.find('li').each(function() {
	                                var $this = $(this);
	                                if ($this.attr('data-value') === currency) {
	                                    $this.addClass('active').siblings().removeClass("active");
	                                }
	                            })
	                        }
	                    });
	                    this._headerContainer.find('.mkts-cmpt-currency-dropdown-list li').bind("click", function(e) {
	                        chartConfigManager.setConfig({
	                            baseCurrency: $(this).attr('data-value')
	                        });
	                        $(this).addClass('active').siblings().removeClass("active");
	                        view._chartConfigChanged();
	                    });
	                },
	                _hideCurrencyPopover: function() {
	                    if (!this._headerContainer) {
	                        return;
	                    }
	                    this._headerContainer.find('.mkts-cmpt-svgcht-currency-text').removeClass('open').parent().find('.mkts-cmpt-currency-dropdown-list').hide();
	                },
	                _createSelectionMode: function() {
	                    var selectionMode = this._lastSelectionMode = this.config.selectionMode;
	                    var SelectionModes = chartConfigManager.SelectionModes;
	                    switch (selectionMode) {
	                        case SelectionModes.Pan:
	                            this._createPan();
	                            if (isMobile) {
	                                this._disablePan();
	                                this._disableZoomIn();
	                            }
	                            break;
	                        case SelectionModes.ZoomIn:
	                            this._createZoomIn();
	                            break;
	                    }
	                },
	                _resetZoomIn: function() {
	                    if (this._lastSelectionMode === SelectionModes.ZoomIn && this._beforeZoomInDateRange) {
	                        var dateRange = this._beforeZoomInDateRange.pop();
	                        if (dateRange) {
	                            var data = this._loadedData || this._data;
	                            var startIndex = this._getDataIndexByDate(dateRange[0], null, null, data);
	                            var endIndex = this._getDataIndexByDate(dateRange[1], null, null, data);
	                            var eventTypes = eventManager.EventTypes;
	                            eventManager.trigger([eventTypes.UpdateMenuInterval, eventTypes.ChangeDateRangeByZoom], [dateRange[0], dateRange[1]]);
	                            if (startIndex == null || endIndex == null) {
	                                var newDateRange = dateRange;
	                                chartConfigManager.setConfig({
	                                    dateRange: newDateRange
	                                });
	                                eventManager.trigger(eventTypes.ChangeIntervalFrequency);
	                            } else {
	                                eventManager.trigger(eventTypes.ChangeXAxisDomain, [startIndex, endIndex]);
	                            }
	                        }
	                    }
	                },
	                _enableZoomIn: function() {
	                    this._brushElem && this._brushElem.style("display", "");
	                },
	                _disableZoomIn: function() {
	                    this._brushElem && this._brushElem.style("display", "none");
	                },
	                _createZoomIn: function() {
	                    this._brushElem && this._brushElem.remove();
	                    var cfg = this.config;
	                    var view = this;
	                    this._beforeZoomInDomain = null;
	                    this._zoomInOffset = 0;
	                    var config = {
	                        containerGElem: this._svg,
	                        graphType: graphTypes.Brush,
	                        graphCss: innerClass.brush,
	                        yValue: 0,
	                        height: this._validHeight, //this._validHeight + 7,
	                        insertBeforeCss: null,
	                        brushStartResponseFunc: function(brushFunc) {
	                            var xDomain = view._xScale.domain();
	                            if (xDomain) {
	                                var start = Math.round(xDomain[0]);
	                                var end = Math.round(xDomain[1]);
	                                var dataLength = view._data.length;
	                                if (end >= dataLength) {
	                                    end = dataLength - 1;
	                                }
	                                var beforeRange = view._beforeZoomInDateRange || [];
	                                beforeRange.push([view._data[start].date, view._data[end].date]);
	                                view._beforeZoomInDateRange = beforeRange;
	                            }
	                        },
	                        brushResponseFunc: function() {
	                            view._zooming = true;
	                        },
	                        brushEndResponseFunc: function(brushFunc) {
	                            view._brushEndResponse(brushFunc);
	                            view._zooming = false;
	                        },
	                        setBrushFunc: function(brushFunc) {
	                            view._brushFunc = brushFunc;
	                        }
	                    };
	
	                    this._brushElem = this._commonDraw(config);
	                },
	                _brushEndResponse: function(brushFunc) {
	                    var brushExtentIsEmpty = brushFunc.empty();
	                    var brushDomain = brushExtentIsEmpty ? this._xScale.domain() : brushFunc.extent();
	                    var startIndex = Math.ceil(brushDomain[0]);
	                    var endIndex = Math.floor(brushDomain[1]);
	                    if (endIndex > (this._data.length - 1)) {
	                        endIndex = this._data.length - 1;
	                    }
	
	                    if (startIndex < endIndex) {
	                        var startDate = this._data[startIndex].date;
	                        var endDate = this._data[endIndex].date;
	                        var dateRange = [startDate, endDate];
	                        var eventTypes = eventManager.EventTypes;
	                        eventManager.trigger([eventTypes.UpdateMenuInterval, eventTypes.ChangeDateRangeByZoom], dateRange);
	                        eventManager.trigger(eventTypes.ChangeXAxisDomain, [startIndex, endIndex], dateRange, true); //true is isZoonIn
	                    }
	                    brushFunc.clear();
	                    this._brushElem.call(brushFunc);
	                    this.drawObj && this.drawObj.redraw(this._data);
	
	                    // add callback function before zoomIn
	                    this._zooming && eventManager.trigger(eventTypes.onbeforeZoomIn, {
	                        name: 'zoomIn',
	                        value: {
	                            startDate: moment(startDate).format(rootConfig.intradayDateFormater),
	                            endDate: moment(endDate).format(rootConfig.intradayDateFormater)
	                        }
	                    });
	                },
	                _enablePan: function() {
	                    this._zoomElem && this._zoomElem.style("display", "");
	                },
	                _disablePan: function() {
	                    this._zoomElem && this._zoomElem.style("display", "none");
	                },
	                //this pan support zoom in by mouse wheel
	                _createPan: function() {
	                    this._beforeZoomInDateRange = null;
	                    var cfg = this.config;
	                    var view = this;
	                    var zoomElem = this._svg.select("." + innerClass.zoomDrag);
	                    zoomElem && zoomElem.remove();
	                    var currentCursorType;
	                    var graphConfig = {
	                        view: this,
	                        containerGElem: this._svg,
	                        graphCss: innerClass.zoomDrag,
	                        graphType: graphTypes.ZoomDrag,
	                        insertBeforeCss: null,
	                        margin: cfg.margin,
	                        zoomDragMaskCss: innerClass.zoomDragMask,
	                        width: this._validWidth,
	                        height: this._validHeight,
	                        panStartCallback: function(zoom) {
	                            currentCursorType = rootConfig.cursorType;
	                            view._panStartResponse(zoom);
	                        },
	                        panCallback: function(zoom) {
	                            if (!view._panning) {
	                                eventManager.trigger(eventManager.EventTypes.ToggleCrossharis);
	                                eventManager.trigger(eventManager.EventTypes.ChangeChartCursor, 'off');
	                                view._panning = true;
	                            }
	                            view._panResponse(zoom);
	                        },
	                        panEndCallback: function(zoom) {
	                            view._panning = false;
	                            eventManager.trigger(eventManager.EventTypes.ChangeChartCursor, currentCursorType);
	                            view._panEndResponse(zoom);
	                        }
	                    };
	
	                    if (cfg.yAxis.orient == "left" && cfg.yAxis.position == "outer") {
	                        graphConfig.translateLeft = graphConfig.margin.left + cfg.yAxis.width + cfg.yAxisMargin;
	                    }
	                    this._zoomElem = this._commonDraw(graphConfig);
	                    this._zoomOriData = this._data.slice(); //it will change when create zoom again.
	                },
	                _panStartResponse: function(zoom) {
	                    this._panTranslate = null;
	                },
	                _panEndResponse: function(zoom) {
	                    this._changeViewByPan();
	                },
	                _panResponse: function(zoom) {
	                    var tx = zoom.translate()[0];
	                    var ty = 0;
	                    var domain = this._xScale.domain();
	                    var range = this._xScale.range();
	                    var oriDataLength = this._zoomOriData.length;
	                    var offsetDomain = this._preloadInfo.offsetDomain || 0;
	                    if (domain[1] > (oriDataLength - 1)) {
	                        tx = tx - this._xScale(oriDataLength) + range[1];
	                    } else if (offsetDomain + domain[0] < 0) {
	                        tx = tx - this._xScale(-offsetDomain) + range[0];
	                    }
	
	                    zoom.translate([tx, ty]);
	                    if (this._panResponseCount !== this.config.panResponseSpan && this._loadedData && this._loadedData.length) {
	                        this._panResponseCount++;
	                        this._panTranslate = tx;
	                    } else {
	                        this._panResponseCount = 0;
	                        this._panTranslate = tx;
	                        this._changeViewByPan();
	                        this._panTranslate = null;
	                    }
	                },
	                _changeViewByPan: function() {
	                    var tx = this._panTranslate;
	                    if (!tx) {
	                        return;
	                    }
	                    //Because the this domain not changed as the chart. we need revise it.
	                    var newDomain = this._xScale.domain();
	                    var offsetDomain = this._preloadInfo.offsetDomain || 0;
	                    var revisedStartIndex = offsetDomain + Math.ceil(newDomain[0]);
	                    var revisedEndIndex = offsetDomain + Math.ceil(newDomain[1]);
	                    var data = this._loadedData || this._data;
	                    if (revisedStartIndex < 0) {
	                        revisedStartIndex = 0;
	                    }
	                    if (revisedEndIndex <= revisedStartIndex) {
	                        this._xScale.domain([revisedStartIndex, revisedStartIndex]);
	                    }
	                    this._preloadData(revisedStartIndex, revisedEndIndex, this._data); //Check if need load more date and do it if need.
	                    if (revisedStartIndex <= data.length - 1 && this._loadedData) {
	                        var startDate = data[revisedStartIndex].date; //need to check if need -1
	                        var loadedDataLen = data.length;
	                        var endIndex = revisedEndIndex < loadedDataLen ? revisedEndIndex : loadedDataLen - 1;
	                        var endDate = data[endIndex].date;
	                        var dateRange = [startDate, endDate];
	                        var eventTypes = eventManager.EventTypes;
	                        this._lastDateRange = dateRange;
	                        eventManager.trigger([eventTypes.UpdateMenuInterval, eventTypes.ChangeDateRangeByZoom], dateRange);
	                        eventManager.trigger(eventTypes.ChangeXAxisDomain, [revisedStartIndex, revisedEndIndex], dateRange);
	                    }
	
	                },
	                _drawMainGraph: function() {
	                    var chartType = chartConfigManager.getMainChartType();
	                    var globalClass = this._getGlobalClass(this.mainTickerObject, null, -1);
	                    this["_draw_" + chartType] && this["_draw_" + chartType](chartType, globalClass);
	                    if (chartConfigManager.getMainDataType() === MainDataTypes.DividendEffect) {
	                        this._draw_dividendEffectChart(MainChartTypes.DividendEffectChart, globalClass);
	                    }
	                },
	                _drawEvent: function(eventType, eventData) {
	                    var cfg = this.config;
	                    var chartType = chartConfigManager.getMainChartType();
	                    var eventPropertyName = Object.keys(dataAdapter.Events).filter(function(e) {
	                        return dataAdapter.Events[e] === eventType
	                    })[0];
	                    var eventProperty = cfg.eventProperties[eventPropertyName];
	                    this._normalizeEventsData(eventData.data);
	                    var graphConfig = {
	                        data: eventData.data,
	                        xRadious: cfg.eventProperties.xRadious,
	                        yRadious: cfg.eventProperties.yRadious,
	                        color: eventProperty.color,
	                        downColor: eventProperty.downColor,
	                        innerText: this.langData[eventProperty.text],
	                        y0Value: this._validHeight - cfg.eventProperties.yRadious - 2,
	                        dy: cfg.eventProperties.dy,
	                        textAnchor: cfg.eventProperties.textAnchor,
	                        textColor: cfg.eventProperties.textColor,
	                        graphCss: innerClass.events,
	                        textClass: innerClass.eventsText,
	                        graphType: graphTypes.Event,
	                    };
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	                },
	                _getTagData: function(dataArr, attName) {
	                    var result = [];
	                    for (var len = dataArr.length, i = len - 1; i >= 0; i--) {
	                        if (!isNaN(dataArr[i][attName])) {
	                            break;
	                        }
	                    }
	                    return dataArr.slice(0, ++i);
	                },
	                _setTagUpward: function() {
	                    this._mainTagUpward = false;
	                    if (this._compareData && this._compareData.length > 0 && this._compareData[0].Price.data.length > 0) {
	                        var tagData = this._getTagData(this._data, this.yAttr);
	                        var tickerPrice = tagData[tagData.length - 1] && tagData[tagData.length - 1][this.yAttr];
	                        var yPos = this._yScale(tickerPrice);
	                        var firstCompareTagData = this._getTagData(this._compareData[0].Price.data, this.yAttr);
	                        if (firstCompareTagData.length > 0) {
	                            var firstCompareTickerPrice = firstCompareTagData[firstCompareTagData.length - 1][this.yAttr];
	                            var firstCompareTickerPriceYPos = this._yScale(firstCompareTickerPrice);
	                            if (Math.abs(firstCompareTickerPriceYPos - yPos) < (this.config.tagProperties.tagHeight * 1.5)) {
	                                if (firstCompareTickerPriceYPos < yPos) {
	                                    this._firstCompareTagUpward = true;
	                                } else {
	                                    this._mainTagUpward = true;
	                                    this._firstCompareTagUpward = false;
	                                }
	                            }
	                        } else {
	                            this._firstCompareTagUpward = false;
	                        }
	                    }
	                },
	                _drawMainTag: function(highLight) {
	                    var mainTagClass = 'main-tag' + this._getGlobalClass(this.mainTickerObject, null, -1);
	                    var mainColor = this.config.tagProperties.tagFillColor || (this.mainTickerObject['customTickerColor'] || rootConfig.mainTickerColor);
	                    this._drawTag(this._data, this.yAttr, mainColor, mainTagClass, this._mainTagUpward, highLight);
	                },
	
	                _drawTag: function(dataArr, yAttr, tagColor, tagClass, upward, highLight) {
	                    var tagData = this._getTagData(dataArr, yAttr);
	                    var tagDataLength = tagData.length;
	                    if (tagDataLength > 0) {
	                        var tickerPrice = tagData[tagDataLength - 1][yAttr];
	                        var decimalPlaces = this._decimalPlaces;
	                        if (this.config.dataType === MainDataTypes.Growth10K && rootConfig.growth10KDecimal) {
	                            decimalPlaces = rootConfig.growth10KDecimal;
	                        }
	                        var tagX = tagDataLength - 1,
	                            tagY = tickerPrice,
	                            tagText = util.numberFormatter(this.config.lang, tickerPrice, decimalPlaces, " ", false, true),
	                            rightSpace = dataArr.length - tagDataLength;
	                        if (chartConfigManager.isPercentChart()) {
	                            tagText += '%';
	                        }
	                        var cfg = this.config;
	                        var chartType = chartConfigManager.getMainChartType();
	                        var xPosition = this._xScale(tagX);
	                        var yPosition = this._yScale(tagY);
	                        if (isNaN(xPosition) || isNaN(yPosition)) {
	                            return;
	                        }
	                        var tagClass = innerClass.tagClass + " " + tagClass;
	                        var tagTextClass = innerClass.tagTextClass;
	                        if (cfg.tagProperties.tagMode) {
	                            tagClass = tagClass + ' mkts-components-chart-tag-mode-' + cfg.tagProperties.tagMode;
	                            tagTextClass = tagTextClass + ' ' + tagTextClass + '-mode-' + cfg.tagProperties.tagMode;
	                        }
	                        if (!rootConfig.showTag) {
	                            tagClass = tagClass + ' hide';
	                        }
	                        var graphConfig = {
	                            xPosition: xPosition,
	                            yPosition: yPosition,
	                            tagHeight: cfg.tagProperties.tagHeight,
	                            tagWidth: cfg.tagProperties.tagWidth,
	                            tagText: tagText,
	                            graphCssText: tagTextClass,
	                            graphCss: tagClass,
	                            spaceOnRight: this._xScale(rightSpace),
	                            fillColor: tagColor,
	                            arrowWidth: cfg.tagProperties.arrowWidth,
	                            arrowHeight: cfg.tagProperties.arrowHeight,
	                            sideMargin: cfg.tagProperties.sideMargin,
	                            textTopMargin: cfg.tagProperties.textTopMargin,
	                            tagMode: cfg.tagProperties.tagMode,
	                            graphType: graphTypes.Tag,
	                            height: this._validHeight,
	                            upward: upward,
	                            componentContainer: rootConfig.$componentContainer,
	                            yVerticalMargin: cfg.tagProperties.yVerticalMargin
	                        };
	
	                        if (highLight) {
	                            this._outerGElem.selectAll('.mkts-components-chart-highlight-tag').remove();
	                            graphConfig.containerGElem = this._outerGElem.append('g').attr('class', 'mkts-components-chart-highlight-tag');
	                        }
	                        return this._commonDraw(graphConfig);
	                    }
	                },
	                _draw_lineChart: function(chartType, globalClass, notMain) {
	                    if (this._needAjustLine) {
	                        this._draw_dotChart(MainChartTypes.DotChart, globalClass);
	                    } else {
	                        var graphConfig = {
	                            graphCss: innerClass[chartType] + globalClass + " " + innerClass.chartlines,
	                            graphType: graphTypes.Line
	                        };
	
	                        var mainColor = this.mainTickerObject['customTickerColor'] || rootConfig.mainTickerColor;
	                        !notMain && mainColor && (graphConfig.color = mainColor);
	                        this["_elem_" + chartType] = this._commonDraw(graphConfig);
	
	                        var trackballConfig = {
	                            trackContainer: this._outerGElem,
	                            graphCss: globalClass,
	                            color: graphConfig.color,
	                            trackType: 'circle', //default
	                            data: this._data //default
	                        };
	
	                        this._commonDrawTrackball(trackballConfig);
	                    }
	                },
	                _draw_mountainChart: function(chartType, globalClass) {
	                    var dataType = chartConfigManager.getMainDataType();
	                    var _chartType = chartType;
	                    switch (dataType) { // compatibility old version when chartType is pGrowthChart, TenKGrowthChart, DividendEffectChart and PostTax
	                        case MainDataTypes.Growth:
	                            _chartType = MainChartTypes.pGrowthChart;
	                            break;
	                        case MainDataTypes.Growth10K:
	                            _chartType = MainChartTypes.TenKGrowthChart;
	                            break;
	                        case MainDataTypes.DividendEffect:
	                            _chartType = MainChartTypes.DividendEffectChart;
	                            break;
	                        case MainDataTypes.PostTax:
	                            _chartType = MainChartTypes.PostTaxChart;
	                            break;
	                    }
	                    var cfg = this.config;
	                    var graphConfig = {
	                        graphCss: innerClass[_chartType] + globalClass,
	                        graphType: graphTypes.Area,
	                        y0Value: this._validHeight
	                    };
	                    graphConfig.color = this.mainTickerObject['customTickerColor'] || rootConfig.mainTickerColor;
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	                    this._draw_lineChart(MainChartTypes.LineChart, globalClass);
	                },
	                _draw_dotChart: function(chartType, globalClass) {
	                    var cfg = this.config;
	
	                    var graphConfig = {
	                        graphCss: innerClass[chartType] + globalClass,
	                        graphType: graphTypes.Dot,
	                        dotRadius: cfg.dotChartRadius
	                    };
	
	                    graphConfig.color = this.mainTickerObject['customTickerColor'] || rootConfig.mainTickerColor;
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	
	                    var trackballConfig = {
	                        graphCss: globalClass,
	                        color: graphConfig.color
	                    };
	
	                    this._commonDrawTrackball(trackballConfig);
	                },
	                _draw_abChart: function(chartType, globalClass) {
	                    var cfg = this.config;
	                    var referValue, yAtrr = this.yAttr;
	
	                    if (chartConfigManager.isCompareOrPercentChart()) {
	                        var baseValue = chartConfigManager.getConfig().growthBaseValue;
	                        if (chartConfigManager.getMainDataType() === MainDataTypes.Growth10K || baseValue) {
	                            referValue = baseValue;
	                        } else {
	                            referValue = 0;
	                        }
	                    } else {
	                        referValue = this._lastClosePrice;
	                    }
	                    var graphConfig = {
	                        graphCss: innerClass[chartType] + globalClass + ' ' + innerClass.chartlines,
	                        graphType: graphTypes.AboveBelow,
	                        referValue: referValue,
	                        definedFunc: function(d) {
	                            return !isNaN(d.y);
	                        },
	                        height: this._validHeight,
	                        aboveClipID: cfg.abChartAboveClipID + util.guid(),
	                        belowClipID: cfg.abChartBelowClipID + util.guid(),
	                        aboveAreaCss: innerClass.aboveArea,
	                        belowAreaCss: innerClass.belowArea,
	                        ASColor: cfg.ASColor,
	                        AFColor: cfg.AFColor,
	                        BSColor: cfg.BSColor,
	                        BFColor: cfg.BFColor
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	
	                    var trackballConfig = {
	                        graphCss: globalClass,
	                        color: this.mainTickerObject['customTickerColor'] || rootConfig.mainTickerColor
	                    };
	
	                    this._commonDrawTrackball(trackballConfig);
	                },
	                _draw_ohlcChart: function(chartType, globalClass) {
	                    var cfg = this.config;
	                    var graphConfig = {
	                        graphCss: innerClass[chartType] + globalClass,
	                        graphType: graphTypes.OHLC,
	                        tickSize: cfg.ohlcTickSize
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	                },
	                _draw_candlestickChart: function(chartType, globalClass) {
	                    var cfg = this.config;
	                    var graphConfig = {
	                        graphCss: innerClass[chartType] + globalClass,
	                        graphType: graphTypes.Candlestick,
	                        tickSize: cfg.candlestickTickSize,
	                        decimal: this.config.crossHairDecimal
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	                },
	                _draw_dividendEffectChart: function(chartType, globalClass) {
	                    var cfg = this.config;
	                    if (this._dividendEffectData) {
	                        var dividendGraphConfig = {
	                            data: this._dividendEffectData,
	                            color: cfg.dividendEffectProperties.color,
	                            graphCss: innerClass.dividendEffectCompareChart + globalClass,
	                            yAttributeName: "value",
	                            graphType: graphTypes.Line,
	                        };
	
	                        this["_elem_" + chartType] = this._commonDraw(dividendGraphConfig);
	
	                    }
	                },
	                _draw_volumeByPrice_Indicators: function(data, indicatorName, graphType, chartIndex, globalGraphClass, indicatorData) {
	                    eventManager.bind(eventManager.EventTypes.MouseOutChart, function() {
	                        this._VBPDrawObj && this._VBPDrawObj.hideTipElement();
	                    }, this);
	                    var view = this;
	                    var graphConfig = {
	                        $container: rootConfig.$componentContainer.find('.chart-body'),
	                        data: data,
	                        totalVolume: indicatorData.totalVolume,
	                        graphCss: innerClass.indicators,
	                        yAttributeName: "value",
	                        graphType: graphType,
	                        downColor: "red",
	                        upColor: "green",
	                        width: this._validWidth,
	                        langData: this.langData,
	                        setDrawObj: function(drawObj) {
	                            view._VBPDrawObj = drawObj;
	                        }
	                    };
	
	                    this["_elem_" + graphType] = this._commonDraw(graphConfig);
	                },
	            };
	
	            return util.extendClass(baseChart, mainChartExtend);
	        };
	
	        var innerClass = {
	            chartlines: 'mkts-cmpt-svgcht-chart-lines',
	            lineChart: "chart-line",
	            mountainChart: "chart-mountain",
	            postTaxChart: "chart-postTax",
	            dotChart: "chart-dot",
	            "dotChart-indicators": "dotChart-indicators",
	            abChart: "chart-aboveBelow",
	            aboveArea: "chart-aboveArea",
	            belowArea: "chart-belowArea",
	            ohlcChart: "chart-ohlcChart",
	            hlcChart: "chart-hlcChart",
	            candlestickChart: "chart-candlestick",
	            priceGrowth: "chart-priceGrowth",
	            pGrowthChart: "chart-tenKGrowthChart",
	            performancesGrowth: "chart-performancesGrowth",
	            tenKGrowthChart: "chart-tenKGrowthChart",
	            dividendEffectChart: "chart-dividendEffectChart",
	            dividendEffectCompareChart: "dividendEffectCompareChart",
	            gridLines: "mainChart-gridLines",
	            chartHeader: "mainChart-header",
	            chartBody: "mainChart-body",
	            tickerName: "mainChart-tickerName",
	            tickerNamePriceChange: "mainChart-tickerName-price-change",
	            tickerNameLegend: "mainChart-tickerName-legend",
	            tickerPice: "mainChart-tickerPrice",
	            tickerCurrency: "mainChart-tickerCurrency",
	            mainValue: "mainValue",
	            compareValue: "compareValue-",
	            indicatorsValue: "indicatorsValue-",
	            fundamentalsValue: "fundamentalsValue-",
	            zoomDrag: "mainChart-zoomDrag",
	            zoomDragMask: "mainChart-zoomDragMask",
	            brush: "mainChart-brush",
	            mainSvg: "mainChart-mainSVG",
	            xAxisSvg: "mainChart-xAxisSvg",
	            xAxis: "mainChart-xAxis",
	            yAxis: "mainChart-yAxis",
	            fundamentals: "fundamentals",
	            fundamentalsLegend: "fundamentals-legend",
	            fundamentalsLegendText: "fundamentals-legend-text",
	            indicators: "indicators",
	            indicatorsLegend: "indicators-legend",
	            indicatorsLegendText: "indicators-legend-text",
	            events: "events",
	            eventsText: "events-text",
	            compare: "compare",
	            compareLegend: "compare-legend",
	            compareLegendText: "compare-legend-text",
	            comparePriceChangeText: "compare-price-change-text",
	            upPriceChangeColor: "upPriceChangeColor",
	            downPriceChangeColor: "downPriceChangeColor",
	            zeroPriceChangeColor: 'zeroPriceChangeColor',
	            dividendEffectLegend: "dividend-effect-legend",
	            dividendEffectLegendText: "dividend-effect-legend-text",
	            closeButton: "icon chart close-button",
	            errorMessage: "error-message",
	            errorMessageCloseButton: "icon chart error-message-close-button",
	            tagClass: "tag",
	            tagTextClass: "tag-text",
	            lineLegendClass: "line-legend",
	            lineLegendTextClass: "line-legend-text",
	            tickerInfoContainer: "mainChart-tickerCon"
	        };
	
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core) {
	    var $ = core.$;
	    var d3 = core.d3;
	
	    return function(chartConfigManager, eventManager) {
	        var _id = 0;
	        var _last
	        var target;
	        var width;
	        var height;
	        var drawType;
	        var findByPosition;
	        var xScale;
	        var yScale;
	        var maskElem;
	        var labelBox = {
	            height: 20,
	            width: 80,
	            spaceFromLine: 2,
	            leftMargin: 4,
	            topMargin: 4,
	            closeIconMargin: 4,
	            closeIconWidth: 12,
	            closeIconHeight: 12
	        };
	        var drawing = {
	            'trendline': {
	                'features': {
	                    movingDraw: true,
	                    dbClickDelete: true,
	                    clickReDraw: false,
	                    dragReDraw: true
	                },
	                'count': 0,
	                'depot': {},
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            },
	            'rectangle': {
	                'features': {
	                    movingDraw: true, //support move
	                    clickRedraw: false, //support draw when click event
	                    dragReDraw: true //support drag and draw
	                },
	                'count': 0,
	                'depot': {},
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            },
	            'ellipse': {
	                'features': {
	                    movingDraw: true, //support move
	                    clickRedraw: false, //support draw when click event
	                    dragReDraw: true //support drag and draw
	                },
	                'count': 0,
	                'depot': {},
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            },
	            'levelline': {
	                'features': {
	                    dbClickDeleteLine: true,
	                    movingDraw: true
	                },
	                'count': 0,
	                'depot': {},
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            },
	            'fibonacciretracementlevels': {
	                'features': {
	                    movingDraw: true,
	                    clickRedraw: false,
	                    dragReDraw: true //support drag and draw
	                },
	                'count': 0,
	                'depot': {},
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            },
	            'fibonaccitimezones': {
	                'features': {
	                    movingDraw: true,
	                    clickRedraw: false,
	                    dragReDraw: true //support drag and draw
	                },
	                'color': {
	                    point: '#555555',
	                    mainLine: '#627BA4'
	                },
	                'count': 0,
	                'depot': {},
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            },
	            'fibonaccifans': {
	                'features': {
	                    movingDraw: true,
	                    clickRedraw: false,
	                    dragReDraw: true //support drag and draw
	                },
	                'color': {
	                    point: '#555555',
	                    mainLine: '#627BA4'
	                },
	                'count': 0,
	                'depot': {},
	                'scale': [0.382, 0.5, 0.618],
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            },
	            'fibonacciarcs': {
	                'features': {
	                    movingDraw: true,
	                    clickRedraw: false,
	                    dragReDraw: true //support drag and draw
	                },
	                'count': 0,
	                'depot': {},
	                'scale': [0.382, 0.5, 0.618],
	                'color': {
	                    point: '#555555',
	                    mainLine: '#627BA4'
	                },
	                'move': {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                }
	            }
	        };
	
	        var store = function(dw, id, position, datapoint, dom) {
	            var current = {
	                'start': {
	                    'x': position[0],
	                    'y': position[1],
	                    'datapoint': datapoint
	                },
	                'end': {},
	                'dom': dom,
	                'id': id
	            };
	            dw.depot[id] = current;
	            dw.count++;
	            dw.currentId = id;
	        };
	
	        var storeBeforeDraging = function(current) {
	            current.oldStart = $.extend(true, {}, current.start);
	            current.oldEnd = $.extend(true, {}, current.end);
	        };
	
	        var storeBeforeMoving = function(dw, current, position, datapoint) {
	            storeBeforeDraging(current);
	            dw.move.moving = true;
	            target.style({
	                'cursor': 'move'
	            });
	            dw.move.cp = [position[0], position[1], datapoint];
	            dw.move.sp = [current.start.x, current.start.y, current.start.datapoint];
	            dw.move.ep = [current.end.x, current.end.y, current.end.datapoint];
	        };
	
	        var mouseOverLine = function(position, sePosition) {
	            var spos = sePosition['spos'],
	                epos = sePosition['epos'];
	            var minx = Math.min(spos[0], epos[0]);
	            var maxx = Math.max(spos[0], epos[0]);
	            var miny = Math.min(spos[1], epos[1]);
	            var maxy = Math.max(spos[1], epos[1]);
	            if (!(Math.round(position[0]) > minx - 2 && Math.round(position[0]) < maxx + 2 && Math.round(position[1]) > miny - 2 && Math.round(position[1]) < maxy + 2)) {
	                return false;
	            }
	            k = (epos[1] - spos[1]) / (epos[0] - spos[0]);
	            b = spos[1] - k * spos[0];
	            var r = k * position[0] + b;
	            if (Math.abs(r - position[1]) > 3) {
	                return false;
	            }
	            return true;
	        };
	
	        var exchangeStartEnd = function(current, item) {
	            if (!item) return;
	            var position = item.mPosition;
	            if (current.oldStart) {
	                if (drawing.selectPoint === 'nw') {
	                    current.start = {
	                        'x': position[0],
	                        'y': position[1],
	                        'datapoint': item.datapoint
	                    };
	                } else if (drawing.selectPoint === 'sw') {
	                    current.start = {
	                        'x': position[0],
	                        'y': current.oldStart.y,
	                        'datapoint': item.datapoint
	                    };
	                    current.end = {
	                        'x': current.oldEnd.x,
	                        'y': position[1],
	                        'datapoint': current.oldEnd.datapoint
	                    };
	                } else if (drawing.selectPoint === 'ne') {
	                    current.start = {
	                        'x': current.oldStart.x,
	                        'y': position[1],
	                        'datapoint': current.oldStart.datapoint
	                    };
	                    current.end = {
	                        'x': position[0],
	                        'y': current.oldEnd.y,
	                        'datapoint': item.datapoint
	                    };
	                } else if (drawing.selectPoint === 'n') {
	                    var sx = current.oldStart.x,
	                        sy = position[1],
	                        ex = current.oldEnd.x,
	                        ey = current.oldEnd.y + (current.oldStart.y - sy);
	
	                    if (ey > height) {
	                        sy -= ey - height;
	                        ey = 0;
	                    }
	
	                    current.start = {
	                        'x': sx,
	                        'y': sy,
	                        'datapoint': findByPosition([sx, sy]).datapoint
	                    };
	                    current.end = {
	                        'x': ex,
	                        'y': ey,
	                        'datapoint': findByPosition([ex, ey]).datapoint
	                    };
	                } else if (drawing.selectPoint === 's') {
	                    var ex = current.oldEnd.x,
	                        ey = position[1],
	                        sx = current.oldStart.x,
	                        sy = current.oldStart.y - (ey - current.oldEnd.y);
	
	                    if (sy < 0) {
	                        ey -= -sy;
	                        sy = 0;
	                    }
	
	                    current.start = {
	                        'x': sx,
	                        'y': sy,
	                        'datapoint': findByPosition([sx, sy]).datapoint
	                    };
	                    current.end = {
	                        'x': ex,
	                        'y': ey,
	                        'datapoint': findByPosition([ex, ey]).datapoint
	                    };
	                } else if (drawing.selectPoint === 'w') {
	                    var sx = position[0],
	                        sy = current.oldStart.y,
	                        ex = current.oldEnd.x + (current.oldStart.x - sx),
	                        ey = current.oldEnd.y;
	
	                    if (ex > width) {
	                        sx += ex - width;
	                        ex = width;
	                    }
	
	                    current.start = {
	                        'x': sx,
	                        'y': sy,
	                        'datapoint': findByPosition([sx, sy]).datapoint
	                    };
	                    current.end = {
	                        'x': ex,
	                        'y': ey,
	                        'datapoint': findByPosition([ex, ey]).datapoint
	                    };
	                } else if (drawing.selectPoint === 'e') {
	                    var ex = position[0],
	                        ey = current.oldEnd.y,
	                        sx = current.oldStart.x - (ex - current.oldEnd.x),
	                        sy = current.start.y;
	
	                    if (sx < 0) {
	                        ex -= -sx;
	                        sx = 0;
	                    }
	
	                    current.start = {
	                        'x': sx,
	                        'y': sy,
	                        'datapoint': findByPosition([sx, sy]).datapoint
	                    };
	                    current.end = {
	                        'x': ex,
	                        'y': ey,
	                        'datapoint': findByPosition([ex, ey]).datapoint
	                    };
	                } else {
	                    current.end = {
	                        'x': position[0],
	                        'y': position[1],
	                        'datapoint': item.datapoint
	                    };
	                }
	            } else {
	                current.end = {
	                    'x': position[0],
	                    'y': position[1],
	                    'datapoint': item.datapoint
	                };
	            }
	        };
	
	        var verify = function(range, v) {
	            if (v < range[0]) {
	                v = range[0];
	            } else if (v > range[1]) {
	                v = range[1];
	            }
	            return v;
	        };
	
	        var calculateStartEnd = function(current, item, move, drawType) {
	            if (!item) return;
	            var position = item.mPosition;
	            var moveX = position[0] - move.cp[0],
	                moveY = position[1] - move.cp[1];
	            var sx = move.sp[0],
	                sy = move.sp[1] + moveY,
	                ex = NaN,
	                ey = NaN;
	
	            if (drawType !== 'levelline') {
	                sx = move.sp[0] + moveX;
	                ex = move.ep[0] + moveX;
	                ey = move.ep[1] + moveY;
	            }
	
	            if (sx < 0) {
	                ex += -sx;
	                sx = 0;
	            }
	
	            if (sy < 0) {
	                ey += -sy;
	                sy = 0;
	            }
	
	            if (ex > width) {
	                sx -= ex - width;
	                ex = width;
	            }
	
	            if (ey > height) {
	                sy -= ey - height;
	                ey = height;
	            }
	            //console.log('x=' + sx);
	            //console.log('y=' + sy);
	            var temp = !isNaN(sx) && !isNaN(sy) ? findByPosition([sx, sy], true) : undefined;
	            if (temp) {
	                //console.log("start=" + temp.datapoint['date']);
	                current.start = {
	                    'x': sx,
	                    'y': sy,
	                    'datapoint': temp.datapoint
	                };
	            }
	            temp = !isNaN(ex) && !isNaN(ey) ? findByPosition([ex, ey]) : undefined;
	            if (temp) {
	                current.end = {
	                    'x': ex,
	                    'y': ey,
	                    'datapoint': temp.datapoint
	                };
	            }
	        };
	
	        var findSelectPoint = function(drawType, current, position) {
	            var t = {
	                'spos': [current.start.x, current.start.y],
	                'epos': [current.end.x, current.end.y]
	            };
	            var selectPoint;
	            switch (drawType) {
	                case 'trendline':
	                case 'fibonacciretracementlevels':
	                case 'fibonaccitimezones':
	                case 'fibonaccifans':
	                case 'fibonacciarcs':
	                    if (Math.abs(t.spos[0] - position[0]) < 4 && Math.abs(t.spos[1] - position[1]) < 4) {
	                        selectPoint = 'nw';
	                    } else if (Math.abs(t.epos[0] - position[0]) < 4 && Math.abs(t.epos[1] - position[1]) < 4) {
	                        selectPoint = 'se';
	                    } else {
	                        selectPoint = null;
	                    }
	                    break;
	                case 'rectangle':
	                    if (Math.abs(t.spos[0] - position[0]) < 4 && Math.abs(t.spos[1] - position[1]) < 4) {
	                        selectPoint = 'nw';
	                    } else if (Math.abs(t.epos[0] - position[0]) < 4 && Math.abs(t.epos[1] - position[1]) < 4) {
	                        selectPoint = 'se';
	                    } else if (Math.abs(t.epos[0] - position[0]) < 4 && Math.abs(t.spos[1] - position[1]) < 4) {
	                        selectPoint = 'ne';
	                    } else if (Math.abs(t.spos[0] - position[0]) < 4 && Math.abs(t.epos[1] - position[1]) < 4) {
	                        selectPoint = 'sw';
	                    } else {
	                        selectPoint = null;
	                    }
	                    break;
	                case 'ellipse':
	                    var rx = Math.abs(t.epos[0] - t.spos[0]) / 2;
	                    var ry = Math.abs(t.epos[1] - t.spos[1]) / 2;
	                    var cx = rx + Math.min(t.spos[0], t.epos[0]);
	                    var cy = ry + Math.min(t.spos[1], t.epos[1]);
	                    if (Math.abs(cx - position[0]) < 4 && Math.abs(cy - ry - position[1]) < 4) {
	                        selectPoint = 'n';
	                    } else if (Math.abs(cx + rx - position[0]) < 4 && Math.abs(cy - position[1]) < 4) {
	                        selectPoint = 'e';
	                    } else if (Math.abs(cx - position[0]) < 4 && Math.abs(cy + ry - position[1]) < 4) {
	                        selectPoint = 's';
	                    } else if (Math.abs(cx - rx - position[0]) < 4 && Math.abs(cy - position[1]) < 4) {
	                        selectPoint = 'w';
	                    } else {
	                        selectPoint = null;
	                    }
	                    break;
	            }
	            return selectPoint;
	        };
	
	        var isChooseDrawings = function(drawType, current, position) {
	            var t = {
	                'spos': [current.start.x, current.start.y],
	                'epos': [current.end.x, current.end.y]
	            };
	            var isChoose = false;
	            switch (drawType) {
	                case 'trendline':
	                    isChoose = mouseOverLine(position, t);
	                    break;
	                case 'rectangle':
	                case 'ellipse':
	                    isChoose = position[0] > (t.spos[0] - 3) && position[0] < (t.epos[0] + 3) && position[1] > (t.spos[1] - 3) && position[1] < (t.epos[1] + 3);
	                    break;
	                case 'levelline':
	                    isChoose = Math.abs(position[1] - t.spos[1]) < 4;
	                    break;
	                case 'fibonacciretracementlevels':
	                    var _height = Math.abs(t.epos[1] - t.spos[1]);
	                    var c2 = {
	                            spos: [t.spos[0], t.epos[1]],
	                            epos: [t.epos[0], t.epos[1]]
	                        },
	                        c3 = {
	                            spos: [t.spos[0], t.spos[1]],
	                            epos: [t.epos[0], t.spos[1]]
	                        },
	                        c4 = {
	                            spos: [t.spos[0], t.epos[1] - _height * 0.618],
	                            epos: [t.epos[0], t.epos[1] - _height * 0.618]
	                        },
	                        c5 = {
	                            spos: [t.spos[0], t.epos[1] - _height * 0.5],
	                            epos: [t.epos[0], t.epos[1] - _height * 0.5]
	                        },
	                        c6 = {
	                            spos: [t.spos[0], t.epos[1] - _height * 0.382],
	                            epos: [t.epos[0], t.epos[1] - _height * 0.382]
	                        };
	                    isChoose = mouseOverLine(position, t) || mouseOverLine(position, c2) ||
	                        mouseOverLine(position, c3) ||
	                        mouseOverLine(position, c4) ||
	                        mouseOverLine(position, c5) ||
	                        mouseOverLine(position, c6);
	
	                    break;
	                case 'fibonaccitimezones':
	                    var timezoneLines = getFibonacciTimeZoneX(t.spos[0], t.epos[0], width);
	                    var linePostions = [t, {
	                            spos: [t.spos[0], 0],
	                            epos: [t.spos[0], height]
	                        },
	                        {
	                            spos: [t.epos[0], 0],
	                            epos: [t.epos[0], height]
	                        }
	                    ];
	                    timezoneLines.forEach(function(line) {
	                        linePostions.push({
	                            spos: [line.x, 0],
	                            epos: [line.x, height]
	                        });
	                    });
	                    for (var i = 0; i < linePostions.length; i++) {
	                        isChoose = mouseOverLine(position, linePostions[i]);
	                        if (isChoose) {
	                            break;
	                        }
	                    }
	                    break;
	                case 'fibonaccifans':
	                    var scales = drawing['fibonaccifans'].scale;
	                    var fflines = [t];
	                    var slope = (t.epos[1] - t.spos[1]) / (t.epos[0] - t.spos[0]);
	                    scales.forEach(function(_s) {
	                        var pos = [getFanLineExtendX(slope, _s, width, height, t.spos[0], t.epos[0], t.spos[1], t.epos[1]), getFanLineExtendY(slope, _s, width, height, t.spos[0], t.epos[0], t.spos[1], t.epos[1])];
	                        fflines.push({
	                            spos: t.spos,
	                            epos: pos
	                        });
	                    });
	                    for (var i = 0; i < fflines.length; i++) {
	                        isChoose = mouseOverLine(position, fflines[i]);
	                        if (isChoose) {
	                            break;
	                        }
	                    }
	                    break;
	                case 'fibonacciarcs':
	                    var scales = drawing['fibonacciarcs'].scale;
	                    isChoose = mouseOverLine(position, t);
	                    if (!isChoose) {
	                        var x1 = t.spos[0],
	                            y1 = t.spos[1],
	                            x2 = t.epos[0],
	                            y2 = t.epos[1];
	                        var updown = (y2 >= y1) ? 'up' : 'down';
	                        var radius = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	                        for (var s = 0; s < scales.length; s++) {
	                            var r = radius * scales[s];
	                            var distance = Math.sqrt(Math.pow(position[0] - x2, 2) + Math.pow(position[1] - y2, 2));
	                            if (updown === 'up') {
	                                isChoose = position[1] <= y2 && Math.abs(distance - r) < 3;
	                            } else {
	                                isChoose = position[1] >= y2 && Math.abs(distance - r) < 3;
	                            }
	                            if (isChoose) {
	                                break;
	                            }
	                        }
	                    }
	                    break;
	            }
	            return isChoose;
	        };
	
	        var isChooseDrawingsForClose = function(drawType, current, position) {
	            var t = {
	                'spos': [current.start.x, current.start.y],
	                'epos': [current.end.x, current.end.y]
	            };
	            var isChoose = false;
	            switch (drawType) {
	                case 'trendline':
	                    isChoose = (t.epos[0] + labelBox.width - labelBox.closeIconWidth < position[0]) && (position[0] < t.epos[0] + labelBox.width) &&
	                        (t.epos[1] - labelBox.height < position[1]) && (position[1] < t.epos[1]);
	                    break;
	                case 'rectangle':
	                    break;
	                case 'ellipse':
	                    isChoose = position[0] > (t.spos[0] - 3) && position[0] < (t.epos[0] + 3) && position[1] > (t.spos[1] - 3) && position[1] < (t.epos[1] + 3);
	                    break;
	                case 'levelline':
	                    isChoose = (width - labelBox.leftMargin - labelBox.closeIconWidth - labelBox.closeIconMargin < position[0]) &&
	                        (position[0] < width - labelBox.leftMargin - labelBox.closeIconMargin) &&
	                        (t.spos[1] - labelBox.height / 2 < position[1]) && (position[1] < t.spos[1] + labelBox.height / 2);
	                    break;
	                case 'fibonacciretracementlevels':
	                    isChoose = (t.epos[0] < position[0]) && (position[0] < t.epos[0] + 15) && (t.spos[1] < position[1]) && (position[1] < t.spos[1] + 15);
	                    break;
	                case 'fibonaccitimezones':
	                    isChoose = current.closex < position[0] && (position[0] < current.closex + 15) && (position[1] < 15);
	                    break;
	                case 'fibonaccifans':
	                    isChoose = current.closex < position[0] && (position[0] < current.closex + 15) && Math.abs(t.epos[1] - position[1]) < 10;
	                    break;
	                case 'fibonacciarcs':
	                    var matchedX = current.closex < position[0] && (current.closex + 15 > position[0]);
	                    isChoose = matchedX && (Math.abs(t.epos[1] - position[1]) < 10);
	                    break;
	            }
	            return isChoose;
	        };
	
	        var removeDrawings = function(drawTypes, drawIds) {
	            var removeDrawings;
	            if(typeof drawTypes === 'string'){
	                drawTypes = [drawTypes];
	            }
	            if(typeof drawIds=== 'string'){
	                drawIds = [drawIds];
	            }
	            drawTypes.forEach(function(drawType, index){
	                var dw = drawType && drawing[drawType] ? drawing[drawType] : {};
	                var drawId = drawIds[index];
	                var current = dw.depot[drawId];
	                if (!current) return;
	                //remove close buttom and legend dom
	                if (chartConfigManager.getConfig().saveDrawings && $.isNumeric(current.id)) {
	                    if (!removeDrawings) {
	                        removeDrawings = {
	                            type: [],
	                            point: []
	                        };
	                    }
	                    var drawings = getDrawingsData(current);
	                    removeDrawings.type.push(drawType);
	                    removeDrawings.point.push(drawings.point);
	                }
	                //remove drawing dom
	                var drawEl = findDrawingDom(drawType, drawId);
	                drawEl && drawEl.remove();
	                //remove drawing data
	                dw.depot[drawId] = null;
	                delete dw.depot[drawId];
	                dw.count--;
	            });
	          
	            if (removeDrawings) {
	                eventManager.trigger(eventManager.EventTypes.RemoveDrawing, removeDrawings);
	            }
	        };
	        _removeAllDrawings = function() {
	            var drawTypes=[], drawIds=[];
	            for (var drawType in drawing) {
	                var depot = drawing[drawType] && drawing[drawType].depot;
	                if (!depot) {
	                    continue;
	                }
	                for (var _d in depot) {
	                    drawTypes.push(drawType);
	                    drawIds.push(_d);
	                }
	            }
	            removeDrawings(drawTypes, drawIds);
	        };
	        getDrawingsData = function(currentDraw) {
	            var decimal = chartConfigManager.getConfig().charts.mainChart.drawingsDecimal;
	            var point = {};
	            point.id = currentDraw.id;
	            if (currentDraw && currentDraw.start && currentDraw.end) {
	                ['start', 'end', 'oldStart', 'oldEnd'].forEach(function(type) {
	                    point[type] = {};
	                    if (currentDraw[type] && currentDraw[type].datapoint) {
	                        point[type].dIdx = currentDraw[type].datapoint.date.getTime()
	                    }
	                    if (currentDraw[type]) {
	                        point[type].y = +currentDraw[type].yValue;
	                    }
	                });
	            }
	            return {
	                type: drawType,
	                point: point
	            };
	        }
	        var setDrawingsId = function(status, data) {
	            if (status) {
	                for (var id in data) {
	                    var originalId = data[id].id;
	                    var _drawType = data[id].drawType;
	                    if (drawing[_drawType].depot[originalId]) {
	                        drawing[_drawType].depot[originalId].id = id;
	                    }
	                }
	            }
	        };
	        var validDrawing = function(drawType, current) {
	            var flag = false;
	            var diffX = Math.abs(current.end.x - current.start.x),
	                diffY = Math.abs(current.end.y - current.start.y),
	                minDistance = 3;
	            if (drawType === 'trendline') {
	                flag = diffX <= minDistance && diffY <= minDistance;
	            } else if (drawType === 'fibonaccitimezones') {
	                flag = diffX <= minDistance;
	            } else if (drawType === 'fibonacciarcs') {
	                flag = diffY <= minDistance && diffX <= minDistance;
	            } else {
	                flag = diffX <= minDistance || diffY <= minDistance;
	            }
	            return flag;
	        };
	
	        var genDrawingId = function() {
	            _id++;
	            return 'drawId_' + _id;
	        };
	
	        var findDrawingDom = function(drawType, drawId) {
	            var array = target.selectAll('.' + drawType);
	            array = array.length > 0 ? array[0] : [];
	            for (var i = 0, l = array.length; i < l; i++) {
	                var dom = d3.select(array[i]);
	                if (dom.length > 0 && dom.attr('drawId') == drawId) {
	                    return dom;
	                }
	            }
	            return null;
	        };
	
	        var getFibonacciTimeZoneX = function(startX, endX, width) {
	            var scan = endX - startX;
	            var diff = Math.abs(scan);
	            var xs = [{
	                n: 0,
	                x: startX
	            }, {
	                n: 1,
	                x: endX
	            }];
	            if (diff > 0) {
	                var first = 0,
	                    second = 1,
	                    next = 0,
	                    sum = 0;
	                while (true) {
	                    if (scan > 0) { //draw right
	                        next = first + second;
	                        sum += next
	                        if (endX + sum * diff > width) {
	                            break;
	                        }
	                        first = second;
	                        second = next;
	                        xs.push({
	                            n: next,
	                            x: endX + sum * diff
	                        });
	                    } else {
	                        next = first + second;
	                        sum += next;
	                        if (endX - sum * diff < 0) {
	                            break;
	                        }
	                        first = second;
	                        second = next;
	                        xs.push({
	                            n: next,
	                            x: endX - sum * diff
	                        });
	                    }
	                }
	            }
	            return xs;
	        };
	
	        var getFanLineExtendX = function(slope, scale, width, height, x1, x2, y1, y2) {
	            var sl = slope * (1 - scale);
	            if (x1 < x2) {
	                if (y2 > y1) {
	                    return Math.min((height - y1) / sl + x1, width);
	                } else {
	                    return Math.min(-y1 / sl + x1, width);
	                }
	            } else {
	                if (y2 > y1) {
	                    return Math.max((height - y1) / sl + x1, 0);
	                } else {
	                    return Math.max(-y1 / sl + x1, 0);
	                }
	            }
	        };
	        var getFanLineExtendY = function(slope, scale, width, height, x1, x2, y1, y2) {
	            var sl = slope * (1 - scale);
	            if (y2 > y1) {
	                if (x1 < x2) {
	                    return Math.min(sl * (width - x1) + y1, height);
	                } else {
	                    return Math.min(sl * (-x1) + y1, height);
	                }
	            } else {
	                if (x1 < x2) {
	                    return Math.max(sl * (width - x1) + y1, 0);
	                } else {
	                    return Math.max(sl * (-x1) + y1, 0);
	                }
	            }
	        };
	        var validSaveRecord = function(draw) {
	            if (draw.drawType) {
	                var validStart = draw.start && draw.start.dIdx && draw.start.y;
	                if (draw.drawType !== 'levelLine') {
	                    return validStart && draw.end && draw.end.dIdx && draw.end.y;
	                } else {
	                    return validStart;
	                }
	            }
	            return false;
	        }
	        eventManager.bind(eventManager.EventTypes.RemoveAllDrawings, _removeAllDrawings);
	        var drawings = function() {};
	        drawings.target = function(value) {
	            if (!arguments.length) {
	                return target;
	            }
	            target = value;
	            maskElem = target.attr('class', 'drawings').append('rect').attr('class', 'mask');
	            return drawings;
	        };
	        drawings.width = function(value) {
	            if (!arguments.length) {
	                return width;
	            }
	            width = value;
	            !maskElem.empty() && maskElem.attr('width', width)
	            return drawings;
	        };
	        drawings.height = function(value) {
	            if (!arguments.length) {
	                return height;
	            }
	            height = value;
	            !maskElem.empty() && maskElem.attr('height', height);
	            return drawings;
	        };
	        drawings.drawType = function(value) {
	            if (!arguments.length) {
	                return drawType;
	            }
	            drawType = value;
	            return drawings;
	        };
	        drawings.findByPosition = function(value) {
	            if (!arguments.length) {
	                return findByPosition;
	            }
	            findByPosition = value;
	            return drawings;
	        };
	        drawings.xScale = function(value) {
	            if (!arguments.length) {
	                return xScale;
	            }
	            xScale = value;
	            return drawings;
	        };
	        drawings.yScale = function(value) {
	            if (!arguments.length) {
	                return yScale;
	            }
	            yScale = value;
	            return drawings;
	        };
	        drawings.isEnter = function(position) {
	            var isChoose = false;
	            var temp;
	            for (var t in drawing) {
	                var dw = drawing[t];
	                if (!dw || !dw.features) continue;
	                if (!isChoose && (dw.features.movingDraw || dw.features.dragReDraw)) {
	                    for (var id in dw.depot) {
	                        if (!dw.depot.hasOwnProperty(id)) continue;
	                        temp = dw.depot[id];
	                        isChoose = isChooseDrawings(t, temp, position);
	                        if (isChoose) break;
	                    }
	                }
	                if (isChoose) break;
	            }
	            return isChoose;
	        };
	        drawings.isCloseButton = function(position) {
	            var isChoose = false;
	            var temp;
	            for (var t in drawing) {
	                var dw = drawing[t];
	                if (!dw || !dw.features) continue;
	                if (!isChoose && (dw.features.movingDraw || dw.features.dragReDraw)) {
	                    for (var id in dw.depot) {
	                        if (!dw.depot.hasOwnProperty(id)) continue;
	                        temp = dw.depot[id];
	                        isChoose = isChooseDrawingsForClose(t, temp, position);
	                        if (isChoose) break;
	                    }
	                }
	                if (isChoose) break;
	            }
	            return isChoose;
	        };
	        drawings.start = function(item, callback, id) {
	            var position = item.mPosition;
	            var datapoint = item.datapoint;
	            var decimal = chartConfigManager.getConfig().charts.mainChart.drawingsDecimal;
	            var closeImage = chartConfigManager.getConfig().StaticFilesPath + "morningstar/images/close-button.svg";
	            var dw = drawType ? drawing[drawType] : null;
	            if (dw) {
	                var _id;
	                if (id) {
	                    _id = id;
	                } else {
	                    _id = genDrawingId();
	                    store(dw, _id, position, datapoint);
	                }
	                switch (drawType) {
	                    case 'trendline':
	                        var g = target.append('g').attr('class', 'trendline').attr('drawId', _id);
	                        g.append('line').attr('class', 'tl-line');
	                        g.append('rect').attr('class', 'tl-text-rect').attr('fill', '#dedede').attr('stroke', '#dedede');
	                        g.append('text').attr('class', 'tl-text');
	                        g.append("image")
	                            .attr('class', 'close-trendline')
	                            .attr({
	                                "width": 12,
	                                "height": 12,
	                                "xlink:href": function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('trendline', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('trendline', _id);
	                            });
	                        break;
	                    case 'rectangle':
	                        var g = target.append('g').attr('class', 'rectangle').attr('drawId', _id);
	                        g.append('rect').attr('class', 'r-rectangle');
	                        g.append("image")
	                            .attr('class', 'close-rectangle')
	                            .attr({
	                                "width": 12,
	                                "height": 12,
	                                "xlink:href": function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('rectangle', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('rectangle', _id);
	                            });
	                        break;
	                    case 'ellipse':
	                        var g = target.append('g').attr('class', 'ellipse').attr('drawId', _id);
	                        g.append('ellipse').attr('class', 'e-ellipse');
	                        g.append("image")
	                            .attr('class', 'close-ellispe')
	                            .attr({
	                                "width": 12,
	                                "height": 12,
	                                "xlink:href": function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('ellipse', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('ellipse', _id);
	                            });
	                        break;
	                    case 'levelline':
	                        var start = dw.depot[_id].start;
	                        var g = target.append('g').attr('class', 'levelline').attr('drawId', _id);
	                        start.yValue = yScale.invert(start.y);
	                        g.append('line').attr('class', 'll-line')
	                            .attr('x1', 0)
	                            .attr('y1', start.y)
	                            .attr('x2', width)
	                            .attr('y2', start.y);
	                        g.append('rect').attr('class', 'll-text-rect').attr('fill', '#dedede').attr('stroke', '#dedede')
	                            .attr({
	                                'x': width - labelBox.width - labelBox.leftMargin,
	                                'y': start.y - labelBox.height / 2,
	                                'width': labelBox.width,
	                                'height': labelBox.height
	                            });
	
	                        g.append('text').attr('class', 'll-text')
	                            .attr({
	                                'x': width - labelBox.width + labelBox.leftMargin,
	                                'y': start.y + labelBox.height / 2 - labelBox.topMargin
	                            }).text(start.yValue.toFixed(decimal));
	
	                        g.append("image")
	                            .attr('class', 'close-levelline')
	                            .attr({
	                                'x': width - labelBox.leftMargin - labelBox.closeIconWidth - labelBox.closeIconMargin,
	                                'y': start.y - labelBox.height / 2 + labelBox.closeIconMargin
	                            })
	                            .attr({
	                                "width": 12,
	                                "height": 12,
	                                "xlink:href": function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('levelline', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('levelline', _id);
	                            });
	
	                        break;
	                    case 'fibonacciretracementlevels':
	                        var g = target.append('g').attr('class', 'fibonacciretracementlevels').attr('drawId', _id);
	                        g.append('line').attr('class', 'l-100').attr("stroke-width", 2);
	                        g.append('circle').attr('class', 'l-100-tip');
	                        g.append('text').attr('class', 'l-100-left-text').text('100.00%');
	                        g.append('text').attr('class', 'l-100-right-text');
	                        g.append('line').attr('class', 'l-618');
	                        g.append('text').attr('class', 'l-618-left-text').text('61.80%');
	                        g.append('text').attr('class', 'l-618-right-text');
	                        g.append('line').attr('class', 'l-50');
	                        g.append('text').attr('class', 'l-50-left-text').text('50.00%');
	                        g.append('text').attr('class', 'l-50-right-text');
	                        g.append('line').attr('class', 'l-382');
	                        g.append('line').attr('class', 'l-0').attr("stroke-width", 2);
	                        //g.append('line').attr('class', 'l-se');
	                        g.append('text').attr('class', 'l-382-left-text').text('38.20%');
	                        g.append('text').attr('class', 'l-382-right-text');
	                        g.append('text').attr('class', 'l-0-left-text').text('0.00%');
	                        g.append('text').attr('class', 'l-0-right-text');
	                        g.append('circle').attr('class', 'l-0-tip');
	                        g.append('line').attr('class', 'l-100-0');
	
	                        g.append("image")
	                            .attr('class', 'close-drawing')
	                            .attr({
	                                "width": 12,
	                                "height": 12,
	                                "xlink:href": function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('fibonacciretracementlevels', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('fibonacciretracementlevels', _id);
	                            });
	                        break;
	                    case 'fibonaccitimezones':
	                        var g = target.append('g').attr('class', 'fibonaccitimezones').attr('drawId', _id);
	                        g.append('line').attr('class', 'ftz-0-1').style({
	                            stroke: dw.color.mainLine
	                        });
	                        g.append('circle').attr('class', 'ftz-0-c').style({
	                            stroke: dw.color.point
	                        });
	                        g.append('circle').attr('class', 'ftz-1-c').style({
	                            stroke: dw.color.point
	                        });
	                        g.append("image")
	                            .attr('class', 'close-drawing')
	                            .attr({
	                                "width": 12,
	                                "height": 12,
	                                "xlink:href": function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('fibonaccitimezones', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('fibonaccitimezones', _id);
	                            });
	                        break;
	                    case 'fibonaccifans':
	                        var g = target.append('g').attr('class', 'fibonaccifans').attr('drawId', _id);
	                        g.append('line').attr('class', 'ffs-0-1').style({
	                            stroke: dw.color.mainLine
	                        });
	                        g.append('circle').attr('class', 'ffs-0-c').style({
	                            stroke: dw.color.point
	                        });
	                        g.append('circle').attr('class', 'ffs-1-c').style({
	                            stroke: dw.color.point
	                        });
	                        g.append("image")
	                            .attr('class', 'close-drawing')
	                            .attr({
	                                "width": 12,
	                                "height": 12,
	                                "xlink:href": function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('fibonaccifans', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('fibonaccifans', _id);
	                            });
	                        break;
	                    case 'fibonacciarcs':
	                        var g = target.append('g').attr('class', 'fibonacciarcs').attr('drawId', _id);
	                        g.append('line').attr('class', 'farcs-0-1').style({
	                            stroke: dw.color.mainLine
	                        });
	                        g.append('circle').attr('class', 'farcs-0-c').style({
	                            stroke: dw.color.point
	                        });
	                        g.append('circle').attr('class', 'farcs-1-c').style({
	                            stroke: dw.color.point
	                        });
	                        if (g.selectAll('clipPath')[0].length === 0) {
	                            g.append('clipPath').attr({
	                                id: 'mkt-markets-farc-clip'
	                            }).append('rect').attr({
	                                x: 0,
	                                y: 0,
	                                width: width,
	                                height: height
	                            });
	                        }
	
	                        g.append('image')
	                            .attr('class', 'close-drawing')
	                            .attr({
	                                'width': 12,
	                                'height': 12,
	                                'xlink:href': function(d, i) {
	                                    return closeImage;
	                                }
	                            }).on('mousedown.drawings', function() {
	                                d3.event.stopPropagation();
	                            }).on('click.drawings', function() {
	                                removeDrawings('fibonacciarcs', _id);
	                            }).on('touchstart.drawings', function() {
	                                removeDrawings('fibonacciarcs', _id);
	                            });
	                        break;
	                }
	
	            } else {
	                var isChoose = false;
	                var selectPoint;
	                var temp;
	                //trendline
	                for (var t in drawing) {
	                    var dw = drawing[t];
	                    if (!dw || !dw.features) continue;
	                    if (!isChoose && (dw.features.movingDraw || dw.features.dragReDraw)) {
	                        for (var id in dw.depot) {
	                            if (!dw.depot.hasOwnProperty(id)) continue;
	                            temp = dw.depot[id];
	                            selectPoint = findSelectPoint(t, temp, position);
	                            if (dw.features.dragReDraw && selectPoint) { //drag the start or end point
	                                target.style({
	                                    'cursor': selectPoint + '-resize'
	                                });
	                                storeBeforeDraging(temp);
	                                isChoose = true;
	                            } else { //move 
	                                isChoose = isChooseDrawings(t, temp, position);
	                                if (isChoose) {
	                                    storeBeforeMoving(dw, temp, position, datapoint);
	                                }
	                            }
	                            if (isChoose) {
	                                drawType = t;
	                                dw.currentId = id;
	                                break;
	                            }
	                        }
	                    }
	                    if (isChoose) {
	                        if (typeof callback === 'function') {
	                            callback(drawType);
	                        }
	                        break;
	                    }
	                }
	
	                drawing.selectPoint = selectPoint;
	            }
	        };
	        drawings.move = function(item) {
	            var dw = drawType ? drawing[drawType] : null;
	            var decimals = chartConfigManager.getConfig().charts.mainChart.drawingsDecimal;
	            if (dw) {
	                var _id = dw.currentId;
	                var _drawEle = findDrawingDom(drawType, _id);
	                if (!_drawEle) return;
	                var end;
	                var current = dw.depot[_id];
	                var move = dw.move;
	                if (move.moving) {
	                    calculateStartEnd(current, item, move, drawType);
	                } else {
	                    exchangeStartEnd(current, item);
	                }
	                current.start.yValue = yScale.invert(current.start.y);
	                current.end.yValue = yScale.invert(current.end.y);
	                var start = current.start;
	                var end = current.end;
	                switch (drawType) {
	                    case 'trendline':
	                        _drawEle.select('.tl-line').attr('x1', start.x)
	                            .attr('y1', start.y)
	                            .attr('x2', end.x)
	                            .attr('y2', end.y);
	                        _drawEle.select('.tl-text').attr({
	                            'x': end.x + labelBox.leftMargin + labelBox.spaceFromLine,
	                            'y': end.y - labelBox.leftMargin
	                        }).text((((current.end.yValue - current.start.yValue) / current.start.yValue) * 100).toFixed(2) + '%');
	                        _drawEle.select('.tl-text-rect').attr({
	                            'x': end.x + labelBox.spaceFromLine,
	                            'y': end.y - labelBox.height,
	                            'width': labelBox.width,
	                            'height': labelBox.height
	                        });
	                        _drawEle.select('.close-trendline').attr({
	                            'x': end.x + labelBox.width - (labelBox.closeIconWidth + labelBox.closeIconMargin),
	                            'y': end.y - (labelBox.height - labelBox.closeIconMargin)
	                        });
	                        break;
	                    case 'rectangle':
	                        var x = Math.min(end.x, start.x);
	                        var y = Math.min(end.y, start.y);
	                        var _width = Math.abs(end.x - start.x);
	                        var _height = Math.abs(end.y - start.y);
	                        _drawEle.select('.r-rectangle').attr('x', x)
	                            .attr('y', y)
	                            .attr('width', _width)
	                            .attr('height', _height)
	                        _drawEle.select('.close-rectangle').attr({
	                            'x': x + _width - labelBox.closeIconWidth,
	                            'y': y
	                        });
	                        break;
	                    case 'ellipse':
	                        var rx = Math.abs(end.x - start.x) / 2;
	                        var ry = Math.abs(end.y - start.y) / 2;
	                        var cx = rx + Math.min(end.x, start.x);
	                        var cy = ry + Math.min(end.y, start.y);
	                        _drawEle.select('.e-ellipse').attr('cx', cx)
	                            .attr('cy', cy)
	                            .attr('rx', rx)
	                            .attr('ry', ry);
	                        _drawEle.select('.close-ellispe').attr({
	                            'x': cx + rx - labelBox.closeIconWidth,
	                            'y': cy - labelBox.closeIconHeight / 2
	                        });
	                        break;
	                    case 'levelline':
	                        _drawEle.select('.ll-line').attr('x1', 0)
	                            .attr('y1', start.y)
	                            .attr('x2', width)
	                            .attr('y2', start.y);
	                        _drawEle.select('.ll-text-rect').attr({
	                            'x': width - labelBox.width - labelBox.leftMargin,
	                            'y': start.y - labelBox.height / 2,
	                            'width': labelBox.width,
	                            'height': labelBox.height
	                        });
	                        _drawEle.select('.ll-text').attr({
	                            'x': width - labelBox.width + labelBox.leftMargin,
	                            'y': start.y + labelBox.height / 2 - labelBox.topMargin
	                        }).text(start.yValue.toFixed(decimals));
	
	                        _drawEle.select('.close-levelline').attr({
	                            'x': width - labelBox.leftMargin - labelBox.closeIconWidth - labelBox.closeIconMargin,
	                            'y': start.y - labelBox.height / 2 + labelBox.closeIconMargin
	                        });
	                        break;
	                    case 'fibonacciretracementlevels':
	                        var _height = Math.abs(end.y - start.y);
	                        var x1 = Math.min(end.x, start.x);
	                        var y1 = Math.min(end.y, start.y);
	                        var x2 = Math.max(end.x, start.x);
	                        var y2 = Math.max(end.y, start.y);
	                        /*_drawEle.select('.l-se').attr({
	                            'x1': x1,
	                            'y1': y1,
	                            'x2': x2,
	                            'y2': y2
	                        });*/
	                        _drawEle.select('.l-0').attr({
	                            'x1': x1,
	                            'y1': y2,
	                            'x2': x2,
	                            'y2': y2
	                        });
	                        _drawEle.select('.l-0-tip').attr({
	                            'cx': x2,
	                            'cy': y2,
	                            'r': 2
	                        });
	                        _drawEle.select('.l-0-left-text').attr({
	                            'x': x1,
	                            'y': y2 - 10
	                        });
	                        _drawEle.select('.l-0-right-text').attr({
	                            'x': x2 - 45,
	                            'y': y2 - 10
	                        }).text(current.end.yValue.toFixed(decimals));
	
	                        _drawEle.select('.l-100-left-text').attr({
	                            'x': x1,
	                            'y': y1 + 20
	                        });
	                        _drawEle.select('.l-100-tip').attr({
	                            'cx': x1,
	                            'cy': y1,
	                            'r': 2
	                        });
	                        _drawEle.select('.l-100-right-text').attr({
	                            'x': x2 - 45,
	                            'y': y1 + 20
	                        }).text(current.start.yValue.toFixed(decimals));
	                        _drawEle.select('.l-100').attr({
	                            'x1': x1,
	                            'y1': y1,
	                            'x2': x2,
	                            'y2': y1
	                        });
	                        _drawEle.select('.l-100-0').attr({
	                            'x1': x1,
	                            'y1': y1,
	                            'x2': x2,
	                            'y2': y2
	                        });
	
	
	                        _drawEle.select('.l-618').attr({
	                            'x1': x1,
	                            'y1': y2 - _height * 0.618,
	                            'x2': x2,
	                            'y2': y2 - _height * 0.618
	                        });
	                        _drawEle.select('.l-618-left-text').attr({
	                            'x': x1,
	                            'y': y2 - _height * 0.618 + 20
	                        });
	                        _drawEle.select('.l-618-right-text').attr({
	                            'x': x2 - 45,
	                            'y': y2 - _height * 0.618 + 20
	                        }).text((current.end.yValue - (current.end.yValue - current.start.yValue) * 0.618).toFixed(decimals));
	
	
	                        _drawEle.select('.l-50').attr({
	                            'x1': x1,
	                            'y1': y2 - _height * 0.5,
	                            'x2': x2,
	                            'y2': y2 - _height * 0.5
	                        });
	                        _drawEle.select('.l-50-left-text').attr({
	                            'x': x1,
	                            'y': y2 - _height * 0.5 + 20
	                        });
	                        _drawEle.select('.l-50-right-text').attr({
	                            'x': x2 - 45,
	                            'y': y2 - _height * 0.5 + 20
	                        }).text((current.end.yValue - (current.end.yValue - current.start.yValue) * 0.5).toFixed(decimals));
	
	                        _drawEle.select('.l-382').attr({
	                            'x1': x1,
	                            'y1': y2 - _height * 0.382,
	                            'x2': x2,
	                            'y2': y2 - _height * 0.382
	                        });
	                        _drawEle.select('.l-382-left-text').attr({
	                            'x': x1,
	                            'y': y2 - _height * 0.382 + 20
	                        });
	                        _drawEle.select('.l-382-right-text').attr({
	                            'x': x2 - 45,
	                            'y': y2 - _height * 0.382 + 20
	                        }).text((current.end.yValue - (current.end.yValue - current.start.yValue) * 0.382).toFixed(decimals));
	
	                        _drawEle.select('.close-drawing').attr({
	                            'x': x2 + 3,
	                            'y': y1
	                        });
	
	                        break;
	                    case 'fibonaccitimezones':
	                        var x1 = start.x;
	                        var y1 = start.y;
	                        var x2 = end.x;
	                        var y2 = end.y;
	                        _drawEle.select('.ftz-0-text').attr({
	                            'x': x1,
	                            'y': 20
	                        });
	                        _drawEle.select('.ftz-1-text').attr({
	                            'x': x2,
	                            'y': 20
	                        });
	                        _drawEle.select('.ftz-0-1').attr({
	                            'x1': x1,
	                            'y1': y1,
	                            'x2': x2,
	                            'y2': y2
	                        });
	                        _drawEle.select('.ftz-0-c').attr({
	                            'cx': x1,
	                            'cy': y1,
	                            'r': 2
	                        });
	                        _drawEle.select('.ftz-1-c').attr({
	                            'cx': x2,
	                            'cy': y2,
	                            'r': 2
	                        });
	                        _drawEle.selectAll('.ftz-time-zone-line, .ftz-time-zone-text').remove();
	                        var tzLines = getFibonacciTimeZoneX(x1, x2, width);
	                        tzLines.forEach(function(line, index) {
	                            var lineEl = _drawEle.append('line');
	                            lineEl.attr('class', 'ftz-time-zone-line').attr({
	                                'x1': line.x,
	                                'y1': 0,
	                                'x2': line.x,
	                                'y2': height
	                            });
	                            if (index === 0) {
	                                lineEl.style({
	                                    stroke: drawing['fibonaccitimezones'].color.mainLine
	                                });
	                            }
	                            _drawEle.append('text').text(line.n).attr('class', 'ftz-time-zone-text').attr({
	                                'x': line.x,
	                                'y': 12
	                            });
	                        });
	                        var lastX = tzLines[tzLines.length - 1].x;
	                        if (x1 > lastX) {
	                            current.closex = x1 + 8;
	                        } else if (tzLines[tzLines.length - 1].n > 10) {
	                            current.closex = lastX + 15;
	                        } else {
	                            current.closex = lastX + 8;
	                        }
	                        current.closex = Math.min(current.closex, width - 15);
	                        _drawEle.select('.close-drawing').attr({
	                            'x': current.closex,
	                            'y': 0
	                        });
	                        break;
	                    case 'fibonaccifans':
	                        var x1 = start.x,
	                            y1 = start.y,
	                            x2 = end.x,
	                            y2 = end.y;
	                        var slope = (y2 - y1) / (x2 - x1);
	                        var scale = drawing['fibonaccifans'].scale;
	                        _drawEle.select('.ffs-0-1').attr({
	                            'x1': x1,
	                            'y1': y1,
	                            'x2': x2,
	                            'y2': y2
	                        });
	                        _drawEle.select('.ffs-0-c').attr({
	                            'cx': x1,
	                            'cy': y1,
	                            'r': 2
	                        });
	                        _drawEle.select('.ffs-1-c').attr({
	                            'cx': x2,
	                            'cy': y2,
	                            'r': 2
	                        });
	                        _drawEle.selectAll('.ffs-line').remove();
	                        current.closex = Math.min(x2 + 2, width - 15);
	                        _drawEle.select('.close-drawing').attr({
	                            'x': current.closex,
	                            'y': Math.max(0, y2 - 8)
	                        });
	                        if (x1 == x2 || y1 == y2) {
	                            return; //Don't need fibonacci lines for horizontal or vertical line
	                        }
	                        scale.forEach(function(_s) {
	                            var pos = [getFanLineExtendX(slope, _s, width, height, x1, x2, y1, y2), getFanLineExtendY(slope, _s, width, height, x1, x2, y1, y2)];
	                            _drawEle.append('line').attr('class', 'ffs-line').attr({
	                                'x1': x1,
	                                'y1': y1,
	                                'x2': pos[0],
	                                'y2': pos[1]
	                            });
	                        });
	                        break;
	                    case 'fibonacciarcs':
	                        var x1 = start.x,
	                            y1 = start.y,
	                            x2 = end.x,
	                            y2 = end.y;
	                        var updown = (y2 >= y1) ? "up" : "down";
	                        var radius = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	                        var scale = drawing['fibonacciarcs'].scale;
	                        _drawEle.selectAll('path').remove();
	                        scale.forEach(function(_s) {
	                            var r = radius * _s;
	                            var startX = x2 - r,
	                                startY = y2,
	                                endX = x2 + r,
	                                endY = y2;
	
	                            _drawEle.select('.farcs-0-1').attr({
	                                'x1': x1,
	                                'y1': y1,
	                                'x2': x2,
	                                'y2': y2
	                            });
	                            _drawEle.select('.farcs-0-c').attr({
	                                'cx': x1,
	                                'cy': y1,
	                                'r': 2
	                            });
	                            _drawEle.select('.farcs-1-c').attr({
	                                'cx': x2,
	                                'cy': y2,
	                                'r': 2
	                            });
	                            var closex = x1 > x2 ? Math.max(x2 - 15, 0) : Math.min(x2 + 2, width - 15);
	                            _drawEle.select('.close-drawing').attr({
	                                'x': closex,
	                                'y': Math.max(0, y2 - 8)
	                            });
	                            current.closex = closex;
	                            var sf = updown === 'up' ? 1 : 0;
	                            var path = ['M', startX, startY, 'A', r, r, 0, 0, sf, endX, endY].join(' ');
	                            _drawEle.append('path').attr({
	                                'd': path,
	                                'clip-path': 'url(#mkt-markets-farc-clip)'
	                            }).style({
	                                fill: 'none'
	                            });
	                        });
	                        break;
	                }
	            }
	        };
	        drawings.end = function(dataPointSize, fromRedraw) {
	            var dw = drawType ? drawing[drawType] : null;
	            var valid = true;
	            if (dw) {
	                var id = dw.currentId;
	                var current = dw.depot[id];
	                dw.move = {
	                    moving: false,
	                    cp: [],
	                    sp: [],
	                    ep: []
	                };
	                if (dataPointSize < 2 && drawType !== 'levelline') { //when data point is less than 2, we don't draw any except levelline
	                    removeDrawings(drawType, id);
	                    valid = false;
	                } else {
	                    if (typeof current.end === 'undefined' || !current.end.x) {
	                        if (!dw.features.clickRedraw && drawType !== 'levelline') {
	                            removeDrawings(drawType, id);
	                            valid = false;
	                        }
	                    } else if (drawType !== 'levelline' && validDrawing(drawType, current)) {
	                        removeDrawings(drawType, id);
	                        valid = false;
	                    } else {
	                        if (drawType !== 'trendline' && drawType !== 'fibonacciarcs' && drawType !== 'fibonaccifans' && drawType !== 'fibonaccitimezones' && (current.start.x > current.end.x || current.start.y > current.end.y)) {
	                            var start = $.extend(true, {}, current.start),
	                                end = $.extend(true, {}, current.end);
	                            current.start = {
	                                'x': Math.min(start.x, end.x),
	                                'y': Math.min(start.y, end.y),
	                                'yValue': Math.max(start.yValue, end.yValue),
	                                'datapoint': start.x > end.x ? end.datapoint : start.datapoint
	                            };
	                            current.end = {
	                                'x': Math.max(start.x, end.x),
	                                'y': Math.max(start.y, end.y),
	                                'yValue': Math.min(start.yValue, end.yValue),
	                                'datapoint': start.x > end.x ? start.datapoint : end.datapoint
	                            };
	                        }
	                    }
	                }
	
	                dw.currentId = null;
	                delete dw.currentId;
	            }
	            if (chartConfigManager.getConfig().saveDrawings && current && !fromRedraw && valid) {
	                if ($.isNumeric(current.id)) {
	                    eventManager.trigger(eventManager.EventTypes.UpdateDrawing, getDrawingsData(current));
	                } else {
	                    var saveData = getDrawingsData(current);
	                    saveData.callback = setDrawingsId;
	                    eventManager.trigger(eventManager.EventTypes.SaveLastDrawing, saveData);
	                }
	                if (current.oldStart) {
	                    current.oldStart = null;
	                    delete current.oldStart;
	                }
	                if (current.oldEnd) {
	                    current.oldEnd = null;
	                    delete current.oldEnd;
	                }
	            }
	
	            drawType = null;
	            drawing.selectPoint = null;
	            delete drawing.selectPoint;
	            target.style({
	                'cursor': 'default'
	            });
	
	        };
	        drawings.redraw = function(dataList) {
	            drawing.selectPoint = null;
	            var _map = {};
	            for (var i = 0, l = dataList.length, d; i < l; i++) {
	                d = dataList[i]['date'].getTime();
	                _map[d] = i;
	            }
	            for (var t in drawing) {
	                var dw = drawing[t];
	                if (!dw || dw.count <= 0) continue;
	                for (var id in dw.depot) {
	                    drawType = t;
	                    var drawEl = findDrawingDom(drawType, id);
	                    var current = dw.depot[id];
	                    dw.currentId = id;
	                    var startY = yScale(current.start.yValue);
	                    if (startY >= 0 && startY <= height) {
	                        if (drawType !== 'levelline') {
	                            var startIndex = _map[current.start.datapoint['date'].getTime()],
	                                endIndex = _map[current.end.datapoint['date'].getTime()],
	                                endY = yScale(current.end.yValue);
	                            if (startIndex > -1 && endIndex > -1 && endY >= 0 && endY <= height) {
	                                var sitem = findByPosition([xScale(startIndex), startY]),
	                                    eitem = findByPosition([xScale(endIndex), endY]),
	                                    sposition = sitem.mPosition;
	                                current.start['x'] = sposition[0];
	                                current.start['y'] = sposition[1];
	                                if (drawEl) {
	                                    drawEl.style({
	                                        'display': ''
	                                    });
	                                } else {
	                                    this.start(sitem, undefined, id);
	                                }
	                                this.move(eitem);
	                                this.end(undefined, true);
	                            } else if (drawEl) {
	                                drawEl.style({
	                                    'display': 'none'
	                                });
	                            }
	                        } else {
	                            current.start['y'] = startY;
	                            var startItem = {
	                                mPosition: [0, startY]
	                            };
	                            if (drawEl) {
	                                drawEl.style({
	                                    'display': ''
	                                });
	                            } else {
	                                this.start(startItem, undefined, id);
	                                this.end();
	                            }
	                            this.move({
	                                mPosition: startItem
	                            });
	
	                        }
	                    } else if (drawEl) {
	                        drawEl.style({
	                            'display': 'none'
	                        });
	                    }
	                }
	            }
	            drawType = null;
	        };
	        drawings.applySavedDrawings = function(savedDrawings) {
	            var formatObj = {};
	            for (var drawType in savedDrawings) {
	                var drawings = savedDrawings[drawType];
	                formatObj[drawType] = {
	                    count: 0,
	                    depot: {}
	                };
	                drawings.forEach(function(draw) {
	                    var depot = {};
	                    if (validSaveRecord(draw)) {
	                        depot.id = draw.id;
	                        ['start', 'end'].forEach(function(type) {
	                            if (draw[type].y !== undefined) {
	                                depot[type] = {
	                                    datapoint: {
	                                        date: new Date(draw[type].dIdx)
	                                    },
	                                    yValue: draw[type].y
	                                };
	                            }
	                        });
	                        formatObj[drawType].count++;
	                        formatObj[drawType].depot[draw.id] = depot;
	                    }
	                });
	            }
	            $.extend(true, drawing, formatObj);
	        }
	        return drawings;
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isIwtSource : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(7, data, 0),"data":data})) != null ? stack1 : "");
	},"2":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "            <div class=\"mainChart-tickerCurrency\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                <div class=\"mkts-cmpt-svgcht-currency-text\">"
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.currency : stack1), depth0))
	    + "</div>\n                <ul class=\"mkts-cmpt-currency-dropdown-list\">\n"
	    + ((stack1 = helpers.each.call(alias1,(depth0 != null ? depth0.currencyList : depth0),{"name":"each","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                </ul>\n            </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    return "                    <div class=\"mkts-cmpt-svgcht-menuicn--label\">Currency</div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                        <li data-value=\""
	    + alias4(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data}) : helper)))
	    + "\"><span>"
	    + alias4(((helper = (helper = helpers.text || (depth0 != null ? depth0.text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"text","hash":{},"data":data}) : helper)))
	    + "</span></li>\n";
	},"7":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "            <div class=\"mainChart-tickerCurrency\">"
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.currency : stack1), depth0))
	    + "</div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.show : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.compare : depth0)) != null ? stack1.show : stack1),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        <span class=\"indicators\"></span>\n        <span class=\"fundamentals\"></span>\n";
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "            <span class=\"mainChart-tickerCon "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.globalClass : stack1), depth0))
	    + "\" style=\"color:"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.color : stack1), depth0))
	    + "; "
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.needLegendBackground : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n            <span class=\"mainChart-tickerName\" title= \""
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.legendText : stack1), depth0))
	    + "\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.legendText : stack1), depth0))
	    + "</span>\n                <p class=\"mainChart-header-wrap\">\n                    <span class=\"mainChart-tickerName-price-change "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.updown : stack1), depth0))
	    + "\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.changeValue : stack1), depth0))
	    + "</span>\n                    <span class=\"mainValue cursor-value\"></span>\n"
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.closeable : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                </p>\n            </span>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return " background-color:"
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.color : stack1), depth0))
	    + ";";
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "                        <span class=\"icon chart close-button\" data-index=\""
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.tickerIndex : stack1), depth0))
	    + "\">&#215</span>\n";
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "            <span class=\"compare\">\n"
	    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.compare : depth0)) != null ? stack1.data : stack1),{"name":"each","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            </span>\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                <span class=\"compare-legend-con "
	    + alias4(((helper = (helper = helpers.compareClass || (depth0 != null ? depth0.compareClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"compareClass","hash":{},"data":data}) : helper)))
	    + "\"style=\"color:"
	    + alias4(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"color","hash":{},"data":data}) : helper)))
	    + "; "
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.needLegendBackground : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\">\n                    <span class=\"compare-legend-text\" data-index=\""
	    + alias4(((helper = (helper = helpers.tickerIndex || (depth0 != null ? depth0.tickerIndex : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"tickerIndex","hash":{},"data":data}) : helper)))
	    + "\"  title=\""
	    + alias4(((helper = (helper = helpers.legendText || (depth0 != null ? depth0.legendText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"legendText","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.legendText || (depth0 != null ? depth0.legendText : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"legendText","hash":{},"data":data}) : helper)))
	    + "</span>\n                <p class=\"mainChart-header-wrap\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.legendChange : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                    <span class=\"cursor-value\"></span>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.closeable : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "                </p>\n            </span>\n            \n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return " background-color:"
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";";
	},"19":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "                        <span class=\"compare-price-change-text "
	    + alias4(((helper = (helper = helpers.updown || (depth0 != null ? depth0.updown : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"updown","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.changeValue || (depth0 != null ? depth0.changeValue : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"changeValue","hash":{},"data":data}) : helper)))
	    + "</span>\n";
	},"21":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                        <span class=\"icon chart close-button\" data-index=\""
	    + container.escapeExpression(((helper = (helper = helpers.tickerIndex || (depth0 != null ? depth0.tickerIndex : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"tickerIndex","hash":{},"data":data}) : helper)))
	    + "\">&#215</span>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "<div class=\"mainChart-header\" style=\"margin-left:"
	    + alias4(((helper = (helper = helpers.marginLeft || (depth0 != null ? depth0.marginLeft : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"marginLeft","hash":{},"data":data}) : helper)))
	    + "px;\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showCurrency : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    <span class=\"error-message\">\n        "
	    + alias4(((helper = (helper = helpers.errorMsg || (depth0 != null ? depth0.errorMsg : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"errorMsg","hash":{},"data":data}) : helper)))
	    + "\n        <span class=\"icon chart error-message-close-button\">&#215</span>\n    </span>\n</div>";
	},"useData":true});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(19), __webpack_require__(3), __webpack_require__(1), __webpack_require__(17), __webpack_require__(46), __webpack_require__(47), __webpack_require__(48), __webpack_require__(49), __webpack_require__(50)], __WEBPACK_AMD_DEFINE_RESULT__ = function(moment, core, morningstar, util, popoverOHLCVTemplate, popoverGrowthTemplate, popoverPerformancesGrowthTemplate, popoverPriceGrowthTemplate, popoverSimpleTemplate) {
	        'use strict';
	
	        var d3 = core.d3;
	        var $ = core.$;
	        var Util = core.Util;
	        var model = function(managers) {
	            var chartConfigManager = managers.chartConfigManager;
	            var eventManager = managers.eventManager;
	            var target;
	            var locale = 'en-US';
	            var decimalPlaces;
	            var rootConfig, ChartGenre;
	            var isFundChart = false;
	            var MainDataTypes = chartConfigManager.MainDataTypes;
	            var PopoverTypes = chartConfigManager.PopoverTypes;
	            var numberFormat = function(d, formatLabel, isVolume, decimal, showOriginalDecimal) {
	                var _dec = $.isNumeric(decimal) ? decimal : ($.isNumeric(decimalPlaces) ? decimalPlaces : rootConfig.defaultDecimal);
	                var needMark = false;
	                var isFormat = rootConfig.isFormat;
	                while (Math.abs(d) * Math.pow(10, _dec) < 0.5 && d != 0) {
	                    _dec++;
	                }
	                if (isVolume) {
	                    _dec = (d > 1000000) ? rootConfig.volumeDecimal : 0;
	                    needMark = (d > 1000000) ? true : false;
	                    isFormat = (d > 1000000) ? true : isFormat;
	                }
	                if (rootConfig.crosshairs && rootConfig.crosshairs[formatLabel]) {
	                    needMark = rootConfig.crosshairs[formatLabel].needMark || needMark;
	                    _dec = rootConfig.crosshairs[formatLabel].decimal || _dec;
	                }
	                d = util.numberFormatter(locale, d, _dec, ' ', needMark, isFormat, showOriginalDecimal);
	                return d;
	            };
	            var _lineH,
	                _lineV,
	                _popover,
	                _maxWidth = 0,
	                _maxHeight = 0,
	                _popoverWidth = 0,
	                _popoverHeight = 0,
	                _lineHHeight = 0,
	                _lineVWidth = 0,
	                _lineVOffsetTop = 0,
	                _targetPaddingTop = 0,
	                _targetPaddingBottom = 0,
	                _targetPaddingLeft = 0,
	                _targetPaddingRight = 0,
	                _config = {},
	                _lang;
	
	            var setChangeValue = function(data, lang, popoverConfig) {
	                var frequency = data.frequency;
	                var valueChange = data['valueChange'];
	                var valueChangePercent = data['valueChangePercent'];
	                valueChange = isNaN(valueChange) ? lang['crosshairsPopoverNoData'] : valueChange.toFixed(decimalPlaces);
	                valueChangePercent = isNaN(valueChangePercent) ? lang['crosshairsPopoverNoData'] : valueChangePercent.toFixed(decimalPlaces);
	                var frequencyKey = util.getKeyByValueInObj(chartConfigManager.FrequencyTypes, frequency);
	                frequencyKey = util.lowerFirstChar(frequencyKey);
	                var valueChangeLabel = lang[frequencyKey + 'ValueChange'];
	                var valueChangePercentLabel = lang[frequencyKey + 'ValueChangePercent'];
	                if (popoverConfig) {
	                    if (rootConfig.showCrosshairChange) {
	                        popoverConfig.valueChange = {
	                            'label': valueChangeLabel,
	                            'value': valueChange,
	                            'upOrDownclass': valueChange >= 0 ? 'upPriceChangeColor' : 'downPriceChangeColor'
	                        };
	                    }
	                    if (rootConfig.showCrosshairChangePercent) {
	                        popoverConfig.valueChangePercent = {
	                            'label': valueChangePercentLabel,
	                            'value': valueChangePercent,
	                            'upOrDownclass': valueChange >= 0 ? 'upPriceChangeColor' : 'downPriceChangeColor'
	                        };
	                    }
	                }
	            };
	
	            var addCrossCurrency = function(val, currency, force) {
	                if ((rootConfig.crossCurrency || force) && currency) {
	                    var cur = rootConfig.currencyAliases[currency];
	                    if (rootConfig.crossCurrency === 'symbol') {
	                        cur = Util.getCurrency(currency);
	                        var symbol = rootConfig.currencyAliases[currency] || cur.symbol;
	                        if (cur.orient === 'right') {
	                            val += ' ' + symbol;
	                        } else {
	                            val = symbol + ' ' + val;
	                        }
	                    } else {
	                        cur = rootConfig.currencyAliases[currency] || currency;
	                        val = cur + " " + val;
	                    }
	                }
	                return val;
	            }
	            var assembleOHLCV = function(data, lang, chartType) {
	                if (isFundChart) {
	                    var label = lang['nav'];
	                    var dataType = chartConfigManager.getMainDataType();
	                    var isChartDataType = dataType === MainDataTypes.TotalReturn || dataType === MainDataTypes.MarketValue || dataType === MainDataTypes.PriceWithDividendGrowth || dataType === MainDataTypes.PostTax;
	                    if (isChartDataType) {
	                        label = lang[dataType];
	                    }
	
	                    var value = data['value'] || data['close'];
	                    if (dataType === MainDataTypes.PriceWithDividendGrowth && (chartType === 'main' || chartType === 'compare')) {
	                        value = data['growthWithNav'];
	                    }
	                    var val = isNaN(value) ? lang['crosshairsPopoverNoData'] : numberFormat(value, isChartDataType ? dataType : 'nav', false, data.decimalPlaces);
	                    val = addCrossCurrency(val, data['currency']);
	                    popoverConfig = {
	                        'navValue': {
	                            'label': label,
	                            'value': val
	                        }
	                    }
	                } else {
	                    var popoverConfig = {
	                        'open': {
	                            'label': lang['open'],
	                            'value': isNaN(data['open']) ? lang['crosshairsPopoverNoData'] : numberFormat(data['open'], 'open')
	                        },
	                        'close': {
	                            'label': lang['close'],
	                            'value': isNaN(data['close']) ? lang['crosshairsPopoverNoData'] : numberFormat(data['close'], 'close')
	                        },
	                        'high': {
	                            'label': lang['high'],
	                            'value': isNaN(data['high']) ? lang['crosshairsPopoverNoData'] : numberFormat(data['high'], 'high')
	                        },
	                        'low': {
	                            'label': lang['low'],
	                            'value': isNaN(data['low']) ? lang['crosshairsPopoverNoData'] : numberFormat(data['low'], 'low')
	                        },
	                        'y': {
	                            'value': isNaN(data['y']) ? lang['crosshairsPopoverNoData'] : numberFormat(data['y'], data.name)
	                        }
	                    };
	                    if (rootConfig.chartGenre === ChartGenre.StockChart && rootConfig.showCrosshairVolume) {
	                        popoverConfig['volume'] = {
	                            'label': lang['volume'],
	                            'value': isNaN(data['volume']) ? lang['crosshairsPopoverNoData'] : numberFormat(data['volume'], 'volume', true)
	                        }
	                    }
	                }
	                setChangeValue(data, lang, popoverConfig);
	                return popoverConfig;
	            };
	
	            var getLabelNameFromLanguage = function(lang, popoverType) {
	                var _popoverType = popoverType.substring(0, 1).toLowerCase() + popoverType.substring(1);
	                return lang[_popoverType];
	            };
	
	            // show plus sign
	            var isShowPlusSign = function(data) {
	                var showPricePlusSign = rootConfig.showPricePlusSign;
	                var _data = data;
	                if (showPricePlusSign) {
	                    _data = parseFloat(data, 10) > 0 ? "+" + data : data;
	                }
	                return _data;
	            };
	
	            var assembleGrowthOrTenKGrowth = function(data, lang, chartType, popoverType, labelName) {
	                var label = getLabelNameFromLanguage(lang, popoverType);
	                var gValue = isNaN(data['close']) ? data['value'] : data['close'];
	                var MainDataTypes = chartConfigManager.MainDataTypes;
	                var mainDataType = chartConfigManager.getMainDataType();
	                if (mainDataType === MainDataTypes.PriceWithDividendGrowth && isFundChart) {
	                    label = lang[MainDataTypes.PriceWithDividendGrowth];
	                    gValue = data['growthWithNav'];
	                } else if (rootConfig.growthBaseValue && rootConfig.growthBaseValue != 10000 && rootConfig.charts.mainChart.dataType === MainDataTypes.Growth10K) {
	                    label = rootConfig.growthBaseValue + " " + lang["growth"];
	                }
	                if (!label) {
	                    label = data.ticker;
	                }
	                if (!data) {
	                    data = {
	                        close: '-',
	                        value: '-',
	                        y: '-'
	                    }
	                }
	
	                if (isNaN(gValue)) {
	                    gValue = lang['crosshairsPopoverNoData'];
	                } else {
	                    gValue = numberFormat(gValue, util.lowerFirstChar(popoverType), false, data.decimalPlaces, false);
	                    if (chartConfigManager.getMainDataType() !== chartConfigManager.MainDataTypes.PriceWithDividendGrowth) {
	                        gValue = isShowPlusSign(gValue);
	                    }
	                }
	                if (chartType === 'compare' && popoverType === PopoverTypes.TenKGrowth) {
	                    labelName = util.lowerFirstChar(popoverType);
	                }
	                if (chartType === 'compare' && !data['y']) {
	                    data['y'] = gValue;
	                }
	                var yVal = isShowPlusSign(numberFormat(data['y'], labelName, false, data.decimalPlaces));
	
	                if (chartConfigManager.isPercentChart()) {
	                    gValue += '%';
	                    yVal += '%';
	                }
	                var popoverConfig = {
	                    'growth': {
	                        'label': label,
	                        'value': gValue
	                    },
	                    'y': {
	                        'value': isNaN(data['y']) ? lang['crosshairsPopoverNoData'] : yVal
	                    }
	                };
	
	                if (rootConfig.chartGenre === ChartGenre.StockChart && rootConfig.showCrosshairVolume) {
	                    popoverConfig['volume'] = {
	                        'label': lang['volume'],
	                        'value': isNaN(data['volume']) ? lang['crosshairsPopoverNoData'] : numberFormat(data['volume'], 'volume', true)
	                    };
	                }
	                setChangeValue(data, lang, popoverConfig);
	                return popoverConfig;
	            };
	
	            var assemblePerformanceGrowth = function(data, lang, chartType) {
	                var performanceValue;
	                var value = data['close'] || data['value'];
	                if (isNaN(value)) {
	                    performanceValue = lang['crosshairsPopoverNoData'];
	                } else {
	                    switch (rootConfig.crossPerformanceVal) {
	                        case MainDataTypes.Growth:
	                            performanceValue = numberFormat((value - 10000) / 100, chartType + 'GrowthLabel') + '%'; // devide 10000 multiply 100 so is 100;
	                            break;
	                        case MainDataTypes.Growth10K:
	                            performanceValue = numberFormat(value, chartType + 'GrowthLabel');
	                            break;
	                        case "original":
	                            performanceValue = numberFormat(data.originalPrice, chartType + 'GrowthLabel');
	                            break;
	                    }
	                    performanceValue = addCrossCurrency(performanceValue, data['currency']);
	                }
	
	                var popoverConfig = {
	                    'growth': {
	                        'label': lang[chartType + 'GrowthLabel'],
	                        'value': performanceValue
	                    }
	                };
	
	                return popoverConfig;
	            };
	
	            var renderPopover = function(container, chartData, popoverType, lang) {
	                var mainCfg = rootConfig.charts.mainChart;
	                var mainDataType = chartConfigManager.getMainDataType();
	                decimalPlaces = $.isNumeric(mainCfg.crossHairDecimal) ? mainCfg.crossHairDecimal : 2;
	                if (mainDataType === MainDataTypes.Growth10K && rootConfig.growth10KDecimal ||
	                    (mainDataType === MainDataTypes.PriceWithDividendGrowth && isFundChart)) {
	                    _popover.addClass("mkts-components-svgchart-crosshair-long");
	                } else {
	                    _popover.removeClass("mkts-components-svgchart-crosshair-long");
	                }
	                var parseData = {};
	                var pooverTemplate;
	                var isPerformancesGrowth = rootConfig.growthType === "performancesGrowth";
	                var isPriceGrowth = rootConfig.growthType === "priceGrowth";
	                if (popoverType === PopoverTypes.Simple) {
	                    pooverTemplate = popoverSimpleTemplate;
	                    _popover.addClass("mkts-cmpt-svgcht-crosshair-mode-" + rootConfig.crosshairMode);
	                } else if (isPerformancesGrowth) {
	                    pooverTemplate = popoverPerformancesGrowthTemplate;
	                } else if (isPriceGrowth) {
	                    pooverTemplate = popoverPriceGrowthTemplate;
	                } else if (popoverType === PopoverTypes.OHLCV) {
	                    pooverTemplate = popoverOHLCVTemplate
	                } else {
	                    pooverTemplate = popoverGrowthTemplate; //popoverGrowthTemplate;
	                }
	
	                var popoverAssembleFunction;
	                if (isPerformancesGrowth) {
	                    popoverAssembleFunction = assemblePerformanceGrowth;
	                } else {
	                    switch (popoverType) {
	                        case PopoverTypes.Growth:
	                        case PopoverTypes.TenKGrowth:
	                        case PopoverTypes.Simple:
	                            popoverAssembleFunction = assembleGrowthOrTenKGrowth;
	                            break;
	                        case PopoverTypes.OHLCV:
	                        default:
	                            popoverAssembleFunction = assembleOHLCV;
	                            break;
	                    };
	                }
	
	                for (var chartType in chartData.data) {
	                    if (chartData.data.hasOwnProperty(chartType)) {
	                        parseData[chartType] = parseData[chartType] || [];
	                        switch (chartType) {
	                            case 'events':
	                                parseData.events = parseData.events || [];
	                                chartData.data.events.forEach(function(e) {
	                                    var eventValue = e.data.yValue;
	                                    if ($.isNumeric(eventValue)) {
	                                        eventValue = numberFormat(+eventValue);
	                                    }
	                                    var y = {
	                                        'value': eventValue,
	                                        'date': moment(e.data.yDate).format(getDateFormat())
	                                    };
	                                    if (e.data.yFrequency) {
	                                        y.frequency = e.data.yFrequency;
	                                    }
	                                    parseData.events.push({
	                                        'showLegend': e.showLegend === false ? false : true,
	                                        'name': e.name,
	                                        'color': e.color,
	                                        'y': y
	                                    });
	                                });
	                                break;
	                            case 'main':
	                                var mainData = chartData.data[chartType].data;
	                                if (mainData) {
	                                    var popData = {
	                                        'showLegend': chartData.data[chartType].showLegend === false ? false : true,
	                                        'datetime': moment(mainData.date).format(getDateFormat()),
	                                        'currency': chartData.data[chartType].currency
	                                    };
	
	                                    if (isPerformancesGrowth || isPriceGrowth) {
	                                        popData['closeDateLabel'] = lang['closeDateLabel'];
	                                    }
	
	                                    if (isPerformancesGrowth || isPriceGrowth) {
	                                        popData['valueLabel'] = lang['value'];
	                                        var v;
	                                        if (isPerformancesGrowth && rootConfig.crossValue === 'original') {
	                                            v = mainData.originalPrice;
	                                        } else if (rootConfig.crossValue === MainDataTypes.Growth) {
	                                            v = ((mainData.value || mainData.y) - 10000) / 100;
	                                        } else {
	                                            v = mainData.value || mainData.y;
	                                        }
	                                        popData['value'] = numberFormat(v);
	                                    } else {
	                                        popData['ticker'] = chartData.data[chartType].ticker;
	                                        popData['color'] = chartData.data[chartType].color;
	                                    }
	                                    var tickerObj = chartData.data[chartType].tickerObject;
	                                    if (rootConfig.showCrosshairOriginalData && !chartConfigManager.isCategory(tickerObj)) {
	                                        var originalPrice = mainData['originalPrice'];
	                                        if (isNaN(originalPrice)) {
	                                            originalPrice = lang['crosshairsPopoverNoData'];
	                                        } else {
	                                            var flag = (chartConfigManager.isMutualFund(tickerObj) && tickerObj.mType !== 'XI');
	                                            originalPrice = numberFormat(originalPrice, flag ? 'nav' : 'price', false, decimalPlaces, !!rootConfig.useDataApiTimeseriesData);
	                                            originalPrice = addCrossCurrency(originalPrice, popData.currency, true);
	                                        }
	                                        popData['originalPrice'] = {
	                                            'label': __getLabel(lang, tickerObj),
	                                            'value': originalPrice
	                                        };
	                                    }
	                                    mainData['currency'] = chartData.data[chartType].currency;
	                                    mainData['ticker'] = chartData.data[chartType].ticker;
	                                    mainData['frequency'] = chartData.data[chartType].frequency;
	                                    popData['globalClass'] = chartData.data[chartType].globalClass;
	                                    parseData[chartType] = $.extend(popData, popoverAssembleFunction(mainData, lang, chartType, popoverType));
	                                }
	                                break;
	                            default:
	                                parseData[chartType] = parseData[chartType] || [];
	                                chartData.data[chartType].forEach(function(d) {
	                                    var defaultData = $.extend(true, {
	                                        'decimalPlaces': d.decimalPlaces,
	                                        'name': d.name
	                                    }, d.data);
	                                    var crossData = {
	                                        'showLegend': d.showLegend === false ? false : true,
	                                        'ticker': lang[d.ticker] || d.ticker,
	                                        'color': d.color,
	                                        'datetime': defaultData ? moment(defaultData.date).format(getDateFormat()) : 0
	                                    };
	                                    if (chartType === 'compare') {
	                                        defaultData.currency = d.currency;
	                                        if (showCompareOriginalPrice(d.tickerObject)) {
	                                            var originalPrice = defaultData['originalPrice'];
	                                            if (isNaN(originalPrice)) {
	                                                originalPrice = lang['crosshairsPopoverNoData'];
	                                            } else {
	                                                originalPrice = numberFormat(originalPrice, '', false, decimalPlaces, !!rootConfig.useDataApiTimeseriesData);
	                                                originalPrice = addCrossCurrency(originalPrice, defaultData.currency, true);
	                                            }
	
	                                            crossData.originalPrice = {
	                                                'label': __getLabel(lang, d.tickerObject),
	                                                'value': originalPrice
	                                            }
	                                        }
	                                        if (d.fundamentals) {
	                                            crossData['fundamentals'] = [];
	                                            for (var f = 0; f < d.fundamentals.length; f++) {
	                                                var fundamentalValue = d.fundamentals[f].data && d.fundamentals[f].data.value;
	                                                if (isNaN(fundamentalValue)) {
	                                                    fundamentalValue = lang['crosshairsPopoverNoData'];
	                                                }
	                                                fundamentalValue = numberFormat(fundamentalValue, util.lowerFirstChar(d.fundamentals[f].name));
	                                                crossData['fundamentals'].push({
	                                                    'showLegend': d.fundamentals[f].showLegend === false ? false : true,
	                                                    'label': lang[d.fundamentals[f].ticker] || d.fundamentals[f].ticker,
	                                                    'color': d.fundamentals[f].color,
	                                                    'value': isShowPlusSign(fundamentalValue),
	                                                    'datetime': defaultData ? moment(defaultData.date).format(getDateFormat()) : 0
	                                                });
	                                            }
	                                        }
	                                    }
	
	                                    if (d.globalClass) {
	                                        crossData.globalClass = d.globalClass;
	                                    }
	                                    parseData[chartType].push($.extend(crossData, popoverAssembleFunction(defaultData, lang, chartType, popoverType, d.name ? util.lowerFirstChar(d.name) : '')));
	                                });
	                                break;
	                        }
	                    }
	                };
	
	                var html = pooverTemplate(parseData);
	                container.html(html);
	            };
	
	            var __getLabel = function(lang, tickerObj) {
	                var mainDataType = chartConfigManager.getMainDataType();
	                var label = lang.price;
	                var flag = (chartConfigManager.isMutualFund(tickerObj) && tickerObj.mType !== 'XI');
	                if (flag) {
	                    // Post tax should display label as PostTax
	                    label = mainDataType === MainDataTypes.PostTax ? lang.postTax : lang.nav;
	                }
	                return label;
	            };
	
	            var getDateFormat = function() {
	                var format;
	                if (chartConfigManager.isIntraday()) {
	                    format = rootConfig.intradayDateFormater;
	                } else {
	                    format = rootConfig.dailyDateFormatter;
	                }
	                return format;
	            };
	
	            var showCompareOriginalPrice = function(tickerObject) {
	                var show = false;
	                if (rootConfig.showCrosshairOriginalData && tickerObject) {
	                    if (!(tickerObject.benchmarkType || chartConfigManager.isCategory(tickerObject))) {
	                        show = true;
	                    }
	                }
	                return show;
	            };
	
	            var position = function(pos, offsetTop) {
	                _maxWidth = target.width();
	                _maxHeight = target.height();
	                var viewWidth = document.documentElement.clientWidth;
	                var viewHeight = document.documentElement.clientHeight;
	                var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop;
	                var scrollLeft = document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft;
	                var pageX = pos.pageX - scrollLeft;
	                var pageY = pos.top - scrollTop;
	                _lineVOffsetTop = 0;
	                if (offsetTop > 0) {
	                    _lineVOffsetTop = offsetTop;
	                }
	                _lineVOffsetTop += _targetPaddingTop;
	                _lineVOffsetTop += _config.menuHeight > 0 ? _config.menuHeight : 0;
	                var top = pos.top - target.offset().top;
	                var left = pos.left;
	                var lineOffSet = 0;
	                var arrowSize = 10;
	                if ($.browser.msie) { //For ie not support pointer-events: none; otherwise it cause zoom and drag can't work.
	                    (left > (_maxWidth / 2)) ? (lineOffSet = -1) : (lineOffSet = 1)
	                }
	
	                _lineH.css({
	                    'left': _targetPaddingLeft,
	                    'top': top + lineOffSet,
	                    'width': _maxWidth - _targetPaddingLeft - _targetPaddingRight
	                }).show();
	                _lineV.css({
	                    'left': left + lineOffSet,
	                    'top': _lineVOffsetTop,
	                    'height': _maxHeight - _lineVOffsetTop - _targetPaddingBottom
	                }).show();
	
	                _popover.show();
	
	                _lineHHeight <= 0 && (_lineHHeight = _lineH.outerHeight(true));
	                _lineVWidth <= 0 && (_lineVWidth = _lineV.outerWidth(true));
	                _popoverWidth = _popover.outerWidth(true) + arrowSize;
	                _popoverHeight = _popover.outerHeight(true) + arrowSize;
	                var direction = [];
	                var halfPopoverWidth = _popoverWidth / 2;
	                var halfViewWidth = viewWidth / 2;
	                var halfViewHeight = viewHeight / 2;
	                if (rootConfig.crosshairJustify) {
	                    if (left + halfPopoverWidth > _maxWidth) {
	                        left = left - _popoverWidth - _lineVWidth;
	                        direction.push('right');
	                    } else if (left < halfPopoverWidth) {
	                        left = left + _lineVWidth;
	                        direction.push('left');
	                    } else {
	                        left = left - halfPopoverWidth;
	                        direction.push('middle');
	                    }
	                } else {
	                    if (pageX < halfViewWidth) {
	                        if (viewWidth - pageX >= _popoverWidth) {
	                            left = left + _lineVWidth;
	                            direction.push('left');
	                        } else {
	                            left = left - halfPopoverWidth;
	                            direction.push('middle');
	                        }
	                    } else {
	                        if (pageX >= _popoverWidth) {
	                            left = left - _popoverWidth - _lineVWidth;
	                            direction.push('right');
	                        } else {
	                            left = left - halfPopoverWidth;
	                            direction.push('middle');
	                        }
	                    }
	                }
	
	                var halfPopoverHeight = _popoverHeight / 2;
	                if (direction.indexOf('middle') > -1) {
	                    if (pageY + _popoverHeight > viewHeight) {
	                        top = top - _popoverHeight - _lineHHeight;
	                        direction.push('down');
	                    } else {
	                        top = top + _lineHHeight;
	                        direction.push('up');
	                    }
	                } else {
	
	                    if (pageY > halfViewHeight) {
	                        if (_popoverHeight + pageY <= viewHeight) {
	                            top = top + _lineHHeight;
	                            direction.push('up');
	                        } else if (pageY >= _popoverHeight) {
	                            top = top - _popoverHeight - _lineHHeight;
	                            direction.push('down');
	                        } else {
	                            top = top - halfPopoverHeight;
	                            direction.push('center');
	                        }
	                    } else {
	                        if (viewHeight >= _popoverHeight + pageY) {
	                            top = top + _lineHHeight;
	                            direction.push('up');
	                        } else {
	                            top = top - halfPopoverHeight;
	                            direction.push('center');
	                        }
	                    }
	                }
	
	
	                _popover.css({
	                    left: left,
	                    top: top
	                }).removeClass(function(index, css) {
	                    return (css.match(/\bpopover-tip-\S+/g) || []).join(' ')
	                }).addClass('popover-tip-' + direction.join(''));
	            };
	
	            var displayCrosshairs = function(e) {
	                renderPopover(_popover, e, e.popoverType, _lang);
	                position(e.position, e.offsetTop);
	            };
	
	            var hideCrosshairs = function() {
	                _lineH.hide();
	                _lineV.hide();
	                _popover.hide();
	            };
	
	            var bindEvent = function() {
	                var chartBody = target.find('.chart-body');
	                var dom = d3.select(chartBody[0]);
	                dom.on('mouseleave.crosshairs', function(e) {
	                    var target = d3.event.relatedTarget;
	                    if (util.contains(_lineH[0], target) || util.contains(_lineV[0], target) || util.contains(_popover[0], target)) {
	                        return false;
	                    }
	                    hideCrosshairs();
	                    eventManager.trigger(eventManager.EventTypes.MouseOutChart);
	                });
	
	                eventManager.bind(eventManager.EventTypes.ToggleCrossharis, function(e) {
	                    if (e) { //display crosshairs
	                        displayCrosshairs(e);
	                    } else {
	                        hideCrosshairs();
	                    }
	                }, crosshairs);
	            };
	
	            var crosshairs = function(tar, config) {
	                rootConfig = chartConfigManager.getConfig();
	                ChartGenre = chartConfigManager.ChartGenre;
	                locale = rootConfig.lang;
	                target = tar;
	                target.append('<div class="crosshairs line horizontal"></div><div class="crosshairs line vertical"></div><div class="crosshairs popover-tip popover-tip-leftup"></div>');
	                _lineH = target.find('.horizontal');
	                _lineV = target.find('.vertical');
	                _popover = target.find('.popover-tip');
	                var chartContainer = target.find('.mkts-cmpt-svgcht-chart-container--padding');
	                if (chartContainer.length) {
	                    _targetPaddingTop = parseInt(chartContainer.css('paddingTop'), 10);
	                    _targetPaddingBottom = parseInt(chartContainer.css('paddingBottom'), 10);
	                    _targetPaddingLeft = parseInt(chartContainer.css('paddingLeft'), 10);
	                    _targetPaddingRight = parseInt(chartContainer.css('paddingRight'), 10);
	                }
	                _config = config;
	                if (rootConfig.chartGenre === ChartGenre.FundChart) {
	                    isFundChart = true;
	                    _popover.addClass("nav-tip");
	                } else {
	                    isFundChart = false;
	                    _popover.removeClass("nav-tip");
	                }
	                _lang = chartConfigManager.getLabels('markets-components-svgchart', chartConfigManager.getConfig().lang);
	                bindEvent();
	            };
	
	            return crosshairs;
	        }
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "        <span class=\"mkts-cmpt-svgcht-crosshair-legend mainChart-legend\" style=\"color: "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.color : stack1), depth0))
	    + ";\"></span> ";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <div class=\"nav\">\n        <div class=\"price o\">\n            <span class=\"mkts-cmpt-svgcht-crosshair-label\">\n                "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.navValue : stack1)) != null ? stack1.label : stack1), depth0))
	    + "\n            </span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">\n                "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.navValue : stack1)) != null ? stack1.value : stack1), depth0))
	    + "\n            </span>\n        </div>\n    </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <div class=\"ohlcv\">\n        <div class=\"price o\">\n            <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.open : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.open : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n        </div>\n        <div class=\"price c\">\n            <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.close : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.close : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n        </div>\n        <div class=\"price h\">\n            <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.high : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.high : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n        </div>\n        <div class=\"price l\">\n            <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.low : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.low : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n        </div>\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "    </div>\n    ";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class=\"volume\">\n            <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n            <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n        </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "\n    <div class=\"change\">\n        <div class=\"value "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1)) != null ? stack1.upOrDownclass : stack1), depth0))
	    + "\">\n            <span class=\"mkts-cmpt-svgcht-crosshair-label\">\n                "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1)) != null ? stack1.label : stack1), depth0))
	    + "\n            </span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">\n                "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1)) != null ? stack1.value : stack1), depth0))
	    + "\n            </span>\n        </div>\n    </div>\n    ";
	},"10":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "\n    <div class=\"change\">\n        <div class=\"valuepercent "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1)) != null ? stack1.upOrDownclass : stack1), depth0))
	    + "\">\n            <span class=\"mkts-cmpt-svgcht-crosshair-label\">\n                "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1)) != null ? stack1.label : stack1), depth0))
	    + "\n            </span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">\n                "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1)) != null ? stack1.value : stack1), depth0))
	    + " %\n            </span>\n        </div>\n    </div>\n";
	},"12":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;
	
	  return "<div class=\"compare "
	    + alias4(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n    <div class=\"ticker\">\n        <span class=\"mkts-cmpt-svgcht-crosshair-legend compare-legend\" style=\"color: "
	    + alias4(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span>\n        <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias4(((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ticker","hash":{},"data":data}) : helper)))
	    + "</span>\n        <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.navValue : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n    </div>\n</div>\n";
	},"14":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;
	
	  return "\n<div class=\"compare "
	    + alias4(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n    <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias4(((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ticker","hash":{},"data":data}) : helper)))
	    + "</span>\n        <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.navValue : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n    </div>\n</div>\n";
	},"15":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "        <span class=\"mkts-cmpt-svgcht-crosshair-legend compare-legend\" style=\"color: "
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span> ";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return " \n<div class=\"events "
	    + container.escapeExpression(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n    <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.frequency : stack1),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.program(22, data, 0),"data":data})) != null ? stack1 : "")
	    + "    </div>\n</div>\n";
	},"18":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "            <span class=\"mkts-cmpt-svgcht-crosshair-legend compare-legend\" style=\"color: "
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span>\n";
	},"20":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;
	
	  return "            <div class=\"mkts-components-svgchart-crosshair-left\">\n                <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias1(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data}) : helper)))
	    + "</span>\n                <span class=\"mkts-cmpt-svgcht-crosshair-frequency\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.frequency : stack1), depth0))
	    + "</span>\n            </div>\n            <div class=\"mkts-components-svgchart-crosshair-right\">\n                <span class=\"mkts-cmpt-svgcht-crosshair-date\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.date : stack1), depth0))
	    + "</span>\n                <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n            </div>  \n";
	},"22":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;
	
	  return "            <div class=\"mkts-components-svgchart-crosshair-left\">\n                <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias1(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data}) : helper)))
	    + "</span>\n            </div>\n            <div class=\"mkts-components-svgchart-crosshair-right\">\n                <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n                <span class=\"mkts-cmpt-svgcht-crosshair-date\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.date : stack1), depth0))
	    + "</span>\n            </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=helpers.helperMissing, alias5="function", alias6=helpers.blockHelperMissing, buffer = 
	  "<div class=\"main "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.globalClass : stack1), depth0))
	    + "\">\n    <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.showLegend : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n        <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.ticker : stack1), depth0))
	    + "</span>\n    </div>\n    <div class=\"mkts-cmpt-svgcht-crosshair-datetime\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.datetime : stack1), depth0))
	    + "</div>\n"
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.navValue : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>\n";
	  stack1 = ((helper = (helper = helpers.compare || (depth0 != null ? depth0.compare : depth0)) != null ? helper : alias4),(options={"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.compare) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += " ";
	  stack1 = ((helper = (helper = helpers.indicators || (depth0 != null ? depth0.indicators : depth0)) != null ? helper : alias4),(options={"name":"indicators","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.indicators) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += " ";
	  stack1 = ((helper = (helper = helpers.fundamentals || (depth0 != null ? depth0.fundamentals : depth0)) != null ? helper : alias4),(options={"name":"fundamentals","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.fundamentals) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += " ";
	  stack1 = ((helper = (helper = helpers.events || (depth0 != null ? depth0.events : depth0)) != null ? helper : alias4),(options={"name":"events","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.events) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer;
	},"useData":true});

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class=\"mkts-cmpt-svgcht-crosshair-datetime mkts-cmpt-svgcht-scrosshair-title\">\n            <span class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.datetime : stack1), depth0))
	    + "</span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.growth : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</span>\n        </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.showLegend : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.ticker : stack1), depth0))
	    + "</span>\n        </div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-datetime\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.datetime : stack1), depth0))
	    + "</div>\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "                <span class=\"mkts-cmpt-svgcht-crosshair-legend mainChart-legend\" style=\"color: "
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.color : stack1), depth0))
	    + ";\"></span>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    return "        <div class=\"growth\">\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.showLegend : stack1),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            <span class=\"mkts-cmpt-svgcht-crosshair--ticker\">"
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.ticker : stack1), depth0))
	    + "</span>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "                <span class=\"mainChart-legend mkts-cmpt-svgcht-crosshair-legend\" style=\"color:"
	    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.color : stack1), depth0))
	    + ";\"></span>\n";
	},"11":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return "            <span class=\"mkts-cmpt-svgcht-crosshair-label--growth-label\">"
	    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.growth : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</span>\n";
	},"13":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <div class=\"change\">\n        <div class=\"value "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1)) != null ? stack1.upOrDownclass : stack1), depth0))
	    + "\">\n            <span class=\"mkts-cmpt-svgcht-crosshair-label mkts-cmpt-svgcht-crosshair-label--value-change\">\n            "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1)) != null ? stack1.label : stack1), depth0))
	    + "\n            </span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">\n            "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1)) != null ? stack1.value : stack1), depth0))
	    + "\n            </span>\n        </div>\n    </div>\n";
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "\n    <div class=\"change\">\n        <div class=\"valuepercent "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1)) != null ? stack1.upOrDownclass : stack1), depth0))
	    + "\">\n            <span class=\"mkts-cmpt-svgcht-crosshair-label mkts-cmpt-svgcht-crosshair-label--value-change-percent\">\n            "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1)) != null ? stack1.label : stack1), depth0))
	    + "\n            </span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">\n            "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1)) != null ? stack1.value : stack1), depth0))
	    + " %\n            </span>\n        </div>\n    </div>\n";
	},"17":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <div class=\"growth\">\n        <div class=\"mkts-cmpt-svgcht-crosshair-label mkts-cmpt-svgcht-crosshair-label--original-price\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.originalPrice : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.originalPrice : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n";
	},"19":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "\n    <div class=\"volume volume-with-growth\">\n        <div class=\"mkts-cmpt-svgcht-crosshair-label mkts-cmpt-svgcht-crosshair-label--volume\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n";
	},"21":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "    <div class=\"compare "
	    + alias4(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n        <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias4(((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ticker","hash":{},"data":data}) : helper)))
	    + "</span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(container.lambda(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n        </div>\n    </div>\n";
	},"22":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                <span class=\"mkts-cmpt-svgcht-crosshair-legend compare-legend\" style=\"color: "
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span> ";
	},"24":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "\n    <div class=\"compare "
	    + alias4(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n        <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias4(((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ticker","hash":{},"data":data}) : helper)))
	    + "</span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(container.lambda(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n        </div>\n    </div>\n";
	},"26":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});
	
	  return "\n    <div class=\"events "
	    + container.escapeExpression(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n        <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(27, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.frequency : stack1),{"name":"if","hash":{},"fn":container.program(29, data, 0),"inverse":container.program(31, data, 0),"data":data})) != null ? stack1 : "")
	    + "        </div>\n    </div>\n";
	},"27":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                <span class=\"mkts-cmpt-svgcht-crosshair-legend event-legend\" style=\"color: "
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span>";
	},"29":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;
	
	  return "                <div class=\"mkts-components-svgchart-crosshair-left\">\n                    <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias1(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data}) : helper)))
	    + "</span>\n                    <span class=\"mkts-cmpt-svgcht-crosshair-frequency-text-size\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.frequency : stack1), depth0))
	    + "</span>\n                </div>\n                <div class=\"mkts-components-svgchart-crosshair-right\">\n                    <span class=\"mkts-cmpt-svgcht-crosshair-date\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.date : stack1), depth0))
	    + "</span>\n                    <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n                </div>\n";
	},"31":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;
	
	  return "                <div class=\"mkts-components-svgchart-crosshair-left\">\n                    <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias1(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"name","hash":{},"data":data}) : helper)))
	    + "</span>\n                </div>\n                <div class=\"mkts-components-svgchart-crosshair-right\">\n                    <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n                    <span class=\"mkts-cmpt-svgcht-crosshair-date\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.date : stack1), depth0))
	    + "</span>\n                </div>\n";
	},"33":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=helpers.blockHelperMissing, buffer = 
	  "\n    <div class=\"compare "
	    + alias4(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n        <div class=\"ticker\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n            <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias4(((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ticker","hash":{},"data":data}) : helper)))
	    + "</span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(container.lambda(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n        </div>\n";
	  stack1 = ((helper = (helper = helpers.originalPrice || (depth0 != null ? depth0.originalPrice : depth0)) != null ? helper : alias2),(options={"name":"originalPrice","hash":{},"fn":container.program(34, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.originalPrice) { stack1 = alias5.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += " ";
	  stack1 = ((helper = (helper = helpers.fundamentals || (depth0 != null ? depth0.fundamentals : depth0)) != null ? helper : alias2),(options={"name":"fundamentals","hash":{},"fn":container.program(36, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.fundamentals) { stack1 = alias5.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer + "    </div>\n";
	},"34":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"mkts-cmpt-svgcht-compare-data ticker\">\n                <span class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias4(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label","hash":{},"data":data}) : helper)))
	    + "</span>\n                <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data}) : helper)))
	    + "</span>\n            </div>\n        ";
	},"36":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "\n            <div class='mkts-cmpt-svgcht-compare-data ticker'>\n                <span class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias4(((helper = (helper = helpers.label || (depth0 != null ? depth0.label : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label","hash":{},"data":data}) : helper)))
	    + "</span>\n                <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data}) : helper)))
	    + "</span>\n            </div>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=helpers.helperMissing, alias5="function", alias6=helpers.blockHelperMissing, buffer = 
	  "<div class=\"main "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.globalClass : stack1), depth0))
	    + "\">\n"
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.compare : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.compare : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
	    + "    <div class=\"mkts-cmpt-svgcht-crosshair-label\">\n"
	    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.compare : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(11, data, 0),"data":data})) != null ? stack1 : "")
	    + "    </div>\n    <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.growth : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n</div>\n"
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChange : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.valueChangePercent : stack1),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "\n"
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.originalPrice : stack1),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + " "
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>\n";
	  stack1 = ((helper = (helper = helpers.fundamentals || (depth0 != null ? depth0.fundamentals : depth0)) != null ? helper : alias4),(options={"name":"fundamentals","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.fundamentals) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += " ";
	  stack1 = ((helper = (helper = helpers.indicators || (depth0 != null ? depth0.indicators : depth0)) != null ? helper : alias4),(options={"name":"indicators","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.indicators) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += " ";
	  stack1 = ((helper = (helper = helpers.events || (depth0 != null ? depth0.events : depth0)) != null ? helper : alias4),(options={"name":"events","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.events) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += " ";
	  stack1 = ((helper = (helper = helpers.compare || (depth0 != null ? depth0.compare : depth0)) != null ? helper : alias4),(options={"name":"compare","hash":{},"fn":container.program(33, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias5 ? helper.call(alias3,options) : helper));
	  if (!helpers.compare) { stack1 = alias6.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer;
	},"useData":true});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;
	
	  return "    <div class=\"popover-close-date\">"
	    + alias4(((helper = (helper = helpers.closeDateLabel || (depth0 != null ? depth0.closeDateLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"closeDateLabel","hash":{},"data":data}) : helper)))
	    + "</div>\n    <div class=\"mkts-cmpt-svgcht-crosshair-datetime\">"
	    + alias4(((helper = (helper = helpers.datetime || (depth0 != null ? depth0.datetime : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"datetime","hash":{},"data":data}) : helper)))
	    + "</div>\n    <div class=\"main-growth-value\">\n        <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias4(((helper = (helper = helpers.valueLabel || (depth0 != null ? depth0.valueLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"valueLabel","hash":{},"data":data}) : helper)))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(((helper = (helper = helpers.value || (depth0 != null ? depth0.value : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"value","hash":{},"data":data}) : helper)))
	    + "</div>\n    </div>\n    <div class=\"main-growth\">\n        <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.growth : depth0)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.growth : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <div class=\"growth\">\n        <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.growth : depth0)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.growth : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda;
	
	  return "    <div class=\"events\">\n        <div class=\"growth\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            <span class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
	    + "</span>\n            <br clear=\"all\" />\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias3(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-event-datetime\">"
	    + alias2(alias3(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.date : stack1), depth0))
	    + "</span>\n        </div>\n    </div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "			<span class=\"mkts-cmpt-svgcht-crosshair-legend compare-legend\" style=\"color: "
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=helpers.blockHelperMissing, buffer = 
	  "<div class=\"crosshair-popover\">\n";
	  stack1 = ((helper = (helper = helpers.main || (depth0 != null ? depth0.main : depth0)) != null ? helper : alias2),(options={"name":"main","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.main) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.compare || (depth0 != null ? depth0.compare : depth0)) != null ? helper : alias2),(options={"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.compare) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.events || (depth0 != null ? depth0.events : depth0)) != null ? helper : alias2),(options={"name":"events","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.events) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer + "</div>\n";
	},"useData":true});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, alias5=container.lambda;
	
	  return "    <div class=\"popover-close-date\">"
	    + alias4(((helper = (helper = helpers.closeDateLabel || (depth0 != null ? depth0.closeDateLabel : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"closeDateLabel","hash":{},"data":data}) : helper)))
	    + "</div>\n    <div class=\"mkts-cmpt-svgcht-crosshair-datetime\">"
	    + alias4(((helper = (helper = helpers.datetime || (depth0 != null ? depth0.datetime : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"datetime","hash":{},"data":data}) : helper)))
	    + "</div>\n    <div class=\"main-growth-value\">\n        <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.navValue : depth0)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias4(alias5(((stack1 = (depth0 != null ? depth0.navValue : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=container.escapeExpression, alias2=container.lambda;
	
	  return "    <div class=\"growth\">\n        <span class=\"mkts-cmpt-svgcht-crosshair-name\">"
	    + alias1(((helper = (helper = helpers.ticker || (depth0 != null ? depth0.ticker : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"ticker","hash":{},"data":data}) : helper)))
	    + "</span>\n        <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.navValue : depth0)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias1(alias2(((stack1 = (depth0 != null ? depth0.navValue : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n";
	},"5":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda;
	
	  return "    <div class=\"events\">\n        <div class=\"growth\">\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "            <span class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(((helper = (helper = helpers.name || (depth0 != null ? depth0.name : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"name","hash":{},"data":data}) : helper)))
	    + "</span>\n            <br clear=\"all\" />\n            <span class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias3(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</span>\n            <span class=\"mkts-cmpt-svgcht-crosshair-event-datetime\">"
	    + alias2(alias3(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.date : stack1), depth0))
	    + "</span>\n        </div>\n    </div>\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "			<span class=\"mkts-cmpt-svgcht-crosshair-legend compare-legend\" style=\"color: "
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3="function", alias4=helpers.blockHelperMissing, buffer = 
	  "<div class=\"crosshair-popover\">\n";
	  stack1 = ((helper = (helper = helpers.main || (depth0 != null ? depth0.main : depth0)) != null ? helper : alias2),(options={"name":"main","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.main) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.compare || (depth0 != null ? depth0.compare : depth0)) != null ? helper : alias2),(options={"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.compare) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.events || (depth0 != null ? depth0.events : depth0)) != null ? helper : alias2),(options={"name":"events","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.events) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer + "</div>";
	},"useData":true});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <div class='mkts-cmpt-svgcht-crosshair-item'>\n        <span class=\"mkts-cmpt-svgcht-crosshair-legend mainChart-legend\" style=\"color: "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.color : stack1), depth0))
	    + ";\"></span>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\"> "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.growth : stack1)) != null ? stack1.value : stack1), depth0))
	    + " </div>     \n    </div>\n";
	},"3":function(container,depth0,helpers,partials,data) {
	    var stack1;
	
	  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.navValue : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "        <div class='mkts-cmpt-svgcht-crosshair-item'>\n            <span class=\"mkts-cmpt-svgcht-crosshair-legend mainChart-legend\" style=\"color: "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.color : stack1), depth0))
	    + ";\"></div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">  "
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.navValue : stack1)) != null ? stack1.value : stack1), depth0))
	    + " </div>     \n        </div> \n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, alias1=container.lambda, alias2=container.escapeExpression;
	
	  return "    <div class=\"volume volume-with-growth\">\n        <div class=\"mkts-cmpt-svgcht-crosshair-label\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1)) != null ? stack1.label : stack1), depth0))
	    + "</div>\n        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;
	
	  return "<div class=\"compare "
	    + alias2(((helper = (helper = helpers.globalClass || (depth0 != null ? depth0.globalClass : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"globalClass","hash":{},"data":data}) : helper)))
	    + "\">\n    <div class='mkts-cmpt-svgcht-crosshair-item'>\n"
	    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showLegend : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "        <div class=\"mkts-cmpt-svgcht-crosshair-value\">"
	    + alias2(container.lambda(((stack1 = (depth0 != null ? depth0.y : depth0)) != null ? stack1.value : stack1), depth0))
	    + "</div>\n    </div>\n</div>\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "		<span class=\"mkts-cmpt-svgcht-crosshair-legend compare-legend\" style=\"color: "
	    + container.escapeExpression(((helper = (helper = helpers.color || (depth0 != null ? depth0.color : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"color","hash":{},"data":data}) : helper)))
	    + ";\"></span>\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), buffer = 
	  "<div class=\"mkts-cmpt-svgcht-crosshair-datetime\">\n    "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.datetime : stack1), depth0))
	    + "</div>\n	<div class=\"main "
	    + alias2(alias1(((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.globalClass : stack1), depth0))
	    + " \">\n"
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.growth : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
	    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.main : depth0)) != null ? stack1.volume : stack1),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
	    + "</div>\n";
	  stack1 = ((helper = (helper = helpers.compare || (depth0 != null ? depth0.compare : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(alias3,options) : helper));
	  if (!helpers.compare) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer;
	},"useData":true});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(9), __webpack_require__(3), __webpack_require__(15), __webpack_require__(17), __webpack_require__(19)], __WEBPACK_AMD_DEFINE_RESULT__ = function(commonPlotter, graphTypes, core, baseChartModel, util, moment) {
	    "use strict";
	    var $ = core.$;
	    var d3 = core.d3;
	
	    /**
	     * Slider chart Model
	     *
	     */
	
	    var model = function(managers) {
	        var eventManager = managers.eventManager;
	        var chartConfigManager = managers.chartConfigManager;
	        var baseChart = baseChartModel(managers);
	        var dataAdapter = managers.dataAdapter;
	
	        var sliderChartExtend = {
	            _init: function(config) {
	                this._innerClass = innerClass;
	                this._bindEvents();
	                this.langData = chartConfigManager.getLabels('markets-components-svgchart', config.lang);
	                this._renderDomFrame();
	                this._decideMinMaxAttrbute();
	                this._getData();
	            },
	            _bindEvents: function() {
	                var eventTypes = eventManager.EventTypes
	                eventManager.bind(eventTypes.UpdateConfig, this._updateConfig, this);
	                eventManager.bind(eventTypes.ChangeIntervalFrequency, this._chartConfigChanged, this);
	                eventManager.bind(eventTypes.LayoutChange, this._changeLayout, this);
	                eventManager.bind(eventTypes.ChangeYAxis, this._chartConfigChanged, this);
	                eventManager.bind([eventTypes.ChangeSliderDateRange, eventTypes.ChangeDateRangeByZoom], this._changeSelectedDateRange, this);
	                eventManager.bind(eventTypes.ChangeIntervalFrequency, this._getData, this);
	                eventManager.bind(eventTypes.ChangeChartType, this._decideMinMaxAttrbute, this);
	            },
	            _updateConfig: function() {
	                this.config = chartConfigManager.getChartConfig(chartConfigManager.ChartTypes.SliderChart);
	            },
	            _getData: function(extendDateRange) {
	                var view = this;
	                var cfg = this.config;
	                view._showLoading();
	                view._loading = true;
	                view._hideDataNotAvailable();
	                view._decideMinMaxAttrbute();
	                chartConfigManager.fetchSliderChartData(extendDateRange ? this._preloadInfo : null,
	                    function(res, preloadInfo) {
	                        view._clearView();
	                        view._data = null;
	                        if (res.status().errorCode === "0") {
	                            view._preloadInfo = preloadInfo;
	                            //view._dynamicValues = {};
	                            var data = res.data()[0].Price.data;
	                            if (data.length > 0) {
	                                data = view._dataInterpolation(data, preloadInfo);
	                                data.forEach(function(d) {
	                                    d.x = d.index;
	                                    d.y = d.close;
	                                });
	                                view._data = data;
	                                view._renderView();
	                            }
	                        }
	
	                        if (!view._data || view._data.length === 0) {
	                            view._showDataNotAvailable();
	                        } else {
	                            view._hideDataNotAvailable();
	                        }
	                        view._hideLoading();
	                        view._loading = false;
	                    });
	            },
	            _chartConfigChanged: function() {
	                ////TODO: Check if just need change brush status.
	            },
	            _clearView: function(chartType) {
	                this._outerGElem && this._outerGElem.selectAll("*").remove();
	            },
	            _dataInterpolation: function(data, preloadInfo) {
	                var frequencyTypes = chartConfigManager.FrequencyTypes;
	                var lastDataItem = data[data.length - 1];
	                var appendedData = $.extend(true, {}, lastDataItem);
	                var today = new Date();
	                var y = today.getFullYear(),
	                    m = today.getMonth(),
	                    d = today.getDate();
	                appendedData.date = new Date(y, m, d + 1);
	                appendedData.index += 1;
	                data.push(appendedData);
	                return data;
	            },
	            _createScale: function() {
	                var yAttr = this.yAttr;
	                this._xScale = this._xScale = d3.scale.linear().range([0, this._validWidth]).domain([0, this._data.length - 1]);
	
	                var minYValue = d3.min(this._data, function(d) {
	                    return d[yAttr];
	                });
	                var maxYValue = d3.max(this._data, function(d) {
	                    return d[yAttr];
	                });
	                var domainScaleup = this.config.domainScaleup
	                var scaleUpValue = (maxYValue - minYValue) * domainScaleup;
	                var yScaleDomain = [minYValue - scaleUpValue, maxYValue + scaleUpValue];
	
	                this._yScale = d3.scale.linear().range([this._validHeight, 0])
	                    .domain(yScaleDomain);
	            },
	            _changeLayout: function() {
	                d3.select(this.config.container).selectAll("div").remove();
	                this._renderDomFrame();
	                if (this._data && (this._data.length > 0)) {
	                    this._renderView();
	                } else {
	                    this._showDataNotAvailable();
	                }
	            },
	            _renderDomFrame: function() {
	                this._caculateValidSize();
	                this._createSvgWrapper();
	                //eventManager.trigger(eventManager.EventTypes.HeightChanged, this);
	            },
	            _renderView: function() {
	                this._createScale();
	                this._decimalPlaces = this._getDecimalPlaces();
	                this._createCommonPlotter();
	                this._drawXAxis();
	                this._drawYAxis();
	                this._drawChart();
	                this._createChartMask();
	                this._createBrush();
	                this._initBrushExtent();
	                //when mouse in the slider chart, we will hide the crossharis
	                d3.select(this.config.container).on('mouseover.sliderchart', function() {
	                    eventManager.trigger(eventManager.EventTypes.ToggleCrossharis);
	                });
	            },
	            _setXAxisStyle: function(selection) {
	                selection.selectAll("text").attr("y", "6").attr("x", "1");
	            },
	            _createCommonPlotter: function() {
	                var graphConfig = this._defaultGraphConfig = {
	                    containerGElem: this._outerGElem,
	                    data: this._data,
	                    xScale: this._xScale,
	                    yScale: this._yScale,
	                    yAttributeName: this.yAttr
	                };
	                this._getDefaultGraphConfig = function() {
	                    this._defaultGraphConfig.data = this._data;
	                    return this._defaultGraphConfig;
	                };
	                this._commonPlotter = new commonPlotter(graphConfig);
	            },
	            _drawChart: function(chartType) {
	                var cfg = this.config;
	                var lineConfig = {
	                    graphType: graphTypes.Line,
	                    graphCss: innerClass.lineChart
	                };
	
	                this._commonDraw(lineConfig);
	
	                var areaConfig = {
	                    graphType: graphTypes.Area,
	                    graphCss: innerClass.mountainChart,
	                    y0Value: this._validHeight,
	                };
	
	                this._commonDraw(areaConfig);
	            },
	            _createChartMask: function() {
	                var brushMaskAttrValue = {
	                    "width": this._validWidth,
	                    "class": innerClass.brushMask,
	                    "height": this._validHeight
	                };
	                this._brushMaskLeftElem = this._outerGElem.append("rect").attr(brushMaskAttrValue);
	                this._brushMaskRightElem = this._outerGElem.append("rect").attr(brushMaskAttrValue).attr("x", this._validWidth);
	            },
	            _createBrush: function() {
	                var cfg = this.config;
	                var view = this;
	
	                var config = {
	                    graphType: graphTypes.Brush,
	                    graphCss: innerClass.brush,
	                    yValue: 0,
	                    height: this._validHeight, //this._validHeight + 7,
	                    brushImages: cfg.brushImages,
	                    brushImagesXAdjust: -11,
	                    brushImagesWidth: 22,
	                    brushResponseFunc: function() {
	                        view._brushResponse.apply(view, arguments);
	                    },
	                    brushEndResponseFunc: function() {
	                        view._brushEndResponse.apply(view, arguments);
	                    },
	                    setExtentFunc: function(callback) {
	                        view._changeBrushExtent = callback;
	                    }
	                };
	
	                this._commonDraw(config);
	            },
	            //Will be overwrite by brush function
	            _changeBrushExtent: function() {},
	            _changeSelectedDateRange: function(dateRange) {
	                if ($.isArray(this._data) && dateRange && dateRange.length === 2) {
	                    var startDate = dateRange[0];
	                    var endDate = dateRange[1];
	                    if (startDate < this._data[0].date && !this._loading) {
	                        this._getData();
	                    } else {
	                        startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
	                        endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate() + 1);
	                        var startIndex = this._getDataIndexByDate(startDate);
	                        var endIndex = this._getDataIndexByDate(endDate);
	                        startIndex = Math.floor(startIndex);
	                        endIndex = Math.ceil(endIndex);
	                        this._setBrushExtent(startIndex, endIndex);
	                    }
	                }
	            },
	            _setBrushExtent: function(startIndex, endIndex) {
	                this._changeBrushExtent([startIndex, endIndex]);
	                this._brushResponse(null, null, [startIndex, endIndex]);
	                this._checkIfNeedLoadMoreData(startIndex);
	            },
	            _checkIfNeedLoadMoreData: function(startIndex) {
	                if (startIndex === 0 &&
	                    !this._loading &&
	                    (this._preloadInfo.intervalType !== chartConfigManager.IntervalTypes.Max)) {
	                    this._getData(true); //get more data.
	                }
	            },
	            _initBrushExtent: function() {
	                var dateRange = this.config.dateRange;
	                if (!dateRange || dateRange.length !== 2) {
	                    eventManager.trigger(eventManager.EventTypes.GetMainChartDateRange);
	                } else {
	                    this._changeSelectedDateRange(dateRange);
	                }
	            },
	            _brushResponse: function(brushFunc, eventTarget, brushDomain) {
	                if (brushFunc && eventTarget) {
	                    var s = d3.event.target.extent();
	                    var miniRange = 0.5;
	                    if (s[1] - s[0] <= miniRange) {
	                        var extentValue;
	                        if (s[1] > (this._data.length / 2)) {
	                            extentValue = [s[1] - miniRange, s[1]];
	                        } else {
	                            extentValue = [s[0], s[0] + miniRange];
	                        }
	                        d3.event.target.extent(extentValue);
	                        d3.event.target(d3.select(eventTarget));
	                        brushDomain = extentValue;
	                    }
	                }
	
	                var brushExtentIsEmpty;
	                if (!brushDomain && brushFunc) {
	                    brushExtentIsEmpty = brushFunc.empty();
	                    brushDomain = brushExtentIsEmpty ? this._xScale.domain() : brushFunc.extent();
	                } else {
	                    brushExtentIsEmpty = false;
	                }
	
	                if (brushDomain) {
	                    var startIndex = Math.floor(brushDomain[0]);
	                    var startDate = this._data[startIndex].date;
	                    var endIndex = Math.ceil(brushDomain[1]);
	                    var endDate, now = new Date();
	                    if (endIndex >= this._data.length) {
	                        endDate = now;
	                    } else {
	                        endDate = this._data[endIndex].date;
	                    }
	
	                    if (endDate > now) {
	                        endDate = now;
	                    }
	                    brushFunc && eventManager.trigger(eventManager.EventTypes.UpdateMenuInterval, [startDate, endDate]);
	                }
	
	                var view = this;
	                this._brushMaskLeftElem.attr("x", function() {
	                    return brushExtentIsEmpty ? 0 : (view._xScale(brushDomain[0]) - view._validWidth);
	                });
	                this._brushMaskRightElem.attr("x", function() {
	                    return brushExtentIsEmpty ? view._validWidth : view._xScale(brushDomain[1]);
	                });
	            },
	            _brushEndResponse: function(brushFunc) {
	                var brushExtentIsEmpty = brushFunc.empty();
	                var brushDomain = brushExtentIsEmpty ? this._xScale.domain() : brushFunc.extent();
	                var startIndex = Math.floor(brushDomain[0]);
	                var startDate = this._data[startIndex].date;
	                var endIndex = Math.ceil(brushDomain[1]);
	                var endDate, now = new Date();
	                if (endIndex >= this._data.length) {
	                    endDate = now;
	                } else {
	                    endDate = this._data[endIndex].date;
	                }
	
	                if (endDate > now) {
	                    endDate = now;
	                }
	
	                var dateRange = [startDate, endDate];
	                var rootConfig = chartConfigManager.getConfig();
	                eventManager.trigger(eventManager.EventTypes.RequestFrequencyFromMenu, dateRange, true);
	                this._checkIfNeedLoadMoreData(startIndex);
	                eventManager.trigger(eventManager.EventTypes.onDateRangeChange, {
	                    name: 'sliderChartRange',
	                    value: {
	                        startDate: moment(startDate).format(rootConfig.intradayDateFormater),
	                        endDate: moment(endDate).format(rootConfig.intradayDateFormater)
	                    }
	                });
	                //eventManager.trigger(eventManager.EventTypes.UpdateMenuInterval, [startDate, endDate]);
	            },
	            _showDataNotAvailable: function() {
	                if (!this._svg) {
	                    return;
	                }
	                if (this._outerGElem) {
	                    this._outerGElem.selectAll("g").remove();
	                }
	                if (this.config && this.config.container) {
	                    $(this.config.container).hide();
	                }
	            },
	
	            _hideDataNotAvailable: function() {
	                $(this.config.container).show();
	            }
	
	        };
	
	        return util.extendClass(baseChart, sliderChartExtend);
	    }
	    var innerClass = {
	        xAxis: "sliderChart-xAxis",
	        lineChart: "sliderChart-line",
	        mountainChart: "sliderChart-mountain",
	        brush: "sliderChart-brush",
	        brushMask: "sliderChart-brushMask",
	        chartBody: 'sliderChart-body',
	    };
	
	    return model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(9), __webpack_require__(3), __webpack_require__(15), __webpack_require__(17),
	        __webpack_require__(10), __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(commonPlotter, graphTypes, core, baseChartModel, util, barSeries, request) {
	        "use strict";
	        var $ = core.$;
	        var d3 = core.d3;
	
	        /**
	         * indicator chart Model
	         *
	         */
	        var model = function(managers) {
	            var eventManager = managers.eventManager;
	            var chartConfigManager = managers.chartConfigManager;
	            var baseChart = baseChartModel(managers);
	            var dataAdapter = managers.dataAdapter;
	            var rootCfg;
	
	            var indicatorChartExtend = {
	                _init: function(config) {
	                    this._innerClass = innerClass;
	                    rootCfg = chartConfigManager.getConfig();
	                    this.langData = chartConfigManager.getLabels('markets-components-svgchart', config.lang);
	                    this._chartTypes = chartConfigManager.IndicatorChartTypes;
	                    this._bindEvents();
	                    this._decideMinMaxAttrbute();
	                    if (rootCfg.indicators && rootCfg.indicators.length > 0) {
	                        this._updateViewData();
	                    }
	                },
	                _reviseData: function(data) {
	                    data.forEach(function(d) {
	                        d.x = d.index;
	                        d.y = d.value;
	                    });
	                    return data;
	                },
	                _bindEvents: function() {
	                    var eventTypes = eventManager.EventTypes
	                    eventManager.bind(eventTypes.UpdateConfig, this._updateConfig, this);
	                    eventManager.bind(eventTypes.ChangeIndicators, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeFundamental, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeXAxisDomain, this._changeLastDateRange, this);
	                    eventManager.bind(eventTypes.ToggleTrackballIndicators, this._toggleTrackball, this);
	                    eventManager.bind(eventTypes.DestroyChart, this._processDestroyChart, this);
	                    eventManager.bind(eventTypes.ChangeStartDate, this._chartConfigChanged, this);
	                },
	                _bindAfterOpenIndicatorEvents: function() {
	                    if (!this._isInited) {
	                        var eventTypes = eventManager.EventTypes
	                        eventManager.bind(eventTypes.ChangeXAxisDomain, this._changeXAxisScaleDomain, this);
	                        eventManager.bind(eventTypes.UpdateCompareTickers, this._chartConfigChanged, this);
	                        eventManager.bind(eventTypes.LayoutChange, this._changeLayout, this);
	                        eventManager.bind(eventTypes.ChangeYAxis, this._changeYaxis, this);
	                        eventManager.bind(eventTypes.FetchPreloadData, this._fetchPreloadData, this);
	                        eventManager.bind(eventTypes.ChangeIntervalFrequency, this._changDataRange, this);
	                        eventManager.bind(eventTypes.ChangeEvents, this._chartConfigChanged, this);
	                        eventManager.bind(eventTypes.DrawNewData, this._chartConfigChanged, this);
	                        eventManager.bind(eventTypes.ShowTrackball, this._showTrackball, this);
	                        eventManager.bind(eventTypes.ChangeChartType, this._decideMinMaxAttrbute, this);
	                        this._isInited = true;
	                    }
	                },
	                _toggleTrackball: function(trackballData) {
	                    var cfg = this.config;
	                    var runningIndex = 0,
	                        chartTypeName = '';
	                    var view = this;
	                    trackballData.forEach(function(d) {
	                        if (!d.data) {
	                            return;
	                        }
	                        var newChartTypeName = d.name;
	                        newChartTypeName = newChartTypeName.replace(' ', '');
	                        if (chartTypeName !== newChartTypeName) {
	                            runningIndex = 0;
	                            chartTypeName = newChartTypeName;
	                        }
	                        var tickerValueElement = view.$el.find('.' + innerClass.indicatorsValue + chartTypeName + runningIndex);
	                        if (tickerValueElement) {
	                            tickerValueElement.css('color', d.color);
	                            tickerValueElement.text((d.data && !isNaN(d.data.y)) ? util.formatNotZeroNum(d.data.y, 2) : '--');
	                        }
	                        runningIndex += 1;
	                    });
	                },
	                _updateConfig: function() {
	                    this.config = chartConfigManager.getChartConfig(chartConfigManager.ChartTypes.IndicatorChart);
	                },
	                _chartConfigChanged: function() {
	                    this._updateViewData();
	                },
	                _changeYaxis: function(position) {
	                    if (this.config.yAxis.position == "outer") {
	                        var translate = this._getGElemTranslate();
	                        this._outerGElem && this._outerGElem.attr("transform", translate);
	                    }
	                    this._chartConfigChanged();
	                },
	                _updateViewData: function(adjustedDateRange) {
	                    var view = this;
	                    var cfg = this.config;
	                    view._showLoading();
	                    view._loading = true;
	                    view._hideDataNotAvailable();
	                    this._cancelNotRunedPreload();
	                    chartConfigManager.fetchMainTickerData(function(res, preloadInfo) {
	                        view._clearAllData();
	                        view._clearView();
	                        if (res.status().errorCode === "0") {
	                            view._preloadInfo = preloadInfo;
	                            var resDataArr = res.data();
	                            var mainTickerData = resDataArr[0];
	                            view._indicatorsData = mainTickerData.Indicators;
	                            view.mainTickerObject = mainTickerData.tickerObject;
	                            view._lastClosePrice = mainTickerData.Price.spos;
	                            view._data = view._reviseData(mainTickerData.Price.data);
	                            view._eventsData = mainTickerData.Events;
	                            if (chartConfigManager.getMainDataType() === chartConfigManager.MainDataTypes.DividendEffect) {
	                                //removing indicators that are shown in main chart
	                                var indicators = null;
	                                for (var indicatorName in view._indicatorsData) {
	                                    if (cfg.indicatorProperties.hasOwnProperty(indicatorName)) {
	                                        indicators = indicators || {};
	                                        indicators[indicatorName] = view._indicatorsData[indicatorName];
	                                    }
	                                }
	                                view._indicatorsData = indicators ? indicators : null;
	                                var fundamentalType = dataAdapter.Fundamental.MReturnIndex;
	                                if (mainTickerData.Fundamentals && mainTickerData.Fundamentals[fundamentalType] &&
	                                    mainTickerData.Fundamentals[fundamentalType].data) {
	                                    view._dividendEffectData = view._reviseDividendEffectData(mainTickerData.Fundamentals[fundamentalType].data);
	                                }
	                            } else {
	                                view._getCompareData(res.data());
	                                view._createDummyData(view._compareData);
	                                preloadInfo.loadedCompareData = view._compareData;
	                            }
	                            view._rebaseCompareData();
	                            view._rebaseFundamentalData();
	                            view._changeChartGraph();
	                            if (preloadInfo.intervalType !== chartConfigManager.IntervalTypes.Max && !chartConfigManager.getConfig().useEUTimeSeriesData) {
	                                setTimeout(function() {
	                                    view._preloading = true;
	                                    view._loadingData = true;
	                                    view._fetchPreloadData();
	                                }, view.config.preloadDelay);
	                            }
	                        }
	
	                        view._hideLoading();
	                        view._loading = false;
	                    }, adjustedDateRange);
	                },
	                _showDataNotAvailable: function(type) {
	                    if (!this._svg) {
	                        return;
	                    }
	                    this._clearGElem();
	                    var elem = this._svg.append('g').append('text').attr("transform", "translate(" + this._validWidth / 2 + "," + this.config.height / 2 + ")");
	                    var message = this.langData['datanotavailable'];
	                    if (type == "changeToDailyFreq") {
	                        message = this.langData['changetodailyfrequency'];
	                    }
	                    var textWidth = this._getTextWidthHeight(message).width;
	                    //text need to be wraped when too long
	                    if (textWidth > (this._validWidth - 20)) {
	                        var mesArr = message.split('|');
	                        for (var i in mesArr) {
	                            elem.append('tspan')
	                                .attr('class', 'dataNotAvailable')
	                                .attr('dy', i * 1.5 + 'em')
	                                .attr('x', '0')
	                                .text(mesArr[i]);
	                        }
	                    } else {
	                        message = message.replace('|', '');
	                        elem.append('tspan')
	                            .attr('class', 'dataNotAvailable')
	                            .text(message);
	                    }
	                    this._$DataNotAvailableElem = elem;
	
	                },
	                _clearGElem: function(chartType) {
	                    if (this._svg) {
	                        this._svg.selectAll("g").remove();
	                    }
	                    this._clearTrackball();
	                },
	                _changeLastDateRange: function(newXDomainValue, lastDateRange) {
	                    this._lastDateRange = lastDateRange;
	                },
	                _displayViewAfterChangeDomain: function() {
	                    this._clearView();
	                    this._changeChartGraph();
	                },
	                _changeChartGraph: function() {
	                    //this._changeScaleDomain();
	                    this._draw_Indicators();
	                    eventManager.trigger(eventManager.EventTypes.HeightChanged);
	                },
	                _draw_Indicators: function() {
	                    var indicatorsData = this._indicatorsData;
	                    if (!indicatorsData) {
	                        return;
	                    }
	                    this._caculateValidSize();
	                    var view = this;
	                    var cfg = this.config;
	                    for (var indicatorName in indicatorsData) {
	                        if (cfg.indicatorProperties.hasOwnProperty(indicatorName)) {
	                            indicatorsData[indicatorName].forEach(function(s, chartIndex) {
	                                var index = 0;
	                                s.data.forEach(function(d) {
	                                    d.x = index++;
	                                    d.y = d.value;
	                                });
	                                if (chartIndex === 0) {
	                                    view._renderView(indicatorName, s.data);
	                                }
	                                if (s.DailyDataPoint) {
	                                    view._showDataNotAvailable('changeToDailyFreq');
	                                    return;
	                                }else if(!(s.data && s.data.length)){
	                                    view._showDataNotAvailable();
	                                }
	                                if (cfg.indicatorProperties[indicatorName].chartTypes) {
	                                    var typeOfChart = cfg.indicatorProperties[indicatorName].chartTypes[chartIndex];
	                                    view["_draw_" + typeOfChart + "_Indicators"](s.data, indicatorName, 'lineChart', chartIndex);
	                                } else {
	                                    view._draw_lineChart_Indicators(s.data, indicatorName, 'lineChart', chartIndex);
	                                }
	                            });
	                        }
	                    }
	                },
	                _draw_histogram_Indicators: function(data, indicatorName, chartType, chartIndex) {
	                    var cfg = this.config;
	                    var view = this;
	                    var baseValue = 0; // MACD
	                    // var baseValue = d3.min(data, function(d) {
	                    //     return d.value;
	                    // });
	                    // baseValue = baseValue >= 0 ? 0 : baseValue;
	                    var graphConfig = {
	                        data: data,
	                        graphCss: innerClass.indicators + " " + indicatorName + "-" + chartIndex + "-class",
	                        color: this.config.indicatorProperties[indicatorName].color[chartIndex],
	                        insertBeforeCss: innerClass.indicators,
	                        yAttributeName: "value",
	                        graphType: graphTypes.Histogram,
	                        baseValue: baseValue,
	                        tickSize: 1,
	                        getElementsMapping: function(elementsMapping) {
	                            var mapping = view._elementsMapping || [];
	                            mapping.push(elementsMapping);
	                            view._elementsMapping = mapping;
	                        }
	                    };
	
	                    this["_elem_" + chartType] = this._commonDraw(graphConfig);
	                },
	                _createScale: function(indicatorName) {
	                    this._xScale = d3.scale.linear()
	                        .range([0, this._validWidth])
	                        .domain([0, this._data.length - 1]);
	
	                    var fixedTickValeus = this.config.indicatorProperties[indicatorName].fixedTickValeus;
	                    var yScaleData;
	                    if (fixedTickValeus) {
	                        yScaleData = {
	                            domain: [fixedTickValeus[0], fixedTickValeus[fixedTickValeus.length - 1]],
	                            tickValues: fixedTickValeus
	                        };
	                    } else {
	                        var minYValue = [];
	                        var maxYValue = [];
	
	                        this._indicatorsData[indicatorName].forEach(function(s) {
	                            minYValue.push(d3.min(s.data, function(d) {
	                                return d.value;
	                            }));
	                            maxYValue.push(d3.max(s.data, function(d) {
	                                return d.value;
	                            }));
	                        });
	
	                        minYValue = d3.min(minYValue);
	                        maxYValue = d3.max(maxYValue);
	                        isNaN(minYValue) && (minYValue = 0);
	                        isNaN(maxYValue) && (maxYValue = 0);
	
	                        var mthTickValeus = this.config.indicatorProperties[indicatorName].mthTickValeus;
	                        if (mthTickValeus) {
	                            var tickValues = [minYValue];
	                            for (var i = 0, l = mthTickValeus.length, tickValue; i < l; i++) {
	                                tickValue = mthTickValeus[i];
	                                if (tickValues.indexOf(tickValue) === -1) {
	                                    tickValues.push(tickValue);
	                                }
	                            }
	                            if (tickValues.indexOf(maxYValue) === -1) {
	                                tickValues.push(maxYValue);
	                            }
	                            yScaleData = {
	                                domain: [tickValues[0], tickValues[tickValues.length - 1]],
	                                tickValues: tickValues
	                            };
	                        } else {
	                            yScaleData = this._calculateYScaleDomainTickValues(minYValue, maxYValue);
	                        }
	                    }
	                    this._yTickValues = yScaleData.tickValues;
	                    this._yScale = d3.scale.linear().range([this._validHeight, 0])
	                        .domain(yScaleData.domain);
	                },
	                _setScaleDomain: function() {},
	                _clearView: function() {
	                    rootCfg.$componentContainer.find("." + this.config.chartClass).empty();
	                    this._clearTrackball();
	                },
	                _changeLayout: function() {
	                    this._rebaseCompareData();
	                    this._clearView();
	                    this._changeChartGraph();
	                },
	                _processDestroyChart: function() {
	                    this._svg && this._svg.on('.indicatorchart', null);
	                },
	                _renderView: function(indicatorName) {
	                    //when open a save config, maybe we need draw indicators.
	                    var view = this;
	                    this._renderHeader(indicatorName);
	                    this._createScale(indicatorName);
	                    this._createSvgWrapper(indicatorName);
	                    this._createCommonPlotter();
	                    this._renderContainedViews();
	                    this._renderFooter(indicatorName);
	                    this._bindAfterOpenIndicatorEvents();
	                    //when mouse move in the indicatorchart, we will show crosshairs, waiting to get main chart data
	                    this._svg.on('mousemove.indicatorchart', function() {
	                        view._mousemove(d3.event, d3.mouse(this), view._headerHeight);
	                    });
	                },
	                _renderContainedViews: function() {
	                    this._caculateValidSize();
	                    this._drawXAxis();
	                    this._drawYAxis();
	                    this._drawGridLines();
	                },
	                _createCommonPlotter: function() {
	                    var graphConfig = this._defaultGraphConfig = {
	                        containerGElem: this._outerGElem,
	                        yAxisContainerGElem: this._yAxisOuterGElem,
	                        xScale: this._xScale,
	                        yScale: this._yScale,
	                        graphType: graphTypes.Histogram,
	                        width: this._validWidth,
	                        height: this._validHeight,
	                        tickSize: this.config.indicatorBarWidth
	                    };
	                    this._getDefaultGraphConfig = function() {
	                        return this._defaultGraphConfig;
	                    };
	                    this._commonPlotter = new commonPlotter(graphConfig);
	                },
	                _renderHeader: function(indicatorName) {
	                    var cfg = this.config,
	                        margin = this.config.margin;
	                    var tickerInfoContainer = this._headerContainer = d3.select(cfg.container)
	                        .append("div").classed(innerClass.chartHeader, true)
	                        .classed(indicatorName + '-class', true);
	                    tickerInfoContainer.append("span").classed(innerClass.chartLegend, true)
	                        .style("background", "#2F4880");
	                    tickerInfoContainer.append("span")
	                        .style("margin-left", margin.left + "px")
	                        .style("width", (this.config.width - margin.left - margin.right) + "px")
	                        .classed(innerClass.chartLegendText, true)
	                        .text(cfg.chartLegendText);
	                    this._headerContainer.append("span").classed(innerClass.compare, true);
	                    this._headerContainer.append("span").classed(innerClass.indicators, true);
	                    this._appendHeaderForIndicators(indicatorName);
	                },
	                _renderFooter: function(indicatorName) {
	                    var cfg = this.config,
	                        margin = this.config.margin;
	                    d3.select(cfg.container)
	                        .append("div").classed(innerClass.chartFooter, true)
	                        .classed(indicatorName + '-class', true)
	                        .style("margin-left", margin.left + "px")
	                        .style("width", (this.config.width - margin.left - margin.right) + "px")
	                }
	            };
	
	            return util.extendClass(baseChart, indicatorChartExtend);
	        };
	
	        var innerClass = {
	            gridLines: "indicatorChart-gridLines",
	            indicatorChart: "chart-indicator",
	            chartHeader: "indicatorChart-header",
	            chartLegend: "indicatorChart-legend",
	            chartLegendText: "indicatorChart-legend-text",
	            chartBody: 'indicatorChart-body',
	            chartFooter: "indicatorChart-footer",
	            indicators: "indicators",
	            indicatorsLegend: "indicators-legend",
	            indicatorsValue: "indicatorsValue-",
	            indicatorsLegendText: "indicators-legend-text",
	            closeButton: "icon chart close-button",
	            yAxis: "indicatorChart-yAxis"
	        };
	
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8), __webpack_require__(9), __webpack_require__(3), __webpack_require__(15), __webpack_require__(17),
	        __webpack_require__(10), __webpack_require__(20)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(commonPlotter, graphTypes, core, baseChartModel, util, barSeries, request) {
	        "use strict";
	        var $ = core.$;
	        var d3 = core.d3;
	
	        /**
	         * fundamental chart Model
	         *
	         */
	        var model = function(managers) {
	            var eventManager = managers.eventManager;
	            var chartConfigManager = managers.chartConfigManager;
	            var baseChart = baseChartModel(managers);
	            var dataAdapter = managers.dataAdapter;
	            var rootCfg;
	
	            var fundamentalChartExtend = {
	                _init: function(config) {
	                    this._innerClass = innerClass;
	                    rootCfg = chartConfigManager.getConfig();
	                    this.langData = chartConfigManager.getLabels('markets-components-svgchart', config.lang);
	                    this._isFundamentalChart = true;
	                    this._chartTypes = chartConfigManager.FundamenatlChartTypes
	                    this._bindEvents();
	                    this._decideMinMaxAttrbute();
	                    if (rootCfg.fundamentals && rootCfg.fundamentals.length > 0) {
	                        this._updateViewData();
	                    }
	                },
	                _reviseData: function(data) {
	                    data.forEach(function(d) {
	                        d.x = d.index;
	                        d.y = d.value;
	                    });
	                    return data;
	                },
	                _bindEvents: function() {
	                    var eventTypes = eventManager.EventTypes
	                    eventManager.bind(eventTypes.UpdateConfig, this._updateConfig, this);
	                    eventManager.bind(eventTypes.ChangeFundamental, this._chartConfigChanged, this);
	                    eventManager.bind(eventTypes.ChangeXAxisDomain, this._changeLastDateRange, this);
	                    eventManager.bind(eventTypes.DestroyChart, this._processDestroyChart, this);
	                    eventManager.bind(eventTypes.ChangeStartDate, this._chartConfigChanged, this);
	                },
	                _bindAfterOpenFundamentalEvents: function() {
	                    if (!this._isInited) {
	                        var eventTypes = eventManager.EventTypes
	                        eventManager.bind(eventTypes.ChangeIndicators, this._chartConfigChanged, this);
	                        eventManager.bind(eventTypes.ChangeXAxisDomain, this._changeXAxisScaleDomain, this);
	                        eventManager.bind(eventTypes.UpdateCompareTickers, this._chartConfigChanged, this);
	                        eventManager.bind(eventTypes.LayoutChange, this._changeLayout, this);
	                        eventManager.bind(eventTypes.ChangeYAxis, this._chartConfigChanged, this);
	                        eventManager.bind(eventTypes.FetchPreloadData, this._fetchPreloadData, this);
	                        eventManager.bind(eventTypes.ChangeIntervalFrequency, this._changDataRange, this);
	                        eventManager.bind(eventTypes.ChangeEvents, this._changeYaxis, this);
	                        eventManager.bind(eventTypes.ToggleTrackballFundamentals, this._toggleTrackball, this);
	                        eventManager.bind(eventTypes.DrawNewData, this._chartConfigChanged, this);
	                        eventManager.bind(eventTypes.ShowTrackball, this._showTrackball, this);
	                        eventManager.bind(eventTypes.ChangeChartType, this._decideMinMaxAttrbute, this);
	                        this._isInited = true;
	                    }
	                },
	                _changeLastDateRange: function(newXDomainValue, lastDateRange) {
	                    this._lastDateRange = lastDateRange;
	                },
	                _toggleTrackball: function(trackballData) {
	                    var cfg = this.config;
	                    trackballData.forEach(function(d) {
	                        var tickerValueElement = rootCfg.$componentContainer.find('.' + innerClass.fundamentalsValue + d.name);
	                        if (tickerValueElement) {
	                            tickerValueElement.css('color', d.color);
	                            tickerValueElement.text((d.data && !isNaN(d.data.y)) ? util.formatNotZeroNum(d.data.y, 2) : '--');
	                        }
	                    });
	                },
	                _updateConfig: function() {
	                    this.config = chartConfigManager.getChartConfig(chartConfigManager.ChartTypes.FundamentalChart);
	                },
	                _chartConfigChanged: function() {
	                    this._updateViewData();
	                },
	                _changeYaxis: function(position) {
	                    if (this.config.yAxis.position == "outer") {
	                        var translate = this._getGElemTranslate();
	                        this._outerGElem && this._outerGElem.attr("transform", translate);
	                    }
	                    this._chartConfigChanged();
	                },
	                _updateViewData: function(adjustedDateRange) {
	                    var view = this;
	                    var cfg = this.config;
	                    chartConfigManager.fetchMainTickerData(function(res, preloadInfo) {
	                        view._clearAllData();
	                        view._clearView();
	                        if (res.status().errorCode === "0") {
	                            view._preloadInfo = preloadInfo;
	                            var mainTickerData = res.data()[0];
	                            view._fundamentalsData = mainTickerData.Fundamentals;
	                            view._indicatorsData = mainTickerData.Indicators;
	                            view._eventsData = mainTickerData.Events;
	                            view.mainTickerObject = mainTickerData.tickerObject;
	                            view._lastClosePrice = mainTickerData.Price.spos;
	                            view._data = view._reviseData(mainTickerData.Price.data);
	                            if (chartConfigManager.getMainDataType() === chartConfigManager.MainDataTypes.DividendEffect) {
	                                //removing indicators that are shown in main chart
	                                var indicators = null;
	                                for (var indicatorName in view._indicatorsData) {
	                                    if (!rootCfg.charts.mainChart.indicatorProperties.hasOwnProperty(indicatorName)) {
	                                        indicators = indicators || {};
	                                        indicators[indicatorName] = view._indicatorsData[indicatorName];
	                                    }
	                                }
	                                view._indicatorsData = indicators ? indicators : null;
	                                var fundamentalType = dataAdapter.Fundamental.MReturnIndex;
	                                if (mainTickerData.Fundamentals && mainTickerData.Fundamentals[fundamentalType] &&
	                                    mainTickerData.Fundamentals[fundamentalType].data) {
	                                    view._dividendEffectData = view._reviseDividendEffectData(mainTickerData.Fundamentals[fundamentalType].data);
	                                }
	                            } else {
	                                view._getCompareData(res.data());
	                                view._createDummyData(view._compareData);
	                                preloadInfo.loadedCompareData = view._compareData;
	                            }
	                            view._rebaseCompareData();
	                            view._rebaseFundamentalData();
	                            view._changeChartGraph();
	                            if (preloadInfo.intervalType !== chartConfigManager.IntervalTypes.Max && !chartConfigManager.getConfig().useEUTimeSeriesData) {
	                                setTimeout(function() {
	                                    view._preloading = true;
	                                    view._loadingData = true;
	                                    view._fetchPreloadData();
	                                }, view.config.preloadDelay);
	                            }
	                        }
	                    }, adjustedDateRange);
	                },
	                _setScaleDomain: function() {},
	                _displayViewAfterChangeDomain: function() {
	                    this._rebaseCompareData();
	                    this._changeChartGraph();
	                },
	                _changeChartGraph: function() {
	                    rootCfg.$componentContainer.find("." + this.config.chartClass).empty();
	                    var fundamentalsData = this._fundamentalsData;
	                    if (rootCfg.fundamentals.length > 0) {
	                        this._draw_Fundamentals(true);
	                    }
	                    this._bindAfterOpenFundamentalEvents();
	                    eventManager.trigger(eventManager.EventTypes.HeightChanged);
	                },
	                _createScale: function(fundamentalName) {
	                    this._xScale = d3.scale.linear()
	                        .range([0, this._validWidth])
	                        .domain([0, this._data.length - 1]);
	
	                    var minYValue = 0;
	                    var maxYValue = 0;
	                    if (this._fundamentalsData && this._fundamentalsData[fundamentalName]) {
	                        var fundamental = this._fundamentalsData[fundamentalName];
	                        if (fundamental.data && fundamental.data.length > 0) {
	                            minYValue = d3.min(fundamental.data, function(d) {
	                                return d.value;
	                            });
	                            maxYValue = d3.max(fundamental.data, function(d) {
	                                return d.value;
	                            });
	                        }
	                    }
	                    var yScaleData = this._calculateYScaleDomainTickValues(minYValue, maxYValue);
	                    this._yTickValues = yScaleData.tickValues;
	                    this._decimalPlaces = this._getDecimalPlaces(yScaleData.domain);
	                    this._yScale = d3.scale.linear().range([this._validHeight, 0])
	                        .domain(yScaleData.domain);
	                },
	                _changeLayout: function() {
	                    this._changeChartGraph();
	                },
	                _processDestroyChart: function() {
	                    this._svg && this._svg.on('.fundamentalchart', null);
	                },
	                _renderView: function(fundamentalName) {
	                    //when open a save config, maybe we need draw fundamentals.
	                    var view = this;
	                    this._caculateValidSize();
	                    this._renderHeader(fundamentalName);
	                    this._createScale(fundamentalName);
	                    this._createSvgWrapper();
	                    this._createCommonPlotter();
	                    this._renderContainedViews();
	                    this._renderFooter();
	                    //when mouse move in the fundamentalchart, we will show crosshairs, waiting to get main chart data
	                    this._svg.on('mousemove.fundamentalchart', function() {
	                        view._mousemove(d3.event, d3.mouse(this), view._headerHeight);
	                    });
	                },
	                _renderContainedViews: function() {
	                    this._caculateValidSize();
	                    this._drawXAxis();
	                    this._drawYAxis();
	                    this._drawGridLines();
	                },
	                _createCommonPlotter: function() {
	                    var graphConfig = this._defaultGraphConfig = {
	                        containerGElem: this._outerGElem,
	                        xScale: this._xScale,
	                        yScale: this._yScale,
	                        graphType: graphTypes.Histogram,
	                        width: this._validWidth,
	                        height: this._validHeight,
	                        tickSize: this.config.indicatorBarWidth,
	                        yAxisContainerGElem: this._yAxisOuterGElem
	                            // yAxisContainerGElem: this._svg,
	                    };
	
	                    this._getDefaultGraphConfig = function() {
	                        return this._defaultGraphConfig;
	                    };
	                    this._commonPlotter = new commonPlotter(graphConfig);
	                },
	                _renderHeader: function(fundamentalName) {
	                    var cfg = this.config,
	                        margin = this.config.margin;
	                    var tickerInfoContainer = this._headerContainer = d3.select(cfg.container)
	                        .append("div").classed(innerClass.chartHeader, true)
	                        .classed(fundamentalName + '-class', true);
	                    tickerInfoContainer.append("span").classed(innerClass.chartLegend, true)
	                        .style("background", "#2F4880");
	                    tickerInfoContainer.append("span")
	                        .style("margin-left", margin.left + "px")
	                        .style("width", (this.config.width - margin.left - margin.right) + "px")
	                        .classed(innerClass.chartLegendText, true)
	                        .text(cfg.chartLegendText);
	                    this._headerContainer.append("span").classed(innerClass.fundamentals, true);
	                    this._appendHeaderForFundamentals(fundamentalName);
	                },
	                _renderFooter: function() {
	                    var cfg = this.config,
	                        margin = this.config.margin;
	                    d3.select(cfg.container)
	                        .append("div").classed(innerClass.chartFooter, true)
	                        .style("margin-left", margin.left + "px")
	                        .style("width", (this.config.width - margin.left - margin.right) + "px")
	                }
	            };
	
	            return util.extendClass(baseChart, fundamentalChartExtend);
	        };
	
	        var innerClass = {
	            gridLines: "fundamentalChart-gridLines",
	            fundamentalChart: "chart-fundamental",
	            chartHeader: "fundamentalChart-header",
	            chartLegend: "fundamentalChart-legend",
	            chartLegendText: "fundamentalChart-legend-text",
	            chartBody: 'fundamentalChart-body',
	            chartFooter: "fundamentalChart-footer",
	            fundamentals: "fundamentals",
	            fundamentalsValue: "fundamentalsValue-",
	            fundamentalsLegend: "fundamentals-legend",
	            fundamentalsLegendText: "fundamentals-legend-text",
	            closeButton: "icon chart close-button",
	            yAxis: "fundamentalChart-yAxis",
	        };
	
	        return model;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(55), __webpack_require__(17), __webpack_require__(19), __webpack_require__(59)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, toolConfig, util, moment, locale) {
	        'use strict';
	        /**
	         * Chart Config Manage Model
	         */
	
	        var $ = core.$;
	        var Util = core.Util;
	        var ChartTypes = toolConfig.ChartTypes;
	        var MainChartTypes = toolConfig.MainChartTypes;
	        var MainDataTypes = toolConfig.MainDataTypes;
	        var VolumeChartTypes = toolConfig.VolumeChartTypes;
	        var IndicatorChartTypes = toolConfig.IndicatorChartTypes;
	        var dateUtil = core.Widget.Chart.Util;
	        /**
	         * strat
	         * transform SDK to Svgchart
	         */
	        var IntervalTypeMap = toolConfig.IntervalTypeMap;
	        var FrequencyMap = toolConfig.FrequencyMap;
	        var ChartCursorType = toolConfig.ChartCursorType;
	        var ScaleType = toolConfig.ScaleType;
	        var ModeType = toolConfig.ModeType;
	        var MainChartTypeMap = toolConfig.MainChartTypeMap;
	        var MainDataTypeMap = toolConfig.MainDataTypeMap;
	        var EventsMap = toolConfig.EventsMap;
	        var DrawTypeMap = toolConfig.DrawTypeMap;
	        /**
	         * end
	         * transform SDK to Svgchart
	         */
	        var IntervalTypesMapping = toolConfig.IntervalTypesMapping;
	        var ExternalTypesMapping = toolConfig.ExternalTypesMapping;
	        var IntervalTypes = toolConfig.IntervalTypes;
	        var FrequencyTypes = toolConfig.FrequencyTypes;
	        var FrequencyTexts = toolConfig.FrequencyTexts;
	        var CursorType = toolConfig.CursorType;
	        var Constants = toolConfig.Constants;
	        var frequencyConfig = toolConfig.frequencyConfig;
	        var TimezoneMap = toolConfig.TimezoneMap;
	        var intervalTypeSortedArray = toolConfig.IntervalTypeSortedArray;
	        var SelectionModes = toolConfig.SelectionModes;
	        var CurrencyMapping = toolConfig.CurrencyMapping;
	        var PopoverTypes = toolConfig.PopoverTypes;
	        var BenchmarkType = toolConfig.BenchmarkType;
	        var VerticalScaleTypes = toolConfig.VerticalScaleTypes;
	        var ChartGenre = toolConfig.ChartGenre;
	        var ChartTypeCategoryMap = toolConfig.ChartTypeCategoryMap;
	        var AutocompleteCategories = toolConfig.AutocompleteCategories;
	        var timers = [];
	
	        function configManager(managers) {
	            var eventManager = managers.eventManager;
	            var eventTypes = eventManager.EventTypes;
	            var lastCursorType;
	            var mainTickerObject, tickerCollection = [];
	            var config;
	            var initedConfig;
	            var dataAdapter = managers.dataAdapter;
	            var initCallback;
	            var customTickerNameField = 'customTickerName';
	            var customTickerColorField = 'customTickerColor';
	            var customTickerCurrencyField = 'customCurrency';
	            var checkList = ['mType', 'type'];
	            var labelsValues = {};
	            var oriConfig = toolConfig.defaultConfig['svgchart'].settings;
	
	            function initConfig(extendConfig, callback) {
	                extendConfig = $.extend(true, {}, extendConfig);
	                if (extendConfig.profileId) {
	                    var param = {
	                        types: oriConfig.profileType + ',ch_v2',
	                        profileId: extendConfig.profileId
	                    };
	                    dataAdapter.getSaveChartSettings(param, function(res) {
	                        var resData = res;
	                        if (resData) {
	                            var profile = {};
	                            if (resData['ch_v3']) {
	                                extendConfig.profileId = resData['ch_v3'].TempId;
	                                profile = resData['ch_v3'].Profile.savedConfig;
	                                if (extendConfig.resetSavedConfig && profile.migrateFromSdk) {
	                                    profile = transformConfig(resData['ch_v2'].Profile);
	                                }
	                            } else if (resData['ch_v2']) {
	                                profile = transformConfig(resData['ch_v2'].Profile);
	                            }
	                            extendConfig.savedConfig = profile;
	                        }
	                        createConfig(extendConfig, callback);
	                    });
	                } else {
	                    createConfig(extendConfig, callback);
	                }
	            }
	            // transform sdk settings config to svgchart config
	            function transformConfig(saveConfig) {
	                var transConfig = {
	                    "events": [],
	                    "fundamentals": [],
	                    "indicators": [],
	                    "compareTickers": [],
	                    "charts": {
	                        "mainChart": {},
	                        "volumeChart": {}
	                    }
	                };
	                var mainChart = {};
	                var eventsObj = saveConfig.events;
	                if (eventsObj) {
	                    var events = [];
	                    Object.keys(eventsObj).forEach(function(e) {
	                        if (eventsObj[e]) {
	                            if (e === 'dividend') {
	                                mainChart.showDividend = true;
	                            }
	                            events.push(EventsMap[e]);
	                        }
	                    });
	                    transConfig.events = events;
	                }
	                var indicatorsData = saveConfig.indicatorsData; //indicator
	                if (indicatorsData) {
	                    Object.keys(indicatorsData).forEach(function(e) {
	                        var indicatorObj = {
	                            parameters: []
	                        };
	                        if (indicatorsData[e].show && e !== 'Volume') {
	                            if (e === 'VPlus') {
	                                var volumeChart = {}
	                                volumeChart.show = true;
	                                volumeChart.chartType = 'volumePlusChart';
	                                transConfig.charts.volumeChart = volumeChart;
	                                return;
	                            }
	                            indicatorObj.name = e;
	                            var parameter = [];
	                            if (e === 'SMAV') {
	                                parameter = [indicatorsData[e].num];
	                            } else if (e === 'EMA' || e === 'SMA') {
	                                parameter = indicatorsData[e].num ? indicatorsData[e].num : [];
	                            } else {
	                                parameter = indicatorsData[e].parameter ? indicatorsData[e].parameter : [];
	                            }
	                            parameter.forEach(function(params) {
	                                if (params) {
	                                    indicatorObj.parameters.push(params);
	                                }
	                            })
	                            transConfig.indicators.push(indicatorObj);
	                        }
	                    });
	
	                }
	                var valuations = saveConfig.valuations; //fundamentals
	                if (valuations) {
	                    Object.keys(valuations).forEach(function(e) {
	                        if (valuations[e].show) {
	                            if (e === 'RDividend' || e === 'DYield') {
	                                transConfig.indicators.push({
	                                    name: e,
	                                    parameters: []
	                                })
	                                return;
	                            }
	                            transConfig.fundamentals.push(e);
	                        }
	                    });
	                }
	                mainChart.selectionMode = ModeType[saveConfig.mode];
	                if (saveConfig.chartStyle === 'dEffect' || saveConfig.chartStyle === 'growth' || saveConfig.chartStyle === 'growth10') {
	                    mainChart.dataType = MainDataTypeMap[saveConfig.chartStyle]
	                } else {
	                    mainChart.chartType = MainChartTypeMap[saveConfig.chartStyle];
	                }
	                var frequency = saveConfig.frequency;
	                if (frequency) {
	                    transConfig.frequency = FrequencyMap[frequency];
	                }
	                var intervalType = saveConfig.zRange;
	                if (intervalType) {
	                    transConfig.intervalType = IntervalTypeMap[intervalType];
	                    if (intervalType === 11) {
	                        var startDate = saveConfig.startDate;
	                        var endDate = saveConfig.endDate;
	                        transConfig.dateRange = [transDateIsoString(startDate), transDateIsoString(endDate)];
	                    }
	                }
	                var yAxisOrient = saveConfig.yaxisAlign;
	                if (yAxisOrient) {
	                    transConfig.yAxisOrient = yAxisOrient;
	                }
	                transConfig.charts.mainChart = mainChart;
	                transConfig.compareTickers = saveConfig.cTickers ? saveConfig.cTickers : [];
	                transConfig.mainTicker = saveConfig.originTicker;
	                transConfig.verticalScaleType = ScaleType[saveConfig.scaleType];
	                transConfig.chartCursor = ChartCursorType[saveConfig.chartCursor];
	                transConfig.showPreAfter = saveConfig.showPreAfter;
	                return transConfig;
	            }
	
	            function transDateIsoString(date) {
	                return new Date(date).toISOString();
	            }
	
	            function createConfig(extendConfig, callback) {
	                initCallback = callback;
	                lastCursorType = undefined;
	                extendConfig = extendConfig || {};
	                config = $.extend(true, {}, oriConfig);
	                if (extendConfig.frequency) {
	                    extendConfig.defaultFrequency = extendConfig.frequency;
	                }
	                extendConfig.charts = extendConfig.charts || {};
	                extendConfig.charts.mainChart = extendConfig.charts.mainChart || {};
	                var savedConfig = extendConfig.savedConfig;
	                if (savedConfig) {
	                    delete extendConfig.savedConfig;
	                }
	                // if invoke createConfig from internal, not need extend.
	                if (!extendConfig.createConfigInternal) {
	                    initedConfig = $.extend(true, {}, extendConfig);
	                }
	                if (savedConfig && (extendConfig.keepSavedMainTicker === false || config.keepSavedMainTicker === false)) {
	                    savedConfig.mainTicker = null;
	                    delete savedConfig.mainTicker;
	                }
	                extendConfig = $.extend(true, {}, extendConfig, savedConfig);
	                extendConfig.width && (extendConfig.width = parseInt(extendConfig.width, 10));
	                extendConfig.height && (extendConfig.height = parseInt(extendConfig.height, 10));
	                if (!extendConfig.solutionKey) {
	                    extendConfig.useEUTimeSeriesData = false;
	                    extendConfig.useEUSecurityData = false;
	                    if (extendConfig.autoComplete && extendConfig.autoComplete.dataSource === 'EU') {
	                        extendConfig.autoComplete.dataSource = 'US';
	                    }
	                }
	                if (extendConfig.premiumUser === undefined) {
	                    var instID = core.getInstID().toUpperCase();
	                    if (instID === 'QSDEMO') {
	                        extendConfig.premiumUser = true;
	                    }
	                }
	
	                if (extendConfig.lang) {
	                    extendConfig.lang = core.Util.standardizeLangSymbol(extendConfig.lang);
	                }
	                //configuration for NavAndPrice chart
	                if (extendConfig.drawNavAndPriceChart) {
	                    extendConfig.legendInfoLabel = "tenforeTicker";
	                    extendConfig["intervalType"] = IntervalTypes.OneMonth;
	                    extendConfig["compareClose"] = false;
	                }
	
	                if (extendConfig.startPeriod) {
	                    var transforedIntervalType = IntervalTypesMapping[extendConfig.startPeriod];
	                    if (transforedIntervalType) {
	                        extendConfig.intervalType = transforedIntervalType;
	                    }
	                    delete extendConfig.startPeriod;
	                }
	                var theme = (extendConfig.theme || config.theme) + '';
	                config.brushImages = extendConfig.brushImages;
	                config.compareColors = extendConfig.compareColors;
	                config.tagMode = extendConfig.tagMode;
	                extendConfig.menubar = extendConfig.menubar || {};
	                for (var menu in extendConfig.menubar) {
	                    var hides = [];
	                    if ($.inArray(menu), ['hideEventsIndicators', 'hideFundamentals', 'hideDisplay', 'hideDrawings']) {
	                        var hides = extendConfig.menubar[menu];
	                        for (var i = 0; i < hides.length; i++) {
	                            hides[i] = util.camelToDashes(hides[i]);
	                        }
	                        config.menubar[menu] = util.arrConcat(config.menubar[menu], hides || []);
	                    }
	                }
	                delete extendConfig.menubar;
	                loadTheme(theme);
	                if (extendConfig.intervalBreakPointMap) {
	                    for (var bp in extendConfig.intervalBreakPointMap) {
	                        config.intervalBreakPointMap[bp] = extendConfig.intervalBreakPointMap[bp];
	                    }
	                    delete extendConfig.intervalBreakPointMap;
	                }
	                if (extendConfig.intervalFrequencyMap) {
	                    for (var key in extendConfig.intervalFrequencyMap) {
	                        extendConfig.intervalFrequencyMap[IntervalTypesMapping[key] || key] = extendConfig.intervalFrequencyMap[key];
	                    }
	                }
	                extendConfig.showGridBlocks && changeShowGridBlocks(extendConfig.showGridBlocks);
	                extendConfig.showSolidGridLines && changeShowSolidGridLines(extendConfig.showSolidGridLines);
	                if (extendConfig.lang) {
	                    config.lang = extendConfig.lang;
	                }
	                var d3Locale = getD3Locale();
	                if (d3Locale.dailyDateFormatter) {
	                    config.dailyDateFormatter = d3Locale.dailyDateFormatter;
	                }
	                if (d3Locale.intradayDateFormater) {
	                    config.intradayDateFormater = d3Locale.intradayDateFormater;
	                }
	                if (d3Locale.momentDateTime) {
	                    config.momentDateTime = d3Locale.momentDateTime;
	                }
	                if (d3Locale.momentDate) {
	                    config.momentDate = d3Locale.momentDate;
	                }
	                if (d3Locale.columnDelimiter) {
	                    config.columnDelimiter = d3Locale.columnDelimiter;
	                }
	                $.extend(true, config, extendConfig);
	                if (config.useEUTimeSeriesData && !extendConfig.legendInfoLabel) {
	                    config.legendInfoLabel = 'Name';
	                }
	                if (config.crossValue === "original") {
	                    config.showCrosshairOriginalData = true;
	                }
	                adapteMainChartType(extendConfig.charts.mainChart.chartType, extendConfig.charts.mainChart.dataType);
	                menuBarConfigProcess();
	                config.charts.sliderChart.show = (config.charts.sliderChart.show === false || config.hideSlider === true) ? false : true;
	                config.charts.volumeChart.show = (config.charts.volumeChart.show === false || config.hideVolume === true) ? false : true;
	
	                //adjust autocomplete config but make it backward compatibility
	                if (typeof config.autoComplete.highlight === 'undefined') {
	                    config.autoComplete.highlight = config.autoCompleteHighLight === true ? true : false;
	                }
	                if (typeof config.autoComplete.action === 'undefined') {
	                    config.autoComplete.action = config.autoCompleteAction === 'main' ? 'main' : 'compare';
	                }
	                if (typeof config.autoComplete.changeTicker === 'undefined') {
	                    config.autoComplete.changeTicker = config.autoChangeTicker === false ? false : true;
	                }
	                if (typeof config.autoComplete.nonFilterCategory === 'undefined') {
	                    config.autoComplete.nonFilterCategory = config.autocompleteNonFilterCategories && config.autocompleteNonFilterCategories.length > 0 ? config.autocompleteNonFilterCategories : [];
	                }
	                if (config.autoComplete.nonFilterCategory === "All") {
	                    config.autoComplete.nonFilterCategory = ["All"];
	                }
	                if (typeof config.autoComplete.group === 'undefined') {
	                    config.autoComplete.group = config.isAutocompleteGroup === false ? false : true;
	                }
	
	                if (config.yAxisOrient && (config.yAxisOrient === 'right' || config.yAxisOrient === 'left')) {
	                    config.charts.mainChart.yAxis.orient = config.charts.volumeChart.yAxis.orient = config.charts.indicatorChart.yAxis.orient = config.charts.fundamentalChart.yAxis.orient = config.yAxisOrient;
	                }
	                if (config.showYAxisTickLine == false) {
	                    config.charts.mainChart.yAxis.tick.line.show = config.charts.volumeChart.yAxis.tick.line.show = config.charts.indicatorChart.yAxis.tick.line.show = config.charts.fundamentalChart.yAxis.tick.line.show = config.showYAxisTickLine;
	                }
	                if (config.yAxisWidth && !isNaN(config.yAxisWidth)) {
	                    config.charts.mainChart.yAxis.width = config.charts.volumeChart.yAxis.width = config.charts.indicatorChart.yAxis.width = config.charts.fundamentalChart.yAxis.width = config.minYAxisWidth = config.yAxisWidth = Number(config.yAxisWidth);
	                }
	
	                if (config.yAxisPosition && (config.yAxisPosition === 'inner' || config.yAxisPosition === 'outer')) {
	                    config.charts.mainChart.yAxis.position = config.charts.volumeChart.yAxis.position = config.charts.indicatorChart.yAxis.position = config.charts.fundamentalChart.yAxis.position = config.yAxisPosition;
	                }
	
	                if (config.yAxisPosition === 'inner') {
	                    config.charts.indicatorChart.yAxis.ticks = 4;
	                    config.charts.fundamentalChart.yAxis.ticks = 4;
	                }
	                if (config.yAxisMargin) {
	                    config.charts.mainChart.yAxisMargin = config.charts.volumeChart.yAxisMargin = config.charts.indicatorChart.yAxisMargin = config.charts.fundamentalChart.yAxisMargin = config.yAxisMargin = Number(config.yAxisMargin);
	                }
	                if (config.hideMainYAxis) {
	                    config.charts.mainChart.yAxis.show = false;
	                }
	                if (config.hideMainXAxis) {
	                    config.charts.mainChart.xAxis.show = false;
	                }
	                if (config.hideVolumeYAxis) {
	                    config.charts.volumeChart.yAxis.show = false;
	                }
	                if (config.hideSliderXAxis) {
	                    config.charts.sliderChart.xAxis.show = false;
	                }
	                if (!config.showDiscountCumFair) {
	                    config.menubar.hideFundamentals = util.arrConcat(config.menubar.hideFundamentals, ['discount-cum-fair']);
	                }
	                if (!config.showNAV) {
	                    config.menubar.hideFundamentals = util.arrConcat(config.menubar.hideFundamentals, ['daily-cum-fair-nav']);
	                }
	                if (!config.showPremiumDiscount) {
	                    config.menubar.hideFundamentals = util.arrConcat(config.menubar.hideFundamentals, ['premium-discount']);
	                }
	                if (config.fundamentals) {
	                    if (typeof config.fundamentals == "string") {
	                        config.fundamentals = [config.fundamentals];
	                    }
	                }
	                if (config.chartCursor && (config.chartCursor === CursorType.Crosshair || config.chartCursor === CursorType.Trackball || config.chartCursor === CursorType.Off)) {
	                    config.cursorType = config.chartCursor;
	                } else {
	                    config.cursorType = CursorType.Crosshair;
	                }
	                if (config.hideCrossHair) config.cursorType = CursorType.Off;
	                if (extendConfig.charts.mainChart.dataType === MainDataTypes.Growth10K) {
	                    config.growthBaseValue = config.growthBaseValue || 10000;
	                } else {
	                    delete config.growthBaseValue;
	                }
	
	                if (config.growthBaseValue) {
	                    if (typeof config.growthBaseValue != "number") {
	                        console.info("GrowthBaseValue should be a number")
	                        if (!isNaN(Number(config.growthBaseValue))) {
	                            config.rootGrowthBaseValue = config.growthBaseValue = Number(config.growthBaseValue);
	                        }
	                    } else {
	                        config.rootGrowthBaseValue = config.growthBaseValue;
	                    }
	                }
	
	                var selectionMode = config.SMode;
	                if (selectionMode) {
	                    config.charts.mainChart.selectionMode = selectionMode;
	                }
	
	                if (config.dateRange && config.dateRange.length === 2) {
	                    if (typeof config.dateRange[0] === 'string') {
	                        config.dateRange[0] = new Date(config.dateRange[0]);
	                    }
	                    if (typeof config.dateRange[1] === 'string') {
	                        config.dateRange[1] = new Date(config.dateRange[1]);
	                    }
	                }
	                for (var i = 0; i < config.events.length; i++) {
	                    if (config.events[i] == 'DD001') {
	                        config.events[i] = 'dividend';
	                    }
	                    if (config.events[i] == 'HS030') {
	                        config.events[i] = 'earnings';
	                    }
	                    if (config.events[i] == 'HSB05:HSB04') {
	                        config.events[i] = 'split'
	                    }
	                }
	                if (config.showTSDividend) {
	                    config.charts.mainChart.showDividend = true;
	                    config.events.push("dividend");
	                }
	                if (config.useEUTimeSeriesData) {
	                    config.charts.volumeChart.needInit = false;
	                }
	                if (config.autoComplete.category) {
	                    config.category = config.autoComplete.category;
	                }
	                for (var f in frequencyConfig) {
	                    frequencyConfig[f].def = config.intervalFrequencyMap[f];
	                }
	                if (config.rangeFrequency) {
	                    for (var i in config.rangeFrequency) {
	                        var currentInterval = IntervalTypesMapping[i];
	                        var currentIntervalValues = config.rangeFrequency[i];
	                        var fcObject = [];
	                        if (currentIntervalValues && currentIntervalValues.length > 0) {
	                            for (var j = 0; j < currentIntervalValues.length; j++) {
	                                fcObject.push({
	                                    "value": currentIntervalValues[j],
	                                    "text": FrequencyTexts[currentIntervalValues[j]]
	                                });
	                            }
	                        }
	                        frequencyConfig[currentInterval].fc = fcObject;
	                        frequencyConfig[currentInterval].reset = true;
	                    }
	                }
	
	                moment.locale(config.lang);
	                bindEvents();
	                initChartGenreConfig();
	            };
	
	            function getD3Locale() {
	                return locale.getD3Locale(config.lang);
	            };
	
	            function processTickerCustom(tickers, tickerInfos) {
	                if (!tickers || !tickerInfos || tickers.length !== tickerInfos.length) {
	                    return;
	                }
	                for (var m = 0, infoLen = tickerInfos.length; m < infoLen; m++) {
	                    if (!tickers[m] || !tickerInfos[m]) {
	                        continue;
	                    }
	                    tickers[m][customTickerColorField] = tickerInfos[m].color;
	                    tickers[m][customTickerNameField] = tickerInfos[m].name;
	                    tickers[m][customTickerCurrencyField] = tickerInfos[m].currency || config.country;
	                    if (config.solutionKey) {
	                        tickers[m].solutionKey = config.solutionKey;
	                        if (config.showCurrencyOptions || config.currencyWithMainTicker) {
	                            setConfig({
	                                baseCurrency: config.baseCurrency || tickerInfos[0].currency || tickers[0].currency
	                            });
	                            tickers[m][customTickerCurrencyField] = config.baseCurrency;
	                        }
	                    }
	                }
	            };
	
	            function switchLanguage(lang) {
	                return lang.replace(/(\w{2})-(\w{2})/, function(str, $1, $2) {
	                    return $1.toLowerCase() + '_' + $2.toLowerCase();
	                })
	            };
	
	            function createTickerObjects(tickers, performanceIds) {
	                var deferred = $.Deferred();
	                dataAdapter.createTickerObjects(tickers, function(tickerObjects) {
	                    if (performanceIds) {
	                        setBenchmarktype(tickerObjects, performanceIds);
	                    }
	                    if (config.translateName) {
	                        var translateData = {
	                            language: switchLanguage(config.lang)
	                        };
	                        var lan = translateData.language;
	                        var str = [];
	                        tickerObjects.forEach(function(item) {
	                            if (item.benchmarkType === BenchmarkType.FundCategory) {
	                                translateData.category = item.categoryId;
	                            } else if (item.benchmarkType === BenchmarkType.RelativeRiskBenchmark) {
	                                translateData.benchmark = item.secId;
	                            } else if (item.benchmarkType === BenchmarkType.ProspectusBenchmark) {
	                                str.push(item.secId);
	                            } else {
	                                str.push(item.secId);
	                            }
	                            translateData.fund = str.join(',');
	                        })
	                        core.Util.ajax({
	                            type: 'GET',
	                            url: core.serviceManager.url('@web') + 'ra/getName',
	                            data: translateData,
	                            dataType: 'jsonp',
	                            success: function(data) {
	                                var resData = data.Data;
	                                tickerObjects.forEach(function(tickerItem) {
	                                    if (resData) {
	                                        if (tickerItem.benchmarkType === BenchmarkType.FundCategory) {
	                                            tickerItem.Name = resData.Category ? resData.Category[tickerItem.categoryId][lan].legalName : tickerItem.Name;
	                                        } else if (tickerItem.benchmarkType === BenchmarkType.RelativeRiskBenchmark) {
	                                            tickerItem.Name = resData.Benchmark ? resData.Benchmark[tickerItem.secId][lan].legalName : tickerItem.Name;
	                                        } else {
	                                            tickerItem.Name = resData.Fund ? resData.Fund[tickerItem.secId] ? resData.Fund[tickerItem.secId][lan].legalName : tickerItem.Name : tickerItem.Name;
	                                        }
	                                    }
	                                })
	                                deferred.resolve(tickerObjects);
	                            }
	                        });
	                    } else {
	                        deferred.resolve(tickerObjects);
	                    }
	                });
	                return deferred;
	            };
	
	            /**
	             * tickerInfo is a object or a string , like below:
	             *  {
	             *   ticker: '126.1.ibm',	// or a tickerObject
	             *   color: #F00,	// or red
	             *   name: 'AAAA'
	             *  }
	             *
	             *  or
	             *
	             *  '126.1.ibm'
	             */
	            var changeMainTicker = util.debounce(function changeMainTicker(tickerInfo, isFromRemoveBtn) {
	                if (!tickerInfo || tickerInfo == "" || tickerInfo == [] || !config || !util.isExistedInDom(config.$container)) {
	                    return;
	                }
	                var ticker = _buildTickers(tickerInfo);
	                if (typeof tickerInfo === 'string') {
	                    tickerInfo = {
	                        ticker: tickerInfo,
	                        color: null,
	                        name: null
	                    };
	                }
	                if (typeof ticker === 'string') {
	                    createTickerObjects([ticker]).done(function(tickerObj) {
	                        tickerInfo.ticker = tickerObj[0];
	                        if (config.saveDrawings) {
	                            dataAdapter.getDrawings(tickerObj[0], function(data) {
	                                setSavedDrawings(data).done().then(function() {
	                                    _changeMainTicker(tickerInfo, isFromRemoveBtn);
	                                });
	                            });
	                        } else {
	                            _changeMainTicker(tickerInfo, isFromRemoveBtn);
	                        }
	                    });
	                } else {
	                    if (config.saveDrawings) {
	                        dataAdapter.getDrawings(tickerInfo, function(data) {
	                            setSavedDrawings(data).done().then(function() {
	                                _changeMainTicker(tickerInfo, isFromRemoveBtn);
	                            });
	                        });
	                    } else {
	                        _changeMainTicker(tickerInfo, isFromRemoveBtn);
	                    }
	                }
	            }, 500, true);
	
	            function _changeMainTicker(tickerInfo, isFromRemoveBtn) {
	                var tickerObj = tickerInfo.ticker;
	                var oriChartGenre = config.chartGenre;
	                var originalMainTicker = mainTickerObject;
	                if (tickerObj && tickerObj.valid) {
	                    processTickerCustom([tickerObj], [tickerInfo]);
	                    if (isSameTicker(mainTickerObject, tickerObj)) {
	                        return;
	                    }
	                    mainTickerObject = tickerObj;
	                    setChartGenre();
	                    var isCompare = false;
	                    //Note: start at 1
	                    for (var i = 1; i < tickerCollection.length; i++) {
	                        if (isSameTicker(tickerCollection[i], tickerObj)) {
	                            tickerCollection.splice(i, 1);
	                            isCompare = true;
	                            break; //Because no duplicate ticker object.
	                        }
	                        //clear benchmark and category
	                        if (tickerCollection[i].benchmarkType) {
	                            tickerCollection.splice(i, 1);
	                            i--;
	                        }
	                    }
	
	                    if (!isCompare) {
	                        dataAdapter.registerChartTickers(tickerObj);
	                    }
	                    tickerCollection[0] = tickerObj;
	                    // when delete mainTicker or change mainTicker, need update compareTicker
	                    var compareTickers = [];
	                    for (var i = 1; i < tickerCollection.length; i++) {
	                        compareTickers.push(tickerCollection[i].symbol)
	                    }
	                    var cfg = {
	                        startDate: config.startDate
	                    };
	                    if (oriChartGenre === config.chartGenre) {
	                        cfg.intervalType = config.intervalType;
	                        cfg.lastFrequency = config.frequency;
	                    }
	                    if (isFromRemoveBtn) {
	                        isFromRemoveBtn && eventManager.trigger(eventManager.EventTypes.onTickerRemoveBtnClicked, [originalMainTicker]);
	                    }
	                    var mainTicker = mainTickerObject.symbol || mainTickerObject.performanceId;
	                    if (config.useEUTimeSeriesData) {
	                        mainTicker = {
	                            id: mainTickerObject.secId,
	                            securityToken: mainTickerObject.securityToken,
	                            name: mainTickerObject.Name,
	                            currency: mainTickerObject.customCurrency
	                        };
	                    }
	                    setConfig({
	                        mainTicker: mainTicker,
	                        compareTickers: compareTickers
	                    });
	                    cfg.mainTicker = mainTicker;
	                    if (config.saveSettingsOnMainTickerChange) {
	                        cfg = getSaveConfig();
	                    }
	                    var from = isFromRemoveBtn ? 'removeBtn' : 'changeTicker';
	                    updateChart(false, cfg, from); //Don't need clear tickers. if chart type doesn't change, keep the original frequency and interval
	                }
	            };
	
	            function updateChart(clearTicker, cfg, from) {
	                var _config = getInitConfig();
	                var newConfig = $.extend({}, _config, cfg);
	                newConfig.width = config.width;
	                newConfig.height = config.height;
	                newConfig.skin = config.skin;
	                if (config.keepMainTickerOnReset) {
	                    newConfig.mainTicker = config.mainTicker;
	                }
	                newConfig.createConfigInternal = true;
	                if (from !== 'changeTicker' && from !== "removeBtn") { // from reset
	                    var cfg = $.extend(true, {}, oriConfig, newConfig);
	                    newConfig.isFullyRendered = true;
	                    if (config.resetSavedConfig && config.profileId) {
	                        newConfig.resetAction = true;
	                    }
	                    setConfig(cfg);
	                    eventManager.trigger(eventTypes.RemoveAllDrawings);
	                    eventManager.trigger(eventTypes.triggerClickCallback, {
	                        name: 'reset',
	                        value: cfg
	                    });
	                }
	                destroyChart(clearTicker);
	                if (from === "removeBtn") {
	                    var changeConfig = $.extend({}, config);
	                    changeConfig.createConfigInternal = true;
	                    createConfig(changeConfig, initCallback); // if from remove button or exchange main ticker, should keep all settings.
	                } else {
	                    createConfig(newConfig, initCallback);
	                }
	            }
	
	            function _updateCompareTickers(updateInfo) {
	                if (typeof updateInfo == 'undefined') {
	                    return;
	                }
	                switch (updateInfo.action) {
	                    case 'add': {
	                        addCompareTickers(updateInfo.tickerInfo);
	                        break;
	                    }
	                    case 'remove': {
	                        removeCompareTickers(updateInfo.tickerInfo);
	                        break;
	                    }
	                    case 'set':
	                    default: {
	                        var updateTickerInfo = [],
	                            updateTickers = [],
	                            addTickers = [],
	                            removeTickers = [];
	                        if ($.isArray(updateInfo.tickerInfo)) {
	                            updateTickerInfo = updateInfo.tickerInfo;
	                        } else if ($.isArray(updateInfo)) {
	                            updateTickerInfo = updateInfo;
	                        }
	                        for (var i = 0; i < updateTickerInfo.length; i++) {
	                            updateTickers.push(_buildTickers(updateTickerInfo[i]));
	                        }
	                        createTickerObjects(updateTickers).done(function(updateTickerObjects) {
	                            for (var i = 0; i < updateTickerObjects.length; i++) {
	                                var updateTickerObj = updateTickerObjects[i];
	                                var needAdd = true;
	                                if (updateTickerObj.valid) {
	                                    for (var t = 0; t < tickerCollection.length; t++) {
	                                        if (isSameTicker(updateTickerObj, tickerCollection[t])) {
	                                            needAdd = false;
	                                        }
	                                    }
	                                } else {
	                                    needAdd = false;
	                                }
	                                if (needAdd) {
	                                    if (config.country) {
	                                        updateTickerObj.currency = config.country;
	                                    }
	                                    addTickers.push({
	                                        ticker: updateTickerObj,
	                                        color: updateTickerInfo[i].color,
	                                        name: updateTickerInfo[i].name,
	                                        currency: updateTickerInfo[i].currency
	                                    });
	                                }
	                            }
	                            for (var i = 0; i < tickerCollection.length; i++) {
	                                if (isSameTicker(mainTickerObject, tickerCollection[i])) {
	                                    continue;
	                                }
	                                var needRemove = true;
	                                for (var j = 0; j < updateTickerObjects.length; j++) {
	                                    if (isSameTicker(tickerCollection[i], updateTickerObjects[j])) {
	                                        needRemove = false;
	                                    }
	                                }
	                                if (needRemove) {
	                                    removeTickers.push(tickerCollection[i]);
	                                }
	                            }
	                            if (removeTickers.length > 0) {
	                                removeCompareTickers(removeTickers);
	                            }
	                            if (addTickers.length > 0) {
	                                addCompareTickers(addTickers);
	                            }
	                        });
	                    }
	                }
	            }
	            var updateCompareTickers = util.debounce(_updateCompareTickers, 500, true);
	            /**
	             *  tickerInfo is a object array or a object or a string , like below:
	             *  [{
	             *   ticker: '126.1.ibm',	// or a tickerObject, but not support string and object at same time.
	             *   color: #F00,	// or red
	             *   name: 'BBBB'
	             *  }]
	             *
	             *  or
	             *
	             *  ['126.1.ibm']
	             */
	            function addCompareTickers(tickerInfos) {
	                if (!$.isArray(tickerInfos)) { // Only support array.
	                    return;
	                }
	
	                // Note: Pay attention to remove duplication in mainChart.js
	                if (tickerCollection.length > config.compareChartsMaxAllowed) {
	                    eventManager.trigger(eventTypes.TickerLimitReached);
	                    return false;
	                }
	
	                var newCompareTickers = [];
	                for (var item, i = 0, len = tickerInfos.length; i < len; i++) {
	                    item = tickerInfos[i];
	                    newCompareTickers.push(_buildTickers(item));
	                }
	
	                // Only support same type: ticker objects or symbols.
	                if (typeof newCompareTickers[0] === 'string') {
	                    createTickerObjects(newCompareTickers).done(function(tickerObjects) {
	                        _addCompareTickers(tickerObjects, tickerInfos);
	                    });
	                } else {
	                    _addCompareTickers(newCompareTickers, tickerInfos);
	                }
	            }
	
	            function _addCompareTickers(newObjects, tickerInfos) {
	                var hasSame, hasChanged = false,
	                    needRegisterTickers = [],
	                    compareTickers = $.extend(true, [], config.compareTickers);
	                processTickerCustom(newObjects, tickerInfos);
	                for (var w = 0, newTicker, newLen = newObjects.length; w < newLen; w++) {
	                    newTicker = newObjects[w];
	                    hasSame = false;
	                    if (newTicker.valid) {
	                        // need calculate collectionLen after change tickerCollection.
	                        for (var i = 0, collectionLen = tickerCollection.length; i < collectionLen; i++) {
	                            if (isSameTicker(newTicker, tickerCollection[i])) {
	                                //config.compareColors[i] = newColors[w] || config.compareColors[i];
	                                hasChanged = true;
	                                hasSame = true;
	                                break;
	                            }
	                        }
	                        if (!hasSame) { // no same ticker
	                            if (collectionLen <= config.compareChartsMaxAllowed) {
	                                tickerCollection.push(newTicker);
	                                compareTickers.push(newTicker.symbol);
	                                needRegisterTickers.push(newTicker);
	                                hasChanged = true;
	                            } else {
	                                eventManager.trigger(eventTypes.TickerLimitReached);
	                                break; //we should drop rest tickers.
	                            }
	                        }
	                    }
	                }
	
	                if (needRegisterTickers.length > 0) {
	                    dataAdapter.registerChartTickers(needRegisterTickers);
	                }
	
	                if (hasChanged) {
	                    executeAddOrRemoveCompareTicker(needRegisterTickers, compareTickers);
	                    eventManager.trigger(eventTypes.UpdateCompareTickers);
	                    // if (config.startDate !== toolConfig.StartDateTypes.MainTicker) {
	                    //     dataAdapter.getLastTradeDate(tickerCollection).done(function () {
	                    //         eventManager.trigger(eventTypes.UpdateCompareTickers);
	                    //     });
	                    // }
	                }
	            }
	
	            /**
	             *  tickers is a string or a array of objects or strings , like below:
	             *  '126.1.ibm' or ['126.1.ibm'] or [tickerObject]
	             */
	            function removeCompareTickers(tickers, isFromRemoveBtn) {
	                if (!$.isArray(tickers)) {
	                    tickers = [tickers];
	                }
	
	                if (typeof tickers[0] === 'string') {
	                    createTickerObjects(tickers).done(function(tickerObjects) {
	                        _removeCompareTickers(tickerObjects, isFromRemoveBtn);
	                    });
	                } else {
	                    _removeCompareTickers(tickers, isFromRemoveBtn);
	                }
	            }
	
	            function _removeCompareTickers(removeTickers, isFromRemoveBtn) {
	                var needUnregisterTickers = [],
	                    hasChanged = false,
	                    compareTickers = $.extend(true, [], config.compareTickers);
	                for (var w = 0, removeTicker, removeLen = removeTickers.length; w < removeLen; w++) {
	                    removeTicker = removeTickers[w];
	                    //Note: start from 1 to cross main ticker.
	                    for (var i = 1, len = tickerCollection.length; i < len; i++) {
	                        var tickerObj = tickerCollection[i];
	                        if (tickerObj && isSameTicker(tickerObj, removeTicker)) {
	                            needUnregisterTickers.push(tickerObj);
	                            tickerCollection.splice(i, 1);
	                            compareTickers.splice(i - 1, 1);
	                            hasChanged = true;
	                            break;
	                        }
	                    }
	                }
	
	                if (hasChanged) {
	                    dataAdapter.unregisterChartTickers(needUnregisterTickers);
	                    executeAddOrRemoveCompareTicker(needUnregisterTickers, compareTickers, true, isFromRemoveBtn);
	                    // if (config.startDate !== toolConfig.StartDateTypes.MainTicker) {
	                    //     dataAdapter.getLastTradeDate(tickerCollection).done(function () {
	                    //         eventManager.trigger(eventTypes.UpdateCompareTickers);
	                    //     });
	                    // } else {
	                    eventManager.trigger(eventManager.EventTypes.UpdateCompareTickers);
	
	                }
	            }
	
	            function executeAddOrRemoveCompareTicker(tickers, compareTickers, toRemove, isFromRemoveBtn) {
	                setConfig({
	                    compareTickers: compareTickers
	                });
	                if (toRemove) {
	                    !isFromRemoveBtn && eventManager.trigger(eventManager.EventTypes.onRemoveCompareTickers, tickers);
	                    isFromRemoveBtn && eventManager.trigger(eventManager.EventTypes.onTickerRemoveBtnClicked, tickers);
	                } else {
	                    eventManager.trigger(eventManager.EventTypes.onAddCompareTickers, tickers);
	                }
	            }
	
	            function isSameTicker(tickerA, tickerB) {
	                return tickerA && tickerB && tickerA.listTicker === tickerB.listTicker && tickerA.secId === tickerB.secId;
	            }
	
	            function menuBarConfigProcess() {
	                var hideInterval;
	                for (var bp in config.intervalBreakPointMap) {
	                    var intervalArr = config.intervalBreakPointMap[bp];
	                    for (var i = 0, len = intervalArr.length; i < len; i++) {
	                        if (config[intervalArr[i]] === false) {
	                            intervalArr.splice(i, 1);
	                            len--;
	                            i--;
	                        }
	                    }
	                }
	            }
	
	            function initChartGenreConfig() {
	                if (tickerCollection && tickerCollection.length > 0) {
	                    _initChartGenreConfig(tickerCollection);
	                } else {
	                    var tickerInfos = [config.mainTicker];
	                    if (config.compareTickers && config.compareTickers.length > 0) {
	                        tickerInfos = tickerInfos.concat(config.compareTickers);
	                    }
	                    for (var i = 0, item, tickers = [], tickerLen = tickerInfos.length; i < tickerLen; i++) {
	                        item = tickerInfos[i];
	                        var ticker = _buildTickers(item);
	                        if (ticker) {
	                            tickers.push(ticker);
	                        } else {
	                            tickerInfos.splice(i, 1);
	                            tickerLen--;
	                        }
	                    }
	                    if (typeof tickers[0] === 'string') {
	                        createTickerObjects(tickers).done(function(tickerObjects) {
	                            if (tickerInfos.length > 1) {
	                                _uniqueTickersAfterIdService(tickerObjects, tickerInfos, tickers);
	                            }
	                            processTickerCustom(tickerObjects, tickerInfos);
	                            dataAdapter.registerChartTickers(tickerObjects);
	                            _initChartGenreConfig(tickerObjects, tickerInfos);
	                        });
	                    } else {
	                        processTickerCustom(tickers, tickerInfos);
	                        dataAdapter.registerChartTickers(tickers);
	                        _initChartGenreConfig(tickers);
	                    }
	                }
	            }
	
	            /**
	             * @function unique tickerObjects,TickerInfos
	             * @params tickerObjects From initChartGenreConfig()
	             * @params tickerInfos From initChartGenreConfig()
	             * @params tickers From initChartGenreConfig()
	             * @params compareTickers on config
	             */
	            function _uniqueTickersAfterIdService(tickerObjects, tickerInfos, tickers) {
	                for (var j = 0; j < tickerObjects.length; j++) {
	                    for (var k = j + 1; k < tickerObjects.length; k++) {
	                        var currentTickerObject = tickerObjects[j];
	                        if (isSameTicker(currentTickerObject, tickerObjects[k])) {
	                            tickerObjects.splice(k, 1);
	                            tickerInfos.splice(k, 1);
	                            tickers.splice(k, 1);
	                            config.compareTickers.splice(k - 1, 1);
	                            // k--, because array length will reduce
	                            k--;
	                        }
	                    }
	                }
	            }
	
	            function _buildTickers(tickerInfo) {
	                var ticker;
	                var chartDataType = config.charts.mainChart.dataType;
	                if (tickerInfo.portfolioId || chartDataType === MainDataTypes.TotalReturn || chartDataType === MainDataTypes.MarketValue) {
	                    ticker = tickerInfo.id + ";PO|" + tickerInfo.name;
	                } else if (tickerInfo.type === 'fund') {
	                    ticker = tickerInfo.securityId + ";PO|" + tickerInfo.name;
	                } else if (tickerInfo.ticker) {
	                    ticker = tickerInfo.ticker;
	                } else if (tickerInfo.id && tickerInfo.id.indexOf(']') > -1) {
	                    config.useEUTimeSeriesData = true;
	                    tickerInfo.securityToken = tickerInfo.securityToken || tickerInfo.id;
	                    tickerInfo.id = tickerInfo.id.split(']')[0];
	                } else if (tickerInfo.id) {
	                    ticker = tickerInfo.id;
	                } else {
	                    ticker = tickerInfo;
	                }
	                if (config.useEUTimeSeriesData && tickerInfo.securityToken) {
	                    ticker = tickerInfo.securityToken;
	                    ticker += '|' + (tickerInfo.idType || 'Morningstar');
	                    ticker += '|' + (tickerInfo.name || '');
	                    if (tickerInfo.id) {
	                        ticker += '@_' + tickerInfo.id;
	                    }
	                    if (tickerInfo.currency && config.useEUSecurityData) {
	                        ticker += '@$' + tickerInfo.currency;
	                    }
	                } else if (config.useEUTimeSeriesData && typeof tickerInfo === "string" && tickerInfo.indexOf(']') > 0) {
	                    ticker += tickerInfo + '@_' + tickerInfo.split(']')[0];
	                }
	                return ticker;
	            }
	
	            function _initChartGenreConfig(tickerObjects) {
	                tickerCollection = tickerObjects;
	                mainTickerObject = config.mainTickerObject = tickerObjects[0];
	                config.securityTypeClass = "mkts-cmpt-svgcht-mtype-" + mainTickerObject.mType || '';
	                setChartGenre();
	                if (config.chartGenre === ChartGenre.ForexChart) {
	                    initForexChartConfig();
	                } else if (config.chartGenre === ChartGenre.FundChart) {
	                    initFundChartConfig();
	                } else if (config.chartGenre === ChartGenre.CommodityChart) {
	                    initCommodityChartConfig();
	                } else {
	                    initStockChartConfig();
	                }
	                dataAdapter.getLastTradeDate(tickerCollection).done(function() {
	                    if (config.saveDrawings && !config.isFullyRendered) {
	                        core.DataManager.Chart.saveDrawings = true;
	                        dataAdapter.getDrawings(mainTickerObject, function(data) {
	                            setSavedDrawings(data).done().then(function() {
	                                initRelatedBenchmarks().done(initCallback);
	                            });
	                        });
	                    } else {
	                        initRelatedBenchmarks().done(initCallback);
	                    }
	                });
	                setAutocompleteCategories();
	            }
	
	            function setSavedDrawings(savedDrawings) {
	                var saveDrawing = {};
	                var deferred = $.Deferred();
	                var drawList = savedDrawings && savedDrawings['ch_v3_draw'];
	                if (drawList && drawList.length) {
	                    saveDrawing = transformDrawings(drawList);
	                    config.savedDrawings = saveDrawing;
	                    deferred.resolve();
	                } else if (savedDrawings && config.migrateFromSdk && savedDrawings['chartdraw']) {
	                    transformSdk(savedDrawings['chartdraw'], function(status, resSaveDrawings) {
	                        config.savedDrawings = transReSaveDrawings(resSaveDrawings);
	                        deferred.resolve();
	                    });
	                } else if (savedDrawings && config.resetSavedConfig && savedDrawings['chartdraw']) {
	                    transformSdk(savedDrawings['chartdraw'], function(status, resSaveDrawings) {
	                        config.savedDrawings = transReSaveDrawings(resSaveDrawings);
	                        deferred.resolve();
	                    });
	                } else {
	                    config.savedDrawings = saveDrawing;
	                    deferred.resolve();
	                }
	                return deferred;
	            }
	
	            function transReSaveDrawings(resSaveDrawings) {
	                var transDrawings = {};
	                Object.keys(resSaveDrawings).forEach(function(drawings) {
	                    var resDrawings = {};
	                    resDrawings = resSaveDrawings[drawings];
	                    resDrawings.id = drawings;
	                    if (!transDrawings[resDrawings.drawType]) {
	                        transDrawings[resDrawings.drawType] = [];
	                    }
	                    transDrawings[resDrawings.drawType].push(resDrawings);
	                })
	                return transDrawings;
	            }
	
	            function transformDrawings(drawList) {
	                var drawings = {};
	                drawList.forEach(function(resObj) {
	                    var eventInfo = resObj.EventInfo;
	                    if (!drawings[eventInfo.drawType]) {
	                        drawings[eventInfo.drawType] = [];
	                    }
	                    eventInfo.id = resObj.EventId;
	                    drawings[eventInfo.drawType].push(eventInfo);
	                })
	                return drawings;
	            };
	
	            function transformSdk(drawingsArray, callback) {
	                var resDrawingsArray = [];
	                drawingsArray.forEach(function(resObj, index) {
	                    var obj = {};
	                    Object.keys(resObj).forEach(function(params) {
	                        obj[params] = resObj[params]
	                        if (params === 'EventInfo') {
	                            var eventInfoObj = resObj[params];
	                            var eventObj = {};
	                            eventObj.drawType = DrawTypeMap[eventInfoObj['drawType']];
	                            if (eventInfoObj.start) {
	                                var startObj = {};
	                                var startIdx = eventInfoObj.start.dIdx;
	                                startObj.dIdx = startIdx > 100000 ? startIdx : dateUtil.toDateFromIndex(startIdx).getTime();
	                                startObj.y = eventInfoObj.start.y;
	                                eventObj.start = startObj;
	                            }
	                            if (eventInfoObj.end) {
	                                var endObj = {};
	                                var endIdx = eventInfoObj.end.dIdx;
	                                endObj.dIdx = endIdx > 100000 ? endIdx : dateUtil.toDateFromIndex(endIdx).getTime();
	                                endObj.y = eventInfoObj.end.y;
	                                eventObj.end = endObj;
	                                if (eventInfoObj['drawType'] === 'levelline') {
	                                    eventObj.end = eventObj.start;
	                                }
	                            }
	                            obj[params] = eventObj;
	                        }
	                    })
	                    resDrawingsArray.push(obj);
	                })
	                var saveData = {
	                    point: []
	                };
	                resDrawingsArray.forEach(function(draws) {
	                    saveData.point.push(draws.EventInfo)
	                })
	                saveData.callback = callback;
	                eventManager.trigger(eventManager.EventTypes.SaveLastDrawing, saveData);
	            }
	
	            function setAutocompleteCategories() {
	                var defaultCategoryType = ChartTypeCategoryMap[config.chartGenre];
	                if ($.isArray(config.category)) {
	                    config.autocompleteCategories = config.category;
	                } else {
	                    if (Util.isObj(config.category)) {
	                        var _category = _getMainTickerTypeCategory();
	                        if (_category) {
	                            config.autocompleteCategories = _category; // get config category
	                        } else if (config.category[defaultCategoryType]) {
	                            config.autocompleteCategories = config.category[defaultCategoryType]; //get chartType category
	                        } else {
	                            config.autocompleteCategories = AutocompleteCategories[defaultCategoryType]; //get default category
	                        }
	                    } else {
	                        config.autocompleteCategories = AutocompleteCategories[defaultCategoryType]; //get default category
	                    }
	                }
	            }
	
	            // get config Category by mainTicker of type
	            function _getMainTickerTypeCategory() {
	                for (var i = 0; i < checkList.length; i++) {
	                    if (mainTickerObject[checkList[i]]) {
	                        var type = mainTickerObject[checkList[i]];
	                        if (config.category[type]) {
	                            return config.category[type];
	                        }
	                    }
	                }
	                return null;
	            }
	
	            function initStockChartConfig() {
	                config.menubar.hideDisplay = util.arrConcat(config.menubar.hideDisplay, ['post-tax-return-chart']);
	                setDefaultInterval(IntervalTypes.OneDay);
	            }
	
	            function initFundChartConfig() {
	                if (mainTickerObject.exch == "MSIT") {
	                    config.charts.mainChart.dataType = config.charts.mainChart.dataType || MainDataTypes.Growth10K;
	                }
	                if (isITFund()) {
	                    config.legendInfoLabel = 'Name';
	                }
	                var fundCategories = AutocompleteCategories.fund;
	                if ($.isArray(config.funds) && config.funds.length > 0) {
	                    for (var i = 0, f; i < config.funds.length; i++) {
	                        f = config.funds[i];
	                        if (f === 'FC') {
	                            f = 'Closed-End Fund';
	                        } else if (f === 'FE') {
	                            f = 'ETF';
	                        } else {
	                            f = '';
	                        }
	                        if (!f || $.inArray(f, fundCategories) >= 0) {
	                            continue;
	                        }
	                        fundCategories.push(f);
	                    }
	                }
	                config.charts.volumeChart.needInit = false;
	
	                config.menubar.hideButtons = util.arrConcat(config.menubar.hideButtons, ['mkts-cmpt-svgcht-menubtn--fundamental']);
	                config.menubar.hideEventsIndicators = util.arrConcat(config.menubar.hideEventsIndicators, ['splits', 'earnings', 'change-chart-volume', 's-m-a-v', 'p-s-a-r', 'c-c-i', 'will-r', 's-stochastic', 'f-stochastic', 'p-channel', 'u-l-t', 'd-m-i', 'm-f-i', 'o-b-v', 'v-acc', 'u-d-ratio', 'v-b-p', 'f-volatility', 'acc-dis', 'mass', 'volatility', 'force-index', 'a-t-r', 'keltner', 'prev-close']);
	                config.menubar.hideDisplay = util.arrConcat(config.menubar.hideDisplay, ['ohlc-chart', 'candlestick-chart', 'dividend-effect-chart', 'change-chart-volume-plus', 'change-extended-market-hour', 'title-other']);
	                config.hideFundamental = true;
	                if (!frequencyConfig.OneMonth.reset) {
	                    frequencyConfig.OneMonth.fc = toolConfig.frequencySetupConfig.f4;
	                }
	                if (!frequencyConfig.ThreeMonth.reset) {
	                    frequencyConfig.ThreeMonth.fc = toolConfig.frequencySetupConfig.f4;
	                }
	                setDefaultInterval(IntervalTypes.OneMonth);
	                //config.intervalType = config.intervalType || IntervalTypes.OneMonth;
	            }
	
	            function initForexChartConfig() {
	                setDefaultInterval(IntervalTypes.OneDay);
	                //config.intervalType = config.intervalType || IntervalTypes.OneDay;
	                config.charts.mainChart.yAxis.formatPrefix = "f";
	                config.charts.volumeChart.show = false;
	                config.menubar.hideButtons = util.arrConcat(config.menubar.hideButtons, ['mkts-cmpt-svgcht-menubtn--fundamental']);
	                config.menubar.hideEventsIndicators = util.arrConcat(config.menubar.hideEventsIndicators, ['mkts-cmpt-svgcht-popover1-subtitle1', 'change-events', 'change-chart-volume', 's-m-a-v', 'p-s-a-r', 'will-r', 's-stochastic', 'f-stochastic', 'p-channel', 'u-l-t', 'd-m-i', 'm-f-i', 'o-b-v', 'v-acc', 'u-d-ratio', 'v-b-p', 'f-volatility', 'acc-dis', 'mass', 'volatility', 'force-index', 'a-t-r', 'keltner', 'prev-close']);
	                config.menubar.hideDisplay = util.arrConcat(config.menubar.hideDisplay, ['dividend-effect-chart', 'change-extended-market-hour', 'change-chart-volume-plus', 'post-tax-return-chart']);
	            }
	
	            function initCommodityChartConfig() {
	                config.menubar.hideButtons = util.arrConcat(config.menubar.hideButtons, ['mkts-cmpt-svgcht-menubtn--fundamental']);
	                config.menubar.hideEventsIndicators = util.arrConcat(config.menubar.hideEventsIndicators, ['mkts-cmpt-svgcht-popover1-subtitle1', 'change-events']);
	                config.menubar.hideDisplay = util.arrConcat(config.menubar.hideDisplay, ['p-growth-chart', 'ten-k-growth-chart', 'dividend-effect-chart', 'post-tax-return-chart']);
	                setDefaultInterval(IntervalTypes.OneDay);
	            }
	
	            function setChartGenre() {
	                if (mainTickerObject.type === 20) {
	                    config.chartGenre = ChartGenre.ForexChart;
	                } else if ((isMutualFund(mainTickerObject) || isPortfolio(mainTickerObject) || config.useDataApiTimeseriesData) && !config.drawNavAndPriceChart || isPerformanceTickers() || isCategory()) {
	                    config.chartGenre = ChartGenre.FundChart;
	                } else if (isCommodity(mainTickerObject)) {
	                    config.chartGenre = ChartGenre.CommodityChart;
	                } else {
	                    config.chartGenre = ChartGenre.StockChart;
	                }
	            }
	
	            function isPortfolio(tickerObj) {
	                var mType = tickerObj.mType;
	                return mType === 'PO';
	            }
	
	            function isCommodity(tickerObj) {
	                var mType = tickerObj.mType;
	                return mType === "FU";
	            }
	
	            function isPerformanceTickers(tickerObj) {
	                if (!tickerObj) {
	                    tickerObj = mainTickerObject;
	                }
	                return !!tickerObj.benchmarkType;
	            }
	
	            function isCategory(tickerObj) {
	                if (!tickerObj) {
	                    tickerObj = mainTickerObject;
	                }
	                return (tickerObj.mType === 'CA' || tickerObj.benchmarkType === BenchmarkType.FundCategory);
	            }
	
	            function isMutualFund(tickerObj) {
	                if (!tickerObj) {
	                    tickerObj = mainTickerObject;
	                }
	                var type = tickerObj.type;
	                var mType = tickerObj.mType;
	                var isFundType = false;
	                if (typeof config.funds === 'function') {
	                    isFundType = config.funds(tickerObj);
	                } else if ($.isArray(config.funds)) {
	                    for (var i = 0; i < config.funds.length; i++) {
	                        if (mType == config.funds[i]) {
	                            isFundType = true;
	                            break;
	                        }
	                    }
	                }
	                if (isFundType) {
	                    tickerObj.isCustomFund = true;
	                }
	                if (tickerObj.tsfund && tickerObj.tenforeCode && tickerObj.tenforeCode.indexOf('9999') > -1 || (tickerObj.tsfund && !tickerObj.tenforeCode)) {
	                    isFundType = true;
	                }
	                if (mType === 'FM') {
	                    isFundType = true;
	                } else if (mType == '' && Number(type) === 15) {
	                    isFundType = true;
	                }
	                return isFundType || mType === "FO" || (type == 8 && (!mType || mType == "SA" || mType === "FV"));
	            }
	
	            function loadTheme(theme) {
	                var leftSliderBrushImageUrl, rightSliderBrushImageUrl;
	                config.hideTab = true;
	                switch (theme) {
	                    case '4':
	                        leftSliderBrushImageUrl = rightSliderBrushImageUrl = config.StaticFilesPath + 'arca/images/brush-q.png';
	                        //config.maxWidth = 960;
	                        config.hideMenu = true;
	                        config.hideTab = false;
	                        config.menubar.hideInterval = ['mkts-cmpt-svgcht-frequency-picker'];
	                        config.applyAspectRatio = false;
	                        config.charts.sliderChart.height = 45;
	                        config.mainTickerColor = config.mainTickerColor || '#a11140';
	                        config.compareColors = config.compareColors || ['#333333', '#B967C7', '#19227D', '#2095F2', '#548A2E', '#AEB32A', '#4D332D'];
	                        config.charts.mainChart.yAxis.formatPrefix = "CUSTOM";
	                        config.charts.mainChart.dataType = MainDataTypes.Growth10K;
	                        config.dailyDateFormatter = 'DD/MM/YYYY';
	                        config.yAxisOrient = "left";
	                        config.yAxisPosition = "inner";
	                        config.showYAxisTickLine = false;
	                        config.growthType = "performancesGrowth";
	                        config.useEUTimeSeriesData = true;
	                        config.hideExport = true;
	                        config.intervalBreakPointMap = {
	                            'default': ['1M', '3M', 'YTD', '1Y', '3Y', '5Y', '10Y'],
	                            '600': ['1M', '1Y', '5Y']
	                        };
	                        break;
	                    case '5':
	                        config.lang = 'en-GB';
	                        config.autoComplete.highlight = true;
	                        leftSliderBrushImageUrl = rightSliderBrushImageUrl = config.StaticFilesPath + 'fidelity/images/fidelity.png';
	                        config.margin = {
	                            left: 0,
	                            top: 0,
	                            right: 0,
	                            bottom: 0
	                        };
	                        config.crosshairJustify = true;
	                        config.theme = 5;
	                        config.enterTipsLabelID = 'search-assets';
	                        config.showDiscountCumFair = true;
	                        config.showNAV = true;
	                        config.yAxisOrient = "right";
	                        config.yAxisPosition = "inner";
	                        config.showYAxisTickLine = false;
	                        config.charts = $.extend(true, config.charts, {
	                            volumeChart: {
	                                height: 98,
	                                yAxis: {
	                                    show: true
	                                }
	                            },
	                            sliderChart: {
	                                height: 85
	                            }
	                        });
	                        config.needLegendBackground = true;
	                        config.mainTickerColor = [];
	                        config.compareColors = [];
	                        config.yAxisMargin = 16;
	                        var tagProperties = {
	                            tagHeight: 32,
	                            sideMargin: 12,
	                            textTopMargin: 13
	                        };
	                        if (config.tagMode === 's') {
	                            tagProperties.tagHeight = 25;
	                            tagProperties.tagWidth = 56;
	                            tagProperties.textTopMargin = 12;
	                            tagProperties.tagMode = config.tagMode;
	                        }
	                        config.charts.mainChart.tagProperties = $.extend(true, config.charts.mainChart.tagProperties, tagProperties);
	                        config.intervalBreakPointMap = {
	                            'default': ['1D', '5D', '1M', '3M', '6M', 'YTD', '1Y', '5Y', '10Y'],
	                            '600': ['1D', '1M', '1Y', '10Y']
	                        };
	                        resetColorConfig();
	                        break;
	                    default:
	                        var url = config.StaticFilesPath;
	                        leftSliderBrushImageUrl = url + "morningstar/images/brush-m-1.png";
	                        rightSliderBrushImageUrl = url + "morningstar/images/brush-m-2.png";
	                        break;
	                }
	
	                if (!config.brushImages) {
	                    config.brushImages = [leftSliderBrushImageUrl, rightSliderBrushImageUrl];
	                }
	                config.compareColors = config.compareColors || ['#FD5516', '#008E91', '#709900', '#5050CC', '#FFB600', '#AA008A', '#037F56'];
	                config.mainTickerColor = config.mainTickerColor || '#0039B7';
	            }
	
	            function resetColorConfig() {
	                var fundamentalCfg = config.charts.mainChart.fundamentalProperties;
	                var indicatorCfg = config.charts.mainChart.indicatorProperties;
	                for (var i in fundamentalCfg) {
	                    fundamentalCfg[i].color = [];
	                }
	                for (var i in indicatorCfg) {
	                    indicatorCfg[i].color = [];
	                }
	            }
	
	            function reduceMonth(date, months) {
	                var d = date.getDate();
	                date.setMonth(date.getMonth() - months);
	                if (date.getDate() < d) { // for special case, like date=new Date('2019-3-31'), months=1
	                    date.setDate(0);
	                }
	                return date;
	            }
	
	            function getDateRangeByInterval(intervalType) {
	                var eod = getLastTradeDate(),
	                    startDate = getLastTradeDate();
	                var y = startDate.getFullYear(),
	                    m = startDate.getMonth(),
	                    d = startDate.getDate();
	                switch (intervalType) {
	                    case IntervalTypes.FiveDay:
	                        startDate = new Date(y, m, d - 5);
	                        break;
	                    case IntervalTypes.FifteenDay:
	                        startDate = new Date(y, m, d - 15);
	                        break;
	                    case IntervalTypes.OneMonth:
	                        startDate = reduceMonth(startDate, 1);
	                        break;
	                    case IntervalTypes.ThreeMonth:
	                        startDate = reduceMonth(startDate, 3);
	                        break;
	                    case IntervalTypes.SixMonth:
	                        startDate = reduceMonth(startDate, 6);
	                        break;
	                    case IntervalTypes.YTD:
	                        startDate = new Date(y, 0, 1);
	                        break;
	                    case IntervalTypes.OneYear:
	                        startDate = new Date(y - 1, m, d);
	                        break;
	                    case IntervalTypes.ThreeYear:
	                        startDate = new Date(y - 3, m, d);
	                        break;
	                    case IntervalTypes.FiveYear:
	                        startDate = new Date(y - 5, m, d);
	                        break;
	                    case IntervalTypes.TenYear:
	                        startDate = new Date(y - 10, m, d);
	                        break;
	                    case IntervalTypes.FifteenYear:
	                        startDate = new Date(y - 15, m, d);
	                        break;
	                    case IntervalTypes.Max:
	                        startDate = config.compareNewstartDate || config.maxRangeStartDate;
	                        break;
	                }
	                return [startDate, eod];
	            }
	
	            function getDefaultFrequencyByIntervalType(intervalType) {
	                if (intervalType) {
	                    return config.intervalFrequencyMap[intervalType];
	                }
	            }
	
	            function getPriceType(tickerObjects) {
	                var priceType = getMainDataType();
	                if (priceType === MainDataTypes.PriceWithDividendGrowth) {
	                    priceType = dataAdapter.PriceType.PriceWithDividendGrowth;
	                } else if (priceType === MainDataTypes.Growth10K) {
	                    priceType = dataAdapter.PriceType.Growth10K;
	                } else {
	                    if (tickerObjects.length > 1) {
	                        if (priceType === MainDataTypes.PostTax) {
	                            priceType = dataAdapter.PriceType.PostTaxReturn;
	                        } else {
	                            if (config.drawNavAndPriceChart) {
	                                priceType = dataAdapter.PriceType.PriceAndNav;
	                            } else {
	                                priceType = dataAdapter.PriceType.Growth;
	                            }
	                        }
	                    } else {
	                        if (config.chartGenre === ChartGenre.FundChart) {
	                            priceType = priceType === MainDataTypes.Price ? MainDataTypes.Nav : priceType;
	                        }
	                    }
	                }
	                switch (priceType) {
	                    case MainDataTypes.Growth:
	                    case MainDataTypes.DividendEffect:
	                        priceType = dataAdapter.PriceType.Growth;
	                        break;
	                    case MainDataTypes.Growth10K:
	                        priceType = dataAdapter.PriceType.Growth10K;
	                        break;
	                    case MainDataTypes.PostTax:
	                        priceType = dataAdapter.PriceType.PostTax;
	                        break;
	                    case MainDataTypes.TotalReturn:
	                        priceType = dataAdapter.PriceType.TotalReturn;
	                        break;
	                    case MainDataTypes.MarketValue:
	                        priceType = dataAdapter.PriceType.MarketValue;
	                        break;
	                    case MainDataTypes.PriceAndNav:
	                        priceType = dataAdapter.PriceType.PriceAndNav;
	                        break;
	                    case MainDataTypes.Price:
	                    case MainDataTypes.Nav:
	                        if (config.growthBaseValue) {
	                            priceType = dataAdapter.PriceType.Growth10K;
	                        }
	                        break;
	                }
	                return priceType;
	            }
	
	            function createRequestObj(tickerObjects, adjustedDateRange) {
	                var req = new dataAdapter.Request();
	                var intervalType = config.intervalType;
	                var frequency;
	                var dateRange = adjustedDateRange || config.dateRange;
	                req.indicators(getIndicators()).fundamentals(getFundamentals()).events(config.events);
	                if (intervalType && !adjustedDateRange) {
	                    frequency = config.frequency || (config.frequency = getDefaultFrequencyByIntervalType(intervalType));
	                    dateRange = setRequestByInterval(intervalType, req, frequency) || dateRange;
	                    dateRange = _changeDateRangeByFrequency(frequency, dateRange, false); // change dateRange to get full data
	                    dateRange && req.dateRange(dateRange);
	                } else {
	                    frequency = config.frequency || (config.frequency = getFrequencyByDateRange(dateRange));
	                    dateRange = _changeDateRangeByFrequency(frequency, dateRange, true); // change dateRange to get full data
	                    req.dateRange(dateRange);
	                }
	                req.isPreAfter(config.showPreAfter);
	                req.priceType(getPriceType(tickerObjects)).tickerObjects(tickerObjects).frequency(frequency).keepDateRange(true);
	                req.growthBaseValue(config.growthBaseValue);
	                if (config.startDate === toolConfig.StartDateTypes.Earliest) {
	                    req.alignMainTicker(false);
	                }
	                var preloadInfo = {}; // this reset all other parameters, like loadedData.
	                preloadInfo.intervalType = intervalType;
	                preloadInfo.frequency = frequency;
	                preloadInfo.dateRange = dateRange;
	                req.preloadInfo = preloadInfo;
	                return req;
	            }
	
	            function createDisplayRequestObj(tickerObjects, dateRange, frequency) {
	                var req = new dataAdapter.Request();
	                var intervalType = config.intervalType;
	                req.indicators(getIndicators()).events(config.events);
	                if (!config.fundamentalNotAvailable) {
	                    req.fundamentals(getFundamentals())
	                }
	                req.dateRange(dateRange);
	                req.isPreAfter(config.showPreAfter);
	                config.growthType && req.chartType(config.growthType);
	                req.growthBaseValue(config.growthBaseValue);
	                req.priceType(getPriceType(tickerObjects)).tickerObjects(tickerObjects).frequency(frequency).keepDateRange(true);
	                return req;
	            }
	
	            function getFundamentals() {
	                var fundamentals = config.fundamentals ? config.fundamentals.slice() : [];
	                if (getMainDataType() === MainDataTypes.DividendEffect) {
	                    fundamentals.push(dataAdapter.Fundamental.MReturnIndex);
	                }
	                return fundamentals;
	            }
	
	            function getPreloadIntervalType(intervalType) {
	                var preloadIntervalType;
	                switch (intervalType) {
	                    case IntervalTypes.OneDay:
	                        preloadIntervalType = IntervalTypes.FiveDay;
	                        break;
	                    case IntervalTypes.FiveDay:
	                        preloadIntervalType = IntervalTypes.FifteenDay;
	                        break;
	                    case IntervalTypes.FifteenDay:
	                        preloadIntervalType = IntervalTypes.OneMonth;
	                        break;
	                    case IntervalTypes.OneMonth:
	                        preloadIntervalType = IntervalTypes.ThreeMonth;
	                        break;
	                    case IntervalTypes.ThreeMonth:
	                        preloadIntervalType = IntervalTypes.SixMonth;
	                        break;
	                    case IntervalTypes.SixMonth:
	                        preloadIntervalType = IntervalTypes.OneYear;
	                        break;
	                    case IntervalTypes.OneYear:
	                        preloadIntervalType = IntervalTypes.ThreeYear;
	                        break;
	                    case IntervalTypes.ThreeYear:
	                        preloadIntervalType = IntervalTypes.FiveYear;
	                        break;
	                    case IntervalTypes.FiveYear:
	                        preloadIntervalType = IntervalTypes.TenYear;
	                        break;
	                }
	                return preloadIntervalType;
	            }
	
	            function getPreloadDateRange(dateRange) {
	                var oriEndDate = dateRange[1];
	                var oriStartDate = dateRange[0];
	                var timeSpan = oriEndDate - oriStartDate;
	                if (timeSpan / (3600 * 24 * 1000) < 4) { //less than 4 days
	                    timeSpan += (3600 * 24 * 1000 * 4);
	                } else {
	                    timeSpan = 2 * timeSpan;
	                }
	                var newStartDate = oriStartDate - timeSpan;
	                return [new Date(newStartDate), oriStartDate];
	            }
	
	            function createPreloadRequestObj(tickerObjects, preloadInfo) {
	                var req = new dataAdapter.Request();
	                preloadInfo = preloadInfo || {};
	                var intervalType = preloadInfo.intervalType || config.intervalType;
	                var frequency = preloadInfo.frequency || config.frequency || getDefaultFrequencyByIntervalType(intervalType);
	                req.indicators(getIndicators()).fundamentals(getFundamentals());
	                var dateRange = preloadInfo.dateRange || config.dateRange;
	                if (dateRange && dateRange.length === 2) {
	                    frequency = frequency || getFrequencyByDateRange(dateRange);
	                    dateRange = getPreloadDateRange(dateRange);
	                    dateRange = _changeDateRangeByFrequency(frequency, dateRange);
	                    req.dateRange(dateRange);
	                } else {
	                    intervalType = getPreloadIntervalType(config.intervalType);
	                    frequency = frequency || getDefaultFrequencyByIntervalType(intervalType);
	                    dateRange = setRequestByInterval(intervalType, req) || dateRange;
	                    dateRange = _changeDateRangeByFrequency(frequency, dateRange);
	                }
	                req.isPreAfter(config.showPreAfter);
	                req.priceType(getPriceType(tickerObjects)).tickerObjects(tickerObjects).frequency(frequency).keepDateRange(true);
	                req.growthBaseValue(config.growthBaseValue);
	                preloadInfo.intervalType = intervalType;
	                preloadInfo.frequency = frequency;
	                preloadInfo.dateRange = dateRange;
	                req.preloadInfo = preloadInfo;
	                return req;
	            }
	
	            function getFrequencyByDateRange(dateRange, returnIntervalType) {
	                var startDate = dateRange[0];
	                var endDate = dateRange[1];
	                var daySpan = (endDate - startDate) / Constants.DAY_IN_MILLISECONDS;
	                var intervalFrequencyMap = config.intervalFrequencyMap;
	                var intervalType, frequency;
	
	                daySpan = Math.abs(daySpan);
	
	                if (daySpan >= 365 * 10) {
	                    intervalType = IntervalTypes.Max;;
	                } else if (daySpan >= 365 * 5 && daySpan < 365 * 10) {
	                    intervalType = IntervalTypes.FiveYear;
	                } else if (daySpan >= 365 * 3 && daySpan < 365 * 5) {
	                    intervalType = IntervalTypes.ThreeYear;
	                } else if (daySpan >= 365 * 1 && daySpan < 365 * 3) {
	                    intervalType = IntervalTypes.OneYear;
	                } else if (daySpan > 90 && daySpan < 365) {
	                    intervalType = IntervalTypes.SixMonth; // rt can not query morn then 90 days of minutes data
	                } else if (daySpan >= 30 && daySpan <= 90) {
	                    intervalType = IntervalTypes.OneMonth;
	                } else if (daySpan >= 15 && daySpan < 30) {
	                    intervalType = IntervalTypes.FifteenDay;
	                } else if (daySpan >= 5 && daySpan < 15) {
	                    intervalType = IntervalTypes.FiveDay;
	                } else if (daySpan < 5) {
	                    intervalType = IntervalTypes.OneDay;
	                }
	                if (config.chartGenre === ChartGenre.FundChart && daySpan < 30) {
	                    intervalType = IntervalTypes.OneMonth;
	                }
	                if (returnIntervalType) {
	                    frequency = intervalType;
	                } else {
	                    frequency = intervalFrequencyMap[intervalType];
	                }
	
	                return frequency;
	            }
	
	            function getSliderChartfrequency() {
	                var frequency = config.sliderChartfrequency;
	                if (!frequency) {
	                    if (config.intervalType) {
	                        var sliderIntervalType = config.SliderChartIntervalTypeMap[config.intervalType];
	                        frequency = config.intervalFrequencyMap[sliderIntervalType];
	                    } else if (config.dateRange) {
	                        frequency = getFrequencyByDateRange(config.dateRange);
	                    }
	                }
	                return frequency;
	            }
	
	            function getSliderNextTntervalType(intervalType) {
	                var pos = $.inArray(intervalType, intervalTypeSortedArray);
	                var nextIntervalType, target, found = false;
	                var sliderIntervalTypeMap = config.SliderChartIntervalTypeMap;
	                for (var i = pos + 1, len = intervalTypeSortedArray.length; i < len; i++) {
	                    nextIntervalType = intervalTypeSortedArray[i];
	                    for (var key in sliderIntervalTypeMap) {
	                        if (sliderIntervalTypeMap[key] === nextIntervalType) {
	                            found = true;
	                            break;
	                        }
	                    }
	                    if (found) {
	                        break;
	                    }
	                }
	                return nextIntervalType;
	            }
	
	            function createSliderChartRequestObj(tickerObjects, preloadInfo) {
	                var sliderChartIntervalType;
	                if (preloadInfo) {
	                    sliderChartIntervalType = getSliderNextTntervalType(preloadInfo.intervalType);
	                } else {
	                    var mainChartIntervalType = config.intervalType;
	                    if (mainChartIntervalType) {
	                        sliderChartIntervalType = config.SliderChartIntervalTypeMap[mainChartIntervalType];
	                    } else {
	                        var mainChartDateRange = config.dateRange;
	                        var today = new Date();
	                        var days = (today - mainChartDateRange[0]) / Constants.DAY_IN_MILLISECONDS;
	                        if (days < 30 * 2.5) {
	                            sliderChartIntervalType = IntervalTypes.ThreeMonth;
	                        } else if (days < 30 * 5) {
	                            sliderChartIntervalType = IntervalTypes.SixMonth;
	                        } else if (days < 30 * 12 * 9.5) {
	                            sliderChartIntervalType = IntervalTypes.TenYear;
	                        } else {
	                            sliderChartIntervalType = IntervalTypes.Max;
	                        }
	                    }
	                }
	
	                var req = new dataAdapter.Request();
	                var frequency = getDefaultFrequencyByIntervalType(sliderChartIntervalType);
	                var dateRange = getDateRangeByInterval(sliderChartIntervalType);
	                req.priceType(getPriceType(tickerObjects));
	                req.dateRange(dateRange);
	                req.growthBaseValue(config.growthBaseValue);
	                req.tickerObjects([mainTickerObject]).frequency(frequency).keepDateRange(true);
	                req.isPreAfter(config.showPreAfter);
	                preloadInfo = preloadInfo || {};
	                preloadInfo.intervalType = sliderChartIntervalType;
	                preloadInfo.frequency = frequency;
	                preloadInfo.dateRange = dateRange;
	                req.preloadInfo = preloadInfo;
	                return req;
	            }
	
	            function isITFund(tickerObject) {
	                var tickerObject = tickerObject || mainTickerObject;
	                return tickerObject.tsfund === true;
	            }
	
	            function isSemiEarningsExch(tickerObject) {
	                var tickerObject = tickerObject || mainTickerObject;
	                var checkFields = ['MIC-CODE', 'CompositeExchangeID', 'tenforeCode', 'listMarket'];
	                for (var i = 0; i < checkFields.length; i++) {
	                    if (config.semiEarningsExch.indexOf(tickerObject[checkFields[i]]) > -1) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	
	            function changeCollectionCurrency() {
	                tickerCollection.forEach(function(item) {
	                    item.customCurrency = config.baseCurrency;
	                })
	            }
	
	            function fetchMainTickerData(callback, adjustedDateRange) {
	                if (config.baseCurrency && config.solutionKey) {
	                    changeCollectionCurrency();
	                    dataAdapter.registerChartTickers(tickerCollection);
	                }
	                var req = createRequestObj(tickerCollection, adjustedDateRange);
	                dataAdapter.fetchTSData(req, function(res) {
	                    dataPreprocess(req, res, callback);
	                });
	            }
	
	            function fetchDisplayData(dateRange, frequency, callback) {
	                var req = createDisplayRequestObj(tickerCollection, dateRange, frequency);
	                dataAdapter.fetchTSData(req, function(res) {
	                    callback(res, req.preloadInfo);
	                });
	            }
	
	            function fetchSliderChartData(preloadInfo, callback) {
	                var req = createSliderChartRequestObj(tickerCollection, preloadInfo);
	                dataAdapter.fetchTSData(req, function(res) {
	                    dataPreprocess(req, res, callback);
	                });
	            }
	
	            function preloadMainTickerData(preloadInfo, callback) {
	                var IPODate = config.mainTickerObject.IPODate
	                if (IPODate && typeof IPODate === 'string') {
	                    IPODate = new Date(IPODate);
	                }
	                var maxStartDate = IPODate || config.maxRangeStartDate;
	                if (!preloadInfo.dateRange || !preloadInfo.dateRange[0] || (preloadInfo.dateRange[0] > maxStartDate)) {
	                    changeFundamentalStatus(false);
	                    var req = createPreloadRequestObj(tickerCollection, preloadInfo);
	                    if (req.dateRange()[0] && req.dateRange()[0] < maxStartDate) {
	                        req.dateRange()[0] = maxStartDate;
	                    }
	                    dataAdapter.fetchTSData(req, function(res) {
	                        dataPreprocess(req, res, callback);
	                    })
	                } else {
	                    callback(null, preloadInfo);
	                }
	            }
	
	            function dataPreprocess(req, res, callback) {
	                var indicatorArr = req.indicators();
	                if (indicatorArr && indicatorArr.length > 0) {
	                    for (var k = 0, reqLen = indicatorArr.length; k < reqLen; k++) {
	                        var requestName = indicatorArr[k].name();
	                        var reuestParameter = indicatorArr[k].parameter() || [];
	                        var indicatorsRes = res.data()[0] && res.data()[0].Indicators;
	                        var resultArr, indicatorData;
	                        for (var returnName in indicatorsRes) {
	                            if ((requestName == "SMA" || requestName == "EMA") && requestName === returnName) {
	                                resultArr = [];
	                                indicatorData = indicatorsRes[returnName];
	                                for (var i = 0, len = reuestParameter.length; i < len; i++) {
	                                    for (var j = 0, dataLen = indicatorData.length; j < dataLen; j++) {
	                                        if (reuestParameter[i] == indicatorData[j].parameter) {
	                                            resultArr.push(indicatorData[j]);
	                                            break;
	                                        }
	                                    }
	                                }
	                                indicatorsRes[returnName] = resultArr;
	                                break;
	                            }
	                        }
	                    }
	                }
	                callback(res, req.preloadInfo);
	            }
	
	            function getIndicators() {
	                var indicators = [];
	                if (config.indicators && config.indicators.length > 0) {
	                    config.indicators.forEach(function(indicator) {
	                        indicators.push(new dataAdapter.Indicator(indicator.name, indicator.parameters));
	                    });
	                }
	                if (config.charts.mainChart.chartType === MainChartTypes.ABChart && config.intervalType === IntervalTypes.OneDay && !_isCompareOrPercentChart()) {
	                    indicators.push(new dataAdapter.Indicator("PrevClose"));
	                }
	                return indicators;
	            }
	
	            function exportToExcel() {
	                eventManager.trigger(eventTypes.ExportData);
	            }
	
	            function bindEvents() {
	                eventManager.bind(eventTypes.ChangeIDFConfig, changeIntervalFrequency);
	                eventManager.bind(eventTypes.ChangeIndicators, changeIndicators);
	                eventManager.bind(eventTypes.ChangeFundamental, changeFundamental);
	                eventManager.bind(eventTypes.ChangeEvents, changeEvents);
	                eventManager.bind(eventTypes.ChangeTicker, changeMainTicker);
	                eventManager.bind(eventTypes.CompareTicker, compareTicker);
	                eventManager.bind(eventTypes.Export, exportToExcel);
	                eventManager.bind(eventTypes.ChangeDateRangeByZoom, changeDateRangeByZoom);
	                eventManager.bind(eventTypes.ChangeChartCursor, changeChartCursor);
	                eventManager.bind(eventTypes.ChangeYAxis, changeYAxis);
	                eventManager.bind(eventTypes.ChangeSelectionMode, changeSelectionMode);
	                eventManager.bind(eventTypes.ChangeVerticalScale, changeVerticalScale);
	                eventManager.bind(eventTypes.FundamentalNotAvailable, changeFundamentalStatus);
	                eventManager.bind(eventTypes.ChangeChartVolume, changeChartVolume);
	                eventManager.bind(eventTypes.ChangeChartVolumePlus, changeChartVolumePlus);
	                eventManager.bind(eventTypes.ChartDataUpdate, processChartDataUpdate);
	                eventManager.bind(eventTypes.DestroyChart, processDestroyChart);
	                eventManager.bind(eventTypes.ChangeOneDayFrequency, changeOneDayFrequency);
	                eventManager.bind(eventTypes.ChangeGrowthType, changeGrowthType);
	                eventManager.bind(eventTypes.ChangeChartType, changeChartType);
	                eventManager.bind(eventTypes.Reset, updateChart);
	                eventManager.bind(eventTypes.ChangeGrowthBaseValue, _changGrowthBaseValue);
	                eventManager.bind(eventTypes.ChangeExtendedMarketHour, _changeExtendedMarketHour);
	                eventManager.bind(eventTypes.ChangeStartDate, _changeStartDate);
	                eventManager.bind(eventTypes.SaveLastDrawing, _saveLastDrawing);
	                eventManager.bind(eventTypes.UpdateDrawing, _updateDrawing);
	                eventManager.bind(eventTypes.RemoveDrawing, _removeDrawing);
	                // bind callback
	                registerCallback(config.callbacks);
	            }
	
	            function _changeExtendedMarketHour() {
	                var newConfig = {};
	                newConfig.showPreAfter = !config.showPreAfter;
	                setConfig(newConfig);
	                eventManager.trigger(eventTypes.DrawNewData);
	            }
	
	            function _saveLastDrawing(drawingsData) {
	                dataAdapter.saveLastDrawing(mainTickerObject, drawingsData.type, drawingsData.point, drawingsData.callback);
	            }
	
	            function _updateDrawing(drawingsData) {
	                dataAdapter.updateDrawing(mainTickerObject, drawingsData.type, drawingsData.point, drawingsData.callback);
	            }
	
	            function _removeDrawing(drawingsData) {
	                dataAdapter.removeDrawing(mainTickerObject, drawingsData.type, drawingsData.point, drawingsData.callback);
	            }
	
	            function changeGrowthType(growthType) {
	                config.growthType = growthType;
	                if (growthType == "performancesGrowth") {
	                    config.charts.mainChart.dataType = MainDataTypes.Growth10K;
	                } else if (growthType == "priceGrowth") {
	                    config.charts.mainChart.dataType = MainDataTypes.Growth;
	                }
	                eventManager.trigger(eventTypes.DrawNewData);
	            }
	
	            function changeOneDayFrequency(isChange) {
	                var frequencyMap = config.intervalFrequencyMap;
	                if (isChange) {
	                    if (!frequencyMap.OneDay_BackUp) {
	                        frequencyMap.OneDay_BackUp = frequencyMap.OneDay;
	                    }
	                    frequencyMap.OneDay = frequencyMap.FiveDay;
	                } else if (frequencyMap.OneDay_BackUp) {
	                    frequencyMap.OneDay = frequencyMap.OneDay_BackUp;
	                }
	            }
	
	            function processDestroyChart(clearTickers) {
	                if (clearTickers !== false) {
	                    dataAdapter.unregisterChartTickers(tickerCollection);
	                    tickerCollection = [];
	                }
	                for (var i = 0; i < timers.length; i++) {
	                    clearTimeout(timers[i]);
	                }
	                eventManager.clearBinders();
	            }
	
	            function isIntraday(frequency) {
	                frequency = frequency || config.frequency;
	                return !isNaN(frequency);
	            }
	
	            function processChartDataUpdate(isAutorefresh) {
	                var isRefresh = isAutorefresh ? isAutorefresh : config.isAutoRefresh;
	                if (config.intervalType && isIntraday(config.frequency) && isRefresh) {
	                    eventManager.trigger(eventTypes.DrawNewData);
	                }
	            }
	
	            function changeChartVolume(status) {
	                config.charts.volumeChart.show = status;
	                eventManager.trigger(eventTypes.ChangeVolumeChart);
	            }
	
	            function changeChartVolumePlus(status) {
	                var chartType = status ? VolumeChartTypes.VolumePlusChart : VolumeChartTypes.VolumeChart;
	                setVolumeChartType(chartType);
	                eventManager.trigger(eventTypes.ChangeVolumeChart);
	            }
	
	            function changeFundamentalStatus(status) {
	                config.fundamentalNotAvailable = status;
	            }
	
	            function changeSelectionMode(selectionMode) {
	                var newConfig = {};
	                newConfig.charts = $.extend(true, newConfig.charts, config.charts);
	                if (selectionMode) {
	                    newConfig.charts.mainChart.selectionMode = selectionMode;
	                }
	                setConfig(newConfig);
	            }
	
	            function changeVerticalScale(verticalScaleType) {
	                var newConfig = {};
	                newConfig.verticalScaleType = verticalScaleType;
	                setConfig(newConfig);
	            }
	
	            function changeYAxis(position) {
	                var newConfig = {};
	                newConfig.yAxisOrient = config.yAxisOrient;
	                newConfig.charts = $.extend(true, newConfig.charts, config.charts);
	                if (position) {
	                    newConfig.yAxisOrient = position;
	                    newConfig.charts.mainChart.yAxis.orient = position;
	                    newConfig.charts.volumeChart.yAxis.orient = position;
	                    newConfig.charts.sliderChart.yAxis.orient = position;
	                    newConfig.charts.indicatorChart.yAxis.orient = position;
	                    newConfig.charts.fundamentalChart.yAxis.orient = position;
	                }
	                setConfig(newConfig);
	            }
	
	            function changeShowGridBlocks(showGridBlocks) {
	                var newConfig = config;
	                newConfig.charts.mainChart.showGridBlocks = showGridBlocks;
	                newConfig.charts.volumeChart.showGridBlocks = showGridBlocks;
	                newConfig.charts.sliderChart.showGridBlocks = showGridBlocks;
	                newConfig.charts.indicatorChart.showGridBlocks = showGridBlocks;
	                newConfig.charts.fundamentalChart.showGridBlocks = showGridBlocks;
	                setConfig(newConfig);
	            }
	
	            function changeShowSolidGridLines(showSolidGridLines) {
	                var newConfig = config;
	                newConfig.charts.mainChart.showSolidGridLines = showSolidGridLines;
	                newConfig.charts.volumeChart.showSolidGridLines = showSolidGridLines;
	                newConfig.charts.sliderChart.showSolidGridLines = showSolidGridLines;
	                newConfig.charts.indicatorChart.showSolidGridLines = showSolidGridLines;
	                newConfig.charts.fundamentalChart.showSolidGridLines = showSolidGridLines;
	                setConfig(newConfig);
	            }
	
	            function changeChartCursor(newCursorType) {
	                if (lastCursorType !== newCursorType) {
	                    var newConfig = {};
	                    newConfig.cursorType = newCursorType;
	                    setConfig(newConfig);
	                    config.$componentContainer.find('.' + config.cursorValueClass).text('');
	                    lastCursorType = newCursorType;
	                }
	            }
	
	            function compareTicker(ticker, toRemove, isFromRemoveBtn) {
	                if (toRemove) {
	                    removeCompareTickers(ticker, isFromRemoveBtn);
	                } else {
	                    addCompareTickers([ticker]);
	                }
	            }
	
	            function changeDateRangeByZoom(newDateRange) {
	                if ($.isArray(newDateRange) && newDateRange.length === 2) {
	                    var newConfig = {};
	                    newConfig.dateRange = newDateRange;
	                    newConfig.intervalType = null;
	                    setConfig(newConfig);
	                }
	            }
	
	            function changeEvents(eventType) {
	                if (eventType === dataAdapter.Events.Dividend) {
	                    config.charts.mainChart.showDividend = !config.charts.mainChart.showDividend;
	                }
	
	                var newConfig = {
	                    events: $.extend(true, [], config.events)
	                };
	                var existingEvents = newConfig.events.filter(function(e) {
	                    return e === eventType;
	                });
	                if (existingEvents.length > 0) {
	                    newConfig.events = newConfig.events.filter(function(e) {
	                        return e !== eventType;
	                    });
	                } else {
	                    newConfig.events.push(eventType);
	                }
	                setConfig(newConfig);
	            }
	
	            function isIndicatorsFundamentals(name) {
	                return dataAdapter.IndicatorName.DYield === name || dataAdapter.IndicatorName.RDividend === name;
	            }
	
	            function changeFundamental(fundamental) {
	                var newConfig = {};
	                if (isIndicatorsFundamentals(fundamental)) {
	                    newConfig = {
	                        indicators: $.extend(true, [], config.indicators)
	                    };
	                    var existingIndicator = newConfig.indicators.filter(function(cf) {
	                        return cf.name === fundamental;
	                    });
	                    if (existingIndicator.length > 0) {
	                        newConfig.indicators = newConfig.indicators.filter(function(cf) {
	                            return cf.name !== fundamental;
	                        });
	                    } else {
	                        newConfig.indicators.push({
	                            name: fundamental,
	                            parameters: []
	                        });
	
	                        //Add dividend if not exists
	                        var eventsConfig = {
	                            events: config.events
	                        };
	                        var dividendExists = eventsConfig.events.filter(function(e) {
	                            return e === 'DD001';
	                        });
	                        if (dividendExists.length === 0) {
	                            eventsConfig.events.push('DD001');
	                        }
	                        setConfig(eventsConfig);
	                    }
	                } else {
	                    newConfig = {
	                        fundamentals: $.extend(true, [], config.fundamentals)
	                    };
	                    var existingFundamental = newConfig.fundamentals.filter(function(f) {
	                        return f === fundamental;
	                    });
	
	                    if (existingFundamental.length > 0) {
	                        newConfig.fundamentals = newConfig.fundamentals.filter(function(f) {
	                            return f !== fundamental;
	                        });
	                    } else {
	                        newConfig.fundamentals.push(fundamental);
	                    }
	                }
	                setConfig(newConfig);
	            }
	
	            function changeIndicators(removeIndicator, indicator, indicatorParameters, removeALL) {
	                var newConfig = {
	                    indicators: $.extend(true, [], config.indicators)
	                };
	                var existingIndicator = newConfig.indicators
	                    .filter(function(cf) {
	                        return cf.name === indicator;
	                    });
	
	                if (removeIndicator) {
	                    if (existingIndicator.length > 0) {
	                        if (removeALL) {
	                            newConfig.indicators = newConfig.indicators.filter(function(cf) {
	                                return cf.name !== indicator;
	                            });
	                        } else {
	                            if (typeof(indicatorParameters) === 'undefined' ||
	                                ($.isArray(indicatorParameters) && indicatorParameters.length === 0)) {
	                                newConfig.indicators = newConfig.indicators.filter(function(cf) {
	                                    return cf.name !== indicator;
	                                });
	                            } else {
	                                existingIndicator[0].parameters = existingIndicator[0].parameters
	                                    .filter(function(p) {
	                                        return p !== indicatorParameters;
	                                    });
	
	                                if (existingIndicator[0].parameters.length === 0) {
	                                    newConfig.indicators = newConfig.indicators.filter(function(cf) {
	                                        return cf.name !== indicator;
	                                    });
	                                }
	                            }
	                        }
	                    }
	
	                } else {
	                    indicatorParameters = indicatorParameters.filter(function(ip) {
	                        return ip;
	                    });
	                    if (existingIndicator.length > 0) {
	                        existingIndicator[0].parameters = indicatorParameters;
	                    } else {
	                        newConfig.indicators.push({
	                            name: indicator,
	                            parameters: indicatorParameters
	                        });
	                    }
	                }
	
	                setConfig(newConfig);
	            }
	
	            function changeIntervalFrequency(newInterval, newDateRange, newFrequency) {
	                var oldIntervalType = config.intervalType;
	                var oldFrequency = config.frequency;
	                if (!newInterval || oldIntervalType !== newInterval || oldFrequency !== newFrequency) {
	                    var newConfig = {};
	                    newConfig.dateRange = newDateRange;
	                    newConfig.frequency = isNaN(newFrequency) ? newFrequency : parseInt(newFrequency, 10);
	                    newConfig.intervalType = newInterval;
	                    setConfig(newConfig);
	                    eventManager.trigger(eventTypes.ChangeIntervalFrequency);
	                }
	            }
	
	            /**
	             * @param {Array} dataRange
	             * @param {string} frequency
	             * @description
	             *  when current data greater then end date
	             *  if frequency equal weekly
	             *  then change the start date to the first day of this week.
	             *  if frequency equal monthly
	             *  then change the start date to the first day for this month.
	             *
	             *  Monday is begin of a week
	             */
	            function _changeDateRangeByFrequency(frequency, dataRange, isDatePicker) {
	                var currDate = new Date(),
	                    _dataRange;
	                if (dataRange && dataRange.length > 0) {
	                    _dataRange = [].slice.apply(dataRange);
	                    var startMonth = _dataRange[0].getMonth(),
	                        startYear = _dataRange[0].getFullYear(),
	                        startDay = _dataRange[0].getDay(),
	                        startDate = _dataRange[0].getDate(),
	                        endMonth = _dataRange[1].getMonth(),
	                        endYear = _dataRange[1].getFullYear(),
	                        endDay = _dataRange[1].getDay(),
	                        endDate = _dataRange[1].getDate();
	                    switch (frequency) {
	                        case FrequencyTypes.Weekly:
	                            var firstWeekDay = startDate - (startDay || 7) + 1; // first week day
	                            _dataRange[0] = _calcuateWeekDate(startYear, startMonth, firstWeekDay, startDay);
	
	                            var lastweekDay = endDate + 5 - _dataRange[1].getDay(); // this week last day
	                            _dataRange[1] = _calcuateWeekDate(endYear, endMonth, lastweekDay, endDay);
	                            break;
	                        case FrequencyTypes.Monthly:
	                            _dataRange[0] = _calcuateMonthDate(startYear, startMonth, startDate, isDatePicker);
	                            var lastDate = _lastWorkDayOfMonth(endYear, endMonth)
	                            lastDate = isDatePicker ? Math.min(endDate, lastDate) : Math.max(endDate, lastDate)
	                            _dataRange[1] = new Date(endYear, endMonth, lastDate);
	                            break;
	                        default:
	                            break;
	                    }
	                }
	                return _dataRange;
	            }
	
	            /**
	             * @description calcuate week date
	             */
	            function _calcuateWeekDate(y, m, d, day) {
	                var _lastWorkDay = _lastWorkDayOfMonth(y, m),
	                    dateArry = [y, m];
	                if (day === 5) {
	                    d = 5 + d - 1;
	                } else {
	                    if (d < 0) {
	                        d += _lastWorkDay;
	                        dateArry = acrossMonthOrYears(y, m)['less']();
	                    } else if (_lastWorkDay < d) {
	                        d = d % _lastWorkDay;
	                        dateArry = acrossMonthOrYears(y, m)['more']();
	
	                    }
	                }
	                return new Date(dateArry[0], dateArry[1], d);
	            }
	
	            /**
	             * @description calcuate month date
	             */
	            function _calcuateMonthDate(y, m, d, isDatePicker) {
	                var dateArry = [y, m],
	                    _lastWorkDay = _lastWorkDayOfMonth(y, m);
	                if (d !== _lastWorkDay) {
	                    dateArry = acrossMonthOrYears(y, m)['less'](); // out of the last workday every month
	                    isDatePicker && (dateArry[1] += 1);
	                }
	                return new Date(dateArry[0], dateArry[1], 1);
	            }
	
	            /**
	             * @description across the years
	             */
	            function acrossMonthOrYears(y, m) {
	                return {
	                    more: function() {
	                        if (m === 11) {
	                            ++y;
	                            m = 0;
	                        } else {
	                            ++m;
	                        }
	                        return [y, m];
	                    },
	                    less: function() {
	                        if (m === 0) {
	                            --y;
	                            m = 11;
	                        } else {
	                            --m;
	                        }
	                        return [y, m];
	                    }
	                }
	            }
	
	            /**
	             * find workend from last day of one month
	             */
	            function _lastWorkDayOfMonth(y, m, date) {
	                date = date || new Date(y, m + 1, 0).getDate();
	                var day = new Date(y, m, date).getDay();
	                if (/[1-5]/.test(day)) {
	                    return date;
	                } else {
	                    return _lastWorkDayOfMonth(y, m, --date);
	                }
	            }
	
	
	            function _changeStartDate(startDate) {
	                var oriStartType = config.startDate;
	                if (oriStartType === startDate) {
	                    return;
	                }
	                setConfig({
	                    startDate: startDate
	                });
	                eventManager.trigger(eventTypes.DrawNewData);
	            }
	
	            function setRequestByInterval(intervalType, req, frequency) {
	                var dataRange;
	                switch (intervalType) {
	                    case IntervalTypes.OneDay:
	                    case IntervalTypes.FiveDay:
	                    case IntervalTypes.FifteenDay:
	                        fetchDateRangeByfrequency(req, frequency, intervalType);
	                        break;
	                    default:
	                        dataRange = getDateRangeByInterval(intervalType);
	                        req.dateRange(dataRange);
	                        break;
	                }
	                return dataRange;
	            }
	
	            function fetchDateRangeByfrequency(req, frequency, intervalType) {
	                var intervalMap = {
	                    OneDay: 1,
	                    FiveDay: 5,
	                    FifteenDay: 15
	                };
	                switch (frequency) {
	                    case FrequencyTypes.Daily:
	                        req.dateRange(getDateRangeByInterval(intervalType));
	                        break;
	                    default:
	                        req.days(intervalMap[intervalType]);
	                        break;
	                }
	            }
	
	            function setConfig(newConfig, triggerEvent) {
	                //if (JSON.stringify(newConfig) === JSON.stringify(config)) return;
	                // if newConfig.intervalType is undefined, we want set config to it. $.extend can't right work.
	                var oldSaveConfig = getSaveConfig(),
	                    newSaveConfig;
	                triggerEvent = triggerEvent === false ? false : true;
	
	                for (var key in newConfig) {
	                    config[key] = newConfig[key];
	                }
	                newSaveConfig = getSaveConfig();
	                if (triggerEvent) {
	                    eventManager.trigger(eventTypes.UpdateConfig);
	                }
	                if (!newConfig.migrateFromSdk && newConfig.migrateFromSdk !== config.migrateFromSdk && JSON.stringify(oldSaveConfig) !== JSON.stringify(newSaveConfig) && config.isFullyRendered) {
	                    if ($.isFunction(config.onConfigChange)) {
	                        config.onConfigChange({
	                            saveConfig: newSaveConfig,
	                            newConfig: newConfig,
	                        });
	                    }
	                    if (config.profileId || config.actionHandler) {
	                        if (config.resetSavedConfig && config.resetAction) {
	                            _saveProfile({
	                                migrateFromSdk: true
	                            }, config);
	                        } else {
	                            _saveProfile(newSaveConfig, config);
	                        }
	                    }
	                }
	            }
	
	            var _saveProfile = util.debounce(function(newSaveConfig, config) {
	                //save to markets database
	                if (config.profileId) {
	                    core.DataManager._saveStateProfile({
	                        profileId: config.profileId,
	                        profileType: config.profileType,
	                        savedConfig: newSaveConfig
	                    }, function(params) {
	                        config.profileId = params.profileId;
	                    });
	                }
	                //for DWM save settings
	                if (config.actionHandler) {
	                    var settingArr = "";
	                    try {
	                        var settingStr = JSON.stringify(newSaveConfig);
	                        settingArr = util.splitStringToArray(settingStr, 250);
	                    } catch (e) {
	                        settingArr = [];
	                    }
	                    config.actionHandler.send("storeSettings", {
	                        storeSettings: settingArr
	                    });
	                }
	            }, 1000);
	
	            function getChartConfig(chartName) {
	                var chartConfig = config.charts[chartName];
	                chartConfig.width = config.width - config.paddingLeftRight;
	                chartConfig.mainTicker = config.mainTicker;
	                if (chartName !== ChartTypes.SliderChart) {
	                    chartConfig.preloadDelay = config.preloadDelay;
	                    chartConfig.indicators = config.indicators;
	                    chartConfig.preloadData = config.preloadData;
	                    chartConfig.dateRange = config.dateRange;
	                    chartConfig.intervalType = config.intervalType;
	                }
	                chartConfig.verticalScaleType = config.verticalScaleType;
	                chartConfig.domainScaleup = config.domainScaleup;
	                chartConfig.lang = config.lang;
	                chartConfig.brushImages = config.brushImages;
	                return chartConfig;
	            }
	
	            function getConfig() {
	                return config;
	            }
	
	            function getSaveConfig() {
	                //The date range's priority is higher than interval type when user open a saved config.
	                if (config.dateRange && config.dateRange.length === 2) {
	                    config.intervalType = null;
	                }
	                var index = $.inArray(dataAdapter.Events.Dividend, config.events);
	                if (index < 0 && config.charts.mainChart.showDividend === true) {
	                    config.events.push(dataAdapter.Events.Dividend);
	                }
	                var saveConfig = {
	                    mainTicker: config.mainTicker,
	                    compareTickers: config.compareTickers,
	                    events: config.events,
	                    indicators: config.indicators,
	                    fundamentals: config.fundamentals,
	                    charts: {
	                        mainChart: {
	                            chartType: config.charts.mainChart.chartType,
	                            dataType: config.charts.mainChart.dataType,
	                            showDividend: config.charts.mainChart.showDividend,
	                            selectionMode: config.charts.mainChart.selectionMode
	                        },
	                        volumeChart: {
	                            show: config.charts.volumeChart.show,
	                            chartType: config.charts.volumeChart.chartType
	                        }
	                    },
	                    chartCursor: config.cursorType,
	                    yAxisOrient: config.yAxisOrient,
	                    verticalScaleType: config.verticalScaleType,
	                    startDate: config.startDate,
	                    showPreAfter: config.showPreAfter,
	                    migrateFromSdk: config.migrateFromSdk,
	                    frequency: (config.frequency + '')
	                };
	                saveConfig.intervalType = config.intervalType;
	                if (config.dateRange && config.dateRange.length === 2) {
	                    saveConfig.dateRange = config.dateRange;
	                }
	                return saveConfig;
	            }
	
	            function getMainChartType() {
	                return config.charts.mainChart.chartType;
	            }
	
	            function setMainChartType(chartType) {
	                var newConfig = $.extend(true, {}, {
	                    charts: config.charts
	                });
	                newConfig.charts.mainChart.chartType = chartType;
	                setConfig(newConfig);
	            }
	
	            function getMainDataType() {
	                return config.charts.mainChart.dataType;
	            }
	
	            function setMainDataType(dataType) {
	                var newConfig = $.extend(true, {}, {
	                    charts: config.charts
	                });
	                newConfig.charts.mainChart.dataType = dataType;
	                setConfig(newConfig);
	            }
	
	            function setVolumeChartType(chartType) {
	                var newConfig = {};
	                newConfig.charts = $.extend(true, newConfig.charts, config.charts);
	                if (chartType) {
	                    newConfig.chartType = chartType;
	                    newConfig.charts.volumeChart.chartType = chartType;
	                }
	                setConfig(newConfig);
	            }
	
	            function isMainChartType(chartType) {
	                var result = false;
	                for (var key in MainChartTypes) {
	                    if (MainChartTypes[key] === chartType) {
	                        result = true;
	                        break;
	                    }
	                }
	                return result;
	            }
	
	            function isVolumeChartType(chartType) {
	                var result = false;
	                for (var key in VolumeChartTypes) {
	                    if (VolumeChartTypes[key] === chartType) {
	                        result = true;
	                        break;
	                    }
	                }
	                return result;
	            }
	
	            function changeChartType(newChartType, newDataType) {
	                if (isMainChartType(newChartType)) {
	                    var dataType;
	                    switch (newChartType) {
	                        case MainChartTypes.DividendEffectChart:
	                            newChartType = MainChartTypes.MountainChart;
	                            dataType = MainDataTypes.DividendEffect;
	                            break;
	                        case MainChartTypes.pGrowthChart:
	                            newChartType = MainChartTypes.MountainChart;
	                            dataType = MainDataTypes.Growth;
	                            break;
	                        case MainChartTypes.TenKGrowthChart:
	                            newChartType = MainChartTypes.MountainChart;
	                            dataType = MainDataTypes.Growth10K;
	                            break;
	                        case MainChartTypes.PostTaxChart:
	                            newChartType = MainChartTypes.MountainChart;
	                            dataType = MainDataTypes.PostTax;
	                            break;
	                        case MainChartTypes.PriceWithDividendGrowth:
	                            newChartType = MainChartTypes.MountainChart;
	                            dataType = MainDataTypes.PriceWithDividendGrowth;
	                            break;
	                        default:
	                            if (newDataType) {
	                                dataType = newDataType;
	                            } else {
	                                dataType = MainDataTypes.Price;
	                            }
	                            break;
	                    }
	                    adapteMainChartType(newChartType, dataType);
	                } else if (isVolumeChartType(newChartType)) {
	                    setVolumeChartType(newChartType);
	                }
	            }
	
	            function destroyChart(clearTickers) { //true or false
	                eventManager.trigger(eventTypes.DestroyChart, clearTickers);
	            }
	
	            function getLabels(name, locale) {
	                var labels = toolConfig.defaultConfig['svgchart'].labels.values || {};
	                var langCode = locale.split('-')[0];
	                labelsValues = labels[locale] || labels[langCode] || labels['en'];
	                if (config.labels) {
	                    labelsValues = $.extend(true, labelsValues, config.labels[locale] || config.labels[langCode]);
	                }
	                return labelsValues;
	
	            }
	
	            function getLabel(name) {
	                return labelsValues[name] || '';
	            }
	
	            function changeInterval(interval) {
	                eventManager.trigger(eventTypes.ChangeInterval, interval);
	            }
	
	            function setBenchmarktype(performanceTickers, performanceIds) {
	                for (var i = 0, l = performanceTickers.length, tickerObj; i < l; i++) {
	                    tickerObj = performanceTickers[i];
	                    if (tickerObj.symbol == performanceIds.cid) {
	                        tickerObj.setField("benchmarkType", BenchmarkType.FundCategory);
	                    } else if (tickerObj.symbol == performanceIds.rrid) {
	                        tickerObj.setField("benchmarkType", BenchmarkType.RelativeRiskBenchmark);
	                    } else if (tickerObj.symbol == performanceIds.mIndex) {
	                        tickerObj.setField("benchmarkType", BenchmarkType.MstarIndex);
	                    } else if (tickerObj.symbol == performanceIds.pbid) {
	                        tickerObj.setField("benchmarkType", BenchmarkType.ProspectusBenchmark);
	                    }
	                }
	            }
	
	            function registerPerformanceTickers(performanceTickers, performanceIds) {
	                setBenchmarktype(performanceTickers, performanceIds)
	                if (performanceTickers.length > 0) {
	                    var unregisterTickerObjects = [];
	                    var registerTickers = [];
	                    for (var i = 1, l = tickerCollection.length, _tickerObj; i < l; i++) {
	                        _tickerObj = tickerCollection[i];
	                        var _benchmarkType = _tickerObj.getField("benchmarkType");
	                        if (_benchmarkType) {
	                            unregisterTickerObjects.push(_tickerObj);
	                        }
	                    }
	                    for (var idx = 0; idx < performanceTickers.length; idx++) {
	                        var isExisted = registerTickers.some(function(ticker) {
	                            return ticker.secId && ticker.secId === performanceTickers[idx].secId || ticker.performanceId && ticker.performanceId === performanceTickers[idx].performanceId;
	                        });
	                        if (!isExisted) {
	                            registerTickers.push(performanceTickers[idx]);
	                        }
	                    }
	                    if (unregisterTickerObjects.length > 0) {
	                        dataAdapter.unregisterChartTickers(unregisterTickerObjects);
	                    }
	                    if (registerTickers.length > 0) {
	                        dataAdapter.registerChartTickers(registerTickers);
	                        var ticker0 = tickerCollection.shift();
	                        tickerCollection = [ticker0].concat(registerTickers.concat(tickerCollection));
	                    }
	                }
	            }
	
	            function initRelatedBenchmarks() {
	                var deferred = $.Deferred();
	                var tickers = [];
	                var cid, rrid, pbid, mIndex;
	
	                if (config.useEUTimeSeriesData) {
	                    if (config.useEUSecurityData) {
	                        cid = mainTickerObject.getField("categoryId");
	                    } else {
	                        // iwt api cannot get data for category id like $FOCA$GY$$, so still use the data api v2 to get category data
	                        cid = getIdWithCategoryId(mainTickerObject.getField("categoryId"));
	                    }
	                    pbid = mainTickerObject.getField("prospectusBenchmarkId");
	                    mIndex = mainTickerObject.getField("mstarIndexId");
	                    rrid = mainTickerObject.getField(config.useEUSecurityData ? "benchMarkId" : "relativeRiskBenchmarkId");
	                } else {
	                    cid = getIdWithCategoryId(mainTickerObject.getField("categoryId"));
	                    rrid = getIdWithRiskBenchmarkId(mainTickerObject.getField("relativeRiskBenchmarkId"));
	                    pbid = getIdForBenchmarks(BenchmarkType.ProspectusBenchmark);
	                    mIndex = getIdForBenchmarks(BenchmarkType.MstarIndex);
	                }
	                var tickerObjects = [];
	                if (config.showCategory && cid) {
	                    if (config.useEUTimeSeriesData && config.useEUSecurityData && dataAdapter.getSecurityObjects(cid)) {
	                        tickerObjects.push(dataAdapter.getSecurityObjects(cid));
	                    } else {
	                        tickers.push(cid);
	                    }
	                }
	                if (config.showRiskBenchmark && rrid) {
	                    if (config.useEUTimeSeriesData && config.useEUSecurityData && dataAdapter.getSecurityObjects(rrid)) {
	                        tickerObjects.push(dataAdapter.getSecurityObjects(rrid));
	                    } else if (config.useEUTimeSeriesData) {
	                        rrid = _buildTickers({
	                            id: rrid,
	                            securityToken: rrid + ']'
	                        });
	                        tickers.push(rrid);
	                    } else {
	                        tickers.push(rrid);
	                    }
	                }
	                if (config.showProspectusBenchmark && pbid) {
	                    if (config.useEUTimeSeriesData) {
	                        pbid = _buildTickers({
	                            id: pbid,
	                            securityToken: pbid + ']'
	                        });
	                    }
	                    tickers.push(pbid);
	                }
	                if (config.showMorningstarIndex && mIndex) {
	                    if (config.useEUTimeSeriesData) {
	                        mIndex = _buildTickers({
	                            id: mIndex,
	                            securityToken: mIndex + ']'
	                        });
	                    }
	                    tickers.push(mIndex);
	                }
	                var performanceIds = {
	                    cid: cid,
	                    rrid: rrid,
	                    pbid: pbid,
	                    mIndex: mIndex
	                }
	                if (tickers.length > 0) {
	                    createTickerObjects(tickers, performanceIds).done(function(performanceTickers) {
	                        registerPerformanceTickers(performanceTickers, performanceIds);
	                        deferred.resolve();
	                    });
	
	                } else if (tickerObjects.length > 0) {
	                    registerPerformanceTickers(tickerObjects, performanceIds);
	                    deferred.resolve();
	                } else {
	                    deferred.resolve();
	                }
	                return deferred;
	            }
	
	            function getIdForBenchmarks(type) {
	                var id, name;
	                if (type === BenchmarkType.MstarIndex) {
	                    id = mainTickerObject.getField('mstarIndexId');
	                    name = mainTickerObject.getField('mstarIndexName');
	                } else if (type === BenchmarkType.ProspectusBenchmark) {
	                    id = mainTickerObject.getField('prospectusBenchmarkId');
	                    name = mainTickerObject.getField('prospectusBenchmarkName');
	                }
	
	                if (id) {
	                    return id + ';benchmark_' + type + ';' + name;
	                }
	                return null;
	            }
	
	            function getIdWithCategoryId(cid) {
	                var mType = mainTickerObject.getField("mType");
	                var secId = getSecId(mainTickerObject);
	                if (secId && cid && (mType == "FE" || mType == "FC" || mType == "FO")) {
	                    return [secId, cid, mType, ''].join("|");
	                } else {
	                    return null;
	                }
	            }
	
	            function getIdWithRiskBenchmarkId(rrmid) {
	                var mType = mainTickerObject.getField("mType");
	                var secId = getSecId(mainTickerObject);
	                if (secId && rrmid && (mType == "FE" || mType == "FC" || mType == "FO")) {
	                    return [secId, '', '', rrmid].join("|");
	                } else {
	                    return null;
	                }
	            }
	
	            function getSecId(tickerObj) {
	                return util.isFund(tickerObj) ? tickerObj.getField("secId") : tickerObj.getField("performanceId");
	            }
	
	            function adapteMainChartType(chartType, dataType) {
	                var _validChartTypes = [];
	                if (dataType) {
	                    switch (dataType) {
	                        case MainDataTypes.Price:
	                            _validChartTypes = [MainChartTypes.LineChart, MainChartTypes.MountainChart, MainChartTypes.DotChart, MainChartTypes.ABChart, MainChartTypes.OHLCChart, MainChartTypes.HLCChart, MainChartTypes.CandlestickChart];
	                            break;
	                        default:
	                            _validChartTypes = [MainChartTypes.LineChart, MainChartTypes.MountainChart, MainChartTypes.DotChart, MainChartTypes.ABChart];
	                            break;
	                    }
	                }
	
	                if (chartType && _validChartTypes.length > 0) {
	                    if ($.inArray(chartType, _validChartTypes) === -1) {
	                        chartType = MainChartTypes.MountainChart;
	                    }
	                }
	
	                if (chartType) {
	                    setMainChartType(chartType);
	                }
	                if (dataType) {
	                    setMainDataType(dataType);
	                }
	
	            }
	
	            function getInitConfig() {
	                return initedConfig;
	            }
	
	            function setDefaultInterval(intervalType) {
	                if (config.dateRange && config.dateRange.length === 2) {
	                    config.intervalType = null;
	                } else {
	                    config.intervalType = config.intervalType || intervalType;
	                }
	            }
	
	            function changeGrowthBaseValue(value) {
	                if (typeof value != "number") {
	                    console.info("GrowthBaseValue should be a number")
	                    if (isNaN(Number(value))) {
	                        return;
	                    } else {
	                        value = Number(value);
	                    }
	                }
	                if (config.growthBaseValue != value && value > 0) {
	                    _changGrowthBaseValue(value);
	                }
	            }
	
	            function _changGrowthBaseValue(value) {
	                var newConfig = {};
	                newConfig.growthBaseValue = value;
	                newConfig.rootGrowthBaseValue = value;
	                setConfig(newConfig);
	                setMainDataType(MainDataTypes.Growth10K);
	                var chartType = getMainChartType();
	                eventManager.trigger(eventTypes.ChangeChartType, chartType, MainDataTypes.Growth10K);
	            }
	
	            function _isCompareOrPercentChart() {
	                var mainDataType = getMainDataType();
	                return (config.compareTickers.length > 0 ||
	                    mainDataType === MainDataTypes.Growth10K ||
	                    mainDataType === MainDataTypes.Growth ||
	                    mainDataType === MainDataTypes.DividendEffect ||
	                    config.growthBaseValue ||
	                    tickerCollection.length > 1) && !config.drawNavAndPriceChart;
	            }
	
	            function _isPercentChart() {
	                var mainDataType = getMainDataType();
	                var priceType = getPriceType(tickerCollection);
	                var isPercent = (config.compareTickers.length > 0 || tickerCollection.length > 1) && mainDataType !== MainDataTypes.Growth10K && mainDataType !== MainDataTypes.PriceWithDividendGrowth && priceType !== dataAdapter.PriceType.Growth10K && !config.drawNavAndPriceChart;
	                return isPercent || mainDataType === MainDataTypes.Growth ||
	                    mainDataType === MainDataTypes.DividendEffect;
	            }
	
	            function getTickerCollection() {
	                return tickerCollection;
	            }
	
	            function getLastTradeDate() {
	                if (!tickerCollection || !tickerCollection.length) {
	                    return new Date();
	                }
	                var lastTradeDate = tickerCollection[0].tradeDate;
	                // Determin always use mainTicker's lastTradeDate regrdess of the startDate type
	                // if (config.startDate !== toolConfig.StartDateTypes.MainTicker) {
	                //     for (var i = 0; i < tickerCollection.length; i++) {
	                //         var tradeDate = tickerCollection[i].tradeDate;
	                //         if (!lastTradeDate) {
	                //             lastTradeDate = tradeDate;
	                //             break;
	                //         }
	                //         if (config.startDate === toolConfig.StartDateTypes.Common) {
	                //             if (tradeDate && (new Date(tradeDate).getTime() < new Date(lastTradeDate).getTime())) {
	                //                 lastTradeDate = tradeDate;
	                //             }
	                //         } else if (config.startDate === toolConfig.StartDateTypes.Earliest) {
	                //             if (tradeDate && (new Date(tradeDate).getTime() > new Date(lastTradeDate).getTime())) {
	                //                 lastTradeDate = tradeDate;
	                //             }
	                //         }
	                //     }
	                // }
	                lastTradeDate = lastTradeDate ? new Date(lastTradeDate) : new Date();
	                return lastTradeDate;
	            }
	
	            // bind all callbacks to eventManager
	            function registerCallback(callbackList) {
	                for (var i in callbackList) {
	                    eventTypes[i] && eventManager.bind(eventTypes[i], callbackList[i]);
	                }
	            }
	
	            function setTickerCollection(tickers) {
	                tickerCollection = tickers;
	            }
	
	            function triggerClickCallback(data) {
	                if (typeof config.onClick === 'function') {
	                    config.onClick(data);
	                }
	            }
	            return {
	                updateCompareTickers: updateCompareTickers,
	                addCompareTickers: addCompareTickers,
	                ChartTypes: ChartTypes,
	                PopoverTypes: PopoverTypes,
	                Constants: Constants,
	                initConfig: initConfig,
	                createConfig: createConfig,
	                ChartGenre: ChartGenre,
	                fetchMainTickerData: fetchMainTickerData,
	                fetchDisplayData: fetchDisplayData,
	                fetchSliderChartData: fetchSliderChartData,
	                frequencyConfig: frequencyConfig,
	                intervalTypeSortedArray: intervalTypeSortedArray,
	                FrequencyTypes: FrequencyTypes,
	                CursorType: CursorType,
	                changeMainTicker: changeMainTicker,
	                getChartConfig: getChartConfig,
	                getConfig: getConfig,
	                getDefaultFrequencyByIntervalType: getDefaultFrequencyByIntervalType,
	                getFrequencyByDateRange: getFrequencyByDateRange,
	                getSliderChartfrequency: getSliderChartfrequency,
	                getSaveConfig: getSaveConfig,
	                getMainChartType: getMainChartType,
	                getMainDataType: getMainDataType,
	                getPriceType: getPriceType,
	                IntervalTypes: IntervalTypes,
	                IndicatorChartTypes: IndicatorChartTypes,
	                ExternalTypesMapping: ExternalTypesMapping,
	                MainChartTypes: MainChartTypes,
	                MainDataTypes: MainDataTypes,
	                preloadMainTickerData: preloadMainTickerData,
	                removeCompareTickers: removeCompareTickers,
	                setConfig: setConfig,
	                SelectionModes: SelectionModes,
	                StartDateTypes: toolConfig.StartDateTypes,
	                getTickerCollection: getTickerCollection,
	                setTickerCollection: setTickerCollection,
	                TimezoneMap: TimezoneMap,
	                VolumeChartTypes: VolumeChartTypes,
	                VerticalScaleTypes: VerticalScaleTypes,
	                isIntraday: isIntraday,
	                isMutualFund: isMutualFund,
	                destroyChart: destroyChart,
	                getInitConfig: getInitConfig,
	                getLabels: getLabels,
	                getLabel: getLabel,
	                changeInterval: changeInterval,
	                indicatorInputTypes: toolConfig.indicatorInputTypes,
	                isIndicatorsFundamentals: isIndicatorsFundamentals,
	                changeGrowthBaseValue: changeGrowthBaseValue,
	                isCompareOrPercentChart: _isCompareOrPercentChart,
	                isPercentChart: _isPercentChart,
	                isITFund: isITFund,
	                isSemiEarningsExch: isSemiEarningsExch,
	                getD3Locale: getD3Locale,
	                triggerClickCallback: triggerClickCallback,
	                intervalTypesMapping: IntervalTypesMapping,
	                frequencySetupConfig: toolConfig.frequencySetupConfig,
	                processChartDataUpdate: processChartDataUpdate,
	                BenchmarkType: BenchmarkType,
	                isCategory: isCategory,
	                CurrencyMapping: CurrencyMapping
	            };
	        }
	
	        return configManager;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(56), __webpack_require__(9), __webpack_require__(57), __webpack_require__(58)], __WEBPACK_AMD_DEFINE_RESULT__ = function(layoutTemplate, GraphTypes, StaticConfig, LanguageConfig) {
	        'use strict';
	
	        var defaultConfig = {
	            'svgchart': {
	                'type': 'svgchart',
	                'settings': {
	                    showPadding: true,
	                    autoComplete: {
	                        dataSource: 'US',
	                        universeIds: '',
	                        sortOrder: 'Name+Asc',
	                        maxCount: 100, // only works when dataSource is EU
	                        categoryMaxCount: 8, //control autocomplete max count for each category
	                        noGroupMaxCount: 18, //control autocomplete max count when no group, only works when data source is US
	                        cnpjTicker: true
	                        //group:true,
	                        //highlight: false,
	                        //action: 'compare',//main
	                        //changeTicker: true,
	                        //nonFilterCategory: [],
	                        //tickerPriority: 'ticker',
	                        //removeExch: false
	                    },
	                    profileId: '',
	                    profileType: 'ch_v3',
	                    resetSavedConfig: false, //for QA test control reset chart. 
	                    migrateFromSdk: true,
	                    saveDrawings: false,
	                    keepSavedMainTicker: true,
	                    keepMainTickerOnReset: true, // keep last mainTicker when click reset
	                    saveSettingsOnMainTickerChange: false, //keep current config when change mainticker 
	                    translateName: false, // support translate name.
	                    StaticFilesPath: '//quotespeed.morningstar.com/components/static/',
	                    AlignToCompare: false,
	                    hideMenu: false,
	                    isAutoRefresh: true, //control chart whether auto refresh. true: auto refresh, false: can't auto refresh need manual refresh
	                    legendInfoLabel: 'clientTicker',
	                    theme: '1',
	                    skin: 'default',
	                    columnDelimiter: ",",
	                    showCategory: false,
	                    showRiskBenchmark: false,
	                    showProspectusBenchmark: false,
	                    showMorningstarIndex: false,
	                    yAxisMargin: 2,
	                    yAxisWidth: 42,
	                    dailyDateFormatter: "MM/DD/YYYY",
	                    intradayDateFormater: "MM/DD/YYYY hh:mm A",
	                    momentDateTime: "MMM DD YYYY hh:mm A",
	                    momentDate: "MMM DD YYYY",
	                    enterTipsLabelID: "",
	                    crosshairJustify: false,
	                    mainTickerObject: {},
	                    showCurrencyOptions: false,   //show currency drop down list
	                    baseCurrency: null,
	                    currencyWithMainTicker: false,
	                    crosshairs: {}, //format crosshairs label value
	                    crossCurrency: null, // can be "symbol" => $ or "code" => USD.
	                    legendChange: true,
	                    showLegendNetChange: true,
	                    showLegendPercentChange: true,
	                    compareClose: true,
	                    legendDot: false,
	                    defaultDecimal: 2,
	                    decimalPlaces: null, //for crosshair, change price value, default: config.defaultDecimal
	                    yAxisDecimal: null, //for y-axis ticks, default: config.defaultDecimal
	                    isFormat: true,
	                    chgPDecimal: 2, // for change percent value 
	                    volumeDecimal: 2, //for crosshair volume value, eg:1.21 mil
	                    chartGenre: StaticConfig.ChartGenre.StockChart,
	                    onLoad: function(loadInfo) {
	                        /*console.log(loadInfo);*/
	                    },
	                    onHeightChange: function(heightInfo) {
	                        /*console.log(heightInfo);*/
	                    },
	                    template: layoutTemplate,
	                    container: document.body,
	                    mainChartClass: "chart-mainchart",
	                    volumeChartClass: "chart-volumechart",
	                    sliderChartClass: "chart-sliderchart",
	                    paddingTopBottom: 0,
	                    paddingLeftRight: 0,
	                    exchangeMainTickerByLegend: true,
	                    useEUTimeSeriesData: false,
	                    showTag: true,
	                    useDataApiTimeseriesData: false,
	                    EUTimeSeriesApiSetting: {
	                        timeseries_price: {
	                            forwardFill: true
	                        },
	                        timeseries_cumulativereturn: {
	                            restructureDateOptions: 'ignore'
	                        },
	                        timeseries_dividend: {}
	                    },
	                    useEUSecurityData: false,
	                    //margin: { left: 20, top: 20, right: 20, bottom: 40 },
	                    //width: 800,
	                    //height:900,
	                    fixHeight: true,
	                    crossPerformanceVal: StaticConfig.MainDataTypes.Growth, // growth or 10K growth; for performace growth chart in theme4, config the data type show in crosshair's performance value.
	                    crossValue: StaticConfig.MainDataTypes.Growth10K,
	                    showPreAfter: false,
	                    applyAspectRatio: true,
	                    minWidth: 240, //mainchart min width is 200, margin-left 20, margin-right 20
	                    maxWidth: Number.MAX_VALUE,
	                    intervalType: null,
	                    frequency: null,
	                    defaultFrequency: null,
	                    frequencyPriority: 'default', // optional value: default
	                    dateRange: [],
	                    indicators: [ /*{ name: "SMA", parameters: [10, 50] }*/ ],
	                    fundamentals: [],
	                    events: [],
	                    /*"dividend" "splits" "earnings"*/
	                    //chartType: StaticConfig.MainChartTypes.MountainChart,
	                    showTSDividend: false,
	                    autocompleteCategories: StaticConfig.AutocompleteCategories.stock, //only internal use
	                    //isAutocompleteGroup: true,
	                    funds: null,
	                    maxRangeStartDate: new Date(1900, 0, 1),
	                    domainScaleup: 0.05,
	                    lang: StaticConfig.LanguageTypes.EN_US,
	                    exchangeTimezone: {}, //Need get from session server
	                    showPricePlusSign: true,
	                    timezone: "",
	                    mainTickerColor: null,
	                    growth10KDecimal: null,
	                    verticalScaleType: StaticConfig.VerticalScaleTypes.Linear,
	                    semiEarningsExch: ["146", "147"],
	                    hightLightHoveredLine: true,
	                    highlightDist: 5,
	                    showCrosshairVolume: true,
	                    showCrosshairChange: false,
	                    showCrosshairChangePercent: false,
	                    showCrosshairOriginalData: false,
	                    isFullyRendered: false,
	                    triggeredFullyRendered: false,
	                    customBreakPoint: null, //[600,800]
	                    showStartDate: false,
	                    showPriceWithDividendGrowth: false,
	                    startDate: StaticConfig.StartDateTypes.MainTicker, //optional value:commom, earliest,main
	                    showMTickerRemoveBtn: false, // show main ticker remove button
	                    datePicker: {
	                        reposition: true,
	                        highlightBetween: false,
	                        highlightMutiSelected: false,
	                        showDisable: false
	                    },
	                    intervalBreakPointMap: {
	                        'default': ['1D', '5D', '15D', '1M', '3M', '6M', 'YTD', '1Y', '3Y', '5Y', '10Y', 'MAX'],
	                        '600': ['1D', '1M', '1Y', '5Y', 'MAX']
	                    },
	                    intervalFrequencyMap: {
	                        OneDay: "1",
	                        FiveDay: "5",
	                        FifteenDay: "5",
	                        OneMonth: "d",
	                        ThreeMonth: "d",
	                        SixMonth: "d",
	                        YTD: "d",
	                        OneYear: "d",
	                        ThreeYear: "w",
	                        FiveYear: "m",
	                        TenYear: "m",
	                        FifteenYear: "m",
	                        Max: "m",
	                        Custom: "5"
	                    },
	                    SliderChartIntervalTypeMap: {
	                        OneDay: "ThreeMonth",
	                        FiveDay: "ThreeMonth",
	                        FifteenDay: "ThreeMonth",
	                        OneMonth: "ThreeMonth",
	                        ThreeMonth: "SixMonth",
	                        SixMonth: "TenYear",
	                        YTD: "TenYear",
	                        OneYear: "TenYear",
	                        ThreeYear: "TenYear",
	                        FiveYear: "TenYear",
	                        TenYear: "FifteenYear",
	                        Max: "Max"
	                    },
	                    mainTicker: "126.1.IBM",
	                    compareTickers: [],
	                    preloadDelay: 500,
	                    preload: true, // control if need preload data for paning 
	                    cursorType: StaticConfig.CursorType.Crosshair,
	                    cursorValueClass: 'cursor-value',
	                    menubar: {},
	                    isHidePopoverAfterSelect: false,
	                    isShowRelateTickerAndMajorIndex: false,
	                    compareChartsMaxAllowed: 7,
	                    compareChartsMaxAllowedErrorLabel: 'compareChartsMaxAllowedErrorLabel',
	                    compareChartsMaxAllowedErrorMessageTimeout: 8000,
	                    compareColors: null,
	                    currencyAliases: {}, // {"USD":"$"},
	                    currencyType: "listCurrency", // currency type tradeCurrency(D204) , listCurrency(s9)
	                    tradeCurrency: [], // support exchange display currency(D204)
	                    listCurrency: [],
	                    charts: {
	                        mainChart: {
	                            panResponseSpan: 4,
	                            xAxisHeight: 18,
	                            margin: {
	                                top: 0,
	                                right: 1,
	                                bottom: 0,
	                                left: 1
	                            },
	                            width: 960,
	                            height: 432,
	                            minHeight: 147,
	                            dataFormat: "%Y%m%d",
	                            container: null,
	                            xAxis: {
	                                show: true,
	                                orient: "bottom",
	                                tickSize: 1
	                            },
	                            yAxis: {
	                                show: true,
	                                orient: "left",
	                                ticks: 5,
	                                maxTickCount: 6,
	                                position: "outer",
	                                withUnit: false,
	                                width: 42,
	                                tick: {
	                                    line: {
	                                        show: true,
	                                        style: {
	                                            'stroke': '#cccccc',
	                                            'stroke-width': '1px'
	                                        }
	                                    }
	                                }
	                            },
	                            showGridLines: true,
	                            showGridBlocks: false,
	                            showSolidGridLines: false,
	                            showIndicatorCloseButton: true,
	                            showFundamentalCloseButton: true,
	                            tagProperties: {
	                                arrowWidth: 5,
	                                arrowHeight: 7,
	                                sideMargin: 6,
	                                textTopMargin: 7,
	                                tagHeight: 18,
	                                yVerticalMargin: 3,
	                                tagFillColor: ''
	                            },
	                            eventProperties: {
	                                xRadious: 5,
	                                yRadious: 10,
	                                textColor: '#FFF',
	                                textAnchor: 'middle',
	                                dy: '0.3em',
	                                Split: {
	                                    color: '#5050CC',
	                                    text: 'splitText',
	                                    labels: 'eventsSplits'
	                                },
	                                Earnings: {
	                                    color: '#008E91',
	                                    downColor: '#AA008A',
	                                    text: 'earningText',
	                                    labels: 'eventsEarnings'
	                                },
	                                Dividend: {
	                                    color: '#FD5516',
	                                    text: 'dividendText',
	                                    labels: 'eventsDividende'
	                                }
	                            },
	                            fundamentalProperties: {
	                                FairValue: {
	                                    color: '#FD5516',
	                                    labels: 'fairValue',
	                                },
	                                QuantitativeFairValue: {
	                                    color: '#FD5516',
	                                    labels: 'fairValue',
	                                },
	                                DailyCumFairNav: {
	                                    color: '#FD5516',
	                                    labels: 'NAV'
	                                },
	                                FundSize: {
	                                    showLegend: false,
	                                    labels: 'fundSize',
	                                    skipDrawGraph: true,
	                                    decimalPlaces: 0,
	                                    showWithCompare: true
	                                },
	                                ShareholdersNumber: {
	                                    showLegend: false,
	                                    labels: 'shareholdersNumber',
	                                    skipDrawGraph: true,
	                                    decimalPlaces: 0,
	                                    showWithCompare: true
	                                }
	                            },
	                            indicatorProperties: {
	                                SMA: {
	                                    color: ['#008E91', '#AA008A', '#FD5516'],
	                                    legend: function(labels, parameters) {
	                                        var labelsArr = [];
	                                        parameters.forEach(function(parameter) {
	                                            labelsArr.push(labels[0] + '(' + parameter + ')')
	                                        });
	                                        return labelsArr;
	                                    }
	                                },
	                                EMA: {
	                                    color: ['#FD5516', '#5050CC', '#008E91'],
	                                    legend: function(labels, parameters) {
	                                        var labelsArr = [];
	                                        parameters.forEach(function(parameter) {
	                                            labelsArr.push(labels[0] + '(' + parameter + ')')
	                                        });
	                                        return labelsArr;
	                                    }
	                                },
	                                BBands: {
	                                    color: ['#5050CC', '#5050CC'],
	                                    chartTypes: ['lineChart', 'lineChart'],
	                                    removeAll: true,
	                                    //example BBands(20, 2)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ',' + parameters[1] + ')'
	                                        ];
	                                    }
	                                },
	                                PSAR: {
	                                    color: ['#AA008A'],
	                                    chartTypes: ['dotChart'],
	                                    removeAll: true,
	                                    //example PSAR(0.02, 0.2)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ',' + parameters[1] + ')'
	                                        ];
	                                    }
	                                },
	                                WMA: {
	                                    color: ['#FD5516', '#5050CC'],
	                                    removeAll: true,
	                                    //example WMA(15)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                },
	                                Keltner: {
	                                    color: ['#FD5516', '#5050CC', '#008E91'],
	                                    removeAll: true,
	                                    //example Keltner Index(20, 2, 10)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ',' + parameters[1] + ',' + parameters[2] + ')'
	                                        ];
	                                    }
	                                },
	                                VBP: {
	                                    color: ['#c9cbcb'],
	                                    chartTypes: GraphTypes.VBP
	                                },
	                                PrevClose: {
	                                    color: ['#FD5516'],
	                                    showLegend: true,
	                                    legend: function(labels, parameters) {
	                                        return labels[0];
	                                    }
	                                },
	                                PChannel: {
	                                    color: ['#AA008A', '#008E91'],
	                                    //example PChannel(14)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                },
	                                MAE: {
	                                    color: ['#FD5516', '#AA008A'],
	                                    removeAll: true,
	                                    //example PChannel(14)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ',' + parameters[1] + '%)'
	                                        ];
	                                    }
	                                }
	                            },
	                            dividendEffectProperties: {
	                                color: '#293FA0'
	                            },
	                            abChartAboveClipID: "mainChart-aboveClip",
	                            abChartBelowClipID: "mainChart-belowClip",
	                            ASColor: null,
	                            AFColor: null,
	                            BSColor: null,
	                            BFColor: null,
	                            dotChartRadius: 2,
	                            xAxisTickSize: 3,
	                            ohlcTickSize: 3,
	                            candlestickTickSize: 1,
	                            show: true,
	                            showDividend: false,
	                            chartClass: "chart-mainchart",
	                            yAxisDimensionForPercentage: "%",
	                            chartType: StaticConfig.MainChartTypes.MountainChart, //.CandlestickChart
	                            dataType: StaticConfig.MainDataTypes.Price,
	                            selectionMode: StaticConfig.SelectionModes.Pan
	                        },
	                        volumeChart: {
	                            margin: {
	                                top: 0,
	                                right: 1,
	                                bottom: 0,
	                                left: 1
	                            },
	                            width: 960,
	                            height: 100,
	                            dataFormat: "%Y%m%d",
	                            container: null,
	                            needInit: true,
	                            xAxis: {
	                                show: false,
	                                orient: "bottom"
	                            },
	                            yAxis: {
	                                show: true,
	                                orient: "left",
	                                ticks: 2,
	                                maxTickCount: 3,
	                                position: "outer",
	                                width: 42,
	                                decimalPlaces: 0,
	                                tick: {
	                                    line: {
	                                        show: true,
	                                        style: {
	                                            'stroke': '#cccccc',
	                                            'stroke-width': '1px'
	                                        }
	                                    }
	                                }
	                            },
	                            showGridLines: true,
	                            showGridBlocks: false,
	                            showSolidGridLines: false,
	                            showIndicatorCloseButton: true,
	                            showLegend: false,
	                            indicatorProperties: {
	                                SMAV: {
	                                    color: ['#AA008A'],
	                                    //example SMAV(50)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                }
	                            },
	                            volumeBarWidth: 5,
	                            show: true,
	                            chartClass: "chart-volumechart",
	                            chartLegendText: "volume",
	                            chartType: StaticConfig.VolumeChartTypes.VolumeChart, //VolumeChart   //VolumePlusChart
	                        },
	                        sliderChart: {
	                            margin: {
	                                top: 0,
	                                right: 5,
	                                bottom: 18,
	                                left: 5
	                            },
	                            width: 960,
	                            height: 65,
	                            dataFormat: "%Y%m%d",
	                            container: null,
	                            xAxis: {
	                                show: true,
	                                orient: "bottom",
	                                tickSize: 1
	                            },
	                            yAxis: {
	                                show: false,
	                                orient: "left",
	                                tickSize: 0,
	                                width: 42,
	                                position: "outer",
	                                tick: {
	                                    line: {
	                                        show: true,
	                                        style: {
	                                            'stroke': '#cccccc',
	                                            'stroke-width': '1px'
	                                        }
	                                    }
	                                }
	                            },
	                            showGridLines: false,
	                            showGridBlocks: false,
	                            showSolidGridLines: false,
	                            show: true,
	                            chartClass: "chart-sliderchart",
	                        },
	                        indicatorChart: {
	                            margin: {
	                                top: 0,
	                                right: 0,
	                                bottom: 0,
	                                left: 0
	                            },
	                            width: 960,
	                            height: 120,
	                            dataFormat: "%Y%m%d",
	                            container: null,
	                            xAxis: {
	                                show: false,
	                                orient: "bottom"
	                            },
	                            yAxis: {
	                                show: true,
	                                orient: "left",
	                                ticks: 3,
	                                maxTickCount: 4,
	                                width: 42,
	                                position: "outer",
	                                tick: {
	                                    line: {
	                                        show: true,
	                                        style: {
	                                            'stroke': '#cccccc',
	                                            'stroke-width': '1px'
	                                        }
	                                    }
	                                }
	                            },
	                            showGridLines: true,
	                            showGridBlocks: false,
	                            showSolidGridLines: false,
	                            showLegend: false,
	                            showIndicatorCloseButton: false,
	                            indicatorProperties: {
	                                DYield: {
	                                    color: ['#008E91'],
	                                },
	                                RDividend: {
	                                    color: ['#008E91'],
	                                },
	                                MACD: {
	                                    color: ['#008E91', '#AA008A', '#FD5516'],
	                                    chartTypes: ['lineChart', 'lineChart', 'histogram'],
	                                    //example MACD(26,12) EMA(9) Divergence
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ',' + parameters[1] + ')',
	                                            labels[1] + ' (' + parameters[2] + ') ',
	                                            labels[2]
	                                        ];
	                                    }
	                                },
	                                RSI: {
	                                    color: ['#AA008A'],
	                                    //example RSI(14)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    },
	                                    fixedTickValeus: [0, 30, 70, 100]
	                                },
	                                ROC: {
	                                    color: ['#008E91', '#AA008A'],
	                                    //example ROC(12)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                },
	                                CCI: {
	                                    color: ['#008E91'],
	                                    //example CCI(20)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    },
	                                    mthTickValeus: [-100, 0, 100] // must to have tick values
	                                },
	                                WillR: {
	                                    color: ['#FD5516'],
	                                    //example WillR(14)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    },
	                                    fixedTickValeus: [-100, -80, -20, 0]
	                                },
	                                SStochastic: {
	                                    color: ['#008E91', '#AA008A'],
	                                    //example SStochastic(14)SStochastic(3)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')',
	                                            labels[0] + '(' + parameters[1] + ')',
	                                        ];
	                                    }
	                                },
	                                FStochastic: {
	                                    color: ['#FD5516', '#008E91'],
	                                    //example FStochastic(14)FStochastic(3)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')',
	                                            labels[0] + '(' + parameters[1] + ')',
	                                        ];
	                                    }
	                                },
	                                Momentum: {
	                                    color: ['#AA008A', '#008E91'],
	                                    //example Momentum(2)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                },
	                                ULT: {
	                                    color: ['#008E91']
	                                },
	                                DMI: {
	                                    color: ['#AA008A', '#008E91', '#FD5516'],
	                                    //example DMI+ DMI- ADX(14)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0],
	                                            labels[1],
	                                            labels[2] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                },
	                                MFI: {
	                                    color: ['#008E91', '#008E91'],
	                                    //example MFI(14)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                },
	                                OBV: {
	                                    color: ['#FD5516', '#008E91']
	                                },
	                                VAcc: {
	                                    color: ['#FD5516', '#008E91']
	                                },
	                                UDRatio: {
	                                    color: ['#FD5516', '#AA008A'],
	                                    //example UDRatio(7,5)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ',' + parameters[1] + ')'
	                                        ];
	                                    }
	                                },
	                                FVolatility: {
	                                    color: ['#FD5516', '#008E91']
	                                },
	                                AccDis: {
	                                    color: ['#FD5516', '#008E91']
	                                },
	                                Mass: {
	                                    color: ['#FD5516', '#008E91']
	                                },
	                                Volatility: {
	                                    color: ['#FD5516', '#008E91'],
	                                    //example Volatility(7,5)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ',' + parameters[1] + ')'
	                                        ];
	                                    }
	                                },
	                                ForceIndex: {
	                                    color: ['#FD5516', '#008E91'],
	                                    //example ForceIndex(13)
	                                    legend: function(labels, parameters) {
	                                        return [
	                                            labels[0] + '(' + parameters[0] + ')'
	                                        ];
	                                    }
	                                },
	                                ATR: {
	                                    color: ['#008E91']
	                                }
	                            },
	                            show: true,
	                            chartClass: "chart-indicatorchart",
	                            chartType: StaticConfig.IndicatorChartTypes.LineChart, //LineChart
	                        },
	                        fundamentalChart: {
	                            margin: {
	                                top: 0,
	                                right: 0,
	                                bottom: 0,
	                                left: 0
	                            },
	                            width: 960,
	                            height: 120,
	                            dataFormat: "%Y%m%d",
	                            container: null,
	                            xAxis: {
	                                show: false,
	                                orient: "bottom"
	                            },
	                            yAxis: {
	                                show: true,
	                                orient: "left",
	                                isFormat: true,
	                                ticks: 3,
	                                maxTickCount: 4,
	                                width: 42,
	                                position: "outer",
	                                tick: {
	                                    line: {
	                                        show: true,
	                                        style: {
	                                            'stroke': '#cccccc',
	                                            'stroke-width': '1px'
	                                        }
	                                    }
	                                }
	                            },
	                            showGridLines: true,
	                            showGridBlocks: false,
	                            showSolidGridLines: false,
	                            showLegend: false,
	                            showFundamentalCloseButton: false,
	                            fundamentalProperties: {
	                                PE: {
	                                    color: '#008E91',
	                                },
	                                PS: {
	                                    color: '#008E91',
	                                },
	                                PB: {
	                                    color: '#008E91',
	                                },
	                                PC: {
	                                    color: '#008E91',
	                                },
	                                SInterest: {
	                                    color: '#008E91',
	                                },
	                                REPS: {
	                                    color: '#008E91',
	                                },
	                                DiscountCumFair: {
	                                    color: '#008E91',
	                                },
	                                PremiumDiscount: {
	                                    color: '#FD5516',
	                                }
	
	                            },
	                            show: true,
	                            chartClass: "chart-fundamentalchart",
	                            chartType: StaticConfig.FundamentalChartTypes.LineChart,
	                        }
	                    }
	                },
	                'labels': LanguageConfig,
	                'components': {}
	            }
	        };
	
	        return {
	            AutocompleteCategories: StaticConfig.AutocompleteCategories,
	            defaultConfig: defaultConfig,
	            frequencyConfig: StaticConfig.frequencyConfig,
	            frequencySetupConfig: StaticConfig.frequencySetupConfig,
	            ChartTypes: StaticConfig.ChartTypes,
	            ITFundGrowthTypes: StaticConfig.ITFundGrowthTypes,
	            CursorType: StaticConfig.CursorType,
	            PopoverTypes: StaticConfig.PopoverTypes,
	            BenchmarkType: StaticConfig.BenchmarkType,
	            MainChartTypes: StaticConfig.MainChartTypes,
	            MainDataTypes: StaticConfig.MainDataTypes,
	            VolumeChartTypes: StaticConfig.VolumeChartTypes,
	            FundamentalChartTypes: StaticConfig.FundamentalChartTypes,
	            IndicatorChartTypes: StaticConfig.IndicatorChartTypes,
	            IntervalTypesMapping: StaticConfig.IntervalTypesMapping,
	            ExternalTypesMapping: StaticConfig.ExternalTypesMapping,
	            IntervalTypes: StaticConfig.IntervalTypes,
	            FrequencyTypes: StaticConfig.FrequencyTypes,
	            FrequencyTexts: StaticConfig.FrequencyTexts,
	            Constants: StaticConfig.Constants,
	            TimezoneMap: StaticConfig.TimezoneMap,
	            IntervalTypeSortedArray: StaticConfig.IntervalTypeSortedArray,
	            SelectionModes: StaticConfig.SelectionModes,
	            StartDateTypes: StaticConfig.StartDateTypes,
	            VerticalScaleTypes: StaticConfig.VerticalScaleTypes,
	            ChartGenre: StaticConfig.ChartGenre,
	            indicatorInputTypes: StaticConfig.indicatorInputTypes,
	            ChartTypeCategoryMap: StaticConfig.ChartTypeCategoryMap,
	            IntervalTypeMap: StaticConfig.IntervalTypeMap,
	            FrequencyMap: StaticConfig.FrequencyMap,
	            ChartCursorType: StaticConfig.ChartCursorType,
	            ScaleType: StaticConfig.ScaleType,
	            ModeType: StaticConfig.ModeType,
	            MainChartTypeMap: StaticConfig.MainChartTypeMap,
	            MainDataTypeMap: StaticConfig.MainDataTypeMap,
	            EventsMap: StaticConfig.EventsMap,
	            DrawTypeMap: StaticConfig.DrawTypeMap,
	            CurrencyMapping: StaticConfig.CurrencyMapping
	        };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(24);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "<div class=\"mkts-cmpt-svgcht-chart-container mkts-cmpt-svgcht-chart-container--"
	    + container.escapeExpression(((helper = (helper = helpers.skin || (depth0 != null ? depth0.skin : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"skin","hash":{},"data":data}) : helper)))
	    + "\">\n    <div class=\"mkts-cmpt-svgcht-chart\">\n        <div class=\"mkts-cmpt-svgcht-errors\"></div>\n        <div class=\"mkts-cmpt-svgcht-menubar\"></div>\n        <div class=\"chart-body\">\n            <div class=\"chart-mainchart\"></div>\n            <div class=\"chart-subcharts\">\n                <div class=\"chart-volumechart\"></div>\n                <div class=\"chart-sliderchart\"></div>\n            </div>\n            <div class=\"chart-indicator-fundamental\">\n                <div class=\"chart-fundamentalchart\"></div>\n                <div class=\"chart-indicatorchart\"></div>\n            </div>\n        </div>\n        <div class=\"chart-bottombar\"></div>\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        'use strict';
	
	        var indicatorInputTypes = {
	            NullOrPositiveInteger: '', //default
	            NecessaryPositiveInteger: 'npi'
	        }
	
	        var ChartTypes = {
	            MainChart: "mainChart",
	            VolumeChart: "volumeChart",
	            SliderChart: "sliderChart",
	            FundamentalChart: "fundamentalChart",
	            IndicatorChart: "indicatorChart",
	        };
	
	
	        var MainChartTypes = {
	            LineChart: "lineChart",
	            MountainChart: "mountainChart",
	            DotChart: "dotChart",
	            ABChart: "abChart",
	            OHLCChart: "ohlcChart",
	            HLCChart: "hlcChart",
	            CandlestickChart: "candlestickChart",
	            DividendEffectChart: "dividendEffectChart",
	            pGrowthChart: "pGrowthChart",
	            TenKGrowthChart: "tenKGrowthChart",
	            PostTaxChart: "postTaxChart",
	            PriceWithDividendGrowth: "priceWithDividendGrowth"
	        };
	
	        var MainDataTypes = {
	            Price: "price",
	            Nav: 'nav',
	            DividendEffect: 'dividendEffect',
	            Growth: 'growth',
	            Growth10K: 'growth10K',
	            PostTax: 'postTax',
	            TotalReturn: 'totalReturn',
	            MarketValue: 'marketValue',
	            PriceAndNav: 'priceNav',
	            PriceWithDividendGrowth: 'priceWithDividendGrowth'
	        };
	
	        var VolumeChartTypes = {
	            VolumeChart: "volumeChart",
	            VolumePlusChart: "volumePlusChart"
	        };
	
	        var FundamentalChartTypes = {
	            LineChart: "lineChart"
	        };
	
	        var IndicatorChartTypes = {
	            LineChart: "lineChart"
	        };
	
	        var IntervalTypes = {
	            OneDay: "OneDay",
	            FiveDay: "FiveDay",
	            FifteenDay: "FifteenDay",
	            OneMonth: "OneMonth",
	            ThreeMonth: "ThreeMonth",
	            SixMonth: "SixMonth",
	            YTD: "YTD",
	            OneYear: "OneYear",
	            ThreeYear: "ThreeYear",
	            FiveYear: "FiveYear",
	            TenYear: "TenYear",
	            FifteenYear: "FifteenYear",
	            Max: "Max",
	            Custom: "Oneday"
	        };
	        /**
	         * start
	         * transform SDK to Svgchart
	         */
	        var IntervalTypeMap = {
	            "1": "OneDay",
	            "2": "FiveDay",
	            "13": "FifteenDay",
	            "3": "OneMonth",
	            "4": "ThreeMonth",
	            "15": "SixMonth",
	            "5": "YTD",
	            "6": "OneYear",
	            "7": "ThreeYear",
	            "8": "FiveYear",
	            "9": "TenYear",
	            "10": "Max",
	            "11": null
	        }
	
	        var FrequencyMap = {
	            "minute": 1,
	            "minute5": 5,
	            "minute10": 10,
	            "minute15": 15,
	            "minute30": 30,
	            "d": "d",
	            "w": "w",
	            "m": "m"
	        }
	
	        var ChartCursorType = {
	            "1": 'crosshair',
	            "0": 'trackball',
	            "3": 'off'
	        }
	
	        var ScaleType = {
	            "0": "linear",
	            "1": "logarithmic"
	        }
	
	        var ModeType = {
	            "pan": "pan",
	            "zoomin": "zoomIn",
	            "off": "off"
	        };
	
	        var MainChartTypeMap = {
	            "line": "lineChart",
	            "mountain": "mountainChart",
	            "dot": "dotChart",
	            "ab": "abChart",
	            "ohlc": "ohlcChart",
	            "hlc": "ohlcChart",
	            "candle": "candlestickChart"
	        };
	
	        var MainDataTypeMap = {
	            "dEffect": 'dividendEffect',
	            "growth": 'growth',
	            "growth10": 'growth10K'
	        };
	
	        var EventsMap = {
	            "dividend": "dividend",
	            "splits": "split",
	            "earnings": "earnings"
	        }
	
	        var DrawTypeMap = {
	            "trendline": "trendline",
	            "rectangle": "rectangle",
	            "ellipse": "ellipse",
	            "levelline": "levelline",
	            "fibonacci": "fibonacciretracementlevels",
	            "fibonacci_timezone": "fibonaccitimezones",
	            "fibonacci_fl": "fibonaccifans",
	            "fibonacci_arc": "fibonacciarcs",
	            "fibonaccitimezones": "fibonaccitimezones",
	            "fibonacciretracementlevels": "fibonacciretracementlevels",
	            "fibonaccifans": "fibonaccifans",
	            "fibonacciarcs": "fibonacciarcs"
	        }
	
	        /**
	         * end
	         * transform SDK to Svgchart
	         */
	        var IntervalTypesMapping = {
	            "1D": "OneDay",
	            "5D": "FiveDay",
	            "15D": "FifteenDay",
	            "1M": "OneMonth",
	            "3M": "ThreeMonth",
	            "6M": "SixMonth",
	            "YTD": "YTD",
	            "1Y": "OneYear",
	            "3Y": "ThreeYear",
	            "5Y": "FiveYear",
	            "10Y": "TenYear",
	            "MAX": "Max"
	        };
	
	        var ExternalTypesMapping = {
	            "OneDay": "One Day",
	            "FiveDay": "Five Days",
	            "FifteenDay": "Fifteen Days",
	            "OneMonth": "One Month",
	            "ThreeMonth": "Three Months",
	            "SixMonth": "Six Months",
	            "YTD": "YTD",
	            "OneYear": "One Year",
	            "ThreeYear": "Three Years",
	            "FiveYear": "Five Years",
	            "TenYear": "Ten Years",
	            "Max": "Max"
	        };
	
	        var IntervalTypeSortedArray = [
	            "OneDay",
	            "FiveDay",
	            "FifteenDay",
	            "OneMonth",
	            "ThreeMonth",
	            "SixMonth",
	            "YTD",
	            "OneYear",
	            "ThreeYear",
	            "FiveYear",
	            "TenYear",
	            "FifteenYear",
	            "Max"
	        ];
	
	        var FrequencyTypes = {
	            OneMinute: 1,
	            FiveMinute: 5,
	            TenMinute: 10,
	            FifteenMinute: 15,
	            ThirtyMinute: 30,
	            SixtyMinute: 60,
	            Daily: "d",
	            Weekly: "w",
	            Monthly: "m"
	        };
	
	        var CursorType = {
	            Crosshair: 'crosshair',
	            Trackball: 'trackball',
	            Off: 'off'
	        };
	
	        var Constants = {
	            MINUTE_IN_MILLISECOND: 60 * 1e3,
	            DAY_IN_MINUTE: 60 * 24,
	            DAY_IN_SECONDS: 60 * 24 * 60,
	            DAY_IN_MILLISECONDS: 60 * 24 * 60 * 1e3
	        };
	        // available categories: ['Equities', 'ETF', 'Closed-End Fund', 'Mutual Fund', 'Index', 'Forex', 'Futures',
	        //'Options', 'Debenture', 'Government Bonds', 'Strategies & Spreads', 'Unspecified Bonds',
	        //'Unspecified Funds & Certificates', 'Warrents']
	        var AutocompleteCategories = {
	            "stock": ['Equities', 'ETF', 'Index', 'Closed-End Fund'],
	            "forex": ['Forex'],
	            "fund": ['Mutual Fund', 'Index']
	        };
	
	        //available category by chartType
	        var ChartTypeCategoryMap = {
	            "StockChart": "stock",
	            "ForexChart": "forex",
	            "FundChart": "fund"
	        };
	        var frequencySetupConfig = {
	            f1: [{
	                    "value": "1",
	                    "text": "oneMinute"
	                },
	                {
	                    "value": "5",
	                    "text": "fiveMinute"
	                },
	                {
	                    "value": "10",
	                    "text": "tenMinute"
	                },
	                {
	                    "value": "15",
	                    "text": "fifteenMinute"
	                },
	                {
	                    "value": "30",
	                    "text": "thirtyMinute"
	                }
	            ],
	            f2: [{
	                    "value": "5",
	                    "text": "fiveMinute"
	                },
	                {
	                    "value": "10",
	                    "text": "tenMinute"
	                },
	                {
	                    "value": "15",
	                    "text": "fifteenMinute"
	                },
	                {
	                    "value": "30",
	                    "text": "thirtyMinute"
	                }
	            ],
	            f3: [{
	                    "value": "10",
	                    "text": "tenMinute"
	                },
	                {
	                    "value": "15",
	                    "text": "fifteenMinute"
	                },
	                {
	                    "value": "30",
	                    "text": "thirtyMinute"
	                },
	                {
	                    "value": "d",
	                    "text": "daily"
	                },
	                {
	                    "value": "w",
	                    "text": "weekly"
	                }
	            ],
	            f4: [{
	                    "value": "d",
	                    "text": "daily"
	                },
	                {
	                    "value": "w",
	                    "text": "weekly"
	                },
	                {
	                    "value": "m",
	                    "text": "monthly"
	                }
	            ],
	            f5: [{
	                "value": "m",
	                "text": "monthly"
	            }],
	            f6: [{
	                    "value": "1",
	                    "text": "oneMinute"
	                },
	                {
	                    "value": "5",
	                    "text": "fiveMinute"
	                },
	                {
	                    "value": "10",
	                    "text": "tenMinute"
	                },
	                {
	                    "value": "15",
	                    "text": "fifteenMinute"
	                },
	                {
	                    "value": "30",
	                    "text": "thirtyMinute"
	                },
	                {
	                    "value": "d",
	                    "text": "daily"
	                },
	                {
	                    "value": "w",
	                    "text": "weekly"
	                },
	                {
	                    "value": "m",
	                    "text": "monthly"
	                }
	            ],
	            f7: [{
	                    "value": "5",
	                    "text": "fiveMinute"
	                },
	                {
	                    "value": "10",
	                    "text": "tenMinute"
	                },
	                {
	                    "value": "15",
	                    "text": "fifteenMinute"
	                },
	                {
	                    "value": "30",
	                    "text": "thirtyMinute"
	                },
	                {
	                    "value": "60",
	                    "text": "sixtyMinute"
	                }
	            ],
	            f8: [{
	                    "value": "10",
	                    "text": "tenMinute"
	                },
	                {
	                    "value": "15",
	                    "text": "fifteenMinute"
	                },
	                {
	                    "value": "30",
	                    "text": "thirtyMinute"
	                },
	                {
	                    "value": "60",
	                    "text": "sixtyMinute"
	                },
	                {
	                    "value": "d",
	                    "text": "daily"
	                },
	                {
	                    "value": "w",
	                    "text": "weekly"
	                }
	            ]
	        };
	
	        var PopoverTypes = {
	            OHLCV: "OHLCV",
	            Growth: "Growth",
	            TenKGrowth: "TenKGrowth",
	            PostTax: "PostTax",
	            Simple: 'Simple'
	        };
	
	        var FrequencyTexts = {
	            "1": "oneMinute",
	            "5": "fiveMinute",
	            "10": "tenMinute",
	            "15": "fifteenMinute",
	            "30": "thirtyMinute",
	            "60": "sixtyMinute",
	            "d": "daily",
	            "w": "weekly",
	            "m": "monthly"
	        };
	
	        var frequencyConfig = {
	            'OneDay': {
	                fc: frequencySetupConfig.f1,
	                def: '1'
	            },
	            'FiveDay': {
	                fc: frequencySetupConfig.f2,
	                def: '5'
	            },
	            'FifteenDay': {
	                fc: frequencySetupConfig.f7,
	                def: '10'
	            },
	            'OneMonth': {
	                fc: frequencySetupConfig.f8,
	                def: 'd'
	            },
	            'ThreeMonth': {
	                fc: frequencySetupConfig.f8,
	                def: 'd'
	            },
	            'SixMonth': {
	                fc: frequencySetupConfig.f4,
	                def: 'd'
	            },
	            'YTD': {
	                fc: frequencySetupConfig.f4,
	                def: 'd'
	            },
	            'OneYear': {
	                fc: frequencySetupConfig.f4,
	                def: 'd'
	            },
	            'ThreeYear': {
	                fc: frequencySetupConfig.f4,
	                def: 'd'
	            },
	            'FiveYear': {
	                fc: frequencySetupConfig.f4,
	                def: 'd'
	            },
	            'TenYear': {
	                fc: frequencySetupConfig.f4,
	                def: 'd'
	            },
	            'Max': {
	                fc: frequencySetupConfig.f4,
	                def: 'm'
	            }
	        };
	
	        var LanguageTypes = {
	            EN_US: 'en-US',
	        };
	
	        var TimezoneMap = {
	            "ADT": -180,
	            "AKDT": -480,
	            "AKST": -540,
	            "AST": -240,
	            "CDT": -300,
	            "CST": -360,
	            "EDT": -240,
	            "EST": -300,
	            "EGT": -60,
	            "EGST": 0,
	            "HADT": -540,
	            "HAST": -600,
	            "MDT": -360,
	            "MST": -420,
	            "NDT": -150,
	            "NST": -210,
	            "PDT": -420,
	            "PST": -480,
	            "WGT": -180,
	            "WGST": -120,
	            "CET": 60
	        };
	
	        var SelectionModes = {
	            Pan: "pan",
	            ZoomIn: "zoomIn",
	            Off: "off"
	        };
	
	        var VerticalScaleTypes = {
	            Linear: "linear",
	            Logarithmic: "logarithmic"
	        };
	
	        var ChartGenre = {
	            StockChart: "StockChart",
	            ForexChart: "ForexChart",
	            FundChart: "FundChart",
	            CommodityChart: "CommodityChart"
	        };
	
	        var BenchmarkType = {
	            FundCategory: "FundCategory",
	            RelativeRiskBenchmark: "RelativeRiskBenchmark",
	            ProspectusBenchmark: "ProspectusBenchmark",
	            MstarIndex: "MstarIndex"
	        };
	
	        var Securities = {
	            'ST': 'Equities',
	            "ST01": "Common Stocks",
	            "ST02": "Preferred Stocks",
	            "STADR": "ADRs",
	            'XI': 'Index',
	            'FE': 'ETF',
	            'FC': 'Closed-End Fund',
	            'FO': 'Mutual Fund',
	            'FM': 'Mutual Fund',
	            'C0': 'Cash',
	            'CA': 'Category',
	            'SA': 'Life & Pension',
	            'OTHER': 'Others',
	            'Bonds': 'Bonds',
	            'FG': 'Euro Funds',
	            'FH': 'Hedge Funds',
	            'CB': 'Custom Benchmark',
	            'MI': 'Miscellaneous',
	            '1': 'Equities',
	            '2': 'Options',
	            '3': 'Futures',
	            '7': 'Debenture',
	            '8': 'Mutual Fund',
	            '9': 'Government Bonds',
	            '10': 'Index',
	            '13': 'Strategies & Spreads',
	            '16': 'Unspecified Bonds',
	            '17': 'Unspecified Funds & Certificates',
	            '18': 'Warrants',
	            '20': 'Forex',
	            '15': 'Mutual Fund'
	        };
	        var StartDateTypes = {
	            Common: "common",
	            MainTicker: "main",
	            Earliest: "earliest"
	        };
	        var CurrencyMapping = {
	            'AUD': "AUD",
	            'CAD': "CAD",
	            'CHF': "CHF",
	            'DKK': "DKK",
	            'EUR': "EUR",
	            'GBP': "GBP",
	            'HKD': "HKD",
	            'ILS': "ILS",
	            'INR': "INR",
	            'MYR': "MYR",
	            'PLN': "PLN",
	            'SEK': "SEK",
	            'SGD': "SGD",
	            'THB': "THB",
	            'USD': "USD",
	            'ZAR': "ZAR"
	        };
	
	        return {
	            ChartTypes: ChartTypes,
	            MainChartTypes: MainChartTypes,
	            MainDataTypes: MainDataTypes,
	            VolumeChartTypes: VolumeChartTypes,
	            FundamentalChartTypes: FundamentalChartTypes,
	            IndicatorChartTypes: IndicatorChartTypes,
	            IntervalTypes: IntervalTypes,
	            IntervalTypeMap: IntervalTypeMap,
	            FrequencyMap: FrequencyMap,
	            IntervalTypesMapping: IntervalTypesMapping,
	            ExternalTypesMapping: ExternalTypesMapping,
	            IntervalTypeSortedArray: IntervalTypeSortedArray,
	            FrequencyTypes: FrequencyTypes,
	            FrequencyTexts: FrequencyTexts,
	            CursorType: CursorType,
	            ChartCursorType: ChartCursorType,
	            ScaleType: ScaleType,
	            ModeType: ModeType,
	            MainChartTypeMap: MainChartTypeMap,
	            MainDataTypeMap: MainDataTypeMap,
	            DrawTypeMap: DrawTypeMap,
	            EventsMap: EventsMap,
	            Constants: Constants,
	            AutocompleteCategories: AutocompleteCategories,
	            frequencySetupConfig: frequencySetupConfig,
	            PopoverTypes: PopoverTypes,
	            BenchmarkType: BenchmarkType,
	            frequencyConfig: frequencyConfig,
	            LanguageTypes: LanguageTypes,
	            TimezoneMap: TimezoneMap,
	            SelectionModes: SelectionModes,
	            VerticalScaleTypes: VerticalScaleTypes,
	            ChartGenre: ChartGenre,
	            indicatorInputTypes: indicatorInputTypes,
	            ChartTypeCategoryMap: ChartTypeCategoryMap,
	            Securities: Securities,
	            StartDateTypes: StartDateTypes,
	            CurrencyMapping: CurrencyMapping
	        };
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	    return {
	        'values': {
	            'en': {
	                'invalidInputDefault': 'Please input a positive interger or nothing',
	                'invalidInputNpi': 'Please input a positive interger',
	                'frequency': 'Frequency',
	                'dataRange': 'Date range',
	                'customDate': 'Custom Date',
	                'customStartDate': 'Start Date',
	                'customEndDate': 'End Date',
	                'labelSearch': 'Add assets to compare',
	                'labelChange': 'Change Main Ticker',
	                'eventsIndicators': 'Events & Indicators',
	                'events': 'Events',
	                'eventsDividende': 'Dividend',
	                'eventsSplits': 'Splits',
	                'eventsEarnings': 'Earnings',
	                'indicators': 'Indicators',
	                'indicatorsSMA': 'Simple Moving Average (SMA)',
	                'indicatorsSMAlabel1': 'Line1 period',
	                'indicatorsSMAlabel2': 'Line2 period',
	                'indicatorsSMAlabel3': 'Line3 period',
	                'indicatorsEMA': 'Exponential Moving Average (EMA)',
	                'indicatorsEMAlabel1': 'Line1 period',
	                'indicatorsEMAlabel2': 'Line2 period',
	                'indicatorsEMAlabel3': 'Line3 period',
	                'indicatorsVolume': 'Volume',
	                'indicatorsVolumeSMA': 'Volume SMA',
	                'indicatorsPeriod': 'Period',
	                'indicatorsBBands': 'Bollinger Bands (BBands)',
	                'indicatorsBBandsPeriod': 'Period',
	                'indicatorsBBandsDeviation': 'Deviation',
	                'indicatorsPSAR': 'Parabolic SAR (PSAR)',
	                'indicatorsPSARStep': 'Step Period',
	                'indicatorsPSARMaxStep': 'Max Step Period',
	                'indicatorsMACD': 'MACD',
	                'indicatorsMACDSlow': 'Slow Period',
	                'indicatorsMACDFast': 'Fast Period',
	                'indicatorsMACDSignal': 'Signal Period',
	                'indicatorsRSI': 'Relative Strength Index (RSI)',
	                'indicatorsRSIPeriod': 'Period',
	                'indicatorsROC': 'Rate of Change (ROC)',
	                'indicatorsROCPeriod': 'Period',
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Period',
	                'indicatorsSMAR': 'Williams %R',
	                'indicatorsSMAPeriod': 'Period',
	                'indicatorsSMASlow': 'Slow Stochastic',
	                'indicatorsSMAK': 'K% Period',
	                'indicatorsSMAD': 'D% Period',
	                'indicatorsSMAFast': 'Fast Stochastic',
	                'indicatorsSMAFastK': 'K% Period',
	                'indicatorsSMAFastD': 'D% Period',
	                'indicatorsSMAPrice': 'Price Channel',
	                'indicatorsSMAPriceChannel': 'Price Channel',
	                'indicatorsSMAMA': 'MA Envelope',
	                'indicatorsSMAMAPeriod': 'Period',
	                'indicatorsSMAMABand': 'Band Width',
	                'indicatorsSMAMomentum': 'Momentum',
	                'indicatorsSMAMomentumPeriod': 'Period',
	                'indicatorsSMAULT': 'Ultimate (ULT) Oscillator',
	                'indicatorsSMADMI': 'Directional Moving Index (DMI)',
	                'indicatorsSMADMIPeriod': 'Period',
	                'indicatorsSMAMoney': 'Money Flow Index',
	                'indicatorsSMAMoneyPeriod': 'Period',
	                'indicatorsSMAOBV': 'On Balance Volume',
	                'indicatorsEMAVol': 'Volume Accumulation',
	                'indicatorsEMADirect': 'Up/Down Ratio',
	                'indicatorsEMADirectPeriodo': 'Period',
	                'indicatorsEMADirectSmoothing': 'Smoothing',
	                'indicatorsEMAVolume': 'Volume By Price',
	                'indicatorsEMAFast': 'Fast Volatility',
	                'indicatorsEMAWeight': 'Weighted Moving Average',
	                'indicatorsEMAWeightPeriodo': 'Period',
	                'indicatorsEMAAD': 'Accumulation/Distribution',
	                'indicatorsEMAMass': 'Mass Index',
	                'indicatorsEMAVolat': 'Volatility',
	                'indicatorsEMAVolatPeriod': 'Period',
	                'indicatorsEMAVolatPeriodA': 'Period Ago',
	                'indicatorsEMAForce': 'Force Index',
	                'indicatorsEMAForcePeriod': 'Period',
	                'indicatorsEMARange': 'Average True Range',
	                'indicatorsVolumeKeltner': 'Keltner Index',
	                'indicatorsVolumeKeltnerEMA': 'EMA Period',
	                'indicatorsVolumeKeltnerTimes': 'Times',
	                'indicatorsVolumeKeltnerATR': 'ATR Period',
	                'indicatorsVolumePrevious': 'Previous Close Line',
	                'performanceGrowthChart': 'Performance Growth Chart',
	                'pricesGrowthChart': 'Prices Growth Chart',
	                'performanceGrowthChartance': 'Performance...',
	                'update': 'Update',
	                'fundamentals': 'Fundamentals',
	                'priceEarnings': 'Price/Earnings',
	                'priceSales': 'Price/Sales',
	                'priceBook': 'Price/Book',
	                'priceCash': 'Price/Cash',
	                'fairValue': 'Fair Value',
	                'rollingDividend': 'Rolling Dividend',
	                'dividendYield': 'Dividend Yield',
	                'rollingEPS': 'Rolling EPS',
	                'drawings': 'Drawings',
	                'trendLine': 'Trend Line',
	                'rectangle': 'Rectangle',
	                'ellipse': 'Ellipse',
	                'levelLine': 'Level Line',
	                'fibonacciRL': 'Fibonacci Retracement Levels',
	                'fibonacciFans': 'Fibonacci Fans',
	                'fibonacciTZ': 'Fibonacci Time Zones',
	                'fibonacciArcs': 'Fibonacci Arcs',
	                'shortInt': '% Short Int.',
	                'priceEarnings0': 'Discount Cum Fair',
	                'priceEarnings1': 'NAV',
	                'priceEarnings2': 'Premium/Discount',
	                'display': 'Display',
	                'cursorType': 'Cursor Type',
	                'crosshair': 'Crosshair',
	                'trackBall': 'Track Ball',
	                'off': 'Off',
	                'chartType': 'Chart Type',
	                'mountain': 'Mountain',
	                'line': 'Line',
	                'dot': 'Dot',
	                'aboveBelow': 'Above/Below',
	                'OHLC': 'OHLC',
	                'HLC': 'HLC',
	                'candlestick': 'Candlestick',
	                'growth': 'Growth',
	                '10KGrowth': '10K Growth',
	                'priceWithDividendGrowth': 'Price with Dividend Growth',
	                'dividendEffect': 'Dividend Effect',
	                'postTax': 'Post Tax',
	                'yAxis': 'Y-Axis',
	                'left': 'Left',
	                'right': 'Right',
	                'verticalScale': 'Vertical Scale',
	                'linear': 'Linear',
	                'logarithmic': 'Logarithmic',
	                'selectionMode': 'Selection Mode',
	                'pan': 'Pan',
	                'zoomIn': 'Zoom In',
	                'reset': 'Reset',
	                'other': 'Other',
	                'extendedMarketHour': 'Extended Market Hour',
	                'volumePlus': 'Volume+',
	                'oneMinute': '1 min',
	                'fiveMinute': "5 min",
	                'tenMinute': "10 min",
	                'fifteenMinute': "15 min",
	                'thirtyMinute': "30 min",
	                'sixtyMinute': "60 min",
	                'daily': "Daily",
	                'weekly': "Weekly",
	                'monthly': "Monthly",
	                'date': 'Date',
	                'time': 'Time',
	                'nav': 'NAV',
	                'oneMinuteValueChange': '1 min Change',
	                'oneMinuteValueChangePercent': '1 min % Change',
	                'fiveMinuteValueChange': "5 min Change",
	                'fiveMinuteValueChangePercent': "5 min % Change",
	                'tenMinuteValueChange': "10 min Change",
	                'tenMinuteValueChangePercent': "10 min % Change",
	                'fifteenMinuteValueChange': "15 min Change",
	                'fifteenMinuteValueChangePercent': "15 min % Change",
	                'thirtyMinuteValueChange': "30 min Change",
	                'thirtyMinuteValueChangePercent': "30 min % Change",
	                'sixtyMinuteValueChange': "60 min Change",
	                'sixtyMinuteValueChangePercent': "60 min % Change",
	                'dailyValueChange': "Daily Change",
	                'dailyValueChangePercent': "Daily % Change",
	                'weeklyValueChange': "Weekly Change",
	                'weeklyValueChangePercent': "Weekly % Change",
	                'monthlyValueChange': "Monthly Change",
	                'monthlyValueChangePercent': "Monthly % Change",
	                'totalReturn': 'Total Return',
	                'marketValue': 'Market Value',
	                'open': 'Open',
	                'close': 'Close',
	                'low': 'Low',
	                'high': 'High',
	                'volume': 'Volume',
	                'value': 'Value',
	                'semiAnnual': 'Semi-annual',
	                'annual': 'Annual',
	                'quarterly': 'Quarterly',
	                'mainGrowthLabel': 'Performance Fondo',
	                'compareGrowthLabel': 'Performance Benchmark',
	                'closeDateLabel': 'Data Chiusura Mercato',
	                'range': 'Range',
	                "datanotavailable": "Data not available",
	                "mifidRuleMessage": "This graph and the related data will be available {0} months after the fund's inception date",
	                'changetodailyfrequency': 'This is a daily data point. |Please change your frequency to Daily.',
	                'tenKGrowth': '10K Growth',
	                'postTax': 'Post Tax',
	                'addComparison': 'Add Comparison',
	                'changeTicker': 'Change Ticker',
	                'searchAssets': 'Search assets',
	                'crosshairsPopoverNoData': '--',
	                'mainChartHeaderDividendEffectLabel': '(w Div.)',
	                'compareChartsMaxAllowedErrorLabel': 'The maximum compare tickers are reached.',
	                'oneDay': '1D',
	                'fiveDay': '5D',
	                'fifteenDay': '15D',
	                'oneMonth': '1M',
	                'threeMonth': '3M',
	                'sixMonth': '6M',
	                'YTD': 'YTD',
	                'oneYear': '1Y',
	                'threeYear': '3Y',
	                'fiveYear': '5Y',
	                'tenYear': '10Y',
	                'max': 'MAX',
	                'to': 'to',
	                'frequencys': 'frequency',
	                'dividendText': 'D',
	                'splitText': 'S',
	                'earningText': 'E',
	                'settings': 'Settings',
	                'optionsBtnText': 'Options',
	                'export': 'Export',
	                'print': 'Print',
	                "closeBtnText": "Close",
	                'errorsMsg': "Your mobile device can’t display some charting features. Log in from a tablet or computer for a better trading experience.",
	                'fundSize': 'Fund Size',
	                'price': 'Price',
	                'shareholdersNumber': 'Number of shareholders',
	                'name': 'Name',
	                'PE': 'Price/Earnings',
	                'PS': 'Price/Sales',
	                'PB': 'Price/Book',
	                'PC': 'Price/Cash',
	                'FairValue': 'Fair Value',
	                'DailyCumFairNav': 'NAV',
	                'QuantitativeFairValue': 'Fair Value',
	                'RDividend': 'Rolling Dividend',
	                'DYield': 'Dividend Yield',
	                'REPS': 'Rolling EPS',
	                'PremiumDiscount': 'Premium/Discount',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '% Short Int.',
	                'SMA': 'SMA',
	                'EMA': 'EMA',
	                'SMAV': 'SMAV',
	                'BBands': 'BBands',
	                'PSAR': 'PSAR',
	                'RSI': 'RSI',
	                'ROC': 'ROC',
	                'CCI': 'CCI',
	                'WillR': 'WillR',
	                'SStochastic': 'SStochastic',
	                'FStochastic': 'FStochastic',
	                'PChannel': 'PChannel',
	                'MAE': 'MA Envelope',
	                'Momentum': 'Momentum',
	                'ULT': 'Ultimate Oscillator',
	                'MFI': 'MFI',
	                'OBV': 'On Balance Volume',
	                'VAcc': 'Volume Accumulation',
	                'UDRatio': 'UDRatio',
	                'FVolatility': 'Fast Volatility',
	                'WMA': 'WMA',
	                'AccDis': 'Accumulation/Distribution',
	                'Mass': 'Mass',
	                'Volatility': 'Volatility',
	                'ForceIndex': 'ForceIndex',
	                'ATR': 'Average True Range',
	                'Keltner': 'Keltner Index',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'Previous Close',
	                "mutualFund": "Mutual Fund",
	                "closedEndFund": "Closed-End Fund",
	                "equities": "Equities",
	                "index": "Index",
	                "eTF": "ETF",
	                "commonStocks": "Common Stocks",
	                "preferredStocks": "Preferred Stocks",
	                "aDRs": "ADRs",
	                "options": "Options",
	                "futures": "Futures",
	                "debenture": "Debenture",
	                "governmentBonds": "Government Bonds",
	                "municipalBonds": "Municipal Bonds",
	                "strategiesSpreads": "Strategies & Spreads",
	                "unspecifiedBonds": "Unspecified Bonds",
	                "unspecifiedFundsCertificates": "Unspecified Funds & Certificates",
	                "warrants": "Warrants",
	                "forex": "Forex",
	                "startDate": "Start Date",
	                "earliest": "Earliest",
	                "common": "Common",
	                "mainTicker": "Main Ticker",
	                "startDateIllustrate": "Indicate the base date when comparison added"
	            },
	            'fr': {
	                'invalidInputDefault': 'Veuillez entrer une variable positive ou nulle',
	                'invalidInputNpi': 'Veuillez entrer une variable positive',
	                'frequency': 'Fréquence',
	                'dataRange': 'Intervalle de dates',
	                'customDate': 'Date personnalisé',
	                'customStartDate': 'Date de début',
	                'customEndDate': 'Date de fin',
	                'labelSearch': 'Ajouter titre en comparaison',
	                'labelChange': 'Changer le symbole',
	                'eventsIndicators': 'Événements et indicateurs',
	                'events': 'Événements',
	                'eventsDividende': 'Dividende',
	                'eventsSplits': 'Fractionnements',
	                'eventsEarnings': 'Bénéfices',
	                'indicators': 'Indicateurs',
	                'indicatorsSMA': 'Moyenne mobile simple (MMA)',
	                'indicatorsSMAlabel1': 'Période Ligne 1',
	                'indicatorsSMAlabel2': 'Période Ligne 2',
	                'indicatorsSMAlabel3': 'Période Ligne 3',
	                'indicatorsEMA': 'Moyenne mobile exponentielle (MME)',
	                'indicatorsEMAlabel1': 'Période Ligne 1',
	                'indicatorsEMAlabel2': 'Période Ligne 2',
	                'indicatorsEMAlabel3': 'Période Ligne 3',
	                'indicatorsVolume': 'Volume',
	                'indicatorsVolumeSMA': 'Moyenne mobile simple du volume',
	                'indicatorsPeriod': 'Période',
	                'indicatorsBBands': 'Bandes de Bollinger Bands (BBandes)',
	                'indicatorsBBandsPeriod': 'Période',
	                'indicatorsBBandsDeviation': 'Écart-type',
	                'indicatorsPSAR': 'Parabolique SAR (PSAR)',
	                'indicatorsPSARStep': 'Étape de valeur',
	                'indicatorsPSARMaxStep': 'Valeur max de l\'indicateur',
	                'indicatorsMACD': 'MACD',
	                'indicatorsMACDSlow': 'Période lente',
	                'indicatorsMACDFast': 'Période court terme',
	                'indicatorsMACDSignal': 'Période de signal',
	                'indicatorsRSI': 'Indice de force relative (RSI)',
	                'indicatorsRSIPeriod': 'Période',
	                'indicatorsROC': 'Taux de changement (TC)',
	                'indicatorsROCPeriod': 'Période',
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Période',
	                'indicatorsSMAR': 'Williams %R',
	                'indicatorsSMAPeriod': 'Période',
	                'indicatorsSMASlow': 'Stochastique lente',
	                'indicatorsSMAK': 'Période K%',
	                'indicatorsSMAD': 'Période D%',
	                'indicatorsSMAFast': 'Stochastique rapide',
	                'indicatorsSMAFastK': 'Période K%',
	                'indicatorsSMAFastD': 'Période D%',
	                'indicatorsSMAPrice': 'Canale di prezzo',
	                'indicatorsSMAPriceChannel': 'Canale di prezzo',
	                'indicatorsSMAMA': 'Enveloppe MM',
	                'indicatorsSMAMAPeriod': 'Période',
	                'indicatorsSMAMABand': 'Bande de fréquence',
	                'indicatorsSMAMomentum': 'Momentum',
	                'indicatorsSMAMomentumPeriod': 'Période',
	                'indicatorsSMAULT': 'Oscillateur ultime (ULT)',
	                'indicatorsSMADMI': 'Indice di movimento direzionale (DMI)',
	                'indicatorsSMADMIPeriod': 'Période',
	                'indicatorsSMAMoney': 'Indice des flux monétaires',
	                'indicatorsSMAMoneyPeriod': 'Période',
	                'indicatorsSMAOBV': 'OBV',
	                'indicatorsEMAVol': 'Accumulation de volume',
	                'indicatorsEMADirect': 'Ratio volume hausse/baisse',
	                'indicatorsEMADirectPeriodo': 'Période',
	                'indicatorsEMADirectSmoothing': 'Lissage',
	                'indicatorsEMAVolume': 'Volume par prix',
	                'indicatorsEMAFast': 'Volatilité rapide',
	                'indicatorsEMAWeight': 'Moyenne mobile pondérée',
	                'indicatorsEMAWeightPeriodo': 'Période',
	                'indicatorsEMAAD': 'Accumulation/distribution',
	                'indicatorsEMAMass': 'Indice de masse',
	                'indicatorsEMAVolat': 'Volatilité',
	                'indicatorsEMAVolatPeriod': 'Période',
	                'indicatorsEMAVolatPeriodA': 'Dernière période',
	                'indicatorsEMAForce': 'Indice de force',
	                'indicatorsEMAForcePeriod': 'Période',
	                'indicatorsEMARange': 'Fourchette moyenne véritable',
	                'indicatorsVolumeKeltner': 'Indice de Keltner',
	                'indicatorsVolumeKeltnerEMA': 'Période mme',
	                'indicatorsVolumeKeltnerTimes': 'Facteur',
	                'indicatorsVolumeKeltnerATR': 'Période écart moyen réel',
	                'indicatorsVolumePrevious': 'Cours de clôture de la veille',
	                'performanceGrowthChart': 'Graphique Croissance Performance',
	                'pricesGrowthChart': 'Graphique Croissance du prix',
	                'performanceGrowthChartance': 'Performance…',
	                'update': 'Mettre à jour',
	                'fundamentals': 'Données fondamentales',
	                'priceEarnings': 'Cours/bénéfices',
	                'priceSales': 'Cours/ventes',
	                'priceBook': 'Cours/valeur comptable',
	                'priceCash': 'Cours/encaisse',
	                'fairValue': 'Valeur juste',
	                'rollingDividend': 'Dividende mobile',
	                'dividendYield': 'Rendement de dividende',
	                'rollingEPS': 'BPA mobile',
	                'shortInt': '% ratio posit à découv',
	                'priceEarnings0': 'Discount Cum Fair',
	                'priceEarnings1': 'NAV',
	                'priceEarnings2': 'Premium/Discount',
	                'drawings': 'Dessin',
	                'trendLine': 'Ligne de tendance',
	                'rectangle': 'Rectangle',
	                'ellipse': 'Ellipse',
	                'levelLine': 'Ligne de niveau',
	                'fibonacciRL': 'Niv. de retracements de Fibonacci',
	                'fibonacciFans': 'Fanions de Fibonacci',
	                'fibonacciTZ': 'Fuseaux horaires de Fibonacci',
	                'fibonacciArcs': 'Arcs de Fibonacci',
	                'shortInt': '% ratio posit à découv',
	                'display': 'Affichage',
	                'cursorType': 'Type de curseur',
	                'crosshair': 'Réticule',
	                'trackBall': 'Boule de commande',
	                'off': 'Désactivé',
	                'chartType': 'Style de graphique',
	                'mountain': 'Montagne',
	                'line': 'Ligne',
	                'dot': 'Point',
	                'aboveBelow': 'Au-dessus/au-dessous',
	                'OHLC': 'OECB',
	                'HLC': 'ECB',
	                'candlestick': 'Graphique en chandelier',
	                'growth': 'Croissance',
	                '10KGrowth': 'Croissance de 10K',
	                'priceWithDividendGrowth': 'Prix avec croissance des dividendes',
	                'dividendEffect': 'Effet de dividende',
	                'postTax': 'Poster d\'impôt',
	                'yAxis': 'Axe Y',
	                'left': 'Gauche',
	                'right': 'Droite',
	                'verticalScale': 'échelle verticale',
	                'linear': 'Linéaire',
	                'logarithmic': 'Logarythmique',
	                'selectionMode': 'Mode de sélection',
	                'pan': 'Panoramique',
	                'zoomIn': 'Zoom avant',
	                'reset': 'Réinitialiser',
	                'other': 'Autre',
	                'extendedMarketHour': 'Heures prolongées des marchés',
	                'volumePlus': 'Volume+',
	                'oneMinute': '1 min',
	                'fiveMinute': "5 min",
	                'tenMinute': "10 min",
	                'fifteenMinute': "15 min",
	                'thirtyMinute': "30 min",
	                'sixtyMinute': "60 min",
	                'daily': "Quotidien",
	                'weekly': "Hebdo.",
	                'monthly': "Mensuel",
	                'date': 'Date',
	                'time': 'Temps',
	                'nav': 'NAV',
	                'oneMinuteValueChange': '1 min Changement',
	                'oneMinuteValueChangePercent': '1 min % Changement',
	                'fiveMinuteValueChange': "5 min Changement",
	                'fiveMinuteValueChangePercent': "5 min % Changement",
	                'tenMinuteValueChange': "10 min Changement",
	                'tenMinuteValueChangePercent': "10 min % Changement",
	                'fifteenMinuteValueChange': "15 min Changement",
	                'fifteenMinuteValueChangePercent': "15 min % Changement",
	                'thirtyMinuteValueChange': "30 min Changement",
	                'thirtyMinuteValueChangePercent': "30 min % Changement",
	                'sixtyMinuteValueChange': "60 min Changement",
	                'sixtyMinuteValueChangePercent': "60 min % Changement",
	                'dailyValueChange': "Quotidien Changement",
	                'dailyValueChangePercent': "Quotidien % Changement",
	                'weeklyValueChange': "Hebdo Changement",
	                'weeklyValueChangePercent': "Hebdo % Changement",
	                'monthlyValueChange': "Mensuel Changement",
	                'monthlyValueChangePercent': "Mensuel % Changement",
	                'totalReturn': 'Retour total',
	                'marketValue': 'Valeur marchande',
	                'open': 'Ouverture',
	                'close': 'Fermeture',
	                'low': 'Bas',
	                'high': 'Haut',
	                'volume': 'Volume',
	                'value': 'Valeur',
	                'semiAnnual': 'Semi-annuel',
	                'annual': 'Annuel',
	                'quarterly': 'Trimestriel',
	                'mainGrowthLabel': 'Performance Fondo',
	                'compareGrowthLabel': 'Performance Benchmark',
	                'closeDateLabel': 'Data Chiusura Mercato',
	                'range': 'Fourchette',
	                "datanotavailable": "Aucune donnée n‘est disponible",
	                "mifidRuleMessage": "Ce graphique et les données relatifs seront disponible {0} mois suivant la création du fond.",
	                'changetodailyfrequency': 'Ceci est un point de données par jour. |S\'il vous plaît changer votre fréquence quotidienne',
	                'tenKGrowth': 'Croissance de 10K',
	                'postTax': 'Après taxes',
	                'addComparison': 'Ajouter Comparaison',
	                'changeTicker': 'Changer le Ticker',
	                'searchAssets': 'rechercher des actifs',
	                'crosshairsPopoverNoData': '--',
	                'mainChartHeaderDividendEffectLabel': '(w Div.)',
	                'compareChartsMaxAllowedErrorLabel': 'Le nombre maximum de symboles à comparer est atteint.',
	                'oneDay': '1J',
	                'fiveDay': '5J',
	                'fifteenDay': '15J',
	                'oneMonth': '1M',
	                'threeMonth': '3M',
	                'sixMonth': '6M',
	                'YTD': 'AAJ',
	                'oneYear': '1A',
	                'threeYear': '3A',
	                'fiveYear': '5A',
	                'tenYear': '10A',
	                'max': 'MAX',
	                'to': 'à',
	                'frequencys': 'fréquence',
	                'dividendText': 'D',
	                'splitText': 'F',
	                'earningText': 'B',
	                'settings': 'Paramètres',
	                'optionsBtnText': 'Options',
	                'export': 'Exporter',
	                'print': 'Imprimer',
	                'closeBtnText': 'Fermer',
	                'errorsMsg': 'Votre appareil mobile ne peut pas afficher certaines fonctionnalités de cartographie. Connectez-vous à partir d\'une tablette ou d\'un ordinateur pour une meilleure expérience commerciale.',
	                'fundSize': 'Taille du fonds',
	                'price': 'Prix',
	                'shareholdersNumber': "Nombre d'actionnaires",
	                'name': 'Nom',
	                'PE': 'Cours/bénéfices',
	                'PS': 'Cours/ventes',
	                'PB': 'Cours/valeur comptable',
	                'PC': 'Cours/encaisse',
	                'FairValue': 'Valeur juste',
	                'DailyCumFairNav': 'NAV',
	                'QuantitativeFairValue': 'Juste valeur',
	                'RDividend': 'Dividende mobile',
	                'DYield': 'Rendement de dividende',
	                'REPS': 'BPA mobile',
	                'PremiumDiscount': 'Premium/Discount',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '% ratio posit à découv',
	                'SMA': 'MMA',
	                'EMA': 'MME',
	                'SMAV': 'MMSDV',
	                'BBands': 'BBandes',
	                'PSAR': 'PSAR',
	                'RSI': 'RSI',
	                'ROC': 'TC',
	                'CCI': 'CCI',
	                'WillR': 'Williams %R',
	                'SStochastic': 'Stochastique lente',
	                'FStochastic': 'Stochastique rapide',
	                'PChannel': 'Canale di prezzo',
	                'MAE': 'Enveloppe MM',
	                'Momentum': 'Momentum',
	                'ULT': 'Oscillateur ultime (ULT)',
	                'MFI': 'Indice des flux monétaires',
	                'OBV': 'OBV',
	                'VAcc': 'Accumulation de volume',
	                'UDRatio': 'Ratio volume hausse/baisse',
	                'FVolatility': 'Volatilité rapide',
	                'WMA': 'MMP',
	                'AccDis': 'Accumulation/distribution',
	                'Mass': 'Indice de masse',
	                'Volatility': 'Volatilité',
	                'ForceIndex': 'Indice de force',
	                'ATR': 'Fourchette moyenne véritable',
	                'Keltner': 'Indice de Keltner',
	                'VBP': 'VPP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'précédent fermer',
	                "mutualFund": "Fonds communs de placement",
	                "closedEndFund": "Fonds fermé",
	                "equities": "Actions",
	                "index": "Indice",
	                "eTF": "ETF",
	                "commonStocks": "Stocks communs",
	                "preferredStocks": "Stocks préférés",
	                "aDRs": "ADRs",
	                "options": "Options",
	                "futures": "Futures",
	                "debenture": "Débenture",
	                "governmentBonds": "Obligations d'État",
	                "municipalBonds": "Les obligations municipales",
	                "strategiesSpreads": "Stratégies et écarts",
	                "unspecifiedBonds": "Obligations non spécifiées",
	                "unspecifiedFundsCertificates": "Fonds et certificats non spécifiés",
	                "warrants": "Warrants",
	                "forex": "Forex",
	                "startDate": "Date de début",
	                "earliest": "La plus précoce",
	                "common": "Commune",
	                "mainTicker": "Symbole principal",
	                "startDateIllustrate": "Indiquez la date de base à laquelle la comparaison a été ajoutée"
	            },
	            'fr-CA': {
	                'invalidInputDefault': 'Veuillez entrer une variable positive ou nulle',
	                'invalidInputNpi': 'Veuillez entrer une variable positive',
	                'frequency': 'Fréquence',
	                'dataRange': 'Intervalle de dates',
	                'customDate': 'Date personnalisé',
	                'customStartDate': 'Date de début',
	                'customEndDate': 'Date de fin',
	                'labelSearch': 'Ajouter titre en comparaison',
	                'labelChange': 'Changer le symbole',
	                'eventsIndicators': 'Événements et indicateurs',
	                'events': 'Événements',
	                'eventsDividende': 'Dividende',
	                'eventsSplits': 'Fractionnements',
	                'eventsEarnings': 'Bénéfices',
	                'indicators': 'Indicateurs',
	                'indicatorsSMA': 'Moyenne mobile simple (MMS)',
	                'indicatorsSMAlabel1': 'Période Ligne 1',
	                'indicatorsSMAlabel2': 'Période Ligne 2',
	                'indicatorsSMAlabel3': 'Période Ligne 3',
	                'indicatorsEMA': 'Moyenne mobile exponentielle (MME)',
	                'indicatorsEMAlabel1': 'Période Ligne 1',
	                'indicatorsEMAlabel2': 'Période Ligne 2',
	                'indicatorsEMAlabel3': 'Période Ligne 3',
	                'indicatorsVolume': 'Volume',
	                'indicatorsVolumeSMA': 'Moyenne mobile simple du volume',
	                'indicatorsPeriod': 'Période',
	                'indicatorsBBands': 'Bandes de Bollinger (BandesB)',
	                'indicatorsBBandsPeriod': 'Période',
	                'indicatorsBBandsDeviation': 'Écart-type',
	                'indicatorsPSAR': 'Parabolique SAR (PSAR)',
	                'indicatorsPSARStep': 'Étape de valeur',
	                'indicatorsPSARMaxStep': 'Valeur max de l\'indicateur',
	                'indicatorsMACD': 'MACD',
	                'indicatorsMACDSlow': 'Période lente',
	                'indicatorsMACDFast': 'Période court terme',
	                'indicatorsMACDSignal': 'Période de signal',
	                'indicatorsRSI': 'Indice de force relative (IFR)',
	                'indicatorsRSIPeriod': 'Période',
	                'indicatorsROC': 'Taux de changement (TDC)',
	                'indicatorsROCPeriod': 'Période',
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Période',
	                'indicatorsSMAR': 'Williams %R',
	                'indicatorsSMAPeriod': 'Période',
	                'indicatorsSMASlow': 'Stochastique lent',
	                'indicatorsSMAK': 'Période K%',
	                'indicatorsSMAD': 'Période D%',
	                'indicatorsSMAFast': 'Stochastique rapide',
	                'indicatorsSMAFastK': 'Période K%',
	                'indicatorsSMAFastD': 'Période D%',
	                'indicatorsSMAPrice': 'Canal de tendance',
	                'indicatorsSMAPriceChannel': 'Canal de tendance',
	                'indicatorsSMAMA': 'Enveloppe moyenne mobile',
	                'indicatorsSMAMAPeriod': 'Période',
	                'indicatorsSMAMABand': 'Bande de fréquence',
	                'indicatorsSMAMomentum': 'Momentum',
	                'indicatorsSMAMomentumPeriod': 'Période',
	                'indicatorsSMAULT': 'Oscillateur ultime (ULT)',
	                'indicatorsSMADMI': 'Indice de mouvement directionnel (DMI)',
	                'indicatorsSMADMIPeriod': 'Période',
	                'indicatorsSMAMoney': 'Indice du flux de capital',
	                'indicatorsSMAMoneyPeriod': 'Période',
	                'indicatorsSMAOBV': 'Indicateur OBV',
	                'indicatorsEMAVol': 'Accumulation de volume',
	                'indicatorsEMADirect': 'Ratio hausse/baisse',
	                'indicatorsEMADirectPeriodo': 'Période',
	                'indicatorsEMADirectSmoothing': 'Lissage',
	                'indicatorsEMAVolume': 'Volume par prix',
	                'indicatorsEMAFast': 'Volatilité rapide',
	                'indicatorsEMAWeight': 'Moyenne mobile pondérée',
	                'indicatorsEMAWeightPeriodo': 'Période',
	                'indicatorsEMAAD': 'Accumulation/distribution',
	                'indicatorsEMAMass': 'Indice MASS',
	                'indicatorsEMAVolat': 'Volatilité',
	                'indicatorsEMAVolatPeriod': 'Période',
	                'indicatorsEMAVolatPeriodA': 'Dernière période',
	                'indicatorsEMAForce': 'Indice de force relative',
	                'indicatorsEMAForcePeriod': 'Période',
	                'indicatorsEMARange': 'Fourchette moyenne véritable',
	                'indicatorsVolumeKeltner': 'Indice de Keltner',
	                'indicatorsVolumeKeltnerEMA': 'Période mme',
	                'indicatorsVolumeKeltnerTimes': 'Facteur',
	                'indicatorsVolumeKeltnerATR': 'Période écart moyen réel',
	                'indicatorsVolumePrevious': 'Ligne de fermeture précédente',
	                'performanceGrowthChart': 'Graphique Croissance Performance',
	                'pricesGrowthChart': 'Graphique Croissance du prix',
	                'performanceGrowthChartance': 'Performance…',
	                'update': 'Mettre à jour',
	                'fundamentals': 'Données fondam.',
	                'priceEarnings': 'Cours/bénéfice',
	                'priceSales': 'Cours/ventes',
	                'priceBook': 'Cours/valeur comptable',
	                'priceCash': 'Cours/flux de trésorerie',
	                'fairValue': 'Juste valeur',
	                'rollingDividend': 'Dividendes mobiles',
	                'dividendYield': 'Rendement en dividendes',
	                'rollingEPS': 'BPA mobile',
	                'shortInt': '% Position à découvert',
	                'priceEarnings0': 'Discount Cum Fair',
	                'priceEarnings1': 'NAV',
	                'priceEarnings2': 'Premium/Discount',
	                'drawings': 'Dessin',
	                'trendLine': 'Ligne de tendance',
	                'rectangle': 'Rectangle',
	                'ellipse': 'Ellipse',
	                'levelLine': 'Ligne de niveau',
	                'fibonacciRL': 'Niv. de retracements de Fibonacci',
	                'fibonacciFans': 'Fanions de Fibonacci',
	                'fibonacciTZ': 'Fuseaux horaires de Fibonacci',
	                'fibonacciArcs': 'Arcs de Fibonacci',
	                'display': 'Afficher',
	                'cursorType': 'Type de graphique',
	                'crosshair': 'Curseur en croix',
	                'trackBall': 'Boule de commande',
	                'off': 'Désactivé',
	                'chartType': 'Type de graphique',
	                'mountain': 'Graphique en montagne',
	                'line': 'Graphique linéaire',
	                'dot': 'Diagramme de dispersion',
	                'aboveBelow': 'Supérieur/Inférieur',
	                'OHLC': 'OHBF',
	                'HLC': 'ECB',
	                'candlestick': 'Graphique en chandelier',
	                'growth': 'Croissance',
	                '10KGrowth': 'Croissance de 10K',
	                'priceWithDividendGrowth': 'Prix avec croissance des dividendes',
	                'dividendEffect': 'Effet de dividende',
	                'postTax': 'Poster d\'impôt',
	                'yAxis': 'Axe Y',
	                'left': 'Gauche',
	                'right': 'Droite',
	                'verticalScale': 'échelle verticale',
	                'linear': 'Linéaire',
	                'logarithmic': 'Logarithmique',
	                'selectionMode': 'Mode de sélection',
	                'pan': "Vue d'ensemble",
	                'zoomIn': 'Zoom avant',
	                'reset': 'Réinitialiser',
	                'other': 'Autre',
	                'extendedMarketHour': 'Heure d’ouverture prolongée',
	                'volumePlus': 'Volume+',
	                'oneMinute': '1 min',
	                'fiveMinute': "5 min",
	                'tenMinute': "10 min",
	                'fifteenMinute': "15 min",
	                'thirtyMinute': "30 min",
	                'sixtyMinute': "60 min",
	                'daily': "Quotidien",
	                'weekly': "Hebdom.",
	                'monthly': "Mensuel",
	                'date': 'Date',
	                'time': 'Temps',
	                'nav': 'NAV',
	                'oneMinuteValueChange': '1 min Changement',
	                'oneMinuteValueChangePercent': '1 min % Changement',
	                'fiveMinuteValueChange': "5 min Changement",
	                'fiveMinuteValueChangePercent': "5 min % Changement",
	                'tenMinuteValueChange': "10 min Changement",
	                'tenMinuteValueChangePercent': "10 min % Changement",
	                'fifteenMinuteValueChange': "15 min Changement",
	                'fifteenMinuteValueChangePercent': "15 min % Changement",
	                'thirtyMinuteValueChange': "30 min Changement",
	                'thirtyMinuteValueChangePercent': "30 min % Changement",
	                'sixtyMinuteValueChange': "60 min Changement",
	                'sixtyMinuteValueChangePercent': "60 min % Changement",
	                'dailyValueChange': "Quotidien Changement",
	                'dailyValueChangePercent': "Quotidien % Changement",
	                'weeklyValueChange': "Hebdo Changement",
	                'weeklyValueChangePercent': "Hebdo % Changement",
	                'monthlyValueChange': "Mensuel Changement",
	                'monthlyValueChangePercent': "Mensuel % Changement",
	                'totalReturn': 'Retour total',
	                'marketValue': 'Valeur marchande',
	                'open': 'Ouvrir',
	                'close': 'Fermer',
	                'low': 'Faible',
	                'high': 'Élevé ',
	                'volume': 'Volume',
	                'value': 'Valeur',
	                'semiAnnual': 'Semi-annuel',
	                'annual': 'Annuel',
	                'quarterly': 'Trimestriel',
	                'mainGrowthLabel': 'Performance Fondo',
	                'compareGrowthLabel': 'Performance Benchmark',
	                'closeDateLabel': 'Data Chiusura Mercato',
	                'range': 'Fourchette',
	                "datanotavailable": "Aucune donnée n‘est disponible",
	                'changetodailyfrequency': 'Ceci est un point de données par jour. |S\'il vous plaît changer votre fréquence quotidienne',
	                'tenKGrowth': 'Croissance de 10K',
	                'postTax': 'Après taxes',
	                'addComparison': 'Ajouter Comparer',
	                'changeTicker': 'Changer le Ticker',
	                'searchAssets': 'rechercher des actifs',
	                'crosshairsPopoverNoData': '--',
	                'mainChartHeaderDividendEffectLabel': '(w Div.)',
	                'compareChartsMaxAllowedErrorLabel': 'Le nombre maximum de symboles à comparer est atteint.',
	                'oneDay': '1J',
	                'fiveDay': '5J',
	                'fifteenDay': '15J',
	                'oneMonth': '1M',
	                'threeMonth': '3M',
	                'sixMonth': '6M',
	                'YTD': 'AAJ',
	                'oneYear': '1A',
	                'threeYear': '3A',
	                'fiveYear': '5A',
	                'tenYear': '10A',
	                'max': 'MAX',
	                'to': 'à',
	                'frequencys': 'fréquence',
	                'dividendText': 'D',
	                'splitText': 'F',
	                'earningText': 'B',
	                'settings': 'Paramètres',
	                'optionsBtnText': 'Options',
	                'export': 'Exporter',
	                'print': 'Imprimer',
	                'closeBtnText': 'Fermer',
	                'errorsMsg': 'Votre appareil mobile ne peut pas afficher certaines fonctionnalités de cartographie. Connectez-vous à partir d\'une tablette ou d\'un ordinateur pour une meilleure expérience commerciale.',
	                'fundSize': 'Taille du fonds',
	                'price': 'Prix',
	                'shareholdersNumber': "Nombre d'actionnaires",
	                'name': 'Nom',
	                'PE': 'Cours/bénéfice',
	                'PS': 'Cours/ventes',
	                'PB': 'Cours/valeur comptable',
	                'PC': 'Cours/flux de trésorerie',
	                'FairValue': 'Juste valeur',
	                'DailyCumFairNav': 'NAV',
	                'QuantitativeFairValue': 'Juste Valeur',
	                'RDividend': 'Dividendes mobiles',
	                'DYield': 'Rendement en dividendes',
	                'REPS': 'BPA mobile',
	                'PremiumDiscount': 'Premium/Discount',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '% Position à découvert',
	                'SMA': 'MMS',
	                'EMA': 'MME',
	                'SMAV': 'MMSDV',
	                'BBands': 'Bbandes',
	                'PSAR': 'PSAR',
	                'RSI': 'RSI',
	                'ROC': 'TDC',
	                'CCI': 'CCI',
	                'WillR': 'Williams %R',
	                'SStochastic': 'Stochastique lent',
	                'FStochastic': 'Stochastique rapide',
	                'PChannel': 'Canal de tendance',
	                'MAE': 'Enveloppe moyenne mobile',
	                'Momentum': 'Momentum',
	                'ULT': 'Oscillateur ultime (ULT)',
	                'MFI': 'Indice du flux de capital',
	                'OBV': 'Indicateur OBV',
	                'VAcc': 'Accumulation de volume',
	                'UDRatio': 'Ratio hausse/baisse',
	                'FVolatility': 'Volatilité rapide',
	                'WMA': 'MMP',
	                'AccDis': 'Accumulation/distribution',
	                'Mass': 'Indice MASS',
	                'Volatility': 'Volatilité',
	                'ForceIndex': 'Indice de force relative',
	                'ATR': 'Fourchette moyenne véritable',
	                'Keltner': 'Indice de Keltner',
	                'VBP': 'VPP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'précédent fermer',
	                "mutualFund": "Fonds communs de placement",
	                "closedEndFund": "Fonds fermé",
	                "equities": "Actions",
	                "index": "Indice",
	                "eTF": "ETF",
	                "commonStocks": "Stocks communs",
	                "preferredStocks": "Stocks préférés",
	                "aDRs": "ADRs",
	                "options": "Options",
	                "futures": "Futures",
	                "debenture": "Débenture",
	                "governmentBonds": "Obligations d'État",
	                "municipalBonds": "Les obligations municipales",
	                "strategiesSpreads": "Stratégies et écarts",
	                "unspecifiedBonds": "Obligations non spécifiées",
	                "unspecifiedFundsCertificates": "Fonds et certificats non spécifiés",
	                "warrants": "Warrants",
	                "forex": "Forex",
	                "startDate": "Date de début",
	                "earliest": "La plus précoce",
	                "common": "Commune",
	                "mainTicker": "Symbole principal",
	                "startDateIllustrate": "Indiquez la date de base à laquelle la comparaison a été ajoutée",
	                "mifidRuleMessage": "Ce graphique et les données relatifs seront disponible {0} mois suivant la création du fond.",
	            },
	            'it': {
	                'invalidInputDefault': "Per favore inserisce un numero intero o nulla",
	                'invalidInputNpi': "Per favore inserisce un numero intero",
	                'frequency': "Frequenza",
	                'dataRange': "Intervallo",
	                'customDate': "Periodo personalizzato",
	                'customStartDate': "Inizio",
	                'customEndDate': "Fine",
	                'labelSearch': "Aggiungi titolo per confronto",
	                'labelChange': 'Changer le ticker principal',
	                'eventsIndicators': "Eventi e Indicatori",
	                'events': "Eventi",
	                'eventsDividende': "Dividendi",
	                'eventsSplits': "Operazioni Capitale",
	                'eventsEarnings': "Utili",
	                'indicators': "Indicatori",
	                'indicatorsSMA': "Media mobile semplice",
	                'indicatorsSMAlabel1': "Periodo linea 1",
	                'indicatorsSMAlabel2': "Periodo linea 2",
	                'indicatorsSMAlabel3': "Periodo linea 3",
	                'indicatorsEMA': "Media mobile esponenziale (MME)",
	                'indicatorsEMAlabel1': "Periodo linea 1",
	                'indicatorsEMAlabel2': "Periodo linea 2",
	                'indicatorsEMAlabel3': "Periodo linea 3",
	                'indicatorsVolume': "Volume",
	                'indicatorsVolumeSMA': "Volume MME",
	                'indicatorsPeriod': "Periodo",
	                'indicatorsBBands': "Bande di Bollinger",
	                'indicatorsBBandsPeriod': "Periodo",
	                'indicatorsBBandsDeviation': "Deviazione",
	                'indicatorsPSAR': "Parabolic SAR",
	                'indicatorsPSARStep': "Step Period",
	                'indicatorsPSARMaxStep': "Max Step Period",
	                'indicatorsMACD': "MACD",
	                'indicatorsMACDSlow': "Periodo lento",
	                'indicatorsMACDFast': "Periodo veloce",
	                'indicatorsMACDSignal': "Periodo MME",
	                'indicatorsRSI': "Indicatore di forza relativa (RSI)",
	                'indicatorsRSIPeriod': "Periodo",
	                'indicatorsROC': "Rate of Change (ROC)",
	                'indicatorsROCPeriod': "Periodo",
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Periodo',
	                'indicatorsSMAR': "Williams %R",
	                'indicatorsSMAPeriod': "Periodo",
	                'indicatorsSMASlow': "Stocastico lento",
	                'indicatorsSMAK': "Periodo K",
	                'indicatorsSMAD': "Periodo D",
	                'indicatorsSMAFast': "Stocastico veloce",
	                'indicatorsSMAFastK': "Periodo K",
	                'indicatorsSMAFastD': "Periodo D",
	                'indicatorsSMAPrice': "Canale di prezzo",
	                'indicatorsSMAPriceChannel': "Canale di prezzo",
	                'indicatorsSMAMA': "MA Envelope",
	                'indicatorsSMAMAPeriod': "Periodo",
	                'indicatorsSMAMABand': "Band Width",
	                'indicatorsSMAMomentum': "Momentum",
	                'indicatorsSMAMomentumPeriod': "Periodo",
	                'indicatorsSMAULT': "Ultimate (ULT) Oscillator",
	                'indicatorsSMADMI': "Indice di movimento direzionale (DMI)",
	                'indicatorsSMADMIPeriod': "Periodo",
	                'indicatorsSMAMoney': "Flusso monetario (MF)",
	                'indicatorsSMAMoneyPeriod': "Periodo",
	                'indicatorsSMAOBV': "On Balance Volume",
	                'indicatorsEMAVol': "Volume Accumulation",
	                'indicatorsEMADirect': "Up/Down",
	                'indicatorsEMADirectPeriodo': "Periodo",
	                'indicatorsEMADirectSmoothing': "Smoothing",
	                'indicatorsEMAVolume': "Volume per prezzo",
	                'indicatorsEMAFast': "Fast Volatility",
	                'indicatorsEMAWeight': "Media mobile ponderata",
	                'indicatorsEMAWeightPeriodo': "Periodo",
	                'indicatorsEMAAD': "Accumulazione/Distribuzione",
	                'indicatorsEMAMass': "Mass Index",
	                'indicatorsEMAVolat': "Volatilità",
	                'indicatorsEMAVolatPeriod': "Periodo",
	                'indicatorsEMAVolatPeriodA': "Period Ago",
	                'indicatorsEMAForce': "Force Index",
	                'indicatorsEMAForcePeriod': "Periodo",
	                'indicatorsEMARange': "Average True Range",
	                'indicatorsVolumeKeltner': "Keltner Index",
	                'indicatorsVolumeKeltnerEMA': "Periodo MME",
	                'indicatorsVolumeKeltnerTimes': "Times",
	                'indicatorsVolumeKeltnerATR': "Periodo ATR",
	                'indicatorsVolumePrevious': "Prezzo di chiusura",
	                'performanceGrowthChart': "Performance Fondo e Benchmark",
	                'pricesGrowthChart': "Andamento Valore Quota",
	                'performanceGrowthChartance': "Rendimento…",
	                'update': "Aggiornamento",
	                'fundamentals': "Fondamentali",
	                'priceEarnings': "P/E (Prezzo/Utile)",
	                'priceSales': "P/S (Prezzo/Fatturato)",
	                'priceBook': "P/B (Prezzo/Valore contabile",
	                'priceCash': "P/C (Prezzo/Cash)",
	                'fairValue': "Fair Value",
	                'rollingDividend': "Rolling Dividend",
	                'dividendYield': "Dividend Yield",
	                'rollingEPS': "Rolling EPS",
	                'drawings': "Disegna",
	                'trendLine': "Linea di trend",
	                'rectangle': "Rettangolo",
	                'ellipse': "Ellisse",
	                'levelLine': "Linea di livello",
	                'fibonacciRL': "Ritracciamenti di Fibonacci",
	                'fibonacciFans': "Fan line di Fibonacci",
	                'fibonacciTZ': "Time zone di Fibonacci",
	                'fibonacciArcs': "Archi di Fibonacci",
	                'shortInt': "% Short Int.",
	                'priceEarnings0': "Discount Cum Fair",
	                'priceEarnings1': "NAV",
	                'priceEarnings2': "Premio/Sconto",
	                'display': "Mostra",
	                'cursorType': "Tipo di cursore",
	                'crosshair': "Crosshair",
	                'trackBall': "Track Ball",
	                'off': "Chiudi",
	                'chartType': "Tipo grafico",
	                'mountain': "Montagna",
	                'line': "Lineare",
	                'dot': "Dot",
	                'aboveBelow': "Sopra/Sotto",
	                'OHLC': "Barre (OHLC)",
	                'HLC': "HLC",
	                'candlestick': "Candele",
	                'growth': "Crescita",
	                '10KGrowth': "10K Crescita",
	                'priceWithDividendGrowth': 'Prezzo con crescita dei dividendi',
	                'dividendEffect': "Effetto dividendo",
	                'postTax': "Post Tax",
	                'yAxis': "Asse Y",
	                'left': "Sinistra",
	                'right': "Destra",
	                'verticalScale': "Scala verticale",
	                'linear': "Lineare",
	                'logarithmic': "Logaritmica",
	                'selectionMode': "Modalità di selezione",
	                'pan': "Pannello",
	                'zoomIn': "Ingrandire",
	                'reset': "Reset",
	                'other': "Altro",
	                'extendedMarketHour': "Estendi ore di mercato",
	                'volumePlus': "Volume+",
	                'oneMinute': '1 min',
	                'fiveMinute': "5 min",
	                'tenMinute': "10 min",
	                'fifteenMinute': "15 min",
	                'thirtyMinute': "30 min",
	                'sixtyMinute': "60 min",
	                'daily': "Quotidiano",
	                'weekly': "settimanale",
	                'monthly': "Mensile",
	                'date': "Data",
	                'time': "Ora",
	                'nav': "NAV",
	                'oneMinuteValueChange': '1 min Cambio',
	                'oneMinuteValueChangePercent': '1 min % Cambio',
	                'fiveMinuteValueChange': "5 min Cambio",
	                'fiveMinuteValueChangePercent': "5 min % Cambio",
	                'tenMinuteValueChange': "10 min Cambio",
	                'tenMinuteValueChangePercent': "10 min % Cambio",
	                'fifteenMinuteValueChange': "15 min Cambio",
	                'fifteenMinuteValueChangePercent': "15 min % Cambio",
	                'thirtyMinuteValueChange': "30 min Cambio",
	                'thirtyMinuteValueChangePercent': "30 min % Cambio",
	                'sixtyMinuteValueChange': "60 min Cambio",
	                'sixtyMinuteValueChangePercent': "60 min % Cambio",
	                'dailyValueChange': "Quotidiano Cambio",
	                'dailyValueChangePercent': "Quotidiano % Cambio",
	                'weeklyValueChange': "settimanale Cambio",
	                'weeklyValueChangePercent': "settimanale % Cambio",
	                'monthlyValueChange': "Mensile Cambio",
	                'monthlyValueChangePercent': "Mensile % Cambio",
	                'totalReturn': "Rendimento totale",
	                'marketValue': "Valore di mercato",
	                'open': "Pzo apertura",
	                'close': "Pzo chiusura",
	                'low': "Min",
	                'high': "Max",
	                'volume': "Volume",
	                'value': "Ultimo prezzo",
	                'semiAnnual': "Semiannuale",
	                'annual': "Annuale",
	                'quarterly': "Trimestrale",
	                'mainGrowthLabel': "Performance Fondo",
	                'compareGrowthLabel': "Performance Benchmark",
	                'closeDateLabel': "Data Chiusura Mercato",
	                'range': "Intervallo",
	                'datanotavailable': "Dati non disponibili",
	                "mifidRuleMessage": "Questo grafico e i relativi dati saranno disponibili {0} mesi dopo la data di inizio del fondo",
	                'changetodailyfrequency': "Questo è un dato giornaliero. Modifica la frequenza per una corretta visualizzazione.",
	                'tenKGrowth': "10K Crescita",
	                'postTax': "Post Tax",
	                'addComparison': "Confronta",
	                'changeTicker': 'Cambio Ticker',
	                'searchAssets': "Cerca titolo",
	                'crosshairsPopoverNoData': "--",
	                'mainChartHeaderDividendEffectLabel': "(w Div.)",
	                'compareChartsMaxAllowedErrorLabel': "Hai raggiunto il massimo numero di Ticker.",
	                'oneDay': "1G",
	                'fiveDay': "5G",
	                'fifteenDay': "15G",
	                'oneMonth': "1M",
	                'threeMonth': "3M",
	                'sixMonth': "6M",
	                'YTD': "YTD",
	                'oneYear': "1A",
	                'threeYear': "3A",
	                'fiveYear': "5A",
	                'tenYear': "10A",
	                'max': "Max",
	                'to': "a",
	                'frequencys': "frequenza",
	                'dividendText': "D",
	                'splitText': "S",
	                'earningText': "U",
	                'settings': "Impostazioni",
	                'optionsBtnText': "Opzioni",
	                'export': "Esporta",
	                'print': "stampa",
	                'closeBtnText': "Chiudi",
	                'errorsMsg': "Il dispositivo non è in grado di visualizzare alcune caratteristiche del grafico. Collegati da un different dispositivo o un computer per una migliore esperienza di trading.",
	                'fundSize': 'dimensioni del fondo',
	                'price': 'Prezzo',
	                'shareholdersNumber': 'Numero di azionisti',
	                'name': 'Nome',
	                'PE': 'P/E (Prezzo/Utile)',
	                'PS': 'P/S (Prezzo/Fatturato)',
	                'PB': 'P/B (Prezzo/Valore contabile',
	                'PC': 'P/C (Prezzo/Cash)',
	                'FairValue': 'Fair Value',
	                'DailyCumFairNav': 'NAV',
	                'QuantitativeFairValue': 'Fair Value',
	                'RDividend': 'Rolling Dividend',
	                'DYield': 'Dividend Yield',
	                'REPS': 'Rolling EPS',
	                'PremiumDiscount': 'Premio/Sconto',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '% Short Int.',
	                'SMA': 'MMS',
	                'EMA': 'MME',
	                'SMAV': 'Volume MME',
	                'BBands': 'Bande di Bollinger',
	                'PSAR': 'Parabolic SAR',
	                'RSI': 'RSI',
	                'ROC': 'ROC',
	                'CCI': 'CCI',
	                'WillR': 'Williams %R',
	                'SStochastic': 'Stocastico lento',
	                'FStochastic': 'Stocastico veloce',
	                'PChannel': 'Canale di prezzo',
	                'MAE': 'MA Envelope',
	                'Momentum': 'Momentum',
	                'ULT': 'Ultimate (ULT) Oscillator',
	                'MFI': 'Flusso monetario (MF)',
	                'OBV': 'On Balance Volume',
	                'VAcc': 'Volume Accumulation',
	                'UDRatio': 'Up/Down',
	                'FVolatility': 'Fast Volatility',
	                'WMA': 'WMP',
	                'AccDis': 'Accumulazione/Distribuzione',
	                'Mass': 'Mass Index',
	                'Volatility': 'Volatilità',
	                'ForceIndex': 'Force Index',
	                'ATR': 'Average True Range',
	                'Keltner': 'Keltner Index',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'chiusura precedente',
	                "mutualFund": "Fondo comune",
	                "closedEndFund": "Fondo chiuso",
	                "equities": "Indice",
	                "index": "Index",
	                "eTF": "ETF",
	                "commonStocks": "Azioni comuni",
	                "preferredStocks": "Azioni preferite",
	                "aDRs": "ADRs",
	                "options": "Opzioni",
	                "futures": "Futures",
	                "debenture": "obbligazione",
	                "governmentBonds": "Obbligazioni statali",
	                "municipalBonds": "Obbligazioni municipali",
	                "strategiesSpreads": "Strategie e diffusioni",
	                "unspecifiedBonds": "Obbligazioni non specificate",
	                "unspecifiedFundsCertificates": "Fondi e certificati non specificati",
	                "warrants": "Warrants",
	                "forex": "Forex",
	                "startDate": "Start Date",
	                "earliest": "Earliest",
	                "common": "Common",
	                "mainTicker": "Main Ticker",
	                "startDateIllustrate": "Indicate the base date when comparison added"
	            },
	            'es': {
	                'invalidInputDefault': "Por favor, introduzca un número positivo o nada",
	                'invalidInputNpi': "Por favor, introduzca un número positivo",
	                'frequency': "Frecuencia",
	                'dataRange': "Rango de fechas",
	                'customDate': "Fecha personalizada",
	                'customStartDate': "Fecha de inicio",
	                'customEndDate': "Fecha final",
	                'labelSearch': "Añada activos a comparar",
	                'labelChange': 'Cambiar el ticker principal',
	                'eventsIndicators': "Eventos e indicadores",
	                'events': "Eventos",
	                'eventsDividende': "Dividendos",
	                'eventsSplits': "Splits",
	                'eventsEarnings': "Ganancias",
	                'indicators': "Indicadores",
	                'indicatorsSMA': "Media Móvil Simple (SMA)",
	                'indicatorsSMAlabel1': "Periodo Línea1",
	                'indicatorsSMAlabel2': "Periodo Línea2",
	                'indicatorsSMAlabel3': "Periodo Línea3",
	                'indicatorsEMA': "Media Móvil Exponencial (EMA)",
	                'indicatorsEMAlabel1': "Periodo Línea1",
	                'indicatorsEMAlabel2': "Periodo Línea2",
	                'indicatorsEMAlabel3': "Periodo Línea3",
	                'indicatorsVolume': "Volumen",
	                'indicatorsVolumeSMA': "Volumen SMA",
	                'indicatorsPeriod': "Periodo",
	                'indicatorsBBands': "Las Bandas de bollinger (BBands)",
	                'indicatorsBBandsPeriod': "Periodo",
	                'indicatorsBBandsDeviation': "Desviación",
	                'indicatorsPSAR': "SAR parabólico (PSAR)",
	                'indicatorsPSARStep': "Step Period",
	                'indicatorsPSARMaxStep': "Step Period Max",
	                'indicatorsMACD': "MACD",
	                'indicatorsMACDSlow': "Periodo lento",
	                'indicatorsMACDFast': "Periodo rápido ",
	                'indicatorsMACDSignal': "Signal Period",
	                'indicatorsRSI': "Relative Strength Index (RSI)",
	                'indicatorsRSIPeriod': "Periodo",
	                'indicatorsROC': "Rate of Change (ROC)",
	                'indicatorsROCPeriod': "Periodo",
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Periodo',
	                'indicatorsSMAR': "Williams %R",
	                'indicatorsSMAPeriod': "Periodo",
	                'indicatorsSMASlow': "Estocástico lento",
	                'indicatorsSMAK': "K% Periodo",
	                'indicatorsSMAD': "D% Periodo",
	                'indicatorsSMAFast': "Estocástico rápido",
	                'indicatorsSMAFastK': "K% Periodo",
	                'indicatorsSMAFastD': "D% Periodo",
	                'indicatorsSMAPrice': "Canal de precios",
	                'indicatorsSMAPriceChannel': "Canal de precios",
	                'indicatorsSMAMA': "MA Envelope",
	                'indicatorsSMAMAPeriod': "Periodo",
	                'indicatorsSMAMABand': "Band Width",
	                'indicatorsSMAMomentum': "Momentum",
	                'indicatorsSMAMomentumPeriod': "Periodo",
	                'indicatorsSMAULT': "Ultimate (ULT) Oscillator",
	                'indicatorsSMADMI': "Índice de movimiento direccional (DMI)",
	                'indicatorsSMADMIPeriod': "Periodo",
	                'indicatorsSMAMoney': "Flujo monetario (MF)",
	                'indicatorsSMAMoneyPeriod': "Periodo",
	                'indicatorsSMAOBV': "On Balance Volume",
	                'indicatorsEMAVol': "Acumulación de volumen",
	                'indicatorsEMADirect': "Ratio Up/Down",
	                'indicatorsEMADirectPeriodo': "Periodo",
	                'indicatorsEMADirectSmoothing': "Smoothing",
	                'indicatorsEMAVolume': "Volumen por precio",
	                'indicatorsEMAFast': "Volatilidad rápida",
	                'indicatorsEMAWeight': "Media móvil ponderada",
	                'indicatorsEMAWeightPeriodo': "Periodo",
	                'indicatorsEMAAD': "Acumulación / Distribución",
	                'indicatorsEMAMass': "Mass Index",
	                'indicatorsEMAVolat': "Volatilidad",
	                'indicatorsEMAVolatPeriod': "Periodo",
	                'indicatorsEMAVolatPeriodA': "Periodo anterior",
	                'indicatorsEMAForce': "Force Index",
	                'indicatorsEMAForcePeriod': "Periodo",
	                'indicatorsEMARange': "Average True Range",
	                'indicatorsVolumeKeltner': "Índice Keltner ",
	                'indicatorsVolumeKeltnerEMA': "Periodo EMA",
	                'indicatorsVolumeKeltnerTimes': "Horarios",
	                'indicatorsVolumeKeltnerATR': "Periodo ATR ",
	                'indicatorsVolumePrevious': "Linea de cierre previo",
	                'performanceGrowthChart': "Gráfico de crecimiento ",
	                'pricesGrowthChart': "Gráfico de precios",
	                'performanceGrowthChartance': "Rentabilidad…",
	                'update': "Actualización",
	                'fundamentals': "Fundamentales",
	                'priceEarnings': "P/Beneficio",
	                'priceSales': "Precio/Ventas",
	                'priceBook': "Precio/Valor contable",
	                'priceCash': "P/CF",
	                'fairValue': "Fair Value",
	                'rollingDividend': "Rolling Dividend",
	                'dividendYield': "Rentabilidad dividendo",
	                'rollingEPS': "Rolling EPS",
	                'drawings': "Dibujos",
	                'trendLine': "Línea de tendencia",
	                'rectangle': "Rectángulo",
	                'ellipse': "Elipse",
	                'levelLine': "Línea nivel",
	                'fibonacciRL': "Fibonacci Retracement Levels",
	                'fibonacciFans': "Fibonacci Fans",
	                'fibonacciTZ': "Fibonacci Time Zones",
	                'fibonacciArcs': "Fibonacci Arcs",
	                'shortInt': "% Short Int.",
	                'priceEarnings0': "Discount Cum Fair",
	                'priceEarnings1': "Valor liquidativo",
	                'priceEarnings2': "Prima/Descuento",
	                'display': "Visualizar",
	                'cursorType': "Tipo de cursor",
	                'crosshair': "Retículo",
	                'trackBall': "Track Ball",
	                'off': "Desactivar",
	                'chartType': "Tipo de gráfico",
	                'mountain': "Montaña",
	                'line': "Línea",
	                'dot': "Punto",
	                'aboveBelow': "Encima/Debajo",
	                'OHLC': "OHLC",
	                'HLC': "HLC",
	                'candlestick': "Velas",
	                'growth': "Crecimiento",
	                '10KGrowth': "Crecimiento 10k",
	                "priceWithDividendGrowth": "Precio con Crecimiento Dividendo",
	                'dividendEffect': "Efecto Dividendo",
	                'postTax': "Post-impuestos",
	                'yAxis': "Eje Y",
	                'left': "Izquierda",
	                'right': "Derecha",
	                'verticalScale': "Escala vertical",
	                'linear': "Lineal",
	                'logarithmic': "Logarítmica",
	                'selectionMode': "Modo de selección",
	                'pan': "Panel",
	                'zoomIn': "Ampliar",
	                'reset': "Resetear",
	                'other': "Otros",
	                'extendedMarketHour': "Horario mercado extandido",
	                'volumePlus': "Volumen+",
	                'oneMinute': "1 min",
	                'fiveMinute': "5 min",
	                'tenMinute': "5 min",
	                'fifteenMinute': "15 min",
	                'thirtyMinute': "30 min",
	                'sixtyMinute': "60 min",
	                'daily': "Diario",
	                'weekly': "Semanal",
	                'monthly': "Mensual",
	                'date': "Fecha",
	                'time': "Hora",
	                'nav': "Valor liquidativo",
	                'oneMinuteValueChange': '1 min Cambio',
	                'oneMinuteValueChangePercent': '1 min % Cambio',
	                'fiveMinuteValueChange': "5 min Cambio",
	                'fiveMinuteValueChangePercent': "5 min % Cambio",
	                'tenMinuteValueChange': "10 min Cambio",
	                'tenMinuteValueChangePercent': "10 min % Cambio",
	                'fifteenMinuteValueChange': "15 min Cambio",
	                'fifteenMinuteValueChangePercent': "15 min % Cambio",
	                'thirtyMinuteValueChange': "30 min Cambio",
	                'thirtyMinuteValueChangePercent': "30 min % Cambio",
	                'sixtyMinuteValueChange': "60 min Cambio",
	                'sixtyMinuteValueChangePercent': "60 min % Cambio",
	                'dailyValueChange': "Diario Cambio",
	                'dailyValueChangePercent': "Diario % Cambio",
	                'weeklyValueChange': "Semanal Cambio",
	                'weeklyValueChangePercent': "Semanal % Cambio",
	                'monthlyValueChange': "Mensual Cambio",
	                'monthlyValueChangePercent': "Mensual % Cambio",
	                'totalReturn': "Rentabilidad total",
	                'marketValue': "Valor mercado",
	                'open': "Precio apertura",
	                'close': "Precio cierre",
	                'low': "Min",
	                'high': "Max",
	                'volume': "Volumen",
	                'value': "Valor mercado",
	                'semiAnnual': "Semianual",
	                'annual': "Anual",
	                'quarterly': "Trimestral",
	                'mainGrowthLabel': "Rendimiento fondo",
	                'compareGrowthLabel': "Rendimiento benchmark",
	                'closeDateLabel': "Fecha cierre mercado",
	                'range': "Rango",
	                'datanotavailable': "Fecha no disponible",
	                "mifidRuleMessage": "Este gráfico y los datos relacionados estarán disponibles {0} meses después de la fecha de inicio del fondo.",
	                'changetodailyfrequency': "Esto es un dato diario. | por favor, cambie su frecuencia a diaria.",
	                'tenKGrowth': "Crecimiento 10k",
	                'postTax': "Post-impuestos",
	                'addComparison': "Añadir comparación",
	                "changeTicker": "Cambiar el ticker",
	                'searchAssets': "Buscar activos",
	                'crosshairsPopoverNoData': "--",
	                'mainChartHeaderDividendEffectLabel': "(w Div.)",
	                'compareChartsMaxAllowedErrorLabel': "Alcanzado el número máximo de tickers comparables",
	                'oneDay': "1D",
	                'fiveDay': "5D",
	                'fifteenDay': "15D",
	                'oneMonth': "1M",
	                'threeMonth': "3M",
	                'sixMonth': "6M",
	                'YTD': "YTD",
	                'oneYear': "1A",
	                'threeYear': "3A",
	                'fiveYear': "5A",
	                'tenYear': "10A",
	                'max': "MAX",
	                'to': "a",
	                'frequencys': "frecuencia",
	                'dividendText': "D",
	                'splitText': "S",
	                'earningText': "E",
	                'settings': "Ajustes",
	                'optionsBtnText': "Opciones",
	                'export': "Exportar",
	                'print': "Impresión",
	                'closeBtnText': "Cerrar",
	                'errorsMsg': "Su dispositivo móvil no puede mostrar ciertas funciones gráficas. Acceda desde una tablet o un pc para mejorar su experiencia de trading",
	                'fundSize': 'tamaño del fondo',
	                'price': 'Precio',
	                'shareholdersNumber': 'Número de accionista',
	                'name': 'Nombre',
	                'PE': 'P/Beneficio',
	                'PS': 'Precio/Ventas',
	                'PB': 'Precio/Valor contable',
	                'PC': 'P/CF',
	                'FairValue': 'Fair Value',
	                'DailyCumFairNav': 'Valor liquidativo',
	                'QuantitativeFairValue': 'Fair Value',
	                'RDividend': 'Rolling Dividend',
	                'DYield': 'Rentabilidad dividendo',
	                'REPS': 'Rolling EPS',
	                'PremiumDiscount': 'Prima/Descuento',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '% Short Int.',
	                'SMA': 'SMA',
	                'EMA': 'EMA',
	                'SMAV': 'SMAV',
	                'BBands': 'BBAnds',
	                'PSAR': 'SAR parabólico (PSAR)',
	                'RSI': 'RSI',
	                'ROC': 'ROC',
	                'CCI': 'CCI',
	                'WillR': 'Williams %R',
	                'SStochastic': 'Estocástico lento',
	                'FStochastic': 'Estocástico rápido',
	                'PChannel': 'Canal de precios',
	                'MAE': 'MA Envelope',
	                'Momentum': 'Momentum',
	                'ULT': 'Ultimate Oscillator (ULT)',
	                'MFI': 'Flujo monetario (MFI)',
	                'OBV': 'On Balance Volume',
	                'VAcc': 'Acumulación de volumen',
	                'UDRatio': 'Ratio UD',
	                'FVolatility': 'Volatilidad rápida',
	                'WMA': 'WMA',
	                'AccDis': 'Acumulación / Distribución',
	                'Mass': 'Mass Index',
	                'Volatility': 'Volatilidad',
	                'ForceIndex': 'ForceIndex',
	                'ATR': 'Average True Range',
	                'Keltner': 'Keltner Index',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'cierre anterior',
	                "mutualFund": "Fondo de inversión",
	                "closedEndFund": "Fondo cerrado",
	                "equities": "Acciones",
	                "index": "Índice",
	                "eTF": "ETF",
	                "commonStocks": "Acciones ordinarias",
	                "preferredStocks": "Acciones preferidas",
	                "aDRs": "ADRs",
	                "options": "Opciones",
	                "futures": "Futuros",
	                "debenture": "Obligación",
	                "governmentBonds": "Bonos del gobierno",
	                "municipalBonds": "Bonos municipales",
	                "strategiesSpreads": "Estrategias y Spreads",
	                "unspecifiedBonds": "Bonos no especificados",
	                "unspecifiedFundsCertificates": "Fondos no especificados y certificados",
	                "warrants": "Warrants",
	                "forex": "Forex",
	                "startDate": "Fecha de inicio",
	                "earliest": "Apertura",
	                "common": "Común",
	                "mainTicker": "Ticker principal",
	                "startDateIllustrate": "Indique la fecha base cuando se agregó la comparación"
	            },
	            'de': {
	                'invalidInputDefault': "Bitte eine positive ganze Zahl eingeben oder leer lassen",
	                'invalidInputNpi': "Bitte eine positive ganze Zahl eingeben",
	                'frequency': "Frequenz",
	                'dataRange': "Datumsbereich",
	                'customDate': "Benutzerdefiniertes Datum",
	                'customStartDate': "Startdatum",
	                'customEndDate': "Enddatum",
	                'labelSearch': "Hinzufügen von Werten zwecks Vergleich",
	                'labelChange': 'Hauptticker wechseln',
	                'eventsIndicators': "Events & Indikatoren",
	                'events': "Events",
	                'eventsDividende': "Dividende",
	                'eventsSplits': "Split",
	                'eventsEarnings': "Gewinn",
	                'indicators': "Indikatoren",
	                'indicatorsSMA': "Einfacher gleitender Mittelwert",
	                'indicatorsSMAlabel1': "Zeitraum Linie 1",
	                'indicatorsSMAlabel2': "Zeitraum Linie 2",
	                'indicatorsSMAlabel3': "Zeitraum Linie 3",
	                'indicatorsEMA': "Exponentieller gleitender Mittelwert",
	                'indicatorsEMAlabel1': "Zeitraum Linie 1",
	                'indicatorsEMAlabel2': "Zeitraum Linie 2",
	                'indicatorsEMAlabel3': "Zeitraum Linie 3",
	                'indicatorsVolume': "Volumen",
	                'indicatorsVolumeSMA': "Volumen SMA",
	                'indicatorsPeriod': "Zeitraum",
	                'indicatorsBBands': "Bollinger Bänder",
	                'indicatorsBBandsPeriod': "Zeitraum",
	                'indicatorsBBandsDeviation': "Abweichung",
	                'indicatorsPSAR': "Parabolic SAR (PSAR)",
	                'indicatorsPSARStep': "Step Period",
	                'indicatorsPSARMaxStep': "Max Step Period",
	                'indicatorsMACD': "MACD",
	                'indicatorsMACDSlow': "Slow Period",
	                'indicatorsMACDFast': "Fast Period",
	                'indicatorsMACDSignal': "Signal Period",
	                'indicatorsRSI': "Relative Stärke Index (RSI)",
	                'indicatorsRSIPeriod': "Zeitraum",
	                'indicatorsROC': "Rate of Change (ROC)",
	                'indicatorsROCPeriod': "Zeitraum",
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Zeitraum',
	                'indicatorsSMAR': "Williams %R",
	                'indicatorsSMAPeriod': "Zeitraum",
	                'indicatorsSMASlow': "Slow Stochastic",
	                'indicatorsSMAK': "K% Zeitraum",
	                'indicatorsSMAD': "D% Zeitraum",
	                'indicatorsSMAFast': "Fast Stochastic",
	                'indicatorsSMAFastK': "K% Zeitraum",
	                'indicatorsSMAFastD': "D% Zeitraum",
	                'indicatorsSMAPrice': "Price Channel",
	                'indicatorsSMAPriceChannel': "Price Channel",
	                'indicatorsSMAMA': "MA Envelope",
	                'indicatorsSMAMAPeriod': "Zeitraum",
	                'indicatorsSMAMABand': "Bandbreite",
	                'indicatorsSMAMomentum': "Momentum",
	                'indicatorsSMAMomentumPeriod': "Zeitraum",
	                'indicatorsSMAULT': "Ultimate (ULT) Oscillator",
	                'indicatorsSMADMI': "Directional Moving Index (DMI)",
	                'indicatorsSMADMIPeriod': "Zeitraum",
	                'indicatorsSMAMoney': "Money Flow Index",
	                'indicatorsSMAMoneyPeriod': "Zeitraum",
	                'indicatorsSMAOBV': "On Balance Volume",
	                'indicatorsEMAVol': "Volume Accumulation",
	                'indicatorsEMADirect': "Up/Down Ratio",
	                'indicatorsEMADirectPeriodo': "Zeitraum",
	                'indicatorsEMADirectSmoothing': "Glättung",
	                'indicatorsEMAVolume': "Volume By Price",
	                'indicatorsEMAFast': "Fast Volatility",
	                'indicatorsEMAWeight': "Gewichteter gleitender Mittelwert",
	                'indicatorsEMAWeightPeriodo': "Zeitraum",
	                'indicatorsEMAAD': "Thesaurierung/Ausschüttung",
	                'indicatorsEMAMass': "Mass Index",
	                'indicatorsEMAVolat': "Volatilität",
	                'indicatorsEMAVolatPeriod': "Zeitraum",
	                'indicatorsEMAVolatPeriodA': "Vorangehender Zeitraum",
	                'indicatorsEMAForce': "Force Index",
	                'indicatorsEMAForcePeriod': "Zeitraum",
	                'indicatorsEMARange': "Average True Range",
	                'indicatorsVolumeKeltner': "Keltner Index",
	                'indicatorsVolumeKeltnerEMA': "EMA Period",
	                'indicatorsVolumeKeltnerTimes': "Times",
	                'indicatorsVolumeKeltnerATR': "ATR Period",
	                'indicatorsVolumePrevious': "Linie Schlusskurs Vortag",
	                'performanceGrowthChart': "Performance Grafik",
	                'pricesGrowthChart': "Kursentwicklungs-Grafik",
	                'performanceGrowthChartance': "Performance…",
	                'update': "Aktualisieren",
	                'fundamentals': "Fundamentals",
	                'priceEarnings': "Kurs/Gewinn",
	                'priceSales': "Kurs/Umsatz",
	                'priceBook': "Kurs/Buchwert",
	                'priceCash': "Kurs/Cashflow",
	                'fairValue': "Fair Value",
	                'rollingDividend': "Rolling Dividend",
	                'dividendYield': "Dividend Yield",
	                'rollingEPS': "Rolling EPS",
	                'drawings': "Drawings",
	                'trendLine': "Trendlinie",
	                'rectangle': "Rechteck",
	                'ellipse': "Ellipse",
	                'levelLine': "Level Line",
	                'fibonacciRL': "Fibonacci Retracement Levels",
	                'fibonacciFans': "Fibonacci Fans",
	                'fibonacciTZ': "Fibonacci Time Zones",
	                'fibonacciArcs': "Fibonacci Arcs",
	                'shortInt': "% Short Int.",
	                'priceEarnings0': "Discount Cum Fair",
	                'priceEarnings1': "NAV",
	                'priceEarnings2': "Premium/Discount",
	                'display': "Darstellung",
	                'cursorType': "Cursor Typ",
	                'crosshair': "Fadenkreuz",
	                'trackBall': "Trackball",
	                'off': "Off",
	                'chartType': "Chart Typ",
	                'mountain': "Mountain",
	                'line': "Linie",
	                'dot': "Punkt",
	                'aboveBelow': "Über/Unter",
	                'OHLC': "OHLC",
	                'HLC': "HLC",
	                'candlestick': "Candlestick",
	                'growth': "Wachstum",
	                '10KGrowth': "10k Wachstum",
	                'priceWithDividendGrowth': 'Preis mit Dividendenwachstum',
	                'dividendEffect': "Dividendeneffekt",
	                'postTax': "Nach Steuern",
	                'yAxis': "Y-Achse",
	                'left': "Links",
	                'verticalScale': "Senkrechte Skala",
	                'linear': "linear",
	                'selectionMode': "Selektionsmodus",
	                'pan': "Pan",
	                'zoomIn': "Zoom in",
	                'reset': "Reset",
	                'other': "Andere",
	                'extendedMarketHour': "Nachbörse",
	                'oneMinute': '1 min',
	                'fiveMinute': "5 min",
	                'tenMinute': "10 min",
	                'fifteenMinute': "15 min",
	                'thirtyMinute': "30 min",
	                'sixtyMinute': "60 min",
	                'daily': "Täglich",
	                'weekly': "wöchentlich",
	                'monthly': "Monatliche",
	                'date': "Datum",
	                'time': "Zeit",
	                'nav': "NAV",
	                'oneMinuteValueChange': '1 min Wechsel',
	                'oneMinuteValueChangePercent': '1 min % Wechsel',
	                'fiveMinuteValueChange': "5 min Wechsel",
	                'fiveMinuteValueChangePercent': "5 min % Wechsel",
	                'tenMinuteValueChange': "10 min Wechsel",
	                'tenMinuteValueChangePercent': "10 min % Wechsel",
	                'fifteenMinuteValueChange': "15 min Wechsel",
	                'fifteenMinuteValueChangePercent': "15 min % Wechsel",
	                'thirtyMinuteValueChange': "30 min Wechsel",
	                'thirtyMinuteValueChangePercent': "30 min % Wechsel",
	                'sixtyMinuteValueChange': "60 min Wechsel",
	                'sixtyMinuteValueChangePercent': "60 min % Wechsel",
	                'dailyValueChange': "Täglich Wechsel",
	                'dailyValueChangePercent': "Täglich % Wechsel",
	                'weeklyValueChange': "wöchentlich Wechsel",
	                'weeklyValueChangePercent': "wöchentlich % Wechsel",
	                'monthlyValueChange': "Monatliche Wechsel",
	                'monthlyValueChangePercent': "Monatliche % Wechsel",
	                'totalReturn': "Gesamtertrag",
	                'marketValue': "Marktwert",
	                'open': "Eröffnungskurs",
	                'close': "Schlusskurs",
	                'low': "Niedrigstkurs",
	                'high': "Höchstkurs",
	                'volume': "Volumen",
	                'value': "Wert",
	                'semiAnnual': "Halbjährlich",
	                'annual': "Jährlich",
	                'quarterly': "Quartalsweise",
	                'mainGrowthLabel': "Fondsperformance",
	                'compareGrowthLabel': "Performance Vergleichsindex",
	                'closeDateLabel': "Data Chiusura Mercato",
	                'range': "Intervall",
	                'datanotavailable': "Daten nicht verfügbar",
	                "mifidRuleMessage": "Diese Grafik und die zugehörigen Daten werden {0} Monate nach Auflegung des Fonds verfügbar sein",
	                'changetodailyfrequency': "Dieser Datenpunkt wird täglich erhoben. Bitte wechseln Sie zu täglicher Frequenz.",
	                'tenKGrowth': "10k Wachstum",
	                'postTax': "Nach Steuern",
	                'addComparison': "Vergleich hinzufügen",
	                "changeTicker": "Ticker wechseln",
	                'searchAssets': "Suche nach Titeln",
	                'crosshairsPopoverNoData': "--",
	                'mainChartHeaderDividendEffectLabel': "(w Div.)",
	                'compareChartsMaxAllowedErrorLabel': "Das Maximum der zu vergleichenden Werte ist erreicht.",
	                'oneDay': "1T",
	                'fiveDay': "5T",
	                'fifteenDay': "15T",
	                'oneMonth': "1M",
	                'threeMonth': "3M",
	                'sixMonth': "6M",
	                'YTD': "YTD",
	                'oneYear': "1J",
	                'threeYear': "3J",
	                'fiveYear': "5J",
	                'tenYear': "10J",
	                'max': "MAX",
	                'to': "zu",
	                'frequencys': "Frequenz",
	                'dividendText': "D",
	                'splitText': "S",
	                'earningText': "G",
	                'settings': "Einstellungen",
	                'optionsBtnText': "Optionen",
	                'export': "Export",
	                'print': "Drucken",
	                'closeBtnText': "Schliessen",
	                'errorsMsg': "Ihr mobiles Gerät kann einige Funktionalitäten im Chart nicht darstellen. Für eine bessere Darstellung wechseln Sie bitte zu einem Tablet oder",
	                'fundSize': 'Fondsvermögen',
	                'price': 'Preis',
	                'shareholdersNumber': 'Número de accionista',
	                'name': 'Name',
	                'PE': 'Kurs/Gewinn',
	                'PS': 'Kurs/Umsatz',
	                'PB': 'Kurs/Buchwert',
	                'PC': 'Kurs/Cashflow',
	                'FairValue': 'Fair Value',
	                'RDividend': 'Rolling Dividend',
	                'DailyCumFairNav': 'NAV',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'QuantitativeFairValue': 'Fair Value',
	                'DYield': 'Dividend Yield',
	                'REPS': 'Rolling EPS',
	                'PremiumDiscount': 'Premium/Discount',
	                'SInterest': '% Short Int.',
	                'SMA': 'EGM',
	                'EMA': 'ETGM',
	                'SMAV': 'SMAV',
	                'BBands': 'Bollinger Bänder',
	                'PSAR': 'PSAR',
	                'RSI': 'RSI',
	                'ROC': 'ROC',
	                'CCI': 'CCI',
	                'WillR': 'WillR',
	                'SStochastic': 'SStochastic',
	                'FStochastic': 'FStochastic',
	                'PChannel': 'PChannel',
	                'MAE': 'MA Envelope',
	                'Momentum': 'Momentum',
	                'ULT': 'Ultimate Oscillator',
	                'MFI': 'MFI',
	                'OBV': 'On Balance Volume',
	                'VAcc': 'Volume Accumulation',
	                'UDRatio': 'UDRatio',
	                'FVolatility': 'Fast Volatility',
	                'WMA': 'GGM',
	                'AccDis': 'Thesaurierung/Ausschüttung',
	                'Mass': 'Mass',
	                'Volatility': 'Volatility',
	                'ForceIndex': 'ForceIndex',
	                'ATR': 'Average True Range',
	                'Keltner': 'Keltner Index',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'vorheriges Schließen',
	                "mutualFund": "Investmentfonds",
	                "closedEndFund": "Geschlossener Fonds",
	                "equities": "Aktien",
	                "index": "Index",
	                "eTF": "ETF",
	                "commonStocks": "Stammaktien",
	                "preferredStocks": "Bevorzugte Aktien",
	                "aDRs": "ADRs",
	                "options": "Optionen",
	                "futures": "Futures",
	                "debenture": "Schuldverschreibung",
	                "governmentBonds": "Staatsanleihen",
	                "municipalBonds": "Kommunalanleihen",
	                "strategiesSpreads": "Strategien & Spreads",
	                "unspecifiedBonds": "Nicht näher bezeichnete Anleihen",
	                "unspecifiedFundsCertificates": "Nicht spezifizierte Fonds und Zertifikate",
	                "warrants": "Warrants",
	                "forex": "Forex",
	                "startDate": "Start Date",
	                "earliest": "Earliest",
	                "common": "Common",
	                "mainTicker": "Main Ticker",
	                "startDateIllustrate": "Indicate the base date when comparison added"
	            },
	            'pt': {
	                "invalidInputDefault": "Por favor, introduza um número positivo ou nada.",
	                "invalidInputNpi": "Por favor, introduza um número negativo ou nada.",
	                "frequency": "Frequência",
	                "dataRange": "Intervalo de datas",
	                "customDate": "Data personalizada",
	                "customStartDate": "Data inicial",
	                "customEndDate": "Data final",
	                "labelSearch": "Adicione ativos para comparar",
	                'labelChange': 'Alterar o ticker principal',
	                "eventsIndicators": "Eventos e indicadores",
	                "events": "Eventos",
	                "eventsDividende": "Dividendo",
	                "eventsSplits": "Splits",
	                "eventsEarnings": "Ganhos",
	                "indicators": "Indicadores",
	                "indicatorsSMA": "Média Móvel Simples (SMA)",
	                "indicatorsSMAlabel1": "Periodo Linha1",
	                "indicatorsSMAlabel2": "Periodo Linha2",
	                "indicatorsSMAlabel3": "Periodo Linha3",
	                "indicatorsEMA": "Média Móvel Exponencial",
	                "indicatorsEMAlabel1": "Periodo Linha1",
	                "indicatorsEMAlabel2": "Periodo Linha2",
	                "indicatorsEMAlabel3": "Periodo Linha3",
	                "indicatorsVolume": "Volume",
	                "indicatorsVolumeSMA": "Volume SMA",
	                "indicatorsPeriod": "Periodo",
	                "indicatorsBBands": "Bandas de Bollinger",
	                "indicatorsBBandsPeriod": "Periodo",
	                "indicatorsBBandsDeviation": "Desvio",
	                "indicatorsPSAR": "Parabolic SAR (PSAR)",
	                "indicatorsPSARStep": "Step Period",
	                "indicatorsPSARMaxStep": "Step Period Max",
	                "indicatorsMACD": "MACD",
	                "indicatorsMACDSlow": "Slow Period",
	                "indicatorsMACDFast": "Fast Period",
	                "indicatorsMACDSignal": "Signal Period",
	                "indicatorsRSI": "Relative Strength Index (RSI)",
	                "indicatorsRSIPeriod": "Período",
	                "indicatorsROC": "Rate of Change (ROC)",
	                "indicatorsROCPeriod": "Período",
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Período',
	                "indicatorsSMAR": "Williams %R",
	                "indicatorsSMAPeriod": "Período",
	                "indicatorsSMASlow": "Slow Stochastic",
	                "indicatorsSMAK": "K% Período",
	                "indicatorsSMAD": "D% Período",
	                "indicatorsSMAFast": "Fast Stochastic",
	                "indicatorsSMAFastK": "K% Período",
	                "indicatorsSMAFastD": "D% Período",
	                "indicatorsSMAPrice": "Price Channel",
	                "indicatorsSMAPriceChannel": "Price Channel",
	                "indicatorsSMAMA": "MA Envelope",
	                "indicatorsSMAMAPeriod": "Período",
	                "indicatorsSMAMABand": "Band Width",
	                "indicatorsSMAMomentum": "Momentum",
	                "indicatorsSMAMomentumPeriod": "Período",
	                "indicatorsSMAULT": "Ultimate (ULT) Oscillator",
	                "indicatorsSMADMI": "Directional Moving Index (DMI)",
	                "indicatorsSMADMIPeriod": "Período",
	                "indicatorsSMAMoney": "Money Flow Index",
	                "indicatorsSMAMoneyPeriod": "Período",
	                "indicatorsSMAOBV": "On Balance Volume",
	                "indicatorsEMAVol": "Volume Accumulation",
	                "indicatorsEMADirect": "Up/Down Ratio",
	                "indicatorsEMADirectPeriodo": "Período",
	                "indicatorsEMADirectSmoothing": "Smoothing",
	                "indicatorsEMAVolume": "Volume por Preço",
	                "indicatorsEMAFast": "Fast Volatility",
	                "indicatorsEMAWeight": "Weighted Moving Average",
	                "indicatorsEMAWeightPeriodo": "Período",
	                "indicatorsEMAAD": "Acumulação / Distribuição",
	                "indicatorsEMAMass": "Mass Index",
	                "indicatorsEMAVolat": "Volatilidade",
	                "indicatorsEMAVolatPeriod": "Período",
	                "indicatorsEMAVolatPeriodA": "Periodo anterior",
	                "indicatorsEMAForce": "Force Index",
	                "indicatorsEMAForcePeriod": "Período",
	                "indicatorsEMARange": "Average True Range",
	                "indicatorsVolumeKeltner": "Keltner Index",
	                "indicatorsVolumeKeltnerEMA": "EMA Period",
	                "indicatorsVolumeKeltnerTimes": "Horários",
	                "indicatorsVolumeKeltnerATR": "ATR Period",
	                "indicatorsVolumePrevious": "Linha de fechamento prévio",
	                "performanceGrowthChart": "Gráfico de Performance",
	                "pricesGrowthChart": "Gráfico de Preços",
	                "performanceGrowthChartance": "Rentabilidade...",
	                "update": "Atualizar",
	                "fundamentals": "Fundamentos",
	                "priceEarnings": "Price/Earnings",
	                "priceSales": "Price/Sales",
	                "priceBook": "Price/Book",
	                "priceCash": "Price/Cash",
	                "fairValue": "Fair Value",
	                "rollingDividend": "Rolling Dividend",
	                "dividendYield": "Dividend Yield",
	                "rollingEPS": "Rolling EPS",
	                "drawings": "Desenhos",
	                "trendLine": "Linha de tendência",
	                "rectangle": "Retângulo",
	                "ellipse": "Elipse",
	                "levelLine": "Linha de nível",
	                "fibonacciRL": "Fibonacci Retracement Levels",
	                "fibonacciFans": "Fibonacci Fans",
	                "fibonacciTZ": "Fibonacci Time Zones",
	                "fibonacciArcs": "Fibonacci Arcs",
	                "shortInt": "% Short Int.",
	                "priceEarnings0": "Discount Cum Fair",
	                "priceEarnings1": "Cota",
	                "priceEarnings2": "Premium/Discount",
	                "display": "Visualizar",
	                "cursorType": "Tipo de cursor",
	                "crosshair": "Crosshair",
	                "trackBall": "Track Ball",
	                "off": "Desativar",
	                "chartType": "Tipo de gráfico",
	                "mountain": "Mountain",
	                "line": "Linha",
	                "dot": "Ponto",
	                "aboveBelow": "Above/Below",
	                "OHLC": "OHLC",
	                "HLC": "HLC",
	                "candlestick": "Candlestick",
	                "growth": "Crescimento",
	                "10KGrowth": "Crescimento 10k",
	                'priceWithDividendGrowth': 'Preço com Crescimento de Dividendos',
	                "dividendEffect": "Efeito de Dividendos",
	                "postTax": "Rentabilidade pós impostos",
	                "yAxis": "Eixo Y",
	                "left": "Esquerda",
	                "right": "Direita",
	                "verticalScale": "Escala vertical",
	                "linear": "Linear",
	                "logarithmic": "Logarítmico",
	                "selectionMode": "Modo de seleção",
	                "pan": "Pan",
	                "zoomIn": "Zoom In",
	                "reset": "Reset",
	                "other": "Outros",
	                "extendedMarketHour": "Horário de Mercado Extendido",
	                "volumePlus": "Volume+",
	                'oneMinute': '1 min',
	                'fiveMinute': "5 min",
	                'tenMinute': "10 min",
	                'fifteenMinute': "15 min",
	                'thirtyMinute': "30 min",
	                'sixtyMinute': "60 min",
	                'daily': "diária",
	                'weekly': "semanal",
	                'monthly': "mensal",
	                "date": "Data",
	                "time": "Hora",
	                "nav": "Cota",
	                'oneMinuteValueChange': '1 min Mudança',
	                'oneMinuteValueChangePercent': '1 min % Mudança',
	                'fiveMinuteValueChange': "5 min Mudança",
	                'fiveMinuteValueChangePercent': "5 min % Mudança",
	                'tenMinuteValueChange': "10 min Mudança",
	                'tenMinuteValueChangePercent': "10 min % Mudança",
	                'fifteenMinuteValueChange': "15 min Mudança",
	                'fifteenMinuteValueChangePercent': "15 min % Mudança",
	                'thirtyMinuteValueChange': "30 min Mudança",
	                'thirtyMinuteValueChangePercent': "30 min % Mudança",
	                'sixtyMinuteValueChange': "60 min Mudança",
	                'sixtyMinuteValueChangePercent': "60 min % Mudança",
	                'dailyValueChange': "diária Mudança",
	                'dailyValueChangePercent': "diária % Mudança",
	                'weeklyValueChange': "semanal Mudança",
	                'weeklyValueChangePercent': "semanal % Mudança",
	                'monthlyValueChange': "mensal Mudança",
	                'monthlyValueChangePercent': "mensal % Mudança",
	                "totalReturn": "Rentabilidade Total",
	                "marketValue": "Valor de mercado",
	                "open": "Abertura",
	                "close": "Fechamento",
	                "low": "Mínima",
	                "high": "Máxima",
	                "volume": "Volume",
	                "value": "Valor de mercado",
	                "semiAnnual": "Semi anual",
	                "annual": "Anual",
	                "quarterly": "Trimestral",
	                "mainGrowthLabel": "Rendimento do fundo",
	                "compareGrowthLabel": "Rendimento do benchmark",
	                "closeDateLabel": "Data fechamento do mercado",
	                "range": "Intervalo",
	                "datanotavailable": "Data não disponível",
	                "mifidRuleMessage": "Este gráfico e os dados relacionados estarão disponíveis {0} meses após a data de início do fundo.",
	                "changetodailyfrequency": "Este é um dado diário. | Por favor mude a frequência para Diário.",
	                "tenKGrowth": "Crescimento 10k",
	                "postTax": "Rentabilidade pós impostos",
	                "addComparison": "Adicionar Comparação",
	                "changeTicker": "Alterar Ticker",
	                "searchAssets": "Procurar ativos",
	                "crosshairsPopoverNoData": "--",
	                "mainChartHeaderDividendEffectLabel": "(w Div.)",
	                "compareChartsMaxAllowedErrorLabel": "Alcançado o número máximo de ativos para comparação",
	                "oneDay": "1D",
	                "fiveDay": "5D",
	                "fifteenDay": "15D",
	                "oneMonth": "1M",
	                "threeMonth": "3M",
	                "sixMonth": "6M",
	                "YTD": "YTD",
	                "oneYear": "1A",
	                "threeYear": "3A",
	                "fiveYear": "5A",
	                "tenYear": "10A",
	                "max": "MAX",
	                "to": "a",
	                "frequencys": "Frequência",
	                "dividendText": "D",
	                "splitText": "S",
	                "earningText": "E",
	                "settings": "Configurações",
	                "optionsBtnText": "Opções",
	                "export": "Exportar",
	                "print": "Impressão",
	                "closeBtnText": "Fechar",
	                "errorsMsg": "Seu dispositivo móvel não pode mostrar alguns gráficos. Conecte-se a um tablet ou computador para uma melhor experiência.",
	                'fundSize': 'Patrimônio Líquido',
	                'price': 'Preço',
	                'shareholdersNumber': 'Número de cotistas',
	                'name': 'Nome',
	                'PE': 'Price/Earnings',
	                'PS': 'Price/Sales',
	                'PB': 'Price/Book',
	                'PC': 'Price/Cash',
	                'FairValue': 'Fair Value',
	                'RDividend': 'Rolling Dividend',
	                'DailyCumFairNav': 'NAV',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'QuantitativeFairValue': 'Fair Value',
	                'DYield': 'Dividend Yield',
	                'REPS': 'Rolling EPS',
	                'PremiumDiscount': 'Premium/Discount',
	                'SInterest': '% Short Int.',
	                'SMA': 'SMA',
	                'EMA': 'MME',
	                'SMAV': 'SMAV',
	                'BBands': 'Bandas de Bollinger',
	                'PSAR': 'PSAR',
	                'RSI': 'RSI',
	                'ROC': 'ROC',
	                'CCI': 'CCI',
	                'WillR': 'WillR',
	                'SStochastic': 'SStochastic',
	                'FStochastic': 'FStochastic',
	                'PChannel': 'PChannel',
	                'MAE': 'MA Envelope',
	                'Momentum': 'Momentum',
	                'ULT': 'Ultimate Oscillator',
	                'MFI': 'MFI',
	                'OBV': 'On Balance Volume',
	                'VAcc': 'Volume Accumulation',
	                'UDRatio': 'UDRatio',
	                'FVolatility': 'Fast Volatility',
	                'WMA': 'WMA',
	                'AccDis': 'Acumulação / Distribuição',
	                'Mass': 'Mass',
	                'Volatility': 'Volatilidade',
	                'ForceIndex': 'ForceIndex',
	                'ATR': 'Average True Range',
	                'Keltner': 'Keltner Index',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'fechamento prévio',
	                "mutualFund": "Fundos de Investimento",
	                "closedEndFund": "Fundos Fechados",
	                "equities": "Equities",
	                "index": "Index",
	                "eTF": "ETF",
	                "commonStocks": "Estoques comuns",
	                "preferredStocks": "Stocks preferenciais",
	                "aDRs": "ADRs",
	                "options": "Opções",
	                "futures": "Futuros",
	                "debenture": "Debênture",
	                "governmentBonds": "Obrigações do governo",
	                "municipalBonds": "Obrigações municipais",
	                "strategiesSpreads": "Estratégias e Spreads",
	                "unspecifiedBonds": "Obrigações não especificadas",
	                "unspecifiedFundsCertificates": "Fundos e certificados não especificados",
	                "warrants": "Warrants",
	                "forex": "Forex",
	                "startDate": "Start Date",
	                "earliest": "Earliest",
	                "common": "Common",
	                "mainTicker": "Main Ticker",
	                "startDateIllustrate": "Indicate the base date when comparison added"
	            },
	            'zh': {
	                "invalidInputDefault": "请输入一个正整数，或不输入。",
	                "invalidInputNpi": "请输入一个正整数。",
	                "frequency": "频率",
	                "dataRange": "日期区间",
	                "customDate": "定制日期",
	                "customStartDate": "开始日期",
	                "customEndDate": "结束日期",
	                "labelSearch": "添加资产比较",
	                'labelChange': '更换资产',
	                "eventsIndicators": "事件和指数",
	                "events": "事件",
	                "eventsDividende": "股息",
	                "eventsSplits": "分割",
	                "eventsEarnings": "收益",
	                "indicators": "指数",
	                "indicatorsSMA": "简单移动平均(SMA)",
	                "indicatorsSMAlabel1": "1线时间范围",
	                "indicatorsSMAlabel2": "2线时间范围",
	                "indicatorsSMAlabel3": "3线时间范围",
	                "indicatorsEMA": "指数移动平均(EMA)",
	                "indicatorsEMAlabel1": "1线时间范围",
	                "indicatorsEMAlabel2": "2线时间范围",
	                "indicatorsEMAlabel3": "3线时间范围",
	                "indicatorsVolume": "交易量",
	                "indicatorsVolumeSMA": "交易量简单移动平均线",
	                "indicatorsPeriod": "时段",
	                "indicatorsBBands": "布林带",
	                "indicatorsBBandsPeriod": "时段",
	                "indicatorsBBandsDeviation": "标准差",
	                "indicatorsPSAR": "抛物线停损转向指标(PSAR)",
	                "indicatorsPSARStep": "Step时段",
	                "indicatorsPSARMaxStep": "Max Step范围",
	                "indicatorsMACD": "MACD",
	                "indicatorsMACDSlow": "慢速时段",
	                "indicatorsMACDFast": "快速时段",
	                "indicatorsMACDSignal": "指标时段",
	                "indicatorsRSI": "相对强弱指数(RSI)",
	                "indicatorsRSIPeriod": "时段",
	                "indicatorsROC": "变动率",
	                "indicatorsROCPeriod": "时段",
	                'indicatorsCCI': '顺势指标(CCI)',
	                'indicatorsCCIPeriod': '时段',
	                "indicatorsSMAR": "Williams %R",
	                "indicatorsSMAPeriod": "时段",
	                "indicatorsSMASlow": "慢速随机指标",
	                "indicatorsSMAK": "K % 时段",
	                "indicatorsSMAD": "D % 时段",
	                "indicatorsSMAFast": "快速随机指标",
	                "indicatorsSMAFastK": "K % 时段",
	                "indicatorsSMAFastD": "D % 时段",
	                "indicatorsSMAPrice": "价格通道",
	                "indicatorsSMAPriceChannel": "价格通道",
	                "indicatorsSMAMA": "移动平均线轨道",
	                "indicatorsSMAMAPeriod": "时段",
	                "indicatorsSMAMABand": "频宽",
	                "indicatorsSMAMomentum": "动量指标",
	                "indicatorsSMAMomentumPeriod": "时段",
	                "indicatorsSMAULT": "终极震荡(ULT)指标",
	                "indicatorsSMADMI": "动向指数(DMI)",
	                "indicatorsSMADMIPeriod": "时段",
	                "indicatorsSMAMoney": "金钱流指标",
	                "indicatorsSMAMoneyPeriod": "时段",
	                "indicatorsSMAOBV": "能量潮指标",
	                "indicatorsEMAVol": "累积交易量",
	                "indicatorsEMADirect": "涨跌比率",
	                "indicatorsEMADirectPeriodo": "时段",
	                "indicatorsEMADirectSmoothing": "平滑法",
	                "indicatorsEMAVolume": "股价成交量分布",
	                "indicatorsEMAFast": "快速波动指标",
	                "indicatorsEMAWeight": "加权移动平均数",
	                "indicatorsEMAWeightPeriodo": "时段",
	                "indicatorsEMAAD": "累积/卖出",
	                "indicatorsEMAMass": "梅斯线",
	                "indicatorsEMAVolat": "波动率",
	                "indicatorsEMAVolatPeriod": "时段",
	                "indicatorsEMAVolatPeriodA": "上期时段",
	                "indicatorsEMAForce": "强力指数",
	                "indicatorsEMAForcePeriod": "时段",
	                "indicatorsEMARange": "高于真正范围",
	                "indicatorsVolumeKeltner": "凯勒Kelter指数",
	                "indicatorsVolumeKeltnerEMA": "EMA 时段",
	                "indicatorsVolumeKeltnerTimes": "时间",
	                "indicatorsVolumeKeltnerATR": "ATR 时段",
	                "indicatorsVolumePrevious": "上次收盘线",
	                "performanceGrowthChart": "业绩增长图",
	                "pricesGrowthChart": "价格增长图",
	                "performanceGrowthChartance": "业绩",
	                "update": "更新",
	                "fundamentals": "基本分析",
	                "priceEarnings": "本益比",
	                "priceSales": "股价营收比",
	                "priceBook": "市帐率",
	                "priceCash": "股价现金比",
	                "fairValue": "公允价值",
	                "rollingDividend": "滚动股息",
	                "dividendYield": "股息率",
	                "rollingEPS": "滚动每股收益",
	                "drawings": "绘图",
	                "trendLine": "趋势线",
	                "rectangle": "方形",
	                "ellipse": "椭圆形",
	                "levelLine": "平行线",
	                "fibonacciRL": "费氏指数",
	                "fibonacciFans": "Fibonacci Fans",
	                "fibonacciTZ": "费氏时间周期",
	                "fibonacciArcs": "费氏弧线",
	                "shortInt": "卖空比率",
	                "priceEarnings0": "Discount Cum Fair",
	                "priceEarnings1": "净资产",
	                "priceEarnings2": "溢价/折价",
	                "display": "显示",
	                "cursorType": "游标类型",
	                "crosshair": "十字",
	                "trackBall": "球状",
	                "off": "关闭",
	                "chartType": "图表类别",
	                "mountain": "山状图",
	                "line": "线状",
	                "dot": "点状图",
	                "aboveBelow": "高于/低于",
	                "OHLC": "OHLC",
	                "HLC": "HLC",
	                "candlestick": "K 线图",
	                "growth": "成长百分比",
	                "10KGrowth": "一万元回报",
	                "priceWithDividendGrowth": "计算股息的价格",
	                "dividendEffect": "股息影响",
	                "postTax": "税后收益",
	                "yAxis": "Y-轴",
	                "left": "左",
	                "right": "右",
	                "verticalScale": "直比例",
	                "linear": "线性",
	                "logarithmic": "对数",
	                "selectionMode": "选择模式",
	                "pan": "Pan",
	                "zoomIn": "放大",
	                "reset": "重设",
	                "other": "其他",
	                "extendedMarketHour": "扩展的市场时间",
	                "volumePlus": "交易量+",
	                'oneMinute': '1 分钟',
	                'fiveMinute': "5 分钟",
	                'tenMinute': "10 分钟",
	                'fifteenMinute': "15 分钟",
	                'thirtyMinute': "30 分钟",
	                'sixtyMinute': "60 分钟",
	                'daily': "每日",
	                'weekly': "每周",
	                'monthly': "每月",
	                "date": "日期",
	                "time": "时间",
	                "nav": "净资产",
	                'oneMinuteValueChange': '1 分钟 涨跌',
	                'oneMinuteValueChangePercent': '1 分钟 % 涨跌幅度',
	                'fiveMinuteValueChange': "5 分钟 涨跌",
	                'fiveMinuteValueChangePercent': "5 分钟 % 涨跌幅度",
	                'tenMinuteValueChange': "10 分钟 涨跌",
	                'tenMinuteValueChangePercent': "10 分钟 % 涨跌幅度",
	                'fifteenMinuteValueChange': "15 分钟 涨跌",
	                'fifteenMinuteValueChangePercent': "15 分钟 % 涨跌幅度",
	                'thirtyMinuteValueChange': "30 分钟 涨跌",
	                'thirtyMinuteValueChangePercent': "30 分钟 % 涨跌幅度",
	                'sixtyMinuteValueChange': "60 分钟 涨跌",
	                'sixtyMinuteValueChangePercent': "60 分钟 % 涨跌幅度",
	                'dailyValueChange': "每日 涨跌",
	                'dailyValueChangePercent': "每日 % 涨跌幅度",
	                'weeklyValueChange': "每周 涨跌",
	                'weeklyValueChangePercent': "每周 % 涨跌幅度",
	                'monthlyValueChange': "每月 涨跌",
	                'monthlyValueChangePercent': "每月 % 涨跌幅度",
	                "totalReturn": "总收益",
	                "marketValue": "市场价值",
	                "open": "开盘",
	                "close": "收盘",
	                "low": "低",
	                "high": "高",
	                "volume": "交易量",
	                "value": "价值",
	                "semiAnnual": "半年",
	                "annual": "年度",
	                "quarterly": "季度",
	                "mainGrowthLabel": "基金业绩",
	                "compareGrowthLabel": "业绩基准",
	                "closeDateLabel": "市场结束日期",
	                "range": "范围",
	                "datanotavailable": "资料不可用。",
	                "mifidRuleMessage": "该图表和相关数据将在基金成立之日起{0}个月后提供",
	                "changetodailyfrequency": "这是一个每日数据点。请将频率改成每日。",
	                "tenKGrowth": "一万元回报",
	                "postTax": "税后收益",
	                "addComparison": "添加比较",
	                "changeTicker": "'更换",
	                "searchAssets": "搜索资产",
	                "crosshairsPopoverNoData": "--",
	                "mainChartHeaderDividendEffectLabel": "（有红利）",
	                "compareChartsMaxAllowedErrorLabel": "已达到最多比较添加。",
	                "oneDay": "1天",
	                "fiveDay": "5天",
	                "fifteenDay": "15天",
	                "oneMonth": "1个月",
	                "threeMonth": "3个月",
	                "sixMonth": "6个月",
	                "YTD": "今年",
	                "oneYear": "1年",
	                "threeYear": "3年",
	                "fiveYear": "5年",
	                "tenYear": "10年",
	                "max": "最大",
	                "to": "到",
	                "frequencys": "频率",
	                "dividendText": "D",
	                "splitText": "S",
	                "earningText": "E",
	                "settings": "设定",
	                "optionsBtnText": "选项",
	                "export": "导出",
	                "print": "打印",
	                "closeBtnText": "关闭",
	                "errorsMsg": "您的移动设备不能显示某些图表信息。请从平板或电脑登录，以获得更佳交易体验。",
	                'fundSize': '基金规模',
	                'price': '价格',
	                'shareholdersNumber': '股东人数',
	                'name': '名字',
	                'PE': '本益比',
	                'PS': '股价营收比',
	                'PB': '市帐率',
	                'PC': '股价现金比',
	                'FairValue': 'Fair Value',
	                'RDividend': '滚动股息',
	                'DYield': '股息率',
	                'REPS': '滚动每股收益',
	                'PremiumDiscount': '溢价/折价',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '卖空比率',
	                'SMA': 'SMA',
	                'EMA': 'EMA',
	                'SMAV': 'SMAV',
	                'BBands': 'BBands',
	                'PSAR': 'PSAR',
	                'RSI': '相对强弱指数(RSI)',
	                'ROC': '变动率',
	                'CCI': 'CCI',
	                'WillR': 'WillR',
	                'SStochastic': '慢速随机指标',
	                'FStochastic': '快速随机指标',
	                'PChannel': '价格通道',
	                'MAE': '移动平均线轨道',
	                'Momentum': '动量指标',
	                'ULT': '终极震荡(ULT)指标',
	                'MFI': '金钱流指标',
	                'OBV': '能量潮指标',
	                'VAcc': '累积交易量',
	                'UDRatio': '涨跌比率',
	                'FVolatility': '快速波动指标',
	                'WMA': '加权移动平均数',
	                'AccDis': '累积/卖出',
	                'Mass': '梅斯线',
	                'Volatility': '波动率',
	                'ForceIndex': '强力指数',
	                'ATR': '高于真正范围',
	                'Keltner': 'Kelter指数',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': '昨日收盘',
	                "mutualFund": "共同基金",
	                "closedEndFund": "封闭式基金",
	                "equities": "股票",
	                "index": "指数",
	                "eTF": "交易所基金",
	                "commonStocks": "普通股",
	                "preferredStocks": "优先股",
	                "aDRs": "ADRs",
	                "options": "期权",
	                "futures": "期货",
	                "debenture": "债券",
	                "governmentBonds": "政府债券",
	                "municipalBonds": "市政债券",
	                "strategiesSpreads": "策略与传播",
	                "unspecifiedBonds": "未指定债券",
	                "unspecifiedFundsCertificates": "未指定的资金和证书",
	                "warrants": "认股权证",
	                "forex": "外汇",
	                "startDate": "开始日期",
	                "earliest": "最早",
	                "common": "共同时期",
	                "mainTicker": "主要Ticker",
	                "startDateIllustrate": "当加入比较的Ticker时的开始比较时间"
	            },
	            'zh-TW': {
	                "invalidInputDefault": "請輸入一個正整數，或不輸入。",
	                "invalidInputNpi": "請輸入一個正整數。",
	                "frequency": "頻率",
	                "dataRange": "日期區間",
	                "customDate": "定制日期",
	                "customStartDate": "開始日期",
	                "customEndDate": "結束日期",
	                "labelSearch": "添加資產比較",
	                'labelChange': '更换資產',
	                "eventsIndicators": "事件和指數",
	                "events": "事件",
	                "eventsDividende": "股息",
	                "eventsSplits": "分割",
	                "eventsEarnings": "收益",
	                "indicators": "指數",
	                "indicatorsSMA": "簡單移動平均(SMA)",
	                "indicatorsSMAlabel1": "1線時間範圍",
	                "indicatorsSMAlabel2": "2線時間範圍",
	                "indicatorsSMAlabel3": "3線時間範圍",
	                "indicatorsEMA": "指數移動平均(EMA)",
	                "indicatorsEMAlabel1": "1線時間範圍",
	                "indicatorsEMAlabel2": "2線時間範圍",
	                "indicatorsEMAlabel3": "3線時間範圍",
	                "indicatorsVolume": "交易量",
	                "indicatorsVolumeSMA": "交易量簡單移動平均線",
	                "indicatorsPeriod": "時段",
	                "indicatorsBBands": "布林带",
	                "indicatorsBBandsPeriod": "時段",
	                "indicatorsBBandsDeviation": "標準差",
	                "indicatorsPSAR": "拋物線停損轉向指標(PSAR)",
	                "indicatorsPSARStep": "Step時段",
	                "indicatorsPSARMaxStep": "Max Step範圍",
	                "indicatorsMACD": "MACD",
	                "indicatorsMACDSlow": "慢速時段",
	                "indicatorsMACDFast": "快速時段",
	                "indicatorsMACDSignal": "指標時段",
	                "indicatorsRSI": "相對強弱指數(RSI)",
	                "indicatorsRSIPeriod": "時段",
	                "indicatorsROC": "變動率",
	                "indicatorsROCPeriod": "時段",
	
	                "indicatorsSMAR": "Williams %R",
	                "indicatorsSMAPeriod": "時段",
	                "indicatorsSMASlow": "慢速隨機指標",
	                "indicatorsSMAK": "K % 時段",
	                "indicatorsSMAD": "D % 時段",
	                "indicatorsSMAFast": "快速隨機指標",
	                "indicatorsSMAFastK": "K % 時段",
	                "indicatorsSMAFastD": "D % 時段",
	                "indicatorsSMAPrice": "價格通道",
	                "indicatorsSMAPriceChannel": "價格通道",
	                "indicatorsSMAMA": "移動平均線軌道",
	                "indicatorsSMAMAPeriod": "時段",
	                "indicatorsSMAMABand": "頻寬",
	                "indicatorsSMAMomentum": "動量指標",
	                "indicatorsSMAMomentumPeriod": "時段",
	                "indicatorsSMAULT": "終極震盪(ULT)指標",
	                "indicatorsSMADMI": "動向指數(DMI)",
	                "indicatorsSMADMIPeriod": "時段",
	                "indicatorsSMAMoney": "金錢流指標",
	                "indicatorsSMAMoneyPeriod": "時段",
	                "indicatorsSMAOBV": "能量潮指標",
	                "indicatorsEMAVol": "累積交易量",
	                "indicatorsEMADirect": "漲跌比率",
	                "indicatorsEMADirectPeriodo": "時段",
	                "indicatorsEMADirectSmoothing": "平滑法",
	                "indicatorsEMAVolume": "股價成交量分佈",
	                "indicatorsEMAFast": "快速波動指標",
	                "indicatorsEMAWeight": "加權移動平均數",
	                "indicatorsEMAWeightPeriodo": "時段",
	                "indicatorsEMAAD": "累積/賣出",
	                "indicatorsEMAMass": "梅斯線",
	                "indicatorsEMAVolat": "波動率",
	                "indicatorsEMAVolatPeriod": "時段",
	                "indicatorsEMAVolatPeriodA": "上期時段",
	                "indicatorsEMAForce": "強力指數",
	                "indicatorsEMAForcePeriod": "時段",
	                "indicatorsEMARange": "高於真正範圍",
	                "indicatorsVolumeKeltner": "凱勒Kelter指數",
	                "indicatorsVolumeKeltnerEMA": "EMA 時段",
	                "indicatorsVolumeKeltnerTimes": "時間",
	                "indicatorsVolumeKeltnerATR": "ATR 時段",
	                "indicatorsVolumePrevious": "上次收盤線",
	                "performanceGrowthChart": "業績增長圖",
	                "pricesGrowthChart": "價格增長圖",
	                "performanceGrowthChartance": "業績",
	                "update": "更新",
	                "fundamentals": "基本面",
	                "priceEarnings": "本益比",
	                "priceSales": "股價營收比",
	                "priceBook": "市帳率",
	                "priceCash": "股價現金比",
	                "fairValue": "公允價值",
	                "rollingDividend": "滾動股息",
	                "dividendYield": "股息率",
	                "rollingEPS": "滾動每股收益",
	                "drawings": "繪圖",
	                "trendLine": "趨勢線",
	                "rectangle": "方形",
	                "ellipse": "橢圓形",
	                "levelLine": "平行線",
	                "fibonacciRL": "費氏指數",
	                "fibonacciFans": "Fibonacci Fans",
	                "fibonacciTZ": "費氏時間週期",
	                "fibonacciArcs": "費氏弧線",
	                "shortInt": "賣空比率",
	                "priceEarnings0": "Discount Cum Fair",
	                "priceEarnings1": "淨資產",
	                "priceEarnings2": "溢價/折價",
	                "display": "顯示",
	                "cursorType": "游標類型",
	                "crosshair": "十字",
	                "trackBall": "球狀",
	                "off": "關閉",
	                "chartType": "圖表類別",
	                "mountain": "山狀圖",
	                "line": "線狀",
	                "dot": "點狀圖",
	                "aboveBelow": "高於/低於",
	                "OHLC": "OHLC",
	                "HLC": "HLC",
	                "candlestick": "K 缐圖",
	                "growth": "成長百分比",
	                "10KGrowth": "一萬元回報",
	                "priceWithDividendGrowth": "計算股息增長的價格",
	                "dividendEffect": "股息影響",
	                "postTax": "稅後收益",
	                "yAxis": "Y-軸",
	                "left": "左",
	                "right": "右",
	                "verticalScale": "直比例",
	                "linear": "線性",
	                "logarithmic": "對數",
	                "selectionMode": "選擇模式",
	                "pan": "Pan",
	                "zoomIn": "放大",
	                "reset": "重設",
	                "other": "其他",
	                "extendedMarketHour": "扩展的市场时间",
	                "volumePlus": "交易量+",
	                'oneMinute': '1 分鐘',
	                'fiveMinute': "5 分鐘",
	                'tenMinute': "10 分鐘",
	                'fifteenMinute': "15 分鐘",
	                'thirtyMinute': "30 分鐘",
	                'sixtyMinute': "60 分鐘",
	                'daily': "每日",
	                'weekly': "每週",
	                'monthly': "每月",
	                "date": "日期",
	                "time": "時間",
	                "nav": "淨資產",
	                'oneMinuteValueChange': '1 min 漲跌',
	                'oneMinuteValueChangePercent': '1 min % 漲跌幅度',
	                'fiveMinuteValueChange': "5 min 漲跌",
	                'fiveMinuteValueChangePercent': "5 min % 漲跌幅度",
	                'tenMinuteValueChange': "10 min 漲跌",
	                'tenMinuteValueChangePercent': "10 min % 漲跌幅度",
	                'fifteenMinuteValueChange': "15 min 漲跌",
	                'fifteenMinuteValueChangePercent': "15 min % 漲跌幅度",
	                'thirtyMinuteValueChange': "30 min 漲跌",
	                'thirtyMinuteValueChangePercent': "30 min % 漲跌幅度",
	                'sixtyMinuteValueChange': "60 min 漲跌",
	                'sixtyMinuteValueChangePercent': "60 min % 漲跌幅度",
	                'dailyValueChange': "每日 漲跌",
	                'dailyValueChangePercent': "每日 % 漲跌幅度",
	                'weeklyValueChange': "每週 漲跌",
	                'weeklyValueChangePercent': "每週 % 漲跌幅度",
	                'monthlyValueChange': "每月 漲跌",
	                'monthlyValueChangePercent': "每月 % 漲跌幅度",
	                "totalReturn": "总收益",
	                "marketValue": "市场价值",
	                "open": "開盤",
	                "close": "關盤",
	                "low": "低",
	                "high": "高",
	                "volume": "交易量",
	                "value": "價值",
	                "semiAnnual": "半年",
	                "annual": "年度",
	                "quarterly": "季度",
	                "mainGrowthLabel": "基金業績",
	                "compareGrowthLabel": "業績基準",
	                "closeDateLabel": "市場結束日期",
	                "range": "範圍",
	                "datanotavailable": "資料不可用。",
	                "mifidRuleMessage": "該圖表和相關數據將在基金成立之日起{0}個月後提供",
	                "changetodailyfrequency": "這是一個每日資料點。 請將頻率改成每日。",
	                "tenKGrowth": "一萬元回報",
	                "postTax": "稅後收益",
	                "addComparison": "添加比較",
	                "changeTicker": "'更换",
	                "searchAssets": "搜索資產",
	                "crosshairsPopoverNoData": "--",
	                "mainChartHeaderDividendEffectLabel": "（有紅利）",
	                "compareChartsMaxAllowedErrorLabel": "已達到最多比較添加。",
	                "oneDay": "1 天",
	                "fiveDay": "5 天",
	                "fifteenDay": "15 天",
	                "oneMonth": "1 個月",
	                "threeMonth": "3 個月",
	                "sixMonth": "6 個月",
	                "YTD": "今年",
	                "oneYear": "1 年",
	                "threeYear": "3 年",
	                "fiveYear": "5 年",
	                "tenYear": "10 年",
	                "max": "最大",
	                "to": "到",
	                "frequencys": "頻率",
	                "dividendText": "D",
	                "splitText": "S",
	                "earningText": "E",
	                "settings": "設定",
	                "optionsBtnText": "選項",
	                "export": "匯出",
	                "print": "打印",
	                "closeBtnText": "關閉",
	                "errorsMsg": "您的行動裝置不能顯示某些圖表資訊。 請從平板或電腦登錄，以獲得更佳交易體驗。",
	                'fundSize': '基金規模',
	                'price': '价格',
	                'shareholdersNumber': '股東人數',
	                'name': '名稱',
	                'PE': '本益比',
	                'PS': '股價營收比',
	                'PB': '市帳率',
	                'PC': '股價現金比',
	                'FairValue': 'Fair Value',
	                'RDividend': '滾動股息',
	                'DYield': '股息率',
	                'REPS': '滾動每股收益',
	                'PremiumDiscount': '溢價/折價',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '賣空比率',
	                'SMA': 'SMA',
	                'EMA': 'EMA',
	                'SMAV': 'SMAV',
	                'BBands': '布林带',
	                'PSAR': 'PSAR',
	                'RSI': '相對強弱指數(RSI)',
	                'ROC': '變動率',
	                'CCI': 'CCI',
	                'WillR': 'WillR',
	                'SStochastic': '慢速隨機指標',
	                'FStochastic': '快速隨機指標',
	                'PChannel': '價格通道',
	                'MAE': '移動平均線軌道',
	                'Momentum': '動量指標',
	                'ULT': '終極震盪(ULT)指標',
	                'MFI': '金錢流指標',
	                'OBV': '能量潮指標',
	                'VAcc': '累積交易量',
	                'UDRatio': '漲跌比率',
	                'FVolatility': '快速波動指標',
	                'WMA': '加權移動平均數',
	                'AccDis': '累積/賣出',
	                'Mass': '梅斯線',
	                'Volatility': '波動率',
	                'ForceIndex': '強力指數',
	                'ATR': '高於真正範圍',
	                'Keltner': 'Keltner指數',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': '昨日收盤',
	                "mutualFund": "共同基金",
	                "closedEndFund": "封閉式基金",
	                "equities": "股票",
	                "index": "指數",
	                "eTF": "交易所交易基金",
	                "commonStocks": "普通股",
	                "preferredStocks": "優先股",
	                "aDRs": "ADRs",
	                "options": "期權",
	                "futures": "期貨",
	                "debenture": "債券",
	                "governmentBonds": "政府債券",
	                "municipalBonds": "市政債券",
	                "strategiesSpreads": "策略與傳播",
	                "unspecifiedBonds": "未指定債券",
	                "unspecifiedFundsCertificates": "未指定的資金和證書",
	                "warrants": "認股權證",
	                "forex": "外匯",
	                "startDate": "开始日期",
	                "earliest": "最早",
	                "common": "共同時期",
	                "mainTicker": "主要Ticker",
	                "startDateIllustrate": "加入比較ticker時比較的開始時間"
	            },
	            'zh-HK': {
	                "invalidInputDefault": "請輸入一個正整數，或不輸入。",
	                "invalidInputNpi": "請輸入一個正整數。",
	                "frequency": "頻率",
	                "dataRange": "日期區間",
	                "customDate": "定制日期",
	                "customStartDate": "開始日期",
	                "customEndDate": "結束日期",
	                "labelSearch": "添加資產比較",
	                'labelChange': '更换資產',
	                "eventsIndicators": "事件和指數",
	                "events": "事件",
	                "eventsDividende": "股息",
	                "eventsSplits": "分割",
	                "eventsEarnings": "收益",
	                "indicators": "指數",
	                "indicatorsSMA": "簡單移動平均(SMA)",
	                "indicatorsSMAlabel1": "1線時間範圍",
	                "indicatorsSMAlabel2": "2線時間範圍",
	                "indicatorsSMAlabel3": "3線時間範圍",
	                "indicatorsEMA": "指數移動平均(EMA)",
	                "indicatorsEMAlabel1": "1線時間範圍",
	                "indicatorsEMAlabel2": "2線時間範圍",
	                "indicatorsEMAlabel3": "3線時間範圍",
	                "indicatorsVolume": "交易量",
	                "indicatorsVolumeSMA": "交易量簡單移動平均線",
	                "indicatorsPeriod": "時段",
	                "indicatorsBBands": "布林带",
	                "indicatorsBBandsPeriod": "時段",
	                "indicatorsBBandsDeviation": "標準差",
	                "indicatorsPSAR": "拋物線停損轉向指標(PSAR)",
	                "indicatorsPSARStep": "Step時段",
	                "indicatorsPSARMaxStep": "Max Step範圍",
	                "indicatorsMACD": "MACD",
	                "indicatorsMACDSlow": "慢速時段",
	                "indicatorsMACDFast": "快速時段",
	                "indicatorsMACDSignal": "指標時段",
	                "indicatorsRSI": "相對強弱指數(RSI)",
	                "indicatorsRSIPeriod": "時段",
	                "indicatorsROC": "變動率",
	                "indicatorsROCPeriod": "時段",
	                'indicatorsCCI': '順勢指標(CCI)',
	                'indicatorsCCIPeriod': '時段',
	                "indicatorsSMAR": "Williams %R",
	                "indicatorsSMAPeriod": "時段",
	                "indicatorsSMASlow": "慢速隨機指標",
	                "indicatorsSMAK": "K % 時段",
	                "indicatorsSMAD": "D % 時段",
	                "indicatorsSMAFast": "快速隨機指標",
	                "indicatorsSMAFastK": "K % 時段",
	                "indicatorsSMAFastD": "D % 時段",
	                "indicatorsSMAPrice": "價格通道",
	                "indicatorsSMAPriceChannel": "價格通道",
	                "indicatorsSMAMA": "移動平均線軌道",
	                "indicatorsSMAMAPeriod": "時段",
	                "indicatorsSMAMABand": "頻寬",
	                "indicatorsSMAMomentum": "動量指標",
	                "indicatorsSMAMomentumPeriod": "時段",
	                "indicatorsSMAULT": "終極震盪(ULT)指標",
	                "indicatorsSMADMI": "動向指數(DMI)",
	                "indicatorsSMADMIPeriod": "時段",
	                "indicatorsSMAMoney": "金錢流指標",
	                "indicatorsSMAMoneyPeriod": "時段",
	                "indicatorsSMAOBV": "能量潮指標",
	                "indicatorsEMAVol": "累積交易量",
	                "indicatorsEMADirect": "漲跌比率",
	                "indicatorsEMADirectPeriodo": "時段",
	                "indicatorsEMADirectSmoothing": "平滑法",
	                "indicatorsEMAVolume": "股價成交量分佈",
	                "indicatorsEMAFast": "快速波動指標",
	                "indicatorsEMAWeight": "加權移動平均數",
	                "indicatorsEMAWeightPeriodo": "時段",
	                "indicatorsEMAAD": "累積/賣出",
	                "indicatorsEMAMass": "梅斯線",
	                "indicatorsEMAVolat": "波動率",
	                "indicatorsEMAVolatPeriod": "時段",
	                "indicatorsEMAVolatPeriodA": "上期時段",
	                "indicatorsEMAForce": "強力指數",
	                "indicatorsEMAForcePeriod": "時段",
	                "indicatorsEMARange": "高於真正範圍",
	                "indicatorsVolumeKeltner": "凱勒Kelter指數",
	                "indicatorsVolumeKeltnerEMA": "EMA 時段",
	                "indicatorsVolumeKeltnerTimes": "時間",
	                "indicatorsVolumeKeltnerATR": "ATR 時段",
	                "indicatorsVolumePrevious": "上次收盤線",
	                "performanceGrowthChart": "業績增長圖",
	                "pricesGrowthChart": "價格增長圖",
	                "performanceGrowthChartance": "業績",
	                "update": "更新",
	                "fundamentals": "基本面",
	                "priceEarnings": "本益比",
	                "priceSales": "股價營收比",
	                "priceBook": "市帳率",
	                "priceCash": "股價現金比",
	                "fairValue": "公允價值",
	                "rollingDividend": "滾動股息",
	                "dividendYield": "股息率",
	                "rollingEPS": "滾動每股收益",
	                "drawings": "繪圖",
	                "trendLine": "趨勢線",
	                "rectangle": "方形",
	                "ellipse": "橢圓形",
	                "levelLine": "平行線",
	                "fibonacciRL": "費氏指數",
	                "fibonacciFans": "Fibonacci Fans",
	                "fibonacciTZ": "費氏時間週期",
	                "fibonacciArcs": "費氏弧線",
	                "shortInt": "賣空比率",
	                "priceEarnings0": "Discount Cum Fair",
	                "priceEarnings1": "淨資產",
	                "priceEarnings2": "溢價/折價",
	                "display": "顯示",
	                "cursorType": "游標類型",
	                "crosshair": "十字",
	                "trackBall": "球狀",
	                "off": "關閉",
	                "chartType": "圖表類別",
	                "mountain": "山狀圖",
	                "line": "線狀",
	                "dot": "點狀圖",
	                "aboveBelow": "高於/低於",
	                "OHLC": "OHLC",
	                "HLC": "HLC",
	                "candlestick": "K 缐圖",
	                "growth": "成長百分比",
	                "10KGrowth": "一萬元回報",
	                "priceWithDividendGrowth": "計算股息增長的價格",
	                "dividendEffect": "股息影響",
	                "postTax": "稅後收益",
	                "yAxis": "Y-軸",
	                "left": "左",
	                "right": "右",
	                "verticalScale": "直比例",
	                "linear": "線性",
	                "logarithmic": "對數",
	                "selectionMode": "選擇模式",
	                "pan": "Pan",
	                "zoomIn": "放大",
	                "reset": "重設",
	                "other": "其他",
	                "extendedMarketHour": "扩展的市场时间",
	                "volumePlus": "交易量+",
	                'oneMinute': '1 分鐘',
	                'fiveMinute': "5 分鐘",
	                'tenMinute': "10 分鐘",
	                'fifteenMinute': "15 分鐘",
	                'thirtyMinute': "30 分鐘",
	                'sixtyMinute': "60 分鐘",
	                'daily': "每日",
	                'weekly': "每週",
	                'monthly': "每月",
	                "date": "日期",
	                "time": "時間",
	                "nav": "淨資產",
	                'oneMinuteValueChange': '1 min 漲跌',
	                'oneMinuteValueChangePercent': '1 min % 漲跌幅度',
	                'fiveMinuteValueChange': "5 min 漲跌",
	                'fiveMinuteValueChangePercent': "5 min % 漲跌幅度",
	                'tenMinuteValueChange': "10 min 漲跌",
	                'tenMinuteValueChangePercent': "10 min % 漲跌幅度",
	                'fifteenMinuteValueChange': "15 min 漲跌",
	                'fifteenMinuteValueChangePercent': "15 min % 漲跌幅度",
	                'thirtyMinuteValueChange': "30 min 漲跌",
	                'thirtyMinuteValueChangePercent': "30 min % 漲跌幅度",
	                'sixtyMinuteValueChange': "60 min 漲跌",
	                'sixtyMinuteValueChangePercent': "60 min % 漲跌幅度",
	                'dailyValueChange': "每日 漲跌",
	                'dailyValueChangePercent': "每日 % 漲跌幅度",
	                'weeklyValueChange': "每週 漲跌",
	                'weeklyValueChangePercent': "每週 % 漲跌幅度",
	                'monthlyValueChange': "每月 漲跌",
	                'monthlyValueChangePercent': "每月 % 漲跌幅度",
	                "totalReturn": "总收益",
	                "marketValue": "市场价值",
	                "open": "開盤",
	                "close": "關盤",
	                "low": "低",
	                "high": "高",
	                "volume": "交易量",
	                "value": "價值",
	                "semiAnnual": "半年",
	                "annual": "年度",
	                "quarterly": "季度",
	                "mainGrowthLabel": "基金業績",
	                "compareGrowthLabel": "業績基準",
	                "closeDateLabel": "市場結束日期",
	                "range": "範圍",
	                "datanotavailable": "資料不可用。",
	                "mifidRuleMessage": "該圖表和相關數據將在基金成立之日起{0}個月後提供",
	                "changetodailyfrequency": "這是一個每日資料點。 請將頻率改成每日。",
	                "tenKGrowth": "一萬元回報",
	                "postTax": "稅後收益",
	                "addComparison": "添加比較",
	                "changeTicker": "'更换",
	                "searchAssets": "搜索資產",
	                "crosshairsPopoverNoData": "--",
	                "mainChartHeaderDividendEffectLabel": "（有紅利）",
	                "compareChartsMaxAllowedErrorLabel": "已達到最多比較添加。",
	                "oneDay": "1 天",
	                "fiveDay": "5 天",
	                "fifteenDay": "15 天",
	                "oneMonth": "1 個月",
	                "threeMonth": "3 個月",
	                "sixMonth": "6 個月",
	                "YTD": "今年",
	                "oneYear": "1 年",
	                "threeYear": "3 年",
	                "fiveYear": "5 年",
	                "tenYear": "10 年",
	                "max": "最大",
	                "to": "到",
	                "frequencys": "頻率",
	                "dividendText": "D",
	                "splitText": "S",
	                "earningText": "E",
	                "settings": "設定",
	                "optionsBtnText": "選項",
	                "export": "匯出",
	                "print": "打印",
	                "closeBtnText": "關閉",
	                "errorsMsg": "您的行動裝置不能顯示某些圖表資訊。 請從平板或電腦登錄，以獲得更佳交易體驗。",
	                'fundSize': '基金規模',
	                'price': '价格',
	                'shareholdersNumber': '股東人數',
	                'name': '名稱',
	                'PE': '本益比',
	                'PS': '股價營收比',
	                'PB': '市帳率',
	                'PC': '股價現金比',
	                'FairValue': 'Fair Value',
	                'RDividend': '滾動股息',
	                'DYield': '股息率',
	                'REPS': '滾動每股收益',
	                'PremiumDiscount': '溢價/折價',
	                'DiscountCumFair': 'Discount Cum Fair',
	                'SInterest': '賣空比率',
	                'SMA': 'SMA',
	                'EMA': 'EMA',
	                'SMAV': 'SMAV',
	                'BBands': '布林带',
	                'PSAR': 'PSAR',
	                'RSI': '相對強弱指數(RSI)',
	                'ROC': '變動率',
	                'CCI': 'CCI',
	                'WillR': 'WillR',
	                'SStochastic': '慢速隨機指標',
	                'FStochastic': '快速隨機指標',
	                'PChannel': '價格通道',
	                'MAE': '移動平均線軌道',
	                'Momentum': '動量指標',
	                'ULT': '終極震盪(ULT)指標',
	                'MFI': '金錢流指標',
	                'OBV': '能量潮指標',
	                'VAcc': '累積交易量',
	                'UDRatio': '漲跌比率',
	                'FVolatility': '快速波動指標',
	                'WMA': '加權移動平均數',
	                'AccDis': '累積/賣出',
	                'Mass': '梅斯線',
	                'Volatility': '波動率',
	                'ForceIndex': '強力指數',
	                'ATR': '高於真正範圍',
	                'Keltner': 'Keltner指數',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': '昨日收盤',
	                "mutualFund": "共同基金",
	                "closedEndFund": "封閉式基金",
	                "equities": "股票",
	                "index": "指數",
	                "eTF": "交易所交易基金",
	                "commonStocks": "普通股",
	                "preferredStocks": "優先股",
	                "aDRs": "ADRs",
	                "options": "期權",
	                "futures": "期貨",
	                "debenture": "債券",
	                "governmentBonds": "政府債券",
	                "municipalBonds": "市政債券",
	                "strategiesSpreads": "策略與傳播",
	                "unspecifiedBonds": "未指定債券",
	                "unspecifiedFundsCertificates": "未指定的資金和證書",
	                "warrants": "認股權證",
	                "forex": "外匯",
	                "startDate": "开始日期",
	                "earliest": "最早",
	                "common": "共同時期",
	                "mainTicker": "主要Ticker",
	                "startDateIllustrate": "加入比較ticker時比較的開始時間"
	            },
	            'ja': {
	                "invalidInputDefault": "正の値を入力するか何も入力しないでください。",
	                "invalidInputNpi": "正の値を入力してください。",
	                "frequency": "頻度",
	                "dataRange": "データ期間",
	                "customDate": "任意設定",
	                "customStartDate": "開始日",
	                "customEndDate": "終了日",
	                "labelSearch": "比較対象を追加",
	                "eventsIndicators": "イベントと指標",
	                "events": "イベント",
	                "eventsDividende": "配当・分配金",
	                "eventsSplits": "分割",
	                "eventsEarnings": "決算（利益）",
	                "indicators": "指標",
	                "indicatorsSMA": "単純移動平均線 (SMA)",
	                "indicatorsSMAlabel1": "線1 期間",
	                "indicatorsSMAlabel2": "線2 期間",
	                "indicatorsSMAlabel3": "線3 期間",
	                "indicatorsEMA": "指数平滑移動平均線 (EMA)",
	                "indicatorsEMAlabel1": "線1 期間",
	                "indicatorsEMAlabel2": "線2 期間",
	                "indicatorsEMAlabel3": "線3 期間",
	                "indicatorsVolume": "出来高",
	                "indicatorsVolumeSMA": "出来高 SMA",
	                "indicatorsPeriod": "期間",
	                "indicatorsBBands": "ボリンジャー・バンド (BB)",
	                "indicatorsBBandsPeriod": "期間",
	                "indicatorsBBandsDeviation": "標準偏差",
	                "indicatorsPSAR": "パラボリックSAR (PSAR)",
	                "indicatorsPSARStep": "加速因数",
	                "indicatorsPSARMaxStep": "最大加速因数",
	                "indicatorsMACD": "MACD",
	                "indicatorsMACDSlow": "長期期間",
	                "indicatorsMACDFast": "短期期間",
	                "indicatorsMACDSignal": "シグナル期間",
	                "indicatorsRSI": "相対性指数 (RSI)",
	                "indicatorsRSIPeriod": "期間",
	                "indicatorsROC": "変化率 (ROC)",
	                "indicatorsROCPeriod": "期間",
	                'indicatorsCCI': 'ホメオパシー指標(CCI)',
	                'indicatorsCCIPeriod': '期間',
	                "indicatorsSMAR": "ウィリアム%R",
	                "indicatorsSMAPeriod": "期間",
	                "indicatorsSMASlow": "スロー・ストキャスティクス",
	                "indicatorsSMAK": "%K 期間",
	                "indicatorsSMAD": "%D 期間",
	                "indicatorsSMAFast": "ファスト・ストキャスティクス",
	                "indicatorsSMAFastK": "%K 期間",
	                "indicatorsSMAFastD": "%D 期間",
	                "indicatorsSMAPrice": "プライス・チャネル",
	                "indicatorsSMAPriceChannel": "プライス・チャネル",
	                "indicatorsSMAMA": "MAエンベロープ",
	                "indicatorsSMAMAPeriod": "期間",
	                "indicatorsSMAMABand": "バンド幅",
	                "indicatorsSMAMomentum": "モメンタム",
	                "indicatorsSMAMomentumPeriod": "期間",
	                "indicatorsSMAULT": "究極の(ULT)オシレーター",
	                "indicatorsSMADMI": "方向性指数 (DMI)",
	                "indicatorsSMADMIPeriod": "期間",
	                "indicatorsSMAMoney": "マネー・フロー・インデックス",
	                "indicatorsSMAMoneyPeriod": "期間",
	                "indicatorsSMAOBV": "オンバランス・ボリューム",
	                "indicatorsEMAVol": "ボリューム・アキュミュレーション",
	                "indicatorsEMADirect": "騰落レシオ",
	                "indicatorsEMADirectPeriodo": "期間",
	                "indicatorsEMADirectSmoothing": "スムージング",
	                "indicatorsEMAVolume": "価格帯別出来高",
	                "indicatorsEMAFast": "ファスト・ボラティリティ",
	                "indicatorsEMAWeight": "加重移動平均線 (WMA)",
	                "indicatorsEMAWeightPeriodo": "期間",
	                "indicatorsEMAAD": "A/D 累積/分散",
	                "indicatorsEMAMass": "マス・インデックス",
	                "indicatorsEMAVolat": "ボラティリティ",
	                "indicatorsEMAVolatPeriod": "期間",
	                "indicatorsEMAVolatPeriodA": "期間 (前)",
	                "indicatorsEMAForce": "勢力指数",
	                "indicatorsEMAForcePeriod": "期間",
	                "indicatorsEMARange": "アベレージ・トゥルー・レンジ (ATR)",
	                "indicatorsVolumeKeltner": "ケルトナー・チャネルズ",
	                "indicatorsVolumeKeltnerEMA": "EMA期間",
	                "indicatorsVolumeKeltnerTimes": "倍率",
	                "indicatorsVolumeKeltnerATR": "ATR期間",
	                "indicatorsVolumePrevious": "前営業日終値",
	                "performanceGrowthChart": "累積パフォーマンス・チャート",
	                "pricesGrowthChart": "価格成長率チャート",
	                "performanceGrowthChartance": "パフォーマンス…",
	                "update": "更新",
	                "fundamentals": "各種指標",
	                "priceEarnings": "PER (株価/利益)",
	                "priceSales": "PSR (株価/売上高)",
	                "priceBook": "PBR (株価/純資産)",
	                "priceCash": "PCFR (株価/キャッシュフロー)",
	                "fairValue": "適正価値推計値",
	                "rollingDividend": "配当推移",
	                "dividendYield": "配当利回り",
	                "rollingEPS": "EPS推移",
	                "drawings": "描画ツール",
	                "trendLine": "トレンドライン",
	                "rectangle": "長方形",
	                "ellipse": "楕円",
	                "levelLine": "水平線",
	                "fibonacciRL": "フィボナッチ・リトレースメント・レベル",
	                "fibonacciFans": "フィナボッチ・ファン",
	                "fibonacciTZ": "フィナボッチ・タイムゾーン",
	                "fibonacciArcs": "フィナボッチ・アーク",
	                "shortInt": "% 空売り残高",
	                "priceEarnings0": "割引適正価値",
	                "priceEarnings1": "基準価額",
	                "priceEarnings2": "プレミアム/ディスカウント",
	                "display": "表示",
	                "cursorType": "カーソル・タイプ",
	                "crosshair": "十字",
	                "trackBall": "丸",
	                "off": "オフ",
	                "chartType": "チャート形式",
	                "mountain": "面",
	                "line": "線",
	                "dot": "点",
	                "aboveBelow": "上昇/下落",
	                "OHLC": "四本値",
	                "HLC": "三本値",
	                "candlestick": "ローソク足",
	                "growth": "累積騰落率",
	                "10KGrowth": "累積資産額",
	                "priceWithDividendGrowth": "分配金込み基準価額",
	                "dividendEffect": "配当効果",
	                "postTax": "税引き後リターン",
	                "yAxis": "Y軸位置",
	                "left": "左",
	                "right": "右",
	                "verticalScale": "縦軸スケール",
	                "linear": "指数",
	                "logarithmic": "対数",
	                "selectionMode": "選択時動作",
	                "pan": "平行移動",
	                "zoomIn": "拡大",
	                "reset": "リセット",
	                "other": "その他",
	                "extendedMarketHour": "時間外取引",
	                "volumePlus": "出来高+",
	                'oneMinute': "1 分",
	                'fiveMinute': "5 分",
	                'tenMinute': "10 分",
	                'fifteenMinute': "15 分",
	                'thirtyMinute': "30 分",
	                'sixtyMinute': "60 分",
	                'daily': "日次",
	                'weekly': "週次",
	                'monthly': "月次",
	                "date": "日付",
	                "time": "時間",
	                "nav": "基準価額",
	                'oneMinuteValueChange': '1 分 変更',
	                'oneMinuteValueChangePercent': '1 min % 変化率',
	                'fiveMinuteValueChange': "5 分 変更",
	                'fiveMinuteValueChangePercent': "5 分 % 変化率",
	                'tenMinuteValueChange': "10 分 変更",
	                'tenMinuteValueChangePercent': "10 分 % 変化率",
	                'fifteenMinuteValueChange': "15 分 変更",
	                'fifteenMinuteValueChangePercent': "15 分 % 変化率",
	                'thirtyMinuteValueChange': "30 分 変更",
	                'thirtyMinuteValueChangePercent': "30 分 % 変化率",
	                'sixtyMinuteValueChange': "60 分 変更",
	                'sixtyMinuteValueChangePercent': "60 分 % 変化率",
	                'dailyValueChange': "毎日 変更",
	                'dailyValueChangePercent': "毎日 % 変化率",
	                'weeklyValueChange': "毎週 変更",
	                'weeklyValueChangePercent': "毎週 % 変化率",
	                'monthlyValueChange': "毎月 変更",
	                'monthlyValueChangePercent': "毎月 % 変化率",
	                "totalReturn": "トータル・リターン",
	                "marketValue": "市場価値",
	                "open": "始値",
	                "close": "終値",
	                "low": "安値",
	                "high": "高値",
	                "volume": "出来高",
	                "value": "値",
	                "semiAnnual": "半年",
	                "annual": "年",
	                "quarterly": "四半期",
	                "mainGrowthLabel": "Performance Fondo",
	                "compareGrowthLabel": "Performance Benchmark",
	                "closeDateLabel": "Data Chiusura Mercato",
	                "range": "範囲",
	                "datanotavailable": "データがありません。",
	                "mifidRuleMessage": "このグラフと関連データは、ファンドの開設日から{0}か月後に利用可能になります。",
	                "changetodailyfrequency": "これは日次のデータ項目です。 | 頻度を日次に変更してください。",
	                "tenKGrowth": "累積資産額",
	                "postTax": "税引き後リターン",
	                "addComparison": "比較対象を追加",
	                "searchAssets": "検索",
	                "crosshairsPopoverNoData": "--",
	                "mainChartHeaderDividendEffectLabel": "(含む配当)",
	                "compareChartsMaxAllowedErrorLabel": "これ以上比較対象を追加できません。",
	                "oneDay": "1日",
	                "fiveDay": "5日",
	                "fifteenDay": "15日",
	                "oneMonth": "1ヶ月",
	                "threeMonth": "3ヶ月",
	                "sixMonth": "6ヶ月",
	                "YTD": "年初来",
	                "oneYear": "1年",
	                "threeYear": "3年",
	                "fiveYear": "5年",
	                "tenYear": "10年",
	                "max": "最大",
	                "to": "～",
	                "frequencys": "頻度",
	                "dividendText": "配",
	                "splitText": "分",
	                "earningText": "利",
	                "settings": "設定",
	                "optionsBtnText": "オプション",
	                "export": "出力",
	                "print": "印刷",
	                "closeBtnText": "閉じる",
	                "errorsMsg": "この携帯端末ではチャートを全て表示できません。タブレット端末もしくはPCからご利用ください。",
	                'fundSize': '基金のサイズ',
	                'price': '価格',
	                'shareholdersNumber': '株主数',
	                'name': '名',
	                'PE': 'PER (株価/利益)',
	                'PS': 'PSR (株価/売上高)',
	                'PB': 'PBR (株価/純資産)',
	                'PC': 'PCFR (株価/キャッシュフロー)',
	                'FairValue': 'Fair Value',
	                'RDividend': '配当推移',
	                'DYield': '配当利回り',
	                'REPS': 'EPS推移',
	                'PremiumDiscount': 'プレミアム/ディスカウント',
	                'DiscountCumFair': '割引適正価値',
	                'SInterest': '% 空売り残高',
	                'SMA': 'SMA',
	                'EMA': 'EMA',
	                'SMAV': 'SMAV',
	                'BBands': 'BB',
	                'PSAR': 'PSAR',
	                'RSI': '相対性指数 (RSI)',
	                'ROC': '変化率 (ROC)',
	                'CCI': 'CCI',
	                'WillR': 'ウィリアム%R',
	                'SStochastic': 'スロー・ストキャスティクス',
	                'FStochastic': 'ファスト・ストキャスティクス',
	                'PChannel': 'PChannel',
	                'MAE': 'MAエンベロープ',
	                'Momentum': 'モメンタム',
	                'ULT': '究極の(ULT)オシレーター',
	                'MFI': 'マネー・フロー・インデックス',
	                'OBV': 'オンバランス・ボリューム',
	                'VAcc': 'ボリューム・アキュミュレーシ',
	                'UDRatio': '騰落レシオ',
	                'FVolatility': 'ファスト・ボラティリティ',
	                'WMA': 'WMA',
	                'AccDis': 'A/D 累積/分散',
	                'Mass': 'マス・インデックス',
	                'Volatility': 'ボラティリティ',
	                'ForceIndex': '勢力指数',
	                'ATR': 'アベレージ・トゥルー・レン',
	                'Keltner': 'Keltnerチャネルズ',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': '前営業日終値',
	                "mutualFund": "ファンド",
	                "closedEndFund": "クローズドエンドファンド",
	                "equities": "株式",
	                "index": "インデックス",
	                "eTF": "ETF",
	                "commonStocks": "普通株式",
	                "preferredStocks": "優先株式",
	                "aDRs": "ADRs",
	                "options": "オプション",
	                "futures": "先物",
	                "debenture": "债券",
	                "governmentBonds": "国債",
	                "municipalBonds": "市債",
	                "strategiesSpreads": "戦略とコミュニケーション",
	                "unspecifiedBonds": "不特定の債券",
	                "unspecifiedFundsCertificates": "不特定の資金と証明書",
	                "warrants": "认ワラント股权证",
	                "forex": "外国為替",
	                "startDate": "開始日",
	                "earliest": "最長",
	                "common": "共通",
	                "mainTicker": "主銘柄",
	                "startDateIllustrate": "比較時の基準日を選択"
	            },
	            'da': {
	                "invalidInputDefault": "Indtast venligst et positivt tal",
	                "invalidInputNpi": "Indtast venligst et positivt tal",
	                "frequency": "Frekvens",
	                "dataRange": "Datointerval",
	                "customDate": "Tilpasset Dato",
	                "customStartDate": "Start Dato",
	                "customEndDate": "Slut Dato",
	                "labelSearch": "Tilføj instrumenter til sammenligning",
	                "labelChange": "Skift Primær Ticker",
	                "eventsIndicators": "Begivenheder & Indikatorer",
	                "events": "Begivenheder",
	                "eventsDividende": "Udbytte",
	                "eventsSplits": "Aktiesplit",
	                "eventsEarnings": "Regnskaber",
	                "indicators": "Indikatorer",
	                "indicatorsSMA": "Simple Moving Average (SMA)",
	                "indicatorsSMAlabel1": "Linje 1 Periode",
	                "indicatorsSMAlabel2": "Linje 2 Periode",
	                "indicatorsSMAlabel3": "Linje 3 Periode",
	                "indicatorsEMA": "Exponential Moving Average (EMA)",
	                "indicatorsEMAlabel1": "Linje 1 Periode",
	                "indicatorsEMAlabel2": "Linje 2 Periode",
	                "indicatorsEMAlabel3": "Linje 3 Periode",
	                "indicatorsVolume": "Volume",
	                "indicatorsVolumeSMA": "Volume SMA",
	                "indicatorsPeriod": "Period",
	                "indicatorsBBands": "Bollinger Bands (BBands)",
	                "indicatorsBBandsPeriod": "Period",
	                "indicatorsBBandsDeviation": "Deviation",
	                "indicatorsPSAR": "Parabolic SAR (PSAR)",
	                "indicatorsPSARStep": "Step Period",
	                "indicatorsPSARMaxStep": "Max Step Period",
	                "indicatorsMACD": "MACD",
	                "indicatorsMACDSlow": "Slow Period",
	                "indicatorsMACDFast": "Fast Period",
	                "indicatorsMACDSignal": "Signal Period",
	                "indicatorsRSI": "Relative Strength Index (RSI)",
	                "indicatorsRSIPeriod": "Period",
	                "indicatorsROC": "Rate of Change (ROC)",
	                "indicatorsROCPeriod": "Period",
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Period',
	                "indicatorsSMAR": "Williams %R",
	                "indicatorsSMAPeriod": "Period",
	                "indicatorsSMASlow": "Slow Stochastic",
	                "indicatorsSMAK": "K% Period",
	                "indicatorsSMAD": "D% Period",
	                "indicatorsSMAFast": "Fast Stochastic",
	                "indicatorsSMAFastK": "K% Period",
	                "indicatorsSMAFastD": "D% Period",
	                "indicatorsSMAPrice": "Price Channel",
	                "indicatorsSMAPriceChannel": "Price Channel",
	                "indicatorsSMAMA": "MA Envelope",
	                "indicatorsSMAMAPeriod": "Period",
	                "indicatorsSMAMABand": "Band Width",
	                "indicatorsSMAMomentum": "Momentum",
	                "indicatorsSMAMomentumPeriod": "Period",
	                "indicatorsSMAULT": "Ultimate (ULT) Oscillator",
	                "indicatorsSMADMI": "Directional Moving Index (DMI)",
	                "indicatorsSMADMIPeriod": "Period",
	                "indicatorsSMAMoney": "Money Flow Index",
	                "indicatorsSMAMoneyPeriod": "Period",
	                "indicatorsSMAOBV": "On Balance Volume",
	                "indicatorsEMAVol": "Volume Accumulation",
	                "indicatorsEMADirect": "Up/Down Ratio",
	                "indicatorsEMADirectPeriodo": "Period",
	                "indicatorsEMADirectSmoothing": "Smoothing",
	                "indicatorsEMAVolume": "Volume By Price",
	                "indicatorsEMAFast": "Fast Volatility",
	                "indicatorsEMAWeight": "Weighted Moving Average",
	                "indicatorsEMAWeightPeriodo": "Period",
	                "indicatorsEMAAD": "Accumulation/Distribution",
	                "indicatorsEMAMass": "Mass Index",
	                "indicatorsEMAVolat": "Volatility",
	                "indicatorsEMAVolatPeriod": "Period",
	                "indicatorsEMAVolatPeriodA": "Period Ago",
	                "indicatorsEMAForce": "Force Index",
	                "indicatorsEMAForcePeriod": "Period",
	                "indicatorsEMARange": "Average True Range",
	                "indicatorsVolumeKeltner": "Keltner Index",
	                "indicatorsVolumeKeltnerEMA": "EMA Period",
	                "indicatorsVolumeKeltnerTimes": "Times",
	                "indicatorsVolumeKeltnerATR": "ATR Period",
	                "indicatorsVolumePrevious": "Previous Close Line",
	                "performanceGrowthChart": "Vækst Graf (Afkast)",
	                "pricesGrowthChart": "Vækst Graf (Pris)",
	                "performanceGrowthChartance": "Afkast...",
	                "update": "Opdatér",
	                "fundamentals": "Fundamentaler",
	                "priceEarnings": "Price/Earnings",
	                "priceSales": "Price/Sales",
	                "priceBook": "Price/Book",
	                "priceCash": "Price/Cash",
	                "fairValue": "Fair Value",
	                "rollingDividend": "Løbende Udbytte",
	                "dividendYield": "Udbytteprocent",
	                "rollingEPS": "Løbende EPS",
	                "drawings": "Tegn",
	                "trendLine": "Trend Linje",
	                "rectangle": "Rektangel",
	                "ellipse": "Ellipse",
	                "levelLine": "Niveau Linje",
	                "fibonacciRL": "Fibonacci Retracement Levels",
	                "fibonacciFans": "Fibonacci Fans",
	                "fibonacciTZ": "Fibonacci Time Zones",
	                "fibonacciArcs": "Fibonacci Arcs",
	                "shortInt": "% Short Interesse",
	                "priceEarnings0": "Nutidsværdi",
	                "priceEarnings1": "NAV",
	                "priceEarnings2": "Præmie/Discount",
	                "display": "Vis",
	                "cursorType": "Markør",
	                "crosshair": "Kryds",
	                "trackBall": "Cirkel",
	                "off": "Fra",
	                "chartType": "Graf",
	                "mountain": "Bjerg",
	                "line": "Linje",
	                "dot": "Prik",
	                "aboveBelow": "Over/Under",
	                "OHLC": "OHLC",
	                "HLC": "HLC",
	                "candlestick": "Candlestick",
	                "growth": "Vækst",
	                "10KGrowth": "10K Vækst",
	                "priceWithDividendGrowth": "Pris med udbyttevækst",
	                "dividendEffect": "Udbytte Effekt",
	                "postTax": "Før Skat Afkast",
	                "yAxis": "Y-Akse",
	                "left": "Venstre",
	                "right": "Højre",
	                "verticalScale": "Vertikal Skala",
	                "linear": "Lineær",
	                "logarithmic": "Logaritmisk",
	                "selectionMode": "Selection Mode",
	                "pan": "Ryk",
	                "zoomIn": "Zoom Ind",
	                "reset": "Nulstil",
	                "other": "Andet",
	                "extendedMarketHour": "Extended Market Hour",
	                "volumePlus": "Volume+",
	                "oneMinute": "1 min.",
	                "fiveMinute": "5 min.",
	                "tenMinute": "10 min.",
	                "fifteenMinute": "15 min.",
	                "thirtyMinute": "30 min.",
	                "sixtyMinute": "60 min.",
	                "daily": "Daglig",
	                "weekly": "Ugentlig",
	                "monthly": "Månedlig",
	                "date": "Dato",
	                "time": "Tid",
	                "nav": "NAV",
	                "oneMinuteValueChange": "1 min. Ændring",
	                "oneMinuteValueChangePercent": "1 min. Ændring (%)",
	                "fiveMinuteValueChange": "5 min. Ændring",
	                "fiveMinuteValueChangePercent": "5 min. Ændring (%)",
	                "tenMinuteValueChange": "10 min. Ændring",
	                "tenMinuteValueChangePercent": "10 min. Ændring (%)",
	                "fifteenMinuteValueChange": "15 min. Ændring",
	                "fifteenMinuteValueChangePercent": "15 min. Ændring (%)",
	                "thirtyMinuteValueChange": "30 min. Ændring",
	                "thirtyMinuteValueChangePercent": "30 min. Ændring (%)",
	                "sixtyMinuteValueChange": "60 min. Ændring",
	                "sixtyMinuteValueChangePercent": "60 min. Ændring (%)",
	                "dailyValueChange": "Daglig Ændring",
	                "dailyValueChangePercent": "Daglig Ændring (%)",
	                "weeklyValueChange": "Ugentlig Ændring",
	                "weeklyValueChangePercent": "Ugentlig Ændring (%)",
	                "monthlyValueChange": "Månedlig Ændring",
	                "monthlyValueChangePercent": "Månedlig Ændring (%)",
	                "totalReturn": "Afkast I Alt",
	                "marketValue": "Markedsværdi",
	                "open": "Åbningskurs",
	                "close": "Lukkekurs",
	                "low": "Laveste",
	                "high": "Højeste",
	                "volume": "Volumen",
	                "value": "Værdi",
	                "semiAnnual": "Semi-årlig",
	                "annual": "Årlig",
	                "quarterly": "Kvartalsvis",
	                "mainGrowthLabel": "Performance Fond",
	                "compareGrowthLabel": "Performance Benchmark",
	                "closeDateLabel": "Sidste handelsdag",
	                "range": "Interval",
	                "datanotavailable": "Utilgængelig Data",
	                "mifidRuleMessage": "Denne graf og de relaterede data vil være tilgængelige {0} måneder efter fondens startdato",
	                "changetodailyfrequency": "Dette er et dagligt datapunkt. | Skift venligst din frekvens til Daglig.",
	                "tenKGrowth": "10K Vækst",
	                "postTax": "Før Skat Afkast",
	                "addComparison": "Tilføj Sammenligning",
	                "changeTicker": "Skift Ticker",
	                "searchAssets": "Søg efter aktiver",
	                "crosshairsPopoverNoData": "--",
	                "mainChartHeaderDividendEffectLabel": "(med Udb.)",
	                "compareChartsMaxAllowedErrorLabel": "Det maksimale antal sammenlignelige tickers er nået.",
	                "oneDay": "1D",
	                "fiveDay": "5D",
	                "fifteenDay": "15D",
	                "oneMonth": "1M",
	                "threeMonth": "3M",
	                "sixMonth": "6M",
	                "YTD": "ÅTD",
	                "oneYear": "1 År",
	                "threeYear": "3 År",
	                "fiveYear": "5 År",
	                "tenYear": "10 År",
	                "max": "MAX",
	                "to": "til",
	                "frequencys": "frekvens",
	                "dividendText": "U",
	                "splitText": "S",
	                "earningText": "I",
	                "settings": "Indstillinger",
	                "options": "Muligheder",
	                "export": "Eksportér",
	                "print": "Print",
	                "errorsMsg": "Din mobile enhed kan ikke vise nogle af grafens funktioner. Log ind fra en tablet eller computer for at få den mest optimale oplevelse.",
	                "fundSize": "Fond Størrelse",
	                "price": "Pris",
	                "shareholdersNumber": "Antal aktionærer",
	                "name": "Navn",
	                'PE': 'Price/Earnings',
	                'PS': 'Price/Sales',
	                'PB': 'Price/Book',
	                'PC': 'Price/Cash',
	                'FairValue': 'Fair Value',
	                'DailyCumFairNav': 'NAV',
	                'QuantitativeFairValue': 'Fair Value',
	                'RDividend': 'Løbende Dividend',
	                'DYield': 'Dividend Yield',
	                'REPS': 'Løbende EPS',
	                'PremiumDiscount': 'Premium/Discount',
	                "DiscountCumFair": "Nutidsværdi",
	                'SInterest': '% Short Int.',
	                'SMA': 'SMA',
	                'EMA': 'EMA',
	                'SMAV': 'SMAV',
	                'BBands': 'BBands',
	                'PSAR': 'PSAR',
	                'RSI': 'RSI',
	                'ROC': 'ROC',
	                'CCI': 'CCI',
	                'WillR': 'WillR',
	                'SStochastic': 'SStochastic',
	                'FStochastic': 'FStochastic',
	                'PChannel': 'PChannel',
	                'MAE': 'MA Envelope',
	                'Momentum': 'Momentum',
	                'ULT': 'Ultimate Oscillator',
	                'MFI': 'MFI',
	                'OBV': 'On Balance Volume',
	                'VAcc': 'Volume Accumulation',
	                'UDRatio': 'UDRatio',
	                'FVolatility': 'Fast Volatility',
	                'WMA': 'WMA',
	                'AccDis': 'Accumulation/Distribution',
	                'Mass': 'Mass',
	                'Volatility': 'Volatility',
	                'ForceIndex': 'ForceIndex',
	                'ATR': 'Average True Range',
	                'Keltner': 'Keltner Index',
	                'VBP': 'VBP',
	                'DMI': ['DMI+', ' DMI-', ' ADX'],
	                'MACD': ['MACD', 'EMA', 'Divergence'],
	                'PrevClose': 'tidligere tæt',
	                "mutualFund": "Investeringsforening",
	                "closedEndFund": "Closed-End Fund",
	                "equities": "Aktier",
	                "index": "Index",
	                "eTF": "ETF",
	                "commonStocks": "Ordinære aktier",
	                "preferredStocks": "Præferenceaktier",
	                "aDRs": "ADRs",
	                "options": "Optioner",
	                "futures": "Futures",
	                "debenture": "Partialobligation",
	                "governmentBonds": "Statsobligationer",
	                "municipalBonds": "Municipal Bonds",
	                "strategiesSpreads": "Strategier & Spreads",
	                "unspecifiedBonds": "Ikke Klassificerede Obligationer",
	                "unspecifiedFundsCertificates": "Ikke Klassificerede Fonde & Certifikater",
	                "warrants": "Warrants",
	                "forex": "Valuta",
	                "startDate": "Start Date",
	                "earliest": "Earliest",
	                "common": "Common",
	                "mainTicker": "Main Ticker",
	                "startDateIllustrate": "Indicate the base date when comparison added"
	            },
	            'sv': {
	                "invalidInputDefault": "Vänligen skriv in ett positivt heltal eller lämna blankt",
	                "invalidInputNpi": "Vänligen skriv in ett positivt heltal",
	                "frequency": "Frekvens",
	                "dataRange": "Datumintervall",
	                "customDate": "Egenvald tidsperiod",
	                "customStartDate": "Startdatum",
	                "customEndDate": "Slutdatum",
	                "labelSearch": "Lägg till jämförelse",
	                "labelChange": "Ändra huvudinstrument",
	                "eventsIndicators": "Händelser & Indikatorer",
	                "events": "Händelser",
	                "eventsDividende": "Utdelning",
	                "eventsSplits": "Splittar",
	                "eventsEarnings": "Earnings",
	                "indicators": "Indikatorer",
	                "indicatorsSMA": "Simple Moving Average (SMA)",
	                "indicatorsSMAlabel1": "Line1 period",
	                "indicatorsSMAlabel2": "Line2 period",
	                "indicatorsSMAlabel3": "Line3 period",
	                "indicatorsEMA": "Exponential Moving Average (EMA)",
	                "indicatorsEMAlabel1": "Line1 period",
	                "indicatorsEMAlabel2": "Line2 period",
	                "indicatorsEMAlabel3": "Line3 period",
	                "indicatorsVolume": "Volume",
	                "indicatorsVolumeSMA": "Volume SMA",
	                "indicatorsPeriod": "Period",
	                "indicatorsBBands": "Bollinger Bands (BBands)",
	                "indicatorsBBandsPeriod": "Period",
	                "indicatorsBBandsDeviation": "Deviation",
	                "indicatorsPSAR": "Parabolic SAR (PSAR)",
	                "indicatorsPSARStep": "Step Period",
	                "indicatorsPSARMaxStep": "Max Step Period",
	                "indicatorsMACD": "MACD",
	                "indicatorsMACDSlow": "Slow Period",
	                "indicatorsMACDFast": "Fast Period",
	                "indicatorsMACDSignal": "Signal Period",
	                "indicatorsRSI": "Relative Strength Index (RSI)",
	                "indicatorsRSIPeriod": "Period",
	                "indicatorsROC": "Rate of Change (ROC)",
	                "indicatorsROCPeriod": "Period",
	                'indicatorsCCI': 'Commodity Channel Index (CCI)',
	                'indicatorsCCIPeriod': 'Period',
	                "indicatorsSMAR": "Williams %R",
	                "indicatorsSMAPeriod": "Period",
	                "indicatorsSMASlow": "Slow Stochastic",
	                "indicatorsSMAK": "K% Period",
	                "indicatorsSMAD": "D% Period",
	                "indicatorsSMAFast": "Fast Stochastic",
	                "indicatorsSMAFastK": "K% Period",
	                "indicatorsSMAFastD": "D% Period",
	                "indicatorsSMAPrice": "Price Channel",
	                "indicatorsSMAPriceChannel": "Price Channel",
	                "indicatorsSMAMA": "MA Envelope",
	                "indicatorsSMAMAPeriod": "Period",
	                "indicatorsSMAMABand": "Band Width",
	                "indicatorsSMAMomentum": "Momentum",
	                "indicatorsSMAMomentumPeriod": "Period",
	                "indicatorsSMAULT": "Ultimate (ULT) Oscillator",
	                "indicatorsSMADMI": "Directional Moving Index (DMI)",
	                "indicatorsSMADMIPeriod": "Period",
	                "indicatorsSMAMoney": "Money Flow Index",
	                "indicatorsSMAMoneyPeriod": "Period",
	                "indicatorsSMAOBV": "On Balance Volume",
	                "indicatorsEMAVol": "Volume Accumulation",
	                "indicatorsEMADirect": "Up/Down Ratio",
	                "indicatorsEMADirectPeriodo": "Period",
	                "indicatorsEMADirectSmoothing": "Smoothing",
	                "indicatorsEMAVolume": "Volume By Price",
	                "indicatorsEMAFast": "Fast Volatility",
	                "indicatorsEMAWeight": "Weighted Moving Average",
	                "indicatorsEMAWeightPeriodo": "Period",
	                "indicatorsEMAAD": "Accumulation/Distribution",
	                "indicatorsEMAMass": "Mass Index",
	                "indicatorsEMAVolat": "Volatility",
	                "indicatorsEMAVolatPeriod": "Period",
	                "indicatorsEMAVolatPeriodA": "Period Ago",
	                "indicatorsEMAForce": "Force Index",
	                "indicatorsEMAForcePeriod": "Period",
	                "indicatorsEMARange": "Average True Range",
	                "indicatorsVolumeKeltner": "Keltner Index",
	                "indicatorsVolumeKeltnerEMA": "EMA Period",
	                "indicatorsVolumeKeltnerTimes": "Times",
	                "indicatorsVolumeKeltnerATR": "ATR Period",
	                "indicatorsVolumePrevious": "Previous Close Line",
	                "performanceGrowthChart": "Performance Growth Chart",
	                "pricesGrowthChart": "Prices Growth Chart",
	                "performanceGrowthChartance": "Performance...",
	                "update": "Uppdatera",
	                "fundamentals": "Fundamentals",
	                "priceEarnings": "Price/Earnings",
	                "priceSales": "Price/Sales",
	                "priceBook": "Price/Book",
	                "priceCash": "Price/Cash",
	                "fairValue": "Fair Value",
	                "rollingDividend": "Rolling Dividend",
	                "dividendYield": "Dividend Yield",
	                "rollingEPS": "Rolling EPS",
	                "drawings": "Drawings",
	                "trendLine": "Trend Line",
	                "rectangle": "Rectangle",
	                "ellipse": "Ellipse",
	                "levelLine": "Level Line",
	                "fibonacciRL": "Fibonacci Retracement Levels",
	                "fibonacciFans": "Fibonacci Fans",
	                "fibonacciTZ": "Fibonacci Time Zones",
	                "fibonacciArcs": "Fibonacci Arcs",
	                "shortInt": "% Short Int.",
	                "priceEarnings0": "Discount Cum Fair",
	                "priceEarnings1": "NAV",
	                "priceEarnings2": "Premium/Discount",
	                "display": "Display",
	                "cursorType": "Markörstyp",
	                "crosshair": "Hårkors",
	                "trackBall": "Spårboll",
	                "off": "av",
	                "chartType": "Graftyp",
	                "mountain": "Berg",
	                "line": "Linje",
	                "dot": "Punkt",
	                "aboveBelow": "Above/Below",
	                "OHLC": "OHLC",
	                "HLC": "HLC",
	                "candlestick": "Candlestick",
	                "growth": "Tillväxt",
	                "10KGrowth": "10K Growth",
	                "priceWithDividendGrowth": "Pris med utdelningstillväxt",
	                "dividendEffect": "Dividend Effect",
	                "postTax": "Post Tax Return",
	                "yAxis": "Y-axeln",
	                "left": "Vänster",
	                "right": "Höger",
	                "verticalScale": "Vertikal skala",
	                "linear": "Linjär",
	                "logarithmic": "Logaritmisk",
	                "selectionMode": "Urvalsläge",
	                "pan": "Pan",
	                "zoomIn": "Zooma in",
	                "reset": "Återställ",
	                "other": "Andra",
	                "extendedMarketHour": "Extended Market Hour",
	                "volumePlus": "Volume+",
	                "oneMinute": "1 min",
	                "fiveMinute": "5 min",
	                "tenMinute": "10 min",
	                "fifteenMinute": "15 min",
	                "thirtyMinute": "30 min",
	                "sixtyMinute": "60 min",
	                "daily": "Daglig",
	                "weekly": "Veckovis",
	                "monthly": "Månadsvis",
	                "date": "Datum",
	                "time": "Tid",
	                "nav": "NAV",
	                "oneMinuteValueChange": "1 min förändring",
	                "oneMinuteValueChangePercent": "1 min% förändring",
	                "fiveMinuteValueChange": "5 min förändring",
	                "fiveMinuteValueChangePercent": "5 min% förändring",
	                "tenMinuteValueChange": "10 min förändring",
	                "tenMinuteValueChangePercent": "10 min% förändring",
	                "fifteenMinuteValueChange": "15 min förändring",
	                "fifteenMinuteValueChangePercent": "15 min% förändring",
	                "thirtyMinuteValueChange": "30 min förändring",
	                "thirtyMinuteValueChangePercent": "30 min% förändring",
	                "sixtyMinuteValueChange": "60 min förändring",
	                "sixtyMinuteValueChangePercent": "60 min% förändring",
	                "dailyValueChange": "Daglig förändring",
	                "dailyValueChangePercent": "Daglig förändring i %",
	                "weeklyValueChange": "Veckovis förändring",
	                "weeklyValueChangePercent": "Veckovis förändring i %",
	                "monthlyValueChange": "Månatlig förändring",
	                "monthlyValueChangePercent": "Månatlig ändring i %",
	                "totalReturn": "Totalavkastning",
	                "marketValue": "Marknadsvärde",
	                "open": "Öppna",
	                "close": "Stäng",
	                "low": "Lägst",
	                "high": "Högst",
	                "volume": "Volym",
	                "value": "Värde",
	                "semiAnnual": "Halvår",
	                "annual": "Helår",
	                "quarterly": "Kvartal",
	                "mainGrowthLabel": "Utveckling Fond",
	                "compareGrowthLabel": "Utveckling Index",
	                "closeDateLabel": "Data Chiusura Mercato",
	                "range": "Intervall",
	                "datanotavailable": "Data saknas",
	                "mifidRuleMessage": "Denna graf och de relaterade uppgifterna kommer att finnas tillgängliga {0} månader efter fondens startdatum",
	                "changetodailyfrequency": "Detta är en dagligt uppdaterad datapunkt. |Vänligen ändra frekvensen till daglig för att se datapunkten.",
	                "tenKGrowth": "Utvecklingen av 10 000",
	                "postTax": "Post Tax Return",
	                "addComparison": "Lägg till jämförelse",
	                "changeTicker": "Ändra ticker",
	                "searchAssets": "Sök instrument",
	                "crosshairsPopoverNoData": "--",
	                "mainChartHeaderDividendEffectLabel": "(w Div.)",
	                "compareChartsMaxAllowedErrorLabel": "'Gränsen för max antal instrument i jämförelsen är nådd, vänligen ta bort ett eller flera instrument",
	                "oneDay": "1 d",
	                "fiveDay": "5 d",
	                "fifteenDay": "15 d",
	                "oneMonth": "1 m",
	                "threeMonth": "3 m",
	                "sixMonth": "6 m",
	                "YTD": "i år",
	                "oneYear": "1 år",
	                "threeYear": "3 år",
	                "fiveYear": "5 år",
	                "tenYear": "10 år",
	                "max": "MAX",
	                "to": "till",
	                "frequencys": "Frekvens",
	                "dividendText": "D",
	                "splitText": "S",
	                "earningText": "E",
	                "settings": "Inställningar",
	                "optionsBtnText": "Alternativ",
	                "export": "Exportera",
	                "print": "Print",
	                "closeBtnText": "Stäng",
	                "errorsMsg": "Din enhet kan inte utnyttja all funktionalitet i grafen, vänligen använd en dator för full funktionalitet",
	                "fundSize": "Fondstorlek",
	                "price": "Pris",
	                "shareholdersNumber": "Antal aktieägare",
	                "name": "Namn",
	                "PE": "Price/Earnings",
	                "PS": "Price/Sales",
	                "PB": "Price/Book",
	                "PC": "Price/Cash",
	                "FairValue": "Fair Value",
	                "DailyCumFairNav": "NAV",
	                "QuantitativeFairValue": "Fair Value",
	                "RDividend": "Rolling Dividend",
	                "DYield": "Dividend Yield",
	                "REPS": "Rolling EPS",
	                "DiscountCumFair": "Discount Cum Fair",
	                "PremiumDiscount": "Premium/Discount",
	                "SInterest": "% Short Int.",
	                "SMA": "SMA",
	                "EMA": "EMA",
	                "SMAV": "SMAV",
	                "BBands": "BBands",
	                "PSAR": "PSAR",
	                "RSI": "RSI",
	                "ROC": "ROC",
	                'CCI': 'CCI',
	                "WillR": "WillR",
	                "SStochastic": "SStochastic",
	                "FStochastic": "FStochastic",
	                "PChannel": "PChannel",
	                "MAE": "MA Envelope",
	                "Momentum": "Momentum",
	                "ULT": "Ultimate Oscillator",
	                "MFI": "MFI",
	                "OBV": "On Balance Volume",
	                "VAcc": "Volume Accumulation",
	                "UDRatio": "UDRatio",
	                "FVolatility": "Fast Volatility",
	                "WMA": "WMA",
	                "AccDis": "Accumulation/Distribution",
	                "Mass": "Mass",
	                "Volatility": "Volatility",
	                "ForceIndex": "ForceIndex",
	                "ATR": "Average True Range",
	                "Keltner": "Keltner Index",
	                "VBP": "VBP",
	                "DMI": ["DMI+", " DMI-", " ADX"],
	                "MACD": ["MACD", "EMA", "Divergence"],
	                'PrevClose': 'föregående stäng',
	                "mutualFund": "Mutual Fund",
	                "closedEndFund": "Closed-End Fund",
	                "equities": "Aktier",
	                "index": "Index",
	                "eTF": "ETF",
	                "commonStocks": "Stamaktier",
	                "preferredStocks": "Preferensaktier",
	                "aDRs": "ADRs",
	                "options": "Optioner",
	                "futures": "Terminer",
	                "debenture": "Debenture",
	                "governmentBonds": "Stadsobligationer",
	                "municipalBonds": "Kommunala obligationer",
	                "strategiesSpreads": "Strategies & Spreads",
	                "unspecifiedBonds": "Ospecificierade obligationer",
	                "unspecifiedFundsCertificates": "Ospecificierade fonder & certifikat",
	                "warrants": "Warranter",
	                "forex": "Forex",
	                "startDate": "Start Date",
	                "earliest": "Earliest",
	                "common": "Common",
	                "mainTicker": "Main Ticker",
	                "startDateIllustrate": "Indicate the base date when comparison added"
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, d3) {
	    var $ = core.$;
	    var CommonXLabelDateTimeFormat = {
	        'YearMonthDay': '%b %d, %Y',
	        'Year': '%Y',
	        'YearMonth': '%Y %b',
	        'Month': '%b',
	        'MonthDay': '%b %d',
	        'HourMinutes': '%I:%M %p'
	    };
	    var EUXLabelDateTimeFormat = {
	        'YearMonthDay': '%d %b, %Y',
	        'Year': '%Y',
	        'YearMonth': '%Y %b',
	        'Month': '%b',
	        'MonthDay': '%d %b',
	        'HourMinutes': '%I:%M %p'
	    };
	    var ChinaXLabelDateTimeFormat = {
	        'YearMonthDay': function(d) {
	            return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
	        },
	        'Year': function(d) {
	            return d.getFullYear() + '年';
	        },
	        'YearMonth': function(d) {
	            return d.getFullYear() + '年' + (d.getMonth() + 1) + '月';
	        },
	        'Month': function(d) {
	            return (d.getMonth() + 1) + '月';
	        },
	        'MonthDay': function(d) {
	            return (d.getMonth() + 1) + '月' + d.getDate() + '日';
	        },
	        'HourMinutes': '%I:%M %p'
	    };
	    var localeConfig = {
	        'en': {
	            'decimal': '.',
	            'thousands': ',',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%a %b %e %X %Y',
	            'date': '%m/%d/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	            'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	            'dailyDateFormatter': 'MM/DD/YYYY',
	            'intradayDateFormater': 'MM/DD/YYYY hh:mm A',
	            'momentDateTime': 'MMM DD YYYY hh:mm A',
	            'momentDate': 'MMM DD YYYY',
	            'columnDelimiter': ',',
	            'XLabelDateTimeFormat': CommonXLabelDateTimeFormat
	        },
	        'en-GB': {
	            'decimal': '.',
	            'thousands': ',',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%a %b %e %X %Y',
	            'date': '%m/%d/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	            'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	            'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	            'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	            'dailyDateFormatter': 'DD/MM/YYYY',
	            'intradayDateFormater': 'DD/MM/YYYY hh:mm A',
	            'momentDateTime': 'DD MMM YYYY hh:mm A',
	            'momentDate': 'DD MMM YYYY',
	            'columnDelimiter': ',',
	            'XLabelDateTimeFormat': CommonXLabelDateTimeFormat
	        },
	        'fr': {
	            'decimal': ',',
	            'thousands': ' ',
	            'grouping': [3],
	            'dateTime': '%A, le %e %B %Y, %X',
	            'date': '%d/%m/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
	            'shortDays': ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
	            'months': ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
	            'shortMonths': ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
	            'dailyDateFormatter': 'DD/MM/YYYY',
	            'intradayDateFormater': 'DD/MM/YYYY hh:mm A',
	            'momentDateTime': 'DD MMM YYYY hh:mm A',
	            'momentDate': 'DD MMM YYYY',
	            'columnDelimiter': ';',
	            'XLabelDateTimeFormat': EUXLabelDateTimeFormat
	        },
	        'zh': {
	            'decimal': '.',
	            'thousands': ',',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%a %b %e %X %Y',
	            'date': '%m/%d/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
	            'shortDays': ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
	            'months': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'shortMonths': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'dailyDateFormatter': 'YYYY/MM/DD',
	            'intradayDateFormater': 'YYYY/MM/DD hh:mm A',
	            'momentDateTime': 'YYYY MM DD hh:mm A',
	            'momentDate': 'YYYY MMM DD',
	            'columnDelimiter': ',',
	            'XLabelDateTimeFormat': ChinaXLabelDateTimeFormat
	        },
	        'zh-TW': {
	            'decimal': '.',
	            'thousands': ',',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%a %b %e %X %Y',
	            'date': '%m/%d/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
	            'shortDays': ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
	            'months': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'shortMonths': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'dailyDateFormatter': 'YYYY/MM/DD',
	            'intradayDateFormater': 'YYYY/MM/DD hh:mm A',
	            'momentDateTime': 'YYYY MMM DD hh:mm A',
	            'momentDate': 'YYYY MMM DD',
	            'columnDelimiter': ',',
	            'XLabelDateTimeFormat': ChinaXLabelDateTimeFormat
	        },
	        'zh-HK': {
	            'decimal': '.',
	            'thousands': ',',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%a %b %e %X %Y',
	            'date': '%m/%d/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
	            'shortDays': ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
	            'months': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'shortMonths': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'dailyDateFormatter': 'YYYY/MM/DD',
	            'intradayDateFormater': 'YYYY/MM/DD hh:mm A',
	            'momentDateTime': 'MMM DD YYYY hh:mm A',
	            'momentDate': 'YYYY MMM DD',
	            'columnDelimiter': ',',
	            'XLabelDateTimeFormat': ChinaXLabelDateTimeFormat
	        },
	        'pt': {
	            'decimal': ',',
	            'thousands': '.',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%A, le %e %B %Y, %X',
	            'date': '%d/%m/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
	            'shortDays': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
	            'months': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
	            'shortMonths': ['Jan.', 'Fev.', 'Mar.', 'Abr.', 'Maio', 'Jun.', 'Jul.', 'Ago.', 'Set.', 'Out.', 'Nov.', 'Dez.'],
	            'dailyDateFormatter': 'DD/MM/YYYY',
	            'intradayDateFormater': 'DD/MM/YYYY hh:mm A',
	            'momentDateTime': 'DD MMM YYYY hh:mm A',
	            'momentDate': 'DD MMM YYYY',
	            'columnDelimiter': ';',
	            'XLabelDateTimeFormat': CommonXLabelDateTimeFormat
	        },
	        'ja': {
	            'decimal': '.',
	            'thousands': ',',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%a %b %e %X %Y',
	            'date': '%m/%d/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
	            'shortDays': ['日', '月', '火', '水', '木', '金', '土'],
	            'months': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'shortMonths': ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	            'dailyDateFormatter': 'YYYY/MM/DD',
	            'intradayDateFormater': 'YYYY/MM/DD hh:mm A',
	            'momentDateTime': 'YYYY MM DD hh:mm A',
	            'momentDate': 'YYYY MMM DD',
	            'columnDelimiter': ',',
	            'XLabelDateTimeFormat': ChinaXLabelDateTimeFormat
	        },
	        'it': {
	            'decimal': ',',
	            'thousands': '.',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%A, le %e %B %Y, %X',
	            'date': '%d/%m/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
	            'shortDays': ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
	            'months': ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
	            'shortMonths': ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
	            'dailyDateFormatter': 'DD/MM/YYYY',
	            'intradayDateFormater': 'DD/MM/YYYY hh:mm A',
	            'momentDateTime': 'DD MMM YYYY hh:mm A',
	            'momentDate': 'DD MMM YYYY',
	            'columnDelimiter': ';',
	            'XLabelDateTimeFormat': CommonXLabelDateTimeFormat
	        },
	        'da': {
	            'decimal': ',',
	            'thousands': '.',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%A den %d %B %Y %X',
	            'date': '%d-%m-%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'],
	            'shortDays': ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
	            'months': ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
	            'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
	            'dailyDateFormatter': 'DD/MM/YYYY',
	            'intradayDateFormater': 'DD/MM/YYYY hh:mm A',
	            'momentDateTime': 'DD MMM YYYY hh:mm A',
	            'momentDate': 'DD MMM YYYY',
	            'columnDelimiter': ';',
	            'XLabelDateTimeFormat': CommonXLabelDateTimeFormat
	        },
	        'sv': {
	            'decimal': ',',
	            'thousands': '.',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%A den %d %B %Y %X',
	            'date': '%Y-%m-%d',
	            'time': '%H:%M:%S',
	            'periods': ['fm', 'em'],
	            'days': ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
	            'shortDays': ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
	            'months': ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
	            'shortMonths': ['Jan', 'Feb', 'Mars', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
	            'dailyDateFormatter': 'YYYY-MM-DD',
	            'intradayDateFormater': 'YYYY-MM-DD HH:mm',
	            'momentDateTime': 'YYYY-MM-DD HH:mm',
	            'momentDate': 'YYYY-MM-DD',
	            'columnDelimiter': ';',
	            'XLabelDateTimeFormat': {
	                'YearMonthDay': '%b %d, %Y',
	                'Year': '%Y',
	                'YearMonth': '%Y %b',
	                'Month': '%b',
	                'MonthDay': '%b %d',
	                'HourMinutes': '%H:%M'
	            }
	        },
	        'es': {
	            'decimal': ',',
	            'thousands': '.',
	            'grouping': [3],
	            'currency': ['$', ''],
	            'dateTime': '%A, le %e %B %Y, %X',
	            'date': '%d/%m/%Y',
	            'time': '%H:%M:%S',
	            'periods': ['AM', 'PM'],
	            'days': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
	            'shortDays': ['Dom.', 'Lun.', 'Mar.', 'Mier.', 'Jue.', 'Vie.', 'Sab.'],
	            'months': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo',  'June', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
	            'shortMonths': [ 'Ene', 'Feb', 'Mar', 'Abr', 'Mayo', 'Jun', 'Jul', 'Ago', 'Sept', 'Oct', 'Nov', 'Dic'],
	            'dailyDateFormatter': 'DD/MM/YYYY',
	            'intradayDateFormater': 'DD/MM/YYYY hh:mm A',
	            'momentDateTime': 'MMM DD YYYY hh:mm A',
	            'momentDate': 'DD MMM YYYY',
	            'columnDelimiter': ';',
	            'XLabelDateTimeFormat': {
	                'YearMonthDay': '%b %d, %Y',
	                'Year': '%Y',
	                'YearMonth': '%Y %b',
	                'Month': '%b',
	                'MonthDay': '%b %d',
	                'HourMinutes': '%H:%M'
	            }
	        }
	    };
	
	    function getSpecifier(languageId) {
	        var specifier;
	        if (localeConfig[languageId]) {
	            specifier = localeConfig[languageId];
	        } else {
	            languageId = languageId.split('-')[0];
	            specifier = localeConfig[languageId] || localeConfig['en'];
	        }
	        return specifier;
	    }
	
	    function getD3Locale(languageId) {
	        var localeObject = {};
	        var specifier = getSpecifier(languageId);
	        var d3_locale = d3.locale(specifier);
	        var originD3LocaleTimeFormat = d3_locale.timeFormat;
	        d3_locale.timeFormat = function(template) {
	            if ($.isFunction(template)) {
	                return template;
	            } else {
	                template = specifier[template] || template;
	                return originD3LocaleTimeFormat(template);
	            }
	        }
	        return $.extend(true, {}, d3_locale, specifier);
	    }
	
	    return {
	        getD3Locale: getD3Locale
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(61), __webpack_require__(20), __webpack_require__(62), __webpack_require__(63), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, indicator, request, response, autoCompleteDataManager, screener_eu) {
	    'use strict';
	    var $ = core.$;
	    var dateUtil = core.Widget.Chart.Util;
	
	    var model = function(managers) {
	        var chartDataManager = core.DataManager.Chart;
	        var eventManager = managers.eventManager;
	        var chartObj = {
	            id: 'markets-components-svgchart-' + Date.now(),
	            refreshChart: function() {
	                eventManager.trigger(eventManager.EventTypes.ChartDataUpdate);
	            }
	        };
	
	        var checkRequest = function(req) {
	            if (req instanceof request) {
	                return true;
	            }
	            return false;
	        };
	
	        var isIntraday = function(req) {
	            return !isNaN(req.frequency());
	        };
	
	        var isPortfolio = function(tickerObj) {
	            var mType = tickerObj.mType;
	            return mType === 'PO';
	        };
	
	        var isCustomBenchmark = function(tickerObj) {
	            return tickerObj.getField("benchmarkType") && tickerObj.getField("benchmarkType").length > 0;
	        };
	        var extractDataPoints = function(tickerObj, req, isMainTicker) {
	            var chartConfigManager = managers.chartConfigManager;
	            var isMutualFund = chartConfigManager.isMutualFund;
	            var type = req.priceType() || dataAdapter.PriceType.Default;
	            var events = req.events() || [];
	            var indicators = req.indicators() || [];
	            var chartCfg = chartConfigManager.getConfig();
	            var useEUTimeSeriesData = chartCfg.useEUTimeSeriesData && isNaN(req.frequency());
	
	            if (isMutualFund(tickerObj) && req.priceType() === 'pricenav') {
	                type = 'p_nav';
	            } else if (req.priceType() === 'pricenav') {
	                type = 'p_price';
	            } else if ((req.priceType() === dataAdapter.PriceType.Nav || req.priceType() === dataAdapter.PriceType.Default || req.priceType() === dataAdapter.PriceType.PriceWithDividendGrowth) && useEUTimeSeriesData) {
	                type = 'tsp';
	            } else if (req.priceType() === dataAdapter.PriceType.Growth && useEUTimeSeriesData) {
	                type = (chartCfg.growthType === "priceGrowth") ? "return_tsp" : 'tsc';
	            } else if (req.priceType() === dataAdapter.PriceType.Growth10K && useEUTimeSeriesData) {
	                type = (chartCfg.growthType === "performancesGrowth") ? "return_k_tsp" : 'k_tsc';
	            } else if (chartCfg.useDataApiTimeseriesData) {
	                if (req.priceType() === dataAdapter.PriceType.Growth10K) {
	                    type = isMutualFund(tickerObj) ? 'return_k_fact_nav' : 'return_k_fact_price';
	                } else if (req.priceType() === dataAdapter.PriceType.Growth) {
	                    type = isMutualFund(tickerObj) ? 'return_fact_nav' : 'return_fact_price';
	                } else {
	                    type = isMutualFund(tickerObj) ? 'fact_nav' : 'fact_price';
	                }
	            }
	            var dps = {
	                'p': type
	            };
	            if (req.priceType() === dataAdapter.PriceType.PriceWithDividendGrowth) {
	                if (useEUTimeSeriesData) {
	                    if (isMutualFund(tickerObj)) {
	                        dps.p = 'tsc';
	                        if (req.frequency() === 'm') {
	                            dps.growthPrice = 'tsp';
	                        }
	                    } else {
	                        dps.p = 'tsp';
	                    }
	                } else {
	                    if (isMutualFund(tickerObj)) {
	                        dps.p = dataAdapter.PriceType.Growth;
	                        dps.growthPrice = dataAdapter.PriceType.Nav;
	                    } else {
	                        dps.p = dataAdapter.PriceType.Default;
	                    }
	                }
	            }
	
	            if (chartCfg.showCrosshairOriginalData) {
	                if (useEUTimeSeriesData) {
	                    dps.originalPrice = 'tsp';
	                } else if (chartCfg.useDataApiTimeseriesData) {
	                    dps.originalPrice = isMutualFund(tickerObj) ? 'fact_nav' : 'fact_price';
	                } else {
	                    dps.originalPrice = isMutualFund(tickerObj) ? 'nav' : 'price';
	                }
	            }
	            req.dpType(type);
	            if (!isMutualFund(tickerObj) && !isCustomBenchmark(tickerObj) && !isPortfolio(tickerObj) && !useEUTimeSeriesData) {
	                dps['v'] = 'volume';
	            }
	            // only mainTicker need to fetch indicator, fundamental and events data
	            if (!isMainTicker) {
	                return dps;
	            }
	            var hasDividendEvent = false;
	            for (var i = 0, l = events.length, event; i < l; i++) {
	                event = events[i];
	                if (event === dataAdapter.Events.Dividend) {
	                    if (!dps['ds']) {
	                        dps['ds'] = {};
	                    }
	                    if (chartConfigManager.getConfig().showTSDividend || chartConfigManager.isITFund()) {
	                        dps['ds']['tsd'] = true;
	                    } else {
	                        dps['ds']['d'] = true;
	                    }
	                    hasDividendEvent = true;
	                } else if (event === dataAdapter.Events.Split) {
	                    if (!dps['ds']) {
	                        dps['ds'] = {};
	                    }
	                    dps['ds']['s'] = true;
	                } else if (event === dataAdapter.Events.Earnings) {
	                    if (chartConfigManager.isSemiEarningsExch()) {
	                        dps['e'] = 'se';
	                    } else {
	                        dps['e'] = 'e';
	                    }
	                }
	            }
	
	            var indicatorSize = indicators.length;
	            var needDividendEvent = false;
	            if (indicatorSize > 0) {
	                dps['indicators'] = [];
	                var pType = type;
	                for (var j = 0, ind, name, para, pType; j < indicatorSize; j++) {
	                    ind = indicators[j];
	                    name = ind.name();
	                    para = ind.parameter() || [];
	                    if (name === dataAdapter.IndicatorName.EMA || name === dataAdapter.IndicatorName.SMA) {
	                        for (var k = 0, kl = para.length; k < kl; k++) {
	                            dps['indicators'].push({
	                                name: name,
	                                p: [para[k]],
	                                pType: pType,
	                                growthBaseValue: req.growthBaseValue()
	                            });
	                        }
	                    } else {
	                        if (name === dataAdapter.IndicatorName.RDividend || name === dataAdapter.IndicatorName.DYield) {
	                            needDividendEvent = true;
	                        }
	                        dps['indicators'].push({
	                            name: name,
	                            p: para,
	                            pType: chartCfg.charts.mainChart.indicatorProperties.hasOwnProperty(name) ? pType : (isMutualFund(tickerObj) ? 'nav' : 'price')
	                        });
	                    }
	                }
	            }
	
	            if (needDividendEvent && !hasDividendEvent) {
	                if (!dps['ds']) {
	                    dps['ds'] = {};
	                }
	                dps['ds']['d'] = true;
	            }
	
	            var fundamentals = req.fundamentals() || [];
	            for (var f = 0, fl = fundamentals.length, fd; f < fl; f++) {
	                fd = fundamentals[f];
	                if (fd === dataAdapter.Fundamental.MReturnIndex) {
	                    dps[fd] = 'return';
	                } else {
	                    dps[fd] = 'fundamental';
	                }
	            }
	            return dps;
	        };
	
	        var generaterInfoList = function(req, dataPoints) {
	            var isMutualFund = managers.chartConfigManager.isMutualFund;
	            var tickerObjects = req.tickerObjects();
	            var infoList = [];
	            for (var i = 0, l = tickerObjects.length, tickerObj, info; i < l; i++) {
	                tickerObj = tickerObjects[i];
	                info = {
	                    type: isMutualFund(tickerObj) || isCustomBenchmark(tickerObj) || isPortfolio(tickerObj) ? '' : 'StockOrForex',
	                    chartType: req.chartType(),
	                    tickerObject: tickerObj,
	                    datapoints: dataPoints || extractDataPoints(tickerObj, req, i === 0),
	                    growthBaseValue: req.growthBaseValue()
	                };
	                if (req.priceType() === dataAdapter.PriceType.PriceWithDividendGrowth) {
	                    info.growthType = dataAdapter.PriceType.PriceWithDividendGrowth;
	                }
	                if (isIntraday(req)) {
	                    info.days = req.days();
	                } else {
	                    info.fields = req.fundamentals();
	                }
	                var chartCfg = managers.chartConfigManager.getConfig();
	                if (chartCfg.useEUTimeSeriesData) {
	                    info.apiSetting = chartCfg.EUTimeSeriesApiSetting || {};
	                    if (chartCfg.EUIWTPath) {
	                        info.apiSetting.euiwt = chartCfg.EUIWTPath;
	                    }
	                    info.solutionKey = chartCfg.solutionKey;
	                }
	                infoList.push(info);
	            }
	            return infoList;
	        };
	
	        var genCallback = function(callback) {
	            return typeof callback === 'function' ? callback : function() {};
	        };
	
	        var handleResponse = function(callback, req, data, status) {
	            if (typeof callback === 'function') {
	                var res = new response();
	                res.req(req).data(data);
	                if (status) {
	                    res.status(status);
	                }
	                callback(res);
	            }
	        };
	
	        var findDataItem = function(data, tickerId, currency) {
	            if (!data || data.length === 0) {
	                return null;
	            }
	            for (var i = 0; i < data.length; i++) {
	                if (data[i].secId === tickerId || (data[i].ISIN === tickerId && data[i].currency === currency)) {
	                    return data[i];
	                }
	            }
	            return null;
	        }
	
	        var buildTickerObjects = function(data, tickers) {
	            var ticker = function() {
	                return {
	                    valid: false,
	                    getField: function(field) {
	                        return !field ? this : this[field];
	                    },
	                    setData: function(data) {
	                        for (var d in data) {
	                            if (d === 'name') {
	                                this.Name = data[d];
	                            } else if (d === "SecId") {
	                                this.secId = data[d];
	                            } else {
	                                this[d] = data[d];
	                            }
	                        }
	                    },
	                    setField: function(field, value) {
	                        if (field) {
	                            this[field] = typeof(value) == "undefined" ? null : value;
	                        }
	                    }
	                }
	            };
	
	            var tickerObjects = [];
	            $.each(tickers, function(i, ot) {
	                var t = new ticker();
	                //ot FOUSA06CGQ]7]0]IXALL$$ALL|MSID|FundName@_Ticker@_currency
	                if (ot.indexOf('@_') > -1) {
	                    t.tsfund = true;
	                }
	                t.securityToken = index(ot.split('|'), 0);
	                t.tickerId = index(t.securityToken.split(']'), 0);
	                index(t.securityToken.split(']'), 0);
	                t.idType = index(ot.split('|'), 1) || 'Morningstar';
	                t.Name = index(ot.split('|'), 2);
	                if (/.+@\$(.+)/.test(ot)) {
	                    t.currency = ot.split('@\$')[1];
	                }
	                var item = findDataItem(data, t.tickerId, t.currency);
	                if (item) {
	                    t.valid = true;
	                    t.setData(item);
	                }
	                $.extend(true, securityCacheMap[t.tickerId], t);
	                tickerObjects.push(securityCacheMap[t.tickerId]);
	                var performanceTickers = [];
	                if (t.categoryId) {
	                    performanceTickers.push({
	                        id: t.categoryId,
	                        type: 'category',
	                        name: t.categoryName
	                    });
	                }
	                if (t.benchMarkId) {
	                    performanceTickers.push({
	                        id: t.benchMarkId,
	                        type: 'benchMark',
	                        name: t.benchMarkName
	                    });
	                }
	                $.each(performanceTickers, function(i, pt) {
	                    var pticker = new ticker();
	                    pticker.secId = pticker.symbol = pticker.ticker = pt.id;
	                    pticker.Name = pt.name;
	                    pticker.securityToken = pticker.secId + ']';
	                    pticker.idType = 'Morningstar';
	                    pticker.mType = pt.type === 'category' ? 'CA' : 'CB';
	                    pticker.currency = t.currency;
	                    pticker.valid = true;
	                    securityCacheMap[pticker.secId] = $.extend(true, securityCacheMap[pticker.secId], pticker);
	                });
	            });
	            return tickerObjects.sort(function(a, b) {
	                return a.order - b.order;
	            });
	        }
	
	        function index(arr, idx) {
	            if (arr.length >= idx) {
	                return arr[idx];
	            }
	            return null;
	        }
	
	        function getOriginalPriceData(originalPriceData, viewData) {
	            var formatedData = {};
	            if (originalPriceData && originalPriceData.length) {
	                for (var i = 0, l = originalPriceData.length; i < l; i++) {
	                    var dp = originalPriceData[i];
	                    var idx = dp[dp.length - 1],
	                        value = dp[1];
	                    formatedData[idx] = value;
	                }
	                for (var j = 0, preData = originalPriceData[0][1], l = viewData.length; j < l; j++) {
	                    var dp = viewData[j];
	                    var idx = dp[dp.length - 1];
	                    if (formatedData[idx]) {
	                        preData = formatedData[idx];
	                        continue;
	                    } else {
	                        formatedData[idx] = preData;
	                    }
	                }
	            }
	            return formatedData;
	        }
	        var formatPrice = function(jsonObject, d) {
	            var chartConfigManager = managers.chartConfigManager;
	            var isMutualFund = chartConfigManager.isMutualFund;
	            var isIntraday = !isNaN(d.fre);
	            var dp = 'Price';
	            var previousColse = d.price && d.price.preclose;
	            var priceData = d.price && d.price.data ? d.price.data : [];
	            var growthPriceData = d.growthPrice && d.growthPrice.data;
	            var baseInfo = null
	
	            var originalPriceData = getOriginalPriceData(d.originalPrice ? d.originalPrice.data : [], priceData);
	            var volumeData = d.volume && d.volume.data ? d.volume.data : [];
	            jsonObject[dp] = {
	                'lastTradeTime': d.price && d.price.lastTradeTime,
	                'epos': d.price && d.price.epos ? (+d.price.epos) : 0,
	                'spos': d.price && d.price.spos ? (+d.price.spos) : 0,
	                'data': [],
	                'currencyField': d.currencyField
	            };
	            var isPercentDataValues = chartConfigManager.isCompareOrPercentChart() && chartConfigManager.getMainDataType() !== chartConfigManager.MainDataTypes.Growth10K;
	            if (isPercentDataValues) {
	                var baseValue = chartConfigManager.getConfig().growthBaseValue;
	                if (chartConfigManager.getMainDataType() === chartConfigManager.MainDataTypes.Growth10K || baseValue) {
	                    previousColse = baseValue;
	                } else {
	                    previousColse = 0;
	                }
	            }
	            for (var j = 0, jl = priceData.length, pd, vd, temp, preTemp; j < jl; j++) {
	                pd = priceData[j];
	                vd = volumeData[j] || [];
	                var prevPdValue = j > 0 ? priceData[j - 1][1] : priceData[0][1];
	                var preColse = j > 0 ? getPreviousClose(priceData, j, previousColse) : previousColse;
	                var valueChange = pd[1] - prevPdValue;
	                var valueChangePercent = valueChange === 0 ? 0 : valueChange / prevPdValue * 100;
	                var index = pd[pd.length - 1];
	                if (isPercentDataValues) {
	                    valueChangePercent = valueChange / (prevPdValue / 100 + 1);
	                    if (jsonObject[dp].spos) {
	                        valueChange = jsonObject[dp].spos * valueChange / 100;
	                    }
	                }
	                if (pd.length >= 5) {
	                    temp = {
	                        'index': pd[0],
	                        'open': pd[4],
	                        'high': pd[2],
	                        'low': pd[3],
	                        'close': pd[1],
	                        'value': pd[1],
	                        'upFlag': pd[5],
	                        'updatedId': pd[pd.length - 2],
	                        'date': dateUtil.toDateFromIndexOrTick(index, isIntraday ? 0 : 1),
	                        'dateIndex': index,
	                        'originalPrice': originalPriceData[index],
	                        'previousColse': preColse
	                    };
	                    if (vd.length > 1) {
	                        temp['volume'] = vd[1];
	                    }
	                    isIntraday && (temp['fillFlag'] = pd[6]);
	                } else {
	                    temp = {
	                        'index': pd[0],
	                        'value': pd[1],
	                        'close': pd[1],
	                        'date': dateUtil.toDateFromIndexOrTick(index),
	                        'dateIndex': index,
	                        'originalPrice': originalPriceData[index]
	                    };
	                }
	                temp.valueChange = valueChange;
	                temp.valueChangePercent = valueChangePercent;
	                if (growthPriceData) {
	                    if (!baseInfo) {
	                        baseInfo = getBasePriceData(priceData, growthPriceData);
	                    }
	                    if (pd[pd.length - 1] >= baseInfo.index) {
	                        temp['growthWithNav'] = calculateGrowthWithNav(baseInfo.basePrice, pd[1] - baseInfo.baseGrowth);
	                        if (temp['growthWithNav']) {
	                            temp.valueChange = temp['growthWithNav'] - (preTemp ? preTemp.growthWithNav : 0);
	                            temp.valueChangePercent = preTemp ? temp.valueChange / preTemp['growthWithNav'] * 100 : 0;
	                            jsonObject[dp].data.push(temp);
	                            preTemp = $.extend(true, {}, temp);
	                        }
	                    }
	                } else {
	                    jsonObject[dp].data.push(temp);
	                }
	            }
	        };
	
	        function getBasePriceData(growthData, priceData) {
	            var basePrice = null;
	            var growthIndex = growthData[0][growthData[0].length - 1];
	            var baseIndex, baseGrowth;
	            for (var j = 0; j < priceData.length; j++) {
	                baseIndex = priceData[j][priceData[j].length - 1];
	                if (baseIndex >= growthIndex) {
	                    basePrice = priceData[j][1];
	                    if (baseIndex === growthIndex) {
	                        baseGrowth = growthData[0][1];
	                    }
	                    break;
	                }
	            }
	            if (!baseGrowth) {
	                for (var i = 0; i < growthData.length; i++) {
	                    if (growthData[i][growthData[i].length - 1] >= baseIndex) {
	                        baseGrowth = growthData[i][1];
	                        break;
	                    }
	                }
	            }
	            return {
	                basePrice: basePrice,
	                index: baseIndex,
	                baseGrowth: baseGrowth
	            };
	        }
	
	        function getPreviousClose(dataList, i, preClose) {
	            var _preClose = null;
	            for (var index = i; index > 0; index--) {
	                var pd = dataList[index - 1];
	                if (!isNaN(pd[1])) {
	                    _preClose = pd[1];
	                    break;
	                }
	            }
	            if (_preClose === null) {
	                _preClose = preClose;
	            }
	            return _preClose;
	        }
	
	        function calculateGrowthWithNav(base, growth) {
	            return growth === null ? NaN : (base + base * growth / 100);
	        }
	        var formatDividendAndSplitData = function(jsonObject, d) {
	            var data = d.dividendAndSplit || [];
	            var l = data.length;
	            if (l > 0) {
	                jsonObject['Events'] = jsonObject['Events'] || {};
	                var dp;
	                for (var i = 0, l = data.length, temp; i < l; i++) {
	                    temp = {
	                        'date': dateUtil.toDateFromIndexOrTick(data[i].DateIndex),
	                        'value': data[i].Desc,
	                        'dateIndex': data[i].DateIndex
	                    }
	                    dp = data[i].Type === 1 ? dataAdapter.Events.Dividend : dataAdapter.Events.Split;
	                    if (!jsonObject['Events'][dp]) {
	                        jsonObject['Events'][dp] = {
	                            'data': []
	                        };
	                    }
	                    jsonObject['Events'][dp].data.push(temp);
	                }
	            }
	        };
	
	        var formatEarnings = function(jsonObject, d) {
	            var data = d.earningsData && d.earningsData.data ? d.earningsData.data : [],
	                dp = dataAdapter.Events.Earnings;
	            var l = data.length;
	            if (l > 0) {
	                jsonObject['Events'] = jsonObject['Events'] || {};
	                jsonObject['Events'][dp] = {
	                    'spos': d.earningsData && d.earningsData.spos ? (+d.earningsData.spos) : 0
	                };
	                var cdata = [];
	                for (var i = 0, ed; i < l; i++) {
	                    ed = data[i];
	                    var md = {
	                        'date': dateUtil.toDateFromIndexOrTick(ed[ed.length - 1]),
	                        'upFlag': ed[2],
	                        'value': ed[1],
	                        'frequency': ed[3],
	                        'dateIndex': ed[ed.length - 1],
	                    }
	                    cdata.push(md);
	                }
	                jsonObject['Events'][dp]['data'] = cdata;
	            }
	        };
	
	        var formatIndicators = function(jsonObject, d, req) {
	            var isIntraday = !isNaN(d.fre);
	            var data = d.indicators ? d.indicators : {};
	            var indData;
	            var IndicatorName = dataAdapter.IndicatorName;
	            for (var indName in data) {
	                jsonObject['Indicators'] = jsonObject['Indicators'] || {};
	                indData = data[indName];
	                switch (indName) {
	                    case IndicatorName.SMA:
	                    case IndicatorName.EMA:
	                        formatSMAEMA(jsonObject['Indicators'], indName, indData, isIntraday);
	                        break;
	                    case IndicatorName.BBands:
	                    case IndicatorName.MACD:
	                    case IndicatorName.RSI:
	                    case IndicatorName.SStochastic:
	                    case IndicatorName.FStochastic:
	                    case IndicatorName.DMI:
	                    case IndicatorName.PChannel:
	                    case IndicatorName.MAE:
	                    case IndicatorName.Keltner:
	                        formatOther(jsonObject['Indicators'], indName, indData, isIntraday, req);
	                        break;
	                    case IndicatorName.ROC:
	                    case IndicatorName.CCI:
	                    case IndicatorName.PSAR:
	                    case IndicatorName.WillR:
	                    case IndicatorName.SMAV:
	                    case IndicatorName.Momentum:
	                    case IndicatorName.ULT:
	                    case IndicatorName.MFI:
	                    case IndicatorName.VAcc:
	                    case IndicatorName.UDRatio:
	                    case IndicatorName.OBV:
	                    case IndicatorName.DYield:
	                    case IndicatorName.FVolatility:
	                    case IndicatorName.WMA:
	                    case IndicatorName.AccDis:
	                    case IndicatorName.Mass:
	                    case IndicatorName.Volatility:
	                    case IndicatorName.ForceIndex:
	                    case IndicatorName.ATR:
	                    case IndicatorName.RDividend:
	                    case IndicatorName.PrevClose:
	                        formatOther(jsonObject['Indicators'], indName, [indData], isIntraday, req);
	                        break;
	                    case IndicatorName.VBP:
	                        formatVBP(jsonObject['Indicators'], indData.data);
	                        break;
	                }
	            };
	        };
	
	        var formatSMAEMA = function(jsonObject, indName, indData, isIntraday) {
	            indData = indData || {};
	            var spos, data, cdata, i = 0;
	            for (var key in indData) {
	                spos = indData[key].spos;
	                data = indData[key].data;
	                if (!jsonObject[indName]) {
	                    jsonObject[indName] = [];
	                }
	                cdata = [];
	                for (var i = 0, l = data.length, d; i < l; i++) {
	                    d = data[i];
	                    cdata.push({
	                        'index': d[0],
	                        'date': dateUtil.toDateFromIndexOrTick(d[d.length - 1], isIntraday ? 0 : 1),
	                        'value': d[1],
	                        'dateIndex': d[d.length - 1]
	                    });
	                }
	                jsonObject[indName].push({
	                    'data': cdata,
	                    'spos': spos ? (+spos) : 0,
	                    'parameter': +key
	                })
	            }
	        };
	
	        var formatVBP = function(jsonObject, data) {
	            var indName = "VBP";
	            if (data.length == 3) {
	                jsonObject[indName] = {
	                    'data': [],
	                    'range': data[1],
	                    'totalVolume': data[2]
	                }
	                for (var i = 0, l = data[0].length, d; i < l; i++) {
	                    d = data[0][i];
	                    if (d.length < 5) continue;
	                    jsonObject[indName]['data'].push({
	                        'range': [d[0], d[1]],
	                        'totalVolume': d[2],
	                        'upVolume': d[3],
	                        'downVolume': d[4]
	                    });
	                }
	            }
	        };
	
	        var formatOther = function(jsonObject, indName, indData, isIntraday, req) {
	            indData = indData || [];
	            var l = indData.length;
	            if (l > 0) {
	                var para = indicatorPara(indName, req.indicators()) || [];
	                var spos, data, cdata, ind;
	                jsonObject[indName] = [];
	                for (var i = 0; i < l; i++) {
	                    spos = indData[i].spos;
	                    data = indData[i].data;
	                    cdata = [];
	                    for (var j = 0, jl = data.length, d, spos; j < jl; j++) {
	                        d = data[j];
	                        cdata.push({
	                            'index': d[0],
	                            'date': dateUtil.toDateFromIndexOrTick(d[d.length - 1], isIntraday ? 0 : 1),
	                            'value': +d[1],
	                            'dateIndex': d[d.length - 1]
	                        });
	                    }
	                    ind = {
	                        'data': cdata,
	                        'spos': spos ? (+spos) : 0
	                    };
	                    if (typeof para[i] !== 'undefined') {
	                        ind['parameter'] = +para[i];
	                    }
	                    if (indData[i]['DailyDataPoint']) {
	                        ind['DailyDataPoint'] = true;
	                    }
	                    jsonObject[indName].push(ind);
	                }
	            }
	
	        };
	
	        var indicatorPara = function(indName, indicators) {
	            var para = [];
	            for (var i = 0, l = indicators.length, ind; i < l; i++) {
	                ind = indicators[i];
	                if (ind.name() === indName) {
	                    para = ind.parameter();
	                    break;
	                }
	            }
	            return para;
	        };
	
	        var formatFundamental = function(jsonObject, d) {
	            for (var key in dataAdapter.Fundamental) {
	                if (!d[key]) continue;
	                var fundData = d[key].data || [];
	                if (fundData.length > 0 || d[key]['DailyDataPoint']) {
	                    jsonObject['Fundamentals'] = jsonObject['Fundamentals'] || {};
	                    jsonObject['Fundamentals'][key] = {};
	                    if (d[key]['DailyDataPoint']) {
	                        jsonObject['Fundamentals'][key]['DailyDataPoint'] = true;
	                        jsonObject['Fundamentals'][key]['data'] = [];
	                    } else {
	                        var cdata = [];
	                        for (var i = 0, l = fundData.length, fd; i < l; i++) {
	                            fd = fundData[i];
	                            cdata.push({
	                                'index': fd[0],
	                                'date': dateUtil.toDateFromIndexOrTick(fd[fd.length - 1]),
	                                'value': fd[1],
	                                'dateIndex': fd[fd.length - 1]
	                            });
	                        }
	                        jsonObject['Fundamentals'][key] = {
	                            'spos': d[key].spos ? (+d[key].spos) : 0,
	                            'data': cdata
	                        };
	                    }
	                }
	            }
	        };
	
	        var formatTSData = function(data, req, growthPrice) {
	            data = data || [];
	            var ret = [],
	                jsonArray, jsonObject, d, freq, priceData, volumeData;
	            for (var i = 0, l = data.length; i < l; i++) {
	                d = data[i];
	                jsonArray = [];
	                jsonObject = {
	                    'tickerObject': d.tickerObject
	                };
	                if (d.mifidExcludedPeriod) {
	                    jsonObject.mifidExcludedPeriod = d.mifidExcludedPeriod;
	                }
	                if (growthPrice && growthPrice[i]) {
	                    d.growthPrice = growthPrice[i].growthPrice;
	                }
	                formatPrice(jsonObject, d);
	                formatDividendAndSplitData(jsonObject, d);
	                formatEarnings(jsonObject, d);
	                formatIndicators(jsonObject, d, req);
	                formatFundamental(jsonObject, d);
	                ret.push(jsonObject);
	            }
	            return ret;
	        };
	
	        var matchKeyWord = function(obj, keyword) {
	            var reg = new RegExp(keyword, "i");
	            return obj.ticker.match(reg) || obj.name.match(reg) || obj.ISIN.match(reg);
	        };
	
	        var formatAutocompleteData = function(data, params) {
	            var config = managers.chartConfigManager.getConfig();
	            var category = params.autoComplete.category;
	            if (!params.autoComplete.needFilter) {
	                category = [];
	                for (var cat in data) {
	                    category.push(cat);
	                }
	            }
	            var nonFilterCategoryMap = params.autoComplete.nonFilterCategoryMap;
	            var isAutocompleteGroup = config.autoComplete.group;
	            var orgainzedArray = [];
	            var max = isAutocompleteGroup ? config.autoComplete.categoryMaxCount : config.autoComplete.noGroupMaxCount;
	            if (params.autoComplete.dataSource === 'EU') {
	                max = params.autoComplete.maxCount;
	            }
	            if (!isAutocompleteGroup) {
	                var allData = [];
	                $.each(category, function(idx, cate) {
	                    var categoryData = data[cate] || [];
	                    if (categoryData.length > 0) {
	                        allData = allData.concat(categoryData);
	                    }
	                });
	                category = ['Securities'];
	                data = {
	                    'Securities': allData
	                };
	            }
	            $.each(category, function(idx, cate) {
	                var categoryData = data[cate] || [];
	                if (categoryData.length > 0) {
	                    var json = {
	                        catName: cate,
	                        results: []
	                    };
	                    for (var i = 0, l = Math.min(max, categoryData.length), d; i < l; i++) {
	                        var d = $.extend(true, {}, categoryData[i]);
	                        if (nonFilterCategoryMap.All !== true && nonFilterCategoryMap[cate] !== true && !matchKeyWord(d, params.queryKey)) continue;
	                        json.results.push(d);
	                    }
	                    orgainzedArray.push(json);
	                }
	            });
	
	            return orgainzedArray;
	        };
	
	
	        var securityCacheMap = {};
	        var dataAdapter = {
	            ready: false,
	            init: function() {
	                if (!this.ready) {
	                    chartDataManager.volumeDividend(1);
	                    this.ready = true;
	                }
	            },
	            getSecurityObjects: function(tickerId) {
	                return securityCacheMap[tickerId];
	            },
	            createTickerObjects: function(tickers, callback) {
	                var rootCfg = managers.chartConfigManager.getConfig();
	                chartObj.autoRefresh = rootCfg.isAutoRefresh;
	                var self = this;
	                if (rootCfg.useEUSecurityData) {
	                    //FOUSA06CGQ]7]0]IXALL$$ALL|MSID|FundName@_Ticker@_Currency
	                    var filters = [],
	                        filter, idType, currency, tickerId, queryList = [];
	                    $.each(tickers, function(i, ticker) {
	                        idType = ticker.split('|')[1];
	                        if (idType && idType.toUpperCase() === 'ISIN') {
	                            tickerId = ticker.split('|')[0];
	                            idType = 'ISIN';
	                            filter = 'ISIN:EQ:' + tickerId;
	                            if (/.+@\$(.+)/.test(ticker)) {
	                                currency = ticker.split('@\$')[1];
	                                filter += '|currencyId:CONTAINS:' + currency;
	                            }
	                            queryList.push(self.requestEUScreener({
	                                euiwt: rootCfg.EUIWTPath,
	                                solutionKey: rootCfg.solutionKey,
	                                languageId: rootCfg.lang,
	                                filters: filter
	                            }));
	                        } else {
	                            tickerId = ticker.split('|')[0].split(']')[0];
	                            idType = 'secId';
	                            filters.push(tickerId);
	                        }
	                        securityCacheMap[tickerId] = {};
	                        securityCacheMap[tickerId].originalTicker = ticker;
	                        securityCacheMap[tickerId].order = i;
	                    });
	                    if (filters.length > 0) {
	                        filters.unshift('secId', 'IN');
	                    }
	                    filters = filters.join(':');
	                    if (filters !== "") {
	                        queryList.push(self.requestEUScreener({
	                            euiwt: rootCfg.EUIWTPath,
	                            solutionKey: rootCfg.solutionKey,
	                            languageId: rootCfg.lang,
	                            filters: filters
	                        }));
	                    }
	                    $.when.apply($, queryList).done(function() {
	                        var tickerObjs = [];
	                        for (var i = 0; i < arguments.length; i++) {
	                            tickerObjs = tickerObjs.concat(arguments[i].tickers);
	                        }
	                        genCallback(callback)(buildTickerObjects(tickerObjs, tickers));
	                    });
	                } else {
	                    core.TickerFactory.create(tickers, {
	                        onSuccess: function(tickerObjects) {
	                            for (var i = 0; i < tickerObjects.length; i++) {
	                                managers.chartConfigManager.isMutualFund(tickerObjects[i]);
	                            }
	                            genCallback(callback)(tickerObjects);
	                        }
	                    });
	                }
	            },
	            requestEUScreener: function(params) {
	                var def = $.Deferred();
	                screener_eu.fetchData(params, {
	                    onSuccess: function(data) {
	                        def.resolve(data);
	                        //  genCallback(callback)(buildTickerObjects(data.tickers, tickers));
	                    }
	                });
	                return def;
	            },
	            registerChartTickers: function(tickerObjects) {
	                this.init();
	                chartDataManager.registerSymbol(chartObj, tickerObjects);
	            },
	            unregisterChartTickers: function(tickerObjects) {
	                this.init();
	                chartDataManager.unregisterSymbol(chartObj, tickerObjects);
	            },
	            extractDataPoints: function(tickerObj, req) {
	                this.init();
	                if (checkRequest(req)) {
	                    extractDataPoints(tickerObj, req);
	                }
	            },
	            fetchTSData: function(req, callback) {
	                this.init();
	                if (checkRequest(req)) {
	                    var infoList = generaterInfoList(req);
	                    var dateRange = req.dateRange();
	                    var startIndex = dateUtil.toDateIndex(dateRange[0]);
	                    var endIndex = dateUtil.toDateIndex(dateRange[1]);
	                    if (isIntraday(req)) {
	                        chartDataManager.getIntradayData(infoList, req.frequency(), startIndex, endIndex, function(data) {
	                            handleResponse(callback, req, formatTSData(data, req));
	                        }, req.isPreAfter(), chartObj.id);
	                    } else {
	                        if (managers.chartConfigManager.getConfig().useEUTimeSeriesData && req.priceType() === dataAdapter.PriceType.PriceWithDividendGrowth && req.frequency() !== 'm') {
	                            chartDataManager.getHistoricalData(generaterInfoList(req, {
	                                growthPrice: 'tsp'
	                            }), 'd', Math.max(startIndex - 7, 0), endIndex, function(growthPriceData) {
	                                chartDataManager.getHistoricalData(infoList, req.frequency(), startIndex, endIndex, function(data) {
	                                    handleResponse(callback, req, formatTSData(data, req, growthPriceData));
	                                }, req.keepDateRange(), req.alignMainTicker());
	                            }, req.keepDateRange(), req.alignMainTicker());
	                        } else {
	                            chartDataManager.getHistoricalData(infoList, req.frequency(), startIndex, endIndex, function(data) {
	                                handleResponse(callback, req, formatTSData(data, req));
	                            }, req.keepDateRange(), req.alignMainTicker());
	                        }
	                    }
	                } else {
	                    handleResponse(callback, req, null, response.Status.InvalidRequest);
	                }
	            },
	            fetchRelatedTickersAndMajorIndexData: function(req, callback) {
	                this.init();
	                if (checkRequest(req)) {
	                    var tickerObjects = req.tickerObjects();
	                    if (tickerObjects.length > 0) {
	                        var mainTicker = tickerObjects[0];
	                        var mainTickerType = mainTicker["mType"] || "";
	                        var pID = mainTicker.performanceId || mainTicker.secId;
	                        if (pID) {
	                            autoCompleteDataManager.fetchRelatedTickersAndMajorIndexData(pID, mainTickerType, function(data, pID) {
	                                handleResponse(callback, req, data);
	                            });
	                        } else {
	                            handleResponse(callback, req, null, response.Status.NoData);
	                        }
	                    } else {
	                        handleResponse(callback, req, null, response.Status.InvalidRequest);
	                    }
	                } else {
	                    handleResponse(callback, req, null, response.Status.InvalidRequest);
	                }
	            },
	            fetchAutocompleteData: function(req, callback) {
	                this.init();
	                if (checkRequest(req)) {
	                    var config = managers.chartConfigManager.getConfig();
	                    if (typeof config.autoComplete.needFilter === "undefined") {
	                        config.autoComplete.needFilter = config.autoComplete.dataSource === "EU" ? false : true;
	                    }
	                    var params = {
	                        euiwt: config.EUIWTPath,
	                        solutionKey: config.solutionKey,
	                        autoComplete: $.extend(true, {}, config.autoComplete, {
	                            category: req.category(),
	                            nonFilterCategory: req.nonFilterCategory()
	                        }),
	                        lang: config.lang,
	                        queryKey: req.keyword()
	                    };
	                    autoCompleteDataManager.fetchData(params, function(data, params) {
	                        data = formatAutocompleteData(data, params);
	                        if (data.length > 0) {
	                            handleResponse(callback, req, data);
	                        } else {
	                            handleResponse(callback, req, null, response.Status.NoData);
	                        }
	                    });
	                } else {
	                    handleResponse(callback, req, null, response.Status.InvalidRequest);
	                }
	            },
	
	            getLastTradeDate: function(tickerObjects) {
	                var deferred = $.Deferred();
	                var needQuery = tickerObjects.filter(function(item) {
	                    return !item.lastTradeDate;
	                });
	                var secIds = needQuery.map(function(item) {
	                    return item.secId;
	                });
	                core.Util.ajax({
	                    url: core.serviceManager.url("@web/ra/snapshotData"),
	                    type: 'GET',
	                    dataType: 'json',
	                    timeout: 100000,
	                    data: {
	                        "fields": "navLastTradeDate,priceLastTradeDate,ctLastTradeDate",
	                        "tickers": secIds.join(',')
	                    },
	                    success: function(res) {
	                        var data = (res && res.Data) || [];
	                        needQuery.forEach(function(item) {
	                            var targetData = data.filter(function(d) {
	                                return d.ticker === item.secId
	                            })[0];
	                            if (targetData) {
	                                if (managers.chartConfigManager.isMutualFund(item)) {
	                                    item.tradeDate = targetData.navLastTradeDate;
	                                } else if (managers.chartConfigManager.isCategory(item)) {
	                                    item.tradeDate = targetData.ctLastTradeDate
	                                } else {
	                                    item.tradeDate = targetData.priceLastTradeDate;
	                                }
	                                if (item.tradeDate) {
	                                    item.tradeDate = item.tradeDate.replace(/(\d{2})-(\d{2})-(\d{4})/, '$3/$1/$2')
	                                }
	                            }
	                        });
	                        deferred.resolve();
	                    },
	                    error: function(e) {
	                        deferred.resolve();
	                    }
	                });
	                return deferred;
	            },
	
	            getDrawings: function(tickerObj, callback) {
	                var eventType = 'ch_v3_draw,chartdraw';
	                chartDataManager.getDrawings(tickerObj, undefined, callback, eventType);
	            },
	            saveLastDrawing: function(tickerObj, type, point, callback) {
	                var eventType = 'ch_v3_draw';
	                chartDataManager.saveLastDrawing(tickerObj, type, point, callback, eventType);
	            },
	            // transfrom sdk to svgchart 
	            getSaveChartSettings: function(params, callback) {
	                core.Util.ajax({
	                    type: 'GET',
	                    url: core.serviceManager.url('@web') + 'ra/getUserTemplateInfo',
	                    data: params,
	                    dataType: 'jsonp',
	                    success: function(res) {
	                        var resData = res.Data;
	                        var resObj = {}
	                        if (resData) {
	                            Object.keys(resData).forEach(function(params) {
	                                var obj = {};
	                                Object.keys(resData[params]).forEach(function(e) {
	                                    obj[e] = resData[params][e];
	                                    if (e === 'Profile') {
	                                        obj[e] = JSON.parse(resData[params][e]) || {};
	                                    }
	                                })
	                                resObj[params] = obj;
	                            })
	                        }
	                        callback(resObj);
	                    },
	                    error: function(e) {
	                        callback({});
	                    }
	                });
	            },
	            updateDrawing: function(tickerObj, type, point, callback) {
	                chartDataManager.updateDrawing(tickerObj, type, point, callback);
	            },
	            removeDrawing: function(tickerObj, type, point, callback) {
	                chartDataManager.removeDrawing(tickerObj, type, point, callback);
	            },
	            IndicatorName: {
	                SMA: 'SMA',
	                EMA: 'EMA',
	                BBands: 'BBands',
	                MACD: 'MACD',
	                RSI: 'RSI',
	                ROC: 'ROC',
	                CCI: 'CCI',
	                SStochastic: 'SStochastic',
	                FStochastic: 'FStochastic',
	                PSAR: 'PSAR',
	                WillR: 'WillR',
	                SMAV: 'SMAV',
	                DMI: 'DMI',
	                PChannel: 'PChannel',
	                MAE: 'MAE',
	                Momentum: 'Momentum',
	                ULT: 'ULT',
	                MFI: 'MFI',
	                VAcc: 'VAcc',
	                UDRatio: 'UDRatio',
	                OBV: 'OBV',
	                VBP: 'VBP',
	                DYield: 'DYield',
	                FVolatility: 'FVolatility',
	                WMA: 'WMA',
	                AccDis: 'AccDis',
	                Mass: 'Mass',
	                Volatility: 'Volatility',
	                ForceIndex: 'ForceIndex',
	                ATR: 'ATR',
	                Keltner: 'Keltner',
	                RDividend: 'RDividend',
	                PrevClose: 'PrevClose'
	            },
	            PriceType: {
	                Default: 'price',
	                Nav: 'nav',
	                Growth: 'return',
	                Growth10K: 'return_k',
	                PostTax: 'postTax',
	                TotalReturn: 'total_return',
	                MarketValue: 'market_value',
	                PriceAndNav: 'pricenav',
	                PriceWithDividendGrowth: 'priceWithDividendGrowth',
	                PriceWithDividendGrowthReturn: 'return_pdg',
	                PostTaxReturn: 'return_postTax'
	            },
	            Events: {
	                Dividend: 'dividend',
	                Split: 'split',
	                Earnings: 'earnings'
	            },
	            Fundamental: {
	                PE: 'PE',
	                PS: 'PS',
	                PB: 'PB',
	                PC: 'PC',
	                FairValue: 'FairValue',
	                QuantitativeFairValue: 'QuantitativeFairValue',
	                SInterest: 'SInterest',
	                REPS: 'REPS',
	                MReturnIndex: 'MReturnIndex', // it is used for draw dividend Effect chart
	                DiscountCumFair: 'DiscountCumFair',
	                DailyCumFairNav: 'DailyCumFairNav',
	                PremiumDiscount: 'PremiumDiscount',
	                FundSize: 'FundSize',
	                ShareholdersNumber: 'ShareholdersNumber'
	            },
	            Request: request,
	            Response: response,
	            Indicator: indicator
	        };
	
	        return dataAdapter;
	    }
	
	    return model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    'use strict';
	
	    function Indicator(name, parameter) {
	        var name = name;
	        var parameter = parameter;
	
	        this.name = function(value) {
	            if (!arguments.length) {
	                return name;
	            }
	            name = value;
	            return this;
	        };
	
	        this.parameter = function(value) {
	            if (!arguments.length) {
	                return parameter;
	            }
	            parameter = value;
	            return this;
	        };
	    }
	
	    return Indicator;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(20)], __WEBPACK_AMD_DEFINE_RESULT__ = function(request) {
	    'use strict';
	
	    function Response() {
	        var req = new request();
	        var data = null;
	        var status = Response.Status.Success;
	
	        this.req = function(value) {
	            if (!arguments.length) {
	                return req;
	            }
	            req = value;
	            return this;
	        };
	
	        this.data = function(value) {
	            if (!arguments.length) {
	                return data;
	            }
	            data = value;
	            return this;
	        };
	
	        this.status = function(value) {
	            if (!arguments.length) {
	                return status;
	            }
	            status = value;
	            return this;
	        };
	    };
	
	    Response.Status = {
	        InvalidRequest: {
	            errorCode: '-1',
	            errorMessage: 'Invalid request'
	        },
	        NoData: {
	            errorCode: '-2',
	            errorMessage: 'No Data'
	        },
	        Success: {
	            errorCode: '0',
	            errorMessage: 'Success'
	        }
	    };
	
	    return Response;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(57), __webpack_require__(64), __webpack_require__(65)], __WEBPACK_AMD_DEFINE_RESULT__ = function(staticConfig, autocomplete_us, autocomplete_eu) {
	    'use strict';
	
	    var acDataManager = {
	        //Fields: autocomplete_us.Fields,
	        //Securities: staticConfig.Securities,
	        fetchData: function(params, callback) {
	            if (params.autoComplete.dataSource.toUpperCase() === 'EU') {
	                autocomplete_eu.fetchData(params, callback);
	            } else {
	                autocomplete_us.fetchData(params, callback);
	            }
	        },
	        fetchRelatedTickersAndMajorIndexData: autocomplete_us.fetchRelatedTickersAndMajorIndexData
	    };
	    return acDataManager;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(57)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, staticConfig) {
	    'use strict';
	
	    var cache = {};
	    var cacheCallback = {};
	
	    var getCacheKey = function(key, condition) {
	        return 'kw=' + key + '&condition=' + condition;
	    };
	
	    var generaterCondition = function(category) {
	        var ret = [],
	            unique = {};
	        for (var i = 0, l = category.length, cat, conditions; i < l; i++) {
	            cat = category[i];
	            conditions = categoryConditionMapping[cat];
	            if (!categoryConditionMapping[cat]) continue;
	            for (var j = 0, jl = conditions.length, cond; j < jl; j++) {
	                cond = conditions[j];
	                if (/^ST/.test(cond)) {
	                    cond = 'ST';
	                }
	                if (unique[cond]) continue;
	                unique[cond] = true;
	                ret.push(cond);
	            }
	        }
	        return ret.join(',');
	        //return 'ST,FE,FC,XI,FO,1,2,7,8,9,10,20';
	    };
	
	    function getExchange(exchId, micCode) {
	        var exch;
	        if (exchId) {
	            exch = core.DataManager._getExchangeMap()[exchId] || '';
	        }
	        if (!exch && micCode) {
	            exch = core.DataManager._getMICExangeMap()[micCode] || micCode || '';
	        }
	        return exch.replace(/\$/ig, '');
	    }
	
	    var dataOnArrived = function(data) {
	        var requestId = data.id,
	            result = data.result || [],
	            iData = {};
	        //var GB_AC_FIELD = acDataManager.Fields;
	        for (var i = 0, l = result.length, item, micCode, securityName, securityName2, r; i < l; i++) {
	            item = result[i];
	            if (!item) continue;
	            if (item.AC003 === '20') { //forex
	                item.OS001 = item.OS001 || item.AC009.substr(6);
	                item.Name = item.Name || item.AC010;
	                item.LS01Z = item.LS01Z || item.AC011;
	                item.AC018 = item.AC018 === '200' ? '213' : item.AC018;
	            }
	            //securityType = item.OS010.toUpperCase();
	            micCode = (item.LS01Z || '').substr(6).replace(/\$/ig, '');
	            // securityType = item[GB_AC_FIELD["SecurityType"]].toUpperCase();
	            // if (securityType === 'FOREX') {
	            //     item[GB_AC_FIELD['Ticker']] = item[GB_AC_FIELD['TFForexTicker']].replace('FLIT', '');
	            //     item[GB_AC_FIELD['Name']] = item[GB_AC_FIELD['TFForexName']];
	            //     item[GB_AC_FIELD['MICCode']] = item[GB_AC_FIELD['TFForexMIC']]; //
	            // } else {
	            //     item[GB_AC_FIELD['MICCode']] = item[GB_AC_FIELD['MICCode']].substr(6).replace(/\$/ig, '');
	            // }
	
	            // if (item[GB_AC_FIELD['TFSecurityType']] == 20) { //forex
	            //     if (item[GB_AC_FIELD['TFExchangeID']] == 200 && item[GB_AC_FIELD['TFForexExchangeID']] == 213) {
	            //         item[GB_AC_FIELD['TFExchangeID']] = 213;
	            //     }
	            // }
	
	            if (!core.DataManager._checkAutoCompletePermission(micCode, item.AC018, item.AC003)) {
	                continue;
	            }
	            if ((item.AC003 === '8' && !item.OS001 && item.AC018 === '127') || item.AC003 === '18') {
	                item.OS001 = 'ST';
	            }
	            if (item.AC018 && item.AC003 && item.AC001) {
	                item.TenforeId = [item.AC018, item.AC003, item.AC001].join('.');
	            }
	
	            securityName = staticConfig.Securities[item.OS010] || staticConfig.Securities[item.AC003];
	
	            if (!iData[securityName]) {
	                iData[securityName] = [];
	            }
	            r = {
	                identifier: item.TenforeId || item.OS06Y || item.SecId || '',
	                ticker: item.OS001 || item.AC001 || item.ClientTicker || item.OS06Y || item.SecId || '',
	                name: item.OS01W || item.AC020 || '',
	                exch: getExchange(item.AC018, micCode),
	                ISIN: item.OS05J || '',
	                category: securityName,
	                type: securityName,
	                secId: item.SecId
	            };
	            iData[securityName].push(r);
	
	            securityName2 = null;
	            if (item.OS010 === 'ST' || item.AC003 === '1') {
	                if (item.AA0A6 === '1') {
	                    securityName2 = "STADR";
	                } else if (item.ST816) {
	                    securityName2 = "ST" + item.ST816;
	                }
	            }
	
	            if (securityName2) {
	                securityName2 = staticConfig.Securities[securityName2];
	                if (securityName2) {
	                    if (!iData[securityName2]) {
	                        iData[securityName2] = [];
	                    }
	                    iData[securityName2].push($.extend({}, r, {
	                        category: securityName2,
	                        type: securityName2
	                    }));
	                }
	            }
	
	            // if (!ticker && item[GB_AC_FIELD['TFTicker']] && item[GB_AC_FIELD['TFTicker']]) {
	            //     item[GB_AC_FIELD['Ticker']] = item[GB_AC_FIELD['TFTicker']];
	            //     ticker = item[GB_AC_FIELD['TFTicker']];
	            // }
	            // if (!item[GB_AC_FIELD['UserTicker']]) {
	            //     item[GB_AC_FIELD['UserTicker']] = ticker;
	            // }
	            // if (!item[GB_AC_FIELD['Name']] || item[GB_AC_FIELD['Name']] == '') { //TFName
	            //     item[GB_AC_FIELD['Name']] = (item[GB_AC_FIELD['TFName']] || '');
	            // }
	
	            // if (!item.OS06Y) {
	            //     if ((securityType == 2 || securityType == 7) && item[GB_AC_FIELD['TFTicker']]) {
	            //         item[GB_AC_FIELD['PerformanceId']] = item[GB_AC_FIELD['TFTicker']];
	            //     } else if (item[GB_AC_FIELD['TFExchangeID']] && item[GB_AC_FIELD['TFSecurityType']] && item[GB_AC_FIELD['TFTicker']]) {
	            //         item[GB_AC_FIELD['PerformanceId']] = item[GB_AC_FIELD['TFExchangeID']] + '.' + item[GB_AC_FIELD['TFSecurityType']] + '.' + item[GB_AC_FIELD['TFTicker']];
	            //     } else if (securityType === 'FOREX') {
	            //         item[GB_AC_FIELD['PerformanceId']] = item[GB_AC_FIELD['TFForexTicker']]
	            //     }
	            // }
	
	            // performanceId = item[GB_AC_FIELD['PerformanceId']] || item[GB_AC_FIELD['SecId']];
	
	            // if (unqiuePerformanceIds[performanceId]) { //reduplicative remove 
	            //     continue;
	            // }
	
	            // if ((item[GB_AC_FIELD['TFSecurityType']] == 8 && !item[GB_AC_FIELD['SecurityType']] && ticker[GB_AC_FIELD['TFExchangeID']] == 127) || item[GB_AC_FIELD['TFSecurityType']] == 18) {
	            //     item[GB_AC_FIELD['SecurityType']] = 'ST';
	            // }
	
	            // !item[GB_AC_FIELD['SecurityType']] && (item[GB_AC_FIELD['SecurityType']] = item[GB_AC_FIELD['TFSecurityType']]);
	
	            // if (!item[GB_AC_FIELD['SecurityType']] || item[GB_AC_FIELD['MICCode']] == 'XMEX') {
	            //     continue;
	            // }
	
	            // securityName = staticConfig.Securities[item[GB_AC_FIELD['SecurityType']]];
	            // securityName = securityName || staticConfig.Securities[item[GB_AC_FIELD['TFSecurityType']]];
	            // if (!iData[securityName]) {
	            //     iData[securityName] = [];
	            // }
	
	            // unqiuePerformanceIds[performanceId] = true;
	            // iData[securityName].push({
	            //     identifier: item.TenforeId || item.PerformanceId || item.SecId,
	            //     ticker: item.Symbol || item.Ticker || index(tenforeInfo, 2) || item.PerformanceId || item.SecId,
	            //     name: item.Name,
	            //     exch: getExchange(index(tenforeInfo, 0), item.MIC),
	            //     ISIN: item.ISIN,
	            //     type: getMorningstarType(item.HoldingTypeId)
	            // });
	
	            // var securityName2 = null;
	            // if (item[GB_AC_FIELD['SecurityType']].toUpperCase() === 'ST' || item[GB_AC_FIELD['TFSecurityType']] === '1') {
	            //     if (item[GB_AC_FIELD["isADR"]] === '1') {
	            //         securityName2 = "STADR";
	            //     } else if (item[GB_AC_FIELD["SecurityType2"]]) {
	            //         securityName2 = "ST" + item[GB_AC_FIELD["SecurityType2"]];
	            //     }
	            // }
	
	            // if (securityName2) {
	            //     securityName2 = staticConfig.Securities[securityName2];
	            //     if (securityName2) {
	            //         if (!iData[securityName2]) {
	            //             iData[securityName2] = [];
	            //         }
	            //         iData[securityName2].push(item);
	            //     }
	            // }
	        }
	        cache[cacheCallback[requestId].cacheKey] = {
	            data: iData,
	            params: cacheCallback[requestId].params
	        };
	
	        if (typeof cacheCallback[requestId].callback === 'function') {
	            cacheCallback[requestId].callback(iData, cacheCallback[requestId].params);
	            cacheCallback[requestId].callback = null;
	            delete cacheCallback[requestId].callback;
	        }
	    };
	
	    var saveDataIntoCache = function(dataObj, requestId) {
	        var RealtedRequestId = requestId;
	        var queryKey = cacheCallback[requestId].queryKey || '';
	
	        var iData = [];
	        for (var name in dataObj) {
	            var _dataObj = {};
	            _dataObj["catName"] = name;
	            _dataObj["results"] = [];
	            var __data = dataObj[name].Data || [];
	            for (var i = 0; i < __data.length; i++) {
	                var _data = __data[i];
	                var obj = {
	                    'category': staticConfig.Securities[_data["SecurityType"]],
	                    'ticker': _data["Ticker"],
	                    'name': _data["Name"],
	                    // 'exch': _data["Exch"],
	                    'exch': staticConfig.Securities[_data["SecurityType"]],
	                    'type': staticConfig.Securities[_data["SecurityType"]],
	                    'identifier': _data["QueryKey"] || _data["TenforeInfo"][1] + "." + _data["TenforeInfo"][2] + "." + _data["Ticker"]
	                };
	                _dataObj["results"].push(obj);
	            };
	            iData.push(_dataObj);
	        }
	
	        cache[cacheCallback[requestId].cacheKey] = {
	            data: iData,
	            queryKey: queryKey,
	        };
	
	        if (typeof cacheCallback[RealtedRequestId].callback === 'function') {
	            cacheCallback[RealtedRequestId].callback(iData, queryKey);
	            cacheCallback[RealtedRequestId].callback = null;
	            delete cacheCallback[RealtedRequestId].callback;
	        }
	    };
	
	    var acDataManager = {
	        // Fields: {
	        //     'SecId': 'SecId',
	        //     'Name': 'OS01W',
	        //     'CUSIP': 'OS05K',
	        //     'ISIN': 'OS05J',
	        //     'Ticker': 'OS001',
	        //     'SecurityType': 'OS010',
	        //     'MICCode': 'LS01Z',
	        //     'PerformanceId': 'OS06Y',
	        //     'CountryName': 'XI018',
	        //     'TFTicker': 'AC001',
	        //     'TFName': 'AC020',
	        //     'TFForexTicker': 'AC009',
	        //     'TFForexName': 'AC010',
	        //     'TFForexMIC': 'AC011',
	        //     'TFForexExchangeID': 'AC030',
	        //     'TFSecurityType': 'AC003',
	        //     'TFExchangeID': 'AC018',
	        //     'TFCurrencyMarket': 'AC019',
	        //     'UserTicker': 'ClientTicker',
	        //     "SecurityType2": "ST816",
	        //     "isADR": "AA0A6"
	        // },
	        fetchData: function(params, callback) {
	            var autoComplete = params.autoComplete || {};
	            var condition = generaterCondition(autoComplete.category);
	            var cacheKey = getCacheKey(params.queryKey, condition);
	            var cacheObject = cache[cacheKey];
	            if (!cacheObject) {
	                autoComplete.nonFilterCategoryMap = {};
	                for (var i = 0, l = autoComplete.nonFilterCategory.length; i < l; i++) {
	                    autoComplete.nonFilterCategoryMap[autoComplete.nonFilterCategory[i]] = true;
	                }
	                var requestId = new Date().getTime();
	                cacheCallback[requestId] = {
	                    'callback': callback,
	                    'cacheKey': cacheKey,
	                    'params': params
	                };
	
	                core.Util.getData({
	                    url: core.serviceManager.url('@web/acb.jsp'),
	                    type: 'GET',
	                    dataType: 'jsonp',
	                    timeout: 100000,
	                    data: {
	                        'id': requestId,
	                        'kw': params.queryKey,
	                        'condition': condition,
	                        'acbinstid': core.getInstID()
	                    }
	                }, {
	                    onSuccess: function(result) {
	                        dataOnArrived(result);
	                    },
	                    onFailure: function() {
	                        callback([], cacheCallback[requestId].params);
	                    }
	                });
	            } else {
	                callback(cacheObject.data, cacheObject.params);
	            }
	        },
	        fetchRelatedTickersAndMajorIndexData: function(pId, mainTickerType, callback) {
	            var queryKey = pId;
	            var mainTickerType = mainTickerType;
	            var cacheKey = getCacheKey(queryKey, "relatedTickersAndMajorIndex");
	            var cacheObject = cache[cacheKey];
	            if (!cacheObject) {
	                var requestId = "realtedAndMajorRequestId";
	                cacheCallback[requestId] = {
	                    'callback': callback,
	                    'requestId': requestId,
	                    'cacheKey': cacheKey,
	                    "queryKey": queryKey
	                };
	
	                core.$.when(core.Util.ajax({
	                    url: core.serviceManager.url("@web/ra/peerSecurities"),
	                    type: 'GET',
	                    dataType: 'json',
	                    timeout: 100000,
	                    data: {
	                        "mainSecurity": queryKey
	                    }
	                }), core.Util.ajax({
	                    url: core.serviceManager.url("@web/ra/majorIndices"),
	                    type: 'GET',
	                    dataType: 'json',
	                    timeout: 100000,
	                    data: {
	                        "mainSecurity": queryKey
	                    }
	                })).done(function(result1, result2) {
	                    if (result1[1] === 'success' && result2[1] === 'success') {
	                        var _dataObj = {};
	                        // only sotck has related tickers
	                        if (result1[0].Data && result1[0].Data.length > 0 && (mainTickerType == 'ST' || mainTickerType == '1')) {
	                            _dataObj["Related Securities"] = result1[0];
	                        }
	                        if (result2[0].Data && result2[0].Data.length > 0) {
	                            _dataObj["Major Indexes"] = result2[0];
	                        }
	                        saveDataIntoCache(_dataObj, requestId);
	                    }
	                })
	
	            } else {
	                callback(cacheObject.data, cacheObject.queryKey);
	            }
	        }
	    };
	
	    var categoryConditionMapping = (function() {
	        var securities = staticConfig.Securities;
	        var map = {};
	        for (var c in securities) {
	            var category = securities[c];
	            if (!map[category]) {
	                map[category] = [];
	            }
	            map[category].push(c);
	        }
	        return map;
	    })();
	
	    return acDataManager;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(57), __webpack_require__(66)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, staticConfig, screener_eu) {
	    'use strict';
	    var $ = core.$;
	    var cache = {};
	    var cacheCallback = {};
	
	    var categoryholdingTypeIdMapping = (function() {
	        var map = {};
	        var holdingTypeId = {
	            "2": "Mutual Fund",
	            "3": "Equities",
	            "7": "Index",
	            "21": "Closed-End Fund",
	            "22": "ETF"
	        };
	        for (var c in holdingTypeId) {
	            var category = holdingTypeId[c];
	            if (!map[category]) {
	                map[category] = [];
	            }
	            map[category].push(c);
	        }
	        return map;
	    })();
	
	    function getCacheKey(key, condition) {
	        return 'kw=' + key + '&condition=' + condition;
	    }
	
	    function getFilters(category) {
	        var ret = [],
	            unique = {};
	        for (var i = 0, l = category.length, cat, conditions; i < l; i++) {
	            cat = category[i];
	            conditions = categoryholdingTypeIdMapping[cat];
	            if (!categoryholdingTypeIdMapping[cat]) continue;
	            for (var j = 0, jl = conditions.length, cond; j < jl; j++) {
	                cond = conditions[j];
	                if (unique[cond]) continue;
	                unique[cond] = true;
	                ret.push("'" + cond + "'");
	            }
	        }
	        if (ret.length > 0) {
	            ret.unshift('HoldingTypeId', 'IN');
	        }
	        return ret.join(':');
	    }
	
	    function dataOnArrived(result) {
	        var requestId = result.requestId,
	            iData = {};
	        $.each(result.tickers, function(i, item) {
	            var securityName = staticConfig.Securities[item.mType];
	            if (!iData[securityName]) {
	                iData[securityName] = [];
	            }
	            iData[securityName].push(item);
	        });
	        cache[cacheCallback[requestId].cacheKey] = {
	            data: iData,
	            params: cacheCallback[requestId].params
	        };
	        if (typeof cacheCallback[requestId].callback === 'function') {
	            cacheCallback[requestId].callback(iData, cacheCallback[requestId].params);
	            cacheCallback[requestId].callback = null;
	            delete cacheCallback[requestId].callback;
	        }
	    }
	
	    function fetchData(params, callback) {
	        var filters = '',
	            autoComplete = params.autoComplete || {},
	            universeIds = autoComplete.universeIds || '';
	        if (params.needFilter && autoComplete.category && autoComplete.category.length > 0) {
	            filters = getFilters(autoComplete.category)
	        }
	        var cacheKey = getCacheKey(params.queryKey, filters);
	        var cacheObject = cache[cacheKey];
	        if (!cacheObject) {
	            autoComplete.nonFilterCategoryMap = {};
	            for (var i = 0, l = autoComplete.nonFilterCategory.length; i < l; i++) {
	                autoComplete.nonFilterCategoryMap[autoComplete.nonFilterCategory[i]] = true;
	            }
	            var requestId = new Date().getTime();
	            cacheCallback[requestId] = {
	                'callback': callback,
	                'cacheKey': cacheKey,
	                'params': params
	            };
	            screener_eu.fetchData({
	                euiwt: params.euiwt,
	                solutionKey: params.solutionKey,
	                languageId: params.lang,
	                filters: filters,
	                requestId: requestId,
	                universeIds: universeIds,
	                sortOrder: autoComplete.sortOrder || 'Name+Asc',
	                queryKey: params.queryKey,
	                maxCount: autoComplete.maxCount
	            }, {
	                onSuccess: function(data) {
	                    dataOnArrived(data);
	                },
	                onFailure: function(data) {
	                    callback([], data);
	                }
	            });
	        } else {
	            callback(cacheObject.data, cacheObject.params);
	        }
	    }
	    return {
	        fetchData: fetchData
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core) {
	    'use strict';
	    var $ = core.$;
	
	    function getMorningstarType(holdingTypeId) {
	        var mType;
	        switch (holdingTypeId) {
	            case 1:
	                mType = 'C0';
	                break;
	            case 2:
	                mType = 'FO';
	                break;
	            case 3:
	                mType = 'ST';
	                break;
	            case 3:
	                mType = 'Bonds';
	                break;
	            case 7:
	                mType = 'XI';
	                break;
	            case 21:
	                mType = 'FC';
	                break;
	            case 22:
	                mType = 'FE';
	                break;
	            case 9:
	                mType = 'SA';
	                break;
	            case 8:
	                mType = 'CA';
	                break;
	            case 10:
	                mType = 'MI';
	                break;
	            case 24:
	                mType = 'FG';
	                break;
	            case 50:
	                mType = 'FH';
	                break;
	            case 60:
	                mType = 'CB';
	                break;
	            default:
	                mType = 'OTHER';
	                break;
	        }
	        return mType;
	    }
	
	    function dataOnArrived(result) {
	        var requestId = result.requestTimestamp,
	            tickers = [];
	        $.each(result.rows, function(i, item) {
	            var tenforeInfo = (item.TenforeId || '').split('\.');
	            var temforValid = tenforeInfo.length > 2;
	            var securityType;
	            if (item.HoldingTypeId) {
	                securityType = getMorningstarType(item.HoldingTypeId);
	            }
	            tickers.push({
	                identifier: item.TenforeId || item.PerformanceId || item.SecId || '',
	                ticker: item.Symbol || item.Ticker || index(tenforeInfo, 2) || item.PerformanceId || item.SecId || '',
	                name: item.Name || '',
	                exch: getExchange(index(tenforeInfo, 0), item.MIC),
	                ISIN: item.ISIN || '',
	                CNPJ: item.CNPJ,
	                secId: item.SecId,
	                currency: item.Currency,
	                mType: securityType,
	                type: index(tenforeInfo, 1),
	                gkey: temforValid ? item.TenforeId : '',
	                tenforeTicker: temforValid ? tenforeInfo[2] : '',
	                tenforeCode: temforValid ? tenforeInfo[0] : '',
	                performanceId: item.PerformanceId,
	                securityId: item.SecId,
	                categoryId: item.CategoryId,
	                benchMarkId: item.PrimaryBenchmarkId,
	                categoryName: item.CategoryName,
	                benchMarkName: item.PrimaryBenchmarkName
	            });
	        });
	        return {
	            tickers: tickers,
	            requestId: requestId
	        }
	
	    }
	
	    function getExchange(exchId, micCode) {
	        var exch;
	        if (micCode) {
	            exch = core.DataManager._getMICExangeMap()[micCode] || micCode || '';
	        }
	        if (!exch) {
	            exch = core.DataManager._getExchangeMap()[exchId] || '';
	        }
	        return exch.replace(/\$/ig, '');
	    }
	
	    function index(tenforeInfo, idx) {
	        if (tenforeInfo.length >= idx) {
	            return tenforeInfo[idx];
	        }
	        return '';
	    }
	
	    function fetchData(params, callback) {
	        var data = {
	            'timestamp': params.requestId || new Date().getTime(),
	            'page': 1,
	            'pageSize': params.maxCount,
	            'outputType': 'json',
	            'version': 1,
	            'languageId': params.languageId,
	            'securityDataPoints': 'Symbol,Ticker,MIC,ISIN,PerformanceId,SecId,TenforeId,Name,ExchangeCode,InvestmentType,HoldingTypeId,Universe,CNPJ,Currency,CategoryId,CategoryName,PrimaryBenchmarkId,PrimaryBenchmarkName',
	            'term': params.queryKey || '',
	            'sortOrder': params.sortOrder || 'Name+Asc',
	            'universeIds': params.universeIds || '',
	            'filters': params.filters || '',
	
	        };
	        core.Util.getData({
	            third: true,
	            url: core.Util.formatString('{0}{1}/security/screener', (params.euiwt || core.serviceManager.url('@euiwt')), params.solutionKey),
	            type: 'GET',
	            dataType: 'jsonp',
	            timeout: 100000,
	            data: data
	        }, {
	            onSuccess: function(result) {
	                if ($.isFunction(callback.onSuccess)) {
	                    callback.onSuccess(dataOnArrived(result));
	                }
	            },
	            onFailure: function() {
	                if ($.isFunction(callback.onFailure)) {
	                    callback.onFailure([], params);
	                }
	
	            }
	        });
	    }
	
	    return {
	        fetchData: fetchData
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3), __webpack_require__(68)], __WEBPACK_AMD_DEFINE_RESULT__ = function(core, EventTypes) {
	    'use strict';
	    /**
	     * Event Manage Model
	     */
	    var $ = core.$;
	
	    function eventManager(managers) {
	        var callbackList = {};
	
	        // Bind one or more space separated events, to a `callback`
	        // function. Passing `"all"` will bind the callback to all events fired.
	        function bind(events, callback, context) {
	            var event, node, list, next;
	            if (!callback) return this;
	            events = $.isArray(events) ? events : [events];
	            for (var i = 0, len = events.length; i < len; i++) {
	                event = events[i];
	                if (!event) {
	                    throw new Error("Event name is undefined!");
	                }
	                list = callbackList[event];
	                list = list ? list : [];
	                node = {};
	                node.context = context;
	                node.callback = callback;
	                list.push(node);
	                callbackList[event] = list
	            }
	            return this;
	        };
	
	        // Remove one or many callbacks. If `context` is null, removes all callbacks
	        // with that function. If `callback` is null, removes all callbacks for the
	        // event. If `events` is null, removes all bound callbacks for all events.
	        function unbind(events, callback, context) {
	            var event;
	            if (!events) {
	                callbackList = {};
	            } else {
	                if (callbackList) {
	                    events = $.isArray(events) ? events : [events];
	                    for (var i = 0, len = events.length; i < len; i++) {
	                        event = events[i];
	                        list = callbackList[event];
	                        deleteCallbackNodeByCallback(list, callback);
	                        deleteCallbackNodeByContext(list, context);
	                    }
	                }
	            }
	            return this;
	        };
	
	        function deleteCallbackNodeByCallback(callbackList, callback) {
	            deleteArrayItemByAttr(callbackList, "callback", callback);
	        };
	
	        function deleteCallbackNodeByContext(callbackList, context) {
	            deleteArrayItemByAttr(callbackList, "context", context);
	        };
	
	        function deleteArrayItemByAttr(array, attrName, attrValue) {
	            for (var i = 0, len = array.length; i < len; i++) {
	                if (array[i][attrName] === attrValue) {
	                    array.splice(i, 1);
	                    break;
	                }
	            }
	        };
	        // Trigger one more many events, firing all bound callbacks. Callbacks are
	        // passed the same arguments as `trigger` is, apart from the event name.
	        function trigger(events) {
	            var event, node, tail, args, all, eventData;
	            if (!callbackList) {
	                return this;
	            }
	            events = $.isArray(events) ? events : [events];
	            eventData = [].slice.call(arguments, 1);
	            if (checkEventsIfContainAll(events)) { //Need run all the callbacks
	                for (event in callbackList) {
	                    runCallbacksByEvent(event, eventData);
	                }
	            } else {
	                events.push(EventTypes.All); //Need run the callbacks that bind on "all"
	                for (var i = 0, len = events.length; i < len; i++) {
	                    var event = events[i];
	                    runCallbacksByEvent(event, eventData);
	                }
	            }
	            return this;
	        };
	
	        function checkEventsIfContainAll(events) {
	            var hasEvent_all = false;
	            for (var i = 0, len = events.length; i < len; i++) {
	                if (events[i] === EventTypes.All) {
	                    hasEvent_all = true;
	                }
	            }
	            return hasEvent_all;
	        };
	
	        function runCallbacksByEvent(eventName, args) {
	            if (!eventName) {
	                throw new Error("Event name is undefined!");
	            }
	            var node, nodeList = callbackList[eventName] || [];
	            for (var i = 0, len = nodeList.length; i < len; i++) {
	                node = nodeList[i];
	                node.callback.apply(node.context || this, args);
	            }
	        };
	
	        function clearBinders() {
	            callbackList = {};
	        };
	
	        return {
	            EventTypes: EventTypes,
	            bind: bind,
	            unbind: unbind,
	            trigger: trigger,
	            clearBinders: clearBinders
	        };
	    }
	
	    return eventManager;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    "use strict";
	    /**
	     * Event Support Types Model
	     */
	    var EventTypes = {
	        All: "all", //will be triggered by any event.
	        LayoutChange: 'layoutChange',
	        //BeginDrawTrandLine: "beginDrawTrandLine",
	        ChangeChartCursor: 'changeChartCursor',
	        ChangeChartVolume: 'changeChartVolume',
	        ChangeChartVolumePlus: 'changeChartVolumePlus',
	        ChangeVolumeChart: 'ChangeVolumeChart',
	        ChangeYAxis: 'changeYAxis',
	        ChangeVerticalScale: 'changeVerticalScale',
	        ChangeSelectionMode: 'changeSelectionMode',
	        ChangeExtendedMarketHour: 'changeExtendedMarketHour',
	        ChangeDateByDateRange: 'changeDateByDateRange',
	        ChangeEvents: 'changeEvents',
	        ChangeIndicators: 'changeIndicators',
	        ChangeFundamental: 'changeFundamental',
	        ChangeDrawing: 'cangeDrawing',
	        ChangeIntervalFrequency: 'changeIntervalFrequency',
	        ChangeTicker: 'changeTicker',
	        ChangeFrequencyItems: 'changeFrequencyItems',
	        ChangeFrequencyFromMenu: 'changeFrequencyFromMenu',
	        CompareTicker: 'compareTicker',
	        ChangeChartType: "changeChartType", //Use for change chart type event, like change to line chart.
	        ChangeXAxisDomain: "changeXAxisDomain", //Use for change chart x axis's scale when operate on slider chart.
	        ChangeDateRangeByZoom: "ChangeDateRangeByZoom",
	        ChartDataUpdate: 'chartDataUpdate', //Use for inform chart that data have updated.
	        UpdateMenuInterval: 'updateMenuInterval',
	        RequestFrequencyFromMenu: 'requestFrequencyFromMenu',
	        GetMainChartDateRange: 'getMainChartDateRange',
	        ChangeSliderDateRange: 'changeSliderDateRange',
	        StartLoading: 'startLoading',
	        EndLoading: 'endLoading',
	        ToggleCrossharis: 'toggleCrossharis', //when mouse is moving in the chart,
	        ToggleTrackball: 'toggleTrackball',
	        ToggleTrackballVolume: 'toggleTrackballVolume',
	        ToggleTrackballIndicators: 'toggleTrackballIndicators',
	        ToggleTrackballFundamentals: 'toggleTrackballFundamentals',
	        FetchPreloadData: 'fetchPreloadData',
	        FetchPreloadRelatedAndIndexData: 'fetchPreloadRelatedAndIndexData',
	        UpdateConfig: 'UpdateConfig',
	        Export: 'export',
	        "Reset": 'Reset',
	        HeightChanged: 'onHeightChange',
	        FundamentalNotAvailable: "FundamentalNotAvailable",
	        MouseOutChart: "MouseOutChart",
	        UpdateMenuIntervalForRender: 'UpdateMenuIntervalForRender',
	        DrawNewData: "DrawNewData",
	        DestroyChart: "DestroyChart",
	        ChangeIDFConfig: "ChangeIntervalDateRangeFrequency",
	        ChangeOneDayFrequency: "ChangeOneDayFrequency",
	        ChangeGrowthType: "ChangeGrowthType",
	        LayoutRendered: "layout-rendered",
	        HideDateRange: "hideDateRange",
	        ErrorShown: 'error-shown',
	        ErrorHidden: 'error-hidden',
	        UpdateCompareTickers: 'UpdateCompareTickers',
	        ShowTrackball: 'ShowTrackball',
	        ChangeMainChartLayout: 'ChangeMainChartLayout',
	        CallBackHeightChanged: 'CallBackHeightChanged',
	        TickerLimitReached: "error:ticker-limit-reached",
	        ChangeInterval: "ChangeInterval",
	        OnMainTickerDrawEnd: "onMainTickerDrawEnd",
	        ChangeGrowthBaseValue: "ChangeGrowthBaseValue",
	        DeployIntervalBreakPoint: "deployIntervalBreakPoint",
	        ExportData: 'ExportData',
	        Print: 'Print',
	        ResetZoomIn: 'ResetZoomIn',
	        ChangeStartDate: 'ChangeStartDate',
	        RedrawDrawings: 'redrawDrawings',
	        SaveLastDrawing: 'saveLastDrawing',
	        UpdateDrawing: 'updateDrawing',
	        RemoveDrawing: 'removeDrawing',
	        RemoveAllDrawings: 'removeAllDrawings',
	        /***callback */
	        onbeforeZoomIn: 'onbeforeZoomIn',
	        onDateRangeChange: 'onDateRangeChange',
	        triggerClickCallback: 'triggerClickCallback',
	        onRemoveCompareTickers: 'onRemoveCompareTickers',
	        onTickerRemoveBtnClicked: 'onTickerRemoveBtnClicked',
	        onAddCompareTickers: 'onAddCompareTickers'
	    };
	
	    return EventTypes;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// markets-components-svgchart.min.js